import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null | undefined;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: string; output: string; }
  Json: { input: any; output: any; }
};

export type ActionMediaAttachmentRequirement =
  | 'MANDATORY'
  | 'NONE'
  | 'OPTIONAL';

export type Activity = {
  __typename?: 'Activity';
  averageHrBpm?: Maybe<Scalars['Float']['output']>;
  devices?: Maybe<Array<Device>>;
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  heartRateSamples?: Maybe<Array<HeartRateSample>>;
  id: Scalars['ID']['output'];
  integration?: Maybe<WearableIntegration>;
  maxHrBpm?: Maybe<Scalars['Float']['output']>;
  minHrBpm?: Maybe<Scalars['Float']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  totalBurnedCalories?: Maybe<Scalars['Float']['output']>;
  type: WearableActivityType;
};

export type AddCouponCodesToPurchaseSyncGroupInput = {
  couponCodes: Array<Scalars['String']['input']>;
  purchaseSyncGroupId: Scalars['ID']['input'];
};

export type AddCouponCodesToPurchaseSyncGroupPayload = {
  __typename?: 'AddCouponCodesToPurchaseSyncGroupPayload';
  purchaseSyncGroupCoupons: Array<PurchaseSyncGroupCoupon>;
};

/** A special type of offering that tracks another offering's order cadence */
export type AddOnOffering = Offering & {
  __typename?: 'AddOnOffering';
  advertisedCostCadence?: Maybe<Scalars['String']['output']>;
  advertisedName: Scalars['String']['output'];
  advertisedShippingCadence: Scalars['String']['output'];
  /** e.g. "$10 per pen" or "£10 / month" */
  advertisedStartingAmount: Scalars['String']['output'];
  advertisedStartingAmountHeader: Scalars['String']['output'];
  advertisedStartingAmountSubtitle: Scalars['String']['output'];
  contents: Array<OfferingContentItem>;
  description: Scalars['String']['output'];
  downsells?: Maybe<Array<SwitchCandidate>>;
  firstOrderGiftCopy?: Maybe<Scalars['String']['output']>;
  friendlyName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  photoUrl: Scalars['String']['output'];
  problemTypes?: Maybe<Array<ProblemType>>;
  sequenceSets?: Maybe<Array<SequenceSet>>;
  status: OfferingStatus;
  tags: Array<Scalars['String']['output']>;
  upsells?: Maybe<Array<SwitchCandidate>>;
};

export type AddonSelectionInput = {
  offeringId: Scalars['ID']['input'];
  sequenceSelections: Array<SequenceSelectionInput>;
};

export type Address = {
  __typename?: 'Address';
  building?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deliveryInstructions?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  municipality?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  prefecture?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  townArea?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  /** @deprecated Use user instead */
  userId: Scalars['String']['output'];
};

export type AddressCreateWithoutUserInput = {
  building?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  deliveryInstructions?: InputMaybe<Scalars['String']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  municipality?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  prefecture?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  townArea?: InputMaybe<Scalars['String']['input']>;
};

export type AdminRole =
  | 'ASSISTANT_MANAGER'
  | 'CLINICAL_OPS'
  | 'COUPON_CAMPAIGN_MANAGER'
  | 'ENGINEER'
  | 'HIGH'
  | 'LOGISTICIAN'
  | 'OFFERINGS_MANAGER'
  | 'ROLE_PERMISSION_ADMIN'
  | 'SENIOR_SUPPORT_SPECIALIST'
  | 'SUPER'
  | 'USER_ROLE_ADMIN';

export type AnnotationInput = {
  supplyNumber: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AnswerInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  /** Deprecated: this will be ignored */
  answerId?: InputMaybe<Scalars['String']['input']>;
  answerList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  questionId: Scalars['String']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
};

export type ApplicationEvent =
  | 'ACCOUNT_CREATED'
  | 'CONSULTATION_ASSIGNED'
  | 'CONSULTATION_AWAITING_DOCTOR'
  | 'CONSULTATION_COMPLETED'
  | 'CONSULTATION_CREATED'
  | 'CONSULTATION_PAID'
  | 'CONSULTATION_PATIENT_QUESTION_ANSWERED'
  | 'CONSULTATION_PATIENT_QUESTION_ASKED'
  | 'CONSULTATION_QUESTION_ANSWERED'
  | 'CONSULTATION_QUESTION_ASKED'
  | 'CONSULTATION_REMINDER_CANCELED'
  | 'CONSULTATION_REMINDER_CREATED'
  | 'CONSULTATION_REMINDER_TRIGGERED'
  | 'CONSULTATION_SURVEY_COMPLETED'
  | 'CONSULTATION_UNASSIGNED'
  | 'CONSULTATION_UPDATED'
  | 'ORDER_COMPLETED'
  | 'ORDER_PAID'
  | 'QUIZ_REOPENED'
  | 'REFUND_FAILED';

export type Appointment = {
  __typename?: 'Appointment';
  calendarId?: Maybe<Scalars['String']['output']>;
  calendarName?: Maybe<Scalars['String']['output']>;
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  startsAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ArticleQuizOutcome = QuizOutcomeV2 & {
  __typename?: 'ArticleQuizOutcome';
  id: Scalars['ID']['output'];
  link: Scalars['String']['output'];
};

export type AssignChatCustomerInput = {
  customerId: Scalars['ID']['input'];
  toUserId: Scalars['ID']['input'];
};

export type AssignChatCustomersPayload = {
  __typename?: 'AssignChatCustomersPayload';
  assignedCount?: Maybe<Scalars['Int']['output']>;
  chatThreadStatusCountsByType?: Maybe<ChatThreadStatusCounts>;
  filteredChatThreads?: Maybe<FilteredChatThreadsPayload>;
};


export type AssignChatCustomersPayloadChatThreadStatusCountsByTypeArgs = {
  type: ChatThreadType;
};


export type AssignChatCustomersPayloadFilteredChatThreadsArgs = {
  input?: InputMaybe<FilteredChatThreadsInput>;
};

export type AssignChatThreadCountInput = {
  count: Scalars['Int']['input'];
  userId: Scalars['ID']['input'];
};

export type AssignChatThreadsPayload = {
  __typename?: 'AssignChatThreadsPayload';
  /** @deprecated use `chatThreadStatusCountsByType` */
  chatThreadCountsByType?: Maybe<ChatThreadCounts>;
  chatThreadStatusCountsByType?: Maybe<ChatThreadStatusCounts>;
  filteredChatThreads?: Maybe<FilteredChatThreadsPayload>;
};


export type AssignChatThreadsPayloadChatThreadCountsByTypeArgs = {
  type: ChatThreadType;
};


export type AssignChatThreadsPayloadChatThreadStatusCountsByTypeArgs = {
  type: ChatThreadType;
};


export type AssignChatThreadsPayloadFilteredChatThreadsArgs = {
  input?: InputMaybe<FilteredChatThreadsInput>;
};

export type AssignNextPatientPayload = {
  __typename?: 'AssignNextPatientPayload';
  consultation: Consultation;
};

export type AuthPayload = {
  __typename?: 'AuthPayload';
  token?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type BillingInterval =
  | 'Daily'
  | 'Monthly'
  | 'Weekly';

export type BloodGlucose = {
  __typename?: 'BloodGlucose';
  devices?: Maybe<Array<Device>>;
  id: Scalars['ID']['output'];
  samples?: Maybe<Array<BloodGlucoseSample>>;
};

export type BloodGlucoseSample = {
  __typename?: 'BloodGlucoseSample';
  id: Scalars['ID']['output'];
  /** @deprecated Never implemented */
  integration?: Maybe<WearableIntegration>;
  mmolPerL: Scalars['Float']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type BoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type BuyOtcQuizOutcome = QuizOutcomeV2 & {
  __typename?: 'BuyOtcQuizOutcome';
  id: Scalars['ID']['output'];
  products?: Maybe<Array<Product>>;
};

export type CallStatus =
  | 'BUSY'
  | 'CANCELED'
  | 'COMPLETED'
  | 'CONNECTED'
  | 'CREATED'
  | 'MANUAL_CONFIRMATION'
  | 'NO_ANSWER'
  | 'VOICEMAIL';

export type CalorieRequirement = {
  __typename?: 'CalorieRequirement';
  deficit?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  level?: Maybe<Scalars['String']['output']>;
  maintenance?: Maybe<Scalars['Float']['output']>;
};

export type CancelTreatmentInput = {
  reason: Scalars['String']['input'];
  treatmentId: Scalars['ID']['input'];
};

export type CancelTreatmentPayload = {
  __typename?: 'CancelTreatmentPayload';
  treatment: Treatment;
};

export type CardMeta = {
  __typename?: 'CardMeta';
  brand?: Maybe<Scalars['String']['output']>;
  expiry?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  mask?: Maybe<Scalars['String']['output']>;
};

export type CardMetaCreateInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  expiry?: InputMaybe<Scalars['String']['input']>;
  mask?: InputMaybe<Scalars['String']['input']>;
};

export type ChangeLevelTreeGoalInput = {
  goalId: Scalars['ID']['input'];
  newGoalTemplateId: Scalars['ID']['input'];
};

export type ChangeLevelTreeGoalPayload = {
  __typename?: 'ChangeLevelTreeGoalPayload';
  level?: Maybe<LevelTreeLevel>;
};

export type ChangeLevelTreeLevelInput = {
  newLevelId: Scalars['ID']['input'];
  pillarId: Scalars['ID']['input'];
};

export type ChangeLevelTreeLevelPayload = {
  __typename?: 'ChangeLevelTreeLevelPayload';
  pillar?: Maybe<LevelTreePillar>;
};

export type Charge = {
  __typename?: 'Charge';
  amount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  status: ChargeStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type ChargeStatus =
  | 'FAILED'
  | 'PENDING'
  | 'SUCCEEDED';

export type ChatMacro = {
  __typename?: 'ChatMacro';
  category: Scalars['String']['output'];
  content: Scalars['Json']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  subcategory: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ChatThread = {
  __typename?: 'ChatThread';
  id: Scalars['ID']['output'];
  participants?: Maybe<Array<CustomerChatThreadParticipant | HealthCoachChatThreadParticipant>>;
  primaryUser?: Maybe<User>;
  priority?: Maybe<ChatThreadPriority>;
  status?: Maybe<ChatThreadStatus>;
  type: ChatThreadType;
  updatedAt: Scalars['DateTime']['output'];
};

export type ChatThreadCount = {
  __typename?: 'ChatThreadCount';
  count: Scalars['Int']['output'];
  status?: Maybe<ChatThreadStatus>;
};

export type ChatThreadCounts = {
  __typename?: 'ChatThreadCounts';
  all?: Maybe<Array<ChatThreadCount>>;
  assigned?: Maybe<Array<UserChatThreadCount>>;
  id: Scalars['ID']['output'];
  unassigned?: Maybe<Array<ChatThreadCount>>;
};

export type ChatThreadOrderBy =
  | 'PRIORITY_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC';

export type ChatThreadParticipant = {
  displayName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ChatThreadPriority =
  | 'HIGH'
  | 'LOW'
  | 'MEDIUM'
  | 'VERY_HIGH'
  | 'VERY_LOW';

export type ChatThreadPriorityCount = {
  __typename?: 'ChatThreadPriorityCount';
  count: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  priority?: Maybe<ChatThreadPriority>;
};

export type ChatThreadPriorityCounts = {
  __typename?: 'ChatThreadPriorityCounts';
  all?: Maybe<Array<ChatThreadPriorityCount>>;
  assigned?: Maybe<Array<UserChatThreadPriorityCount>>;
  id: Scalars['ID']['output'];
  unassigned?: Maybe<Array<ChatThreadPriorityCount>>;
};

export type ChatThreadStatus =
  | 'AWAITING_PATIENT'
  | 'CLOSED'
  | 'NO_ACTION_REQUIRED'
  | 'SCHEDULED_MESSAGE'
  | 'TO_ACTION';

export type ChatThreadStatusCount = {
  __typename?: 'ChatThreadStatusCount';
  count: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  status?: Maybe<ChatThreadStatus>;
};

export type ChatThreadStatusCounts = {
  __typename?: 'ChatThreadStatusCounts';
  all?: Maybe<Array<ChatThreadStatusCount>>;
  assigned?: Maybe<Array<UserChatThreadStatusCount>>;
  id: Scalars['ID']['output'];
  unassigned?: Maybe<Array<ChatThreadStatusCount>>;
};

export type ChatThreadType =
  | 'ASSISTANT'
  | 'CONSULTATION'
  | 'HEALTH_COACH';

export type CheckInResponse = {
  __typename?: 'CheckInResponse';
  /** @deprecated deprecating in favour of submittedAt */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  quizResponses?: Maybe<Array<QuizResponse>>;
  satisfactionRating?: Maybe<Scalars['Int']['output']>;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type Checklist = {
  __typename?: 'Checklist';
  attributes?: Maybe<ChecklistAttribute>;
  consultationId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  groups?: Maybe<Array<Maybe<ChecklistGroup>>>;
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['String']['output'];
};

export type ChecklistAttribute = {
  __typename?: 'ChecklistAttribute';
  age?: Maybe<Scalars['Int']['output']>;
  expectedNewborns?: Maybe<Scalars['String']['output']>;
  trimester?: Maybe<Scalars['String']['output']>;
  tryingStatus?: Maybe<TryingStatusType>;
};

export type ChecklistGroup = {
  __typename?: 'ChecklistGroup';
  id: Scalars['String']['output'];
  items?: Maybe<Array<Maybe<ChecklistItem>>>;
  title: Scalars['String']['output'];
};

export type ChecklistItem = {
  __typename?: 'ChecklistItem';
  code: Scalars['String']['output'];
  completed: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
};

export type ChecklistType =
  | 'FERTILITY'
  | 'PREGNANCY';

export type ClearUserPushTokenInput = {
  devicePlatform: DevicePlatform;
};

export type ClearUserPushTokenPayload = {
  __typename?: 'ClearUserPushTokenPayload';
  success: Scalars['Boolean']['output'];
};

export type ClinicianType =
  | 'DOCTOR'
  | 'NURSE'
  | 'PHARMACIST';

export type CollectCompoundingConsentInput = {
  consent: Scalars['Boolean']['input'];
  consultationId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  productIds: Array<Scalars['ID']['input']>;
};

export type CollectCompoundingConsentPayload = {
  __typename?: 'CollectCompoundingConsentPayload';
  consultation: Consultation;
  prescriptionHistory?: Maybe<Array<PrescriptionHistoryEntry>>;
};

export type CompletionStatus =
  | 'COMPLETED'
  | 'IN_PROGRESS'
  | 'NOT_STARTED';

export type CompoundingConsent =
  | 'AWAITING_RESPONSE'
  | 'NO'
  | 'NOT_REQUIRED'
  | 'YES';

export type Condition = {
  __typename?: 'Condition';
  asyncEligible?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  mostRecentRxPurchase?: Maybe<Purchase>;
  offeringUpgradeBanner?: Maybe<OfferingUpgradeBanner>;
  previousPractitioner?: Maybe<User>;
  problemType: ProblemType;
};

export type ConfirmAsyncConsultationInput = {
  consultationId: Scalars['ID']['input'];
};

export type ConfirmAsyncConsultationPayload = {
  __typename?: 'ConfirmAsyncConsultationPayload';
  consultation: Consultation;
};

export type ConfirmPurchaseGroupInput = {
  pricingSessionId: Scalars['ID']['input'];
  purchaseGroupId: Scalars['ID']['input'];
};

export type ConfirmPurchaseGroupPayload = {
  __typename?: 'ConfirmPurchaseGroupPayload';
  purchaseGroup: PurchaseGroup;
};

/** Represents a matching offering, but requiring final confirmation from the patient through repurchase. */
export type ConfirmPurchasePrompt = PurchasePrompt & {
  __typename?: 'ConfirmPurchasePrompt';
  id: Scalars['ID']['output'];
  /** Use the purchase group ID when calling Mutation.confirmPurchaseGroup to provide consent on an existing purchase group. */
  purchaseGroup: PurchaseGroup;
};

export type ConsentToPurchaseGroupInput = {
  purchaseGroupId: Scalars['ID']['input'];
};

export type Consultation = {
  __typename?: 'Consultation';
  allowPatientToSendMessageToDoctor: Scalars['Boolean']['output'];
  appointment?: Maybe<Appointment>;
  assignedAt?: Maybe<Scalars['DateTime']['output']>;
  canContinueExistingTreatment: Scalars['Boolean']['output'];
  canSchedulePractitionerBooking: Scalars['Boolean']['output'];
  chatThread?: Maybe<ChatThread>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customer: User;
  customerId: Scalars['String']['output'];
  doctor?: Maybe<User>;
  doctorId?: Maybe<Scalars['String']['output']>;
  doctorQuestions?: Maybe<Array<ConsultationQuestion>>;
  followupTreatment?: Maybe<Treatment>;
  /** @deprecated Use followupTreatment instead */
  followupTreatmentId?: Maybe<Scalars['ID']['output']>;
  hasPaid?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** This field is null when the consult has not been completed by the prescriber. If the prescriber declined treatment, its set to false. If the prescriber approves a prescription, its set to true. */
  isApproved?: Maybe<Scalars['Boolean']['output']>;
  isAvailableForPractitionerBooking?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use stage instead */
  isFollowUp: Scalars['Boolean']['output'];
  isFree?: Maybe<Scalars['Boolean']['output']>;
  isInNoPickUpQueue?: Maybe<Scalars['Boolean']['output']>;
  isReApprove?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use stage instead */
  isReview: Scalars['Boolean']['output'];
  isRural?: Maybe<Scalars['Boolean']['output']>;
  isUpfrontPayment: Scalars['Boolean']['output'];
  latestPractitionerBooking?: Maybe<PractitionerBooking>;
  medicationPreferenceProduct?: Maybe<MedicationPreferenceProducts>;
  medium: ConsultationMedium;
  nextAvailableCallWindowRange?: Maybe<PractitionerBookingWindowRange>;
  order?: Maybe<Order>;
  orderId?: Maybe<Scalars['String']['output']>;
  pathologyRequests?: Maybe<Array<Maybe<PathologyRequest>>>;
  patientMessagedAt?: Maybe<Scalars['DateTime']['output']>;
  patientNotes?: Maybe<Scalars['String']['output']>;
  patientQuestions?: Maybe<Array<ConsultationPatientQuestion>>;
  payment?: Maybe<PaymentTransaction>;
  /** @deprecated Use payment instead */
  paymentId?: Maybe<Scalars['ID']['output']>;
  phoneCalls?: Maybe<Array<PhoneCall>>;
  practitionerBookingWindows?: Maybe<Array<PractitionerBookingWindow>>;
  practitionerMessagedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Sequence prescribed by the doctor associated with this consultation */
  prescribedSequence?: Maybe<PrescribedSequence>;
  prescriberAvailableToCall?: Maybe<Scalars['Boolean']['output']>;
  /** States the expected prescribing experience between legacy and flexi-plans for practitioners */
  prescribingExperience?: Maybe<PrescribingExperience>;
  price?: Maybe<ConsultationPrice>;
  purchaseGroups?: Maybe<Array<PurchaseGroup>>;
  purchasePrompt?: Maybe<ConfirmPurchasePrompt | FurPurchasePrompt | InitialPurchasePrompt | RestartFlowPrompt | SubstitutePurchasePrompt>;
  quizApplication?: Maybe<QuizApplication>;
  quizApplicationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use QuizApplication.responses instead. */
  quizResponses?: Maybe<Array<QuizResponse>>;
  rejectReason?: Maybe<Scalars['String']['output']>;
  reminders?: Maybe<Array<ConsultationReminder>>;
  requiresPrescriberCall: Scalars['Boolean']['output'];
  screeningQuizApplication?: Maybe<QuizApplication>;
  stage: ConsultationStage;
  status: ConsultationStatus;
  suggestedDoctorNotesToPharmacist?: Maybe<Scalars['String']['output']>;
  treatment?: Maybe<Treatment>;
  treatmentId?: Maybe<Scalars['String']['output']>;
  type: ProblemType;
  /** Indicates that the patient is being treated as a flexi-plans patient for the problem type of this consultation. */
  typeIsFlexi?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


export type ConsultationDoctorQuestionsArgs = {
  orderBy?: InputMaybe<Array<ConsultationQuestionOrderByInput>>;
};


export type ConsultationPatientQuestionsArgs = {
  orderBy?: InputMaybe<Array<ConsultationPatientQuestionOrderByInput>>;
};


export type ConsultationPriceArgs = {
  discount?: InputMaybe<Scalars['String']['input']>;
};

export type ConsultationAnswer = {
  __typename?: 'ConsultationAnswer';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  patientQuestion?: Maybe<ConsultationPatientQuestion>;
  question?: Maybe<ConsultationQuestion>;
  type: ConsultationAnswerType;
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['String']['output'];
};

export type ConsultationAnswerType =
  | 'IMAGE'
  | 'NO_REPLY'
  | 'OBSERVATION'
  | 'TEXT';

export type ConsultationLog = {
  __typename?: 'ConsultationLog';
  consultation?: Maybe<Consultation>;
  consultationId?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['Json']['output']>;
  event?: Maybe<ApplicationEvent>;
  id: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']['output']>;
};

export type ConsultationMedium =
  | 'STANDARD'
  | 'VIDEO';

export type ConsultationNote = Note & {
  __typename?: 'ConsultationNote';
  addendums?: Maybe<Array<MetaNote>>;
  archivalNote?: Maybe<MetaNote>;
  author?: Maybe<User>;
  body: Scalars['String']['output'];
  canAddAddendum: Scalars['Boolean']['output'];
  canArchive: Scalars['Boolean']['output'];
  canEdit: Scalars['Boolean']['output'];
  consultation?: Maybe<Consultation>;
  createdAt: Scalars['DateTime']['output'];
  domain: NoteDomain;
  history?: Maybe<Array<NoteHistoryEntry>>;
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ConsultationOrderByInput = {
  assignedAt?: InputMaybe<SortOrder>;
  completedAt?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  isFollowUp?: InputMaybe<SortOrder>;
  isReview?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ConsultationParametersInput = {
  consultationId: Scalars['String']['input'];
  patientNotes: Scalars['String']['input'];
  /** Used to signal that a practitioner has manually reviewed customer photos outside of our platform */
  reviewedPhotosManually?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConsultationPatientQuestion = {
  __typename?: 'ConsultationPatientQuestion';
  answer?: Maybe<ConsultationAnswer>;
  answerId?: Maybe<Scalars['String']['output']>;
  consultation?: Maybe<Consultation>;
  consultationId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['String']['output'];
};

export type ConsultationPatientQuestionOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
};

export type ConsultationPrice = {
  __typename?: 'ConsultationPrice';
  amountOff: Scalars['Float']['output'];
  fullPrice: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

export type ConsultationQuestion = {
  __typename?: 'ConsultationQuestion';
  allowedAnswerType: ConsultationAnswerType;
  answer?: Maybe<ConsultationAnswer>;
  answerId?: Maybe<Scalars['String']['output']>;
  attachments?: Maybe<Array<ConsultationQuestionAttachment>>;
  consultation?: Maybe<Consultation>;
  consultationId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  doctor?: Maybe<User>;
  id: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['String']['output'];
};

export type ConsultationQuestionAttachment = {
  __typename?: 'ConsultationQuestionAttachment';
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mimetype: Scalars['String']['output'];
  signedUrl?: Maybe<Scalars['String']['output']>;
};

export type ConsultationQuestionOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
};

export type ConsultationQuizOutcome = QuizOutcomeV2 & {
  __typename?: 'ConsultationQuizOutcome';
  id: Scalars['ID']['output'];
};

export type ConsultationRejectReasonMetaInput = {
  weight?: InputMaybe<WeightConsultationRejectReasonMetaInput>;
};

export type ConsultationReminder = {
  __typename?: 'ConsultationReminder';
  canceled: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  doneAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  scheduledAt: Scalars['DateTime']['output'];
};

export type ConsultationStage =
  | 'FOLLOW_UP'
  | 'INITIAL'
  | 'REVIEW';

export type ConsultationStatus =
  | 'AWAITING_ANSWERS'
  | 'AWAITING_DOCTOR'
  | 'AWAITING_PAYMENT'
  | 'AWAITING_RESULTS'
  | 'AWAITING_SURVEY'
  | 'AWAITING_VERIFY_ID'
  | 'CANCELED'
  | 'CUSTOMER_COMPLETED'
  | 'DOCTOR_ASSIGNED'
  | 'DOCTOR_COMPLETED'
  | 'ORDER_COMPLETED';

export type ConsultationWhereInput = {
  OR?: InputMaybe<Array<ConsultationWhereInput>>;
  assignedAt?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<EnumConsultationStatusFilter>;
  type?: InputMaybe<EnumProblemTypeFilter>;
};

export type ContactMethod =
  | 'EMAIL'
  | 'PHONE';

export type ContentCategory = {
  __typename?: 'ContentCategory';
  id: Scalars['String']['output'];
  items?: Maybe<Array<FaqContentItem | ReadingContentItem | RecipeContentItem | VideoContentItem | VideoWithReadingContentItem>>;
  name?: Maybe<Scalars['String']['output']>;
};


export type ContentCategoryItemsArgs = {
  sessionKey: Scalars['ID']['input'];
};

export type ContentCollection = {
  __typename?: 'ContentCollection';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  items: Array<FaqContentItem | ReadingContentItem | RecipeContentItem | VideoContentItem | VideoWithReadingContentItem>;
  name: Scalars['String']['output'];
  nextIncompleteItem?: Maybe<FaqContentItem | ReadingContentItem | RecipeContentItem | VideoContentItem | VideoWithReadingContentItem>;
};

export type ContentItem = {
  id: Scalars['ID']['output'];
  status: ContentItemStatus;
  tags: Array<ContentTag>;
};

export type ContentItemProgressReadingInput = {
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ContentItemProgressRecipeInput = {
  reading?: InputMaybe<ContentItemProgressRecipeReadingInput>;
  video?: InputMaybe<ContentItemProgressRecipeVideoInput>;
};

export type ContentItemProgressRecipeReadingInput = {
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ContentItemProgressRecipeVideoInput = {
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  elapsedSeconds?: InputMaybe<Scalars['Int']['input']>;
  startedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ContentItemProgressVideoInput = {
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  elapsedSeconds?: InputMaybe<Scalars['Int']['input']>;
  startedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ContentItemProgressVideoWithReadingInput = {
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  elapsedSeconds?: InputMaybe<Scalars['Int']['input']>;
  startedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ContentItemStatus =
  | 'PRIVATE'
  | 'PUBLISHED';

export type ContentTag = {
  __typename?: 'ContentTag';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ContinuePrescribedSequenceInput = {
  consultationParameters: ConsultationParametersInput;
  prescribedSequenceId: Scalars['ID']['input'];
  scheduleProcessingDate?: InputMaybe<Scalars['DateTime']['input']>;
  scriptParameters?: InputMaybe<ScriptParametersInput>;
  undergoingWeightMaintenance?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContinuePrescribedSequencePayload = {
  __typename?: 'ContinuePrescribedSequencePayload';
  consultation: Consultation;
};

export type ContraceptionType =
  | 'IMPLANT'
  | 'INJECTION'
  | 'IUD'
  | 'NON_HORMONAL'
  | 'NO_CONTRACEPTION'
  | 'PATCH'
  | 'PILL'
  | 'RING'
  | 'SHOT';

export type CoreTriggerSource =
  | 'admin'
  | 'auto'
  | 'pauseModal'
  | 'system'
  | 'user';

export type CouponOutcome =
  | 'ALLOCATION_EXHAUSTED'
  | 'EXPIRED'
  | 'GENERIC_FAILURE'
  | 'NOT_FOUND'
  | 'SUCCESS';

export type CreateCallWithManualConfirmationInput = {
  consultationId: Scalars['ID']['input'];
};

export type CreateCallWithManualConfirmationPayload = {
  __typename?: 'CreateCallWithManualConfirmationPayload';
  consultation?: Maybe<Consultation>;
};

export type CreateNativeWearableIntegrationPayload = CreateWearableIntegrationPayload & {
  __typename?: 'CreateNativeWearableIntegrationPayload';
  terraToken: Scalars['String']['output'];
  wearableIntegrations?: Maybe<Array<WearableIntegration>>;
};

export type CreateReviewConsultationInput = {
  category: TreatmentReviewCategory;
  prescribedSequenceId: Scalars['ID']['input'];
  trigger: CoreTriggerSource;
};

export type CreateReviewConsultationPayload = {
  __typename?: 'CreateReviewConsultationPayload';
  consultation: Consultation;
};

export type CreateWearableIntegrationInput = {
  authFailureRedirectUrl: Scalars['String']['input'];
  authSuccessRedirectUrl: Scalars['String']['input'];
  provider: WearableIntegrationProvider;
};

export type CreateWearableIntegrationPayload = {
  wearableIntegrations?: Maybe<Array<WearableIntegration>>;
};

export type CreateWebApiWearableIntegrationPayload = CreateWearableIntegrationPayload & {
  __typename?: 'CreateWebApiWearableIntegrationPayload';
  authUrl: Scalars['String']['output'];
  wearableIntegrations?: Maybe<Array<WearableIntegration>>;
};

export type CrossSellCategoryType =
  | 'CONCEPTION'
  | 'POSTPARTUM'
  | 'PREGNANCY'
  | 'WOMENS_HEALTH';

export type CrossSellContextType =
  | 'profile';

export type CrossSellItemType =
  | 'CONCEPTION_CHECKLIST'
  | 'FERTILITY_HORMONE'
  | 'FERTILITY_LUBE'
  | 'MALE_PRENATAL'
  | 'POSTPARTUM_BELLY_ESSENTIALS'
  | 'POSTPARTUM_BUNDLE_BREASTFEEDING'
  | 'POSTPARTUM_BUNDLE_RECOVERY_KIT'
  | 'POSTPARTUM_C_SECTION_RECOVERY'
  | 'PREGNANCY_BELLY_ESSENTIALS'
  | 'PREGNANCY_CHECKLIST'
  | 'PRENATAL'
  | 'SITZ_BATH';

export type CrossSellRecommendations = {
  __typename?: 'CrossSellRecommendations';
  category: CrossSellCategoryType;
  initialType: CrossSellTrigger;
  recommendations: Array<Maybe<CrossSellItemType>>;
  trigger: Array<Maybe<CrossSellTrigger>>;
};

export type CrossSellTrigger = {
  __typename?: 'CrossSellTrigger';
  problemType?: Maybe<ProblemType>;
  sku?: Maybe<Scalars['String']['output']>;
  type?: Maybe<CrossSellTriggerEnumType>;
};

export type CrossSellTriggerEnumType =
  | 'NONE'
  | 'PROBLEM_TYPE'
  | 'SKU';

export type CustomerAttributes = {
  __typename?: 'CustomerAttributes';
  age?: Maybe<Scalars['Int']['output']>;
  allergies?: Maybe<Scalars['String']['output']>;
  birthday?: Maybe<Scalars['String']['output']>;
  bmi?: Maybe<Scalars['Float']['output']>;
  conditions?: Maybe<Scalars['String']['output']>;
  diabetesRisk: CustomerDiabetesRiskAttributes;
  fertility: CustomerFertilityAttributes;
  hair: CustomerHairAttributes;
  height?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  medications?: Maybe<Scalars['String']['output']>;
  menopause: CustomerMenopauseAttributes;
  mentalHealthConditions?: Maybe<Scalars['String']['output']>;
  pregnancy: CustomerPregnancyAttributes;
  sex?: Maybe<Sex>;
  skinSeeingResults?: Maybe<Scalars['Boolean']['output']>;
  skinSideEffects?: Maybe<Scalars['Boolean']['output']>;
  skinTreatmentUsage?: Maybe<SkinUsage>;
  smoking?: Maybe<Smoking>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type CustomerChatThreadParticipant = ChatThreadParticipant & {
  __typename?: 'CustomerChatThreadParticipant';
  displayName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type CustomerDiabetesRiskAttributes = {
  __typename?: 'CustomerDiabetesRiskAttributes';
  diabetesRiskLevel?: Maybe<DiabetesRiskLevel>;
  diabetesRiskProbability?: Maybe<Scalars['Float']['output']>;
};

export type CustomerFertilityAttributes = {
  __typename?: 'CustomerFertilityAttributes';
  contraceptionType?: Maybe<ContraceptionType>;
};

export type CustomerHairAttributes = {
  __typename?: 'CustomerHairAttributes';
  familyHistoryHairLoss?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomerMenopauseAttributes = {
  __typename?: 'CustomerMenopauseAttributes';
  menopauseSymptoms?: Maybe<Array<Maybe<MenopauseSymptoms>>>;
};

export type CustomerNote = Note & {
  __typename?: 'CustomerNote';
  addendums?: Maybe<Array<MetaNote>>;
  archivalNote?: Maybe<MetaNote>;
  author?: Maybe<User>;
  body: Scalars['String']['output'];
  canAddAddendum: Scalars['Boolean']['output'];
  canArchive: Scalars['Boolean']['output'];
  canEdit: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  customer?: Maybe<User>;
  domain: NoteDomain;
  history?: Maybe<Array<NoteHistoryEntry>>;
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CustomerOrder = {
  __typename?: 'CustomerOrder';
  amountPaid: MonetaryAmount;
  createdAt: Scalars['DateTime']['output'];
  /** Always null for legacy orders as it was deemed difficult to resolve */
  discount?: Maybe<MonetaryAmount>;
  id: Scalars['ID']['output'];
  reference: Scalars['String']['output'];
  shipmentCount: Scalars['Int']['output'];
  shipmentStatuses: Array<Scalars['String']['output']>;
  shipments: Array<Shipment>;
  shippingAddress: Scalars['String']['output'];
  /** Always null for legacy orders as we cannot accurately retroactively calculate */
  totalPrice?: Maybe<MonetaryAmount>;
};

export type CustomerPregnancyAttributes = {
  __typename?: 'CustomerPregnancyAttributes';
  pregnant?: Maybe<PregnancyStatus>;
};

export type DateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DefaultLevelTreeGoalTemplate = LevelTreeGoalTemplate & {
  __typename?: 'DefaultLevelTreeGoalTemplate';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Actions are returned in order of position of position. */
  latestPublishedActions?: Maybe<Array<LevelTreeActionTemplate>>;
  latestPublishedLevel?: Maybe<LevelTreeLevelTemplate>;
  /** Variants are returned in order of position. */
  latestPublishedVariants?: Maybe<Array<VariantLevelTreeGoalTemplate>>;
  name?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  useCase?: Maybe<Scalars['String']['output']>;
};

export type DelayPurchaseSyncGroupAction = PurchaseSyncGroupAction & {
  __typename?: 'DelayPurchaseSyncGroupAction';
  delayableUntil: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
};

export type DelayPurchaseSyncGroupInput = {
  purchaseSyncGroupId: Scalars['ID']['input'];
  targetTime: Scalars['DateTime']['input'];
};

export type DelayPurchaseSyncGroupPayload = {
  __typename?: 'DelayPurchaseSyncGroupPayload';
  purchaseSyncGroup: PurchaseSyncGroup;
};

export type DeleteMedicationPreferenceInput = {
  problemType: ProblemType;
};

export type DeleteMedicationPreferencePayload = {
  __typename?: 'DeleteMedicationPreferencePayload';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteTrackerEntryInput = {
  observationId: Scalars['ID']['input'];
};

export type DeleteTrackerEntryPayload = {
  __typename?: 'DeleteTrackerEntryPayload';
  tracking?: Maybe<WeightLossTracker>;
};

export type DeleteWearableIntegrationInput = {
  id: Scalars['ID']['input'];
};

export type DeleteWearableIntegrationPayload = {
  __typename?: 'DeleteWearableIntegrationPayload';
  wearableIntegrations?: Maybe<Array<WearableIntegration>>;
};

export type DeltaSentiment =
  | 'NEGATIVE'
  | 'NEUTRAL'
  | 'POSITIVE';

export type DerivedMeasurement = {
  __typename?: 'DerivedMeasurement';
  date: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  value: Scalars['Float']['output'];
};

export type Device = {
  __typename?: 'Device';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  lastUpdateAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
};

export type DevicePlatform =
  | 'ANDROID'
  | 'IOS'
  | 'WEB';

export type DiabetesRiskLevel =
  | 'HIGH'
  | 'INTERMEDIATE'
  | 'LOW';

export type Discount = {
  __typename?: 'Discount';
  amount: MonetaryAmount;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  removable: Scalars['Boolean']['output'];
};

export type DiscountCode = {
  __typename?: 'DiscountCode';
  amount: Scalars['Float']['output'];
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  products: Array<Product>;
  stages: Array<DiscountStage>;
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  type: DiscountType;
  updatedAt: Scalars['DateTime']['output'];
};

export type DiscountStage =
  | 'CONSULTATION_PAID'
  | 'ORDER_PAID'
  | 'OTC_CART'
  | 'RECURRING_ORDER_DISCOUNT';

export type DiscountType =
  | 'FIXED'
  | 'PERCENTAGE';

export type Drug = {
  __typename?: 'Drug';
  createdAt: Scalars['DateTime']['output'];
  data?: Maybe<Scalars['Json']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type EditWaistCmObservationInput = {
  observationId: Scalars['ID']['input'];
  valueCm: Scalars['Float']['input'];
};

export type EditWaistObservationCmPayload = {
  __typename?: 'EditWaistObservationCmPayload';
  tracking?: Maybe<WeightLossTracker>;
};

export type EditWeightKgObservationInput = {
  observationId: Scalars['ID']['input'];
  valueKg: Scalars['Float']['input'];
};

export type EditWeightObservationKgPayload = {
  __typename?: 'EditWeightObservationKgPayload';
  tracking?: Maybe<WeightLossTracker>;
};

/** Collection of Education Readings */
export type EducationCollection = {
  __typename?: 'EducationCollection';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** EducationReadings in this reading collection */
  readings?: Maybe<Array<EducationReading>>;
};

/** Education program module */
export type EducationModule = {
  __typename?: 'EducationModule';
  /** User progress through the module */
  completionStatus?: Maybe<CompletionStatus>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** EducationReadings associated with this module (if any) */
  readings?: Maybe<Array<EducationReading>>;
};

/** An interactive content program assigned to users based on treatments */
export type EducationProgram = {
  __typename?: 'EducationProgram';
  id: Scalars['ID']['output'];
  /** All EducationModules (completed or not) associated with this program */
  modules?: Maybe<Array<EducationModule>>;
  name: Scalars['String']['output'];
  nextUnreadReading?: Maybe<EducationReading>;
};

/** A renderable article containing education content */
export type EducationReading = {
  __typename?: 'EducationReading';
  /** Time at which the user finished this reading */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  content: Scalars['Json']['output'];
  id: Scalars['ID']['output'];
  /** User read status of the reading */
  readStatus?: Maybe<ReadStatus>;
  /** Time at which the user started this reading */
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Time taken to read the reading in milliseconds */
  timeToReadMs?: Maybe<Scalars['Int']['output']>;
};

export type EnumConsultationStatusFilter = {
  equals?: InputMaybe<ConsultationStatus>;
  in?: InputMaybe<Array<ConsultationStatus>>;
  not?: InputMaybe<NestedEnumConsultationStatusFilter>;
  notIn?: InputMaybe<Array<ConsultationStatus>>;
};

export type EnumOrderPaymentStatusNullableFilter = {
  equals?: InputMaybe<OrderPaymentStatus>;
  in?: InputMaybe<Array<OrderPaymentStatus>>;
  not?: InputMaybe<NestedEnumOrderPaymentStatusNullableFilter>;
  notIn?: InputMaybe<Array<OrderPaymentStatus>>;
};

export type EnumOrderStatusNullableFilter = {
  equals?: InputMaybe<OrderStatus>;
  in?: InputMaybe<Array<OrderStatus>>;
  not?: InputMaybe<NestedEnumOrderStatusNullableFilter>;
  notIn?: InputMaybe<Array<OrderStatus>>;
};

export type EnumProblemTypeFilter = {
  equals?: InputMaybe<ProblemType>;
  in?: InputMaybe<Array<ProblemType>>;
  not?: InputMaybe<NestedEnumProblemTypeFilter>;
  notIn?: InputMaybe<Array<ProblemType>>;
};

export type ErxMedicine = {
  __typename?: 'ErxMedicine';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  genericName: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  instructions?: Maybe<Scalars['String']['output']>;
  itemForm?: Maybe<Scalars['String']['output']>;
  itemStrength?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['String']['output']>;
  tradeName?: Maybe<Scalars['String']['output']>;
};

export type EventSequenceNode = SequenceNode & {
  __typename?: 'EventSequenceNode';
  body: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: EventSequenceNodeName;
  nextNodeId?: Maybe<Scalars['ID']['output']>;
};

export type EventSequenceNodeName =
  | 'CHANGING_SKU'
  | 'FOLLOW_UP_REMINDER'
  | 'UPCOMING_ORDER';

export type ExperimentAvailablePaymentPlan = {
  __typename?: 'ExperimentAvailablePaymentPlan';
  amount: ExperimentAvailablePaymentPlanAmount;
  cadence: Scalars['String']['output'];
  discountPercentage: Scalars['Int']['output'];
  months: Scalars['Int']['output'];
  paymentPlan: ExperimentPaymentPlanVariant;
};

export type ExperimentAvailablePaymentPlanAmount = {
  __typename?: 'ExperimentAvailablePaymentPlanAmount';
  perMonth: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalSaved: Scalars['Int']['output'];
};

export type ExperimentPaymentPlanVariant =
  | 'ORDER_2'
  | 'ORDER_3'
  | 'ORDER_4'
  | 'ORDER_6'
  | 'ORDER_12';

export type ExperimentTreatmentPaymentPlan = {
  __typename?: 'ExperimentTreatmentPaymentPlan';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  chargeId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  discountPercentage: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  months?: Maybe<Scalars['Int']['output']>;
  nextPaymentAmount: Scalars['Int']['output'];
  otcSchedules?: Maybe<Array<OtcSchedule>>;
  paymentPlan: ExperimentPaymentPlanVariant;
  planEndDate?: Maybe<Scalars['DateTime']['output']>;
  treatmentId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type Faq = {
  __typename?: 'Faq';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  markdown?: Maybe<Scalars['String']['output']>;
  product: Product;
  productId: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  videoEmbedUrl?: Maybe<Scalars['String']['output']>;
};

export type FaqContentItem = ContentItem & {
  __typename?: 'FaqContentItem';
  answer: Scalars['String']['output'];
  contentfulId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  question: Scalars['String']['output'];
  status: ContentItemStatus;
  tags: Array<ContentTag>;
};

export type File = {
  __typename?: 'File';
  avatarOf?: Maybe<User>;
  cmiOf?: Maybe<Product>;
  createdAt: Scalars['DateTime']['output'];
  filename: Scalars['String']['output'];
  id: Scalars['String']['output'];
  mimetype: Scalars['String']['output'];
  photoOf?: Maybe<Product>;
  signatureOf?: Maybe<Provider>;
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
};

export type FileUploadSignedUrlItem = {
  __typename?: 'FileUploadSignedUrlItem';
  id: Scalars['String']['output'];
  uploadSignedUrl: Scalars['String']['output'];
};

export type FilteredChatThreadsInput = {
  chatThreadIds?: InputMaybe<Array<Scalars['String']['input']>>;
  chatThreadStatuses?: InputMaybe<Array<ChatThreadStatus>>;
  chatThreadTypes?: InputMaybe<Array<ChatThreadType>>;
  hasPrimaryUser?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<ChatThreadOrderBy>;
  pageRequest?: InputMaybe<PageRequestInput>;
  primaryUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};

export type FilteredChatThreadsPayload = PaginationPayload & {
  __typename?: 'FilteredChatThreadsPayload';
  chatThreads?: Maybe<Array<ChatThread>>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type FilteredNotesInput = {
  consultationId?: InputMaybe<Scalars['ID']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
};

export type FulfillmentStatus =
  | 'FULFILLED'
  | 'UNFULFILLED';

/** Purchase prompt that occurs after a practitioner prescribes a sequence during a follow-up or review (FUR) consult. */
export type FurPurchasePrompt = PurchasePrompt & {
  __typename?: 'FurPurchasePrompt';
  id: Scalars['ID']['output'];
  /** The simplest offering selection matching the customers most recently prescribed sequence for this follow-up/review consults problem type. */
  proposedOfferingSelection?: Maybe<OfferingSelection>;
};

export type GeneralPrescribeDisclaimer = PrescribeDisclaimer & {
  __typename?: 'GeneralPrescribeDisclaimer';
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
};

export type GenerateLevelTreeActionSignedUploadUrlInput = {
  actionId: Scalars['ID']['input'];
  fileExtension: Scalars['String']['input'];
};

export type GenerateLevelTreeActionSignedUploadUrlPayload = {
  __typename?: 'GenerateLevelTreeActionSignedUploadUrlPayload';
  action?: Maybe<LevelTreeAction>;
  signedUploadUrl: Scalars['String']['output'];
};

export type GeneratePharmacyInvoiceInput = {
  orderId: Scalars['String']['input'];
};

export type GeneratePharmacyInvoicePayload = {
  __typename?: 'GeneratePharmacyInvoicePayload';
  signedUrl?: Maybe<Scalars['String']['output']>;
};

export type GoalFeedbackType =
  | 'ABOVE_STARTING_WEIGHT'
  | 'ALLOWED'
  | 'BMI_LESS_THAN_20'
  | 'LESS_THAN_2PERCENT_OF_BODY_WEIGHT'
  | 'LESS_THAN_10PERCENT_OF_BODY_WEIGHT'
  | 'LOSS_MORE_THAN_52KG_IN_12_MONTHS';

export type Headline = {
  __typename?: 'Headline';
  body: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  iconUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  subtext: Scalars['String']['output'];
};

export type HealthCareDetails = {
  __typename?: 'HealthCareDetails';
  hasIndividualHealthcareIdentifier?: Maybe<Scalars['Boolean']['output']>;
  hasMedicareDetails?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
};

export type HealthCoachChat = MobileAppFeature & {
  __typename?: 'HealthCoachChat';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type HealthCoachChatThreadParticipant = ChatThreadParticipant & {
  __typename?: 'HealthCoachChatThreadParticipant';
  avatarImageUrl?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated Use `ChatThread.primaryUser` */
  isPrimary: Scalars['Boolean']['output'];
};

export type HealthcareIdentifierMedicare = {
  __typename?: 'HealthcareIdentifierMedicare';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  familyName: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  maskedMedicareNumber: Scalars['String']['output'];
  medicareIrn: Scalars['Int']['output'];
  sex: MedicareSexType;
  /** Day of expiration, i.e. DD in DD/MM/YYYY */
  validToDay?: Maybe<Scalars['Int']['output']>;
  /** Month of expiration, i.e. MM in DD/MM/YYYY */
  validToMonth: Scalars['Int']['output'];
  /** Year of expiration, i.e. YYYY in DD/MM/YYYY */
  validToYear: Scalars['Int']['output'];
};

export type HeartRateSample = {
  __typename?: 'HeartRateSample';
  bpm?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  timestamp?: Maybe<Scalars['DateTime']['output']>;
};

export type HeartRateVariability = {
  __typename?: 'HeartRateVariability';
  devices?: Maybe<Array<Device>>;
  id: Scalars['ID']['output'];
  samples?: Maybe<Array<RmssdHeartRateVariabilitySample | SdnnHeartRateVariabilitySample>>;
};

export type HeartRateVariabilitySample = {
  id: Scalars['ID']['output'];
  /** @deprecated Never implemented */
  integration?: Maybe<WearableIntegration>;
  timestamp: Scalars['DateTime']['output'];
};

export type IhiRecordStatus =
  | 'PROVISIONAL'
  | 'UNKNOWN'
  | 'UNVERIFIED'
  | 'VERIFIED';

export type IhiStatus =
  | 'ACTIVE'
  | 'DECEASED'
  | 'EXPIRED'
  | 'RESOLVED'
  | 'RETIRED'
  | 'UNKNOWN';

export type IncreaseUsageQuizOutcome = QuizOutcomeV2 & {
  __typename?: 'IncreaseUsageQuizOutcome';
  id: Scalars['ID']['output'];
};

export type IndividualHealthcareIdentifier = {
  __typename?: 'IndividualHealthcareIdentifier';
  id: Scalars['ID']['output'];
  ihi: Scalars['String']['output'];
  recordStatus: IhiRecordStatus;
  status: IhiStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type InitialPurchaseConfirmPage = {
  __typename?: 'InitialPurchaseConfirmPage';
  faqs?: Maybe<Array<FaqContentItem>>;
  id: Scalars['ID']['output'];
};

export type InitialPurchasePriceCoupon = {
  __typename?: 'InitialPurchasePriceCoupon';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  outcome: CouponOutcome;
};

export type InitialPurchasePriceList = {
  __typename?: 'InitialPurchasePriceList';
  amount: Scalars['Float']['output'];
  coupons?: Maybe<Array<InitialPurchasePriceCoupon>>;
  /** Sum of all session and item discounts */
  discountAmount: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  offeringPriceLists: Array<InitialPurchasePriceOfferingPriceList>;
  /** Sum of unit prices of variants in the first order. Does not take discounting or credit into account. */
  originalAmount: Scalars['Float']['output'];
  /** Credit carried over from previous purchases on this session. */
  sessionCreditAmount: Scalars['Float']['output'];
};

export type InitialPurchasePriceOfferingPriceList = {
  __typename?: 'InitialPurchasePriceOfferingPriceList';
  id: Scalars['ID']['output'];
  offering?: Maybe<AddOnOffering | OtcOffering | RxOffering>;
  sequencePriceLists: Array<InitialPurchasePriceSequencePriceList>;
};

export type InitialPurchasePriceSequencePriceList = {
  __typename?: 'InitialPurchasePriceSequencePriceList';
  id: Scalars['ID']['output'];
  pricedItems: Array<InitialPurchasePriceSequencePricedItem>;
  sequence?: Maybe<OtcSequence | PrescribableSequence>;
  sequenceSet?: Maybe<SequenceSet>;
};

export type InitialPurchasePriceSequencePricedItem = {
  __typename?: 'InitialPurchasePriceSequencePricedItem';
  id: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  unitPrice: Scalars['Float']['output'];
  unitPriceDiscount: Scalars['Float']['output'];
  variant?: Maybe<Variant>;
};

/** This purchase prompt is surfaced when the customer is eligible to start a new treatment for the associated problem type. */
export type InitialPurchasePrompt = PurchasePrompt & {
  __typename?: 'InitialPurchasePrompt';
  id: Scalars['ID']['output'];
  /** The simplest offering selection fitting the needs of the patient. Will prefer an offering matching an existing prescribed sequence over other potentially simpler offerings. Optionally accepts a pre-selected offering selection that overrides the default proposed selection if valid. */
  proposedOfferingSelection?: Maybe<OfferingSelection>;
};


/** This purchase prompt is surfaced when the customer is eligible to start a new treatment for the associated problem type. */
export type InitialPurchasePromptProposedOfferingSelectionArgs = {
  input?: InputMaybe<InitialPurchaseProposedOfferingSelectionInput>;
};

export type InitialPurchaseProposedOfferingSelectionInput = {
  selection: OfferingSelectionInput;
};

export type InitiateFlexiZipCheckoutInput = {
  couponCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  offeringSelections: Array<OfferingSelectionInput>;
  pricingSessionId: Scalars['ID']['input'];
  redirectUrl: Scalars['String']['input'];
};

export type InternalTriggerSequenceNode = SequenceNode & {
  __typename?: 'InternalTriggerSequenceNode';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  nextNodeId?: Maybe<Scalars['ID']['output']>;
};

export type IntervalType =
  | 'DAYS'
  | 'HOURS'
  | 'MONTHS';

export type ItemListShopSection = ShopSection & {
  __typename?: 'ItemListShopSection';
  id: Scalars['ID']['output'];
  items?: Maybe<Array<ShopItem>>;
  title: Scalars['String']['output'];
  totalItems?: Maybe<Scalars['Int']['output']>;
};

export type Job = {
  __typename?: 'Job';
  createdAt: Scalars['DateTime']['output'];
  data?: Maybe<Scalars['Json']['output']>;
  doneAt?: Maybe<Scalars['DateTime']['output']>;
  failed: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isReApprove?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
  orderId?: Maybe<Scalars['String']['output']>;
  retries: Scalars['Int']['output'];
  scheduledAt?: Maybe<Scalars['DateTime']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  treatment?: Maybe<Treatment>;
  treatmentId?: Maybe<Scalars['String']['output']>;
  type: JobType;
  updatedAt: Scalars['DateTime']['output'];
};

export type JobType =
  | 'ERX_MEDICINE_UPDATE'
  | 'MEMBERSHIP_EXPIRE'
  | 'MEMBERSHIP_REMINDER'
  | 'MEMBERSHIP_RENEW'
  | 'MIMS_MEDICINE_DELETION'
  | 'PROCESS_ORDER'
  | 'PROCESS_PAYMENT'
  | 'PROCESS_SIGNED_SCRIPT_BUNDLE'
  | 'PROCESS_WEBFLOW_ORDER'
  | 'REMINDER';

export type JoinChatThreadPayload = {
  __typename?: 'JoinChatThreadPayload';
  chatThread?: Maybe<ChatThread>;
};

export type LeaveChatThreadPayload = {
  __typename?: 'LeaveChatThreadPayload';
  chatThread?: Maybe<ChatThread>;
};

export type LevelTree = {
  __typename?: 'LevelTree';
  id: Scalars['ID']['output'];
  pillars?: Maybe<Array<LevelTreePillar>>;
  problemType: ProblemType;
};

export type LevelTreeAction = {
  __typename?: 'LevelTreeAction';
  actionTemplate?: Maybe<LevelTreeActionTemplate>;
  canSubmit: Scalars['Boolean']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Always null for non-repeating actions */
  completedCount?: Maybe<Scalars['Int']['output']>;
  goal?: Maybe<LevelTreeGoal>;
  history?: Maybe<Array<LevelTreeActionHistory>>;
  id: Scalars['ID']['output'];
  lastSubmittedAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<LevelTreeNodeState>;
};

export type LevelTreeActionAttachment = {
  __typename?: 'LevelTreeActionAttachment';
  downloadUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type LevelTreeActionHistory = {
  __typename?: 'LevelTreeActionHistory';
  /** Always null for non-repeating actions */
  completedCount?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  mediaAttachments?: Maybe<Array<LevelTreeActionAttachment>>;
  status?: Maybe<LevelTreeNodeState>;
};

export type LevelTreeActionTemplate = {
  __typename?: 'LevelTreeActionTemplate';
  contentItems?: Maybe<Array<FaqContentItem | ReadingContentItem | RecipeContentItem | VideoContentItem | VideoWithReadingContentItem>>;
  id: Scalars['ID']['output'];
  latestPublishedVersion?: Maybe<LevelTreeActionTemplate>;
  mediaAttachmentRequirement?: Maybe<ActionMediaAttachmentRequirement>;
  name?: Maybe<Scalars['String']['output']>;
  repeatingActionTemplate?: Maybe<LevelTreeRepeatingActionTemplate>;
};

export type LevelTreeGoal = {
  __typename?: 'LevelTreeGoal';
  actions?: Maybe<Array<LevelTreeAction>>;
  goalTemplate?: Maybe<DefaultLevelTreeGoalTemplate | VariantLevelTreeGoalTemplate>;
  id: Scalars['ID']['output'];
  level?: Maybe<LevelTreeLevel>;
  progressPercentage?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<LevelTreeNodeState>;
};

export type LevelTreeGoalTemplate = {
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Actions are returned in order of position of position. */
  latestPublishedActions?: Maybe<Array<LevelTreeActionTemplate>>;
  name?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  useCase?: Maybe<Scalars['String']['output']>;
};

export type LevelTreeLevel = {
  __typename?: 'LevelTreeLevel';
  activeGoal?: Maybe<LevelTreeGoal>;
  goals?: Maybe<Array<LevelTreeGoal>>;
  id: Scalars['ID']['output'];
  lastCompletedGoal?: Maybe<LevelTreeGoal>;
  levelTemplate?: Maybe<LevelTreeLevelTemplate>;
  pillar?: Maybe<LevelTreePillar>;
  status?: Maybe<LevelTreeNodeState>;
};

export type LevelTreeLevelTemplate = {
  __typename?: 'LevelTreeLevelTemplate';
  id: Scalars['ID']['output'];
  latestPublishedVersion?: Maybe<LevelTreeLevelTemplate>;
  levelNumber: Scalars['Int']['output'];
};

export type LevelTreeNodeState =
  | 'AVAILABLE'
  | 'COMPLETED'
  | 'IN_PROGRESS'
  | 'LOCKED'
  | 'SKIPPED';

export type LevelTreePillar = {
  __typename?: 'LevelTreePillar';
  activeLevel?: Maybe<LevelTreeLevel>;
  id: Scalars['ID']['output'];
  lastCompletedLevel?: Maybe<LevelTreeLevel>;
  levels?: Maybe<Array<LevelTreeLevel>>;
  numberOfLevels: Scalars['Int']['output'];
  pillarTemplate?: Maybe<LevelTreePillarTemplate>;
  status?: Maybe<LevelTreeNodeState>;
};

export type LevelTreePillarTemplate = {
  __typename?: 'LevelTreePillarTemplate';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  latestPublishedVersion?: Maybe<LevelTreePillarTemplate>;
  levelsDescription?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
};

export type LevelTreeRepeatingActionTemplate = {
  __typename?: 'LevelTreeRepeatingActionTemplate';
  id: Scalars['ID']['output'];
  repeatCount: Scalars['Int']['output'];
  repeatRefreshTime: Scalars['String']['output'];
  repeatRefreshTimezone: Scalars['String']['output'];
};

export type LinePhoneCallDetails = PhoneCallProviderDetails & {
  __typename?: 'LinePhoneCallDetails';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
};

export type LinkCallToConsultationInput = {
  callId: Scalars['ID']['input'];
  consultationId: Scalars['ID']['input'];
};

export type LinkCallToConsultationPayload = {
  __typename?: 'LinkCallToConsultationPayload';
  consultation?: Maybe<Consultation>;
};

export type MasterclassVideo = {
  __typename?: 'MasterclassVideo';
  created?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  hashed_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  section?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Thumbnail>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['String']['output']>;
};

export type MedicalProfile = {
  __typename?: 'MedicalProfile';
  age?: Maybe<Scalars['Int']['output']>;
  allergies?: Maybe<Scalars['String']['output']>;
  bmi?: Maybe<Scalars['Float']['output']>;
  currentMedications?: Maybe<Scalars['String']['output']>;
  /** @deprecated do not use, implementation removed */
  diabetesRiskLevel?: Maybe<DiabetesRiskLevel>;
  dob?: Maybe<Scalars['String']['output']>;
  existingConditions?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  pregnancyStatus?: Maybe<PregnancyStatus>;
  requiresClinicalReview: Scalars['Boolean']['output'];
  sex?: Maybe<Sex>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type MedicareSexType =
  | 'F'
  | 'I'
  | 'M'
  | 'N';

export type MedicationPreferenceProducts = {
  __typename?: 'MedicationPreferenceProducts';
  defaultProduct: Product;
  id: Scalars['ID']['output'];
  preferredProduct?: Maybe<Product>;
};

export type Membership = {
  __typename?: 'Membership';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  membershipTerms: Array<MembershipTerm>;
  type: ProblemType;
  updatedAt: Scalars['DateTime']['output'];
};


export type MembershipMembershipTermsArgs = {
  orderBy?: InputMaybe<Array<MembershipTermOrderByInput>>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type MembershipInterval =
  | 'MONTHS';

export type MembershipStatus =
  | 'ACTIVE'
  | 'CANCELED'
  | 'EXPIRED'
  | 'PAYMENT_FAILED'
  | 'PENDING'
  | 'PENDING_RENEW'
  | 'RENEW_FAILED';

export type MembershipSubscriptionStatus =
  | 'ACTIVE'
  | 'CANCELED';

export type MembershipTerm = {
  __typename?: 'MembershipTerm';
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  interval: MembershipInterval;
  intervalCount: Scalars['Int']['output'];
  isValid: Scalars['Boolean']['output'];
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status: MembershipStatus;
  subscriptionStatus: MembershipSubscriptionStatus;
};

export type MembershipTermOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
};

export type MenopauseSymptoms =
  | 'HOT_FLUSHES'
  | 'JOINT_PAIN'
  | 'LOW_LIBIDO'
  | 'MOOD_CHANGES'
  | 'SKIN_IRRITATION'
  | 'SLEEPLESSNESS'
  | 'VAGINAL_SYMPTOMS'
  | 'WEIGHT_GAIN';

/** A MetaNote is a Note with a Note parent entity (i.e. a Note on a Note), similar to how a ConsultationNote is a note on a Consultation. Initially, the use case is to allow users to archive or add addendums to Notes. */
export type MetaNote = Note & {
  __typename?: 'MetaNote';
  archivalNote?: Maybe<MetaNote>;
  author?: Maybe<User>;
  body: Scalars['String']['output'];
  canArchive: Scalars['Boolean']['output'];
  canEdit: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  domain: NoteDomain;
  history?: Maybe<Array<NoteHistoryEntry>>;
  id: Scalars['ID']['output'];
  parent?: Maybe<ConsultationNote | CustomerNote | MetaNote>;
  updatedAt: Scalars['DateTime']['output'];
};

export type MilestoneCelebration = {
  __typename?: 'MilestoneCelebration';
  id: Scalars['ID']['output'];
  references?: Maybe<Array<MilestoneCelebrationReference>>;
  text?: Maybe<Scalars['String']['output']>;
};

export type MilestoneCelebrationReference = {
  __typename?: 'MilestoneCelebrationReference';
  id: Scalars['ID']['output'];
  text?: Maybe<Scalars['String']['output']>;
};

export type MilestoneWeightStatusType =
  | 'COMPLETE'
  | 'IN_PROGRESS'
  | 'RELAPSED'
  | 'UPCOMING';

export type MobileAppAccess = {
  __typename?: 'MobileAppAccess';
  features?: Maybe<Array<HealthCoachChat>>;
  id: Scalars['ID']['output'];
};

export type MobileAppFeature = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type MonetaryAmount = {
  __typename?: 'MonetaryAmount';
  baseUnitAmount: Scalars['Int']['output'];
  currencySymbol: Scalars['String']['output'];
  formattedAmount: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  postSeparator: Scalars['String']['output'];
  preSeparator: Scalars['String']['output'];
  separator: Scalars['String']['output'];
};

export type MoveConsultationPaidToOrderPaidPayload = {
  __typename?: 'MoveConsultationPaidToOrderPaidPayload';
  success: Scalars['Boolean']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  abortEPrescription?: Maybe<Scalars['Boolean']['output']>;
  addCouponCodesToPurchaseSyncGroup?: Maybe<AddCouponCodesToPurchaseSyncGroupPayload>;
  addDoctorQuestion?: Maybe<Consultation>;
  addNotes?: Maybe<Consultation>;
  addPatientQuestionToConsultation?: Maybe<Consultation>;
  addTreatmentDiscount?: Maybe<Treatment>;
  addUserToSegment?: Maybe<Segment>;
  answerApplicationQuestion?: Maybe<QuizApplication>;
  answerApplicationQuestions?: Maybe<QuizApplication>;
  answerDoctorQuestions?: Maybe<Consultation>;
  approveConsultation?: Maybe<Consultation>;
  assignChatCustomers?: Maybe<AssignChatCustomersPayload>;
  assignChatThreads?: Maybe<AssignChatThreadsPayload>;
  assignNextPatient?: Maybe<AssignNextPatientPayload>;
  cancelConsultationReminder?: Maybe<ConsultationReminder>;
  cancelEPrescription?: Maybe<Scalars['Boolean']['output']>;
  cancelExperimentPaymentPlan: Treatment;
  cancelSubscription?: Maybe<Membership>;
  cancelSubscriptionPlan?: Maybe<SubscriptionPlan>;
  cancelSubscriptionV2?: Maybe<SubscriptionV2>;
  cancelTreatment?: Maybe<CancelTreatmentPayload>;
  ceaseEPrescription?: Maybe<Scalars['Boolean']['output']>;
  changeExperimentPaymentPlan: Treatment;
  changeLevelTreeGoal?: Maybe<ChangeLevelTreeGoalPayload>;
  changeLevelTreeLevel?: Maybe<ChangeLevelTreeLevelPayload>;
  clearUserPushToken?: Maybe<ClearUserPushTokenPayload>;
  completeChecklistItem?: Maybe<ChecklistItem>;
  completeConsultation?: Maybe<Consultation>;
  confirmAsyncConsultation?: Maybe<ConfirmAsyncConsultationPayload>;
  confirmOrder?: Maybe<Order>;
  confirmPurchaseGroup?: Maybe<ConfirmPurchaseGroupPayload>;
  continueExistingTreatment?: Maybe<Consultation>;
  continuePrescribedSequence?: Maybe<ContinuePrescribedSequencePayload>;
  createCallWithManualConfirmation: CreateCallWithManualConfirmationPayload;
  createChecklist?: Maybe<Checklist>;
  createConsultationReminder?: Maybe<ConsultationReminder>;
  createOrRetrieveStripeSetupIntent?: Maybe<StripeSetupIntent>;
  createOtcOrder?: Maybe<Order>;
  createPathologyRequest?: Maybe<PathologyRequest>;
  createPrescriptionBundle?: Maybe<Scalars['String']['output']>;
  createPrescriptionBundleWithPrescriptions?: Maybe<Scalars['String']['output']>;
  createReviewConsultation?: Maybe<CreateReviewConsultationPayload>;
  createWearableIntegration?: Maybe<CreateNativeWearableIntegrationPayload | CreateWebApiWearableIntegrationPayload>;
  createWeightLossJourneyStart?: Maybe<WeightLossJourneyStartPayload>;
  delayPurchaseSyncGroup?: Maybe<DelayPurchaseSyncGroupPayload>;
  delayTreatment?: Maybe<Treatment>;
  deleteMedicationPreference?: Maybe<DeleteMedicationPreferencePayload>;
  deleteTrackerEntry?: Maybe<DeleteTrackerEntryPayload>;
  deleteWearableIntegration?: Maybe<DeleteWearableIntegrationPayload>;
  dismissConsultation?: Maybe<Consultation>;
  doctorsLoginSSO: AuthPayload;
  editWaistObservationCm?: Maybe<EditWaistObservationCmPayload>;
  editWeightObservationKg?: Maybe<EditWeightObservationKgPayload>;
  generateLevelTreeActionSignedUploadUrl?: Maybe<GenerateLevelTreeActionSignedUploadUrlPayload>;
  /** @deprecated Pharmacy invoices are handled by the dispensing pharmacy */
  generatePharmacyInvoice?: Maybe<GeneratePharmacyInvoicePayload>;
  /** This is a temporary mutation to enable Zip payments in Flexi prior to migrating from Stripe Setup Intents to Stripe Payment Intents. It provides a redirection URL that allows a customer to authorise payment via Zip for purchasing an offering. */
  initiateFlexiZipCheckout?: Maybe<ZipCheckoutResponse>;
  initiateZipCheckout?: Maybe<ZipCheckoutResponse>;
  initiateZipConsultationPayment?: Maybe<ZipCheckoutResponse>;
  joinChatThread?: Maybe<JoinChatThreadPayload>;
  leaveChatThread?: Maybe<LeaveChatThreadPayload>;
  linkCallToConsultation: LinkCallToConsultationPayload;
  login: AuthPayload;
  markConsultationStatusAwaitingAnswer?: Maybe<Consultation>;
  markEducationReadingCompleted?: Maybe<EducationReading>;
  markEducationReadingStarted?: Maybe<EducationReading>;
  markMedicalRecordAsReviewed: Scalars['Boolean']['output'];
  membershipSubscribe?: Maybe<Membership>;
  migrateCustomerSubscriptions?: Maybe<Array<Maybe<SubscriptionV2>>>;
  /** Update a consultation in the development environment to move from consultation completed to doctor completed */
  moveConsultationPaidToOrderPaid?: Maybe<MoveConsultationPaidToOrderPaidPayload>;
  passwordReset?: Maybe<TriggerPasswordResetPayload>;
  pausePurchase?: Maybe<PausePurchasePayload>;
  pauseTreatment?: Maybe<Treatment>;
  payConsultation?: Maybe<Consultation>;
  postponeConsultation?: Maybe<Job>;
  prescribeSequence?: Maybe<PrescribeSequencePayload>;
  purchaseOfferings?: Maybe<PurchaseOfferingsPayload>;
  purchaseOrder?: Maybe<Order>;
  purchaseOtcShoppingCart?: Maybe<OtcShoppingCart>;
  reactivateMembership?: Maybe<Membership>;
  reactivateSubscription?: Maybe<Membership>;
  reactivateSubscriptionV2?: Maybe<SubscriptionV2>;
  reassignChatThread?: Maybe<ReassignChatThreadPayload>;
  reassignChatThreads?: Maybe<ReassignChatThreadsPayload>;
  refillSubscriptionV2?: Maybe<SubscriptionV2>;
  refillTreatment?: Maybe<Treatment>;
  registerMissedAppointment?: Maybe<RegisterMissedAppointmentPayload>;
  rejectConsultationV2?: Maybe<Consultation>;
  removeOtcProductFromTreatment?: Maybe<Treatment>;
  removeOtcShoppingCartItem?: Maybe<OtcShoppingCart>;
  removeTreatmentDiscount?: Maybe<Treatment>;
  removeZip?: Maybe<Scalars['Boolean']['output']>;
  reopenApplication?: Maybe<QuizApplication>;
  requestPatientPhotosForConsultation?: Maybe<Consultation>;
  requestReviewTreatment?: Maybe<Consultation>;
  /** Creates a support ticket for the patient regarding their treatment. Note that the 'subject' and 'body' values will become patient facing in the initial support email. See https://www.notion.so/eucalyptus-vc/Admins-link-being-exposed-to-software-patients-through-support-emails-Zendesk-99e032f7ebee4ac0b98eed27b28b5500 for a previous incident. */
  requestReviewTreatmentSupport?: Maybe<Treatment>;
  restartFlow?: Maybe<RestartFlowPayload>;
  resumePurchase?: Maybe<ResumePurchasePayload>;
  retryPayment?: Maybe<Membership>;
  savePatientNotes?: Maybe<Consultation>;
  saveProgress?: Maybe<User>;
  sendPhoneNumberVerification?: Maybe<Scalars['Boolean']['output']>;
  /** Update the progress for a given content item. Must provide progress for exactly one content type. */
  setContentItemProgress?: Maybe<SetContentItemProgressPayload>;
  /** Sets the patient's goal weight */
  setGoalWeight?: Maybe<SetGoalWeightPayload>;
  setHealthCoachAvailability?: Maybe<SetHealthCoachAvailabilityPayload>;
  setStepsGoal?: Maybe<SetStepsGoalPayload>;
  setTrendAsAddressed?: Maybe<SetTrendAsAddressedPayload>;
  /** used to update users push noti token */
  setUserPushToken?: Maybe<SetUserPushTokenPayload>;
  setUserStatedCallResult: SetUserStatedCallResultPayload;
  signPrescriptionDigitally?: Maybe<Scalars['Boolean']['output']>;
  signUpLead?: Maybe<AuthPayload>;
  signup?: Maybe<AuthPayload>;
  startQuizApplication?: Maybe<QuizApplication>;
  startQuizApplicationWithQuizCode?: Maybe<QuizApplication>;
  submitApplication?: Maybe<QuizApplication>;
  submitConsultationQuestionToPharmacist?: Maybe<SubmitConsultationQuestionToPharmacistPayload>;
  submitLevelTreeAction?: Maybe<SubmitLevelTreeActionPayload>;
  submitPatientPharmacistQuestion?: Maybe<Scalars['Boolean']['output']>;
  subscribePlanV2?: Maybe<SubscriptionV2>;
  switchPrescribedSequence?: Maybe<SwitchPrescribedSequencePayload>;
  switchPurchasedOffering?: Maybe<SwitchPurchasedOfferingPayload>;
  trackApplicationStop?: Maybe<QuizApplication>;
  trackWaistCmV2?: Maybe<TrackWaistCmV2Payload>;
  trackWeightKgV2?: Maybe<TrackWeightLossKgV2Payload>;
  triggerPasswordReset?: Maybe<TriggerPasswordResetPayload>;
  unCompleteChecklistItem?: Maybe<ChecklistItem>;
  unsubmitLevelTreeAction?: Maybe<UnsubmitLevelTreeActionPayload>;
  updateChatThreadStatus?: Maybe<UpdateChatThreadStatusPayload>;
  updateCustomerStatedTreatmentStatedAt?: Maybe<Treatment>;
  updateDefaultPaymentGateway?: Maybe<Scalars['Boolean']['output']>;
  updateLineItem?: Maybe<Order>;
  updateMedicareDetails?: Maybe<Scalars['Boolean']['output']>;
  updateMedicationPreference?: Maybe<UserNominatedMedicationPreference>;
  updateNotificationPrefs?: Maybe<UpdateNotificationPrefsPayload>;
  updateOtcShoppingCart?: Maybe<OtcShoppingCart>;
  updatePassword?: Maybe<Scalars['Boolean']['output']>;
  updatePathologyCustomerStatedCollectedAt?: Maybe<PathologyRequest>;
  updatePathologyTestResults?: Maybe<PathologyRequest>;
  updatePayment?: Maybe<User>;
  updateProfile?: Maybe<User>;
  updateResidentialAddress?: Maybe<ResidentialAddress>;
  updateShipping?: Maybe<User>;
  updateWearableIntegration?: Maybe<UpdateWearableIntegrationPayload>;
  upsertDvaFileNumber?: Maybe<UpsertDvaFileNumberPayload>;
  /** used to create/update notes */
  upsertNote?: Maybe<UpsertNotePayload>;
  upsertOtcProductToTreatment?: Maybe<Treatment>;
  upsertPractitionerBooking?: Maybe<UpsertPractitionerBookingPayload>;
  verifyId?: Maybe<User>;
};


export type MutationAbortEPrescriptionArgs = {
  id: Scalars['String']['input'];
  patientId: Scalars['String']['input'];
};


export type MutationAddCouponCodesToPurchaseSyncGroupArgs = {
  input: AddCouponCodesToPurchaseSyncGroupInput;
};


export type MutationAddDoctorQuestionArgs = {
  allowedAnswerType?: InputMaybe<ConsultationAnswerType>;
  attachmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  consultationId: Scalars['String']['input'];
  question: Scalars['String']['input'];
};


export type MutationAddNotesArgs = {
  id: Scalars['String']['input'];
  notes: Scalars['String']['input'];
};


export type MutationAddPatientQuestionToConsultationArgs = {
  id: Scalars['String']['input'];
  question: Scalars['String']['input'];
  trigger: Scalars['String']['input'];
};


export type MutationAddTreatmentDiscountArgs = {
  discountCode: Scalars['String']['input'];
  treatmentId: Scalars['String']['input'];
};


export type MutationAddUserToSegmentArgs = {
  activeFrom?: InputMaybe<Scalars['String']['input']>;
  activeTo?: InputMaybe<Scalars['String']['input']>;
  segmentName: Segment;
};


export type MutationAnswerApplicationQuestionArgs = {
  answer?: InputMaybe<Scalars['String']['input']>;
  answerId?: InputMaybe<Scalars['String']['input']>;
  answersArray?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  applicationId: Scalars['String']['input'];
  optionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  questionId: Scalars['String']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAnswerApplicationQuestionsArgs = {
  answers?: InputMaybe<Array<InputMaybe<AnswerInput>>>;
  applicationId: Scalars['String']['input'];
};


export type MutationAnswerDoctorQuestionsArgs = {
  answers?: InputMaybe<Scalars['Json']['input']>;
  consultationId: Scalars['String']['input'];
};


export type MutationApproveConsultationArgs = {
  abortKey?: InputMaybe<Scalars['String']['input']>;
  acknowledgedReviewedPhotos?: InputMaybe<Scalars['Boolean']['input']>;
  allergies?: InputMaybe<Scalars['String']['input']>;
  annotations?: InputMaybe<Array<InputMaybe<AnnotationInput>>>;
  currentMedications?: InputMaybe<Scalars['String']['input']>;
  dob: Scalars['String']['input'];
  doctorNotesToPharmacist?: InputMaybe<Scalars['String']['input']>;
  erxTokenEmail?: InputMaybe<Scalars['String']['input']>;
  existingConditions?: InputMaybe<Scalars['String']['input']>;
  hadPreviousSideEffects?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  isEmergencySupply?: InputMaybe<Scalars['Boolean']['input']>;
  isUnusualDosage?: InputMaybe<Scalars['Boolean']['input']>;
  maximumQuantity?: InputMaybe<Scalars['String']['input']>;
  minimumRepeatIntervalDays?: InputMaybe<Scalars['Int']['input']>;
  patientNotes: Scalars['String']['input'];
  preventBrandSubstitution?: InputMaybe<Scalars['Boolean']['input']>;
  previouslyTaken?: InputMaybe<Scalars['Boolean']['input']>;
  reasonForPrescribing?: InputMaybe<Scalars['String']['input']>;
  regulation24Applied?: InputMaybe<Scalars['Boolean']['input']>;
  skipCallHistoryCheck?: InputMaybe<Scalars['Boolean']['input']>;
  skipMySL?: InputMaybe<Scalars['Boolean']['input']>;
  skipPharmacySL?: InputMaybe<SkipPharmacySlType>;
  useLegacyPaperScript?: InputMaybe<Scalars['Boolean']['input']>;
  variantId: Scalars['String']['input'];
};


export type MutationAssignChatCustomersArgs = {
  assignments: Array<AssignChatCustomerInput>;
  threadType: ChatThreadType;
};


export type MutationAssignChatThreadsArgs = {
  counts: Array<AssignChatThreadCountInput>;
  statuses: Array<ChatThreadStatus>;
  threadType: ChatThreadType;
};


export type MutationAssignNextPatientArgs = {
  problemTypes: Array<ProblemType>;
};


export type MutationCancelConsultationReminderArgs = {
  consultationId: Scalars['String']['input'];
};


export type MutationCancelEPrescriptionArgs = {
  prescriptionDocumentId: Scalars['String']['input'];
};


export type MutationCancelExperimentPaymentPlanArgs = {
  treatmentId: Scalars['String']['input'];
};


export type MutationCancelSubscriptionArgs = {
  cancelOtherReason?: InputMaybe<Scalars['String']['input']>;
  cancelReason?: InputMaybe<Scalars['String']['input']>;
  type: ProblemType;
};


export type MutationCancelSubscriptionPlanArgs = {
  subscriptionId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCancelSubscriptionV2Args = {
  subscriptionId: Scalars['String']['input'];
};


export type MutationCancelTreatmentArgs = {
  input: CancelTreatmentInput;
};


export type MutationCeaseEPrescriptionArgs = {
  prescriptionDocumentId: Scalars['String']['input'];
};


export type MutationChangeExperimentPaymentPlanArgs = {
  paymentPlan: ExperimentPaymentPlanVariant;
  treatmentId: Scalars['String']['input'];
  version?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationChangeLevelTreeGoalArgs = {
  input: ChangeLevelTreeGoalInput;
};


export type MutationChangeLevelTreeLevelArgs = {
  input: ChangeLevelTreeLevelInput;
};


export type MutationClearUserPushTokenArgs = {
  devicePlatform: DevicePlatform;
};


export type MutationCompleteChecklistItemArgs = {
  checklistId: Scalars['String']['input'];
  code: Scalars['String']['input'];
};


export type MutationCompleteConsultationArgs = {
  id: Scalars['String']['input'];
  patientNotes: Scalars['String']['input'];
};


export type MutationConfirmAsyncConsultationArgs = {
  input: ConfirmAsyncConsultationInput;
};


export type MutationConfirmOrderArgs = {
  address?: InputMaybe<AddressCreateWithoutUserInput>;
  cardMeta?: InputMaybe<CardMetaCreateInput>;
  consultationId: Scalars['String']['input'];
  couponCode?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gateway?: InputMaybe<PaymentGateway>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  zipCheckoutId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationConfirmPurchaseGroupArgs = {
  input: ConfirmPurchaseGroupInput;
};


export type MutationContinueExistingTreatmentArgs = {
  consultationId: Scalars['String']['input'];
  patientNotes: Scalars['String']['input'];
};


export type MutationContinuePrescribedSequenceArgs = {
  input: ContinuePrescribedSequenceInput;
};


export type MutationCreateCallWithManualConfirmationArgs = {
  input: CreateCallWithManualConfirmationInput;
};


export type MutationCreateChecklistArgs = {
  consultationId: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type MutationCreateConsultationReminderArgs = {
  consultationId: Scalars['String']['input'];
  scheduledAt: Scalars['DateTime']['input'];
};


export type MutationCreateOtcOrderArgs = {
  items: Array<PurchaseOtcItemInput>;
};


export type MutationCreatePathologyRequestArgs = {
  consultationId: Scalars['String']['input'];
};


export type MutationCreatePrescriptionBundleWithPrescriptionsArgs = {
  prescriptionIds: Array<Scalars['String']['input']>;
};


export type MutationCreateReviewConsultationArgs = {
  input: CreateReviewConsultationInput;
};


export type MutationCreateWearableIntegrationArgs = {
  input: CreateWearableIntegrationInput;
};


export type MutationCreateWeightLossJourneyStartArgs = {
  input: WeightLossJourneyStartInput;
};


export type MutationDelayPurchaseSyncGroupArgs = {
  input: DelayPurchaseSyncGroupInput;
};


export type MutationDelayTreatmentArgs = {
  id: Scalars['String']['input'];
  newDate: Scalars['String']['input'];
  trigger?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteMedicationPreferenceArgs = {
  input: DeleteMedicationPreferenceInput;
};


export type MutationDeleteTrackerEntryArgs = {
  input: DeleteTrackerEntryInput;
};


export type MutationDeleteWearableIntegrationArgs = {
  input: DeleteWearableIntegrationInput;
};


export type MutationDismissConsultationArgs = {
  consultationId: Scalars['ID']['input'];
};


export type MutationDoctorsLoginSsoArgs = {
  id_token: Scalars['String']['input'];
};


export type MutationEditWaistObservationCmArgs = {
  input: EditWaistCmObservationInput;
};


export type MutationEditWeightObservationKgArgs = {
  input: EditWeightKgObservationInput;
};


export type MutationGenerateLevelTreeActionSignedUploadUrlArgs = {
  input: GenerateLevelTreeActionSignedUploadUrlInput;
};


export type MutationGeneratePharmacyInvoiceArgs = {
  input: GeneratePharmacyInvoiceInput;
};


export type MutationInitiateFlexiZipCheckoutArgs = {
  input: InitiateFlexiZipCheckoutInput;
};


export type MutationInitiateZipCheckoutArgs = {
  address: AddressCreateWithoutUserInput;
  couponCode?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  redirectUrl: Scalars['String']['input'];
};


export type MutationInitiateZipConsultationPaymentArgs = {
  consultationId: Scalars['String']['input'];
  couponCode?: InputMaybe<Scalars['String']['input']>;
  redirectUrl: Scalars['String']['input'];
};


export type MutationJoinChatThreadArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLeaveChatThreadArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLinkCallToConsultationArgs = {
  input: LinkCallToConsultationInput;
};


export type MutationLoginArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMarkConsultationStatusAwaitingAnswerArgs = {
  consultationId: Scalars['String']['input'];
};


export type MutationMarkEducationReadingCompletedArgs = {
  readingId: Scalars['ID']['input'];
};


export type MutationMarkEducationReadingStartedArgs = {
  readingId: Scalars['ID']['input'];
};


export type MutationMarkMedicalRecordAsReviewedArgs = {
  patientId: Scalars['String']['input'];
};


export type MutationMembershipSubscribeArgs = {
  cardMeta?: InputMaybe<CardMetaCreateInput>;
  couponCode?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  type: ProblemType;
};


export type MutationMoveConsultationPaidToOrderPaidArgs = {
  consultationId: Scalars['String']['input'];
  doctorId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPasswordResetArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  resetToken?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPausePurchaseArgs = {
  input: PausePurchaseInput;
};


export type MutationPauseTreatmentArgs = {
  id: Scalars['String']['input'];
  isReview?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  reasonExtended?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPayConsultationArgs = {
  cardMeta?: InputMaybe<CardMetaCreateInput>;
  couponCode?: InputMaybe<Scalars['String']['input']>;
  gateway?: InputMaybe<PaymentGateway>;
  id: Scalars['String']['input'];
  method?: InputMaybe<Scalars['String']['input']>;
  stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  zipCheckoutId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPostponeConsultationArgs = {
  id: Scalars['String']['input'];
  months: Scalars['Int']['input'];
};


export type MutationPrescribeSequenceArgs = {
  input: PrescribeSequenceInput;
};


export type MutationPurchaseOfferingsArgs = {
  input: PurchaseOfferingsInput;
};


export type MutationPurchaseOrderArgs = {
  cardMeta?: InputMaybe<CardMetaCreateInput>;
  couponCode?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPurchaseOtcShoppingCartArgs = {
  cartId: Scalars['String']['input'];
  discountCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationReactivateMembershipArgs = {
  type: ProblemType;
};


export type MutationReactivateSubscriptionArgs = {
  type: ProblemType;
};


export type MutationReactivateSubscriptionV2Args = {
  subscriptionId: Scalars['String']['input'];
};


export type MutationReassignChatThreadArgs = {
  chatThreadId: Scalars['ID']['input'];
  toUserId: Scalars['ID']['input'];
};


export type MutationReassignChatThreadsArgs = {
  counts: Array<AssignChatThreadCountInput>;
  fromUserId: Scalars['ID']['input'];
  statuses: Array<ChatThreadStatus>;
  threadType: ChatThreadType;
};


export type MutationRefillSubscriptionV2Args = {
  subscriptionId: Scalars['String']['input'];
};


export type MutationRefillTreatmentArgs = {
  isPaused?: InputMaybe<Scalars['Boolean']['input']>;
  treatmentId: Scalars['String']['input'];
};


export type MutationRegisterMissedAppointmentArgs = {
  input: RegisterMissedAppointmentInput;
};


export type MutationRejectConsultationV2Args = {
  id: Scalars['String']['input'];
  rejectReason?: InputMaybe<Scalars['String']['input']>;
  rejectReasonMeta?: InputMaybe<ConsultationRejectReasonMetaInput>;
};


export type MutationRemoveOtcProductFromTreatmentArgs = {
  id: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemoveOtcShoppingCartItemArgs = {
  cartId: Scalars['String']['input'];
  variantId: Scalars['String']['input'];
};


export type MutationRemoveTreatmentDiscountArgs = {
  treatmentId: Scalars['String']['input'];
};


export type MutationReopenApplicationArgs = {
  id: Scalars['String']['input'];
};


export type MutationRequestPatientPhotosForConsultationArgs = {
  consultationId: Scalars['String']['input'];
};


export type MutationRequestReviewTreatmentArgs = {
  input: RequestReviewTreatmentInput;
};


export type MutationRequestReviewTreatmentSupportArgs = {
  body: Scalars['String']['input'];
  category: TreatmentReviewCategory;
  quizApplicationId?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
  treatmentId: Scalars['String']['input'];
};


export type MutationRestartFlowArgs = {
  input: RestartFlowInput;
};


export type MutationResumePurchaseArgs = {
  input: ResumePurchaseInput;
};


export type MutationRetryPaymentArgs = {
  type: ProblemType;
};


export type MutationSavePatientNotesArgs = {
  id: Scalars['String']['input'];
  patientNotes: Scalars['String']['input'];
};


export type MutationSaveProgressArgs = {
  progressPercentage: Scalars['Float']['input'];
  videoId: Scalars['String']['input'];
};


export type MutationSendPhoneNumberVerificationArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type MutationSetContentItemProgressArgs = {
  input: SetContentItemProgressInput;
};


export type MutationSetGoalWeightArgs = {
  input: SetGoalWeightInput;
};


export type MutationSetHealthCoachAvailabilityArgs = {
  makeAvailable: Scalars['Boolean']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationSetStepsGoalArgs = {
  input: SetStepsGoalInput;
};


export type MutationSetTrendAsAddressedArgs = {
  input: SetTrendAsAddressedInput;
};


export type MutationSetUserPushTokenArgs = {
  input: SetUserPushTokenInput;
};


export type MutationSetUserStatedCallResultArgs = {
  input: SetUserStatedCallResultInput;
};


export type MutationSignPrescriptionDigitallyArgs = {
  prescriptionDocumentId: Scalars['String']['input'];
};


export type MutationSignUpLeadArgs = {
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  marketingCommsConsent?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSignupArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  marketingCommsConsent?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  trigger?: InputMaybe<Scalars['String']['input']>;
};


export type MutationStartQuizApplicationArgs = {
  errorWhenFollowUpReminderNotDone?: InputMaybe<Scalars['Boolean']['input']>;
  problemType: ProblemType;
  quizPurpose?: InputMaybe<QuizPurpose>;
};


export type MutationStartQuizApplicationWithQuizCodeArgs = {
  quizCode: Scalars['String']['input'];
};


export type MutationSubmitApplicationArgs = {
  id: Scalars['String']['input'];
};


export type MutationSubmitConsultationQuestionToPharmacistArgs = {
  consultationId: Scalars['String']['input'];
  contactMethod?: InputMaybe<ContactMethod>;
  messageText: Scalars['String']['input'];
};


export type MutationSubmitLevelTreeActionArgs = {
  input: SubmitLevelTreeActionInput;
};


export type MutationSubmitPatientPharmacistQuestionArgs = {
  contactMethod?: InputMaybe<ContactMethod>;
  messageText: Scalars['String']['input'];
  treatmentId: Scalars['String']['input'];
};


export type MutationSubscribePlanV2Args = {
  subscriptionPlanId: Scalars['String']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSwitchPrescribedSequenceArgs = {
  input: SwitchPrescribedSequenceInput;
};


export type MutationSwitchPurchasedOfferingArgs = {
  input: SwitchPurchasedOfferingInput;
};


export type MutationTrackApplicationStopArgs = {
  id: Scalars['String']['input'];
};


export type MutationTrackWaistCmV2Args = {
  input: TrackWaistCmV2Input;
};


export type MutationTrackWeightKgV2Args = {
  input: TrackWeightKgV2Input;
};


export type MutationTriggerPasswordResetArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUnCompleteChecklistItemArgs = {
  checklistId: Scalars['String']['input'];
  code: Scalars['String']['input'];
};


export type MutationUnsubmitLevelTreeActionArgs = {
  input: UnsubmitLevelTreeActionInput;
};


export type MutationUpdateChatThreadStatusArgs = {
  chatThreadId: Scalars['ID']['input'];
  status: ChatThreadStatus;
};


export type MutationUpdateCustomerStatedTreatmentStatedAtArgs = {
  date: Scalars['String']['input'];
  treatmentId: Scalars['String']['input'];
};


export type MutationUpdateDefaultPaymentGatewayArgs = {
  gateway: PaymentGateway;
};


export type MutationUpdateLineItemArgs = {
  orderId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  variantId: Scalars['String']['input'];
};


export type MutationUpdateMedicareDetailsArgs = {
  dateOfBirth: Scalars['String']['input'];
  familyName: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  medicareIrn: Scalars['Int']['input'];
  medicareNumber?: InputMaybe<Scalars['String']['input']>;
  problemType?: InputMaybe<ProblemType>;
  sex: MedicareSexType;
  trigger?: InputMaybe<Scalars['String']['input']>;
  validToMonth: Scalars['Int']['input'];
  validToYear: Scalars['Int']['input'];
};


export type MutationUpdateMedicationPreferenceArgs = {
  medicationSkuPrefix: Scalars['String']['input'];
  problemType: ProblemType;
  quizApplicationId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateNotificationPrefsArgs = {
  personalisedMarketing: Scalars['Boolean']['input'];
};


export type MutationUpdateOtcShoppingCartArgs = {
  item: OtcShoppingCartItemInput;
};


export type MutationUpdatePasswordArgs = {
  currentPassword?: InputMaybe<Scalars['String']['input']>;
  newPassword?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdatePathologyCustomerStatedCollectedAtArgs = {
  collectedAt: Scalars['String']['input'];
  pathologyRequestId: Scalars['String']['input'];
};


export type MutationUpdatePathologyTestResultsArgs = {
  pathologyRequestId: Scalars['String']['input'];
  results: Array<PathologyResultValueInput>;
};


export type MutationUpdatePaymentArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  stripeCardMeta?: InputMaybe<Scalars['Json']['input']>;
  stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
  stripeTokenId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateProfileArgs = {
  address?: InputMaybe<AddressCreateWithoutUserInput>;
  birthday?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  namePreference?: InputMaybe<NamePreferenceCreateWithoutUserInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneVerificationCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateResidentialAddressArgs = {
  residentialAddress: ResidentialAddressCreateInput;
};


export type MutationUpdateShippingArgs = {
  address?: InputMaybe<AddressCreateWithoutUserInput>;
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateWearableIntegrationArgs = {
  input: UpdateWearableIntegrationInput;
};


export type MutationUpsertDvaFileNumberArgs = {
  input: UpsertDvaFileNumberInput;
};


export type MutationUpsertNoteArgs = {
  input: UpsertNoteInput;
};


export type MutationUpsertOtcProductToTreatmentArgs = {
  cadence?: InputMaybe<OtcScheduleCadence>;
  id: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpsertPractitionerBookingArgs = {
  input: UpsertPractitionerBookingInput;
};


export type MutationVerifyIdArgs = {
  code: Scalars['String']['input'];
  consultationId?: InputMaybe<Scalars['String']['input']>;
};

export type NamePreferenceCreateWithoutUserInput = {
  preferredName?: InputMaybe<Scalars['String']['input']>;
};

export type NestedBoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type NestedDateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type NestedEnumConsultationStatusFilter = {
  equals?: InputMaybe<ConsultationStatus>;
  in?: InputMaybe<Array<ConsultationStatus>>;
  not?: InputMaybe<NestedEnumConsultationStatusFilter>;
  notIn?: InputMaybe<Array<ConsultationStatus>>;
};

export type NestedEnumOrderPaymentStatusNullableFilter = {
  equals?: InputMaybe<OrderPaymentStatus>;
  in?: InputMaybe<Array<OrderPaymentStatus>>;
  not?: InputMaybe<NestedEnumOrderPaymentStatusNullableFilter>;
  notIn?: InputMaybe<Array<OrderPaymentStatus>>;
};

export type NestedEnumOrderStatusNullableFilter = {
  equals?: InputMaybe<OrderStatus>;
  in?: InputMaybe<Array<OrderStatus>>;
  not?: InputMaybe<NestedEnumOrderStatusNullableFilter>;
  notIn?: InputMaybe<Array<OrderStatus>>;
};

export type NestedEnumProblemTypeFilter = {
  equals?: InputMaybe<ProblemType>;
  in?: InputMaybe<Array<ProblemType>>;
  not?: InputMaybe<NestedEnumProblemTypeFilter>;
  notIn?: InputMaybe<Array<ProblemType>>;
};

export type NestedStringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

/** The next order containing Rx products due to be processed for a given user */
export type NextRxCustomerOrder = {
  __typename?: 'NextRxCustomerOrder';
  amountDue: MonetaryAmount;
  delayOrderUrl: Scalars['String']['output'];
  discountAmount: MonetaryAmount;
  discountablePurchaseSyncGroup?: Maybe<PurchaseSyncGroup>;
  discounts: Array<Discount>;
  id: Scalars['ID']['output'];
  lineItems?: Maybe<Array<UpcomingOrderLineItem>>;
  manageOrderUrl: Scalars['String']['output'];
  preDiscountAmount: MonetaryAmount;
  reference: Scalars['String']['output'];
  toBeProcessedAt: Scalars['DateTime']['output'];
};

export type NotEligibleQuizOutcome = QuizOutcomeV2 & {
  __typename?: 'NotEligibleQuizOutcome';
  id: Scalars['ID']['output'];
  reasons?: Maybe<Array<QuizOutcomeReason>>;
};

export type Note = {
  archivalNote?: Maybe<MetaNote>;
  author?: Maybe<User>;
  body: Scalars['String']['output'];
  canArchive: Scalars['Boolean']['output'];
  canEdit: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  domain: NoteDomain;
  history?: Maybe<Array<NoteHistoryEntry>>;
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type NoteDomain =
  | 'ADMIN'
  | 'CLINICAL_OPS'
  | 'CUSTOMER_CRITICAL'
  | 'HEALTH_COACH'
  | 'LORIKEET'
  | 'NOTE_ARCHIVAL'
  | 'PRESCRIBER';

export type NoteHistoryEntry = {
  __typename?: 'NoteHistoryEntry';
  author?: Maybe<User>;
  body: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  note?: Maybe<ConsultationNote | CustomerNote | MetaNote>;
};

export type NotificationPrefs = {
  __typename?: 'NotificationPrefs';
  id: Scalars['ID']['output'];
  personalisedMarketing?: Maybe<Scalars['Boolean']['output']>;
};

export type OtcShoppingCartItemInput = {
  quantity: Scalars['Int']['input'];
  variantId: Scalars['ID']['input'];
};

export type ObservedMeasurement = {
  __typename?: 'ObservedMeasurement';
  effectiveFrom: Scalars['DateTime']['output'];
  /** Returns true if this measurement is effective today (in region time). Subsequent measurements of the same type will overwrite this one. */
  effectiveToday: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Used to identify if this observation is being used as a starting value. */
  nominatedStartingValue: Scalars['Boolean']['output'];
  value: Scalars['Float']['output'];
};

/** A product offering */
export type Offering = {
  /** i.e. "28 days" */
  advertisedCostCadence?: Maybe<Scalars['String']['output']>;
  advertisedName: Scalars['String']['output'];
  advertisedShippingCadence: Scalars['String']['output'];
  /** e.g. "$10 per pen" or "£10 / month" */
  advertisedStartingAmount: Scalars['String']['output'];
  advertisedStartingAmountHeader: Scalars['String']['output'];
  advertisedStartingAmountSubtitle: Scalars['String']['output'];
  contents: Array<OfferingContentItem>;
  description: Scalars['String']['output'];
  /** Sorted by decreasing prominence. */
  downsells?: Maybe<Array<SwitchCandidate>>;
  /** i.e. "Bluetooth scale + Juniper shaker bottle" */
  firstOrderGiftCopy?: Maybe<Scalars['String']['output']>;
  friendlyName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  photoUrl: Scalars['String']['output'];
  problemTypes?: Maybe<Array<ProblemType>>;
  sequenceSets?: Maybe<Array<SequenceSet>>;
  status: OfferingStatus;
  tags: Array<Scalars['String']['output']>;
  /** Sorted by decreasing prominence. */
  upsells?: Maybe<Array<SwitchCandidate>>;
};

export type OfferingAdvertisedDosageExplanation = {
  __typename?: 'OfferingAdvertisedDosageExplanation';
  id: Scalars['ID']['output'];
  markdown: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type OfferingContentItem = {
  __typename?: 'OfferingContentItem';
  description: Scalars['String']['output'];
  /** svg encoded icon */
  icon: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  rank: Scalars['Int']['output'];
  tooltip?: Maybe<Scalars['String']['output']>;
};

export type OfferingPrepayOption = {
  __typename?: 'OfferingPrepayOption';
  discountPercentage: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  interval: IntervalType;
  intervalCount: Scalars['Int']['output'];
  savedAmount?: Maybe<Scalars['Float']['output']>;
  upfrontAmount?: Maybe<Scalars['Float']['output']>;
};

export type OfferingSelection = {
  __typename?: 'OfferingSelection';
  id: Scalars['ID']['output'];
  offering?: Maybe<AddOnOffering | OtcOffering | RxOffering>;
  sequenceSelections?: Maybe<Array<SequenceSelection>>;
};

export type OfferingSelectionInput = {
  addons?: InputMaybe<Array<AddonSelectionInput>>;
  offeringId: Scalars['ID']['input'];
  prepayOptionId?: InputMaybe<Scalars['ID']['input']>;
  sequenceSelections: Array<SequenceSelectionInput>;
};

export type OfferingStatus =
  | 'AVAILABLE'
  | 'UNAVAILABLE';

export type OfferingUpgradeBanner = {
  __typename?: 'OfferingUpgradeBanner';
  ctaCopy: Scalars['String']['output'];
  ctaUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type Order = {
  __typename?: 'Order';
  consultation?: Maybe<Consultation>;
  createdAt: Scalars['DateTime']['output'];
  customer: User;
  customerId: Scalars['String']['output'];
  fulfilledAt?: Maybe<Scalars['DateTime']['output']>;
  fulfillment?: Maybe<FulfillmentStatus>;
  id: Scalars['String']['output'];
  jobs?: Maybe<Array<Job>>;
  lineItems?: Maybe<Array<OrderLineItem>>;
  paymentStatus?: Maybe<OrderPaymentStatus>;
  payments?: Maybe<Array<PaymentTransaction>>;
  status?: Maybe<OrderStatus>;
  statusReason?: Maybe<Scalars['String']['output']>;
  stripeChargeId?: Maybe<Scalars['String']['output']>;
  /** @deprecated will be deleted */
  trackingNumber?: Maybe<Scalars['String']['output']>;
  treatment?: Maybe<Treatment>;
  treatmentId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type OrderLineItem = {
  __typename?: 'OrderLineItem';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  order: Order;
  orderId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  variant: Variant;
  variantId: Scalars['String']['output'];
};

export type OrderOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
};

export type OrderPaymentStatus =
  | 'PAID'
  | 'PARTIALLY'
  | 'PENDING'
  | 'REFUNDED'
  | 'UNPAID'
  | 'VOIDED';

export type OrderStatus =
  | 'AWAITING_SCRIPT'
  | 'CANCELED'
  | 'COMPLETED'
  | 'CREATED'
  | 'FAILED_SCRIPT'
  | 'FAILED_SHOPIFY'
  | 'FAILED_VENDOR_CREATION'
  | 'PENDING_VENDOR_CREATION';

export type OrderTimelineItem = {
  __typename?: 'OrderTimelineItem';
  date: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  products?: Maybe<Array<Product>>;
  sequenceContext?: Maybe<SequenceContext>;
  status: OrderTimelineItemStatus;
  totalAmount: Scalars['Int']['output'];
};

export type OrderTimelineItemStatus =
  | 'FULFILLED'
  | 'PAID'
  | 'UPCOMING';

export type OrderWhereInput = {
  AND?: InputMaybe<Array<OrderWhereInput>>;
  OR?: InputMaybe<Array<OrderWhereInput>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  customerId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  paymentStatus?: InputMaybe<EnumOrderPaymentStatusNullableFilter>;
  shopifyOrderId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumOrderStatusNullableFilter>;
  treatmentId?: InputMaybe<StringNullableFilter>;
  webflowOrderId?: InputMaybe<StringNullableFilter>;
};

/** A non-RX product offering that supports prepay and order add-ons */
export type OtcOffering = Offering & {
  __typename?: 'OtcOffering';
  advertisedCostCadence?: Maybe<Scalars['String']['output']>;
  advertisedName: Scalars['String']['output'];
  advertisedShippingCadence: Scalars['String']['output'];
  /** e.g. "$10 per pen" or "£10 / month" */
  advertisedStartingAmount: Scalars['String']['output'];
  advertisedStartingAmountHeader: Scalars['String']['output'];
  advertisedStartingAmountSubtitle: Scalars['String']['output'];
  availableAddons?: Maybe<Array<AddOnOffering>>;
  contents: Array<OfferingContentItem>;
  description: Scalars['String']['output'];
  downsells?: Maybe<Array<SwitchCandidate>>;
  firstOrderGiftCopy?: Maybe<Scalars['String']['output']>;
  friendlyName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  photoUrl: Scalars['String']['output'];
  prepayOptions?: Maybe<Array<OfferingPrepayOption>>;
  problemTypes?: Maybe<Array<ProblemType>>;
  sequenceSets?: Maybe<Array<SequenceSet>>;
  status: OfferingStatus;
  tags: Array<Scalars['String']['output']>;
  upsells?: Maybe<Array<SwitchCandidate>>;
};

export type OtcQuizOutcome = QuizOutcomeV2 & {
  __typename?: 'OtcQuizOutcome';
  id: Scalars['ID']['output'];
  reasons?: Maybe<Array<QuizOutcomeReason>>;
};

export type OtcSchedule = {
  __typename?: 'OtcSchedule';
  cadence: OtcScheduleCadence;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  product: Product;
  productId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  treatment?: Maybe<Treatment>;
  treatmentId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type OtcScheduleCadence =
  | 'ONE_TIME'
  | 'RECURRING';

export type OtcSchedulesWhereInput = {
  isActive?: InputMaybe<BoolFilter>;
  product?: InputMaybe<ProductWhereInput>;
};

/** Independent sequence containing no RX medications. */
export type OtcSequence = Sequence & {
  __typename?: 'OtcSequence';
  description: Scalars['String']['output'];
  externalLinks: Array<SequenceExternalLink>;
  faqs: Array<SequenceFaq>;
  friendlyName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  internalName: Scalars['String']['output'];
  nodes: Array<EventSequenceNode | InternalTriggerSequenceNode | SmsSequenceNode | VariantSequenceNode | WaitSequenceNode>;
  problemTypes: Array<Maybe<ProblemType>>;
  products?: Maybe<Array<Product>>;
  status: SequenceStatus;
  tags: Array<Scalars['String']['output']>;
};

export type OtcShop = {
  __typename?: 'OtcShop';
  id: Scalars['ID']['output'];
  sections?: Maybe<Array<Maybe<ItemListShopSection>>>;
};

export type OtcShoppingCart = {
  __typename?: 'OtcShoppingCart';
  id: Scalars['ID']['output'];
  items?: Maybe<Array<OtcShoppingCartItem>>;
  orderId?: Maybe<Scalars['ID']['output']>;
};

export type OtcShoppingCartItem = {
  __typename?: 'OtcShoppingCartItem';
  id: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
  variant: Variant;
};

export type PafAddonSection = {
  __typename?: 'PafAddonSection';
  bannerMarkdown?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  shopItems: Array<ShopItem>;
};

export type PafStage =
  /** Follow up (or) Review */
  | 'FUR'
  | 'INITIAL';

export type PageRequestInput = {
  /** The number of items to retrieve per page. Defaults to 10. */
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  /** The token to retrieve the next page of results. */
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type Pagination = {
  pageSize: Scalars['Int']['input'];
  skip: Scalars['Int']['input'];
};

export type PaginationPayload = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type PathologyLocation = {
  __typename?: 'PathologyLocation';
  display?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type PathologyPanel = {
  __typename?: 'PathologyPanel';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  pathologyRequestId: Scalars['String']['output'];
  tests?: Maybe<Array<PathologyPanelTest>>;
};

export type PathologyPanelTest = {
  __typename?: 'PathologyPanelTest';
  createdAt: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  formName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: PathologyPanelTestNameKey;
  pathologyPanelId: Scalars['String']['output'];
  result?: Maybe<PathologyPanelTestResult>;
};

export type PathologyPanelTestName = {
  __typename?: 'PathologyPanelTestName';
  displayName?: Maybe<Scalars['String']['output']>;
  formName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<PathologyPanelTestNameKey>;
};

export type PathologyPanelTestNameKey =
  | 'AMH'
  | 'B12'
  | 'CHLAMYDIA'
  | 'CHLAMYDIA_GONORRHOEA_RECTAL_SWAB'
  | 'CHLAMYDIA_GONORRHOEA_THROAT_SWAB'
  | 'E2'
  | 'EUC'
  | 'FASTING_BGL'
  | 'FASTING_INSULIN'
  | 'FASTING_LIPIDS'
  | 'FBC'
  | 'FE_STUDIES'
  | 'FREE_TESTOSTERONE'
  | 'FSH'
  | 'FT4'
  | 'GONORRHOEA'
  | 'HBA1C'
  | 'HEP_B'
  | 'HEP_C'
  | 'HIV_AG_AB'
  | 'LFT'
  | 'LH'
  | 'PRL'
  | 'SYPHILIS'
  | 'TFT'
  | 'TSH'
  | 'TSH_T34_IF_ABNORMAL';

export type PathologyPanelTestResult = {
  __typename?: 'PathologyPanelTestResult';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  pathologyPanelTestId: Scalars['String']['output'];
  result: PathologyPanelTestResultValue;
};

export type PathologyPanelTestResultPositiveNegativeValueInput = {
  type: PathologyPanelTestResultValueType;
  value: PathologyPanelTestResultPositiveNegativeValueOptions;
};

export type PathologyPanelTestResultPositiveNegativeValueOptions =
  | 'NEGATIVE'
  | 'POSITIVE';

export type PathologyPanelTestResultUnitWithRangeValueInput = {
  number: Scalars['Float']['input'];
  range: PathologyPanelTestResultValueRangeInput;
  type: PathologyPanelTestResultValueType;
  unit: Scalars['String']['input'];
};

export type PathologyPanelTestResultValue = {
  __typename?: 'PathologyPanelTestResultValue';
  default?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['Float']['output']>;
  range?: Maybe<PathologyPanelTestResultValueRange>;
  type: PathologyPanelTestResultValueType;
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type PathologyPanelTestResultValueRange = {
  __typename?: 'PathologyPanelTestResultValueRange';
  high?: Maybe<Scalars['Float']['output']>;
  low?: Maybe<Scalars['Float']['output']>;
};

export type PathologyPanelTestResultValueRangeInput = {
  high: Scalars['Float']['input'];
  low: Scalars['Float']['input'];
};

export type PathologyPanelTestResultValueType =
  | 'POSITIVE_NEGATIVE'
  | 'UNIT_WITH_RANGE';

export type PathologyReferral = {
  __typename?: 'PathologyReferral';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  pathologyRequestId: Scalars['String']['output'];
  signedUrl: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type PathologyRequest = {
  __typename?: 'PathologyRequest';
  consultation?: Maybe<Consultation>;
  createdAt: Scalars['DateTime']['output'];
  customerStatedCollectedAt?: Maybe<Scalars['DateTime']['output']>;
  customerStatedCollectedDate?: Maybe<Scalars['String']['output']>;
  doctor?: Maybe<User>;
  doctorId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  panels?: Maybe<Array<PathologyPanel>>;
  patient?: Maybe<User>;
  patientId: Scalars['String']['output'];
  reference: Scalars['String']['output'];
  referral?: Maybe<PathologyReferral>;
  result?: Maybe<PathologyResult>;
  status?: Maybe<PathologyRequestStatus>;
};

export type PathologyRequestStatus =
  | 'AWAITING_RESULTS'
  | 'RESULTS_AVAILABLE';

export type PathologyResult = {
  __typename?: 'PathologyResult';
  collectedAt?: Maybe<Scalars['DateTime']['output']>;
  collectedDate?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  file?: Maybe<PathologyResultFile>;
  id: Scalars['String']['output'];
  lab: Scalars['String']['output'];
  pathologyRequestId: Scalars['String']['output'];
  releasedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PathologyResultFile = {
  __typename?: 'PathologyResultFile';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  pathologyResultId: Scalars['String']['output'];
  signedUrl: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type PathologyResultValueInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  pathologyRequestPanelTestId: Scalars['String']['input'];
  positiveNegativeResult?: InputMaybe<PathologyPanelTestResultPositiveNegativeValueInput>;
  unitWithRangeResult?: InputMaybe<PathologyPanelTestResultUnitWithRangeValueInput>;
};

export type PatientOrder = {
  __typename?: 'PatientOrder';
  createdAt: Scalars['DateTime']['output'];
  deliveredAt?: Maybe<Scalars['DateTime']['output']>;
  fulfilledAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  rxVariants?: Maybe<Array<Variant>>;
  status: PatientOrderStatus;
};

export type PatientOrderStatus =
  | 'CANCELLED'
  | 'DELIVERED'
  | 'FAILED'
  | 'FULFILLED'
  | 'PROCESSING';

export type PausePurchaseInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  purchaseId: Scalars['ID']['input'];
};

export type PausePurchasePayload = {
  __typename?: 'PausePurchasePayload';
  purchase: Purchase;
};

export type PaymentGateway =
  | 'FATZEBRA'
  | 'POLI'
  | 'STRIPE'
  | 'ZIP';

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  cardMeta?: Maybe<CardMeta>;
  gateway?: Maybe<PaymentGateway>;
  id?: Maybe<Scalars['String']['output']>;
};

export type PaymentTransaction = {
  __typename?: 'PaymentTransaction';
  charge?: Maybe<Charge>;
  consultation?: Maybe<Consultation>;
  createdAt: Scalars['DateTime']['output'];
  gateway: PaymentGateway;
  id: Scalars['String']['output'];
  identifier?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
  orderId?: Maybe<Scalars['String']['output']>;
  paymentReference?: Maybe<Scalars['String']['output']>;
  refunded?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PersonalizationRecord = {
  __typename?: 'PersonalizationRecord';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type PhoneCall = {
  __typename?: 'PhoneCall';
  callee?: Maybe<User>;
  calleeNumber?: Maybe<Scalars['String']['output']>;
  caller?: Maybe<User>;
  canStateCallResult?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  phoneCallProviderDetails?: Maybe<LinePhoneCallDetails | ZoomPhoneCallDetails>;
  status: CallStatus;
};

export type PhoneCallProviderDetails = {
  id: Scalars['ID']['output'];
};

export type PhotoAngleType =
  | 'BACK'
  | 'FRONT'
  | 'LEFT'
  | 'RIGHT'
  | 'TOP';

export type Plan = {
  __typename?: 'Plan';
  amount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  interval: BillingInterval;
  intervalCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  products: Array<Product>;
  repeats?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PlugRecommendation = {
  __typename?: 'PlugRecommendation';
  id: Scalars['ID']['output'];
  shopItem?: Maybe<ShopItem>;
};

export type PractitionerBooking = {
  __typename?: 'PractitionerBooking';
  consultation?: Maybe<Consultation>;
  id: Scalars['ID']['output'];
  patient?: Maybe<User>;
  problemType: ProblemType;
  windowEndAt: Scalars['DateTime']['output'];
  windowStartAt: Scalars['DateTime']['output'];
};

export type PractitionerBookingWindow = {
  __typename?: 'PractitionerBookingWindow';
  available: Scalars['Boolean']['output'];
  endAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  problemType: ProblemType;
  startAt: Scalars['DateTime']['output'];
};

export type PractitionerBookingWindowRange = {
  __typename?: 'PractitionerBookingWindowRange';
  endWindow: PractitionerBookingWindow;
  id: Scalars['ID']['output'];
  startWindow: PractitionerBookingWindow;
};

export type PractitionerBookingWindowSummary = {
  __typename?: 'PractitionerBookingWindowSummary';
  count: Scalars['Int']['output'];
  end: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  start: Scalars['DateTime']['output'];
};

export type PractitionerBookingWindowsSummary = {
  __typename?: 'PractitionerBookingWindowsSummary';
  current: PractitionerBookingWindowSummary;
  next: PractitionerBookingWindowSummary;
  problemType: ProblemType;
  timezone: Scalars['String']['output'];
};

export type PredictedOfferingTimelineItem = {
  __typename?: 'PredictedOfferingTimelineItem';
  date: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  products?: Maybe<Array<Product>>;
  totalAmount: Scalars['Int']['output'];
};

export type PregnancyStatus =
  | 'BREASTFEEDING'
  | 'NOT_APPLICABLE'
  | 'NOT_PREGNANT'
  | 'POTENTIALLY_PREGNANT'
  | 'PREGNANT'
  | 'TRYING_FOR_BABY';

/** Independent sequence containing RX medications (thus requiring doctor involvement). */
export type PrescribableSequence = Sequence & {
  __typename?: 'PrescribableSequence';
  addressValidationExempt?: Maybe<Scalars['Boolean']['output']>;
  compoundableProducts?: Maybe<Array<Product>>;
  containsCompoundableMedication?: Maybe<Scalars['Boolean']['output']>;
  containsRefrigeratedContents?: Maybe<Scalars['Boolean']['output']>;
  description: Scalars['String']['output'];
  externalLinks: Array<SequenceExternalLink>;
  faqs: Array<SequenceFaq>;
  friendlyName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  internalName: Scalars['String']['output'];
  nodes: Array<EventSequenceNode | InternalTriggerSequenceNode | SmsSequenceNode | VariantSequenceNode | WaitSequenceNode>;
  problemTypes: Array<Maybe<ProblemType>>;
  products?: Maybe<Array<Product>>;
  safetyInformation?: Maybe<SequenceSafetyInformation>;
  status: SequenceStatus;
  tags: Array<Scalars['String']['output']>;
};

export type PrescribeDisclaimer = {
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
};

export type PrescribeSequenceInput = {
  consultationParameters: ConsultationParametersInput;
  /** An ISO formatted date string representing the earliest date a prescribed sequence can begin. */
  minimumStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  scriptParameters: ScriptParametersInput;
  sequenceId: Scalars['ID']['input'];
  undergoingWeightMaintenance?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PrescribeSequencePayload = {
  __typename?: 'PrescribeSequencePayload';
  consultation: Consultation;
};

export type PrescribedSequence = {
  __typename?: 'PrescribedSequence';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  sequence?: Maybe<OtcSequence | PrescribableSequence>;
};

export type PrescribingExperience =
  | 'FLEXI'
  | 'LEGACY';

export type PrescriptionHistoryEntry = {
  __typename?: 'PrescriptionHistoryEntry';
  availableActions?: Maybe<Array<Maybe<PrescriptionHistoryEntryAction>>>;
  cancelReason?: Maybe<Scalars['String']['output']>;
  canceledAt?: Maybe<Scalars['String']['output']>;
  ceasedAt?: Maybe<Scalars['String']['output']>;
  compoundingConsent?: Maybe<CompoundingConsent>;
  dosage?: Maybe<Scalars['String']['output']>;
  erxStatus?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  prescribed: Scalars['String']['output'];
  prescriber: Scalars['String']['output'];
  prescriptionDocumentId?: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
  scriptId: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type PrescriptionHistoryEntryAction =
  | 'CANCEL'
  | 'CEASE';

export type ProblemType =
  | 'ACNE'
  | 'ANTI_AGEING'
  | 'BREASTFEEDING'
  | 'COLD_SORES'
  | 'CONTRACEPTION'
  | 'DEPRECATED_OTC'
  | 'ERECTILE'
  | 'FERTILITY'
  | 'FERTILITY_HORMONE'
  | 'FERTILITY_NAVIGATOR'
  | 'FERTILITY_NAVIGATOR_PREGNANCY'
  | 'GENETIC_TEST'
  | 'HAIR'
  | 'HERPES'
  | 'INFANT_SLEEP'
  | 'MENOPAUSE'
  | 'MENTAL_HEALTH_GOOD'
  | 'MENTAL_HEALTH_MEH'
  | 'MENTAL_HEALTH_SAD'
  | 'POSTPARTUM'
  | 'POSTPARTUM_MENTAL_HEALTH'
  | 'POSTPARTUM_NUTRITION'
  | 'POSTPARTUM_PHYSIO'
  | 'PRECONCEPTION_FERTILITY'
  | 'PRECONCEPTION_MENTAL_HEALTH'
  | 'PRECONCEPTION_NUTRITION'
  | 'PRECONCEPTION_PHYSIO'
  | 'PREGNANCY'
  | 'PREGNANCY_MENTAL_HEALTH'
  | 'PREGNANCY_NUTRITION'
  | 'PREGNANCY_PHYSIO'
  | 'PREMATURE'
  | 'SKIN_GENERAL'
  | 'SLEEP'
  | 'STI'
  | 'UTI'
  | 'WEIGHT_LOSS'
  | 'WOMENS_HEALTH';

export type Product = {
  __typename?: 'Product';
  cmi?: Maybe<File>;
  cmiId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  deliveryInformation?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  drug?: Maybe<Drug>;
  drugId?: Maybe<Scalars['String']['output']>;
  erxMedicines: Array<ErxMedicine>;
  faqs: Array<Faq>;
  friendlyName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  instructions?: Maybe<Scalars['String']['output']>;
  isCompoundable: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  photo?: Maybe<File>;
  photoId?: Maybe<Scalars['String']['output']>;
  plan?: Maybe<Plan>;
  planId?: Maybe<Scalars['String']['output']>;
  priority: Scalars['Int']['output'];
  problemTypes: Array<ProblemType>;
  productType: ProductType;
  safetyInformation?: Maybe<Scalars['String']['output']>;
  shopifyProductId?: Maybe<Scalars['String']['output']>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  stripePlanId?: Maybe<Scalars['String']['output']>;
  units?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  usage: ProductUsage;
  variants: Array<Variant>;
};

export type ProductType =
  | 'ACCESSORY'
  | 'CONSULTATION'
  | 'CONTENT'
  | 'DIGITAL_TIME_ACCESS'
  | 'OTC'
  | 'RX';

export type ProductUsage =
  | 'Daily'
  | 'OnDemand';

export type ProductWhereInput = {
  id?: InputMaybe<StringFilter>;
  variants?: InputMaybe<VariantListRelationFilter>;
};

export type ProgressDelta = {
  __typename?: 'ProgressDelta';
  deltaSentiment?: Maybe<DeltaSentiment>;
  difference?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  initial?: Maybe<Scalars['String']['output']>;
  mostRecent?: Maybe<Scalars['String']['output']>;
};

export type ProgressEntry = {
  __typename?: 'ProgressEntry';
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  photos?: Maybe<Array<Maybe<ProgressEntryPhoto>>>;
  responses?: Maybe<Array<Maybe<ProgressEntryResponse>>>;
  type: ProgressEntryType;
  userId: Scalars['String']['output'];
};

export type ProgressEntryAnswerInput = {
  answer: Scalars['String']['input'];
  question: Scalars['String']['input'];
  questionCode: ProgressEntryQuestionCodeType;
  type: ProgressEntryAnswerType;
};

export type ProgressEntryAnswerType =
  | 'PHOTO'
  | 'RESPONSE';

export type ProgressEntryPhoto = {
  __typename?: 'ProgressEntryPhoto';
  angle: PhotoAngleType;
  id: Scalars['String']['output'];
  signedUrl: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ProgressEntryQuestionCodeType =
  | 'PHOTO_LEFT'
  | 'PHOTO_MIDDLE'
  | 'PHOTO_RIGHT'
  | 'SKIN_CONFIDENCE';

export type ProgressEntryResponse = {
  __typename?: 'ProgressEntryResponse';
  answer: Scalars['String']['output'];
  id: Scalars['String']['output'];
  questionCode: ProgressEntryQuestionCodeType;
};

export type ProgressEntryType =
  | 'HAIR'
  | 'SKIN';

export type Provider = {
  __typename?: 'Provider';
  clinicianTitle: Scalars['String']['output'];
  clinicianType: ClinicianType;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  prescriberNumber?: Maybe<Scalars['String']['output']>;
  providerNumber?: Maybe<Scalars['String']['output']>;
  qualifications?: Maybe<Scalars['String']['output']>;
  signature?: Maybe<File>;
  signatureId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['String']['output'];
};

export type Purchase = {
  __typename?: 'Purchase';
  /** List of actions that a patient can perform on this purchase. */
  availableActions?: Maybe<Array<PurchaseResumeAction>>;
  canBeSwitched?: Maybe<Scalars['Boolean']['output']>;
  contexts?: Maybe<Array<SequenceContext>>;
  id: Scalars['ID']['output'];
  isVisibleInProfilePage?: Maybe<Scalars['Boolean']['output']>;
  nextOrder?: Maybe<OrderTimelineItem>;
  offering?: Maybe<AddOnOffering | OtcOffering | RxOffering>;
  orderTimeline?: Maybe<Array<OrderTimelineItem>>;
  problemType?: Maybe<ProblemType>;
  selectedPrepayOption?: Maybe<OfferingPrepayOption>;
  status: PurchaseStatus;
  supersededBy?: Maybe<Purchase>;
  switchCandidates?: Maybe<Array<SwitchCandidate>>;
  syncGroups?: Maybe<Array<PurchaseSyncGroup>>;
};

export type PurchaseAction = {
  id: Scalars['ID']['output'];
};

export type PurchaseGroup = {
  __typename?: 'PurchaseGroup';
  /** amount that customer paid to cover their first order */
  amountPaid?: Maybe<Scalars['Int']['output']>;
  consultation?: Maybe<Consultation>;
  id: Scalars['ID']['output'];
  pricingSessionId: Scalars['ID']['output'];
  purchases?: Maybe<Array<Purchase>>;
};

export type PurchaseOtcItemInput = {
  quantity: Scalars['Int']['input'];
  sku: Scalars['String']['input'];
};

export type PurchaseOfferingsInput = {
  /** If set to true the purchase group does not need to be consented to separately via a ConfirmPurchasePrompt on Consultation.purchasePrompt. */
  consent: Scalars['Boolean']['input'];
  /** Optionally used as a reference to the customers consultation credit */
  consultationId?: InputMaybe<Scalars['String']['input']>;
  couponCode?: InputMaybe<Scalars['String']['input']>;
  discountCode?: InputMaybe<Scalars['String']['input']>;
  expectedChargeAmount: Scalars['Int']['input'];
  gateway: PaymentGateway;
  offerings: Array<OfferingSelectionInput>;
  pricingSessionId: Scalars['ID']['input'];
  purchaseGroupId: Scalars['ID']['input'];
  /** Optional address input in order to update the user's shipping address before purchase */
  shippingAddress?: InputMaybe<AddressCreateWithoutUserInput>;
  /** Optional Stripe payment method id used to update the customer before performing a charge */
  stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
  /** Optional Stripe token used to update the customer before performing a charge */
  stripeToken?: InputMaybe<Scalars['String']['input']>;
  /** Optional Zip checkout id used to update the customer before performing a charge */
  zipCheckoutId?: InputMaybe<Scalars['String']['input']>;
};

export type PurchaseOfferingsPayload = {
  __typename?: 'PurchaseOfferingsPayload';
  purchaseGroup: PurchaseGroup;
};

export type PurchasePrompt = {
  id: Scalars['ID']['output'];
};

export type PurchaseResumeAction = PurchaseAction & {
  __typename?: 'PurchaseResumeAction';
  id: Scalars['ID']['output'];
};

export type PurchaseStatus =
  | 'ACTIVE'
  | 'AWAITING_PATIENT_CONFIRMATION'
  | 'AWAITING_PAYMENT'
  | 'AWAITING_VALID_SCRIPTS'
  | 'CANCELLED'
  | 'COMPLETED'
  | 'PAUSED';

export type PurchaseSubstitution = {
  __typename?: 'PurchaseSubstitution';
  id: Scalars['ID']['output'];
  purchased: Purchase;
  substitution: OfferingSelection;
};

export type PurchaseSyncGroup = {
  __typename?: 'PurchaseSyncGroup';
  actions?: Maybe<Array<DelayPurchaseSyncGroupAction>>;
  id: Scalars['ID']['output'];
  nextOrder?: Maybe<PurchaseSyncGroupOrder>;
  nextOrderDue?: Maybe<Scalars['DateTime']['output']>;
  sequenceContexts?: Maybe<Array<SequenceContext>>;
  status: PurchaseSyncGroupStatus;
  timeline?: Maybe<Array<SyncGroupTimelineItem>>;
};

export type PurchaseSyncGroupAction = {
  id: Scalars['ID']['output'];
};

export type PurchaseSyncGroupCoupon = {
  __typename?: 'PurchaseSyncGroupCoupon';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  outcome: CouponOutcome;
};

export type PurchaseSyncGroupOrder = {
  __typename?: 'PurchaseSyncGroupOrder';
  date: Scalars['DateTime']['output'];
  discountAmount: MonetaryAmount;
  discounts: Array<Discount>;
  id: Scalars['ID']['output'];
  preDiscountTotalAmount: MonetaryAmount;
  /** Products are sorted by type and quantity descending with RX products appearing first */
  products?: Maybe<Array<PurchaseSyncGroupOrderProduct>>;
  totalAmount: MonetaryAmount;
};

export type PurchaseSyncGroupOrderProduct = {
  __typename?: 'PurchaseSyncGroupOrderProduct';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  photoUrl?: Maybe<Scalars['String']['output']>;
};

export type PurchaseSyncGroupStatus =
  | 'ACTIVE'
  | 'CANCELLED'
  | 'COMPLETED'
  | 'PAUSED';

export type Query = {
  __typename?: 'Query';
  activePractitionerBookingWindowHasPatients?: Maybe<Scalars['Boolean']['output']>;
  activePractitionerBookingWindowPatientCount?: Maybe<Scalars['Int']['output']>;
  activities?: Maybe<Array<Activity>>;
  bloodGlucose: BloodGlucose;
  calorieRequirements?: Maybe<Array<Maybe<CalorieRequirement>>>;
  canRestartInitialQuizApplication?: Maybe<Scalars['Boolean']['output']>;
  chatMacros?: Maybe<Array<ChatMacro>>;
  /** @deprecated use `chatThreadStatusCountsByType` */
  chatThreadCountsByType?: Maybe<ChatThreadCounts>;
  chatThreadPriorityCountsByType?: Maybe<ChatThreadPriorityCounts>;
  chatThreadStatusCountsByType?: Maybe<ChatThreadStatusCounts>;
  chatThreads?: Maybe<Array<ChatThread>>;
  chatToken?: Maybe<Scalars['String']['output']>;
  checklistByConsultation?: Maybe<Checklist>;
  consultation?: Maybe<Consultation>;
  consultations?: Maybe<Array<Consultation>>;
  contentCollection?: Maybe<ContentCollection>;
  contentItem?: Maybe<FaqContentItem | ReadingContentItem | RecipeContentItem | VideoContentItem | VideoWithReadingContentItem>;
  contentItems?: Maybe<Array<FaqContentItem | ReadingContentItem | RecipeContentItem | VideoContentItem | VideoWithReadingContentItem>>;
  crossSellRecommendations?: Maybe<CrossSellRecommendations>;
  customerAttributes: CustomerAttributes;
  customerOrder?: Maybe<CustomerOrder>;
  dailyStepsGoalResults?: Maybe<Array<StepsGoalResult>>;
  discountCode?: Maybe<DiscountCode>;
  doctorsLetterTemplate?: Maybe<Scalars['String']['output']>;
  educationCollection?: Maybe<EducationCollection>;
  educationProgram?: Maybe<EducationProgram>;
  educationReading?: Maybe<EducationReading>;
  filteredChatThreads?: Maybe<FilteredChatThreadsPayload>;
  filteredNotes?: Maybe<Array<ConsultationNote | CustomerNote | MetaNote>>;
  getConsultationByQuizApplicationId?: Maybe<Consultation>;
  getConsultationsForCustomer?: Maybe<Array<Maybe<Consultation>>>;
  getPathologyConsultationsForDoctor?: Maybe<Array<Maybe<Consultation>>>;
  getPathologyReferralFile: Scalars['String']['output'];
  getPathologyResultFile: Scalars['String']['output'];
  getPatient?: Maybe<User>;
  getQuizApplication?: Maybe<QuizApplication>;
  getTreatmentsForCustomer?: Maybe<Array<Maybe<Treatment>>>;
  goalDurationFromStartingDateSeconds?: Maybe<Scalars['Int']['output']>;
  goalWeightFeedbackType?: Maybe<GoalFeedbackType>;
  healthCoaches?: Maybe<Array<User>>;
  heartRateVariability: HeartRateVariability;
  inSegment?: Maybe<Scalars['Boolean']['output']>;
  initialPurchaseConfirmPage?: Maybe<InitialPurchaseConfirmPage>;
  initialPurchasePrice?: Maybe<InitialPurchasePriceList>;
  isEPrescribingAllowed: Scalars['Boolean']['output'];
  masterclassVideos: Array<MasterclassVideo>;
  medicationPreferenceProduct?: Maybe<MedicationPreferenceProducts>;
  mobileLearnCategories?: Maybe<Array<ContentCategory>>;
  mobileLearnCategory?: Maybe<ContentCategory>;
  mobileLearnContentItems?: Maybe<Array<FaqContentItem | ReadingContentItem | RecipeContentItem | VideoContentItem | VideoWithReadingContentItem>>;
  mobileOnboardingMedicationContentItems?: Maybe<ContentCollection>;
  mobileTreatmentContentItems?: Maybe<ContentCollection>;
  myTestProduct?: Maybe<Product>;
  nadal: Scalars['String']['output'];
  /** Only currently available offerings are returned. */
  offerings?: Maybe<Array<AddOnOffering | OtcOffering | RxOffering>>;
  offeringsTimeline?: Maybe<Array<PredictedOfferingTimelineItem>>;
  otcShoppingCart?: Maybe<OtcShoppingCart>;
  pafAddonSection?: Maybe<PafAddonSection>;
  pathologyLocationHealius: PathologyLocation;
  pathologyLocations: Array<PathologyLocation>;
  pathologyPanelTestNames: Array<PathologyPanelTestName>;
  personalizationRecordsByProblemType?: Maybe<Array<Maybe<PersonalizationRecord>>>;
  practitionerBooking?: Maybe<PractitionerBooking>;
  practitionerBookingWindowSummaries?: Maybe<Array<PractitionerBookingWindowsSummary>>;
  prescriptionHistory?: Maybe<Array<Maybe<PrescriptionHistoryEntry>>>;
  productPrescriptionOptions?: Maybe<Array<Product>>;
  products: Array<Product>;
  profile?: Maybe<User>;
  progressEntries: Array<ProgressEntry>;
  purchase?: Maybe<Purchase>;
  purchaseGroup?: Maybe<PurchaseGroup>;
  rankedContentItems?: Maybe<Array<FaqContentItem | ReadingContentItem | RecipeContentItem | VideoContentItem | VideoWithReadingContentItem>>;
  roger: Scalars['String']['output'];
  sequence?: Maybe<OtcSequence | PrescribableSequence>;
  shippingAddressWithinRange?: Maybe<Scalars['Boolean']['output']>;
  shop?: Maybe<OtcShop>;
  shopItem?: Maybe<ShopItem>;
  skinRegimen?: Maybe<SkinRegimen>;
  steps?: Maybe<Steps>;
  stepsGoal?: Maybe<StepsGoal>;
  stripeAccount?: Maybe<StripeAccount>;
  subscriptionPlanV2ById?: Maybe<SubscriptionPlanV2>;
  subscriptionPlans: Array<SubscriptionPlan>;
  subscriptionV2: SubscriptionV2;
  totalConsultations?: Maybe<TotalConsultations>;
  totalPathologyConsultationsForDoctor?: Maybe<Scalars['Int']['output']>;
  tracker: TrackerField;
  trackerDetailsForCustomerQuery: Array<TrackerDetails>;
  treatment?: Maybe<Treatment>;
  treatmentResponses: Array<TreatmentResponses>;
  treatments?: Maybe<Array<Treatment>>;
  unsignedPrescriptions?: Maybe<Array<Maybe<UnsignedPrescription>>>;
  unsignedPrescriptionsCount?: Maybe<Scalars['Int']['output']>;
  validPhoneRegions?: Maybe<Array<ValidPhoneRegion>>;
  viewedContentItems: ViewedContentItemsPayload;
  weightMilestonesPreview?: Maybe<Array<WeightMilestonePreview>>;
};


export type QueryActivePractitionerBookingWindowHasPatientsArgs = {
  problemTypes: Array<ProblemType>;
};


export type QueryActivePractitionerBookingWindowPatientCountArgs = {
  problemTypes: Array<ProblemType>;
};


export type QueryActivitiesArgs = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate: Scalars['DateTime']['input'];
};


export type QueryBloodGlucoseArgs = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  span?: InputMaybe<WearableSampleSpan>;
  startDate: Scalars['DateTime']['input'];
};


export type QueryCanRestartInitialQuizApplicationArgs = {
  problemType: ProblemType;
};


export type QueryChatMacrosArgs = {
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  targetUserId: Scalars['String']['input'];
};


export type QueryChatThreadCountsByTypeArgs = {
  type: ChatThreadType;
};


export type QueryChatThreadPriorityCountsByTypeArgs = {
  type: ChatThreadType;
};


export type QueryChatThreadStatusCountsByTypeArgs = {
  type: ChatThreadType;
};


export type QueryChecklistByConsultationArgs = {
  consultationId: Scalars['String']['input'];
};


export type QueryConsultationArgs = {
  id: Scalars['String']['input'];
};


export type QueryConsultationsArgs = {
  orderBy?: InputMaybe<ConsultationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ConsultationWhereInput>;
};


export type QueryContentCollectionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContentItemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCrossSellRecommendationsArgs = {
  crossSellContext: CrossSellContextType;
};


export type QueryCustomerOrderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDailyStepsGoalResultsArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
};


export type QueryDiscountCodeArgs = {
  checkoutStage?: InputMaybe<DiscountStage>;
  code: Scalars['String']['input'];
  productIds?: InputMaybe<Array<Scalars['String']['input']>>;
  skipProductValidation?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryDoctorsLetterTemplateArgs = {
  consultationId: Scalars['String']['input'];
  productId?: InputMaybe<Scalars['String']['input']>;
  sequenceId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEducationCollectionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEducationProgramArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEducationReadingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFilteredChatThreadsArgs = {
  input?: InputMaybe<FilteredChatThreadsInput>;
};


export type QueryFilteredNotesArgs = {
  input: FilteredNotesInput;
};


export type QueryGetConsultationByQuizApplicationIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetConsultationsForCustomerArgs = {
  customerId: Scalars['String']['input'];
};


export type QueryGetPathologyConsultationsForDoctorArgs = {
  orderBy?: InputMaybe<ConsultationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ConsultationWhereInput>;
};


export type QueryGetPathologyReferralFileArgs = {
  consultationId: Scalars['String']['input'];
};


export type QueryGetPathologyResultFileArgs = {
  consultationId: Scalars['String']['input'];
};


export type QueryGetPatientArgs = {
  patientId: Scalars['String']['input'];
};


export type QueryGetQuizApplicationArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetTreatmentsForCustomerArgs = {
  customerId: Scalars['String']['input'];
};


export type QueryGoalDurationFromStartingDateSecondsArgs = {
  goalWeightKg: Scalars['Float']['input'];
};


export type QueryGoalWeightFeedbackTypeArgs = {
  goalWeightKg: Scalars['Float']['input'];
};


export type QueryHeartRateVariabilityArgs = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate: Scalars['DateTime']['input'];
};


export type QueryInSegmentArgs = {
  segmentName: Segment;
};


export type QueryInitialPurchaseConfirmPageArgs = {
  consultationId: Scalars['String']['input'];
};


export type QueryInitialPurchasePriceArgs = {
  consultationId?: InputMaybe<Scalars['String']['input']>;
  couponCode?: InputMaybe<Scalars['String']['input']>;
  couponCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  discountCode?: InputMaybe<Scalars['String']['input']>;
  offeringSelections: Array<OfferingSelectionInput>;
  pricingSessionId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryIsEPrescribingAllowedArgs = {
  doctorId: Scalars['String']['input'];
  patientId: Scalars['String']['input'];
  productId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMedicationPreferenceProductArgs = {
  problemType: ProblemType;
};


export type QueryMobileLearnCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMobileLearnContentItemsArgs = {
  sessionKey: Scalars['String']['input'];
};


export type QueryOfferingsArgs = {
  problemType: ProblemType;
  requiresPrescription?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryOfferingsTimelineArgs = {
  offerings: Array<OfferingSelectionInput>;
};


export type QueryPafAddonSectionArgs = {
  problemType: ProblemType;
  stage: PafStage;
};


export type QueryPathologyLocationHealiusArgs = {
  postcode: Scalars['String']['input'];
};


export type QueryPathologyLocationsArgs = {
  postcode: Scalars['String']['input'];
};


export type QueryPathologyPanelTestNamesArgs = {
  type: ProblemType;
};


export type QueryPersonalizationRecordsByProblemTypeArgs = {
  problemType: ProblemType;
};


export type QueryPractitionerBookingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPractitionerBookingWindowSummariesArgs = {
  problemTypes: Array<ProblemType>;
};


export type QueryPrescriptionHistoryArgs = {
  userId: Scalars['String']['input'];
};


export type QueryProductPrescriptionOptionsArgs = {
  patientId: Scalars['String']['input'];
  problemType: ProblemType;
};


export type QueryProductsArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  problemType?: InputMaybe<ProblemType>;
  productType?: InputMaybe<ProductType>;
  where?: InputMaybe<ProductWhereInput>;
};


export type QueryProgressEntriesArgs = {
  type: ProgressEntryType;
};


export type QueryPurchaseArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPurchaseGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRankedContentItemsArgs = {
  sessionKey: Scalars['ID']['input'];
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QuerySequenceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryShippingAddressWithinRangeArgs = {
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  postcode: Scalars['String']['input'];
  suburb: Scalars['String']['input'];
};


export type QueryShopItemArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySkinRegimenArgs = {
  consultationId: Scalars['String']['input'];
};


export type QueryStepsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  span?: InputMaybe<WearableSampleSpan>;
  startDate: Scalars['DateTime']['input'];
};


export type QuerySubscriptionPlanV2ByIdArgs = {
  id: Scalars['String']['input'];
};


export type QuerySubscriptionV2Args = {
  id: Scalars['String']['input'];
};


export type QueryTotalConsultationsArgs = {
  where?: InputMaybe<ConsultationWhereInput>;
};


export type QueryTrackerDetailsForCustomerQueryArgs = {
  customerId: Scalars['String']['input'];
  problemType: ProblemType;
};


export type QueryTreatmentArgs = {
  id: Scalars['String']['input'];
};


export type QueryTreatmentResponsesArgs = {
  consultationId: Scalars['String']['input'];
};


export type QueryTreatmentsArgs = {
  where?: InputMaybe<TreatmentWhereInput>;
};


export type QueryUnsignedPrescriptionsArgs = {
  pagination: Pagination;
};


export type QueryViewedContentItemsArgs = {
  input: ViewedContentItemsInput;
};


export type QueryWeightMilestonesPreviewArgs = {
  goalWeightKg: Scalars['Float']['input'];
};

export type QueryMode =
  | 'default'
  | 'insensitive';

export type Quiz = {
  __typename?: 'Quiz';
  createdAt: Scalars['DateTime']['output'];
  default: Scalars['Boolean']['output'];
  flags: Array<QuizFlag>;
  id: Scalars['String']['output'];
  logics: Array<QuizLogic>;
  questions: Array<QuizQuestion>;
  questionsOrder: Array<Scalars['String']['output']>;
  quizCode: Scalars['String']['output'];
  skips: Array<QuizSkip>;
  slug?: Maybe<Scalars['String']['output']>;
  status: QuizStatus;
  title: Scalars['String']['output'];
  type: ProblemType;
  updatedAt: Scalars['DateTime']['output'];
};

export type QuizApplication = {
  __typename?: 'QuizApplication';
  answers: Array<QuizApplicationResponse>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  consultation?: Maybe<Consultation>;
  createdAt: Scalars['DateTime']['output'];
  customer: User;
  customerId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isNonEnglish: Scalars['Boolean']['output'];
  languageCode: SupportedLanguages;
  languageDisplayName?: Maybe<Scalars['String']['output']>;
  outcomeSummary?: Maybe<Scalars['String']['output']>;
  outcomes?: Maybe<Array<QuizOutcomeV2Result>>;
  problemType: ProblemType;
  purpose: QuizPurpose;
  quiz: Quiz;
  quizId: Scalars['String']['output'];
  responses?: Maybe<Array<QuizResponse>>;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


export type QuizApplicationAnswersArgs = {
  orderBy?: InputMaybe<Array<QuizApplicationResponseOrderByInput>>;
};

export type QuizApplicationResponse = {
  __typename?: 'QuizApplicationResponse';
  answer?: Maybe<Scalars['String']['output']>;
  answersArray: Array<Scalars['String']['output']>;
  application: QuizApplication;
  applicationId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  question?: Maybe<QuizQuestion>;
  questionId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


export type QuizApplicationResponseAnswerArgs = {
  languageCode?: InputMaybe<SupportedLanguages>;
};


export type QuizApplicationResponseAnswersArrayArgs = {
  languageCode?: InputMaybe<SupportedLanguages>;
};

export type QuizApplicationResponseOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
};

export type QuizConditions = {
  __typename?: 'QuizConditions';
  createdAt: Scalars['DateTime']['output'];
  flag?: Maybe<QuizFlag>;
  flagId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  jump?: Maybe<QuizJump>;
  jumpId?: Maybe<Scalars['String']['output']>;
  nextCondition?: Maybe<QuizValidationCondition>;
  operator: QuizJumpOperator;
  order: Scalars['Int']['output'];
  question: QuizQuestion;
  questionId: Scalars['String']['output'];
  skip?: Maybe<QuizSkip>;
  skipId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['String']['output'];
};

export type QuizConditionsOrderByInput = {
  order?: InputMaybe<SortOrder>;
};

export type QuizFlag = {
  __typename?: 'QuizFlag';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  level: QuizFlagLevel;
  question: QuizQuestion;
  questionId: Scalars['String']['output'];
  quiz: Quiz;
  /** @deprecated use quiz instead */
  quizId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type QuizFlagLevel =
  | 'CRITICAL'
  | 'MODERATE';

export type QuizJump = {
  __typename?: 'QuizJump';
  conditions: Array<QuizConditions>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  logic: QuizLogic;
  logicId: Scalars['String']['output'];
  to: QuizQuestion;
  toId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


export type QuizJumpConditionsArgs = {
  orderBy?: InputMaybe<Array<QuizConditionsOrderByInput>>;
};

export type QuizJumpOperator =
  | 'CONTAINS'
  | 'IS'
  | 'IS_GREATER_THAN'
  | 'IS_GREATER_THAN_OR_EQUAL'
  | 'IS_LESS_THAN'
  | 'IS_LESS_THAN_OR_EQUAL'
  | 'IS_NOT'
  | 'NOT_CONTAINS';

export type QuizLogic = {
  __typename?: 'QuizLogic';
  createdAt: Scalars['DateTime']['output'];
  elseJump: QuizQuestion;
  elseJumpId: Scalars['String']['output'];
  from: QuizQuestion;
  fromId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  jumps: Array<QuizJump>;
  quiz: Quiz;
  quizId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type QuizOutcomeReason =
  | 'AGE'
  | 'AGE_OLD'
  | 'AGE_OLD_75'
  | 'AGE_OLD_85'
  | 'AGE_YOUNG'
  | 'BMI'
  | 'FAMILY_HISTORY_THYROID_CANCER'
  | 'GALLSTONES'
  | 'MEDICATION_CONTRAINDICATIONS'
  | 'MENTAL_HEALTH_CONDITIONS'
  | 'NO_COMORBIDITIES'
  | 'PREGNANCY'
  | 'PREGNANCY_OR_BREASTFEEDING'
  | 'TYPE_1_DIABETES';

export type QuizOutcomeV2 = {
  id: Scalars['ID']['output'];
};

export type QuizOutcomeV2Result = ArticleQuizOutcome | BuyOtcQuizOutcome | ConsultationQuizOutcome | IncreaseUsageQuizOutcome | NotEligibleQuizOutcome | OtcQuizOutcome | ReviewQuizOutcome | SideEffectProactiveActionQuizOutcome | ZendeskQuizOutcome;

export type QuizPurpose =
  | 'FOLLOW_UP_CONSULTATION'
  | 'INITIAL'
  | 'SCREENING'
  | 'TRACKER';

export type QuizQuestion = {
  __typename?: 'QuizQuestion';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customStyle?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  imgOptions?: Maybe<Scalars['Json']['output']>;
  imgUrl?: Maybe<Scalars['String']['output']>;
  optionImgLayout?: Maybe<QuizQuestionOptionImageLayout>;
  options?: Maybe<Scalars['Json']['output']>;
  popup?: Maybe<QuizQuestionPopup>;
  questionOptions: Array<QuizQuestionOption>;
  quiz?: Maybe<Quiz>;
  quizId?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
  shortcode?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: QuizQuestionType;
  updatedAt: Scalars['DateTime']['output'];
};

export type QuizQuestionOption = {
  __typename?: 'QuizQuestionOption';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  imgUrl?: Maybe<Scalars['String']['output']>;
  option?: Maybe<Scalars['String']['output']>;
  popup?: Maybe<QuizQuestionPopup>;
  position?: Maybe<Scalars['Int']['output']>;
  question: QuizQuestion;
  questionId: Scalars['String']['output'];
};

export type QuizQuestionOptionImageLayout =
  | 'FULL_BUTTON'
  | 'LEFT_ICON'
  | 'RIGHT_ICON'
  | 'SQUARE';

export type QuizQuestionPopup = {
  __typename?: 'QuizQuestionPopup';
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  imgUrl?: Maybe<Scalars['String']['output']>;
  linkOutText?: Maybe<Scalars['String']['output']>;
  questionId: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type QuizQuestionType =
  | 'CHECKBOX'
  | 'CONTINUE'
  | 'CUSTOM'
  | 'DATE'
  | 'DROPDOWN'
  | 'EMAIL'
  | 'IMAGEUPLOAD'
  | 'NUMBER'
  | 'RADIO'
  | 'RADIO_IMG'
  | 'REVIEW'
  | 'STOP'
  | 'TEXTAREA'
  | 'TEXTFIELD'
  | 'TRANSITION'
  | 'UNITISED_NUMERIC';

export type QuizResponse = {
  __typename?: 'QuizResponse';
  id: Scalars['ID']['output'];
  question?: Maybe<QuizResponseQuestion>;
  response?: Maybe<QuizResponseResponse>;
};

export type QuizResponseQuestion = {
  __typename?: 'QuizResponseQuestion';
  id?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<QuizResponseQuestionOption>>;
  shortcode?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<QuizQuestionType>;
};


export type QuizResponseQuestionTitleArgs = {
  languageCode?: InputMaybe<SupportedLanguages>;
};

export type QuizResponseQuestionOption = {
  __typename?: 'QuizResponseQuestionOption';
  value: Scalars['String']['output'];
};


export type QuizResponseQuestionOptionValueArgs = {
  languageCode?: InputMaybe<SupportedLanguages>;
};

export type QuizResponseResponse = {
  __typename?: 'QuizResponseResponse';
  answers?: Maybe<Array<QuizResponseResponseAnswer>>;
  flag?: Maybe<QuizResponseResponseFlag>;
};


export type QuizResponseResponseAnswersArgs = {
  languageCode?: InputMaybe<SupportedLanguages>;
};

export type QuizResponseResponseAnswer = {
  __typename?: 'QuizResponseResponseAnswer';
  imageUrl?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type QuizResponseResponseFlag = {
  __typename?: 'QuizResponseResponseFlag';
  level: QuizFlagLevel;
};

export type QuizSkip = {
  __typename?: 'QuizSkip';
  conditions: Array<QuizConditions>;
  createdAt: Scalars['DateTime']['output'];
  from: QuizQuestion;
  fromId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  quiz: Quiz;
  quizId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


export type QuizSkipConditionsArgs = {
  orderBy?: InputMaybe<Array<QuizConditionsOrderByInput>>;
};

export type QuizStatus =
  | 'ARCHIVED'
  | 'DRAFT'
  | 'LIVE'
  | 'PREVIEW'
  | 'VARIANT';

export type QuizValidationCondition =
  | 'AND'
  | 'OR';

export type RmssdHeartRateVariabilitySample = HeartRateVariabilitySample & {
  __typename?: 'RMSSDHeartRateVariabilitySample';
  id: Scalars['ID']['output'];
  /** @deprecated Never implemented */
  integration?: Maybe<WearableIntegration>;
  rmssd: Scalars['Float']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type ReadStatus =
  | 'IN_PROGRESS'
  | 'READ'
  | 'UNREAD';

export type ReadingContentItem = ContentItem & {
  __typename?: 'ReadingContentItem';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  content: Scalars['Json']['output'];
  contentfulId: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  heroHash: Scalars['String']['output'];
  heroUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: ContentItemStatus;
  tags: Array<ContentTag>;
  thumbnailHash: Scalars['String']['output'];
  thumbnailUrl: Scalars['String']['output'];
  /** Time taken to read the reading in milliseconds */
  timeToReadMs?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
};

export type ReassignChatThreadPayload = {
  __typename?: 'ReassignChatThreadPayload';
  chatThread?: Maybe<ChatThread>;
};

export type ReassignChatThreadsPayload = {
  __typename?: 'ReassignChatThreadsPayload';
  /** @deprecated use `chatThreadStatusCountsByType` */
  chatThreadCountsByType?: Maybe<ChatThreadCounts>;
  chatThreadStatusCountsByType?: Maybe<ChatThreadStatusCounts>;
  filteredChatThreads?: Maybe<FilteredChatThreadsPayload>;
};


export type ReassignChatThreadsPayloadChatThreadCountsByTypeArgs = {
  type: ChatThreadType;
};


export type ReassignChatThreadsPayloadChatThreadStatusCountsByTypeArgs = {
  type: ChatThreadType;
};


export type ReassignChatThreadsPayloadFilteredChatThreadsArgs = {
  input?: InputMaybe<FilteredChatThreadsInput>;
};

export type RecipeContentItem = ContentItem & {
  __typename?: 'RecipeContentItem';
  content: Scalars['Json']['output'];
  contentfulId: Scalars['ID']['output'];
  cookingTimeMins: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  heroHash: Scalars['String']['output'];
  heroUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  kiloCalories?: Maybe<Scalars['Int']['output']>;
  /** m3u8 */
  playbackUrl?: Maybe<Scalars['String']['output']>;
  serves: Scalars['Int']['output'];
  status: ContentItemStatus;
  tags: Array<ContentTag>;
  thumbnailHash: Scalars['String']['output'];
  thumbnailUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
  videoDurationSeconds?: Maybe<Scalars['Int']['output']>;
};

export type RegisterMissedAppointmentInput = {
  consultationId: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
};

export type RegisterMissedAppointmentPayload = {
  __typename?: 'RegisterMissedAppointmentPayload';
  registered?: Maybe<Scalars['Boolean']['output']>;
};

export type ReportSignedPrescriptionUploadsPayload = {
  __typename?: 'ReportSignedPrescriptionUploadsPayload';
  signedPrescriptionIds: Array<Scalars['String']['output']>;
};

export type RequestReviewTreatmentInput = {
  reason: RequestReviewTreatmentReason;
  treatmentId: Scalars['ID']['input'];
  trigger: CoreTriggerSource;
};

export type RequestReviewTreatmentReason =
  | 'MEDICATION_CHANGES'
  | 'NOT_SEEING_RESULTS';

export type ResidentialAddress = {
  __typename?: 'ResidentialAddress';
  building?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  company?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  line1: Scalars['String']['output'];
  line2?: Maybe<Scalars['String']['output']>;
  municipality?: Maybe<Scalars['String']['output']>;
  postalCode: Scalars['String']['output'];
  prefecture?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  townArea?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ResidentialAddressCreateInput = {
  building?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  municipality?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  prefecture?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  townArea?: InputMaybe<Scalars['String']['input']>;
};

export type RestartFlowInput = {
  type: ProblemType;
};

export type RestartFlowPayload = {
  __typename?: 'RestartFlowPayload';
  consultation: Consultation;
};

/** The patient was previously prescribed something that is now expired. */
export type RestartFlowPrompt = PurchasePrompt & {
  __typename?: 'RestartFlowPrompt';
  id: Scalars['ID']['output'];
};

export type ResumePurchaseInput = {
  purchaseId: Scalars['ID']['input'];
};

export type ResumePurchasePayload = {
  __typename?: 'ResumePurchasePayload';
  purchase: Purchase;
};

export type ReviewQuizOutcome = QuizOutcomeV2 & {
  __typename?: 'ReviewQuizOutcome';
  id: Scalars['ID']['output'];
};

export type ReviewReason =
  | 'EXPIRED_SCRIPT'
  | 'EXTERNAL_SCRIPT_REQUEST'
  | 'LEGACY_MIGRATED'
  | 'LORIKEET'
  | 'MEDICAL_HISTORY_CHANGES'
  | 'MEDICAL_INQUIRY'
  | 'MEDICATION_CHANGES'
  | 'NOT_SEEING_RESULTS'
  | 'PATHOLOGY_RESULTS'
  | 'PROGRESS_REVIEW'
  | 'REACTIVATION'
  | 'SIDE_EFFECTS'
  | 'STOCKOUT_EVENT'
  | 'TRANSITION_OFF_TREATMENT'
  | 'URGENT_MEDICATION_CHANGES'
  | 'URGENT_NEW_SCRIPT_REQUIRED'
  | 'URGENT_SIDE_EFFECTS';

export type Role = {
  __typename?: 'Role';
  id: Scalars['ID']['output'];
  value: AdminRole;
};

/** An RX product offering that supports prepay, bundling and order add-ons */
export type RxOffering = Offering & {
  __typename?: 'RxOffering';
  advertisedCostCadence?: Maybe<Scalars['String']['output']>;
  advertisedDosageExplanation?: Maybe<OfferingAdvertisedDosageExplanation>;
  advertisedName: Scalars['String']['output'];
  advertisedShippingCadence: Scalars['String']['output'];
  /** e.g. "$10 per pen" or "£10 / month" */
  advertisedStartingAmount: Scalars['String']['output'];
  advertisedStartingAmountHeader: Scalars['String']['output'];
  advertisedStartingAmountSubtitle: Scalars['String']['output'];
  availableAddons?: Maybe<Array<AddOnOffering>>;
  contents: Array<OfferingContentItem>;
  description: Scalars['String']['output'];
  downsells?: Maybe<Array<SwitchCandidate>>;
  firstOrderGiftCopy?: Maybe<Scalars['String']['output']>;
  friendlyName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  photoUrl: Scalars['String']['output'];
  prepayOptions?: Maybe<Array<OfferingPrepayOption>>;
  problemTypes?: Maybe<Array<ProblemType>>;
  sequenceSets?: Maybe<Array<SequenceSet>>;
  status: OfferingStatus;
  tags: Array<Scalars['String']['output']>;
  upsells?: Maybe<Array<SwitchCandidate>>;
};

export type SdnnHeartRateVariabilitySample = HeartRateVariabilitySample & {
  __typename?: 'SDNNHeartRateVariabilitySample';
  id: Scalars['ID']['output'];
  /** @deprecated Never implemented */
  integration?: Maybe<WearableIntegration>;
  sdnn: Scalars['Float']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type SavedCardPaymentMethod = SavedPaymentMethod & {
  __typename?: 'SavedCardPaymentMethod';
  brand: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  default: Scalars['Boolean']['output'];
  expiry: Scalars['String']['output'];
  gateway: PaymentGateway;
  id: Scalars['ID']['output'];
  mask: Scalars['String']['output'];
};

export type SavedPayPalPaymentMethod = SavedPaymentMethod & {
  __typename?: 'SavedPayPalPaymentMethod';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  default: Scalars['Boolean']['output'];
  email?: Maybe<Scalars['String']['output']>;
  gateway: PaymentGateway;
  id: Scalars['ID']['output'];
};

export type SavedPaymentMethod = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  default: Scalars['Boolean']['output'];
  gateway: PaymentGateway;
  id: Scalars['ID']['output'];
};

export type SavedSofortPaymentMethod = SavedPaymentMethod & {
  __typename?: 'SavedSofortPaymentMethod';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  default: Scalars['Boolean']['output'];
  gateway: PaymentGateway;
  id: Scalars['ID']['output'];
};

export type SavedZipPaymentMethod = SavedPaymentMethod & {
  __typename?: 'SavedZipPaymentMethod';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  default: Scalars['Boolean']['output'];
  gateway: PaymentGateway;
  id: Scalars['ID']['output'];
  valid: Scalars['Boolean']['output'];
};

export type Script = {
  __typename?: 'Script';
  allergies?: Maybe<Scalars['String']['output']>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  consultation?: Maybe<Consultation>;
  consultationId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currentMedications?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  dob?: Maybe<Scalars['String']['output']>;
  doctor?: Maybe<User>;
  doctorId?: Maybe<Scalars['String']['output']>;
  existingConditions?: Maybe<Scalars['String']['output']>;
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  isDirect?: Maybe<Scalars['Boolean']['output']>;
  isPerfect?: Maybe<Scalars['Boolean']['output']>;
  patient: User;
  patientId: Scalars['String']['output'];
  reference?: Maybe<Scalars['String']['output']>;
  reg24?: Maybe<Scalars['Boolean']['output']>;
  repeats: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  version?: Maybe<Scalars['Int']['output']>;
};

export type ScriptParametersInput = {
  allergies?: InputMaybe<Scalars['String']['input']>;
  annotations?: InputMaybe<Array<AnnotationInput>>;
  currentMedications?: InputMaybe<Scalars['String']['input']>;
  dob: Scalars['String']['input'];
  doctorNotesToPharmacist?: InputMaybe<Scalars['String']['input']>;
  eScriptAbortKey?: InputMaybe<Scalars['String']['input']>;
  eScriptTokenEmail?: InputMaybe<Scalars['String']['input']>;
  existingConditions?: InputMaybe<Scalars['String']['input']>;
  hadPreviousSideEffects?: InputMaybe<Scalars['Boolean']['input']>;
  isEmergencySupply?: InputMaybe<Scalars['Boolean']['input']>;
  isUnusualDosage?: InputMaybe<Scalars['Boolean']['input']>;
  maximumQuantity?: InputMaybe<Scalars['String']['input']>;
  minimumRepeatIntervalDays?: InputMaybe<Scalars['Int']['input']>;
  preventBrandSubstitution?: InputMaybe<Scalars['Boolean']['input']>;
  previouslyTaken?: InputMaybe<Scalars['Boolean']['input']>;
  reasonForPrescribing?: InputMaybe<Scalars['String']['input']>;
  regulation24Applied?: InputMaybe<Scalars['Boolean']['input']>;
  skipMySl?: InputMaybe<Scalars['Boolean']['input']>;
  skipPharmacySl?: InputMaybe<SkipPharmacySlType>;
  useLegacyPaperScript?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Segment =
  | 'COMPLETED_LEVELS_ONBOARDING'
  | 'COMPLETED_MOBILE_ONBOARDING_SCREENS'
  | 'COMPLETED_MOBILE_ONBOARDING_TASKS'
  | 'COMPOUNDING_CONSENT_REQUIRED_IN_CONSULT'
  | 'COMPOUNDING_CONSENT_REQUIRED_LOW_DOSE_ACTIVE_POST_20TH'
  | 'COMPOUNDING_CONSENT_REQUIRED_LOW_DOSE_ACTIVE_POST_20TH_NO_DOC'
  | 'COMPOUNDING_CONSENT_REQUIRED_LOW_DOSE_ACTIVE_POST_20TH_QLD_NP'
  | 'COMPOUNDING_CONSENT_REQUIRED_LOW_DOSE_ACTIVE_PRE_20TH'
  | 'COMPOUNDING_CONSENT_REQUIRED_LOW_DOSE_ACTIVE_PRE_20TH_NO_DOC'
  | 'COMPOUNDING_CONSENT_REQUIRED_LOW_DOSE_ACTIVE_PRE_20TH_QLD_NP'
  | 'COMPOUNDING_CONSENT_REQUIRED_LOW_DOSE_DA_NO_OP_ACTIVE_DOCTOR'
  | 'COMPOUNDING_CONSENT_REQUIRED_LOW_DOSE_DA_NO_OP_INACTIVE_DOCTOR'
  | 'COMPOUNDING_CONSENT_REQUIRED_LOW_DOSE_DA_NO_OP_QLD_NP'
  | 'COMPOUNDING_CONSENT_REQUIRED_OZEMPIC_CHURNED'
  | 'ELIGIBLE_FOR_CHAT'
  | 'LGA_ENABLED'
  | 'PRICING_BATCHING_EXPERIMENT_CONTROL'
  | 'PRICING_BATCHING_EXPERIMENT_V3_EXPERIMENT'
  | 'PRICING_BATCHING_EXPERIMENT_VARIATION'
  | 'SEGMENT_JUNIPER_OP_CREDIT'
  | 'SKIN_CHECK_IN_SMS'
  | 'SOFTWARE_INSIDERS_WIDGET_DISMISSED'
  | 'SOFTWARE_RECURRING_OTC_DISCOUNT_EXPERIMENT'
  | 'WEIGHT_DASHBOARD_LEARN_TAB_ACTION_NOT_REQUIRED'
  | 'WEIGHT_FACEBOOK_COMMUNITY_JOINED';

export type Sequence = {
  description: Scalars['String']['output'];
  externalLinks: Array<SequenceExternalLink>;
  faqs: Array<SequenceFaq>;
  friendlyName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  internalName: Scalars['String']['output'];
  nodes: Array<EventSequenceNode | InternalTriggerSequenceNode | SmsSequenceNode | VariantSequenceNode | WaitSequenceNode>;
  problemTypes: Array<Maybe<ProblemType>>;
  products?: Maybe<Array<Product>>;
  status: SequenceStatus;
  tags: Array<Scalars['String']['output']>;
};

export type SequenceContext = {
  __typename?: 'SequenceContext';
  consultations?: Maybe<Array<Consultation>>;
  id: Scalars['ID']['output'];
  nextOrderDue?: Maybe<Scalars['DateTime']['output']>;
  purchaseSyncGroup?: Maybe<PurchaseSyncGroup>;
  sequence?: Maybe<OtcSequence | PrescribableSequence>;
  sequenceSet?: Maybe<SequenceSet>;
  status: SequenceContextStatus;
};

export type SequenceContextStatus =
  | 'ACTIVE'
  | 'CANCELLED'
  | 'COMPLETED'
  | 'PAUSED';

export type SequenceExternalLink = {
  __typename?: 'SequenceExternalLink';
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type SequenceFaq = {
  __typename?: 'SequenceFaq';
  answerMarkdown: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  question: Scalars['String']['output'];
  rank?: Maybe<Scalars['Int']['output']>;
  videoUrl: Scalars['String']['output'];
};

export type SequenceNode = {
  id: Scalars['ID']['output'];
  nextNodeId?: Maybe<Scalars['ID']['output']>;
};

export type SequenceSafetyInformation = {
  __typename?: 'SequenceSafetyInformation';
  cmiCopyMarkdown: Scalars['String']['output'];
  cmiUrl: Scalars['String']['output'];
  doctorLetterTemplate: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type SequenceSelection = {
  __typename?: 'SequenceSelection';
  id: Scalars['ID']['output'];
  /** If set, this represents a selection from either the patient or Eucalyptus. */
  sequence?: Maybe<OtcSequence | PrescribableSequence>;
  sequenceSet?: Maybe<SequenceSet>;
};

export type SequenceSelectionInput = {
  sequenceId: Scalars['ID']['input'];
  sequenceSetId: Scalars['ID']['input'];
};

export type SequenceSet = {
  __typename?: 'SequenceSet';
  /** Should be used in lieu of the customer making a selection */
  defaultSequence?: Maybe<OtcSequence | PrescribableSequence>;
  id: Scalars['ID']['output'];
  problemTypesFilter?: Maybe<Array<ProblemType>>;
  /** Returned in the order defined in sequenceIdsFilter (if set). */
  sequences?: Maybe<Array<OtcSequence | PrescribableSequence>>;
};

export type SequenceStatus =
  /** Available for purchase and prescription. */
  | 'AVAILABLE'
  /** Not available for purchase or prescription. No customers are expected to be ticking on this sequence. */
  | 'DEPRECATED'
  /** Not available for purchase or prescription. */
  | 'DRAFT'
  /** Not available for prescription. Available for purchase only if the customer has a pending prescribed sequence matching this sequence. */
  | 'PHASING_OUT'
  /** Not available for purchase or prescription. Customers can continue ticking on this sequence. */
  | 'UNAVAILABLE';

export type SetContentItemProgressInput = {
  id: Scalars['ID']['input'];
  reading?: InputMaybe<ContentItemProgressReadingInput>;
  recipe?: InputMaybe<ContentItemProgressRecipeInput>;
  video?: InputMaybe<ContentItemProgressVideoInput>;
  videoWithReading?: InputMaybe<ContentItemProgressVideoWithReadingInput>;
};

export type SetContentItemProgressPayload = {
  __typename?: 'SetContentItemProgressPayload';
  item: FaqContentItem | ReadingContentItem | RecipeContentItem | VideoContentItem | VideoWithReadingContentItem;
};

export type SetGoalWeightInput = {
  goalWeightKg: Scalars['Float']['input'];
};

export type SetGoalWeightPayload = {
  __typename?: 'SetGoalWeightPayload';
  user?: Maybe<User>;
  weightLoss?: Maybe<WeightLossTracker>;
};

export type SetHealthCoachAvailabilityPayload = {
  __typename?: 'SetHealthCoachAvailabilityPayload';
  user?: Maybe<User>;
};

export type SetStepsGoalInput = {
  dailyCount: Scalars['Int']['input'];
};

export type SetStepsGoalPayload = {
  __typename?: 'SetStepsGoalPayload';
  stepsGoal?: Maybe<StepsGoal>;
};

export type SetTrendAsAddressedInput = {
  trendId: Scalars['ID']['input'];
};

export type SetTrendAsAddressedPayload = {
  __typename?: 'SetTrendAsAddressedPayload';
  trend: Trend;
};

export type SetUserPushTokenInput = {
  devicePlatform: DevicePlatform;
  token: Scalars['String']['input'];
};

export type SetUserPushTokenPayload = {
  __typename?: 'SetUserPushTokenPayload';
  success: Scalars['Boolean']['output'];
};

export type SetUserStatedCallResultInput = {
  callId: Scalars['ID']['input'];
  callResult: UserStatedCallResult;
  consultationId: Scalars['ID']['input'];
};

export type SetUserStatedCallResultPayload = {
  __typename?: 'SetUserStatedCallResultPayload';
  consultation?: Maybe<Consultation>;
};

export type Sex =
  | 'FEMALE'
  | 'INTERSEX'
  | 'MALE'
  | 'UNKNOWN';

export type Shipment = {
  __typename?: 'Shipment';
  deliveredAt?: Maybe<Scalars['DateTime']['output']>;
  deliveryProgress?: Maybe<ShipmentDeliveryProgress>;
  expectedDeliveryWindowEnd?: Maybe<Scalars['DateTime']['output']>;
  expectedDeliveryWindowStart?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isCanceled: Scalars['Boolean']['output'];
  lineItems: Array<ShipmentLineItem>;
  note?: Maybe<Scalars['String']['output']>;
  trackingCta?: Maybe<ShipmentCta>;
};

export type ShipmentCta = {
  __typename?: 'ShipmentCta';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ShipmentDeliveryProgress = {
  __typename?: 'ShipmentDeliveryProgress';
  deliveryStages: Array<ShipmentDeliveryStage>;
  id: Scalars['ID']['output'];
};

export type ShipmentDeliveryStage = {
  __typename?: 'ShipmentDeliveryStage';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  cta?: Maybe<ShipmentCta>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  status: ShipmentDeliveryStageStatus;
  title: Scalars['String']['output'];
};

export type ShipmentDeliveryStageStatus =
  | 'ACTIVE'
  | 'COMPLETED'
  | 'INACTIVE';

export type ShipmentLineItem = {
  __typename?: 'ShipmentLineItem';
  amountPaid?: Maybe<MonetaryAmount>;
  discount?: Maybe<MonetaryAmount>;
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  price?: Maybe<MonetaryAmount>;
  quantity: Scalars['Int']['output'];
};

export type ShopItem = {
  __typename?: 'ShopItem';
  availability: ShopItemAvailability;
  id: Scalars['ID']['output'];
  otcOffering?: Maybe<OtcOffering>;
  title: Scalars['String']['output'];
};

export type ShopItemAvailability =
  | 'AVAILABLE'
  | 'UNAVAILABLE';

export type ShopSection = {
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type SideEffectProactiveActionQuizOutcome = QuizOutcomeV2 & {
  __typename?: 'SideEffectProactiveActionQuizOutcome';
  action: SideEffectProactiveActionQuizOutcomeAction;
  id: Scalars['ID']['output'];
};

export type SideEffectProactiveActionQuizOutcomeAction =
  | 'REACTING'
  | 'REVIEWING';

export type SkinGoal =
  | 'BrightenSkin'
  | 'FadePigmentation'
  | 'ReduceBlackheadsWhiteheads'
  | 'ReducePimples'
  | 'ReduceRedness'
  | 'RemoveFineLinesWrinkles'
  | 'TreatAcneScarring'
  | 'TreatDrySkin';

export type SkinRegimen = {
  __typename?: 'SkinRegimen';
  primarySkinGoal?: Maybe<SkinGoal>;
  restOfRange?: Maybe<Array<Product>>;
  skinGoalBasedRecommendedOTC?: Maybe<Array<Product>>;
  skinType?: Maybe<SkinType>;
  unorderedSkinGoals?: Maybe<Array<SkinGoal>>;
};

export type SkinType =
  | 'Combination'
  | 'Dry'
  | 'Normal'
  | 'Oily'
  | 'Unknown';

export type SkinUsage =
  | 'FIVE_PLUS_TIMES_A_WEEK'
  | 'FOUR_TIMES_A_WEEK'
  | 'ONCE_A_WEEK'
  | 'THREE_TIMES_A_WEEK'
  | 'TWICE_A_WEEK';

export type SkipPharmacySlType =
  | 'DosingPoint'
  | 'RepeatOnFile'
  | 'StagedSupply';

export type Smoking =
  | 'NO'
  | 'RARELY'
  | 'YES';

export type SmsSequenceNode = SequenceNode & {
  __typename?: 'SmsSequenceNode';
  id: Scalars['ID']['output'];
  nextNodeId?: Maybe<Scalars['ID']['output']>;
  type: SmsSequenceNodeType;
};

export type SmsSequenceNodeType =
  | 'UPCOMING_PAYMENT_REMINDER';

export type SortOrder =
  | 'asc'
  | 'desc';

export type Steps = {
  __typename?: 'Steps';
  devices?: Maybe<Array<Device>>;
  id: Scalars['ID']['output'];
  samples?: Maybe<Array<StepsSample>>;
};

export type StepsGoal = {
  __typename?: 'StepsGoal';
  dailyCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
};

export type StepsGoalResult = {
  __typename?: 'StepsGoalResult';
  /** An ISO formatted date string. */
  date: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  stepCount?: Maybe<Scalars['Int']['output']>;
  stepGoal?: Maybe<Scalars['Int']['output']>;
};

export type StepsSample = {
  __typename?: 'StepsSample';
  id: Scalars['ID']['output'];
  steps: Scalars['Int']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StripeAccount = {
  __typename?: 'StripeAccount';
  publicKey?: Maybe<Scalars['String']['output']>;
};

export type StripeSetupIntent = {
  __typename?: 'StripeSetupIntent';
  clientSecret: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type SubmitConsultationQuestionToPharmacistPayload = {
  __typename?: 'SubmitConsultationQuestionToPharmacistPayload';
  consultation?: Maybe<Consultation>;
};

export type SubmitLevelTreeActionInput = {
  actionId: Scalars['ID']['input'];
};

export type SubmitLevelTreeActionPayload = {
  __typename?: 'SubmitLevelTreeActionPayload';
  completedAction?: Maybe<LevelTreeAction>;
  completedActionGoal?: Maybe<LevelTreeGoal>;
  completedActionLevel?: Maybe<LevelTreeLevel>;
  pillar?: Maybe<LevelTreePillar>;
  result: SubmitLevelTreeActionResult;
};

export type SubmitLevelTreeActionResult =
  | 'ACTION_COMPLETED'
  | 'ACTION_IN_PROGRESS'
  | 'GOAL_COMPLETED'
  | 'LEVEL_COMPLETED'
  | 'PILLAR_COMPLETED';

export type SubmittedQuizApplicationInstance = {
  __typename?: 'SubmittedQuizApplicationInstance';
  id: Scalars['String']['output'];
  quizCode: Scalars['String']['output'];
  responses?: Maybe<Array<QuizResponse>>;
  submittedAt: Scalars['DateTime']['output'];
};

export type SubscriptionLineItem = {
  __typename?: 'SubscriptionLineItem';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  productId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  subscriptionPlanId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SubscriptionOrder = {
  __typename?: 'SubscriptionOrder';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  order: Order;
  status: SubscriptionOrderStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type SubscriptionOrderStatus =
  | 'CANCELED'
  | 'COMPLETED'
  | 'CREATED'
  | 'PAYMENT_FAILED'
  | 'PROCESSING';

export type SubscriptionPlan = {
  __typename?: 'SubscriptionPlan';
  active: Scalars['Boolean']['output'];
  amount?: Maybe<Scalars['Int']['output']>;
  cancelAt?: Maybe<Scalars['DateTime']['output']>;
  cancelAtPeriodEnd: Scalars['Boolean']['output'];
  currentPeriodEnd: Scalars['DateTime']['output'];
  currentPeriodStart: Scalars['DateTime']['output'];
  daysUntilDue?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  interval: Scalars['String']['output'];
  intervalCount: Scalars['Int']['output'];
  product?: Maybe<Product>;
  sku?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
};

export type SubscriptionPlanInterval =
  | 'DAYS'
  | 'MONTHS';

export type SubscriptionPlanV2 = {
  __typename?: 'SubscriptionPlanV2';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  interval: SubscriptionPlanInterval;
  intervalCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  photo: File;
  price: Scalars['Int']['output'];
  subscriptionLineItems: Array<SubscriptionLineItem>;
};

export type SubscriptionStatus =
  | 'ACTIVE'
  | 'CANCELED'
  | 'CREATED'
  | 'PAYMENT_FAILED'
  | 'PROCESSING';

export type SubscriptionV2 = {
  __typename?: 'SubscriptionV2';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  nextPaymentAt?: Maybe<Scalars['DateTime']['output']>;
  status: SubscriptionStatus;
  subscriptionOrders?: Maybe<Array<SubscriptionOrder>>;
  subscriptionPlan: SubscriptionPlanV2;
  subscriptionPlanId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};


export type SubscriptionV2SubscriptionOrdersArgs = {
  pagination?: InputMaybe<Pagination>;
};

/** Represents a set of suggested offering selection changes due to a doctor prescribing a sequence outside of the original offering selection or a differently priced sequence within the original selection. */
export type SubstitutePurchasePrompt = PurchasePrompt & {
  __typename?: 'SubstitutePurchasePrompt';
  id: Scalars['ID']['output'];
  /** This should be provided to Query.initialPurchasePrice and Mutation.purchaseOfferings to override the previous purchase group associated with this pricing session. */
  pricingSessionId: Scalars['ID']['output'];
  substitutions?: Maybe<Array<PurchaseSubstitution>>;
};

export type SupportedLanguages =
  | 'DE'
  | 'EN_AU'
  | 'EN_GB'
  | 'JA';

export type SwitchCandidate = {
  __typename?: 'SwitchCandidate';
  advertisedCadencePricingDelta?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  offering?: Maybe<AddOnOffering | OtcOffering | RxOffering>;
};

export type SwitchPrescribedSequenceInput = {
  consultationParameters: ConsultationParametersInput;
  /** An ISO formatted date string representing the earliest date a prescribed sequence can begin. */
  minimumStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  scriptParameters: ScriptParametersInput;
  sequenceId: Scalars['ID']['input'];
  undergoingWeightMaintenance?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SwitchPrescribedSequencePayload = {
  __typename?: 'SwitchPrescribedSequencePayload';
  consultation: Consultation;
};

export type SwitchPurchasedOfferingInput = {
  offeringSelection: OfferingSelectionInput;
  purchaseId: Scalars['ID']['input'];
};

export type SwitchPurchasedOfferingPayload = {
  __typename?: 'SwitchPurchasedOfferingPayload';
  newPurchase: Purchase;
  oldPurchase: Purchase;
};

export type SyncGroupTimelineItem = {
  __typename?: 'SyncGroupTimelineItem';
  /** Products are sorted by quantity descending */
  addonProducts?: Maybe<Array<SyncGroupTimelineItemProduct>>;
  date: Scalars['DateTime']['output'];
  discountAmount: MonetaryAmount;
  discounts: Array<Discount>;
  id: Scalars['ID']['output'];
  preDiscountTotalAmount: MonetaryAmount;
  /** Products are sorted by type and quantity descending with RX products appearing first */
  products?: Maybe<Array<SyncGroupTimelineItemProduct>>;
  status: SyncGroupTimelineItemStatus;
  totalAmount: MonetaryAmount;
};

export type SyncGroupTimelineItemProduct = {
  __typename?: 'SyncGroupTimelineItemProduct';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  type: ProductType;
};

export type SyncGroupTimelineItemStatus =
  | 'FULFILLED'
  | 'PLACED'
  | 'UPCOMING';

export type TargetType =
  | 'CONSULTATION'
  | 'CUSTOMER'
  | 'NOTE';

export type Thumbnail = {
  __typename?: 'Thumbnail';
  height?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

/** Time intervals that can be used in offerings and sequences */
export type TimeInterval =
  | 'DAYS'
  | 'HOURS'
  | 'MONTHS';

export type TimedObservation = {
  __typename?: 'TimedObservation';
  id: Scalars['ID']['output'];
  timestamp: Scalars['DateTime']['output'];
  waistValue?: Maybe<Scalars['Float']['output']>;
  weightValue?: Maybe<Scalars['Float']['output']>;
};

export type TotalConsultations = {
  __typename?: 'TotalConsultations';
  count?: Maybe<Scalars['Int']['output']>;
};

export type TrackWaistCmV2Input = {
  date: Scalars['DateTime']['input'];
  waistCm: Scalars['Float']['input'];
};

export type TrackWaistCmV2Payload = {
  __typename?: 'TrackWaistCmV2Payload';
  tracking?: Maybe<WeightLossTracker>;
};

export type TrackWeightKgInputMethod =
  | 'MANUAL'
  | 'SCALE';

export type TrackWeightKgV2Input = {
  /** This field is no longer respected and will be removed soon. */
  date?: InputMaybe<Scalars['DateTime']['input']>;
  inputMethod: TrackWeightKgInputMethod;
  weightKg: Scalars['Float']['input'];
};

export type TrackWeightLossKgV2Payload = {
  __typename?: 'TrackWeightLossKgV2Payload';
  tracking?: Maybe<WeightLossTracker>;
};

export type TrackWeightLossPayload = {
  __typename?: 'TrackWeightLossPayload';
  tracking?: Maybe<WeightLossTracker>;
};

export type TrackerDetails = {
  __typename?: 'TrackerDetails';
  bodyWeight?: Maybe<Scalars['Float']['output']>;
  bodyWeightMeta?: Maybe<TrackerMeta>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  photoBack?: Maybe<Scalars['String']['output']>;
  photoCenter?: Maybe<Scalars['String']['output']>;
  photoFront?: Maybe<Scalars['String']['output']>;
  photoLeft?: Maybe<Scalars['String']['output']>;
  photoRight?: Maybe<Scalars['String']['output']>;
  photoTop?: Maybe<Scalars['String']['output']>;
  quizResponses?: Maybe<Array<SubmittedQuizApplicationInstance>>;
  skinConfidence?: Maybe<Scalars['String']['output']>;
  skinConfidenceMeta?: Maybe<TrackerMeta>;
  skinPhotosMeta?: Maybe<TrackerMeta>;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  waistSize?: Maybe<Scalars['Float']['output']>;
  waistSizeMeta?: Maybe<TrackerMeta>;
};

export type TrackerField = {
  __typename?: 'TrackerField';
  id: Scalars['ID']['output'];
  weightLoss: WeightLossTracker;
};

export type TrackerMeta = {
  __typename?: 'TrackerMeta';
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  observationId: Scalars['ID']['output'];
  overrides?: Maybe<Array<TrackerDetails>>;
};

export type Treatment = {
  __typename?: 'Treatment';
  active: Scalars['Boolean']['output'];
  canPause: Scalars['Boolean']['output'];
  canRefill: Scalars['Boolean']['output'];
  canReschedule: Scalars['Boolean']['output'];
  canReview: Scalars['Boolean']['output'];
  canceledAt?: Maybe<Scalars['DateTime']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  consultation?: Maybe<Consultation>;
  cooldownActiveUntil?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customer: User;
  customerId: Scalars['String']['output'];
  customerStatedTreatmentStartedAt?: Maybe<Scalars['DateTime']['output']>;
  experimentAvailablePaymentPlans: Array<ExperimentAvailablePaymentPlan>;
  experimentPaymentPlan?: Maybe<ExperimentTreatmentPaymentPlan>;
  followupConsultations: Array<Consultation>;
  /** @deprecated No longer used */
  hadPaymentInLast14Days?: Maybe<Scalars['String']['output']>;
  hasPendingFollowUpReminder: Scalars['Boolean']['output'];
  hasScriptExpired: Scalars['Boolean']['output'];
  hasUnfulfilledOrder: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isLastOrderUnfulfilled: Scalars['Boolean']['output'];
  isProcessingPayment: Scalars['Boolean']['output'];
  nextPayment?: Maybe<Scalars['DateTime']['output']>;
  nextPaymentAmount?: Maybe<Scalars['Int']['output']>;
  nextScheduledDate?: Maybe<Scalars['DateTime']['output']>;
  orders: Array<Order>;
  otcSchedules: Array<OtcSchedule>;
  pausedAt?: Maybe<Scalars['DateTime']['output']>;
  pendingFollowUpReminderDate?: Maybe<Scalars['DateTime']['output']>;
  plan?: Maybe<Plan>;
  planId?: Maybe<Scalars['String']['output']>;
  product: Product;
  productId: Scalars['String']['output'];
  refills: Scalars['Int']['output'];
  refillsLeft?: Maybe<Scalars['Int']['output']>;
  script?: Maybe<Script>;
  scriptId?: Maybe<Scalars['String']['output']>;
  status: TreatmentStatus;
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  supersededByFlexiPlans?: Maybe<Scalars['Boolean']['output']>;
  treatmentDiscount?: Maybe<TreatmentDiscount>;
  type: ProblemType;
  updatedAt: Scalars['DateTime']['output'];
  weightTreatmentCategory?: Maybe<WeightTreatmentCategory>;
};


export type TreatmentFollowupConsultationsArgs = {
  orderBy?: InputMaybe<Array<ConsultationOrderByInput>>;
};


export type TreatmentOrdersArgs = {
  orderBy?: InputMaybe<Array<OrderOrderByInput>>;
};


export type TreatmentOtcSchedulesArgs = {
  where?: InputMaybe<OtcSchedulesWhereInput>;
};

export type TreatmentDiscount = {
  __typename?: 'TreatmentDiscount';
  createdAt: Scalars['DateTime']['output'];
  discountCode?: Maybe<DiscountCode>;
  discountId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  treatmentId: Scalars['String']['output'];
};

export type TreatmentLog = {
  __typename?: 'TreatmentLog';
  data?: Maybe<Scalars['Json']['output']>;
  event?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  status?: Maybe<TreatmentStatus>;
  treatment?: Maybe<Treatment>;
  treatmentId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']['output']>;
};

export type TreatmentOrderByInput = {
  canceledAt?: InputMaybe<SortOrder>;
  completedAt?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pausedAt?: InputMaybe<SortOrder>;
  planId?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  refills?: InputMaybe<SortOrder>;
  scriptId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  stripeSubscriptionId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type TreatmentResponses = {
  __typename?: 'TreatmentResponses';
  consultation: Consultation;
};

export type TreatmentReviewCategory =
  | 'cancelReview'
  | 'checkInQuiz'
  | 'helpOrder'
  | 'helpPayment'
  | 'ineffective'
  | 'medicalQuestion'
  | 'medicationInteraction'
  | 'modifyDosage'
  | 'other'
  | 'pausedState'
  | 'sideEffects'
  | 'skincareRoutineQuestion'
  | 'treatmentChanges';

export type TreatmentStatus =
  | 'ACTIVE'
  | 'AWAITING_VERIFY_ID'
  | 'CANCELED'
  | 'COMPLETED'
  | 'CREATED'
  | 'FOLLOW_UP'
  | 'MIGRATED'
  | 'PAUSED'
  | 'PAYMENT_FAILED'
  | 'PROCESSING_ORDER'
  | 'PROCESSING_PAYMENT'
  | 'REVIEW';

export type TreatmentWhereInput = {
  type?: InputMaybe<EnumProblemTypeFilter>;
};

export type Trend = {
  __typename?: 'Trend';
  addressedBy?: Maybe<User>;
  body?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  startedAt: Scalars['DateTime']['output'];
  subtext: Scalars['String']['output'];
};

export type TriggerPasswordResetPayload = {
  __typename?: 'TriggerPasswordResetPayload';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type TryingStatusType =
  | 'ACTIVE'
  | 'FUTURE'
  | 'PERSISTING';

export type UnitSystem =
  | 'IMPERIAL'
  | 'METRIC';

export type UnsignedPrescription = {
  __typename?: 'UnsignedPrescription';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  patientFullName: Scalars['String']['output'];
  patientId: Scalars['String']['output'];
  problemType: ProblemType;
  unsignedScriptFileUrl: Scalars['String']['output'];
};

export type UnsubmitLevelTreeActionInput = {
  actionId: Scalars['ID']['input'];
};

export type UnsubmitLevelTreeActionPayload = {
  __typename?: 'UnsubmitLevelTreeActionPayload';
  action?: Maybe<LevelTreeAction>;
};

export type UpcomingOrderLineItem = {
  __typename?: 'UpcomingOrderLineItem';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
};

export type UpdateChatThreadStatusPayload = {
  __typename?: 'UpdateChatThreadStatusPayload';
  chatThread?: Maybe<ChatThread>;
};

export type UpdateNotificationPrefsPayload = {
  __typename?: 'UpdateNotificationPrefsPayload';
  user?: Maybe<User>;
};

export type UpdateWearableIntegrationInput = {
  activityBackfillTriggeredAt?: InputMaybe<Scalars['DateTime']['input']>;
  bodyMeasurementBackfillTriggeredAt?: InputMaybe<Scalars['DateTime']['input']>;
  dailyMeasurementBackfillTriggeredAt?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
};

export type UpdateWearableIntegrationPayload = {
  __typename?: 'UpdateWearableIntegrationPayload';
  wearableIntegration: WearableIntegration;
};

export type UpsertDvaFileNumberInput = {
  customerId: Scalars['ID']['input'];
  dvaFileNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertDvaFileNumberPayload = {
  __typename?: 'UpsertDvaFileNumberPayload';
  user?: Maybe<User>;
};

export type UpsertNoteInput = {
  body: Scalars['String']['input'];
  domain: NoteDomain;
  noteId: Scalars['ID']['input'];
  targetId: Scalars['ID']['input'];
  targetType: TargetType;
};

export type UpsertNotePayload = {
  __typename?: 'UpsertNotePayload';
  note?: Maybe<ConsultationNote | CustomerNote | MetaNote>;
};

export type UpsertPractitionerBookingInput = {
  bookingId?: InputMaybe<Scalars['ID']['input']>;
  consultationId: Scalars['ID']['input'];
  endWindowId?: InputMaybe<Scalars['ID']['input']>;
  startWindowId: Scalars['ID']['input'];
};

export type UpsertPractitionerBookingPayload = {
  __typename?: 'UpsertPractitionerBookingPayload';
  consultation: Consultation;
};

export type User = {
  __typename?: 'User';
  acuityId?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Address>;
  archivedQuizApplications?: Maybe<Array<QuizApplication>>;
  avatar?: Maybe<File>;
  avgCheckInSatisfactionRating?: Maybe<Scalars['Float']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  birthday?: Maybe<Scalars['String']['output']>;
  bmiProgress?: Maybe<ProgressDelta>;
  /** Whether the user should be prompted to go through the journey start flow */
  canStartWeightLossJourney?: Maybe<Scalars['Boolean']['output']>;
  chatThreads?: Maybe<Array<ChatThread>>;
  checkInResponses?: Maybe<Array<CheckInResponse>>;
  completedConsultationTypes?: Maybe<Array<Maybe<ProblemType>>>;
  /** Orders which have reached a terminal state */
  completedOrders?: Maybe<Array<Maybe<CustomerOrder>>>;
  condition?: Maybe<Condition>;
  consultationQuestionAttachments?: Maybe<Array<ConsultationQuestionAttachment>>;
  consultations: Array<Consultation>;
  currentWeightValueKg?: Maybe<Scalars['Float']['output']>;
  defaultPaymentGateway?: Maybe<PaymentGateway>;
  /** Australia only: unique identifier issued by the Department of Veterans' Affairs (DVA) */
  dvaFileNumber?: Maybe<Scalars['String']['output']>;
  /** List of education programs this user has access to */
  educationPrograms?: Maybe<Array<EducationProgram>>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  fullClinicianName: Scalars['String']['output'];
  fullName?: Maybe<Scalars['String']['output']>;
  hasEdTreatment?: Maybe<Scalars['Boolean']['output']>;
  hasHairTreatment?: Maybe<Scalars['Boolean']['output']>;
  hasPaidMasterclass?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated User.zip should be used to indicate if a user has zip. */
  hasZip?: Maybe<Scalars['Boolean']['output']>;
  headlines?: Maybe<Array<Headline>>;
  healthCareDetails?: Maybe<HealthCareDetails>;
  healthcareIdentifierMedicare?: Maybe<HealthcareIdentifierMedicare>;
  id: Scalars['String']['output'];
  /** Orders that have been created but not yet reached a terminal state */
  inFlightOrders?: Maybe<Array<Maybe<CustomerOrder>>>;
  inSegment?: Maybe<Scalars['Boolean']['output']>;
  individualHealthcareIdentifier?: Maybe<IndividualHealthcareIdentifier>;
  initialWeightTrackedDate?: Maybe<Scalars['DateTime']['output']>;
  initialWeightValueKg?: Maybe<Scalars['Float']['output']>;
  isAvailable?: Maybe<Scalars['Boolean']['output']>;
  /** User is considered to be treated if they have an active Treatment or Purchased Offerings for the given problem type */
  isBeingTreated?: Maybe<Scalars['Boolean']['output']>;
  isConnectedToStripe?: Maybe<Scalars['Boolean']['output']>;
  isPasswordSet: Scalars['Boolean']['output'];
  isVerified?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  legalFirstName?: Maybe<Scalars['String']['output']>;
  legalFullName?: Maybe<Scalars['String']['output']>;
  legalLastName?: Maybe<Scalars['String']['output']>;
  levelTrees?: Maybe<Array<LevelTree>>;
  lgaEnabled?: Maybe<Scalars['Boolean']['output']>;
  medicalProfile: MedicalProfile;
  memberships: Array<Membership>;
  /** This user can access the mobile app because we have record of past payments for weight loss products or services. */
  mobileAppAccess?: Maybe<MobileAppAccess>;
  mostRecentCheckInDate?: Maybe<Scalars['DateTime']['output']>;
  mostRecentCheckInSatisfactionRating?: Maybe<Scalars['Int']['output']>;
  mostRecentWeightTrackedDate?: Maybe<Scalars['DateTime']['output']>;
  needsSubscriptionMigration?: Maybe<Scalars['Boolean']['output']>;
  /** The next order containing Rx products due to be processed for a given user */
  nextRxOrder?: Maybe<NextRxCustomerOrder>;
  notificationPrefs?: Maybe<NotificationPrefs>;
  openTrends?: Maybe<Array<Trend>>;
  orders: Array<Order>;
  patientOrders?: Maybe<Array<PatientOrder>>;
  /** @deprecated Use savedPaymentMethods instead */
  paymentMethods?: Maybe<Array<Maybe<PaymentMethod>>>;
  phone?: Maybe<Scalars['String']['output']>;
  plugRecommendations?: Maybe<Array<PlugRecommendation>>;
  preferredName?: Maybe<Scalars['String']['output']>;
  preferredUnitSystem?: Maybe<UnitSystem>;
  provider?: Maybe<Provider>;
  purchases?: Maybe<Array<Purchase>>;
  quizApplications?: Maybe<Array<QuizApplication>>;
  referralCode?: Maybe<Scalars['String']['output']>;
  referralUrl?: Maybe<Scalars['String']['output']>;
  residentialAddress?: Maybe<ResidentialAddress>;
  roger: Scalars['String']['output'];
  role: UserRole;
  roles?: Maybe<Array<Role>>;
  savedPaymentMethods?: Maybe<Array<Maybe<SavedCardPaymentMethod | SavedPayPalPaymentMethod | SavedSofortPaymentMethod | SavedZipPaymentMethod>>>;
  shortAddressableName?: Maybe<Scalars['String']['output']>;
  shortClinicianName: Scalars['String']['output'];
  /** Whether the user should be prompted to submit their goal weight */
  shouldSubmitGoalWeight?: Maybe<Scalars['Boolean']['output']>;
  subscriptions?: Maybe<Array<SubscriptionV2>>;
  timedObservations?: Maybe<Array<TimedObservation>>;
  tracker?: Maybe<TrackerField>;
  trackingCountPerWeek?: Maybe<Scalars['Float']['output']>;
  trackingCountTotal?: Maybe<Scalars['Int']['output']>;
  treatments?: Maybe<Array<Treatment>>;
  trends?: Maybe<Array<Trend>>;
  uncompletedConsultationTypes?: Maybe<Array<Maybe<ProblemType>>>;
  videoProgresses: Array<VideoProgress>;
  waistProgress?: Maybe<ProgressDelta>;
  wearableIntegrations?: Maybe<Array<WearableIntegration>>;
  weightLossJourneyStartDate?: Maybe<WeightLossJourneyStartDate>;
  weightProgress?: Maybe<ProgressDelta>;
  /** Category of medication used for weight loss treatment. Informed by flexi-plans purchases if a patient has made one, or legacy treatments otherwise. */
  weightTreatmentCategory?: Maybe<WeightTreatmentCategory>;
  /** Web app URL with weight treatment notes */
  weightTreatmentNotesUrl?: Maybe<Scalars['String']['output']>;
  /** Web app URL with weight treatment overview */
  weightTreatmentPlanUrl?: Maybe<Scalars['String']['output']>;
  weightTreatmentStatus?: Maybe<WeightTreatmentStatus>;
  zip?: Maybe<Zip>;
};


export type UserArchivedQuizApplicationsArgs = {
  problemType?: InputMaybe<ProblemType>;
  purpose: QuizPurpose;
};


export type UserConditionArgs = {
  problemType: ProblemType;
};


export type UserConsultationsArgs = {
  orderBy?: InputMaybe<Array<ConsultationOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ConsultationWhereInput>;
};


export type UserInSegmentArgs = {
  segmentName: Segment;
};


export type UserIsBeingTreatedArgs = {
  problemType: ProblemType;
};


export type UserMedicalProfileArgs = {
  problemType?: InputMaybe<ProblemType>;
};


export type UserOrdersArgs = {
  orderBy?: InputMaybe<Array<OrderOrderByInput>>;
  where?: InputMaybe<OrderWhereInput>;
};


export type UserQuizApplicationsArgs = {
  purpose?: InputMaybe<QuizPurpose>;
};


export type UserTreatmentsArgs = {
  where?: InputMaybe<UserTreatmentWhereInput>;
};

export type UserChatThreadCount = {
  __typename?: 'UserChatThreadCount';
  counts?: Maybe<Array<ChatThreadCount>>;
  id: Scalars['ID']['output'];
  user?: Maybe<User>;
};

export type UserChatThreadPriorityCount = {
  __typename?: 'UserChatThreadPriorityCount';
  counts?: Maybe<Array<ChatThreadPriorityCount>>;
  id: Scalars['ID']['output'];
  user?: Maybe<User>;
};

export type UserChatThreadStatusCount = {
  __typename?: 'UserChatThreadStatusCount';
  counts?: Maybe<Array<ChatThreadStatusCount>>;
  id: Scalars['ID']['output'];
  user?: Maybe<User>;
};

export type UserNominatedMedicationPreference = {
  __typename?: 'UserNominatedMedicationPreference';
  createdAt: Scalars['DateTime']['output'];
  medicationSkuPrefix: Scalars['String']['output'];
  type: ProblemType;
  userId: Scalars['String']['output'];
};

export type UserRole =
  | 'CUSTOMER'
  | 'DOCTOR'
  | 'HEALTH_COACH'
  | 'PHARMACY'
  | 'SUPERADMIN';

export type UserStatedCallResult =
  | 'ANSWERED'
  | 'MANUAL_CONFIRMATION'
  | 'VOICEMAIL';

export type UserTreatmentWhereInput = {
  problemType?: InputMaybe<ProblemType>;
};

export type ValidPhoneRegion = {
  __typename?: 'ValidPhoneRegion';
  countryCode: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type Variant = {
  __typename?: 'Variant';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  inventory?: Maybe<VariantInventory>;
  isRefill: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  price: Scalars['Int']['output'];
  product: Product;
  productId: Scalars['String']['output'];
  public: Scalars['Boolean']['output'];
  shopifyVariantId?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type VariantInventory = {
  __typename?: 'VariantInventory';
  canPurchaseOutOfStock?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  quantity?: Maybe<Scalars['Int']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type VariantInventoryWhereInput = {
  sku?: InputMaybe<StringNullableFilter>;
};

export type VariantLevelTreeGoalTemplate = LevelTreeGoalTemplate & {
  __typename?: 'VariantLevelTreeGoalTemplate';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Actions are returned in order of position of position. */
  latestPublishedActions?: Maybe<Array<LevelTreeActionTemplate>>;
  latestPublishedDefaultGoal?: Maybe<DefaultLevelTreeGoalTemplate>;
  name?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  useCase?: Maybe<Scalars['String']['output']>;
};

export type VariantListRelationFilter = {
  some?: InputMaybe<VariantWhereInput>;
};

export type VariantSequenceNode = SequenceNode & {
  __typename?: 'VariantSequenceNode';
  id: Scalars['ID']['output'];
  nextNodeId?: Maybe<Scalars['ID']['output']>;
  price: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  variant?: Maybe<Variant>;
};

export type VariantWhereInput = {
  inventory?: InputMaybe<VariantInventoryWhereInput>;
};

export type VideoContentItem = ContentItem & {
  __typename?: 'VideoContentItem';
  citations?: Maybe<Array<VideoContentItemCitation>>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  durationSeconds: Scalars['Int']['output'];
  elapsedSeconds?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  /** m3u8 */
  playbackUrl: Scalars['String']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: ContentItemStatus;
  tags: Array<ContentTag>;
  thumbnailHash: Scalars['String']['output'];
  thumbnailUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
  viewed?: Maybe<Scalars['Boolean']['output']>;
};

export type VideoContentItemCitation = {
  __typename?: 'VideoContentItemCitation';
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export type VideoProgress = {
  __typename?: 'VideoProgress';
  id: Scalars['String']['output'];
  progressPercentage?: Maybe<Scalars['Float']['output']>;
  user: User;
  userId: Scalars['String']['output'];
  videoId: Scalars['String']['output'];
};

export type VideoWithReadingContentItem = ContentItem & {
  __typename?: 'VideoWithReadingContentItem';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  content: Scalars['Json']['output'];
  description: Scalars['String']['output'];
  durationSeconds: Scalars['Int']['output'];
  elapsedSeconds?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  /** m3u8 */
  playbackUrl: Scalars['String']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: ContentItemStatus;
  tags: Array<ContentTag>;
  thumbnailHash: Scalars['String']['output'];
  thumbnailUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
  viewed?: Maybe<Scalars['Boolean']['output']>;
};

export type ViewedContentItemsInput = {
  pageRequest?: InputMaybe<PageRequestInput>;
};

export type ViewedContentItemsPayload = PaginationPayload & {
  __typename?: 'ViewedContentItemsPayload';
  contentItems?: Maybe<Array<FaqContentItem | ReadingContentItem | RecipeContentItem | VideoContentItem | VideoWithReadingContentItem>>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type WaitSequenceNode = SequenceNode & {
  __typename?: 'WaitSequenceNode';
  count: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  nextNodeId?: Maybe<Scalars['ID']['output']>;
  type: TimeInterval;
};

export type WearableActivityType =
  | 'AEROBICS'
  | 'AMERICAN_FOOTBALL'
  | 'ARCHERY'
  | 'AUSTRALIAN_FOOTBALL'
  | 'BACK_COUNTRY_SKIING'
  | 'BADMINTON'
  | 'BASEBALL'
  | 'BASKETBALL'
  | 'BEACH_VOLLEYBALL'
  | 'BIATHLON'
  | 'BIKING'
  | 'BOXING'
  | 'CALISTHENICS'
  | 'CANOEING'
  | 'CARDIO_TRAINING'
  | 'CIRCUIT_TRAINING'
  | 'CRICKET'
  | 'CROSSFIT'
  | 'CROSS_COUNTRY_SKIING'
  | 'CROSS_SKATING'
  | 'CURLING'
  | 'DANCING'
  | 'DIVING'
  | 'DOWNHILL_SKIING'
  | 'DRIVING'
  | 'ELEVATOR'
  | 'ELLIPTICAL'
  | 'ENDURO'
  | 'ENGLISH_FOOTBALL'
  | 'ERGOMETER'
  | 'ESCALATOR'
  | 'FENCING'
  | 'FISHING'
  | 'FLYING'
  | 'FRISBEE'
  | 'GAELIC_FOOTBALL'
  | 'GARDENING'
  | 'GOLF'
  | 'GUIDED_BREATHING'
  | 'GYMNASTICS'
  | 'HANDBALL'
  | 'HANDBIKING'
  | 'HANG_GLIDING'
  | 'HIIT'
  | 'HIKING'
  | 'HOCKEY'
  | 'HORSEBACK_RIDING'
  | 'HOT_AIR_BALLOONING'
  | 'HOUSEWORK'
  | 'HURLING'
  | 'ICE_SKATING'
  | 'INDOOR_ROLLERBLADING'
  | 'INDOOR_RUNNING'
  | 'INDOOR_SKATING'
  | 'INDOOR_VOLLEYBALL'
  | 'INLINE_SKATING'
  | 'INTERVAL_TRAINING'
  | 'IN_VEHICLE'
  | 'JET_SKIING'
  | 'JOGGING'
  | 'JUMPING_ROPE'
  | 'KAYAKING'
  | 'KETTLEBELL_TRAINING'
  | 'KICKBOXING'
  | 'KITESURFING'
  | 'KITE_SKIING'
  | 'LACROSSE'
  | 'MARTIAL_ARTS'
  | 'MEDITATION'
  | 'MIXED_MARTIAL_ARTS'
  | 'MOTORBIKING'
  | 'MOTOR_RACING'
  | 'MOUNTAINEERING'
  | 'MOUNTAIN_BIKING'
  | 'NORDING_WALKING'
  | 'OFF_ROAD_DRIVING'
  | 'OPEN_WATER_SWIMMING'
  | 'ORIENTEERING'
  | 'OTHER'
  | 'P90X_EXERCISES'
  | 'PADDLING'
  | 'PADEL_TENNIS'
  | 'PARAGLIDING'
  | 'PILATES'
  | 'POLO'
  | 'POWER_BOATING'
  | 'RACQUETBALL'
  | 'ROAD_BIKING'
  | 'ROCK_CLIMBING'
  | 'ROLLER_SKIING'
  | 'ROWING'
  | 'ROWING_MACHINE'
  | 'RUGBY'
  | 'RUNNING'
  | 'RUNNING_ON_SAND'
  | 'SAILING'
  | 'SCUBA_DIVING'
  | 'SKATEBOARDING'
  | 'SKATING'
  | 'SKIING'
  | 'SKY_DIVING'
  | 'SLEDDING'
  | 'SNOWBOARDING'
  | 'SNOWMOBILE'
  | 'SNOWSHOEING'
  | 'SOFTBALL'
  | 'SPINNING'
  | 'SQUASH'
  | 'STAIR_CLIMBING'
  | 'STAIR_CLIMBING_MACHINE'
  | 'STAND_UP_PADDLEBOARDING'
  | 'STATIONARY_BIKING'
  | 'STILL'
  | 'STRENGTH_TRAINING'
  | 'STRETCHING'
  | 'SURFING'
  | 'SWIMMING'
  | 'SWIMMING_IN_POOL'
  | 'TABLE_TENNIS'
  | 'TEAM_SPORT'
  | 'TENNIS'
  | 'TILTING'
  | 'TREADMILL'
  | 'TREADMILL_RUNNING'
  | 'TRIATHLON'
  | 'UNKNOWN'
  | 'UTILITY_BIKING'
  | 'VOLLEYBALL'
  | 'WAKEBOARDING'
  | 'WALKING'
  | 'WALKING_FITNESS'
  | 'WALKING_TREADMILL'
  | 'WALKIN_STROLLER'
  | 'WATERPOLO'
  | 'WATER_SKIING'
  | 'WEIGHTLIFTING'
  | 'WHEELCHAIR'
  | 'WINDSURFING'
  | 'YOGA'
  | 'ZUMBA';

export type WearableIntegration = {
  __typename?: 'WearableIntegration';
  devices?: Maybe<Array<Device>>;
  id: Scalars['ID']['output'];
  lastUpdateAt?: Maybe<Scalars['DateTime']['output']>;
  provider: WearableIntegrationProvider;
  shouldTriggerActivityBackfill: Scalars['Boolean']['output'];
  shouldTriggerBodyMeasurementBackfill: Scalars['Boolean']['output'];
  shouldTriggerDailyMeasurementBackfill: Scalars['Boolean']['output'];
  showIntegrationBackfilling?: Maybe<Scalars['Boolean']['output']>;
  status: WearableIntegrationStatus;
};

export type WearableIntegrationProvider =
  | 'APPLE'
  | 'BIOSTRAP'
  | 'BRYTONSPORT'
  | 'CARDIOMOOD'
  | 'CLUE'
  | 'CONCEPT2'
  | 'COROS'
  | 'CRONOMETER'
  | 'CYCLINGANALYTICS'
  | 'DEXCOM'
  | 'EATTHISMUCH'
  | 'EIGHTSLEEP'
  | 'FATSECRET'
  | 'FINALSURGE'
  | 'FITBIT'
  | 'FREESTYLELIBRE'
  | 'FREESTYLELIBRESDK'
  | 'GARMIN'
  | 'GOOGLE'
  | 'GOOGLEFIT'
  | 'HAMMERHEAD'
  | 'HEALTHGAUGE'
  | 'HUAWEI'
  | 'IFIT'
  | 'INBODY'
  | 'KETOMOJOEU'
  | 'KETOMOJOUS'
  | 'KOMOOT'
  | 'LEZYNE'
  | 'LIVEROWING'
  | 'MACROSFIRST'
  | 'MOXY'
  | 'NOLIO'
  | 'NUTRACHECK'
  | 'OMRON'
  | 'OMRONUS'
  | 'OURA'
  | 'PELOTON'
  | 'POLAR'
  | 'PUL'
  | 'RENPHO'
  | 'RIDEWITHGPS'
  | 'ROUVY'
  | 'SAMSUNG'
  | 'STRAVA'
  | 'SUUNTO'
  | 'TECHNOGYM'
  | 'TEMPO'
  | 'TODAYSPLAN'
  | 'TRAINASONE'
  | 'TRAINERROAD'
  | 'TRAININGPEAKS'
  | 'TRAINXHALE'
  | 'TREDICT'
  | 'TRIDOT'
  | 'UNDERARMOUR'
  | 'VELOHERO'
  | 'VIRTUAGYM'
  | 'WAHOO'
  | 'WGER'
  | 'WHOOP'
  | 'WITHINGS'
  | 'XERT'
  | 'XIAOMI'
  | 'XOSS'
  | 'ZEPP'
  | 'ZWIFT';

export type WearableIntegrationStatus =
  | 'AUTHORIZED'
  | 'DEAUTHORIZED'
  | 'PENDING';

export type WearableSampleSpan =
  | 'DAY'
  | 'HOUR'
  | 'MINUTE';

export type WeightAction =
  | 'CREATE'
  | 'OVERRIDE';

export type WeightConsultationRejectReasonMetaInput = {
  absoluteContraindication: Array<Scalars['String']['input']>;
  appropriateRejectReason?: InputMaybe<Scalars['String']['input']>;
  followupReviewReasons?: InputMaybe<Array<Scalars['String']['input']>>;
  medopsContact?: InputMaybe<Scalars['Boolean']['input']>;
  medopsContactExtended?: InputMaybe<Scalars['String']['input']>;
  nonClinical: Array<Scalars['String']['input']>;
  nonClinicalExtended?: InputMaybe<Scalars['String']['input']>;
  nonPharmacologicalWeightLossTherapy?: InputMaybe<Scalars['Boolean']['input']>;
  primaryRejectReason?: InputMaybe<Scalars['String']['input']>;
  rejectPermanency: Scalars['String']['input'];
  relativeContraindication: Array<Scalars['String']['input']>;
  relativeContraindicationExtended?: InputMaybe<Scalars['String']['input']>;
  temporaryCheckIn?: InputMaybe<Scalars['String']['input']>;
};

export type WeightGoal = {
  __typename?: 'WeightGoal';
  bmi?: Maybe<Scalars['Float']['output']>;
  feedbackType?: Maybe<GoalFeedbackType>;
  id: Scalars['ID']['output'];
  milestones?: Maybe<Array<WeightMilestone>>;
  weightKg?: Maybe<Scalars['Float']['output']>;
};

export type WeightInput = {
  action: WeightAction;
  weightKg: Scalars['Float']['input'];
};

export type WeightLossJourneyStartDate = {
  __typename?: 'WeightLossJourneyStartDate';
  /** The actual start date the user has set via the weight journey quiz */
  date?: Maybe<Scalars['DateTime']['output']>;
  /** Used to prefill the estimated started date derived from a purchase timeline item consumed date or an order fulfilled date, with a buffer to take into account delivery. Returns null if there is no relevant purchase timeline item or first order */
  estimatedDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
};

export type WeightLossJourneyStartInput = {
  startDate: Scalars['DateTime']['input'];
  startWeightKg: Scalars['Float']['input'];
};

export type WeightLossJourneyStartPayload = {
  __typename?: 'WeightLossJourneyStartPayload';
  user: User;
};

export type WeightLossTracker = {
  __typename?: 'WeightLossTracker';
  expectedWeightLoss?: Maybe<Array<DerivedMeasurement>>;
  id: Scalars['ID']['output'];
  lastCheckIn?: Maybe<Scalars['DateTime']['output']>;
  maxGoalWeightKg?: Maybe<Scalars['Float']['output']>;
  minGoalWeightKg?: Maybe<Scalars['Float']['output']>;
  momentum?: Maybe<Scalars['Float']['output']>;
  shouldCompleteCheckIn?: Maybe<Scalars['Boolean']['output']>;
  suggestedGoalBmi?: Maybe<Scalars['Float']['output']>;
  suggestedGoalDurationFromStartingDateSeconds?: Maybe<Scalars['Int']['output']>;
  suggestedGoalWeightKg?: Maybe<Scalars['Float']['output']>;
  waist?: Maybe<Array<ObservedMeasurement>>;
  weight?: Maybe<Array<ObservedMeasurement>>;
  weightGoal?: Maybe<WeightGoal>;
  /** A list of weight observations filtered to only include those that are at or after the start date of the user's weight loss journey */
  weightJourney?: Maybe<Array<ObservedMeasurement>>;
};

export type WeightMilestone = {
  __typename?: 'WeightMilestone';
  achievedAt?: Maybe<Scalars['DateTime']['output']>;
  achievedAtLastWeighIn?: Maybe<Scalars['Boolean']['output']>;
  celebrations?: Maybe<Array<MilestoneCelebration>>;
  completionKg?: Maybe<Scalars['Float']['output']>;
  currentPercentageComplete?: Maybe<Scalars['Float']['output']>;
  historicalMaxPercentageComplete?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  kgUntilCompletion?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  startKg?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<MilestoneWeightStatusType>;
};

export type WeightMilestonePreview = {
  __typename?: 'WeightMilestonePreview';
  celebrations?: Maybe<Array<MilestoneCelebration>>;
  completionKg?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  order?: Maybe<Scalars['Int']['output']>;
};

export type WeightTreatmentCategory =
  | 'compoundedSemaglutide'
  | 'mounjaro'
  | 'ozempic'
  | 'phentop'
  | 'saxenda'
  | 'weightShake';

/** Status representing a patient's weight loss treatment. Informed by a customer's purchases (if any) or legacy treatment otherwise. */
export type WeightTreatmentStatus =
  | 'ACTIVE'
  | 'PAUSED'
  | 'PENDING_PURCHASE';

export type ZendeskQuizOutcome = QuizOutcomeV2 & {
  __typename?: 'ZendeskQuizOutcome';
  id: Scalars['ID']['output'];
};

export type Zip = {
  __typename?: 'Zip';
  valid: Scalars['Boolean']['output'];
};

export type ZipCheckoutResponse = {
  __typename?: 'ZipCheckoutResponse';
  redirectUrl: Scalars['String']['output'];
};

export type ZoomPhoneCallDetails = PhoneCallProviderDetails & {
  __typename?: 'ZoomPhoneCallDetails';
  /** Duration string to be rendered by the frontend e.g. "1 minute, 30 seconds" */
  duration?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  startedRingingAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CompoundMobileAppBannerQueryVariables = Exact<{
  segmentName: Segment;
}>;


export type CompoundMobileAppBannerQuery = { __typename?: 'Query', inSegment?: boolean | null | undefined };

export type CompoundAsyncConsultConfirmedPageQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type CompoundAsyncConsultConfirmedPageQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, type: ProblemType, requiresPrescriberCall: boolean } | null | undefined };

export type CompoundCollectAddressPageQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type CompoundCollectAddressPageQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, type: ProblemType } | null | undefined };

export type CompoundCollectMedicarePageQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type CompoundCollectMedicarePageQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, type: ProblemType, stage: ConsultationStage, canSchedulePractitionerBooking: boolean, quizApplication?: { __typename?: 'QuizApplication', id: string, problemType: ProblemType } | null | undefined } | null | undefined };

export type CompoundAsyncEligibleMedicarePageQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
  problemType: ProblemType;
}>;


export type CompoundAsyncEligibleMedicarePageQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, customer: { __typename?: 'User', id: string, condition?: { __typename?: 'Condition', id: string, asyncEligible?: boolean | null | undefined } | null | undefined } } | null | undefined };

export type CompoundOrderConfirmationPageQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
  segmentName: Segment;
}>;


export type CompoundOrderConfirmationPageQuery = { __typename?: 'Query', inSegment?: boolean | null | undefined, consultation?: { __typename?: 'Consultation', id: string, type: ProblemType, isUpfrontPayment: boolean, doctor?: { __typename?: 'User', id: string, fullName?: string | null | undefined, fullClinicianName: string } | null | undefined } | null | undefined };

export type CompoundConfirmationPageQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type CompoundConfirmationPageQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, type: ProblemType, createdAt: string, stage: ConsultationStage, isApproved?: boolean | null | undefined, isUpfrontPayment: boolean, screeningQuizApplication?: { __typename?: 'QuizApplication', id: string } | null | undefined, customer: { __typename?: 'User', id: string, email: string } } | null | undefined };

export type CompoundConsultationCreateAccountQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
  bnplEnabled: Scalars['Boolean']['input'];
}>;


export type CompoundConsultationCreateAccountQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, type: ProblemType, isUpfrontPayment: boolean, purchasePrompt?: { __typename?: 'ConfirmPurchasePrompt', id: string } | { __typename?: 'FurPurchasePrompt', id: string } | { __typename?: 'InitialPurchasePrompt', id: string } | { __typename?: 'RestartFlowPrompt', id: string } | { __typename?: 'SubstitutePurchasePrompt', id: string } | null | undefined } | null | undefined };

export type GippQueryVariables = Exact<{
  consultationId?: InputMaybe<Scalars['String']['input']>;
  pricingSessionId: Scalars['ID']['input'];
  offeringSelections: Array<OfferingSelectionInput> | OfferingSelectionInput;
}>;


export type GippQuery = { __typename?: 'Query', initialPurchasePrice?: { __typename?: 'InitialPurchasePriceList', id: string, amount: number } | null | undefined };

export type AnytimePurchaseOfferingSelectionFragment = { __typename?: 'OfferingSelection', id: string, offering?: { __typename?: 'AddOnOffering', id: string, friendlyName: string, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, friendlyName: string } | { __typename?: 'PrescribableSequence', id: string, friendlyName: string }> | null | undefined }> | null | undefined } | { __typename?: 'OtcOffering', id: string, friendlyName: string, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, friendlyName: string } | { __typename?: 'PrescribableSequence', id: string, friendlyName: string }> | null | undefined }> | null | undefined } | { __typename?: 'RxOffering', id: string, friendlyName: string, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, friendlyName: string } | { __typename?: 'PrescribableSequence', id: string, friendlyName: string }> | null | undefined }> | null | undefined } | null | undefined, sequenceSelections?: Array<{ __typename?: 'SequenceSelection', id: string, sequence?: { __typename?: 'OtcSequence', id: string, friendlyName: string } | { __typename?: 'PrescribableSequence', id: string, friendlyName: string } | null | undefined, sequenceSet?: { __typename?: 'SequenceSet', id: string } | null | undefined }> | null | undefined };

export type AnytimePurchaseQueryVariables = Exact<{ [key: string]: never; }>;


export type AnytimePurchaseQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, purchases?: Array<{ __typename?: 'Purchase', id: string, status: PurchaseStatus, offering?: { __typename?: 'AddOnOffering', id: string, friendlyName: string } | { __typename?: 'OtcOffering', id: string, friendlyName: string } | { __typename?: 'RxOffering', id: string, friendlyName: string } | null | undefined, contexts?: Array<{ __typename?: 'SequenceContext', id: string, status: SequenceContextStatus }> | null | undefined }> | null | undefined, consultations: Array<{ __typename?: 'Consultation', id: string, purchasePrompt?: { __typename: 'ConfirmPurchasePrompt', id: string } | { __typename: 'FurPurchasePrompt', id: string } | { __typename: 'InitialPurchasePrompt', id: string, proposedOfferingSelection?: { __typename?: 'OfferingSelection', id: string, offering?: { __typename?: 'AddOnOffering', id: string, friendlyName: string, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, friendlyName: string } | { __typename?: 'PrescribableSequence', id: string, friendlyName: string }> | null | undefined }> | null | undefined } | { __typename?: 'OtcOffering', id: string, friendlyName: string, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, friendlyName: string } | { __typename?: 'PrescribableSequence', id: string, friendlyName: string }> | null | undefined }> | null | undefined } | { __typename?: 'RxOffering', id: string, friendlyName: string, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, friendlyName: string } | { __typename?: 'PrescribableSequence', id: string, friendlyName: string }> | null | undefined }> | null | undefined } | null | undefined, sequenceSelections?: Array<{ __typename?: 'SequenceSelection', id: string, sequence?: { __typename?: 'OtcSequence', id: string, friendlyName: string } | { __typename?: 'PrescribableSequence', id: string, friendlyName: string } | null | undefined, sequenceSet?: { __typename?: 'SequenceSet', id: string } | null | undefined }> | null | undefined } | null | undefined } | { __typename: 'RestartFlowPrompt', id: string } | { __typename: 'SubstitutePurchasePrompt', id: string, pricingSessionId: string, substitutions?: Array<{ __typename?: 'PurchaseSubstitution', id: string, purchased: { __typename?: 'Purchase', id: string }, substitution: { __typename?: 'OfferingSelection', id: string, offering?: { __typename?: 'AddOnOffering', id: string, friendlyName: string, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, friendlyName: string } | { __typename?: 'PrescribableSequence', id: string, friendlyName: string }> | null | undefined }> | null | undefined } | { __typename?: 'OtcOffering', id: string, friendlyName: string, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, friendlyName: string } | { __typename?: 'PrescribableSequence', id: string, friendlyName: string }> | null | undefined }> | null | undefined } | { __typename?: 'RxOffering', id: string, friendlyName: string, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, friendlyName: string } | { __typename?: 'PrescribableSequence', id: string, friendlyName: string }> | null | undefined }> | null | undefined } | null | undefined, sequenceSelections?: Array<{ __typename?: 'SequenceSelection', id: string, sequence?: { __typename?: 'OtcSequence', id: string, friendlyName: string } | { __typename?: 'PrescribableSequence', id: string, friendlyName: string } | null | undefined, sequenceSet?: { __typename?: 'SequenceSet', id: string } | null | undefined }> | null | undefined } }> | null | undefined } | null | undefined }> } | null | undefined };

export type AnytimePurchasePurchaseOfferingsMutationVariables = Exact<{
  input: PurchaseOfferingsInput;
}>;


export type AnytimePurchasePurchaseOfferingsMutation = { __typename?: 'Mutation', purchaseOfferings?: { __typename?: 'PurchaseOfferingsPayload', purchaseGroup: { __typename?: 'PurchaseGroup', id: string, purchases?: Array<{ __typename?: 'Purchase', id: string }> | null | undefined } } | null | undefined };

export type CompoundFollowUpConsultationQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type CompoundFollowUpConsultationQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, status: ConsultationStatus, type: ProblemType } | null | undefined };

export type CompoundPracBookingConfirmationPageQueryVariables = Exact<{
  pracBookingId: Scalars['ID']['input'];
}>;


export type CompoundPracBookingConfirmationPageQuery = { __typename?: 'Query', practitionerBooking?: { __typename?: 'PractitionerBooking', id: string, windowStartAt: string, windowEndAt: string, consultation?: { __typename?: 'Consultation', id: string, type: ProblemType } | null | undefined, patient?: { __typename?: 'User', id: string, email: string, phone?: string | null | undefined } | null | undefined } | null | undefined, validPhoneRegions?: Array<{ __typename?: 'ValidPhoneRegion', id: string, countryCode: string }> | null | undefined };

export type CompoundPractitionerPhoneCallPageQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type CompoundPractitionerPhoneCallPageQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, latestPractitionerBooking?: { __typename?: 'PractitionerBooking', id: string } | null | undefined } | null | undefined };

export type CompoundSchedulePhoneCallPageQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type CompoundSchedulePhoneCallPageQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, latestPractitionerBooking?: { __typename?: 'PractitionerBooking', id: string } | null | undefined } | null | undefined };

export type CompoundAccountPageQueryVariables = Exact<{ [key: string]: never; }>;


export type CompoundAccountPageQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, weightTreatmentCategory?: WeightTreatmentCategory | null | undefined, defaultPaymentGateway?: PaymentGateway | null | undefined, email: string, fullName?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, phone?: string | null | undefined, zip?: { __typename?: 'Zip', valid: boolean } | null | undefined, address?: { __typename?: 'Address', id: string, line1?: string | null | undefined, line2?: string | null | undefined, city?: string | null | undefined, postalCode?: string | null | undefined, prefecture?: string | null | undefined, municipality?: string | null | undefined, townArea?: string | null | undefined, state?: string | null | undefined, building?: string | null | undefined, company?: string | null | undefined, country?: string | null | undefined } | null | undefined, savedPaymentMethods?: Array<{ __typename?: 'SavedCardPaymentMethod', expiry: string, mask: string, brand: string, id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | { __typename?: 'SavedPayPalPaymentMethod', email?: string | null | undefined, id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | { __typename?: 'SavedSofortPaymentMethod', id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | { __typename?: 'SavedZipPaymentMethod', valid: boolean, id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | null | undefined> | null | undefined, residentialAddress?: { __typename?: 'ResidentialAddress', id: string, line1: string, line2?: string | null | undefined, city: string, postalCode: string, prefecture?: string | null | undefined, municipality?: string | null | undefined, townArea?: string | null | undefined, state?: string | null | undefined, building?: string | null | undefined, company?: string | null | undefined, country: string } | null | undefined } | null | undefined, validPhoneRegions?: Array<{ __typename?: 'ValidPhoneRegion', id: string, countryCode: string }> | null | undefined };

export type UpdatePasswordMutationVariables = Exact<{
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
}>;


export type UpdatePasswordMutation = { __typename?: 'Mutation', updatePassword?: boolean | null | undefined };

export type CompoundProfilePageQueryVariables = Exact<{ [key: string]: never; }>;


export type CompoundProfilePageQuery = { __typename?: 'Query', completedMobileOnboardingScreens?: boolean | null | undefined, profile?: { __typename?: 'User', id: string, shortAddressableName?: string | null | undefined, needsSubscriptionMigration?: boolean | null | undefined, isBeingTreatedForWeight?: boolean | null | undefined, mobileAppAccess?: { __typename?: 'MobileAppAccess', id: string } | null | undefined, initialQuizApplications?: Array<{ __typename?: 'QuizApplication', id: string, problemType: ProblemType, createdAt: string, archivedAt?: string | null | undefined, submittedAt?: string | null | undefined, outcomes?: Array<{ __typename?: 'ArticleQuizOutcome', id: string } | { __typename?: 'BuyOtcQuizOutcome', id: string } | { __typename?: 'ConsultationQuizOutcome', id: string } | { __typename?: 'IncreaseUsageQuizOutcome', id: string } | { __typename?: 'NotEligibleQuizOutcome', id: string } | { __typename?: 'OtcQuizOutcome', id: string } | { __typename?: 'ReviewQuizOutcome', id: string } | { __typename?: 'SideEffectProactiveActionQuizOutcome', id: string } | { __typename?: 'ZendeskQuizOutcome', id: string }> | null | undefined }> | null | undefined, subscriptionsV2?: Array<{ __typename?: 'SubscriptionV2', id: string, status: SubscriptionStatus, nextPaymentAt?: string | null | undefined, subscriptionPlan: { __typename?: 'SubscriptionPlanV2', id: string, name: string, interval: SubscriptionPlanInterval, intervalCount: number, price: number, photo: { __typename?: 'File', id: string, url: string } } }> | null | undefined, consultations: Array<{ __typename?: 'Consultation', id: string, type: ProblemType, stage: ConsultationStage, createdAt: string, isApproved?: boolean | null | undefined, typeIsFlexi?: boolean | null | undefined, status: ConsultationStatus, practitionerMessagedAt?: string | null | undefined, requiresPrescriberCall: boolean, allowPatientToSendMessageToDoctor: boolean, isInNoPickUpQueue?: boolean | null | undefined, purchasePrompt?: { __typename?: 'ConfirmPurchasePrompt', id: string } | { __typename?: 'FurPurchasePrompt', id: string } | { __typename?: 'InitialPurchasePrompt', id: string } | { __typename?: 'RestartFlowPrompt', id: string } | { __typename?: 'SubstitutePurchasePrompt', id: string } | null | undefined, quizApplication?: { __typename?: 'QuizApplication', id: string, problemType: ProblemType, submittedAt?: string | null | undefined } | null | undefined, treatment?: { __typename?: 'Treatment', id: string, status: TreatmentStatus, active: boolean, pendingFollowUpReminderDate?: string | null | undefined, isLastOrderUnfulfilled: boolean, refillsLeft?: number | null | undefined, nextPayment?: string | null | undefined, canRefill: boolean, nextPaymentAmount?: number | null | undefined, type: ProblemType, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined }, otcSchedules: Array<{ __typename?: 'OtcSchedule', id: string, cadence: OtcScheduleCadence, quantity: number, isActive: boolean, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined, variants: Array<{ __typename?: 'Variant', id: string, price: number }> } }>, plan?: { __typename?: 'Plan', id: string, amount: number } | null | undefined } | null | undefined, pathologyRequests?: Array<{ __typename?: 'PathologyRequest', id: string, customerStatedCollectedAt?: string | null | undefined, result?: { __typename?: 'PathologyResult', id: string } | null | undefined } | null | undefined> | null | undefined, doctor?: { __typename?: 'User', id: string, fullName?: string | null | undefined, fullClinicianName: string } | null | undefined, chatThread?: { __typename?: 'ChatThread', id: string } | null | undefined, prescribedSequence?: { __typename?: 'PrescribedSequence', id: string } | null | undefined, screeningQuizApplication?: { __typename?: 'QuizApplication', id: string, submittedAt?: string | null | undefined } | null | undefined, latestPractitionerBooking?: { __typename?: 'PractitionerBooking', id: string, windowStartAt: string, windowEndAt: string } | null | undefined, reminders?: Array<{ __typename?: 'ConsultationReminder', id: string, canceled: boolean, doneAt?: string | null | undefined, scheduledAt: string }> | null | undefined, patientQuestions?: Array<{ __typename?: 'ConsultationPatientQuestion', id: string, createdAt: string }> | null | undefined }>, purchases?: Array<{ __typename?: 'Purchase', id: string, status: PurchaseStatus, problemType?: ProblemType | null | undefined, isVisibleInProfilePage?: boolean | null | undefined, contexts?: Array<{ __typename?: 'SequenceContext', id: string, status: SequenceContextStatus, consultations?: Array<{ __typename?: 'Consultation', id: string }> | null | undefined, sequence?: { __typename?: 'OtcSequence', id: string, products?: Array<{ __typename?: 'Product', id: string, productType: ProductType }> | null | undefined } | { __typename?: 'PrescribableSequence', id: string, products?: Array<{ __typename?: 'Product', id: string, productType: ProductType }> | null | undefined } | null | undefined }> | null | undefined, orderTimeline?: Array<{ __typename?: 'OrderTimelineItem', id: string, status: OrderTimelineItemStatus }> | null | undefined, offering?: { __typename?: 'AddOnOffering', id: string, friendlyName: string, problemTypes?: Array<ProblemType> | null | undefined } | { __typename?: 'OtcOffering', id: string, friendlyName: string, problemTypes?: Array<ProblemType> | null | undefined } | { __typename?: 'RxOffering', id: string, friendlyName: string, problemTypes?: Array<ProblemType> | null | undefined } | null | undefined, nextOrder?: { __typename?: 'OrderTimelineItem', id: string, date: string, totalAmount: number, products?: Array<{ __typename?: 'Product', id: string, friendlyName?: string | null | undefined, name: string }> | null | undefined } | null | undefined, availableActions?: Array<{ __typename?: 'PurchaseResumeAction', id: string }> | null | undefined }> | null | undefined } | null | undefined, customerAttributes: { __typename?: 'CustomerAttributes', id: string }, subscriptionsV1: Array<{ __typename?: 'SubscriptionPlan', id: string, active: boolean, amount?: number | null | undefined, cancelAt?: string | null | undefined, cancelAtPeriodEnd: boolean, interval: string, intervalCount: number, status: string, currentPeriodEnd: string, product?: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined, photo?: { __typename?: 'File', id: string, url: string } | null | undefined } | null | undefined }> };

export type CompoundProfilePageUserSegmentsFragment = { __typename?: 'Query', completedMobileOnboardingScreens?: boolean | null | undefined };

export type CompoundProfilePageConsultationFragment = { __typename?: 'Consultation', id: string, type: ProblemType, stage: ConsultationStage, createdAt: string, isApproved?: boolean | null | undefined, typeIsFlexi?: boolean | null | undefined, status: ConsultationStatus, practitionerMessagedAt?: string | null | undefined, requiresPrescriberCall: boolean, allowPatientToSendMessageToDoctor: boolean, isInNoPickUpQueue?: boolean | null | undefined, purchasePrompt?: { __typename?: 'ConfirmPurchasePrompt', id: string } | { __typename?: 'FurPurchasePrompt', id: string } | { __typename?: 'InitialPurchasePrompt', id: string } | { __typename?: 'RestartFlowPrompt', id: string } | { __typename?: 'SubstitutePurchasePrompt', id: string } | null | undefined, quizApplication?: { __typename?: 'QuizApplication', id: string, problemType: ProblemType, submittedAt?: string | null | undefined } | null | undefined, treatment?: { __typename?: 'Treatment', id: string, status: TreatmentStatus, active: boolean, pendingFollowUpReminderDate?: string | null | undefined, isLastOrderUnfulfilled: boolean, refillsLeft?: number | null | undefined, nextPayment?: string | null | undefined, canRefill: boolean, nextPaymentAmount?: number | null | undefined, type: ProblemType, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined }, otcSchedules: Array<{ __typename?: 'OtcSchedule', id: string, cadence: OtcScheduleCadence, quantity: number, isActive: boolean, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined, variants: Array<{ __typename?: 'Variant', id: string, price: number }> } }>, plan?: { __typename?: 'Plan', id: string, amount: number } | null | undefined } | null | undefined, pathologyRequests?: Array<{ __typename?: 'PathologyRequest', id: string, customerStatedCollectedAt?: string | null | undefined, result?: { __typename?: 'PathologyResult', id: string } | null | undefined } | null | undefined> | null | undefined, doctor?: { __typename?: 'User', id: string, fullName?: string | null | undefined, fullClinicianName: string } | null | undefined, chatThread?: { __typename?: 'ChatThread', id: string } | null | undefined, prescribedSequence?: { __typename?: 'PrescribedSequence', id: string } | null | undefined, screeningQuizApplication?: { __typename?: 'QuizApplication', id: string, submittedAt?: string | null | undefined } | null | undefined, latestPractitionerBooking?: { __typename?: 'PractitionerBooking', id: string, windowStartAt: string, windowEndAt: string } | null | undefined, reminders?: Array<{ __typename?: 'ConsultationReminder', id: string, canceled: boolean, doneAt?: string | null | undefined, scheduledAt: string }> | null | undefined, patientQuestions?: Array<{ __typename?: 'ConsultationPatientQuestion', id: string, createdAt: string }> | null | undefined };

export type CompoundProfilePagePurchaseFragment = { __typename?: 'Purchase', id: string, status: PurchaseStatus, problemType?: ProblemType | null | undefined, isVisibleInProfilePage?: boolean | null | undefined, contexts?: Array<{ __typename?: 'SequenceContext', id: string, status: SequenceContextStatus, consultations?: Array<{ __typename?: 'Consultation', id: string }> | null | undefined, sequence?: { __typename?: 'OtcSequence', id: string, products?: Array<{ __typename?: 'Product', id: string, productType: ProductType }> | null | undefined } | { __typename?: 'PrescribableSequence', id: string, products?: Array<{ __typename?: 'Product', id: string, productType: ProductType }> | null | undefined } | null | undefined }> | null | undefined, orderTimeline?: Array<{ __typename?: 'OrderTimelineItem', id: string, status: OrderTimelineItemStatus }> | null | undefined, offering?: { __typename?: 'AddOnOffering', id: string, friendlyName: string, problemTypes?: Array<ProblemType> | null | undefined } | { __typename?: 'OtcOffering', id: string, friendlyName: string, problemTypes?: Array<ProblemType> | null | undefined } | { __typename?: 'RxOffering', id: string, friendlyName: string, problemTypes?: Array<ProblemType> | null | undefined } | null | undefined, nextOrder?: { __typename?: 'OrderTimelineItem', id: string, date: string, totalAmount: number, products?: Array<{ __typename?: 'Product', id: string, friendlyName?: string | null | undefined, name: string }> | null | undefined } | null | undefined, availableActions?: Array<{ __typename?: 'PurchaseResumeAction', id: string }> | null | undefined };

export type CompoundProfilePageInitialQuizApplicationFragment = { __typename?: 'QuizApplication', id: string, problemType: ProblemType, createdAt: string, archivedAt?: string | null | undefined, submittedAt?: string | null | undefined, outcomes?: Array<{ __typename?: 'ArticleQuizOutcome', id: string } | { __typename?: 'BuyOtcQuizOutcome', id: string } | { __typename?: 'ConsultationQuizOutcome', id: string } | { __typename?: 'IncreaseUsageQuizOutcome', id: string } | { __typename?: 'NotEligibleQuizOutcome', id: string } | { __typename?: 'OtcQuizOutcome', id: string } | { __typename?: 'ReviewQuizOutcome', id: string } | { __typename?: 'SideEffectProactiveActionQuizOutcome', id: string } | { __typename?: 'ZendeskQuizOutcome', id: string }> | null | undefined };

export type CompoundTreatmentStatusCardQuizApplicationFragment = { __typename?: 'QuizApplication', id: string, submittedAt?: string | null | undefined, problemType: ProblemType, createdAt: string, archivedAt?: string | null | undefined, outcomes?: Array<{ __typename?: 'ArticleQuizOutcome', id: string } | { __typename?: 'BuyOtcQuizOutcome', id: string } | { __typename?: 'ConsultationQuizOutcome', id: string } | { __typename?: 'IncreaseUsageQuizOutcome', id: string } | { __typename?: 'NotEligibleQuizOutcome', id: string } | { __typename?: 'OtcQuizOutcome', id: string } | { __typename?: 'ReviewQuizOutcome', id: string } | { __typename?: 'SideEffectProactiveActionQuizOutcome', id: string } | { __typename?: 'ZendeskQuizOutcome', id: string }> | null | undefined };

export type CompoundTreatmentStatusCardConsultationFragment = { __typename?: 'Consultation', id: string, type: ProblemType, stage: ConsultationStage, createdAt: string, isApproved?: boolean | null | undefined, typeIsFlexi?: boolean | null | undefined, status: ConsultationStatus, practitionerMessagedAt?: string | null | undefined, requiresPrescriberCall: boolean, allowPatientToSendMessageToDoctor: boolean, isInNoPickUpQueue?: boolean | null | undefined, treatment?: { __typename?: 'Treatment', id: string, status: TreatmentStatus, active: boolean, pendingFollowUpReminderDate?: string | null | undefined, isLastOrderUnfulfilled: boolean, refillsLeft?: number | null | undefined, nextPayment?: string | null | undefined, canRefill: boolean, nextPaymentAmount?: number | null | undefined, type: ProblemType, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined }, otcSchedules: Array<{ __typename?: 'OtcSchedule', id: string, cadence: OtcScheduleCadence, quantity: number, isActive: boolean, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined, variants: Array<{ __typename?: 'Variant', id: string, price: number }> } }>, plan?: { __typename?: 'Plan', id: string, amount: number } | null | undefined } | null | undefined, purchasePrompt?: { __typename?: 'ConfirmPurchasePrompt', id: string } | { __typename?: 'FurPurchasePrompt', id: string } | { __typename?: 'InitialPurchasePrompt', id: string } | { __typename?: 'RestartFlowPrompt', id: string } | { __typename?: 'SubstitutePurchasePrompt', id: string } | null | undefined, quizApplication?: { __typename?: 'QuizApplication', id: string, problemType: ProblemType, submittedAt?: string | null | undefined } | null | undefined, pathologyRequests?: Array<{ __typename?: 'PathologyRequest', id: string, customerStatedCollectedAt?: string | null | undefined, result?: { __typename?: 'PathologyResult', id: string } | null | undefined } | null | undefined> | null | undefined, doctor?: { __typename?: 'User', id: string, fullName?: string | null | undefined, fullClinicianName: string } | null | undefined, chatThread?: { __typename?: 'ChatThread', id: string } | null | undefined, prescribedSequence?: { __typename?: 'PrescribedSequence', id: string } | null | undefined, screeningQuizApplication?: { __typename?: 'QuizApplication', id: string, submittedAt?: string | null | undefined } | null | undefined, latestPractitionerBooking?: { __typename?: 'PractitionerBooking', id: string, windowStartAt: string, windowEndAt: string } | null | undefined, reminders?: Array<{ __typename?: 'ConsultationReminder', id: string, canceled: boolean, doneAt?: string | null | undefined, scheduledAt: string }> | null | undefined, patientQuestions?: Array<{ __typename?: 'ConsultationPatientQuestion', id: string, createdAt: string }> | null | undefined };

export type CompoundTreatmentStatusCardTreatmentFragment = { __typename?: 'Treatment', id: string, refillsLeft?: number | null | undefined, nextPayment?: string | null | undefined, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined }, otcSchedules: Array<{ __typename?: 'OtcSchedule', id: string, cadence: OtcScheduleCadence, quantity: number, isActive: boolean, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined } }> };

export type CompoundTreatmentStatusCardPurchaseFragment = { __typename?: 'Purchase', id: string, problemType?: ProblemType | null | undefined, status: PurchaseStatus, isVisibleInProfilePage?: boolean | null | undefined, contexts?: Array<{ __typename?: 'SequenceContext', id: string, status: SequenceContextStatus, consultations?: Array<{ __typename?: 'Consultation', id: string }> | null | undefined, sequence?: { __typename?: 'OtcSequence', id: string, products?: Array<{ __typename?: 'Product', id: string, productType: ProductType }> | null | undefined } | { __typename?: 'PrescribableSequence', id: string, products?: Array<{ __typename?: 'Product', id: string, productType: ProductType }> | null | undefined } | null | undefined }> | null | undefined, orderTimeline?: Array<{ __typename?: 'OrderTimelineItem', id: string, status: OrderTimelineItemStatus }> | null | undefined, offering?: { __typename?: 'AddOnOffering', id: string, friendlyName: string, problemTypes?: Array<ProblemType> | null | undefined } | { __typename?: 'OtcOffering', id: string, friendlyName: string, problemTypes?: Array<ProblemType> | null | undefined } | { __typename?: 'RxOffering', id: string, friendlyName: string, problemTypes?: Array<ProblemType> | null | undefined } | null | undefined, nextOrder?: { __typename?: 'OrderTimelineItem', id: string, date: string, totalAmount: number, products?: Array<{ __typename?: 'Product', id: string, friendlyName?: string | null | undefined, name: string }> | null | undefined } | null | undefined, availableActions?: Array<{ __typename?: 'PurchaseResumeAction', id: string }> | null | undefined };

export type CompoundOtcPurchaseQueryVariables = Exact<{
  offeringSelections: Array<OfferingSelectionInput> | OfferingSelectionInput;
  pricingSessionId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
  userIsAnonymous: Scalars['Boolean']['input'];
  hasOfferingsSelections: Scalars['Boolean']['input'];
  couponCodes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type CompoundOtcPurchaseQuery = { __typename?: 'Query', initialPurchasePrice?: { __typename?: 'InitialPurchasePriceList', id: string, amount: number, originalAmount: number, coupons?: Array<{ __typename?: 'InitialPurchasePriceCoupon', id: string, code: string, outcome: CouponOutcome }> | null | undefined, offeringPriceLists: Array<{ __typename?: 'InitialPurchasePriceOfferingPriceList', id: string, sequencePriceLists: Array<{ __typename?: 'InitialPurchasePriceSequencePriceList', id: string, pricedItems: Array<{ __typename?: 'InitialPurchasePriceSequencePricedItem', id: string, quantity: number, unitPrice: number, unitPriceDiscount: number, variant?: { __typename?: 'Variant', id: string, product: { __typename?: 'Product', id: string, name: string } } | null | undefined }> }>, offering?: { __typename?: 'AddOnOffering', id: string, photoUrl: string, friendlyName: string, advertisedShippingCadence: string } | { __typename?: 'OtcOffering', id: string, photoUrl: string, friendlyName: string, advertisedShippingCadence: string } | { __typename?: 'RxOffering', id: string, photoUrl: string, friendlyName: string, advertisedShippingCadence: string } | null | undefined }> } | null | undefined, profile?: { __typename?: 'User', id: string, email: string, lastName?: string | null | undefined, firstName?: string | null | undefined, address?: { __typename?: 'Address', id: string } | null | undefined, residentialAddress?: { __typename?: 'ResidentialAddress', id: string, city: string, line1: string, line2?: string | null | undefined, state?: string | null | undefined, country: string, postalCode: string, prefecture?: string | null | undefined, municipality?: string | null | undefined, townArea?: string | null | undefined } | null | undefined } | null | undefined };

export type CompoundPurchaseConfirmUpdateUserMutationVariables = Exact<{
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  residentialAddress: ResidentialAddressCreateInput;
}>;


export type CompoundPurchaseConfirmUpdateUserMutation = { __typename?: 'Mutation', updateProfile?: { __typename?: 'User', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined } | null | undefined, updateResidentialAddress?: { __typename?: 'ResidentialAddress', id: string, line1: string, line2?: string | null | undefined, state?: string | null | undefined, country: string, company?: string | null | undefined, building?: string | null | undefined, postalCode: string, city: string } | null | undefined };

export type CompletedPurchasesPageQueryVariables = Exact<{ [key: string]: never; }>;


export type CompletedPurchasesPageQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, email: string, residentialAddress?: { __typename?: 'ResidentialAddress', building?: string | null | undefined, city: string, company?: string | null | undefined, country: string, createdAt: string, id: string, line1: string, line2?: string | null | undefined, municipality?: string | null | undefined, postalCode: string, prefecture?: string | null | undefined, state?: string | null | undefined, townArea?: string | null | undefined, updatedAt: string } | null | undefined } | null | undefined };

export type ConfirmAsyncConsultationMutationVariables = Exact<{
  input: ConfirmAsyncConsultationInput;
}>;


export type ConfirmAsyncConsultationMutation = { __typename?: 'Mutation', confirmAsyncConsultation?: { __typename?: 'ConfirmAsyncConsultationPayload', consultation: { __typename?: 'Consultation', id: string } } | null | undefined };

export type CompoundQuizCompletePageQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type CompoundQuizCompletePageQuery = { __typename?: 'Query', getQuizApplication?: { __typename?: 'QuizApplication', id: string, purpose: QuizPurpose, problemType: ProblemType, quiz: { __typename?: 'Quiz', id: string, default: boolean, quizCode: string }, consultation?: { __typename?: 'Consultation', id: string, status: ConsultationStatus, stage: ConsultationStage, isUpfrontPayment: boolean, requiresPrescriberCall: boolean, canSchedulePractitionerBooking: boolean } | null | undefined, outcomes?: Array<{ __typename?: 'ArticleQuizOutcome', id: string } | { __typename?: 'BuyOtcQuizOutcome', id: string } | { __typename?: 'ConsultationQuizOutcome', id: string } | { __typename?: 'IncreaseUsageQuizOutcome', id: string } | { __typename?: 'NotEligibleQuizOutcome', id: string } | { __typename?: 'OtcQuizOutcome', id: string } | { __typename?: 'ReviewQuizOutcome', id: string } | { __typename?: 'SideEffectProactiveActionQuizOutcome', id: string } | { __typename?: 'ZendeskQuizOutcome', id: string }> | null | undefined } | null | undefined, profile?: { __typename?: 'User', id: string, phone?: string | null | undefined, isPasswordSet: boolean, residentialAddress?: { __typename?: 'ResidentialAddress', id: string } | null | undefined } | null | undefined };

export type CompoundAsyncEligibleQuizCompletePageQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
  problemType: ProblemType;
}>;


export type CompoundAsyncEligibleQuizCompletePageQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, customer: { __typename?: 'User', id: string, condition?: { __typename?: 'Condition', id: string, asyncEligible?: boolean | null | undefined } | null | undefined } } | null | undefined };

export type CompoundStartConfirmProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type CompoundStartConfirmProfileQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, consultations: Array<{ __typename?: 'Consultation', id: string, type: ProblemType, status: ConsultationStatus, isUpfrontPayment: boolean }> } | null | undefined };

export type JuniperMobileAppBannerQueryVariables = Exact<{
  segmentName: Segment;
}>;


export type JuniperMobileAppBannerQuery = { __typename?: 'Query', inSegment?: boolean | null | undefined };

export type ConsultationInfoJuniperEuFragment = { __typename?: 'Consultation', id: string, type: ProblemType, status: ConsultationStatus, isApproved?: boolean | null | undefined, stage: ConsultationStage, isUpfrontPayment: boolean, patientNotes?: string | null | undefined, rejectReason?: string | null | undefined, completedAt?: string | null | undefined, createdAt: string, patientQuestions?: Array<{ __typename?: 'ConsultationPatientQuestion', id: string, createdAt: string, updatedAt: string, value: string }> | null | undefined, treatment?: { __typename?: 'Treatment', id: string, status: TreatmentStatus, refillsLeft?: number | null | undefined, plan?: { __typename?: 'Plan', id: string, amount: number } | null | undefined, otcSchedules: Array<{ __typename?: 'OtcSchedule', id: string, productId: string, createdAt: string, updatedAt: string, cadence: OtcScheduleCadence, isActive: boolean, quantity: number, product: { __typename?: 'Product', id: string, name: string, variants: Array<{ __typename?: 'Variant', id: string, price: number }> } }>, product: { __typename?: 'Product', id: string, name: string, productType: ProductType, safetyInformation?: string | null | undefined, photo?: { __typename?: 'File', id: string, url: string } | null | undefined, cmi?: { __typename?: 'File', id: string, url: string } | null | undefined, plan?: { __typename?: 'Plan', id: string, intervalCount: number, interval: BillingInterval } | null | undefined, faqs: Array<{ __typename?: 'Faq', id: string, title?: string | null | undefined, markdown?: string | null | undefined }>, variants: Array<{ __typename?: 'Variant', id: string, price: number, isRefill: boolean }> } } | null | undefined, customer: { __typename?: 'User', id: string, firstName?: string | null | undefined }, doctorQuestions?: Array<{ __typename?: 'ConsultationQuestion', id: string, createdAt: string, updatedAt: string, value: string, allowedAnswerType: ConsultationAnswerType, answer?: { __typename?: 'ConsultationAnswer', id: string, createdAt: string, updatedAt: string, value: string } | null | undefined }> | null | undefined, doctor?: { __typename?: 'User', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, shortClinicianName: string, fullClinicianName: string, fullName?: string | null | undefined, role: UserRole, bio?: string | null | undefined, avatar?: { __typename?: 'File', id: string, createdAt: string, updatedAt: string, filename: string, mimetype: string, url: string } | null | undefined } | null | undefined, quizApplication?: { __typename?: 'QuizApplication', id: string, answers: Array<{ __typename?: 'QuizApplicationResponse', id: string, answer?: string | null | undefined, answersArray: Array<string>, question?: { __typename?: 'QuizQuestion', id: string, shortcode?: string | null | undefined } | null | undefined }>, quiz: { __typename?: 'Quiz', id: string, questionsOrder: Array<string>, questions: Array<{ __typename?: 'QuizQuestion', id: string, title?: string | null | undefined, type: QuizQuestionType, description?: string | null | undefined, required: boolean, options?: any | null | undefined, imgUrl?: string | null | undefined, shortcode?: string | null | undefined, questionOptions: Array<{ __typename?: 'QuizQuestionOption', id: string, questionId: string, option?: string | null | undefined, position?: number | null | undefined }> }>, logics: Array<{ __typename?: 'QuizLogic', id: string, from: { __typename?: 'QuizQuestion', id: string }, elseJump: { __typename?: 'QuizQuestion', id: string }, jumps: Array<{ __typename?: 'QuizJump', id: string, conditions: Array<{ __typename?: 'QuizConditions', id: string, value: string, operator: QuizJumpOperator, nextCondition?: QuizValidationCondition | null | undefined, question: { __typename?: 'QuizQuestion', id: string } }>, to: { __typename?: 'QuizQuestion', id: string } }> }>, skips: Array<{ __typename?: 'QuizSkip', id: string, from: { __typename?: 'QuizQuestion', id: string }, conditions: Array<{ __typename?: 'QuizConditions', id: string, value: string, operator: QuizJumpOperator, nextCondition?: QuizValidationCondition | null | undefined, question: { __typename?: 'QuizQuestion', id: string } }> }> } } | null | undefined, order?: { __typename?: 'Order', id: string, lineItems?: Array<{ __typename?: 'OrderLineItem', id: string, quantity: number, variant: { __typename?: 'Variant', id: string, price: number, product: { __typename?: 'Product', id: string, name: string, productType: ProductType } } }> | null | undefined } | null | undefined };

export type UpdateResidentialAddressMutationVariables = Exact<{
  residentialAddress: ResidentialAddressCreateInput;
}>;


export type UpdateResidentialAddressMutation = { __typename?: 'Mutation', updateResidentialAddress?: { __typename?: 'ResidentialAddress', id: string } | null | undefined };

export type AddOnsPageProductFragment = { __typename?: 'Product', id: string, name: string, description?: string | null | undefined, priority: number, productType: ProductType, problemTypes: Array<ProblemType>, photo?: { __typename?: 'File', id: string, url: string } | null | undefined, variants: Array<{ __typename?: 'Variant', id: string, price: number, public: boolean, inventory?: { __typename?: 'VariantInventory', id: string, sku?: string | null | undefined } | null | undefined }> };

export type AddOnsPageProductsQueryVariables = Exact<{
  productSKU?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddOnsPageProductsQuery = { __typename?: 'Query', otcProducts: Array<{ __typename?: 'Product', id: string, name: string, description?: string | null | undefined, priority: number, productType: ProductType, problemTypes: Array<ProblemType>, photo?: { __typename?: 'File', id: string, url: string } | null | undefined, variants: Array<{ __typename?: 'Variant', id: string, price: number, public: boolean, inventory?: { __typename?: 'VariantInventory', id: string, sku?: string | null | undefined } | null | undefined }> }>, nutritionSupportProducts: Array<{ __typename?: 'Product', id: string, name: string, description?: string | null | undefined, priority: number, productType: ProductType, problemTypes: Array<ProblemType>, photo?: { __typename?: 'File', id: string, url: string } | null | undefined, variants: Array<{ __typename?: 'Variant', id: string, price: number, public: boolean, inventory?: { __typename?: 'VariantInventory', id: string, sku?: string | null | undefined } | null | undefined }> }> };

export type JuniperAsyncConsultConfirmedPageQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type JuniperAsyncConsultConfirmedPageQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, type: ProblemType, requiresPrescriberCall: boolean } | null | undefined };

export type JuniperCollectAddressPageQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type JuniperCollectAddressPageQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, type: ProblemType } | null | undefined };

export type JuniperCollectMedicarePageQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type JuniperCollectMedicarePageQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, type: ProblemType, stage: ConsultationStage, canSchedulePractitionerBooking: boolean, quizApplication?: { __typename?: 'QuizApplication', id: string, problemType: ProblemType } | null | undefined } | null | undefined };

export type JuniperAsyncEligibleMedicarePageQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
  problemType: ProblemType;
}>;


export type JuniperAsyncEligibleMedicarePageQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, customer: { __typename?: 'User', id: string, condition?: { __typename?: 'Condition', id: string, asyncEligible?: boolean | null | undefined } | null | undefined } } | null | undefined };

export type JuniperOrderConfirmationPageQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
  type: ProblemType;
  segmentName: Segment;
}>;


export type JuniperOrderConfirmationPageQuery = { __typename?: 'Query', inSegment?: boolean | null | undefined, consultation?: { __typename?: 'Consultation', id: string, type: ProblemType, isUpfrontPayment: boolean, doctor?: { __typename?: 'User', id: string, fullName?: string | null | undefined, fullClinicianName: string } | null | undefined } | null | undefined, profile?: { __typename?: 'User', id: string, weightTreatmentCategory?: WeightTreatmentCategory | null | undefined } | null | undefined, treatments?: Array<{ __typename?: 'Treatment', id: string, active: boolean, product: { __typename?: 'Product', id: string, variants: Array<{ __typename?: 'Variant', id: string, isRefill: boolean, inventory?: { __typename?: 'VariantInventory', id: string, sku?: string | null | undefined } | null | undefined }> } }> | null | undefined };

export type JuniperConfirmationPageQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type JuniperConfirmationPageQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, type: ProblemType, createdAt: string, stage: ConsultationStage, isApproved?: boolean | null | undefined, isUpfrontPayment: boolean, screeningQuizApplication?: { __typename?: 'QuizApplication', id: string } | null | undefined, customer: { __typename?: 'User', id: string, email: string } } | null | undefined };

export type ConsultPayConsultationQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ConsultPayConsultationQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, type: ProblemType, stage: ConsultationStage, isUpfrontPayment: boolean, quizApplicationId?: string | null | undefined, price?: { __typename?: 'ConsultationPrice', amountOff: number, fullPrice: number, total: number } | null | undefined } | null | undefined, customerAttributes: { __typename?: 'CustomerAttributes', id: string, menopause: { __typename?: 'CustomerMenopauseAttributes', menopauseSymptoms?: Array<MenopauseSymptoms | null | undefined> | null | undefined } } };

export type JuniperConsultationCreateAccountQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
  bnplEnabled: Scalars['Boolean']['input'];
}>;


export type JuniperConsultationCreateAccountQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, type: ProblemType, isUpfrontPayment: boolean, purchasePrompt?: { __typename?: 'ConfirmPurchasePrompt', id: string } | { __typename?: 'FurPurchasePrompt', id: string } | { __typename?: 'InitialPurchasePrompt', id: string } | { __typename?: 'RestartFlowPrompt', id: string } | { __typename?: 'SubstitutePurchasePrompt', id: string } | null | undefined } | null | undefined };

export type JuniperJpInitialPurchaseConfirmQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
  pricingSessionId: Scalars['ID']['input'];
  offeringSelections: Array<OfferingSelectionInput> | OfferingSelectionInput;
  noSelections: Scalars['Boolean']['input'];
  couponCodes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  proposedOfferingSelectionInput?: InputMaybe<InitialPurchaseProposedOfferingSelectionInput>;
}>;


export type JuniperJpInitialPurchaseConfirmQuery = { __typename?: 'Query', initialPurchasePrice?: { __typename?: 'InitialPurchasePriceList', id: string, amount: number, coupons?: Array<{ __typename?: 'InitialPurchasePriceCoupon', id: string, code: string, outcome: CouponOutcome }> | null | undefined } | null | undefined, validPhoneRegions?: Array<{ __typename?: 'ValidPhoneRegion', id: string, countryCode: string }> | null | undefined, profile?: { __typename?: 'User', id: string, email: string, phone?: string | null | undefined, isPasswordSet: boolean, birthday?: string | null | undefined, defaultPaymentGateway?: PaymentGateway | null | undefined, address?: { __typename?: 'Address', id: string } | null | undefined, residentialAddress?: { __typename?: 'ResidentialAddress', id: string, city: string, line1: string, line2?: string | null | undefined, state?: string | null | undefined, country: string, postalCode: string, prefecture?: string | null | undefined, municipality?: string | null | undefined, townArea?: string | null | undefined } | null | undefined, savedPaymentMethods?: Array<{ __typename?: 'SavedCardPaymentMethod', expiry: string, mask: string, brand: string, id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | { __typename?: 'SavedPayPalPaymentMethod', email?: string | null | undefined, id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | { __typename?: 'SavedSofortPaymentMethod', id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | { __typename?: 'SavedZipPaymentMethod', valid: boolean, id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | null | undefined> | null | undefined, zip?: { __typename?: 'Zip', valid: boolean } | null | undefined } | null | undefined, consultation?: { __typename?: 'Consultation', id: string, type: ProblemType, purchasePrompt?: { __typename?: 'ConfirmPurchasePrompt', id: string } | { __typename?: 'FurPurchasePrompt', id: string } | { __typename?: 'InitialPurchasePrompt', id: string, proposedOfferingSelection?: { __typename?: 'OfferingSelection', id: string, offering?: { __typename?: 'AddOnOffering', id: string, friendlyName: string, photoUrl: string } | { __typename?: 'OtcOffering', id: string, friendlyName: string, photoUrl: string } | { __typename?: 'RxOffering', id: string, friendlyName: string, photoUrl: string } | null | undefined, sequenceSelections?: Array<{ __typename?: 'SequenceSelection', id: string, sequence?: { __typename?: 'OtcSequence', id: string, friendlyName: string, description: string, faqs: Array<{ __typename?: 'SequenceFaq', id: string, rank?: number | null | undefined, question: string, answerMarkdown: string }> } | { __typename?: 'PrescribableSequence', id: string, friendlyName: string, description: string, faqs: Array<{ __typename?: 'SequenceFaq', id: string, rank?: number | null | undefined, question: string, answerMarkdown: string }> } | null | undefined, sequenceSet?: { __typename?: 'SequenceSet', id: string } | null | undefined }> | null | undefined } | null | undefined } | { __typename?: 'RestartFlowPrompt', id: string } | { __typename?: 'SubstitutePurchasePrompt', id: string } | null | undefined } | null | undefined, offeringsTimeline?: Array<{ __typename?: 'PredictedOfferingTimelineItem', id: string, date: string, totalAmount: number, products?: Array<{ __typename?: 'Product', id: string, friendlyName?: string | null | undefined, erxMedicines: Array<{ __typename?: 'ErxMedicine', id?: string | null | undefined, itemForm?: string | null | undefined }> }> | null | undefined }> | null | undefined };

export type JuniperJpInitialPurchaseConfirmUpdateUserMutationVariables = Exact<{
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  birthday?: InputMaybe<Scalars['String']['input']>;
  residentialAddress: ResidentialAddressCreateInput;
}>;


export type JuniperJpInitialPurchaseConfirmUpdateUserMutation = { __typename?: 'Mutation', updateProfile?: { __typename?: 'User', id: string, phone?: string | null | undefined, birthday?: string | null | undefined, isPasswordSet: boolean } | null | undefined, updateResidentialAddress?: { __typename?: 'ResidentialAddress', id: string, line1: string, line2?: string | null | undefined, state?: string | null | undefined, country: string, company?: string | null | undefined, building?: string | null | undefined, postalCode: string, city: string } | null | undefined };

export type FollowUpConsultationJuniperUkQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type FollowUpConsultationJuniperUkQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, type: ProblemType, status: ConsultationStatus, isApproved?: boolean | null | undefined, stage: ConsultationStage, isUpfrontPayment: boolean, patientNotes?: string | null | undefined, rejectReason?: string | null | undefined, completedAt?: string | null | undefined, createdAt: string, patientQuestions?: Array<{ __typename?: 'ConsultationPatientQuestion', id: string, createdAt: string, updatedAt: string, value: string }> | null | undefined, treatment?: { __typename?: 'Treatment', id: string, status: TreatmentStatus, refillsLeft?: number | null | undefined, plan?: { __typename?: 'Plan', id: string, amount: number } | null | undefined, otcSchedules: Array<{ __typename?: 'OtcSchedule', id: string, productId: string, createdAt: string, updatedAt: string, cadence: OtcScheduleCadence, isActive: boolean, quantity: number, product: { __typename?: 'Product', id: string, name: string, variants: Array<{ __typename?: 'Variant', id: string, price: number }> } }>, product: { __typename?: 'Product', id: string, name: string, productType: ProductType, safetyInformation?: string | null | undefined, photo?: { __typename?: 'File', id: string, url: string } | null | undefined, cmi?: { __typename?: 'File', id: string, url: string } | null | undefined, plan?: { __typename?: 'Plan', id: string, intervalCount: number, interval: BillingInterval } | null | undefined, faqs: Array<{ __typename?: 'Faq', id: string, title?: string | null | undefined, markdown?: string | null | undefined }>, variants: Array<{ __typename?: 'Variant', id: string, price: number, isRefill: boolean }> } } | null | undefined, customer: { __typename?: 'User', id: string, firstName?: string | null | undefined }, doctorQuestions?: Array<{ __typename?: 'ConsultationQuestion', id: string, createdAt: string, updatedAt: string, value: string, allowedAnswerType: ConsultationAnswerType, answer?: { __typename?: 'ConsultationAnswer', id: string, createdAt: string, updatedAt: string, value: string } | null | undefined }> | null | undefined, doctor?: { __typename?: 'User', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, shortClinicianName: string, fullClinicianName: string, fullName?: string | null | undefined, role: UserRole, bio?: string | null | undefined, avatar?: { __typename?: 'File', id: string, createdAt: string, updatedAt: string, filename: string, mimetype: string, url: string } | null | undefined } | null | undefined, quizApplication?: { __typename?: 'QuizApplication', id: string, answers: Array<{ __typename?: 'QuizApplicationResponse', id: string, answer?: string | null | undefined, answersArray: Array<string>, question?: { __typename?: 'QuizQuestion', id: string, shortcode?: string | null | undefined } | null | undefined }>, quiz: { __typename?: 'Quiz', id: string, questionsOrder: Array<string>, questions: Array<{ __typename?: 'QuizQuestion', id: string, title?: string | null | undefined, type: QuizQuestionType, description?: string | null | undefined, required: boolean, options?: any | null | undefined, imgUrl?: string | null | undefined, shortcode?: string | null | undefined, questionOptions: Array<{ __typename?: 'QuizQuestionOption', id: string, questionId: string, option?: string | null | undefined, position?: number | null | undefined }> }>, logics: Array<{ __typename?: 'QuizLogic', id: string, from: { __typename?: 'QuizQuestion', id: string }, elseJump: { __typename?: 'QuizQuestion', id: string }, jumps: Array<{ __typename?: 'QuizJump', id: string, conditions: Array<{ __typename?: 'QuizConditions', id: string, value: string, operator: QuizJumpOperator, nextCondition?: QuizValidationCondition | null | undefined, question: { __typename?: 'QuizQuestion', id: string } }>, to: { __typename?: 'QuizQuestion', id: string } }> }>, skips: Array<{ __typename?: 'QuizSkip', id: string, from: { __typename?: 'QuizQuestion', id: string }, conditions: Array<{ __typename?: 'QuizConditions', id: string, value: string, operator: QuizJumpOperator, nextCondition?: QuizValidationCondition | null | undefined, question: { __typename?: 'QuizQuestion', id: string } }> }> } } | null | undefined, order?: { __typename?: 'Order', id: string, lineItems?: Array<{ __typename?: 'OrderLineItem', id: string, quantity: number, variant: { __typename?: 'Variant', id: string, price: number, product: { __typename?: 'Product', id: string, name: string, productType: ProductType } } }> | null | undefined } | null | undefined } | null | undefined };

export type JuniperConsultationPlanQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type JuniperConsultationPlanQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, completedAt?: string | null | undefined, treatment?: { __typename?: 'Treatment', id: string, weightTreatmentCategory?: WeightTreatmentCategory | null | undefined } | null | undefined } | null | undefined };

export type JuniperPracBookingConfirmationPageQueryVariables = Exact<{
  pracBookingId: Scalars['ID']['input'];
}>;


export type JuniperPracBookingConfirmationPageQuery = { __typename?: 'Query', practitionerBooking?: { __typename?: 'PractitionerBooking', id: string, windowStartAt: string, windowEndAt: string, consultation?: { __typename?: 'Consultation', id: string, type: ProblemType } | null | undefined, patient?: { __typename?: 'User', id: string, email: string, phone?: string | null | undefined } | null | undefined } | null | undefined, validPhoneRegions?: Array<{ __typename?: 'ValidPhoneRegion', id: string, countryCode: string }> | null | undefined };

export type JuniperPractitionerPhoneCallPageQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type JuniperPractitionerPhoneCallPageQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, latestPractitionerBooking?: { __typename?: 'PractitionerBooking', id: string } | null | undefined } | null | undefined };

export type JuniperSchedulePhoneCallPageQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type JuniperSchedulePhoneCallPageQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, latestPractitionerBooking?: { __typename?: 'PractitionerBooking', id: string } | null | undefined } | null | undefined };

export type JuniperShippingPageQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type JuniperShippingPageQuery = { __typename?: 'Query', inSegment?: boolean | null | undefined, profile?: { __typename?: 'User', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined, phone?: string | null | undefined, defaultPaymentGateway?: PaymentGateway | null | undefined, email: string, zip?: { __typename?: 'Zip', valid: boolean } | null | undefined, address?: { __typename?: 'Address', id: string, line1?: string | null | undefined, line2?: string | null | undefined, city?: string | null | undefined, postalCode?: string | null | undefined, state?: string | null | undefined, deliveryInstructions?: string | null | undefined } | null | undefined, residentialAddress?: { __typename?: 'ResidentialAddress', id: string, line1: string, line2?: string | null | undefined, city: string, postalCode: string, state?: string | null | undefined } | null | undefined, savedPaymentMethods?: Array<{ __typename?: 'SavedCardPaymentMethod', expiry: string, mask: string, brand: string, id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | { __typename?: 'SavedPayPalPaymentMethod', email?: string | null | undefined, id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | { __typename?: 'SavedSofortPaymentMethod', id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | { __typename?: 'SavedZipPaymentMethod', valid: boolean, id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, consultation?: { __typename?: 'Consultation', id: string, type: ProblemType, typeIsFlexi?: boolean | null | undefined, isUpfrontPayment: boolean, payment?: { __typename?: 'PaymentTransaction', id: string, charge?: { __typename?: 'Charge', id: string, amount: number, createdAt: string } | null | undefined } | null | undefined, order?: { __typename?: 'Order', id: string, lineItems?: Array<{ __typename?: 'OrderLineItem', id: string, quantity: number, variant: { __typename?: 'Variant', id: string, price: number, product: { __typename?: 'Product', id: string, name: string, productType: ProductType, photo?: { __typename?: 'File', id: string, url: string } | null | undefined } } }> | null | undefined } | null | undefined, treatment?: { __typename?: 'Treatment', id: string, status: TreatmentStatus, experimentPaymentPlan?: { __typename?: 'ExperimentTreatmentPaymentPlan', id: string, paymentPlan: ExperimentPaymentPlanVariant, discountPercentage: number } | null | undefined, experimentAvailablePaymentPlans: Array<{ __typename?: 'ExperimentAvailablePaymentPlan', paymentPlan: ExperimentPaymentPlanVariant, discountPercentage: number, months: number }>, plan?: { __typename?: 'Plan', id: string, interval: BillingInterval, intervalCount: number } | null | undefined, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined, shortDescription?: string | null | undefined, deliveryInformation?: string | null | undefined, photo?: { __typename?: 'File', id: string, url: string } | null | undefined, variants: Array<{ __typename?: 'Variant', id: string, isRefill: boolean, price: number, inventory?: { __typename?: 'VariantInventory', id: string, sku?: string | null | undefined } | null | undefined }>, plan?: { __typename?: 'Plan', id: string, interval: BillingInterval, intervalCount: number } | null | undefined }, otcSchedules: Array<{ __typename?: 'OtcSchedule', id: string, cadence: OtcScheduleCadence, quantity: number, isActive: boolean, product: { __typename?: 'Product', id: string } }> } | null | undefined } | null | undefined };

export type TreatmentBreakdownPageQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type TreatmentBreakdownPageQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, weightTreatmentCategory?: WeightTreatmentCategory | null | undefined } | null | undefined, consultation?: { __typename?: 'Consultation', id: string, status: ConsultationStatus, type: ProblemType, patientNotes?: string | null | undefined, doctor?: { __typename?: 'User', id: string, shortClinicianName: string } | null | undefined, treatment?: { __typename?: 'Treatment', id: string, updatedAt: string, weightTreatmentCategory?: WeightTreatmentCategory | null | undefined, product: { __typename?: 'Product', id: string, faqs: Array<{ __typename?: 'Faq', id: string, markdown?: string | null | undefined, title?: string | null | undefined }>, variants: Array<{ __typename?: 'Variant', id: string, inventory?: { __typename?: 'VariantInventory', id: string, sku?: string | null | undefined } | null | undefined }> } } | null | undefined } | null | undefined, customerAttributes: { __typename?: 'CustomerAttributes', id: string, weight?: number | null | undefined } };

export type UpdateProfileCheckoutFormJuniperUkMutationVariables = Exact<{
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  birthday?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateProfileCheckoutFormJuniperUkMutation = { __typename?: 'Mutation', updateProfile?: { __typename?: 'User', id: string } | null | undefined };

export type PayConsultationCheckoutFormJuniperUkMutationVariables = Exact<{
  id: Scalars['String']['input'];
  couponCode?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  gateway?: InputMaybe<PaymentGateway>;
  zipCheckoutId?: InputMaybe<Scalars['String']['input']>;
}>;


export type PayConsultationCheckoutFormJuniperUkMutation = { __typename?: 'Mutation', payConsultation?: { __typename?: 'Consultation', id: string } | null | undefined };

export type JuniperConsultationUpfrontPaymentPageQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type JuniperConsultationUpfrontPaymentPageQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, stage: ConsultationStage, status: ConsultationStatus, type: ProblemType, medicationPreferenceProduct?: { __typename?: 'MedicationPreferenceProducts', id: string, preferredProduct?: { __typename?: 'Product', id: string, erxMedicines: Array<{ __typename?: 'ErxMedicine', id?: string | null | undefined, productName?: string | null | undefined, genericName: string }>, faqs: Array<{ __typename?: 'Faq', id: string, title?: string | null | undefined, markdown?: string | null | undefined }>, variants: Array<{ __typename?: 'Variant', id: string, price: number, isRefill: boolean }>, plan?: { __typename?: 'Plan', id: string, name: string, interval: BillingInterval, intervalCount: number } | null | undefined } | null | undefined, defaultProduct: { __typename?: 'Product', id: string, erxMedicines: Array<{ __typename?: 'ErxMedicine', id?: string | null | undefined, productName?: string | null | undefined, genericName: string }>, faqs: Array<{ __typename?: 'Faq', id: string, title?: string | null | undefined, markdown?: string | null | undefined }>, variants: Array<{ __typename?: 'Variant', id: string, price: number, isRefill: boolean }>, plan?: { __typename?: 'Plan', id: string, name: string, interval: BillingInterval, intervalCount: number } | null | undefined } } | null | undefined } | null | undefined, profile?: { __typename?: 'User', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, email: string, phone?: string | null | undefined, birthday?: string | null | undefined, isPasswordSet: boolean, defaultPaymentGateway?: PaymentGateway | null | undefined, consultations: Array<{ __typename?: 'Consultation', id: string, quizApplication?: { __typename?: 'QuizApplication', id: string } | null | undefined }>, residentialAddress?: { __typename?: 'ResidentialAddress', id: string, line1: string, line2?: string | null | undefined, city: string, state?: string | null | undefined, postalCode: string, country: string } | null | undefined, savedPaymentMethods?: Array<{ __typename?: 'SavedCardPaymentMethod', expiry: string, mask: string, brand: string, id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | { __typename?: 'SavedPayPalPaymentMethod', email?: string | null | undefined, id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | { __typename?: 'SavedSofortPaymentMethod', id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | { __typename?: 'SavedZipPaymentMethod', valid: boolean, id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | null | undefined> | null | undefined, zip?: { __typename?: 'Zip', valid: boolean } | null | undefined } | null | undefined, validPhoneRegions?: Array<{ __typename?: 'ValidPhoneRegion', id: string, countryCode: string }> | null | undefined };

export type JuniperAccountPageQueryVariables = Exact<{ [key: string]: never; }>;


export type JuniperAccountPageQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, weightTreatmentCategory?: WeightTreatmentCategory | null | undefined, defaultPaymentGateway?: PaymentGateway | null | undefined, email: string, fullName?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, phone?: string | null | undefined, zip?: { __typename?: 'Zip', valid: boolean } | null | undefined, address?: { __typename?: 'Address', id: string, line1?: string | null | undefined, line2?: string | null | undefined, city?: string | null | undefined, postalCode?: string | null | undefined, prefecture?: string | null | undefined, municipality?: string | null | undefined, townArea?: string | null | undefined, state?: string | null | undefined, building?: string | null | undefined, company?: string | null | undefined, country?: string | null | undefined } | null | undefined, savedPaymentMethods?: Array<{ __typename?: 'SavedCardPaymentMethod', expiry: string, mask: string, brand: string, id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | { __typename?: 'SavedPayPalPaymentMethod', email?: string | null | undefined, id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | { __typename?: 'SavedSofortPaymentMethod', id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | { __typename?: 'SavedZipPaymentMethod', valid: boolean, id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | null | undefined> | null | undefined, residentialAddress?: { __typename?: 'ResidentialAddress', id: string, line1: string, line2?: string | null | undefined, city: string, postalCode: string, prefecture?: string | null | undefined, municipality?: string | null | undefined, townArea?: string | null | undefined, state?: string | null | undefined, building?: string | null | undefined, company?: string | null | undefined, country: string } | null | undefined } | null | undefined, validPhoneRegions?: Array<{ __typename?: 'ValidPhoneRegion', id: string, countryCode: string }> | null | undefined };

export type JuniperProfilePageQueryVariables = Exact<{ [key: string]: never; }>;


export type JuniperProfilePageQuery = { __typename?: 'Query', completedMobileOnboardingScreens?: boolean | null | undefined, profile?: { __typename?: 'User', id: string, shortAddressableName?: string | null | undefined, needsSubscriptionMigration?: boolean | null | undefined, isBeingTreatedForWeight?: boolean | null | undefined, mobileAppAccess?: { __typename?: 'MobileAppAccess', id: string } | null | undefined, initialQuizApplications?: Array<{ __typename?: 'QuizApplication', id: string, problemType: ProblemType, createdAt: string, archivedAt?: string | null | undefined, submittedAt?: string | null | undefined, outcomes?: Array<{ __typename?: 'ArticleQuizOutcome', id: string } | { __typename?: 'BuyOtcQuizOutcome', id: string } | { __typename?: 'ConsultationQuizOutcome', id: string } | { __typename?: 'IncreaseUsageQuizOutcome', id: string } | { __typename?: 'NotEligibleQuizOutcome', id: string } | { __typename?: 'OtcQuizOutcome', id: string } | { __typename?: 'ReviewQuizOutcome', id: string } | { __typename?: 'SideEffectProactiveActionQuizOutcome', id: string } | { __typename?: 'ZendeskQuizOutcome', id: string }> | null | undefined }> | null | undefined, archivedQuizApplications?: Array<{ __typename?: 'QuizApplication', id: string, problemType: ProblemType, createdAt: string, archivedAt?: string | null | undefined, submittedAt?: string | null | undefined, outcomes?: Array<{ __typename?: 'ArticleQuizOutcome', id: string } | { __typename?: 'BuyOtcQuizOutcome', id: string } | { __typename?: 'ConsultationQuizOutcome', id: string } | { __typename?: 'IncreaseUsageQuizOutcome', id: string } | { __typename?: 'NotEligibleQuizOutcome', id: string } | { __typename?: 'OtcQuizOutcome', id: string } | { __typename?: 'ReviewQuizOutcome', id: string } | { __typename?: 'SideEffectProactiveActionQuizOutcome', id: string } | { __typename?: 'ZendeskQuizOutcome', id: string }> | null | undefined }> | null | undefined, subscriptionsV2?: Array<{ __typename?: 'SubscriptionV2', id: string, status: SubscriptionStatus, nextPaymentAt?: string | null | undefined, subscriptionPlan: { __typename?: 'SubscriptionPlanV2', id: string, name: string, interval: SubscriptionPlanInterval, intervalCount: number, price: number, photo: { __typename?: 'File', id: string, url: string } } }> | null | undefined, consultations: Array<{ __typename?: 'Consultation', id: string, type: ProblemType, stage: ConsultationStage, createdAt: string, isApproved?: boolean | null | undefined, typeIsFlexi?: boolean | null | undefined, status: ConsultationStatus, practitionerMessagedAt?: string | null | undefined, requiresPrescriberCall: boolean, allowPatientToSendMessageToDoctor: boolean, isInNoPickUpQueue?: boolean | null | undefined, purchasePrompt?: { __typename?: 'ConfirmPurchasePrompt', id: string } | { __typename?: 'FurPurchasePrompt', id: string } | { __typename?: 'InitialPurchasePrompt', id: string } | { __typename?: 'RestartFlowPrompt', id: string } | { __typename?: 'SubstitutePurchasePrompt', id: string } | null | undefined, quizApplication?: { __typename?: 'QuizApplication', id: string, problemType: ProblemType, submittedAt?: string | null | undefined } | null | undefined, treatment?: { __typename?: 'Treatment', id: string, status: TreatmentStatus, active: boolean, pendingFollowUpReminderDate?: string | null | undefined, isLastOrderUnfulfilled: boolean, refillsLeft?: number | null | undefined, nextPayment?: string | null | undefined, canRefill: boolean, nextPaymentAmount?: number | null | undefined, type: ProblemType, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined }, otcSchedules: Array<{ __typename?: 'OtcSchedule', id: string, cadence: OtcScheduleCadence, quantity: number, isActive: boolean, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined, variants: Array<{ __typename?: 'Variant', id: string, price: number }> } }>, plan?: { __typename?: 'Plan', id: string, amount: number } | null | undefined } | null | undefined, pathologyRequests?: Array<{ __typename?: 'PathologyRequest', id: string, customerStatedCollectedAt?: string | null | undefined, result?: { __typename?: 'PathologyResult', id: string } | null | undefined } | null | undefined> | null | undefined, doctor?: { __typename?: 'User', id: string, fullName?: string | null | undefined, fullClinicianName: string } | null | undefined, chatThread?: { __typename?: 'ChatThread', id: string } | null | undefined, prescribedSequence?: { __typename?: 'PrescribedSequence', id: string } | null | undefined, screeningQuizApplication?: { __typename?: 'QuizApplication', id: string, submittedAt?: string | null | undefined } | null | undefined, latestPractitionerBooking?: { __typename?: 'PractitionerBooking', id: string, windowStartAt: string, windowEndAt: string } | null | undefined, reminders?: Array<{ __typename?: 'ConsultationReminder', id: string, canceled: boolean, doneAt?: string | null | undefined, scheduledAt: string }> | null | undefined, patientQuestions?: Array<{ __typename?: 'ConsultationPatientQuestion', id: string, createdAt: string }> | null | undefined }>, purchases?: Array<{ __typename?: 'Purchase', id: string, status: PurchaseStatus, problemType?: ProblemType | null | undefined, isVisibleInProfilePage?: boolean | null | undefined, contexts?: Array<{ __typename?: 'SequenceContext', id: string, status: SequenceContextStatus, consultations?: Array<{ __typename?: 'Consultation', id: string }> | null | undefined, sequence?: { __typename?: 'OtcSequence', id: string, products?: Array<{ __typename?: 'Product', id: string, productType: ProductType }> | null | undefined } | { __typename?: 'PrescribableSequence', id: string, products?: Array<{ __typename?: 'Product', id: string, productType: ProductType }> | null | undefined } | null | undefined }> | null | undefined, orderTimeline?: Array<{ __typename?: 'OrderTimelineItem', id: string, status: OrderTimelineItemStatus }> | null | undefined, offering?: { __typename?: 'AddOnOffering', id: string, friendlyName: string, problemTypes?: Array<ProblemType> | null | undefined } | { __typename?: 'OtcOffering', id: string, friendlyName: string, problemTypes?: Array<ProblemType> | null | undefined } | { __typename?: 'RxOffering', id: string, friendlyName: string, problemTypes?: Array<ProblemType> | null | undefined } | null | undefined, nextOrder?: { __typename?: 'OrderTimelineItem', id: string, date: string, totalAmount: number, products?: Array<{ __typename?: 'Product', id: string, friendlyName?: string | null | undefined, name: string }> | null | undefined } | null | undefined, availableActions?: Array<{ __typename?: 'PurchaseResumeAction', id: string }> | null | undefined }> | null | undefined } | null | undefined, customerAttributes: { __typename?: 'CustomerAttributes', id: string }, subscriptionsV1: Array<{ __typename?: 'SubscriptionPlan', id: string, active: boolean, amount?: number | null | undefined, cancelAt?: string | null | undefined, cancelAtPeriodEnd: boolean, interval: string, intervalCount: number, status: string, currentPeriodEnd: string, product?: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined, photo?: { __typename?: 'File', id: string, url: string } | null | undefined } | null | undefined }> };

export type JuniperProfilePageUserSegmentsFragment = { __typename?: 'Query', completedMobileOnboardingScreens?: boolean | null | undefined };

export type JuniperProfilePageConsultationFragment = { __typename?: 'Consultation', id: string, type: ProblemType, stage: ConsultationStage, createdAt: string, isApproved?: boolean | null | undefined, typeIsFlexi?: boolean | null | undefined, status: ConsultationStatus, practitionerMessagedAt?: string | null | undefined, requiresPrescriberCall: boolean, allowPatientToSendMessageToDoctor: boolean, isInNoPickUpQueue?: boolean | null | undefined, purchasePrompt?: { __typename?: 'ConfirmPurchasePrompt', id: string } | { __typename?: 'FurPurchasePrompt', id: string } | { __typename?: 'InitialPurchasePrompt', id: string } | { __typename?: 'RestartFlowPrompt', id: string } | { __typename?: 'SubstitutePurchasePrompt', id: string } | null | undefined, quizApplication?: { __typename?: 'QuizApplication', id: string, problemType: ProblemType, submittedAt?: string | null | undefined } | null | undefined, treatment?: { __typename?: 'Treatment', id: string, status: TreatmentStatus, active: boolean, pendingFollowUpReminderDate?: string | null | undefined, isLastOrderUnfulfilled: boolean, refillsLeft?: number | null | undefined, nextPayment?: string | null | undefined, canRefill: boolean, nextPaymentAmount?: number | null | undefined, type: ProblemType, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined }, otcSchedules: Array<{ __typename?: 'OtcSchedule', id: string, cadence: OtcScheduleCadence, quantity: number, isActive: boolean, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined, variants: Array<{ __typename?: 'Variant', id: string, price: number }> } }>, plan?: { __typename?: 'Plan', id: string, amount: number } | null | undefined } | null | undefined, pathologyRequests?: Array<{ __typename?: 'PathologyRequest', id: string, customerStatedCollectedAt?: string | null | undefined, result?: { __typename?: 'PathologyResult', id: string } | null | undefined } | null | undefined> | null | undefined, doctor?: { __typename?: 'User', id: string, fullName?: string | null | undefined, fullClinicianName: string } | null | undefined, chatThread?: { __typename?: 'ChatThread', id: string } | null | undefined, prescribedSequence?: { __typename?: 'PrescribedSequence', id: string } | null | undefined, screeningQuizApplication?: { __typename?: 'QuizApplication', id: string, submittedAt?: string | null | undefined } | null | undefined, latestPractitionerBooking?: { __typename?: 'PractitionerBooking', id: string, windowStartAt: string, windowEndAt: string } | null | undefined, reminders?: Array<{ __typename?: 'ConsultationReminder', id: string, canceled: boolean, doneAt?: string | null | undefined, scheduledAt: string }> | null | undefined, patientQuestions?: Array<{ __typename?: 'ConsultationPatientQuestion', id: string, createdAt: string }> | null | undefined };

export type JuniperProfilePagePurchaseFragment = { __typename?: 'Purchase', id: string, status: PurchaseStatus, problemType?: ProblemType | null | undefined, isVisibleInProfilePage?: boolean | null | undefined, contexts?: Array<{ __typename?: 'SequenceContext', id: string, status: SequenceContextStatus, consultations?: Array<{ __typename?: 'Consultation', id: string }> | null | undefined, sequence?: { __typename?: 'OtcSequence', id: string, products?: Array<{ __typename?: 'Product', id: string, productType: ProductType }> | null | undefined } | { __typename?: 'PrescribableSequence', id: string, products?: Array<{ __typename?: 'Product', id: string, productType: ProductType }> | null | undefined } | null | undefined }> | null | undefined, orderTimeline?: Array<{ __typename?: 'OrderTimelineItem', id: string, status: OrderTimelineItemStatus }> | null | undefined, offering?: { __typename?: 'AddOnOffering', id: string, friendlyName: string, problemTypes?: Array<ProblemType> | null | undefined } | { __typename?: 'OtcOffering', id: string, friendlyName: string, problemTypes?: Array<ProblemType> | null | undefined } | { __typename?: 'RxOffering', id: string, friendlyName: string, problemTypes?: Array<ProblemType> | null | undefined } | null | undefined, nextOrder?: { __typename?: 'OrderTimelineItem', id: string, date: string, totalAmount: number, products?: Array<{ __typename?: 'Product', id: string, friendlyName?: string | null | undefined, name: string }> | null | undefined } | null | undefined, availableActions?: Array<{ __typename?: 'PurchaseResumeAction', id: string }> | null | undefined };

export type JuniperProfilePageInitialQuizApplicationFragment = { __typename?: 'QuizApplication', id: string, problemType: ProblemType, createdAt: string, archivedAt?: string | null | undefined, submittedAt?: string | null | undefined, outcomes?: Array<{ __typename?: 'ArticleQuizOutcome', id: string } | { __typename?: 'BuyOtcQuizOutcome', id: string } | { __typename?: 'ConsultationQuizOutcome', id: string } | { __typename?: 'IncreaseUsageQuizOutcome', id: string } | { __typename?: 'NotEligibleQuizOutcome', id: string } | { __typename?: 'OtcQuizOutcome', id: string } | { __typename?: 'ReviewQuizOutcome', id: string } | { __typename?: 'SideEffectProactiveActionQuizOutcome', id: string } | { __typename?: 'ZendeskQuizOutcome', id: string }> | null | undefined };

export type JuniperTreatmentStatusCardQuizApplicationFragment = { __typename?: 'QuizApplication', id: string, submittedAt?: string | null | undefined, problemType: ProblemType, createdAt: string, archivedAt?: string | null | undefined, outcomes?: Array<{ __typename?: 'ArticleQuizOutcome', id: string } | { __typename?: 'BuyOtcQuizOutcome', id: string } | { __typename?: 'ConsultationQuizOutcome', id: string } | { __typename?: 'IncreaseUsageQuizOutcome', id: string } | { __typename?: 'NotEligibleQuizOutcome', id: string } | { __typename?: 'OtcQuizOutcome', id: string } | { __typename?: 'ReviewQuizOutcome', id: string } | { __typename?: 'SideEffectProactiveActionQuizOutcome', id: string } | { __typename?: 'ZendeskQuizOutcome', id: string }> | null | undefined };

export type JuniperTreatmentStatusCardConsultationFragment = { __typename?: 'Consultation', id: string, type: ProblemType, stage: ConsultationStage, createdAt: string, isApproved?: boolean | null | undefined, typeIsFlexi?: boolean | null | undefined, status: ConsultationStatus, practitionerMessagedAt?: string | null | undefined, requiresPrescriberCall: boolean, allowPatientToSendMessageToDoctor: boolean, isInNoPickUpQueue?: boolean | null | undefined, treatment?: { __typename?: 'Treatment', id: string, status: TreatmentStatus, active: boolean, pendingFollowUpReminderDate?: string | null | undefined, isLastOrderUnfulfilled: boolean, refillsLeft?: number | null | undefined, nextPayment?: string | null | undefined, canRefill: boolean, nextPaymentAmount?: number | null | undefined, type: ProblemType, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined }, otcSchedules: Array<{ __typename?: 'OtcSchedule', id: string, cadence: OtcScheduleCadence, quantity: number, isActive: boolean, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined, variants: Array<{ __typename?: 'Variant', id: string, price: number }> } }>, plan?: { __typename?: 'Plan', id: string, amount: number } | null | undefined } | null | undefined, purchasePrompt?: { __typename?: 'ConfirmPurchasePrompt', id: string } | { __typename?: 'FurPurchasePrompt', id: string } | { __typename?: 'InitialPurchasePrompt', id: string } | { __typename?: 'RestartFlowPrompt', id: string } | { __typename?: 'SubstitutePurchasePrompt', id: string } | null | undefined, quizApplication?: { __typename?: 'QuizApplication', id: string, problemType: ProblemType, submittedAt?: string | null | undefined } | null | undefined, pathologyRequests?: Array<{ __typename?: 'PathologyRequest', id: string, customerStatedCollectedAt?: string | null | undefined, result?: { __typename?: 'PathologyResult', id: string } | null | undefined } | null | undefined> | null | undefined, doctor?: { __typename?: 'User', id: string, fullName?: string | null | undefined, fullClinicianName: string } | null | undefined, chatThread?: { __typename?: 'ChatThread', id: string } | null | undefined, prescribedSequence?: { __typename?: 'PrescribedSequence', id: string } | null | undefined, screeningQuizApplication?: { __typename?: 'QuizApplication', id: string, submittedAt?: string | null | undefined } | null | undefined, latestPractitionerBooking?: { __typename?: 'PractitionerBooking', id: string, windowStartAt: string, windowEndAt: string } | null | undefined, reminders?: Array<{ __typename?: 'ConsultationReminder', id: string, canceled: boolean, doneAt?: string | null | undefined, scheduledAt: string }> | null | undefined, patientQuestions?: Array<{ __typename?: 'ConsultationPatientQuestion', id: string, createdAt: string }> | null | undefined };

export type JuniperTreatmentStatusCardTreatmentFragment = { __typename?: 'Treatment', id: string, refillsLeft?: number | null | undefined, nextPayment?: string | null | undefined, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined }, otcSchedules: Array<{ __typename?: 'OtcSchedule', id: string, cadence: OtcScheduleCadence, quantity: number, isActive: boolean, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined } }> };

export type JuniperTreatmentStatusCardPurchaseFragment = { __typename?: 'Purchase', id: string, problemType?: ProblemType | null | undefined, status: PurchaseStatus, isVisibleInProfilePage?: boolean | null | undefined, contexts?: Array<{ __typename?: 'SequenceContext', id: string, status: SequenceContextStatus, consultations?: Array<{ __typename?: 'Consultation', id: string }> | null | undefined, sequence?: { __typename?: 'OtcSequence', id: string, products?: Array<{ __typename?: 'Product', id: string, productType: ProductType }> | null | undefined } | { __typename?: 'PrescribableSequence', id: string, products?: Array<{ __typename?: 'Product', id: string, productType: ProductType }> | null | undefined } | null | undefined }> | null | undefined, orderTimeline?: Array<{ __typename?: 'OrderTimelineItem', id: string, status: OrderTimelineItemStatus }> | null | undefined, offering?: { __typename?: 'AddOnOffering', id: string, friendlyName: string, problemTypes?: Array<ProblemType> | null | undefined } | { __typename?: 'OtcOffering', id: string, friendlyName: string, problemTypes?: Array<ProblemType> | null | undefined } | { __typename?: 'RxOffering', id: string, friendlyName: string, problemTypes?: Array<ProblemType> | null | undefined } | null | undefined, nextOrder?: { __typename?: 'OrderTimelineItem', id: string, date: string, totalAmount: number, products?: Array<{ __typename?: 'Product', id: string, friendlyName?: string | null | undefined, name: string }> | null | undefined } | null | undefined, availableActions?: Array<{ __typename?: 'PurchaseResumeAction', id: string }> | null | undefined };

export type JuniperOtcPurchaseQueryVariables = Exact<{
  offeringSelections: Array<OfferingSelectionInput> | OfferingSelectionInput;
  pricingSessionId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
  userIsAnonymous: Scalars['Boolean']['input'];
  hasOfferingsSelections: Scalars['Boolean']['input'];
  couponCodes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type JuniperOtcPurchaseQuery = { __typename?: 'Query', initialPurchasePrice?: { __typename?: 'InitialPurchasePriceList', id: string, amount: number, originalAmount: number, coupons?: Array<{ __typename?: 'InitialPurchasePriceCoupon', id: string, code: string, outcome: CouponOutcome }> | null | undefined, offeringPriceLists: Array<{ __typename?: 'InitialPurchasePriceOfferingPriceList', id: string, sequencePriceLists: Array<{ __typename?: 'InitialPurchasePriceSequencePriceList', id: string, pricedItems: Array<{ __typename?: 'InitialPurchasePriceSequencePricedItem', id: string, quantity: number, unitPrice: number, unitPriceDiscount: number, variant?: { __typename?: 'Variant', id: string, product: { __typename?: 'Product', id: string, name: string } } | null | undefined }> }>, offering?: { __typename?: 'AddOnOffering', id: string, photoUrl: string, friendlyName: string, advertisedShippingCadence: string } | { __typename?: 'OtcOffering', id: string, photoUrl: string, friendlyName: string, advertisedShippingCadence: string } | { __typename?: 'RxOffering', id: string, photoUrl: string, friendlyName: string, advertisedShippingCadence: string } | null | undefined }> } | null | undefined, profile?: { __typename?: 'User', id: string, email: string, lastName?: string | null | undefined, firstName?: string | null | undefined, address?: { __typename?: 'Address', id: string } | null | undefined, residentialAddress?: { __typename?: 'ResidentialAddress', id: string, city: string, line1: string, line2?: string | null | undefined, state?: string | null | undefined, country: string, postalCode: string, prefecture?: string | null | undefined, municipality?: string | null | undefined, townArea?: string | null | undefined } | null | undefined } | null | undefined };

export type JuniperPurchaseConfirmUpdateUserMutationVariables = Exact<{
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  residentialAddress: ResidentialAddressCreateInput;
}>;


export type JuniperPurchaseConfirmUpdateUserMutation = { __typename?: 'Mutation', updateProfile?: { __typename?: 'User', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined } | null | undefined, updateResidentialAddress?: { __typename?: 'ResidentialAddress', id: string, line1: string, line2?: string | null | undefined, state?: string | null | undefined, country: string, company?: string | null | undefined, building?: string | null | undefined, postalCode: string, city: string } | null | undefined };

export type JuniperQuizCompletePageQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type JuniperQuizCompletePageQuery = { __typename?: 'Query', getQuizApplication?: { __typename?: 'QuizApplication', id: string, purpose: QuizPurpose, problemType: ProblemType, quiz: { __typename?: 'Quiz', id: string, default: boolean, quizCode: string }, consultation?: { __typename?: 'Consultation', id: string, status: ConsultationStatus, stage: ConsultationStage, isUpfrontPayment: boolean, requiresPrescriberCall: boolean, canSchedulePractitionerBooking: boolean } | null | undefined, outcomes?: Array<{ __typename?: 'ArticleQuizOutcome', id: string } | { __typename?: 'BuyOtcQuizOutcome', id: string } | { __typename?: 'ConsultationQuizOutcome', id: string } | { __typename?: 'IncreaseUsageQuizOutcome', id: string } | { __typename?: 'NotEligibleQuizOutcome', id: string } | { __typename?: 'OtcQuizOutcome', id: string } | { __typename?: 'ReviewQuizOutcome', id: string } | { __typename?: 'SideEffectProactiveActionQuizOutcome', id: string } | { __typename?: 'ZendeskQuizOutcome', id: string }> | null | undefined } | null | undefined, profile?: { __typename?: 'User', id: string, phone?: string | null | undefined, isPasswordSet: boolean, residentialAddress?: { __typename?: 'ResidentialAddress', id: string } | null | undefined, medicalProfile: { __typename?: 'MedicalProfile', id: string, weight?: number | null | undefined } } | null | undefined };

export type JuniperAsyncEligibleQuizCompletePageQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
  problemType: ProblemType;
}>;


export type JuniperAsyncEligibleQuizCompletePageQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, customer: { __typename?: 'User', id: string, condition?: { __typename?: 'Condition', id: string, asyncEligible?: boolean | null | undefined } | null | undefined } } | null | undefined };

export type StartConfirmProfileJuniperQueryVariables = Exact<{ [key: string]: never; }>;


export type StartConfirmProfileJuniperQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, consultations: Array<{ __typename?: 'Consultation', id: string, type: ProblemType, status: ConsultationStatus, isUpfrontPayment: boolean }> } | null | undefined };

export type FaqTreatmentJuniperQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type FaqTreatmentJuniperQuery = { __typename?: 'Query', treatment?: { __typename?: 'Treatment', id: string, type: ProblemType, weightTreatmentCategory?: WeightTreatmentCategory | null | undefined, canPause: boolean, status: TreatmentStatus, nextPayment?: string | null | undefined, product: { __typename?: 'Product', id: string, faqs: Array<{ __typename?: 'Faq', id: string, title?: string | null | undefined, markdown?: string | null | undefined }> } } | null | undefined };

export type TreatmentPageProductFragment = { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined, description?: string | null | undefined, shortDescription?: string | null | undefined, priority: number, productType: ProductType, problemTypes: Array<ProblemType>, photo?: { __typename?: 'File', id: string, url: string } | null | undefined, variants: Array<{ __typename?: 'Variant', id: string, price: number, public: boolean, inventory?: { __typename?: 'VariantInventory', id: string, sku?: string | null | undefined } | null | undefined }> };

export type JuniperTreatmentPlanPageQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type JuniperTreatmentPlanPageQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string } | null | undefined, treatment?: { __typename?: 'Treatment', id: string, status: TreatmentStatus, canRefill: boolean, refillsLeft?: number | null | undefined, type: ProblemType, nextPayment?: string | null | undefined, canReschedule: boolean, cooldownActiveUntil?: string | null | undefined, nextPaymentAmount?: number | null | undefined, weightTreatmentCategory?: WeightTreatmentCategory | null | undefined, supersededByFlexiPlans?: boolean | null | undefined, plan?: { __typename?: 'Plan', id: string, amount: number } | null | undefined, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined, description?: string | null | undefined, shortDescription?: string | null | undefined, priority: number, productType: ProductType, problemTypes: Array<ProblemType>, photo?: { __typename?: 'File', id: string, url: string } | null | undefined, variants: Array<{ __typename?: 'Variant', id: string, price: number, public: boolean, inventory?: { __typename?: 'VariantInventory', id: string, sku?: string | null | undefined } | null | undefined }> }, otcSchedules: Array<{ __typename?: 'OtcSchedule', id: string, cadence: OtcScheduleCadence, isActive: boolean, quantity: number, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined, productType: ProductType, description?: string | null | undefined, shortDescription?: string | null | undefined, priority: number, problemTypes: Array<ProblemType>, photo?: { __typename?: 'File', id: string, url: string } | null | undefined, variants: Array<{ __typename?: 'Variant', id: string, price: number, public: boolean, inventory?: { __typename?: 'VariantInventory', id: string, sku?: string | null | undefined } | null | undefined }> } }>, treatmentDiscount?: { __typename?: 'TreatmentDiscount', id: string, discountCode?: { __typename?: 'DiscountCode', id: string, code: string, amount: number, stages: Array<DiscountStage>, type: DiscountType, products: Array<{ __typename?: 'Product', id: string, variants: Array<{ __typename?: 'Variant', id: string }> }> } | null | undefined } | null | undefined, consultation?: { __typename?: 'Consultation', id: string, type: ProblemType, doctor?: { __typename?: 'User', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, fullClinicianName: string, fullName?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, customerAttributes: { __typename?: 'CustomerAttributes', id: string, menopause: { __typename?: 'CustomerMenopauseAttributes', menopauseSymptoms?: Array<MenopauseSymptoms | null | undefined> | null | undefined } } };

export type ProductListTreatmentProductFragment = { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined, productType: ProductType, photo?: { __typename?: 'File', id: string, url: string } | null | undefined, variants: Array<{ __typename?: 'Variant', id: string, price: number, inventory?: { __typename?: 'VariantInventory', id: string, sku?: string | null | undefined } | null | undefined }> };

export type ProductListTreatmentFragment = { __typename?: 'Treatment', id: string, type: ProblemType, nextPayment?: string | null | undefined, nextPaymentAmount?: number | null | undefined, canReschedule: boolean, canRefill: boolean, cooldownActiveUntil?: string | null | undefined, supersededByFlexiPlans?: boolean | null | undefined, treatmentDiscount?: { __typename?: 'TreatmentDiscount', id: string, discountCode?: { __typename?: 'DiscountCode', id: string, code: string, amount: number, stages: Array<DiscountStage>, type: DiscountType, products: Array<{ __typename?: 'Product', id: string, variants: Array<{ __typename?: 'Variant', id: string }> }> } | null | undefined } | null | undefined, plan?: { __typename?: 'Plan', id: string, amount: number } | null | undefined, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined, productType: ProductType, photo?: { __typename?: 'File', id: string, url: string } | null | undefined, variants: Array<{ __typename?: 'Variant', id: string, price: number, inventory?: { __typename?: 'VariantInventory', id: string, sku?: string | null | undefined } | null | undefined }> }, otcSchedules: Array<{ __typename?: 'OtcSchedule', id: string, cadence: OtcScheduleCadence, isActive: boolean, quantity: number, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined, productType: ProductType, photo?: { __typename?: 'File', id: string, url: string } | null | undefined, variants: Array<{ __typename?: 'Variant', id: string, price: number, inventory?: { __typename?: 'VariantInventory', id: string, sku?: string | null | undefined } | null | undefined }> } }> };

export type JuniperWeightLossDashboardPageQueryVariables = Exact<{
  segmentName: Segment;
}>;


export type JuniperWeightLossDashboardPageQuery = { __typename?: 'Query', inSegment?: boolean | null | undefined, weightLossTreatments?: Array<{ __typename?: 'Treatment', id: string, active: boolean }> | null | undefined, profile?: { __typename?: 'User', id: string, isBeingTreated?: boolean | null | undefined, purchases?: Array<{ __typename?: 'Purchase', id: string, problemType?: ProblemType | null | undefined, status: PurchaseStatus }> | null | undefined } | null | undefined, tracker: { __typename?: 'TrackerField', id: string, weightLoss: { __typename?: 'WeightLossTracker', id: string, lastCheckIn?: string | null | undefined, momentum?: number | null | undefined, waist?: Array<{ __typename?: 'ObservedMeasurement', id: string, value: number, effectiveFrom: string }> | null | undefined, weight?: Array<{ __typename?: 'ObservedMeasurement', id: string, value: number, effectiveFrom: string }> | null | undefined } } };

export type SunsetBpDashboardQueryVariables = Exact<{ [key: string]: never; }>;


export type SunsetBpDashboardQuery = { __typename?: 'Query', completedMobileOnboardingScreens?: boolean | null | undefined, profile?: { __typename?: 'User', id: string, shortAddressableName?: string | null | undefined } | null | undefined };

export type UseConsultationKinQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type UseConsultationKinQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, type: ProblemType, status: ConsultationStatus, patientNotes?: string | null | undefined, pathologyRequests?: Array<{ __typename?: 'PathologyRequest', id: string, result?: { __typename?: 'PathologyResult', id: string, collectedDate?: string | null | undefined, file?: { __typename?: 'PathologyResultFile', id: string, signedUrl: string } | null | undefined } | null | undefined, panels?: Array<{ __typename?: 'PathologyPanel', id: string, tests?: Array<{ __typename?: 'PathologyPanelTest', id: string, name: PathologyPanelTestNameKey, formName: string, displayName: string, pathologyPanelId: string, result?: { __typename?: 'PathologyPanelTestResult', id?: string | null | undefined, note?: string | null | undefined, result: { __typename?: 'PathologyPanelTestResultValue', type: PathologyPanelTestResultValueType, value?: string | null | undefined, number?: number | null | undefined, unit?: string | null | undefined, range?: { __typename?: 'PathologyPanelTestResultValueRange', low?: number | null | undefined, high?: number | null | undefined } | null | undefined } } | null | undefined }> | null | undefined }> | null | undefined } | null | undefined> | null | undefined, doctor?: { __typename?: 'User', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, shortClinicianName: string, fullClinicianName: string, fullName?: string | null | undefined, avatar?: { __typename?: 'File', id: string, url: string } | null | undefined } | null | undefined } | null | undefined };

export type ConsultationInfoKinFragment = { __typename?: 'Consultation', id: string, type: ProblemType, status: ConsultationStatus, patientNotes?: string | null | undefined, pathologyRequests?: Array<{ __typename?: 'PathologyRequest', id: string, result?: { __typename?: 'PathologyResult', id: string, collectedDate?: string | null | undefined, file?: { __typename?: 'PathologyResultFile', id: string, signedUrl: string } | null | undefined } | null | undefined, panels?: Array<{ __typename?: 'PathologyPanel', id: string, tests?: Array<{ __typename?: 'PathologyPanelTest', id: string, name: PathologyPanelTestNameKey, formName: string, displayName: string, pathologyPanelId: string, result?: { __typename?: 'PathologyPanelTestResult', id?: string | null | undefined, note?: string | null | undefined, result: { __typename?: 'PathologyPanelTestResultValue', type: PathologyPanelTestResultValueType, value?: string | null | undefined, number?: number | null | undefined, unit?: string | null | undefined, range?: { __typename?: 'PathologyPanelTestResultValueRange', low?: number | null | undefined, high?: number | null | undefined } | null | undefined } } | null | undefined }> | null | undefined }> | null | undefined } | null | undefined> | null | undefined, doctor?: { __typename?: 'User', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, shortClinicianName: string, fullClinicianName: string, fullName?: string | null | undefined, avatar?: { __typename?: 'File', id: string, url: string } | null | undefined } | null | undefined };

export type KinAsyncConsultConfirmedPageQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type KinAsyncConsultConfirmedPageQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, type: ProblemType, requiresPrescriberCall: boolean } | null | undefined };

export type KinAsyncEligibleMedicarePageQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
  problemType: ProblemType;
}>;


export type KinAsyncEligibleMedicarePageQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, customer: { __typename?: 'User', id: string, condition?: { __typename?: 'Condition', id: string, asyncEligible?: boolean | null | undefined } | null | undefined } } | null | undefined };

export type FertilityTestConfirmCardPathologyLocationHealiusQueryVariables = Exact<{
  postcode: Scalars['String']['input'];
}>;


export type FertilityTestConfirmCardPathologyLocationHealiusQuery = { __typename?: 'Query', pathologyLocationHealius: { __typename?: 'PathologyLocation', display?: string | null | undefined, url?: string | null | undefined } };

export type FollowUpConsultationQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type FollowUpConsultationQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, type: ProblemType, status: ConsultationStatus } | null | undefined };

export type VideoConsultationNotesQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type VideoConsultationNotesQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, patientNotes?: string | null | undefined } | null | undefined };

export type FertilityTestPaymentPathologyPanelTestNamesQueryVariables = Exact<{
  type: ProblemType;
}>;


export type FertilityTestPaymentPathologyPanelTestNamesQuery = { __typename?: 'Query', pathologyPanelTestNames: Array<{ __typename?: 'PathologyPanelTestName', displayName?: string | null | undefined, name?: PathologyPanelTestNameKey | null | undefined }> };

export type KinPracBookingConfirmationPageQueryVariables = Exact<{
  pracBookingId: Scalars['ID']['input'];
}>;


export type KinPracBookingConfirmationPageQuery = { __typename?: 'Query', practitionerBooking?: { __typename?: 'PractitionerBooking', id: string, windowStartAt: string, windowEndAt: string, consultation?: { __typename?: 'Consultation', id: string, type: ProblemType } | null | undefined, patient?: { __typename?: 'User', id: string, email: string, phone?: string | null | undefined } | null | undefined } | null | undefined, validPhoneRegions?: Array<{ __typename?: 'ValidPhoneRegion', id: string, countryCode: string }> | null | undefined };

export type KinPractitionerPhoneCallPageQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type KinPractitionerPhoneCallPageQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, latestPractitionerBooking?: { __typename?: 'PractitionerBooking', id: string } | null | undefined } | null | undefined };

export type KinSchedulePhoneCallPageQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type KinSchedulePhoneCallPageQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, latestPractitionerBooking?: { __typename?: 'PractitionerBooking', id: string } | null | undefined } | null | undefined };

export type KinRedirectPageQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type KinRedirectPageQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, isApproved?: boolean | null | undefined, customerId: string, allowPatientToSendMessageToDoctor: boolean, requiresPrescriberCall: boolean, isInNoPickUpQueue?: boolean | null | undefined, stage: ConsultationStage, status: ConsultationStatus, type: ProblemType, medium: ConsultationMedium, quizApplication?: { __typename?: 'QuizApplication', id: string, problemType: ProblemType } | null | undefined, screeningQuizApplication?: { __typename?: 'QuizApplication', id: string, submittedAt?: string | null | undefined } | null | undefined, latestPractitionerBooking?: { __typename?: 'PractitionerBooking', id: string } | null | undefined, chatThread?: { __typename?: 'ChatThread', id: string } | null | undefined } | null | undefined };

export type ScheduleVideoConsultQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type ScheduleVideoConsultQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, type: ProblemType, doctor?: { __typename?: 'User', id: string, acuityId?: string | null | undefined } | null | undefined } | null | undefined, profile?: { __typename?: 'User', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, phone?: string | null | undefined, email: string } | null | undefined };

export type ScheduleFertilityTestVideoConsultQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type ScheduleFertilityTestVideoConsultQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, type: ProblemType, doctor?: { __typename?: 'User', id: string, acuityId?: string | null | undefined } | null | undefined } | null | undefined, profile?: { __typename?: 'User', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, phone?: string | null | undefined, email: string } | null | undefined };

export type KinProfilePageQueryVariables = Exact<{
  crossSellContext: CrossSellContextType;
}>;


export type KinProfilePageQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, shortAddressableName?: string | null | undefined, savedPaymentMethods?: Array<{ __typename?: 'SavedCardPaymentMethod', brand: string, mask: string, expiry: string, createdAt?: string | null | undefined, default: boolean, gateway: PaymentGateway, id: string } | { __typename?: 'SavedPayPalPaymentMethod', email?: string | null | undefined, createdAt?: string | null | undefined, default: boolean, gateway: PaymentGateway, id: string } | { __typename?: 'SavedSofortPaymentMethod', createdAt?: string | null | undefined, default: boolean, gateway: PaymentGateway, id: string } | { __typename?: 'SavedZipPaymentMethod', valid: boolean, createdAt?: string | null | undefined, default: boolean, gateway: PaymentGateway, id: string } | null | undefined> | null | undefined } | null | undefined, crossSellRecommendations?: { __typename?: 'CrossSellRecommendations', recommendations: Array<CrossSellItemType | null | undefined> } | null | undefined };

export type CreateConceptionChecklistMutationVariables = Exact<{
  consultationId: Scalars['String']['input'];
  type: Scalars['String']['input'];
}>;


export type CreateConceptionChecklistMutation = { __typename?: 'Mutation', createChecklist?: { __typename?: 'Checklist', id: string, consultationId: string, attributes?: { __typename?: 'ChecklistAttribute', age?: number | null | undefined, tryingStatus?: TryingStatusType | null | undefined, trimester?: string | null | undefined, expectedNewborns?: string | null | undefined } | null | undefined, groups?: Array<{ __typename?: 'ChecklistGroup', id: string, items?: Array<{ __typename?: 'ChecklistItem', id: string, code: string, completed: boolean } | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type KinQuizCompletePageQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type KinQuizCompletePageQuery = { __typename?: 'Query', getQuizApplication?: { __typename?: 'QuizApplication', id: string, purpose: QuizPurpose, problemType: ProblemType, quiz: { __typename?: 'Quiz', id: string, default: boolean, quizCode: string }, consultation?: { __typename?: 'Consultation', id: string, stage: ConsultationStage } | null | undefined, outcomes?: Array<{ __typename?: 'ArticleQuizOutcome', id: string } | { __typename?: 'BuyOtcQuizOutcome', id: string } | { __typename?: 'ConsultationQuizOutcome', id: string } | { __typename?: 'IncreaseUsageQuizOutcome', id: string } | { __typename?: 'NotEligibleQuizOutcome', id: string } | { __typename?: 'OtcQuizOutcome', id: string } | { __typename?: 'ReviewQuizOutcome', id: string } | { __typename?: 'SideEffectProactiveActionQuizOutcome', id: string } | { __typename?: 'ZendeskQuizOutcome', id: string }> | null | undefined } | null | undefined };

export type KinAsyncEligibleQuizCompleteQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
  problemType: ProblemType;
}>;


export type KinAsyncEligibleQuizCompleteQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, customer: { __typename?: 'User', id: string, condition?: { __typename?: 'Condition', id: string, asyncEligible?: boolean | null | undefined } | null | undefined } } | null | undefined };

export type TreatmentOrdersQueryVariables = Exact<{
  where?: InputMaybe<TreatmentWhereInput>;
}>;


export type TreatmentOrdersQuery = { __typename?: 'Query', treatments?: Array<{ __typename?: 'Treatment', id: string, orders: Array<{ __typename?: 'Order', id: string, paymentStatus?: OrderPaymentStatus | null | undefined }> }> | null | undefined };

export type PilotAsyncConsultConfirmedPageQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type PilotAsyncConsultConfirmedPageQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, type: ProblemType, requiresPrescriberCall: boolean } | null | undefined };

export type PilotCollectAddressPageQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type PilotCollectAddressPageQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, type: ProblemType } | null | undefined };

export type PilotCollectMedicarePageQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type PilotCollectMedicarePageQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, type: ProblemType, stage: ConsultationStage, isUpfrontPayment: boolean, canSchedulePractitionerBooking: boolean, quizApplication?: { __typename?: 'QuizApplication', id: string, problemType: ProblemType } | null | undefined } | null | undefined };

export type PilotAsyncEligibleMedicarePageQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
  problemType: ProblemType;
}>;


export type PilotAsyncEligibleMedicarePageQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, customer: { __typename?: 'User', id: string, condition?: { __typename?: 'Condition', id: string, asyncEligible?: boolean | null | undefined } | null | undefined } } | null | undefined };

export type PilotConfirmationPageQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type PilotConfirmationPageQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, type: ProblemType, screeningQuizApplication?: { __typename?: 'QuizApplication', id: string } | null | undefined, customer: { __typename?: 'User', id: string, email: string } } | null | undefined };

export type PilotPayConsultationQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type PilotPayConsultationQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, type: ProblemType, isUpfrontPayment: boolean } | null | undefined };

export type PilotConsultationPaidPageQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type PilotConsultationPaidPageQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, type: ProblemType, status: ConsultationStatus, isUpfrontPayment: boolean, requiresPrescriberCall: boolean, quizApplication?: { __typename?: 'QuizApplication', id: string, submittedAt?: string | null | undefined } | null | undefined, medicationPreferenceProduct?: { __typename?: 'MedicationPreferenceProducts', id: string, preferredProduct?: { __typename?: 'Product', id: string, photo?: { __typename?: 'File', id: string, url: string } | null | undefined, plan?: { __typename?: 'Plan', id: string, interval: BillingInterval, intervalCount: number, amount: number } | null | undefined } | null | undefined, defaultProduct: { __typename?: 'Product', id: string, photo?: { __typename?: 'File', id: string, url: string } | null | undefined, plan?: { __typename?: 'Plan', id: string, interval: BillingInterval, intervalCount: number, amount: number } | null | undefined } } | null | undefined } | null | undefined };

export type ProblemTypeFromConsultationQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
  bnplEnabled: Scalars['Boolean']['input'];
}>;


export type ProblemTypeFromConsultationQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, type: ProblemType, isUpfrontPayment: boolean, purchasePrompt?: { __typename?: 'ConfirmPurchasePrompt', id: string } | { __typename?: 'FurPurchasePrompt', id: string } | { __typename?: 'InitialPurchasePrompt', id: string } | { __typename?: 'RestartFlowPrompt', id: string } | { __typename?: 'SubstitutePurchasePrompt', id: string } | null | undefined } | null | undefined };

export type PilotDoctorsNoteQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type PilotDoctorsNoteQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, treatment?: { __typename?: 'Treatment', id: string, product: { __typename?: 'Product', id: string, variants: Array<{ __typename?: 'Variant', id: string, inventory?: { __typename?: 'VariantInventory', id: string, sku?: string | null | undefined } | null | undefined }> } } | null | undefined } | null | undefined };

export type PilotOrderConfirmedPageQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type PilotOrderConfirmedPageQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, type: ProblemType, patientNotes?: string | null | undefined, isUpfrontPayment: boolean, customer: { __typename?: 'User', id: string, firstName?: string | null | undefined }, doctor?: { __typename?: 'User', id: string, shortClinicianName: string, fullClinicianName: string, fullName?: string | null | undefined } | null | undefined, treatment?: { __typename?: 'Treatment', id: string, experimentPaymentPlan?: { __typename?: 'ExperimentTreatmentPaymentPlan', id: string, paymentPlan: ExperimentPaymentPlanVariant, discountPercentage: number } | null | undefined, experimentAvailablePaymentPlans: Array<{ __typename?: 'ExperimentAvailablePaymentPlan', paymentPlan: ExperimentPaymentPlanVariant, discountPercentage: number, months: number }>, otcSchedules: Array<{ __typename?: 'OtcSchedule', id: string, cadence: OtcScheduleCadence, quantity: number, isActive: boolean, product: { __typename?: 'Product', id: string } }> } | null | undefined, order?: { __typename?: 'Order', id: string, lineItems?: Array<{ __typename?: 'OrderLineItem', id: string, quantity: number, variant: { __typename?: 'Variant', id: string, price: number, product: { __typename?: 'Product', id: string, name: string, productType: ProductType, shortDescription?: string | null | undefined, photo?: { __typename?: 'File', id: string, url: string } | null | undefined } } }> | null | undefined } | null | undefined } | null | undefined };

export type PilotConsultationPayConfirmPageQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type PilotConsultationPayConfirmPageQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, stage: ConsultationStage, isUpfrontPayment: boolean, type: ProblemType } | null | undefined, profile?: { __typename?: 'User', id: string, email: string, shortAddressableName?: string | null | undefined, phone?: string | null | undefined } | null | undefined };

export type PilotConsultationPlanQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type PilotConsultationPlanQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, treatment?: { __typename?: 'Treatment', id: string, product: { __typename?: 'Product', id: string, variants: Array<{ __typename?: 'Variant', id: string, inventory?: { __typename?: 'VariantInventory', id: string, sku?: string | null | undefined } | null | undefined }> } } | null | undefined } | null | undefined };

export type PilotPracBookingConfirmationPageQueryVariables = Exact<{
  pracBookingId: Scalars['ID']['input'];
}>;


export type PilotPracBookingConfirmationPageQuery = { __typename?: 'Query', practitionerBooking?: { __typename?: 'PractitionerBooking', id: string, windowStartAt: string, windowEndAt: string, consultation?: { __typename?: 'Consultation', id: string, type: ProblemType } | null | undefined, patient?: { __typename?: 'User', id: string, email: string, phone?: string | null | undefined } | null | undefined } | null | undefined, validPhoneRegions?: Array<{ __typename?: 'ValidPhoneRegion', id: string, countryCode: string }> | null | undefined };

export type PilotPractitionerPhoneCallPageQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type PilotPractitionerPhoneCallPageQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, latestPractitionerBooking?: { __typename?: 'PractitionerBooking', id: string } | null | undefined } | null | undefined };

export type PilotRedirectPageQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type PilotRedirectPageQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, isApproved?: boolean | null | undefined, isUpfrontPayment: boolean, requiresPrescriberCall: boolean, allowPatientToSendMessageToDoctor: boolean, stage: ConsultationStage, status: ConsultationStatus, type: ProblemType, latestPractitionerBooking?: { __typename?: 'PractitionerBooking', id: string } | null | undefined, screeningQuizApplication?: { __typename?: 'QuizApplication', id: string, submittedAt?: string | null | undefined } | null | undefined, quizApplication?: { __typename?: 'QuizApplication', id: string } | null | undefined } | null | undefined };

export type PilotSchedulePhoneCallPageQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type PilotSchedulePhoneCallPageQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, latestPractitionerBooking?: { __typename?: 'PractitionerBooking', id: string } | null | undefined } | null | undefined };

export type TestResultsQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type TestResultsQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, patientNotes?: string | null | undefined, pathologyRequests?: Array<{ __typename?: 'PathologyRequest', id: string, createdAt: string, customerStatedCollectedAt?: string | null | undefined, result?: { __typename?: 'PathologyResult', id: string, lab: string, releasedAt?: string | null | undefined, file?: { __typename?: 'PathologyResultFile', id: string, url: string } | null | undefined } | null | undefined, referral?: { __typename?: 'PathologyReferral', id: string, url: string } | null | undefined, panels?: Array<{ __typename?: 'PathologyPanel', id: string, tests?: Array<{ __typename?: 'PathologyPanelTest', id: string, name: PathologyPanelTestNameKey, result?: { __typename?: 'PathologyPanelTestResult', id?: string | null | undefined, note?: string | null | undefined, result: { __typename?: 'PathologyPanelTestResultValue', type: PathologyPanelTestResultValueType, value?: string | null | undefined } } | null | undefined }> | null | undefined }> | null | undefined } | null | undefined> | null | undefined, doctor?: { __typename?: 'User', id: string, fullClinicianName: string, avatar?: { __typename?: 'File', id: string, url: string } | null | undefined, provider?: { __typename?: 'Provider', id: string, clinicianTitle: string, qualifications?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type PilotAccountSettingsFragment = { __typename?: 'User', id: string, email: string };

export type PilotProfilePageQueryVariables = Exact<{ [key: string]: never; }>;


export type PilotProfilePageQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, needsSubscriptionMigration?: boolean | null | undefined, firstName?: string | null | undefined, hasPaidMasterclass?: boolean | null | undefined, email: string, isBeingTreatedForWeight?: boolean | null | undefined, initialQuizApplications?: Array<{ __typename?: 'QuizApplication', id: string, createdAt: string, updatedAt: string, submittedAt?: string | null | undefined, purpose: QuizPurpose, problemType: ProblemType, archivedAt?: string | null | undefined, outcomes?: Array<{ __typename?: 'ArticleQuizOutcome', id: string } | { __typename?: 'BuyOtcQuizOutcome', id: string } | { __typename?: 'ConsultationQuizOutcome', id: string } | { __typename?: 'IncreaseUsageQuizOutcome', id: string } | { __typename?: 'NotEligibleQuizOutcome', id: string } | { __typename?: 'OtcQuizOutcome', id: string } | { __typename?: 'ReviewQuizOutcome', id: string } | { __typename?: 'SideEffectProactiveActionQuizOutcome', id: string } | { __typename?: 'ZendeskQuizOutcome', id: string }> | null | undefined }> | null | undefined, archivedQuizApplications?: Array<{ __typename?: 'QuizApplication', id: string, createdAt: string, updatedAt: string, submittedAt?: string | null | undefined, purpose: QuizPurpose, problemType: ProblemType, archivedAt?: string | null | undefined, outcomes?: Array<{ __typename?: 'ArticleQuizOutcome', id: string } | { __typename?: 'BuyOtcQuizOutcome', id: string } | { __typename?: 'ConsultationQuizOutcome', id: string } | { __typename?: 'IncreaseUsageQuizOutcome', id: string } | { __typename?: 'NotEligibleQuizOutcome', id: string } | { __typename?: 'OtcQuizOutcome', id: string } | { __typename?: 'ReviewQuizOutcome', id: string } | { __typename?: 'SideEffectProactiveActionQuizOutcome', id: string } | { __typename?: 'ZendeskQuizOutcome', id: string }> | null | undefined }> | null | undefined, consultations: Array<{ __typename?: 'Consultation', id: string, createdAt: string, type: ProblemType, stage: ConsultationStage, isApproved?: boolean | null | undefined, typeIsFlexi?: boolean | null | undefined, status: ConsultationStatus, practitionerMessagedAt?: string | null | undefined, requiresPrescriberCall: boolean, allowPatientToSendMessageToDoctor: boolean, isInNoPickUpQueue?: boolean | null | undefined, purchasePrompt?: { __typename?: 'ConfirmPurchasePrompt', id: string } | { __typename?: 'FurPurchasePrompt', id: string } | { __typename?: 'InitialPurchasePrompt', id: string } | { __typename?: 'RestartFlowPrompt', id: string } | { __typename?: 'SubstitutePurchasePrompt', id: string } | null | undefined, quizApplication?: { __typename?: 'QuizApplication', id: string, problemType: ProblemType, submittedAt?: string | null | undefined } | null | undefined, treatment?: { __typename?: 'Treatment', id: string, status: TreatmentStatus, active: boolean, pendingFollowUpReminderDate?: string | null | undefined, isLastOrderUnfulfilled: boolean, refillsLeft?: number | null | undefined, nextPayment?: string | null | undefined, canRefill: boolean, nextPaymentAmount?: number | null | undefined, type: ProblemType, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined }, otcSchedules: Array<{ __typename?: 'OtcSchedule', id: string, cadence: OtcScheduleCadence, quantity: number, isActive: boolean, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined, variants: Array<{ __typename?: 'Variant', id: string, price: number }> } }>, plan?: { __typename?: 'Plan', id: string, amount: number } | null | undefined } | null | undefined, pathologyRequests?: Array<{ __typename?: 'PathologyRequest', id: string, customerStatedCollectedAt?: string | null | undefined, result?: { __typename?: 'PathologyResult', id: string } | null | undefined } | null | undefined> | null | undefined, doctor?: { __typename?: 'User', id: string, fullName?: string | null | undefined, fullClinicianName: string } | null | undefined, chatThread?: { __typename?: 'ChatThread', id: string } | null | undefined, prescribedSequence?: { __typename?: 'PrescribedSequence', id: string } | null | undefined, screeningQuizApplication?: { __typename?: 'QuizApplication', id: string, submittedAt?: string | null | undefined } | null | undefined, latestPractitionerBooking?: { __typename?: 'PractitionerBooking', id: string, windowStartAt: string, windowEndAt: string } | null | undefined, reminders?: Array<{ __typename?: 'ConsultationReminder', id: string, canceled: boolean, doneAt?: string | null | undefined, scheduledAt: string }> | null | undefined, patientQuestions?: Array<{ __typename?: 'ConsultationPatientQuestion', id: string, createdAt: string }> | null | undefined }>, subscriptions?: Array<{ __typename?: 'SubscriptionV2', id: string, status: SubscriptionStatus, nextPaymentAt?: string | null | undefined, subscriptionPlan: { __typename?: 'SubscriptionPlanV2', id: string, name: string, interval: SubscriptionPlanInterval, intervalCount: number, price: number, photo: { __typename?: 'File', id: string, url: string } } }> | null | undefined, purchases?: Array<{ __typename?: 'Purchase', id: string, status: PurchaseStatus, problemType?: ProblemType | null | undefined, isVisibleInProfilePage?: boolean | null | undefined, contexts?: Array<{ __typename?: 'SequenceContext', id: string, status: SequenceContextStatus, consultations?: Array<{ __typename?: 'Consultation', id: string }> | null | undefined, sequence?: { __typename?: 'OtcSequence', id: string, products?: Array<{ __typename?: 'Product', id: string, productType: ProductType }> | null | undefined } | { __typename?: 'PrescribableSequence', id: string, products?: Array<{ __typename?: 'Product', id: string, productType: ProductType }> | null | undefined } | null | undefined }> | null | undefined, orderTimeline?: Array<{ __typename?: 'OrderTimelineItem', id: string, status: OrderTimelineItemStatus }> | null | undefined, offering?: { __typename?: 'AddOnOffering', id: string, friendlyName: string, problemTypes?: Array<ProblemType> | null | undefined } | { __typename?: 'OtcOffering', id: string, friendlyName: string, problemTypes?: Array<ProblemType> | null | undefined } | { __typename?: 'RxOffering', id: string, friendlyName: string, problemTypes?: Array<ProblemType> | null | undefined } | null | undefined, nextOrder?: { __typename?: 'OrderTimelineItem', id: string, date: string, totalAmount: number, products?: Array<{ __typename?: 'Product', id: string, friendlyName?: string | null | undefined, name: string }> | null | undefined } | null | undefined, availableActions?: Array<{ __typename?: 'PurchaseResumeAction', id: string }> | null | undefined }> | null | undefined } | null | undefined, treatments?: Array<{ __typename?: 'Treatment', id: string, refillsLeft?: number | null | undefined, nextPayment?: string | null | undefined, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined }, otcSchedules: Array<{ __typename?: 'OtcSchedule', id: string, cadence: OtcScheduleCadence, quantity: number, isActive: boolean, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined } }> }> | null | undefined, subscriptionPlans: Array<{ __typename?: 'SubscriptionPlan', id: string, amount?: number | null | undefined, interval: string, intervalCount: number, status: string, currentPeriodEnd: string, cancelAt?: string | null | undefined, product?: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined, photo?: { __typename?: 'File', id: string, url: string } | null | undefined } | null | undefined }> };

export type PilotSubscriptionsFragment = { __typename?: 'SubscriptionPlan', id: string, amount?: number | null | undefined, interval: string, intervalCount: number, status: string, currentPeriodEnd: string, cancelAt?: string | null | undefined, product?: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined, photo?: { __typename?: 'File', id: string, url: string } | null | undefined } | null | undefined };

export type PilotTreatmentStatusCardsQuizApplicationFragment = { __typename?: 'QuizApplication', id: string, submittedAt?: string | null | undefined, problemType: ProblemType, createdAt: string, archivedAt?: string | null | undefined, outcomes?: Array<{ __typename?: 'ArticleQuizOutcome', id: string } | { __typename?: 'BuyOtcQuizOutcome', id: string } | { __typename?: 'ConsultationQuizOutcome', id: string } | { __typename?: 'IncreaseUsageQuizOutcome', id: string } | { __typename?: 'NotEligibleQuizOutcome', id: string } | { __typename?: 'OtcQuizOutcome', id: string } | { __typename?: 'ReviewQuizOutcome', id: string } | { __typename?: 'SideEffectProactiveActionQuizOutcome', id: string } | { __typename?: 'ZendeskQuizOutcome', id: string }> | null | undefined };

export type PilotTreatmentStatusCardsConsultationFragment = { __typename?: 'Consultation', id: string, type: ProblemType, stage: ConsultationStage, createdAt: string, isApproved?: boolean | null | undefined, typeIsFlexi?: boolean | null | undefined, status: ConsultationStatus, practitionerMessagedAt?: string | null | undefined, requiresPrescriberCall: boolean, allowPatientToSendMessageToDoctor: boolean, isInNoPickUpQueue?: boolean | null | undefined, treatment?: { __typename?: 'Treatment', id: string, status: TreatmentStatus, active: boolean, pendingFollowUpReminderDate?: string | null | undefined, isLastOrderUnfulfilled: boolean, refillsLeft?: number | null | undefined, nextPayment?: string | null | undefined, canRefill: boolean, nextPaymentAmount?: number | null | undefined, type: ProblemType, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined }, otcSchedules: Array<{ __typename?: 'OtcSchedule', id: string, cadence: OtcScheduleCadence, quantity: number, isActive: boolean, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined, variants: Array<{ __typename?: 'Variant', id: string, price: number }> } }>, plan?: { __typename?: 'Plan', id: string, amount: number } | null | undefined } | null | undefined, purchasePrompt?: { __typename?: 'ConfirmPurchasePrompt', id: string } | { __typename?: 'FurPurchasePrompt', id: string } | { __typename?: 'InitialPurchasePrompt', id: string } | { __typename?: 'RestartFlowPrompt', id: string } | { __typename?: 'SubstitutePurchasePrompt', id: string } | null | undefined, quizApplication?: { __typename?: 'QuizApplication', id: string, problemType: ProblemType, submittedAt?: string | null | undefined } | null | undefined, pathologyRequests?: Array<{ __typename?: 'PathologyRequest', id: string, customerStatedCollectedAt?: string | null | undefined, result?: { __typename?: 'PathologyResult', id: string } | null | undefined } | null | undefined> | null | undefined, doctor?: { __typename?: 'User', id: string, fullName?: string | null | undefined, fullClinicianName: string } | null | undefined, chatThread?: { __typename?: 'ChatThread', id: string } | null | undefined, prescribedSequence?: { __typename?: 'PrescribedSequence', id: string } | null | undefined, screeningQuizApplication?: { __typename?: 'QuizApplication', id: string, submittedAt?: string | null | undefined } | null | undefined, latestPractitionerBooking?: { __typename?: 'PractitionerBooking', id: string, windowStartAt: string, windowEndAt: string } | null | undefined, reminders?: Array<{ __typename?: 'ConsultationReminder', id: string, canceled: boolean, doneAt?: string | null | undefined, scheduledAt: string }> | null | undefined, patientQuestions?: Array<{ __typename?: 'ConsultationPatientQuestion', id: string, createdAt: string }> | null | undefined };

export type PilotTreatmentStatusCardsTreatmentFragment = { __typename?: 'Treatment', id: string, refillsLeft?: number | null | undefined, nextPayment?: string | null | undefined, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined }, otcSchedules: Array<{ __typename?: 'OtcSchedule', id: string, cadence: OtcScheduleCadence, quantity: number, isActive: boolean, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined } }> };

export type PilotTreatmentStatusCardsPurchaseFragment = { __typename?: 'Purchase', id: string, problemType?: ProblemType | null | undefined, status: PurchaseStatus, isVisibleInProfilePage?: boolean | null | undefined, contexts?: Array<{ __typename?: 'SequenceContext', id: string, status: SequenceContextStatus, consultations?: Array<{ __typename?: 'Consultation', id: string }> | null | undefined, sequence?: { __typename?: 'OtcSequence', id: string, products?: Array<{ __typename?: 'Product', id: string, productType: ProductType }> | null | undefined } | { __typename?: 'PrescribableSequence', id: string, products?: Array<{ __typename?: 'Product', id: string, productType: ProductType }> | null | undefined } | null | undefined }> | null | undefined, orderTimeline?: Array<{ __typename?: 'OrderTimelineItem', id: string, status: OrderTimelineItemStatus }> | null | undefined, offering?: { __typename?: 'AddOnOffering', id: string, friendlyName: string, problemTypes?: Array<ProblemType> | null | undefined } | { __typename?: 'OtcOffering', id: string, friendlyName: string, problemTypes?: Array<ProblemType> | null | undefined } | { __typename?: 'RxOffering', id: string, friendlyName: string, problemTypes?: Array<ProblemType> | null | undefined } | null | undefined, nextOrder?: { __typename?: 'OrderTimelineItem', id: string, date: string, totalAmount: number, products?: Array<{ __typename?: 'Product', id: string, friendlyName?: string | null | undefined, name: string }> | null | undefined } | null | undefined, availableActions?: Array<{ __typename?: 'PurchaseResumeAction', id: string }> | null | undefined };

export type PilotQuizCompletePageQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type PilotQuizCompletePageQuery = { __typename?: 'Query', getQuizApplication?: { __typename?: 'QuizApplication', id: string, purpose: QuizPurpose, problemType: ProblemType, quiz: { __typename?: 'Quiz', id: string, default: boolean, quizCode: string }, consultation?: { __typename?: 'Consultation', id: string, status: ConsultationStatus, stage: ConsultationStage, type: ProblemType, isUpfrontPayment: boolean, canSchedulePractitionerBooking: boolean } | null | undefined, outcomes?: Array<{ __typename?: 'ArticleQuizOutcome', id: string } | { __typename?: 'BuyOtcQuizOutcome', id: string } | { __typename?: 'ConsultationQuizOutcome', id: string } | { __typename?: 'IncreaseUsageQuizOutcome', id: string } | { __typename?: 'NotEligibleQuizOutcome', id: string } | { __typename?: 'OtcQuizOutcome', id: string } | { __typename?: 'ReviewQuizOutcome', id: string } | { __typename?: 'SideEffectProactiveActionQuizOutcome', id: string } | { __typename?: 'ZendeskQuizOutcome', id: string }> | null | undefined } | null | undefined, profile?: { __typename?: 'User', id: string, phone?: string | null | undefined, isPasswordSet: boolean } | null | undefined };

export type PilotAsyncEligibleQuizCompletePageQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
  problemType: ProblemType;
}>;


export type PilotAsyncEligibleQuizCompletePageQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, customer: { __typename?: 'User', id: string, condition?: { __typename?: 'Condition', id: string, asyncEligible?: boolean | null | undefined } | null | undefined } } | null | undefined };

export type PilotProfileTreatmentHelpPageQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type PilotProfileTreatmentHelpPageQuery = { __typename?: 'Query', treatment?: { __typename?: 'Treatment', id: string, status: TreatmentStatus, weightTreatmentCategory?: WeightTreatmentCategory | null | undefined, type: ProblemType, nextPayment?: string | null | undefined, canPause: boolean, experimentPaymentPlan?: { __typename?: 'ExperimentTreatmentPaymentPlan', id: string } | null | undefined, consultation?: { __typename?: 'Consultation', id: string, status: ConsultationStatus } | null | undefined, product: { __typename?: 'Product', id: string, faqs: Array<{ __typename?: 'Faq', id: string, title?: string | null | undefined, markdown?: string | null | undefined, videoEmbedUrl?: string | null | undefined }> }, customer: { __typename?: 'User', id: string, email: string } } | null | undefined };

export type PilotTreatmentPlanPageQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type PilotTreatmentPlanPageQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string } | null | undefined, treatment?: { __typename?: 'Treatment', id: string, updatedAt: string, status: TreatmentStatus, type: ProblemType, canRefill: boolean, nextPayment?: string | null | undefined, refillsLeft?: number | null | undefined, hasUnfulfilledOrder: boolean, canPause: boolean, canReschedule: boolean, weightTreatmentCategory?: WeightTreatmentCategory | null | undefined, consultation?: { __typename?: 'Consultation', id: string, isUpfrontPayment: boolean, type: ProblemType, treatment?: { __typename?: 'Treatment', id: string, experimentPaymentPlan?: { __typename?: 'ExperimentTreatmentPaymentPlan', id: string, paymentPlan: ExperimentPaymentPlanVariant, discountPercentage: number } | null | undefined, experimentAvailablePaymentPlans: Array<{ __typename?: 'ExperimentAvailablePaymentPlan', paymentPlan: ExperimentPaymentPlanVariant, discountPercentage: number, months: number }>, otcSchedules: Array<{ __typename?: 'OtcSchedule', id: string, cadence: OtcScheduleCadence, quantity: number, isActive: boolean, product: { __typename?: 'Product', id: string } }> } | null | undefined, order?: { __typename?: 'Order', id: string, lineItems?: Array<{ __typename?: 'OrderLineItem', id: string, quantity: number, variant: { __typename?: 'Variant', id: string, price: number, product: { __typename?: 'Product', id: string, name: string, productType: ProductType, shortDescription?: string | null | undefined, photo?: { __typename?: 'File', id: string, url: string } | null | undefined } } }> | null | undefined } | null | undefined, doctor?: { __typename?: 'User', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, fullClinicianName: string, fullName?: string | null | undefined } | null | undefined } | null | undefined, treatmentDiscount?: { __typename?: 'TreatmentDiscount', id: string, discountCode?: { __typename?: 'DiscountCode', id: string, code: string, amount: number, stages: Array<DiscountStage>, type: DiscountType, products: Array<{ __typename?: 'Product', id: string, variants: Array<{ __typename?: 'Variant', id: string }> }> } | null | undefined } | null | undefined, customer: { __typename?: 'User', id: string, email: string }, plan?: { __typename?: 'Plan', id: string, amount: number, products: Array<{ __typename?: 'Product', id: string, variants: Array<{ __typename?: 'Variant', id: string, inventory?: { __typename?: 'VariantInventory', id: string, sku?: string | null | undefined } | null | undefined }> }> } | null | undefined, product: { __typename?: 'Product', id: string, name: string, description?: string | null | undefined, safetyInformation?: string | null | undefined, friendlyName?: string | null | undefined, productType: ProductType, drug?: { __typename?: 'Drug', id: string, name?: string | null | undefined } | null | undefined, variants: Array<{ __typename?: 'Variant', id: string, price: number, inventory?: { __typename?: 'VariantInventory', id: string, sku?: string | null | undefined } | null | undefined }>, faqs: Array<{ __typename?: 'Faq', id: string, title?: string | null | undefined, markdown?: string | null | undefined }>, cmi?: { __typename?: 'File', id: string, url: string } | null | undefined, photo?: { __typename?: 'File', id: string, url: string } | null | undefined }, script?: { __typename?: 'Script', id: string, createdAt: string } | null | undefined, orders: Array<{ __typename?: 'Order', id: string, fulfillment?: FulfillmentStatus | null | undefined, updatedAt: string }>, otcSchedules: Array<{ __typename?: 'OtcSchedule', id: string, createdAt: string, updatedAt: string, cadence: OtcScheduleCadence, isActive: boolean, quantity: number, product: { __typename?: 'Product', id: string, name: string, productType: ProductType, variants: Array<{ __typename?: 'Variant', id: string, price: number }>, photo?: { __typename?: 'File', id: string, url: string } | null | undefined } }>, experimentPaymentPlan?: { __typename?: 'ExperimentTreatmentPaymentPlan', id: string, nextPaymentAmount: number, planEndDate?: string | null | undefined, paymentPlan: ExperimentPaymentPlanVariant, discountPercentage: number, months?: number | null | undefined, otcSchedules?: Array<{ __typename?: 'OtcSchedule', id: string, product: { __typename?: 'Product', id: string, name: string } }> | null | undefined } | null | undefined, experimentAvailablePaymentPlans: Array<{ __typename?: 'ExperimentAvailablePaymentPlan', paymentPlan: ExperimentPaymentPlanVariant, cadence: string }> } | null | undefined };

export type ConsultationInfoSoftwareFragment = { __typename?: 'Consultation', id: string, type: ProblemType, status: ConsultationStatus, isApproved?: boolean | null | undefined, stage: ConsultationStage, isUpfrontPayment: boolean, patientNotes?: string | null | undefined, rejectReason?: string | null | undefined, completedAt?: string | null | undefined, createdAt: string, patientQuestions?: Array<{ __typename?: 'ConsultationPatientQuestion', id: string, createdAt: string, updatedAt: string, value: string }> | null | undefined, treatment?: { __typename?: 'Treatment', id: string, status: TreatmentStatus, refillsLeft?: number | null | undefined, otcSchedules: Array<{ __typename?: 'OtcSchedule', id: string, productId: string, createdAt: string, updatedAt: string, cadence: OtcScheduleCadence, isActive: boolean, quantity: number, product: { __typename?: 'Product', id: string, name: string, variants: Array<{ __typename?: 'Variant', id: string, price: number }> } }>, plan?: { __typename?: 'Plan', id: string, amount: number } | null | undefined, product: { __typename?: 'Product', id: string, name: string, productType: ProductType, safetyInformation?: string | null | undefined, photo?: { __typename?: 'File', id: string, url: string } | null | undefined, cmi?: { __typename?: 'File', id: string, url: string } | null | undefined, plan?: { __typename?: 'Plan', id: string, intervalCount: number, interval: BillingInterval } | null | undefined, faqs: Array<{ __typename?: 'Faq', id: string, title?: string | null | undefined, markdown?: string | null | undefined }>, variants: Array<{ __typename?: 'Variant', id: string, price: number, isRefill: boolean }> } } | null | undefined, customer: { __typename?: 'User', id: string, firstName?: string | null | undefined }, doctorQuestions?: Array<{ __typename?: 'ConsultationQuestion', id: string, createdAt: string, updatedAt: string, value: string, allowedAnswerType: ConsultationAnswerType, answer?: { __typename?: 'ConsultationAnswer', id: string, createdAt: string, updatedAt: string, value: string } | null | undefined }> | null | undefined, doctor?: { __typename?: 'User', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, shortClinicianName: string, fullClinicianName: string, fullName?: string | null | undefined, role: UserRole, bio?: string | null | undefined, avatar?: { __typename?: 'File', id: string, createdAt: string, updatedAt: string, filename: string, mimetype: string, url: string } | null | undefined, provider?: { __typename?: 'Provider', id: string, clinicianType: ClinicianType, clinicianTitle: string } | null | undefined } | null | undefined, quizApplication?: { __typename?: 'QuizApplication', id: string, answers: Array<{ __typename?: 'QuizApplicationResponse', id: string, answer?: string | null | undefined, answersArray: Array<string>, question?: { __typename?: 'QuizQuestion', id: string, shortcode?: string | null | undefined } | null | undefined }>, quiz: { __typename?: 'Quiz', id: string, questionsOrder: Array<string>, questions: Array<{ __typename?: 'QuizQuestion', id: string, title?: string | null | undefined, type: QuizQuestionType, description?: string | null | undefined, required: boolean, options?: any | null | undefined, imgUrl?: string | null | undefined, shortcode?: string | null | undefined, questionOptions: Array<{ __typename?: 'QuizQuestionOption', id: string, questionId: string, option?: string | null | undefined, position?: number | null | undefined }> }>, logics: Array<{ __typename?: 'QuizLogic', id: string, from: { __typename?: 'QuizQuestion', id: string }, elseJump: { __typename?: 'QuizQuestion', id: string }, jumps: Array<{ __typename?: 'QuizJump', id: string, conditions: Array<{ __typename?: 'QuizConditions', id: string, value: string, operator: QuizJumpOperator, nextCondition?: QuizValidationCondition | null | undefined, question: { __typename?: 'QuizQuestion', id: string } }>, to: { __typename?: 'QuizQuestion', id: string } }> }>, skips: Array<{ __typename?: 'QuizSkip', id: string, from: { __typename?: 'QuizQuestion', id: string }, conditions: Array<{ __typename?: 'QuizConditions', id: string, value: string, operator: QuizJumpOperator, nextCondition?: QuizValidationCondition | null | undefined, question: { __typename?: 'QuizQuestion', id: string } }> }> } } | null | undefined, order?: { __typename?: 'Order', id: string, lineItems?: Array<{ __typename?: 'OrderLineItem', id: string, quantity: number, variant: { __typename?: 'Variant', id: string, price: number, product: { __typename?: 'Product', id: string, name: string, productType: ProductType } } }> | null | undefined } | null | undefined };

export type TreatmentInfoSoftwareFragment = { __typename?: 'Treatment', id: string, type: ProblemType, refillsLeft?: number | null | undefined, canReschedule: boolean, canRefill: boolean, cooldownActiveUntil?: string | null | undefined, canReview: boolean, nextPayment?: string | null | undefined, status: TreatmentStatus, treatmentDiscount?: { __typename?: 'TreatmentDiscount', id: string, discountCode?: { __typename?: 'DiscountCode', id: string, code: string, amount: number, stages: Array<DiscountStage>, type: DiscountType, products: Array<{ __typename?: 'Product', id: string, variants: Array<{ __typename?: 'Variant', id: string }> }> } | null | undefined } | null | undefined, plan?: { __typename?: 'Plan', id: string, amount: number } | null | undefined, otcSchedules: Array<{ __typename?: 'OtcSchedule', id: string, isActive: boolean, cadence: OtcScheduleCadence, quantity: number, product: { __typename?: 'Product', id: string, name: string, productType: ProductType, photo?: { __typename?: 'File', id: string, url: string } | null | undefined, variants: Array<{ __typename?: 'Variant', id: string, price: number }> } }>, consultation?: { __typename?: 'Consultation', id: string, patientNotes?: string | null | undefined, doctor?: { __typename?: 'User', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, shortClinicianName: string, fullClinicianName: string, fullName?: string | null | undefined, role: UserRole, bio?: string | null | undefined, avatar?: { __typename?: 'File', id: string, createdAt: string, updatedAt: string, filename: string, mimetype: string, url: string } | null | undefined, provider?: { __typename?: 'Provider', id: string, clinicianTitle: string, clinicianType: ClinicianType, qualifications?: string | null | undefined } | null | undefined } | null | undefined, quizApplication?: { __typename?: 'QuizApplication', id: string, answers: Array<{ __typename?: 'QuizApplicationResponse', id: string, answer?: string | null | undefined, answersArray: Array<string>, question?: { __typename?: 'QuizQuestion', id: string, shortcode?: string | null | undefined } | null | undefined }> } | null | undefined, order?: { __typename?: 'Order', id: string, lineItems?: Array<{ __typename?: 'OrderLineItem', id: string, quantity: number, variant: { __typename?: 'Variant', id: string, price: number, product: { __typename?: 'Product', id: string, name: string, productType: ProductType } } }> | null | undefined } | null | undefined } | null | undefined, product: { __typename?: 'Product', id: string, name: string, productType: ProductType, instructions?: string | null | undefined, safetyInformation?: string | null | undefined, photo?: { __typename?: 'File', id: string, url: string } | null | undefined, faqs: Array<{ __typename?: 'Faq', id: string, title?: string | null | undefined, markdown?: string | null | undefined }>, cmi?: { __typename?: 'File', id: string, url: string } | null | undefined } };

export type UserInfoSoftwareFragment = { __typename?: 'User', id: string, email: string, firstName?: string | null | undefined, lastName?: string | null | undefined, legalFirstName?: string | null | undefined, legalLastName?: string | null | undefined, phone?: string | null | undefined, role: UserRole, isPasswordSet: boolean, defaultPaymentGateway?: PaymentGateway | null | undefined, birthday?: string | null | undefined, zip?: { __typename?: 'Zip', valid: boolean } | null | undefined, residentialAddress?: { __typename?: 'ResidentialAddress', id: string, line1: string, line2?: string | null | undefined, city: string, postalCode: string, state?: string | null | undefined, country: string, company?: string | null | undefined, building?: string | null | undefined } | null | undefined, address?: { __typename?: 'Address', id: string, line1?: string | null | undefined, line2?: string | null | undefined, city?: string | null | undefined, postalCode?: string | null | undefined, state?: string | null | undefined, country?: string | null | undefined, company?: string | null | undefined, building?: string | null | undefined } | null | undefined, savedPaymentMethods?: Array<{ __typename?: 'SavedCardPaymentMethod', brand: string, expiry: string, mask: string, id: string, gateway: PaymentGateway, default: boolean } | { __typename?: 'SavedPayPalPaymentMethod', email?: string | null | undefined, id: string, gateway: PaymentGateway, default: boolean } | { __typename?: 'SavedSofortPaymentMethod', id: string, gateway: PaymentGateway, default: boolean } | { __typename?: 'SavedZipPaymentMethod', valid: boolean, id: string, gateway: PaymentGateway, default: boolean } | null | undefined> | null | undefined };

export type ProgressEntriesQueryVariables = Exact<{
  type: ProgressEntryType;
}>;


export type ProgressEntriesQuery = { __typename?: 'Query', progressEntries: Array<{ __typename?: 'ProgressEntry', date: string, userId: string, type: ProgressEntryType, id: string, photos?: Array<{ __typename?: 'ProgressEntryPhoto', id: string, angle: PhotoAngleType, signedUrl: string } | null | undefined> | null | undefined, responses?: Array<{ __typename?: 'ProgressEntryResponse', id: string, answer: string, questionCode: ProgressEntryQuestionCodeType } | null | undefined> | null | undefined }> };

export type SoftwareAsyncConsultConfirmedPageQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type SoftwareAsyncConsultConfirmedPageQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, type: ProblemType, requiresPrescriberCall: boolean } | null | undefined };

export type SoftwareAsyncEligibleMedicarePageQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
  problemType: ProblemType;
}>;


export type SoftwareAsyncEligibleMedicarePageQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, customer: { __typename?: 'User', id: string, condition?: { __typename?: 'Condition', id: string, asyncEligible?: boolean | null | undefined } | null | undefined } } | null | undefined };

export type ConsultationConfirmationRootQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ConsultationConfirmationRootQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, type: ProblemType, screeningQuizApplication?: { __typename?: 'QuizApplication', id: string } | null | undefined } | null | undefined };

export type CreateAccountSoftwarePageQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type CreateAccountSoftwarePageQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, type: ProblemType } | null | undefined };

export type FollowUpConsultationSoftwareQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type FollowUpConsultationSoftwareQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, type: ProblemType, status: ConsultationStatus, isApproved?: boolean | null | undefined, stage: ConsultationStage, isUpfrontPayment: boolean, patientNotes?: string | null | undefined, rejectReason?: string | null | undefined, completedAt?: string | null | undefined, createdAt: string, patientQuestions?: Array<{ __typename?: 'ConsultationPatientQuestion', id: string, createdAt: string, updatedAt: string, value: string }> | null | undefined, treatment?: { __typename?: 'Treatment', id: string, status: TreatmentStatus, refillsLeft?: number | null | undefined, otcSchedules: Array<{ __typename?: 'OtcSchedule', id: string, productId: string, createdAt: string, updatedAt: string, cadence: OtcScheduleCadence, isActive: boolean, quantity: number, product: { __typename?: 'Product', id: string, name: string, variants: Array<{ __typename?: 'Variant', id: string, price: number }> } }>, plan?: { __typename?: 'Plan', id: string, amount: number } | null | undefined, product: { __typename?: 'Product', id: string, name: string, productType: ProductType, safetyInformation?: string | null | undefined, photo?: { __typename?: 'File', id: string, url: string } | null | undefined, cmi?: { __typename?: 'File', id: string, url: string } | null | undefined, plan?: { __typename?: 'Plan', id: string, intervalCount: number, interval: BillingInterval } | null | undefined, faqs: Array<{ __typename?: 'Faq', id: string, title?: string | null | undefined, markdown?: string | null | undefined }>, variants: Array<{ __typename?: 'Variant', id: string, price: number, isRefill: boolean }> } } | null | undefined, customer: { __typename?: 'User', id: string, firstName?: string | null | undefined }, doctorQuestions?: Array<{ __typename?: 'ConsultationQuestion', id: string, createdAt: string, updatedAt: string, value: string, allowedAnswerType: ConsultationAnswerType, answer?: { __typename?: 'ConsultationAnswer', id: string, createdAt: string, updatedAt: string, value: string } | null | undefined }> | null | undefined, doctor?: { __typename?: 'User', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, shortClinicianName: string, fullClinicianName: string, fullName?: string | null | undefined, role: UserRole, bio?: string | null | undefined, avatar?: { __typename?: 'File', id: string, createdAt: string, updatedAt: string, filename: string, mimetype: string, url: string } | null | undefined, provider?: { __typename?: 'Provider', id: string, clinicianType: ClinicianType, clinicianTitle: string } | null | undefined } | null | undefined, quizApplication?: { __typename?: 'QuizApplication', id: string, answers: Array<{ __typename?: 'QuizApplicationResponse', id: string, answer?: string | null | undefined, answersArray: Array<string>, question?: { __typename?: 'QuizQuestion', id: string, shortcode?: string | null | undefined } | null | undefined }>, quiz: { __typename?: 'Quiz', id: string, questionsOrder: Array<string>, questions: Array<{ __typename?: 'QuizQuestion', id: string, title?: string | null | undefined, type: QuizQuestionType, description?: string | null | undefined, required: boolean, options?: any | null | undefined, imgUrl?: string | null | undefined, shortcode?: string | null | undefined, questionOptions: Array<{ __typename?: 'QuizQuestionOption', id: string, questionId: string, option?: string | null | undefined, position?: number | null | undefined }> }>, logics: Array<{ __typename?: 'QuizLogic', id: string, from: { __typename?: 'QuizQuestion', id: string }, elseJump: { __typename?: 'QuizQuestion', id: string }, jumps: Array<{ __typename?: 'QuizJump', id: string, conditions: Array<{ __typename?: 'QuizConditions', id: string, value: string, operator: QuizJumpOperator, nextCondition?: QuizValidationCondition | null | undefined, question: { __typename?: 'QuizQuestion', id: string } }>, to: { __typename?: 'QuizQuestion', id: string } }> }>, skips: Array<{ __typename?: 'QuizSkip', id: string, from: { __typename?: 'QuizQuestion', id: string }, conditions: Array<{ __typename?: 'QuizConditions', id: string, value: string, operator: QuizJumpOperator, nextCondition?: QuizValidationCondition | null | undefined, question: { __typename?: 'QuizQuestion', id: string } }> }> } } | null | undefined, order?: { __typename?: 'Order', id: string, lineItems?: Array<{ __typename?: 'OrderLineItem', id: string, quantity: number, variant: { __typename?: 'Variant', id: string, price: number, product: { __typename?: 'Product', id: string, name: string, productType: ProductType } } }> | null | undefined } | null | undefined } | null | undefined };

export type PaymentProfileSoftwareQueryVariables = Exact<{ [key: string]: never; }>;


export type PaymentProfileSoftwareQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, email: string, firstName?: string | null | undefined, lastName?: string | null | undefined, legalFirstName?: string | null | undefined, legalLastName?: string | null | undefined, phone?: string | null | undefined, role: UserRole, isPasswordSet: boolean, defaultPaymentGateway?: PaymentGateway | null | undefined, birthday?: string | null | undefined, zip?: { __typename?: 'Zip', valid: boolean } | null | undefined, residentialAddress?: { __typename?: 'ResidentialAddress', id: string, line1: string, line2?: string | null | undefined, city: string, postalCode: string, state?: string | null | undefined, country: string, company?: string | null | undefined, building?: string | null | undefined } | null | undefined, address?: { __typename?: 'Address', id: string, line1?: string | null | undefined, line2?: string | null | undefined, city?: string | null | undefined, postalCode?: string | null | undefined, state?: string | null | undefined, country?: string | null | undefined, company?: string | null | undefined, building?: string | null | undefined } | null | undefined, savedPaymentMethods?: Array<{ __typename?: 'SavedCardPaymentMethod', brand: string, expiry: string, mask: string, id: string, gateway: PaymentGateway, default: boolean } | { __typename?: 'SavedPayPalPaymentMethod', email?: string | null | undefined, id: string, gateway: PaymentGateway, default: boolean } | { __typename?: 'SavedSofortPaymentMethod', id: string, gateway: PaymentGateway, default: boolean } | { __typename?: 'SavedZipPaymentMethod', valid: boolean, id: string, gateway: PaymentGateway, default: boolean } | null | undefined> | null | undefined } | null | undefined };

export type UpdateProfilePaymentSoftwareMutationVariables = Exact<{
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  birthday?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateProfilePaymentSoftwareMutation = { __typename?: 'Mutation', updateProfile?: { __typename?: 'User', id: string } | null | undefined };

export type PayConsultationPaymentSoftwareMutationVariables = Exact<{
  id: Scalars['String']['input'];
  couponCode?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  gateway?: InputMaybe<PaymentGateway>;
  zipCheckoutId?: InputMaybe<Scalars['String']['input']>;
  method?: InputMaybe<Scalars['String']['input']>;
}>;


export type PayConsultationPaymentSoftwareMutation = { __typename?: 'Mutation', payConsultation?: { __typename?: 'Consultation', id: string } | null | undefined };

export type InitiateZipConsultationPaymentMutationVariables = Exact<{
  consultationId: Scalars['String']['input'];
  redirectUrl: Scalars['String']['input'];
  couponCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type InitiateZipConsultationPaymentMutation = { __typename?: 'Mutation', initiateZipConsultationPayment?: { __typename?: 'ZipCheckoutResponse', redirectUrl: string } | null | undefined };

export type SoftwareConsultationPlanQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type SoftwareConsultationPlanQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, type: ProblemType, requiresPrescriberCall: boolean } | null | undefined };

export type SoftwarePracBookingConfirmationPageQueryVariables = Exact<{
  pracBookingId: Scalars['ID']['input'];
}>;


export type SoftwarePracBookingConfirmationPageQuery = { __typename?: 'Query', practitionerBooking?: { __typename?: 'PractitionerBooking', id: string, windowStartAt: string, windowEndAt: string, consultation?: { __typename?: 'Consultation', id: string } | null | undefined, patient?: { __typename?: 'User', id: string, email: string, phone?: string | null | undefined } | null | undefined } | null | undefined, validPhoneRegions?: Array<{ __typename?: 'ValidPhoneRegion', id: string, countryCode: string }> | null | undefined };

export type SoftwarePractitionerPhoneCallPageQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type SoftwarePractitionerPhoneCallPageQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, latestPractitionerBooking?: { __typename?: 'PractitionerBooking', id: string } | null | undefined } | null | undefined };

export type RegimenVariationQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type RegimenVariationQuery = { __typename?: 'Query', skinRegimen?: { __typename?: 'SkinRegimen', skinType?: SkinType | null | undefined, primarySkinGoal?: SkinGoal | null | undefined, unorderedSkinGoals?: Array<SkinGoal> | null | undefined, skinGoalBasedRecommendedOTC?: Array<{ __typename?: 'Product', id: string, name: string, description?: string | null | undefined, shortDescription?: string | null | undefined, photo?: { __typename?: 'File', id: string, url: string } | null | undefined, variants: Array<{ __typename?: 'Variant', id: string, name: string, price: number, inventory?: { __typename?: 'VariantInventory', id: string, sku?: string | null | undefined } | null | undefined }> }> | null | undefined, restOfRange?: Array<{ __typename?: 'Product', id: string, name: string, description?: string | null | undefined, shortDescription?: string | null | undefined, photo?: { __typename?: 'File', id: string, url: string } | null | undefined, variants: Array<{ __typename?: 'Variant', id: string, name: string, price: number, inventory?: { __typename?: 'VariantInventory', id: string, sku?: string | null | undefined } | null | undefined }> }> | null | undefined } | null | undefined };

export type SoftwareSchedulePhoneCallPageQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type SoftwareSchedulePhoneCallPageQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, latestPractitionerBooking?: { __typename?: 'PractitionerBooking', id: string } | null | undefined } | null | undefined };

export type ConfirmOrderSoftwareMutationVariables = Exact<{
  consultationId: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  address: AddressCreateWithoutUserInput;
  phone?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  gateway?: InputMaybe<PaymentGateway>;
  zipCheckoutId?: InputMaybe<Scalars['String']['input']>;
  couponCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type ConfirmOrderSoftwareMutation = { __typename?: 'Mutation', confirmOrder?: { __typename?: 'Order', id: string } | null | undefined };

export type InitiateZipCheckoutSoftwareMutationVariables = Exact<{
  redirectUrl: Scalars['String']['input'];
  address: AddressCreateWithoutUserInput;
  orderId: Scalars['String']['input'];
  couponCode?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
}>;


export type InitiateZipCheckoutSoftwareMutation = { __typename?: 'Mutation', initiateZipCheckout?: { __typename?: 'ZipCheckoutResponse', redirectUrl: string } | null | undefined };

export type ShippingContainerProfileSoftwareQueryVariables = Exact<{ [key: string]: never; }>;


export type ShippingContainerProfileSoftwareQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, email: string, firstName?: string | null | undefined, lastName?: string | null | undefined, legalFirstName?: string | null | undefined, legalLastName?: string | null | undefined, phone?: string | null | undefined, role: UserRole, isPasswordSet: boolean, defaultPaymentGateway?: PaymentGateway | null | undefined, birthday?: string | null | undefined, zip?: { __typename?: 'Zip', valid: boolean } | null | undefined, residentialAddress?: { __typename?: 'ResidentialAddress', id: string, line1: string, line2?: string | null | undefined, city: string, postalCode: string, state?: string | null | undefined, country: string, company?: string | null | undefined, building?: string | null | undefined } | null | undefined, address?: { __typename?: 'Address', id: string, line1?: string | null | undefined, line2?: string | null | undefined, city?: string | null | undefined, postalCode?: string | null | undefined, state?: string | null | undefined, country?: string | null | undefined, company?: string | null | undefined, building?: string | null | undefined } | null | undefined, savedPaymentMethods?: Array<{ __typename?: 'SavedCardPaymentMethod', brand: string, expiry: string, mask: string, id: string, gateway: PaymentGateway, default: boolean } | { __typename?: 'SavedPayPalPaymentMethod', email?: string | null | undefined, id: string, gateway: PaymentGateway, default: boolean } | { __typename?: 'SavedSofortPaymentMethod', id: string, gateway: PaymentGateway, default: boolean } | { __typename?: 'SavedZipPaymentMethod', valid: boolean, id: string, gateway: PaymentGateway, default: boolean } | null | undefined> | null | undefined } | null | undefined };

export type SoftwareEducationReadingQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SoftwareEducationReadingQuery = { __typename?: 'Query', educationReading?: { __typename?: 'EducationReading', id: string, content: any, timeToReadMs?: number | null | undefined } | null | undefined };

export type SoftwareEducationCollectionQueryVariables = Exact<{
  essentialId: Scalars['ID']['input'];
  treatmentId: Scalars['ID']['input'];
  skincareId: Scalars['ID']['input'];
  sideEffectsId: Scalars['ID']['input'];
  progressId: Scalars['ID']['input'];
}>;


export type SoftwareEducationCollectionQuery = { __typename?: 'Query', collectionEssentialReading?: { __typename?: 'EducationCollection', id: string, name: string, description?: string | null | undefined, readings?: Array<{ __typename?: 'EducationReading', id: string, content: any, completedAt?: string | null | undefined, startedAt?: string | null | undefined, timeToReadMs?: number | null | undefined }> | null | undefined } | null | undefined, collectionTreatment?: { __typename?: 'EducationCollection', id: string, name: string, description?: string | null | undefined, readings?: Array<{ __typename?: 'EducationReading', id: string, content: any, completedAt?: string | null | undefined, startedAt?: string | null | undefined, timeToReadMs?: number | null | undefined }> | null | undefined } | null | undefined, collectionSkinCare?: { __typename?: 'EducationCollection', id: string, name: string, description?: string | null | undefined, readings?: Array<{ __typename?: 'EducationReading', id: string, content: any, completedAt?: string | null | undefined, startedAt?: string | null | undefined, timeToReadMs?: number | null | undefined }> | null | undefined } | null | undefined, collectionSideEffects?: { __typename?: 'EducationCollection', id: string, name: string, description?: string | null | undefined, readings?: Array<{ __typename?: 'EducationReading', id: string, content: any, completedAt?: string | null | undefined, startedAt?: string | null | undefined, timeToReadMs?: number | null | undefined }> | null | undefined } | null | undefined, collectionProgress?: { __typename?: 'EducationCollection', id: string, name: string, description?: string | null | undefined, readings?: Array<{ __typename?: 'EducationReading', id: string, content: any, completedAt?: string | null | undefined, startedAt?: string | null | undefined, timeToReadMs?: number | null | undefined }> | null | undefined } | null | undefined };

export type EducationCollectionFragment = { __typename?: 'EducationCollection', id: string, name: string, description?: string | null | undefined, readings?: Array<{ __typename?: 'EducationReading', id: string, content: any, completedAt?: string | null | undefined, startedAt?: string | null | undefined, timeToReadMs?: number | null | undefined }> | null | undefined };

export type UpdateShippingMutationVariables = Exact<{
  address: AddressCreateWithoutUserInput;
}>;


export type UpdateShippingMutation = { __typename?: 'Mutation', updateShipping?: { __typename?: 'User', id: string, address?: { __typename?: 'Address', id: string, line1?: string | null | undefined, line2?: string | null | undefined, city?: string | null | undefined, postalCode?: string | null | undefined, state?: string | null | undefined, country?: string | null | undefined, building?: string | null | undefined, company?: string | null | undefined } | null | undefined } | null | undefined };

export type UpdateProfileUserDetailsSoftwareMutationVariables = Exact<{
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  namePreference?: InputMaybe<NamePreferenceCreateWithoutUserInput>;
}>;


export type UpdateProfileUserDetailsSoftwareMutation = { __typename?: 'Mutation', updateProfile?: { __typename?: 'User', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, email: string, shortAddressableName?: string | null | undefined, fullName?: string | null | undefined, phone?: string | null | undefined, preferredName?: string | null | undefined } | null | undefined };

export type SoftwareProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type SoftwareProfileQuery = { __typename?: 'Query', consultations?: Array<{ __typename?: 'Consultation', id: string, type: ProblemType, treatment?: { __typename?: 'Treatment', id: string, status: TreatmentStatus, hasUnfulfilledOrder: boolean, type: ProblemType } | null | undefined }> | null | undefined };

export type UserProfileWithConsultationsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserProfileWithConsultationsQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, firstName?: string | null | undefined, consultations: Array<{ __typename?: 'Consultation', id: string, type: ProblemType, createdAt: string, completedAt?: string | null | undefined, treatment?: { __typename?: 'Treatment', id: string, customerStatedTreatmentStartedAt?: string | null | undefined } | null | undefined }> } | null | undefined };

export type RefillTreatmentRestartTreatmentSoftwareMutationVariables = Exact<{
  treatmentId: Scalars['String']['input'];
}>;


export type RefillTreatmentRestartTreatmentSoftwareMutation = { __typename?: 'Mutation', refillTreatment?: { __typename?: 'Treatment', id: string, status: TreatmentStatus, refillsLeft?: number | null | undefined, nextPayment?: string | null | undefined } | null | undefined };

export type ProductListTreatmentSoftwareQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ProductListTreatmentSoftwareQuery = { __typename?: 'Query', treatment?: { __typename?: 'Treatment', id: string, otcSchedules: Array<{ __typename?: 'OtcSchedule', id: string, cadence: OtcScheduleCadence, isActive: boolean }> } | null | undefined };

export type SupportPageQueryVariables = Exact<{ [key: string]: never; }>;


export type SupportPageQuery = { __typename?: 'Query', treatments?: Array<{ __typename?: 'Treatment', id: string, type: ProblemType, status: TreatmentStatus, product: { __typename?: 'Product', id: string, faqs: Array<{ __typename?: 'Faq', id: string, title?: string | null | undefined, markdown?: string | null | undefined }> } }> | null | undefined };

export type EducationCardCollectionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EducationCardCollectionQuery = { __typename?: 'Query', educationCollection?: { __typename?: 'EducationCollection', id: string, name: string, description?: string | null | undefined, readings?: Array<{ __typename?: 'EducationReading', id: string, content: any, completedAt?: string | null | undefined, startedAt?: string | null | undefined, timeToReadMs?: number | null | undefined }> | null | undefined } | null | undefined };

export type SoftwareProfileHomeQueryVariables = Exact<{ [key: string]: never; }>;


export type SoftwareProfileHomeQuery = { __typename?: 'Query', customerAttributes: { __typename?: 'CustomerAttributes', id: string, skinSeeingResults?: boolean | null | undefined, skinSideEffects?: boolean | null | undefined, skinTreatmentUsage?: SkinUsage | null | undefined }, profile?: { __typename?: 'User', id: string, firstName?: string | null | undefined, email: string, consultations: Array<{ __typename?: 'Consultation', id: string, type: ProblemType, status: ConsultationStatus, createdAt: string, updatedAt: string, completedAt?: string | null | undefined, stage: ConsultationStage, isUpfrontPayment: boolean, isApproved?: boolean | null | undefined, requiresPrescriberCall: boolean, isInNoPickUpQueue?: boolean | null | undefined, allowPatientToSendMessageToDoctor: boolean, rejectReason?: string | null | undefined, typeIsFlexi?: boolean | null | undefined, practitionerMessagedAt?: string | null | undefined, latestPractitionerBooking?: { __typename?: 'PractitionerBooking', id: string, windowStartAt: string, windowEndAt: string } | null | undefined, doctor?: { __typename?: 'User', id: string, fullName?: string | null | undefined, fullClinicianName: string, shortClinicianName: string, provider?: { __typename?: 'Provider', id: string, clinicianType: ClinicianType } | null | undefined } | null | undefined, reminders?: Array<{ __typename?: 'ConsultationReminder', id: string, canceled: boolean, doneAt?: string | null | undefined, scheduledAt: string }> | null | undefined, chatThread?: { __typename?: 'ChatThread', id: string } | null | undefined, treatment?: { __typename?: 'Treatment', id: string, type: ProblemType, status: TreatmentStatus, isLastOrderUnfulfilled: boolean, refillsLeft?: number | null | undefined, nextPayment?: string | null | undefined, createdAt: string, customerStatedTreatmentStartedAt?: string | null | undefined, pendingFollowUpReminderDate?: string | null | undefined, hasScriptExpired: boolean, hasUnfulfilledOrder: boolean, plan?: { __typename?: 'Plan', id: string, amount: number } | null | undefined, orders: Array<{ __typename?: 'Order', id: string, createdAt: string, fulfilledAt?: string | null | undefined, fulfillment?: FulfillmentStatus | null | undefined }>, otcSchedules: Array<{ __typename?: 'OtcSchedule', id: string, isActive: boolean, cadence: OtcScheduleCadence, quantity: number, product: { __typename?: 'Product', id: string, name: string, variants: Array<{ __typename?: 'Variant', id: string, price: number }>, photo?: { __typename?: 'File', id: string, url: string } | null | undefined } }>, product: { __typename?: 'Product', id: string, name: string, variants: Array<{ __typename?: 'Variant', id: string, price: number }>, photo?: { __typename?: 'File', id: string, url: string } | null | undefined } } | null | undefined, quizApplication?: { __typename?: 'QuizApplication', id: string, submittedAt?: string | null | undefined, problemType: ProblemType, answers: Array<{ __typename?: 'QuizApplicationResponse', id: string, answer?: string | null | undefined, answersArray: Array<string>, question?: { __typename?: 'QuizQuestion', id: string, shortcode?: string | null | undefined } | null | undefined }> } | null | undefined, screeningQuizApplication?: { __typename?: 'QuizApplication', id: string, submittedAt?: string | null | undefined } | null | undefined, purchasePrompt?: { __typename?: 'ConfirmPurchasePrompt', id: string } | { __typename?: 'FurPurchasePrompt', id: string } | { __typename?: 'InitialPurchasePrompt', id: string } | { __typename?: 'RestartFlowPrompt', id: string } | { __typename?: 'SubstitutePurchasePrompt', id: string } | null | undefined }>, initialQuizApplications?: Array<{ __typename?: 'QuizApplication', id: string, createdAt: string, updatedAt: string, submittedAt?: string | null | undefined, problemType: ProblemType, purpose: QuizPurpose, archivedAt?: string | null | undefined }> | null | undefined, trackerQuizApplications?: Array<{ __typename?: 'QuizApplication', id: string, outcomeSummary?: string | null | undefined, createdAt: string, submittedAt?: string | null | undefined, quiz: { __typename?: 'Quiz', id: string, quizCode: string }, outcomes?: Array<{ __typename?: 'ArticleQuizOutcome', id: string, link: string } | { __typename?: 'BuyOtcQuizOutcome', id: string, products?: Array<{ __typename?: 'Product', id: string, name: string, variants: Array<{ __typename?: 'Variant', id: string, public: boolean }>, photo?: { __typename?: 'File', id: string, url: string } | null | undefined }> | null | undefined } | { __typename?: 'ConsultationQuizOutcome', id: string } | { __typename?: 'IncreaseUsageQuizOutcome', id: string } | { __typename?: 'NotEligibleQuizOutcome', id: string, reasons?: Array<QuizOutcomeReason> | null | undefined } | { __typename?: 'OtcQuizOutcome', id: string } | { __typename?: 'ReviewQuizOutcome', id: string } | { __typename?: 'SideEffectProactiveActionQuizOutcome', id: string } | { __typename?: 'ZendeskQuizOutcome', id: string }> | null | undefined }> | null | undefined, purchases?: Array<{ __typename?: 'Purchase', id: string, status: PurchaseStatus, problemType?: ProblemType | null | undefined, isVisibleInProfilePage?: boolean | null | undefined, contexts?: Array<{ __typename?: 'SequenceContext', id: string, consultations?: Array<{ __typename?: 'Consultation', id: string }> | null | undefined }> | null | undefined }> | null | undefined } | null | undefined, progressEntries: Array<{ __typename?: 'ProgressEntry', id: string, date: string, type: ProgressEntryType, photos?: Array<{ __typename?: 'ProgressEntryPhoto', id: string, angle: PhotoAngleType, signedUrl: string } | null | undefined> | null | undefined }> };

export type UpdateCustomerStartedTreatmentStartedAtMutationVariables = Exact<{
  date: Scalars['String']['input'];
  treatmentId: Scalars['String']['input'];
}>;


export type UpdateCustomerStartedTreatmentStartedAtMutation = { __typename?: 'Mutation', updateCustomerStatedTreatmentStatedAt?: { __typename?: 'Treatment', id: string, customerStatedTreatmentStartedAt?: string | null | undefined } | null | undefined };

export type SoftwareCheckinQueryVariables = Exact<{ [key: string]: never; }>;


export type SoftwareCheckinQuery = { __typename?: 'Query', consultations?: Array<{ __typename?: 'Consultation', id: string, type: ProblemType, treatment?: { __typename?: 'Treatment', id: string, customerStatedTreatmentStartedAt?: string | null | undefined, orders: Array<{ __typename?: 'Order', id: string, createdAt: string, fulfillment?: FulfillmentStatus | null | undefined, fulfilledAt?: string | null | undefined }> } | null | undefined }> | null | undefined };

export type ProfileTrackerQuizzesQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfileTrackerQuizzesQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, firstName?: string | null | undefined, consultations: Array<{ __typename?: 'Consultation', id: string, type: ProblemType, treatment?: { __typename?: 'Treatment', id: string } | null | undefined }>, quizApplications?: Array<{ __typename?: 'QuizApplication', id: string, outcomeSummary?: string | null | undefined, createdAt: string, submittedAt?: string | null | undefined, quiz: { __typename?: 'Quiz', id: string, quizCode: string }, outcomes?: Array<{ __typename?: 'ArticleQuizOutcome', id: string, link: string } | { __typename?: 'BuyOtcQuizOutcome', id: string, products?: Array<{ __typename?: 'Product', id: string, name: string, variants: Array<{ __typename?: 'Variant', id: string, public: boolean }>, photo?: { __typename?: 'File', id: string, url: string } | null | undefined }> | null | undefined } | { __typename?: 'ConsultationQuizOutcome', id: string } | { __typename?: 'IncreaseUsageQuizOutcome', id: string } | { __typename?: 'NotEligibleQuizOutcome', id: string, reasons?: Array<QuizOutcomeReason> | null | undefined } | { __typename?: 'OtcQuizOutcome', id: string } | { __typename?: 'ReviewQuizOutcome', id: string } | { __typename?: 'SideEffectProactiveActionQuizOutcome', id: string } | { __typename?: 'ZendeskQuizOutcome', id: string }> | null | undefined }> | null | undefined } | null | undefined, customerAttributes: { __typename?: 'CustomerAttributes', id: string, skinSeeingResults?: boolean | null | undefined, skinSideEffects?: boolean | null | undefined, skinTreatmentUsage?: SkinUsage | null | undefined } };

export type SoftwareQuizCompleteQuizApplicationProblemTypeQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SoftwareQuizCompleteQuizApplicationProblemTypeQuery = { __typename?: 'Query', getQuizApplication?: { __typename?: 'QuizApplication', id: string, purpose: QuizPurpose, problemType: ProblemType, quiz: { __typename?: 'Quiz', id: string, default: boolean, quizCode: string }, consultation?: { __typename?: 'Consultation', id: string, stage: ConsultationStage, status: ConsultationStatus, canSchedulePractitionerBooking: boolean } | null | undefined } | null | undefined, profile?: { __typename?: 'User', id: string, phone?: string | null | undefined, isPasswordSet: boolean } | null | undefined };

export type SoftwareAsyncEligibleQuizCompletePageQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
  problemType: ProblemType;
}>;


export type SoftwareAsyncEligibleQuizCompletePageQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, customer: { __typename?: 'User', id: string, condition?: { __typename?: 'Condition', id: string, asyncEligible?: boolean | null | undefined } | null | undefined } } | null | undefined };

export type StartProblemTypeProfileSoftwareQueryVariables = Exact<{ [key: string]: never; }>;


export type StartProblemTypeProfileSoftwareQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, consultations: Array<{ __typename?: 'Consultation', id: string, type: ProblemType, status: ConsultationStatus, stage: ConsultationStage }> } | null | undefined };

export type StartConfirmProfileSoftwareQueryVariables = Exact<{ [key: string]: never; }>;


export type StartConfirmProfileSoftwareQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, consultations: Array<{ __typename?: 'Consultation', id: string, type: ProblemType, status: ConsultationStatus }> } | null | undefined };

export type SignUpLeadStartSignupSoftwareMutationVariables = Exact<{
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
}>;


export type SignUpLeadStartSignupSoftwareMutation = { __typename?: 'Mutation', signUpLead?: { __typename?: 'AuthPayload', token?: string | null | undefined, user?: { __typename?: 'User', id: string, email: string, firstName?: string | null | undefined, lastName?: string | null | undefined, shortAddressableName?: string | null | undefined, fullName?: string | null | undefined } | null | undefined } | null | undefined };

export type DelayTreatmentMutationVariables = Exact<{
  id: Scalars['String']['input'];
  newDate: Scalars['String']['input'];
  trigger: Scalars['String']['input'];
}>;


export type DelayTreatmentMutation = { __typename?: 'Mutation', delayTreatment?: { __typename?: 'Treatment', id: string, nextPayment?: string | null | undefined, status: TreatmentStatus } | null | undefined };

export type TreatmentOverviewSoftwareQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type TreatmentOverviewSoftwareQuery = { __typename?: 'Query', treatment?: { __typename?: 'Treatment', id: string, type: ProblemType } | null | undefined };

export type NotesTreatmentSoftwareQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type NotesTreatmentSoftwareQuery = { __typename?: 'Query', treatment?: { __typename?: 'Treatment', id: string, type: ProblemType, refillsLeft?: number | null | undefined, canReschedule: boolean, canRefill: boolean, cooldownActiveUntil?: string | null | undefined, canReview: boolean, nextPayment?: string | null | undefined, status: TreatmentStatus, treatmentDiscount?: { __typename?: 'TreatmentDiscount', id: string, discountCode?: { __typename?: 'DiscountCode', id: string, code: string, amount: number, stages: Array<DiscountStage>, type: DiscountType, products: Array<{ __typename?: 'Product', id: string, variants: Array<{ __typename?: 'Variant', id: string }> }> } | null | undefined } | null | undefined, plan?: { __typename?: 'Plan', id: string, amount: number } | null | undefined, otcSchedules: Array<{ __typename?: 'OtcSchedule', id: string, isActive: boolean, cadence: OtcScheduleCadence, quantity: number, product: { __typename?: 'Product', id: string, name: string, productType: ProductType, photo?: { __typename?: 'File', id: string, url: string } | null | undefined, variants: Array<{ __typename?: 'Variant', id: string, price: number }> } }>, consultation?: { __typename?: 'Consultation', id: string, patientNotes?: string | null | undefined, doctor?: { __typename?: 'User', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, shortClinicianName: string, fullClinicianName: string, fullName?: string | null | undefined, role: UserRole, bio?: string | null | undefined, avatar?: { __typename?: 'File', id: string, createdAt: string, updatedAt: string, filename: string, mimetype: string, url: string } | null | undefined, provider?: { __typename?: 'Provider', id: string, clinicianTitle: string, clinicianType: ClinicianType, qualifications?: string | null | undefined } | null | undefined } | null | undefined, quizApplication?: { __typename?: 'QuizApplication', id: string, answers: Array<{ __typename?: 'QuizApplicationResponse', id: string, answer?: string | null | undefined, answersArray: Array<string>, question?: { __typename?: 'QuizQuestion', id: string, shortcode?: string | null | undefined } | null | undefined }> } | null | undefined, order?: { __typename?: 'Order', id: string, lineItems?: Array<{ __typename?: 'OrderLineItem', id: string, quantity: number, variant: { __typename?: 'Variant', id: string, price: number, product: { __typename?: 'Product', id: string, name: string, productType: ProductType } } }> | null | undefined } | null | undefined } | null | undefined, product: { __typename?: 'Product', id: string, name: string, productType: ProductType, instructions?: string | null | undefined, safetyInformation?: string | null | undefined, photo?: { __typename?: 'File', id: string, url: string } | null | undefined, faqs: Array<{ __typename?: 'Faq', id: string, title?: string | null | undefined, markdown?: string | null | undefined }>, cmi?: { __typename?: 'File', id: string, url: string } | null | undefined } } | null | undefined };

export type PlanTreatmentSoftwareQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type PlanTreatmentSoftwareQuery = { __typename?: 'Query', treatment?: { __typename?: 'Treatment', id: string, type: ProblemType, refillsLeft?: number | null | undefined, canReschedule: boolean, canRefill: boolean, cooldownActiveUntil?: string | null | undefined, canReview: boolean, nextPayment?: string | null | undefined, status: TreatmentStatus, treatmentDiscount?: { __typename?: 'TreatmentDiscount', id: string, discountCode?: { __typename?: 'DiscountCode', id: string, code: string, amount: number, stages: Array<DiscountStage>, type: DiscountType, products: Array<{ __typename?: 'Product', id: string, variants: Array<{ __typename?: 'Variant', id: string }> }> } | null | undefined } | null | undefined, plan?: { __typename?: 'Plan', id: string, amount: number } | null | undefined, otcSchedules: Array<{ __typename?: 'OtcSchedule', id: string, isActive: boolean, cadence: OtcScheduleCadence, quantity: number, product: { __typename?: 'Product', id: string, name: string, productType: ProductType, photo?: { __typename?: 'File', id: string, url: string } | null | undefined, variants: Array<{ __typename?: 'Variant', id: string, price: number }> } }>, consultation?: { __typename?: 'Consultation', id: string, patientNotes?: string | null | undefined, doctor?: { __typename?: 'User', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, shortClinicianName: string, fullClinicianName: string, fullName?: string | null | undefined, role: UserRole, bio?: string | null | undefined, avatar?: { __typename?: 'File', id: string, createdAt: string, updatedAt: string, filename: string, mimetype: string, url: string } | null | undefined, provider?: { __typename?: 'Provider', id: string, clinicianTitle: string, clinicianType: ClinicianType, qualifications?: string | null | undefined } | null | undefined } | null | undefined, quizApplication?: { __typename?: 'QuizApplication', id: string, answers: Array<{ __typename?: 'QuizApplicationResponse', id: string, answer?: string | null | undefined, answersArray: Array<string>, question?: { __typename?: 'QuizQuestion', id: string, shortcode?: string | null | undefined } | null | undefined }> } | null | undefined, order?: { __typename?: 'Order', id: string, lineItems?: Array<{ __typename?: 'OrderLineItem', id: string, quantity: number, variant: { __typename?: 'Variant', id: string, price: number, product: { __typename?: 'Product', id: string, name: string, productType: ProductType } } }> | null | undefined } | null | undefined } | null | undefined, product: { __typename?: 'Product', id: string, name: string, productType: ProductType, instructions?: string | null | undefined, safetyInformation?: string | null | undefined, photo?: { __typename?: 'File', id: string, url: string } | null | undefined, faqs: Array<{ __typename?: 'Faq', id: string, title?: string | null | undefined, markdown?: string | null | undefined }>, cmi?: { __typename?: 'File', id: string, url: string } | null | undefined } } | null | undefined, hairTreatments?: Array<{ __typename?: 'Treatment', id: string, active: boolean }> | null | undefined };

export type TreatmentExploreProductsSoftwareQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type TreatmentExploreProductsSoftwareQuery = { __typename?: 'Query', treatment?: { __typename?: 'Treatment', id: string, type: ProblemType, refillsLeft?: number | null | undefined, canReschedule: boolean, canRefill: boolean, cooldownActiveUntil?: string | null | undefined, canReview: boolean, nextPayment?: string | null | undefined, status: TreatmentStatus, treatmentDiscount?: { __typename?: 'TreatmentDiscount', id: string, discountCode?: { __typename?: 'DiscountCode', id: string, code: string, amount: number, stages: Array<DiscountStage>, type: DiscountType, products: Array<{ __typename?: 'Product', id: string, variants: Array<{ __typename?: 'Variant', id: string }> }> } | null | undefined } | null | undefined, plan?: { __typename?: 'Plan', id: string, amount: number } | null | undefined, otcSchedules: Array<{ __typename?: 'OtcSchedule', id: string, isActive: boolean, cadence: OtcScheduleCadence, quantity: number, product: { __typename?: 'Product', id: string, name: string, productType: ProductType, photo?: { __typename?: 'File', id: string, url: string } | null | undefined, variants: Array<{ __typename?: 'Variant', id: string, price: number }> } }>, consultation?: { __typename?: 'Consultation', id: string, patientNotes?: string | null | undefined, doctor?: { __typename?: 'User', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, shortClinicianName: string, fullClinicianName: string, fullName?: string | null | undefined, role: UserRole, bio?: string | null | undefined, avatar?: { __typename?: 'File', id: string, createdAt: string, updatedAt: string, filename: string, mimetype: string, url: string } | null | undefined, provider?: { __typename?: 'Provider', id: string, clinicianTitle: string, clinicianType: ClinicianType, qualifications?: string | null | undefined } | null | undefined } | null | undefined, quizApplication?: { __typename?: 'QuizApplication', id: string, answers: Array<{ __typename?: 'QuizApplicationResponse', id: string, answer?: string | null | undefined, answersArray: Array<string>, question?: { __typename?: 'QuizQuestion', id: string, shortcode?: string | null | undefined } | null | undefined }> } | null | undefined, order?: { __typename?: 'Order', id: string, lineItems?: Array<{ __typename?: 'OrderLineItem', id: string, quantity: number, variant: { __typename?: 'Variant', id: string, price: number, product: { __typename?: 'Product', id: string, name: string, productType: ProductType } } }> | null | undefined } | null | undefined } | null | undefined, product: { __typename?: 'Product', id: string, name: string, productType: ProductType, instructions?: string | null | undefined, safetyInformation?: string | null | undefined, photo?: { __typename?: 'File', id: string, url: string } | null | undefined, faqs: Array<{ __typename?: 'Faq', id: string, title?: string | null | undefined, markdown?: string | null | undefined }>, cmi?: { __typename?: 'File', id: string, url: string } | null | undefined } } | null | undefined, hairTreatments?: Array<{ __typename?: 'Treatment', id: string, active: boolean }> | null | undefined };

export type RefillTreatmentSoftwareMutationVariables = Exact<{
  treatmentId: Scalars['String']['input'];
}>;


export type RefillTreatmentSoftwareMutation = { __typename?: 'Mutation', refillTreatment?: { __typename?: 'Treatment', id: string, status: TreatmentStatus, canRefill: boolean, nextPayment?: string | null | undefined, refillsLeft?: number | null | undefined } | null | undefined };

export type AuthProviderProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type AuthProviderProfileQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, shortAddressableName?: string | null | undefined, fullName?: string | null | undefined, email: string } | null | undefined };

export type ChatTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type ChatTokenQuery = { __typename?: 'Query', chatToken?: string | null | undefined };

export type ChatProviderQueryVariables = Exact<{ [key: string]: never; }>;


export type ChatProviderQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string } | null | undefined };

export type UpdateProfilePhoneNumberMutationVariables = Exact<{
  phone: Scalars['String']['input'];
}>;


export type UpdateProfilePhoneNumberMutation = { __typename?: 'Mutation', updateProfile?: { __typename?: 'User', id: string, phone?: string | null | undefined } | null | undefined };

export type ConsultStripePaymentResultHandlerQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type ConsultStripePaymentResultHandlerQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, type: ProblemType, price?: { __typename?: 'ConsultationPrice', total: number } | null | undefined, customer: { __typename?: 'User', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, phone?: string | null | undefined } } | null | undefined };

export type UpfrontPaymentConsultProductFragment = { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined, erxMedicines: Array<{ __typename?: 'ErxMedicine', id?: string | null | undefined, genericName: string }>, faqs: Array<{ __typename?: 'Faq', id: string }>, variants: Array<{ __typename?: 'Variant', id: string, price: number, isRefill: boolean, inventory?: { __typename?: 'VariantInventory', id: string, sku?: string | null | undefined } | null | undefined }>, photo?: { __typename?: 'File', id: string, url: string } | null | undefined, plan?: { __typename?: 'Plan', id: string, name: string, interval: BillingInterval, intervalCount: number } | null | undefined };

export type UpfrontConsultPayPageQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type UpfrontConsultPayPageQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, legalFirstName?: string | null | undefined, legalLastName?: string | null | undefined, email: string, phone?: string | null | undefined, defaultPaymentGateway?: PaymentGateway | null | undefined, address?: { __typename?: 'Address', id: string, line1?: string | null | undefined, line2?: string | null | undefined, city?: string | null | undefined, postalCode?: string | null | undefined, state?: string | null | undefined, deliveryInstructions?: string | null | undefined } | null | undefined, savedPaymentMethods?: Array<{ __typename?: 'SavedCardPaymentMethod', brand: string, mask: string, expiry: string, createdAt?: string | null | undefined, default: boolean, gateway: PaymentGateway, id: string } | { __typename?: 'SavedPayPalPaymentMethod', email?: string | null | undefined, createdAt?: string | null | undefined, default: boolean, gateway: PaymentGateway, id: string } | { __typename?: 'SavedSofortPaymentMethod', createdAt?: string | null | undefined, default: boolean, gateway: PaymentGateway, id: string } | { __typename?: 'SavedZipPaymentMethod', valid: boolean, createdAt?: string | null | undefined, default: boolean, gateway: PaymentGateway, id: string } | null | undefined> | null | undefined, zip?: { __typename?: 'Zip', valid: boolean } | null | undefined } | null | undefined, consultation?: { __typename?: 'Consultation', id: string, type: ProblemType, isUpfrontPayment: boolean, requiresPrescriberCall: boolean, order?: { __typename?: 'Order', id: string } | null | undefined, medicationPreferenceProduct?: { __typename?: 'MedicationPreferenceProducts', id: string, preferredProduct?: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined, erxMedicines: Array<{ __typename?: 'ErxMedicine', id?: string | null | undefined, genericName: string }>, faqs: Array<{ __typename?: 'Faq', id: string }>, variants: Array<{ __typename?: 'Variant', id: string, price: number, isRefill: boolean, inventory?: { __typename?: 'VariantInventory', id: string, sku?: string | null | undefined } | null | undefined }>, photo?: { __typename?: 'File', id: string, url: string } | null | undefined, plan?: { __typename?: 'Plan', id: string, name: string, interval: BillingInterval, intervalCount: number } | null | undefined } | null | undefined, defaultProduct: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined, erxMedicines: Array<{ __typename?: 'ErxMedicine', id?: string | null | undefined, genericName: string }>, faqs: Array<{ __typename?: 'Faq', id: string }>, variants: Array<{ __typename?: 'Variant', id: string, price: number, isRefill: boolean, inventory?: { __typename?: 'VariantInventory', id: string, sku?: string | null | undefined } | null | undefined }>, photo?: { __typename?: 'File', id: string, url: string } | null | undefined, plan?: { __typename?: 'Plan', id: string, name: string, interval: BillingInterval, intervalCount: number } | null | undefined } } | null | undefined } | null | undefined };

export type ActiveReminderRemindersFragment = { __typename?: 'ConsultationReminder', id: string, canceled: boolean, doneAt?: string | null | undefined, scheduledAt: string };

export type ActiveReminderPatientQuestionsFragment = { __typename?: 'ConsultationPatientQuestion', id: string, createdAt: string };

export type DoctorBioComponentFragment = { __typename?: 'User', id: string, bio?: string | null | undefined, fullName?: string | null | undefined, fullClinicianName: string, shortClinicianName: string, lastName?: string | null | undefined, provider?: { __typename?: 'Provider', clinicianTitle: string, qualifications?: string | null | undefined, id: string } | null | undefined, avatar?: { __typename?: 'File', id: string, url: string } | null | undefined };

export type DoctorInfoComponentFragment = { __typename?: 'User', id: string, fullName?: string | null | undefined, fullClinicianName: string, shortClinicianName: string, lastName?: string | null | undefined, bio?: string | null | undefined, avatar?: { __typename?: 'File', id: string, url: string } | null | undefined, provider?: { __typename?: 'Provider', id: string, clinicianTitle: string, qualifications?: string | null | undefined } | null | undefined };

export type NextReadingCardQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type NextReadingCardQuery = { __typename?: 'Query', educationProgram?: { __typename?: 'EducationProgram', id: string, nextUnreadReading?: { __typename?: 'EducationReading', id: string, content: any, startedAt?: string | null | undefined, timeToReadMs?: number | null | undefined } | null | undefined } | null | undefined };

export type NextReadingRedirectQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type NextReadingRedirectQuery = { __typename?: 'Query', educationProgram?: { __typename?: 'EducationProgram', id: string, nextUnreadReading?: { __typename?: 'EducationReading', id: string, content: any, startedAt?: string | null | undefined, timeToReadMs?: number | null | undefined } | null | undefined } | null | undefined };

export type IhiQueryVariables = Exact<{ [key: string]: never; }>;


export type IhiQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, residentialAddress?: { __typename?: 'ResidentialAddress', id: string } | null | undefined, healthCareDetails?: { __typename?: 'HealthCareDetails', id: string, hasMedicareDetails?: boolean | null | undefined, hasIndividualHealthcareIdentifier?: boolean | null | undefined } | null | undefined } | null | undefined };

export type MedicareRedirectQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type MedicareRedirectQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, type: ProblemType, stage: ConsultationStage } | null | undefined, profile?: { __typename?: 'User', id: string, residentialAddress?: { __typename?: 'ResidentialAddress', id: string } | null | undefined } | null | undefined };

export type UpdateMedicareDetailsMutationVariables = Exact<{
  familyName: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  medicareNumber: Scalars['String']['input'];
  medicareIrn: Scalars['Int']['input'];
  validToMonth: Scalars['Int']['input'];
  validToYear: Scalars['Int']['input'];
  sex: MedicareSexType;
  dateOfBirth: Scalars['String']['input'];
}>;


export type UpdateMedicareDetailsMutation = { __typename?: 'Mutation', updateMedicareDetails?: boolean | null | undefined };

export type MasterclassClassPageContentQueryVariables = Exact<{ [key: string]: never; }>;


export type MasterclassClassPageContentQuery = { __typename?: 'Query', masterclassVideos: Array<{ __typename?: 'MasterclassVideo', id?: number | null | undefined, created?: string | null | undefined, description?: string | null | undefined, duration?: number | null | undefined, hashed_id?: string | null | undefined, section?: string | null | undefined, title?: string | null | undefined, type?: string | null | undefined, updated?: string | null | undefined, thumbnail?: { __typename?: 'Thumbnail', height?: number | null | undefined, url?: string | null | undefined, width?: number | null | undefined } | null | undefined }>, profile?: { __typename?: 'User', id: string, hasPaidMasterclass?: boolean | null | undefined } | null | undefined };

export type SaveProgressMutationVariables = Exact<{
  videoId: Scalars['String']['input'];
  progressPercentage: Scalars['Float']['input'];
}>;


export type SaveProgressMutation = { __typename?: 'Mutation', saveProgress?: { __typename?: 'User', id: string, videoProgresses: Array<{ __typename?: 'VideoProgress', id: string, videoId: string, progressPercentage?: number | null | undefined }> } | null | undefined };

export type MasterclassEpisodeFragment = { __typename?: 'MasterclassVideo', id?: number | null | undefined, created?: string | null | undefined, description?: string | null | undefined, duration?: number | null | undefined, hashed_id?: string | null | undefined, section?: string | null | undefined, title?: string | null | undefined, type?: string | null | undefined, updated?: string | null | undefined, thumbnail?: { __typename?: 'Thumbnail', height?: number | null | undefined, url?: string | null | undefined, width?: number | null | undefined } | null | undefined };

export type MasterclassHomePageContentQueryVariables = Exact<{ [key: string]: never; }>;


export type MasterclassHomePageContentQuery = { __typename?: 'Query', masterclassVideos: Array<{ __typename?: 'MasterclassVideo', id?: number | null | undefined, created?: string | null | undefined, description?: string | null | undefined, duration?: number | null | undefined, hashed_id?: string | null | undefined, section?: string | null | undefined, title?: string | null | undefined, type?: string | null | undefined, updated?: string | null | undefined, thumbnail?: { __typename?: 'Thumbnail', height?: number | null | undefined, url?: string | null | undefined, width?: number | null | undefined } | null | undefined }>, profile?: { __typename?: 'User', id: string, hasPaidMasterclass?: boolean | null | undefined } | null | undefined };

export type AutoAddOtcToTreatmentMutationVariables = Exact<{
  id: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  cadence: OtcScheduleCadence;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
}>;


export type AutoAddOtcToTreatmentMutation = { __typename?: 'Mutation', upsertOtcProductToTreatment?: { __typename?: 'Treatment', id: string, otcSchedules: Array<{ __typename?: 'OtcSchedule', id: string, isActive: boolean, cadence: OtcScheduleCadence, createdAt: string, updatedAt: string, quantity: number, product: { __typename?: 'Product', id: string, name: string, productType: ProductType, photo?: { __typename?: 'File', id: string, url: string } | null | undefined, variants: Array<{ __typename?: 'Variant', id: string, price: number }> } }> } | null | undefined };

export type RemoveOtcLineItemMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
  variantId: Scalars['String']['input'];
}>;


export type RemoveOtcLineItemMutation = { __typename?: 'Mutation', updateLineItem?: { __typename?: 'Order', id: string, consultation?: { __typename?: 'Consultation', id: string, order?: { __typename?: 'Order', id: string, lineItems?: Array<{ __typename?: 'OrderLineItem', id: string, quantity: number, variant: { __typename?: 'Variant', id: string, price: number, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined, productType: ProductType, photo?: { __typename?: 'File', id: string, url: string } | null | undefined } } }> | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type BillingDetailsFragment = { __typename?: 'User', id: string, defaultPaymentGateway?: PaymentGateway | null | undefined, savedPaymentMethods?: Array<{ __typename?: 'SavedCardPaymentMethod', expiry: string, mask: string, brand: string, id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | { __typename?: 'SavedPayPalPaymentMethod', email?: string | null | undefined, id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | { __typename?: 'SavedSofortPaymentMethod', id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | { __typename?: 'SavedZipPaymentMethod', valid: boolean, id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | null | undefined> | null | undefined, zip?: { __typename?: 'Zip', valid: boolean } | null | undefined };

export type OtcPurchaseCompletedQueryVariables = Exact<{ [key: string]: never; }>;


export type OtcPurchaseCompletedQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined, email: string, phone?: string | null | undefined, defaultPaymentGateway?: PaymentGateway | null | undefined, address?: { __typename?: 'Address', id: string, line1?: string | null | undefined, line2?: string | null | undefined, city?: string | null | undefined, state?: string | null | undefined, postalCode?: string | null | undefined, country?: string | null | undefined } | null | undefined, savedPaymentMethods?: Array<{ __typename?: 'SavedCardPaymentMethod', expiry: string, mask: string, brand: string, id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | { __typename?: 'SavedPayPalPaymentMethod', email?: string | null | undefined, id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | { __typename?: 'SavedSofortPaymentMethod', id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | { __typename?: 'SavedZipPaymentMethod', valid: boolean, id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | null | undefined> | null | undefined, zip?: { __typename?: 'Zip', valid: boolean } | null | undefined } | null | undefined };

export type OtcPurchaseDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type OtcPurchaseDetailsQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined, email: string, phone?: string | null | undefined, defaultPaymentGateway?: PaymentGateway | null | undefined, address?: { __typename?: 'Address', id: string, line1?: string | null | undefined, line2?: string | null | undefined, city?: string | null | undefined, state?: string | null | undefined, postalCode?: string | null | undefined, country?: string | null | undefined } | null | undefined, savedPaymentMethods?: Array<{ __typename?: 'SavedCardPaymentMethod', expiry: string, mask: string, brand: string, id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | { __typename?: 'SavedPayPalPaymentMethod', email?: string | null | undefined, id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | { __typename?: 'SavedSofortPaymentMethod', id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | { __typename?: 'SavedZipPaymentMethod', valid: boolean, id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | null | undefined> | null | undefined, zip?: { __typename?: 'Zip', valid: boolean } | null | undefined } | null | undefined };

export type PaymentFormFragment = { __typename?: 'User', id: string, defaultPaymentGateway?: PaymentGateway | null | undefined, savedPaymentMethods?: Array<{ __typename?: 'SavedCardPaymentMethod', expiry: string, mask: string, brand: string, id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | { __typename?: 'SavedPayPalPaymentMethod', email?: string | null | undefined, id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | { __typename?: 'SavedSofortPaymentMethod', id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | { __typename?: 'SavedZipPaymentMethod', valid: boolean, id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | null | undefined> | null | undefined, zip?: { __typename?: 'Zip', valid: boolean } | null | undefined };

export type DiscountCodeQueryVariables = Exact<{
  code: Scalars['String']['input'];
  checkoutStage?: InputMaybe<DiscountStage>;
  productIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  skipProductValidation: Scalars['Boolean']['input'];
}>;


export type DiscountCodeQuery = { __typename?: 'Query', discountCode?: { __typename?: 'DiscountCode', id: string, code: string, amount: number, stages: Array<DiscountStage>, type: DiscountType, products: Array<{ __typename?: 'Product', id: string, variants: Array<{ __typename?: 'Variant', id: string }> }> } | null | undefined };

export type PurchaseOrderMutationVariables = Exact<{
  couponCode?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
}>;


export type PurchaseOrderMutation = { __typename?: 'Mutation', purchaseOrder?: { __typename?: 'Order', id: string, status?: OrderStatus | null | undefined } | null | undefined };

export type ShoppingCartFragment = { __typename?: 'OtcShoppingCart', id: string, items?: Array<{ __typename?: 'OtcShoppingCartItem', id: string, quantity: number, variant: { __typename?: 'Variant', id: string, name: string, price: number, product: { __typename?: 'Product', id: string, name: string, photo?: { __typename?: 'File', id: string, url: string } | null | undefined }, inventory?: { __typename?: 'VariantInventory', id: string, sku?: string | null | undefined } | null | undefined } }> | null | undefined };

export type UpdateOtcShoppingCartMutationVariables = Exact<{
  item: OtcShoppingCartItemInput;
}>;


export type UpdateOtcShoppingCartMutation = { __typename?: 'Mutation', updateOtcShoppingCart?: { __typename?: 'OtcShoppingCart', id: string, items?: Array<{ __typename?: 'OtcShoppingCartItem', id: string, quantity: number, variant: { __typename?: 'Variant', id: string, name: string, price: number, product: { __typename?: 'Product', id: string, name: string, photo?: { __typename?: 'File', id: string, url: string } | null | undefined }, inventory?: { __typename?: 'VariantInventory', id: string, sku?: string | null | undefined } | null | undefined } }> | null | undefined } | null | undefined };

export type PurchaseOtcShoppingCartMutationVariables = Exact<{
  cartId: Scalars['String']['input'];
  discountCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type PurchaseOtcShoppingCartMutation = { __typename?: 'Mutation', purchaseOtcShoppingCart?: { __typename?: 'OtcShoppingCart', id: string, items?: Array<{ __typename?: 'OtcShoppingCartItem', id: string, quantity: number, variant: { __typename?: 'Variant', id: string, name: string, price: number, product: { __typename?: 'Product', id: string, name: string, photo?: { __typename?: 'File', id: string, url: string } | null | undefined }, inventory?: { __typename?: 'VariantInventory', id: string, sku?: string | null | undefined } | null | undefined } }> | null | undefined } | null | undefined };

export type RemoveOtcShoppingCartItemMutationVariables = Exact<{
  cartId: Scalars['String']['input'];
  variantId: Scalars['String']['input'];
}>;


export type RemoveOtcShoppingCartItemMutation = { __typename?: 'Mutation', removeOtcShoppingCartItem?: { __typename?: 'OtcShoppingCart', id: string, items?: Array<{ __typename?: 'OtcShoppingCartItem', id: string, quantity: number, variant: { __typename?: 'Variant', id: string, name: string, price: number, product: { __typename?: 'Product', id: string, name: string, photo?: { __typename?: 'File', id: string, url: string } | null | undefined }, inventory?: { __typename?: 'VariantInventory', id: string, sku?: string | null | undefined } | null | undefined } }> | null | undefined } | null | undefined };

export type OtcShoppingCartQueryVariables = Exact<{ [key: string]: never; }>;


export type OtcShoppingCartQuery = { __typename?: 'Query', otcShoppingCart?: { __typename?: 'OtcShoppingCart', id: string, items?: Array<{ __typename?: 'OtcShoppingCartItem', id: string, quantity: number, variant: { __typename?: 'Variant', id: string, name: string, price: number, product: { __typename?: 'Product', id: string, name: string, photo?: { __typename?: 'File', id: string, url: string } | null | undefined }, inventory?: { __typename?: 'VariantInventory', id: string, sku?: string | null | undefined } | null | undefined } }> | null | undefined } | null | undefined };

export type UsePurchaseCardContentPurchaseFragment = { __typename?: 'Purchase', id: string, status: PurchaseStatus, offering?: { __typename?: 'AddOnOffering', id: string, friendlyName: string } | { __typename?: 'OtcOffering', id: string, friendlyName: string } | { __typename?: 'RxOffering', id: string, friendlyName: string } | null | undefined, orderTimeline?: Array<{ __typename?: 'OrderTimelineItem', id: string, status: OrderTimelineItemStatus }> | null | undefined, nextOrder?: { __typename?: 'OrderTimelineItem', id: string, date: string, products?: Array<{ __typename?: 'Product', id: string, friendlyName?: string | null | undefined, name: string }> | null | undefined } | null | undefined, contexts?: Array<{ __typename?: 'SequenceContext', id: string, status: SequenceContextStatus, sequence?: { __typename?: 'OtcSequence', id: string, products?: Array<{ __typename?: 'Product', id: string, productType: ProductType }> | null | undefined } | { __typename?: 'PrescribableSequence', id: string, products?: Array<{ __typename?: 'Product', id: string, productType: ProductType }> | null | undefined } | null | undefined }> | null | undefined };

export type ConfirmPathologyQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type ConfirmPathologyQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, type: ProblemType, doctor?: { __typename?: 'User', id: string, fullName?: string | null | undefined, fullClinicianName: string, shortClinicianName: string, lastName?: string | null | undefined, bio?: string | null | undefined, avatar?: { __typename?: 'File', id: string, url: string } | null | undefined, provider?: { __typename?: 'Provider', id: string, clinicianTitle: string, qualifications?: string | null | undefined } | null | undefined } | null | undefined, pathologyRequests?: Array<{ __typename?: 'PathologyRequest', id: string, createdAt: string, customerStatedCollectedAt?: string | null | undefined, referral?: { __typename?: 'PathologyReferral', id: string, signedUrl: string } | null | undefined } | null | undefined> | null | undefined } | null | undefined, customerAttributes: { __typename?: 'CustomerAttributes', id: string, diabetesRisk: { __typename?: 'CustomerDiabetesRiskAttributes', diabetesRiskLevel?: DiabetesRiskLevel | null | undefined, diabetesRiskProbability?: number | null | undefined } } };

export type DoctorInfoFragment = { __typename?: 'User', id: string, fullClinicianName: string, lastName?: string | null | undefined, bio?: string | null | undefined, avatar?: { __typename?: 'File', id: string, url: string } | null | undefined, provider?: { __typename?: 'Provider', id: string, clinicianTitle: string } | null | undefined };

export type ChatPageQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type ChatPageQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, doctor?: { __typename?: 'User', id: string, fullClinicianName: string, lastName?: string | null | undefined, bio?: string | null | undefined, avatar?: { __typename?: 'File', id: string, url: string } | null | undefined, provider?: { __typename?: 'Provider', id: string, clinicianTitle: string } | null | undefined } | null | undefined, chatThread?: { __typename?: 'ChatThread', id: string } | null | undefined } | null | undefined };

export type ConsultationPlanQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type ConsultationPlanQuery = { __typename?: 'Query', inBatchingExperimentSegment?: boolean | null | undefined, consultation?: { __typename?: 'Consultation', id: string, isUpfrontPayment: boolean, typeIsFlexi?: boolean | null | undefined, completedAt?: string | null | undefined, patientNotes?: string | null | undefined, doctor?: { __typename?: 'User', id: string, fullName?: string | null | undefined, fullClinicianName: string, shortClinicianName: string, lastName?: string | null | undefined, avatar?: { __typename?: 'File', id: string, url: string } | null | undefined } | null | undefined, customer: { __typename?: 'User', id: string, firstName?: string | null | undefined }, treatment?: { __typename?: 'Treatment', id: string, status: TreatmentStatus, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined, shortDescription?: string | null | undefined, plan?: { __typename?: 'Plan', id: string, interval: BillingInterval, intervalCount: number } | null | undefined, variants: Array<{ __typename?: 'Variant', id: string, isRefill: boolean, price: number, inventory?: { __typename?: 'VariantInventory', id: string, sku?: string | null | undefined } | null | undefined }>, photo?: { __typename?: 'File', id: string, url: string } | null | undefined, faqs: Array<{ __typename?: 'Faq', id: string, title?: string | null | undefined, markdown?: string | null | undefined }> }, experimentAvailablePaymentPlans: Array<{ __typename?: 'ExperimentAvailablePaymentPlan', paymentPlan: ExperimentPaymentPlanVariant }> } | null | undefined } | null | undefined, customerAttributes: { __typename?: 'CustomerAttributes', id: string, menopause: { __typename?: 'CustomerMenopauseAttributes', menopauseSymptoms?: Array<MenopauseSymptoms | null | undefined> | null | undefined } } };

export type DoctorLetterComponentFragment = { __typename?: 'User', id: string, shortClinicianName: string, fullClinicianName: string, bio?: string | null | undefined, fullName?: string | null | undefined, lastName?: string | null | undefined, provider?: { __typename?: 'Provider', clinicianTitle: string, qualifications?: string | null | undefined, id: string } | null | undefined, avatar?: { __typename?: 'File', id: string, url: string } | null | undefined };

export type DoctorsNotePageQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type DoctorsNotePageQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, status: ConsultationStatus, type: ProblemType, completedAt?: string | null | undefined, patientNotes?: string | null | undefined, doctor?: { __typename?: 'User', id: string, shortClinicianName: string, fullClinicianName: string, bio?: string | null | undefined, avatar?: { __typename?: 'File', id: string, url: string } | null | undefined, provider?: { __typename?: 'Provider', id: string, clinicianTitle: string, qualifications?: string | null | undefined } | null | undefined } | null | undefined, treatment?: { __typename?: 'Treatment', id: string, createdAt: string, updatedAt: string, product: { __typename?: 'Product', id: string, faqs: Array<{ __typename?: 'Faq', id: string, markdown?: string | null | undefined, title?: string | null | undefined }> } } | null | undefined } | null | undefined };

export type PharmacyInformationPageProductFragment = { __typename?: 'Product', id: string, name: string, shortDescription?: string | null | undefined, safetyInformation?: string | null | undefined, plan?: { __typename?: 'Plan', id: string, interval: BillingInterval, intervalCount: number } | null | undefined, variants: Array<{ __typename?: 'Variant', id: string, isRefill: boolean, price: number, inventory?: { __typename?: 'VariantInventory', id: string, sku?: string | null | undefined } | null | undefined }>, photo?: { __typename?: 'File', id: string, url: string } | null | undefined, cmi?: { __typename?: 'File', id: string, url: string } | null | undefined, faqs: Array<{ __typename?: 'Faq', id: string, title?: string | null | undefined, markdown?: string | null | undefined, videoEmbedUrl?: string | null | undefined }> };

export type PharmacyInformationPageTemplateQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type PharmacyInformationPageTemplateQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, customer: { __typename?: 'User', id: string, firstName?: string | null | undefined, healthCareDetails?: { __typename?: 'HealthCareDetails', id: string, hasIndividualHealthcareIdentifier?: boolean | null | undefined } | null | undefined }, treatment?: { __typename?: 'Treatment', id: string, status: TreatmentStatus, weightTreatmentCategory?: WeightTreatmentCategory | null | undefined, product: { __typename?: 'Product', id: string, name: string, shortDescription?: string | null | undefined, safetyInformation?: string | null | undefined, plan?: { __typename?: 'Plan', id: string, interval: BillingInterval, intervalCount: number } | null | undefined, variants: Array<{ __typename?: 'Variant', id: string, isRefill: boolean, price: number, inventory?: { __typename?: 'VariantInventory', id: string, sku?: string | null | undefined } | null | undefined }>, photo?: { __typename?: 'File', id: string, url: string } | null | undefined, cmi?: { __typename?: 'File', id: string, url: string } | null | undefined, faqs: Array<{ __typename?: 'Faq', id: string, title?: string | null | undefined, markdown?: string | null | undefined, videoEmbedUrl?: string | null | undefined }> } } | null | undefined } | null | undefined };

export type NextUnreadEducationReadingQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type NextUnreadEducationReadingQuery = { __typename?: 'Query', educationProgram?: { __typename?: 'EducationProgram', id: string, nextUnreadReading?: { __typename?: 'EducationReading', id: string, content: any, startedAt?: string | null | undefined, timeToReadMs?: number | null | undefined } | null | undefined } | null | undefined };

export type MarkEducationReadingStartedMutationVariables = Exact<{
  readingId: Scalars['ID']['input'];
}>;


export type MarkEducationReadingStartedMutation = { __typename?: 'Mutation', markEducationReadingStarted?: { __typename?: 'EducationReading', id: string } | null | undefined };

export type MarkEducationReadingCompletedMutationVariables = Exact<{
  readingId: Scalars['ID']['input'];
}>;


export type MarkEducationReadingCompletedMutation = { __typename?: 'Mutation', markEducationReadingCompleted?: { __typename?: 'EducationReading', id: string } | null | undefined };

export type EducationReadingQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EducationReadingQuery = { __typename?: 'Query', educationReading?: { __typename?: 'EducationReading', id: string, content: any, completedAt?: string | null | undefined, startedAt?: string | null | undefined, timeToReadMs?: number | null | undefined } | null | undefined };

export type EducationProgramQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EducationProgramQuery = { __typename?: 'Query', educationProgram?: { __typename?: 'EducationProgram', id: string, name: string, nextUnreadReading?: { __typename?: 'EducationReading', id: string, content: any, startedAt?: string | null | undefined, readStatus?: ReadStatus | null | undefined, timeToReadMs?: number | null | undefined } | null | undefined, modules?: Array<{ __typename?: 'EducationModule', id: string, name: string, description: string, readings?: Array<{ __typename?: 'EducationReading', id: string, content: any, readStatus?: ReadStatus | null | undefined, timeToReadMs?: number | null | undefined }> | null | undefined }> | null | undefined } | null | undefined };

export type EducationReadingCollectionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EducationReadingCollectionQuery = { __typename?: 'Query', educationCollection?: { __typename?: 'EducationCollection', id: string, name: string, description?: string | null | undefined, readings?: Array<{ __typename?: 'EducationReading', id: string, content: any, completedAt?: string | null | undefined, startedAt?: string | null | undefined, timeToReadMs?: number | null | undefined }> | null | undefined } | null | undefined };

export type DoctorLetterPageQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type DoctorLetterPageQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, patientNotes?: string | null | undefined, purchasePrompt?: { __typename?: 'ConfirmPurchasePrompt', id: string } | { __typename?: 'FurPurchasePrompt', id: string } | { __typename?: 'InitialPurchasePrompt', id: string } | { __typename?: 'RestartFlowPrompt', id: string } | { __typename?: 'SubstitutePurchasePrompt', id: string } | null | undefined, doctor?: { __typename?: 'User', id: string, shortClinicianName: string, fullClinicianName: string, bio?: string | null | undefined, fullName?: string | null | undefined, lastName?: string | null | undefined, provider?: { __typename?: 'Provider', clinicianTitle: string, qualifications?: string | null | undefined, id: string } | null | undefined, avatar?: { __typename?: 'File', id: string, url: string } | null | undefined } | null | undefined, prescribedSequence?: { __typename?: 'PrescribedSequence', id: string, createdAt: string, sequence?: { __typename?: 'OtcSequence', id: string, faqs: Array<{ __typename?: 'SequenceFaq', id: string, rank?: number | null | undefined, question: string, answerMarkdown: string }> } | { __typename?: 'PrescribableSequence', id: string, faqs: Array<{ __typename?: 'SequenceFaq', id: string, rank?: number | null | undefined, question: string, answerMarkdown: string }> } | null | undefined } | null | undefined } | null | undefined };

export type FurPurchaseConfirmAddressRangeQueryVariables = Exact<{
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  suburb: Scalars['String']['input'];
  postcode: Scalars['String']['input'];
}>;


export type FurPurchaseConfirmAddressRangeQuery = { __typename?: 'Query', shippingAddressWithinRange?: boolean | null | undefined };

export type FollowUpOrReviewPurchaseConfirmQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
  offeringSelections: Array<OfferingSelectionInput> | OfferingSelectionInput;
  noSelections: Scalars['Boolean']['input'];
  couponCodes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  pricingSessionId: Scalars['ID']['input'];
}>;


export type FollowUpOrReviewPurchaseConfirmQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, defaultPaymentGateway?: PaymentGateway | null | undefined, address?: { __typename?: 'Address', id: string, city?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined, state?: string | null | undefined, country?: string | null | undefined, postalCode?: string | null | undefined, prefecture?: string | null | undefined, municipality?: string | null | undefined, deliveryInstructions?: string | null | undefined, townArea?: string | null | undefined } | null | undefined, residentialAddress?: { __typename?: 'ResidentialAddress', id: string, city: string, line1: string, line2?: string | null | undefined, state?: string | null | undefined, country: string, postalCode: string, prefecture?: string | null | undefined, municipality?: string | null | undefined, townArea?: string | null | undefined } | null | undefined, savedPaymentMethods?: Array<{ __typename?: 'SavedCardPaymentMethod', expiry: string, mask: string, brand: string, id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | { __typename?: 'SavedPayPalPaymentMethod', email?: string | null | undefined, id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | { __typename?: 'SavedSofortPaymentMethod', id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | { __typename?: 'SavedZipPaymentMethod', valid: boolean, id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | null | undefined> | null | undefined, zip?: { __typename?: 'Zip', valid: boolean } | null | undefined } | null | undefined, consultation?: { __typename?: 'Consultation', id: string, purchasePrompt?: { __typename?: 'ConfirmPurchasePrompt', id: string } | { __typename?: 'FurPurchasePrompt', id: string, proposedOfferingSelection?: { __typename?: 'OfferingSelection', id: string, offering?: { __typename?: 'AddOnOffering', id: string, friendlyName: string, photoUrl: string } | { __typename?: 'OtcOffering', id: string, friendlyName: string, photoUrl: string } | { __typename?: 'RxOffering', id: string, friendlyName: string, photoUrl: string } | null | undefined, sequenceSelections?: Array<{ __typename?: 'SequenceSelection', id: string, sequence?: { __typename?: 'OtcSequence', id: string, products?: Array<{ __typename?: 'Product', id: string, deliveryInformation?: string | null | undefined }> | null | undefined } | { __typename?: 'PrescribableSequence', addressValidationExempt?: boolean | null | undefined, id: string, products?: Array<{ __typename?: 'Product', id: string, deliveryInformation?: string | null | undefined }> | null | undefined } | null | undefined, sequenceSet?: { __typename?: 'SequenceSet', id: string } | null | undefined }> | null | undefined } | null | undefined } | { __typename?: 'InitialPurchasePrompt', id: string } | { __typename?: 'RestartFlowPrompt', id: string } | { __typename?: 'SubstitutePurchasePrompt', id: string } | null | undefined } | null | undefined, initialPurchasePrice?: { __typename?: 'InitialPurchasePriceList', id: string, amount: number, originalAmount: number, discountAmount: number, sessionCreditAmount: number, coupons?: Array<{ __typename?: 'InitialPurchasePriceCoupon', id: string, code: string, outcome: CouponOutcome }> | null | undefined } | null | undefined, offeringsTimeline?: Array<{ __typename?: 'PredictedOfferingTimelineItem', id: string, date: string, totalAmount: number, products?: Array<{ __typename?: 'Product', id: string, friendlyName?: string | null | undefined, erxMedicines: Array<{ __typename?: 'ErxMedicine', id?: string | null | undefined, itemForm?: string | null | undefined, itemStrength?: string | null | undefined }> }> | null | undefined }> | null | undefined };

export type FurConfirmInitiateZipCheckoutMutationVariables = Exact<{
  input: InitiateFlexiZipCheckoutInput;
}>;


export type FurConfirmInitiateZipCheckoutMutation = { __typename?: 'Mutation', initiateFlexiZipCheckout?: { __typename?: 'ZipCheckoutResponse', redirectUrl: string } | null | undefined };

export type FollowUpOrReviewPurchaseReviewQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
  offeringSelections: Array<OfferingSelectionInput> | OfferingSelectionInput;
  noSelections: Scalars['Boolean']['input'];
}>;


export type FollowUpOrReviewPurchaseReviewQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, shortAddressableName?: string | null | undefined } | null | undefined, consultation?: { __typename?: 'Consultation', id: string, type: ProblemType, patientNotes?: string | null | undefined, doctor?: { __typename?: 'User', fullClinicianName: string, id: string, fullName?: string | null | undefined, shortClinicianName: string, lastName?: string | null | undefined, bio?: string | null | undefined, avatar?: { __typename?: 'File', id: string, url: string } | null | undefined, provider?: { __typename?: 'Provider', id: string, clinicianTitle: string, qualifications?: string | null | undefined } | null | undefined } | null | undefined, purchasePrompt?: { __typename?: 'ConfirmPurchasePrompt', id: string } | { __typename?: 'FurPurchasePrompt', id: string, proposedOfferingSelection?: { __typename?: 'OfferingSelection', id: string, offering?: { __typename?: 'AddOnOffering', id: string, friendlyName: string, photoUrl: string, advertisedShippingCadence: string } | { __typename?: 'OtcOffering', id: string, friendlyName: string, photoUrl: string, advertisedShippingCadence: string } | { __typename?: 'RxOffering', id: string, friendlyName: string, photoUrl: string, advertisedShippingCadence: string } | null | undefined, sequenceSelections?: Array<{ __typename?: 'SequenceSelection', id: string, sequence?: { __typename?: 'OtcSequence', id: string, faqs: Array<{ __typename?: 'SequenceFaq', id: string, question: string, answerMarkdown: string, rank?: number | null | undefined }>, externalLinks: Array<{ __typename?: 'SequenceExternalLink', id: string, text: string, url: string }> } | { __typename?: 'PrescribableSequence', id: string, faqs: Array<{ __typename?: 'SequenceFaq', id: string, question: string, answerMarkdown: string, rank?: number | null | undefined }>, externalLinks: Array<{ __typename?: 'SequenceExternalLink', id: string, text: string, url: string }> } | null | undefined, sequenceSet?: { __typename?: 'SequenceSet', id: string } | null | undefined }> | null | undefined } | null | undefined } | { __typename?: 'InitialPurchasePrompt', id: string } | { __typename?: 'RestartFlowPrompt', id: string } | { __typename?: 'SubstitutePurchasePrompt', id: string } | null | undefined } | null | undefined, offeringsTimeline?: Array<{ __typename?: 'PredictedOfferingTimelineItem', id: string, date: string, totalAmount: number, products?: Array<{ __typename?: 'Product', id: string, friendlyName?: string | null | undefined, erxMedicines: Array<{ __typename?: 'ErxMedicine', id?: string | null | undefined, itemForm?: string | null | undefined, itemStrength?: string | null | undefined }> }> | null | undefined }> | null | undefined };

export type InitialPurchaseConfirmQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
  pricingSessionId: Scalars['ID']['input'];
  offeringSelections: Array<OfferingSelectionInput> | OfferingSelectionInput;
  noSelections: Scalars['Boolean']['input'];
  couponCodes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  proposedOfferingSelectionInput?: InputMaybe<InitialPurchaseProposedOfferingSelectionInput>;
}>;


export type InitialPurchaseConfirmQuery = { __typename?: 'Query', initialPurchasePrice?: { __typename?: 'InitialPurchasePriceList', id: string, amount: number, originalAmount: number, coupons?: Array<{ __typename?: 'InitialPurchasePriceCoupon', id: string, code: string, outcome: CouponOutcome }> | null | undefined } | null | undefined, validPhoneRegions?: Array<{ __typename?: 'ValidPhoneRegion', id: string, countryCode: string }> | null | undefined, profile?: { __typename?: 'User', id: string, email: string, phone?: string | null | undefined, isPasswordSet: boolean, birthday?: string | null | undefined, lastName?: string | null | undefined, firstName?: string | null | undefined, shortAddressableName?: string | null | undefined, preferredUnitSystem?: UnitSystem | null | undefined, defaultPaymentGateway?: PaymentGateway | null | undefined, address?: { __typename?: 'Address', id: string, city?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined, state?: string | null | undefined, country?: string | null | undefined, postalCode?: string | null | undefined, prefecture?: string | null | undefined, municipality?: string | null | undefined, deliveryInstructions?: string | null | undefined, townArea?: string | null | undefined } | null | undefined, residentialAddress?: { __typename?: 'ResidentialAddress', id: string, city: string, line1: string, line2?: string | null | undefined, state?: string | null | undefined, country: string, postalCode: string, prefecture?: string | null | undefined, municipality?: string | null | undefined, townArea?: string | null | undefined } | null | undefined, medicalProfile: { __typename?: 'MedicalProfile', id: string, weight?: number | null | undefined }, savedPaymentMethods?: Array<{ __typename?: 'SavedCardPaymentMethod', expiry: string, mask: string, brand: string, id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | { __typename?: 'SavedPayPalPaymentMethod', email?: string | null | undefined, id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | { __typename?: 'SavedSofortPaymentMethod', id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | { __typename?: 'SavedZipPaymentMethod', valid: boolean, id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | null | undefined> | null | undefined, zip?: { __typename?: 'Zip', valid: boolean } | null | undefined } | null | undefined, initialPurchaseConfirmPage?: { __typename?: 'InitialPurchaseConfirmPage', id: string, faqs?: Array<{ __typename?: 'FaqContentItem', id: string, question: string, answer: string }> | null | undefined } | null | undefined, consultation?: { __typename?: 'Consultation', id: string, type: ProblemType, purchasePrompt?: { __typename?: 'ConfirmPurchasePrompt', id: string } | { __typename?: 'FurPurchasePrompt', id: string } | { __typename?: 'InitialPurchasePrompt', id: string, proposedOfferingSelection?: { __typename?: 'OfferingSelection', id: string, offering?: { __typename?: 'AddOnOffering', id: string, friendlyName: string, advertisedShippingCadence: string, photoUrl: string, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, rank: number, description: string }> } | { __typename?: 'OtcOffering', id: string, friendlyName: string, advertisedShippingCadence: string, photoUrl: string, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, rank: number, description: string }> } | { __typename?: 'RxOffering', id: string, friendlyName: string, advertisedShippingCadence: string, photoUrl: string, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, rank: number, description: string }> } | null | undefined, sequenceSelections?: Array<{ __typename?: 'SequenceSelection', id: string, sequence?: { __typename?: 'OtcSequence', id: string } | { __typename?: 'PrescribableSequence', addressValidationExempt?: boolean | null | undefined, id: string } | null | undefined, sequenceSet?: { __typename?: 'SequenceSet', id: string } | null | undefined }> | null | undefined } | null | undefined } | { __typename?: 'RestartFlowPrompt', id: string } | { __typename?: 'SubstitutePurchasePrompt', id: string } | null | undefined } | null | undefined };

export type InitialPurchaseConfirmShippingAddressWithinRangeQueryVariables = Exact<{
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  suburb: Scalars['String']['input'];
  postcode: Scalars['String']['input'];
}>;


export type InitialPurchaseConfirmShippingAddressWithinRangeQuery = { __typename?: 'Query', shippingAddressWithinRange?: boolean | null | undefined };

export type InitialPurchaseConfirmUpdateProfileMutationVariables = Exact<{
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  birthday?: InputMaybe<Scalars['String']['input']>;
}>;


export type InitialPurchaseConfirmUpdateProfileMutation = { __typename?: 'Mutation', updateProfile?: { __typename?: 'User', id: string, firstName?: string | null | undefined, phone?: string | null | undefined, birthday?: string | null | undefined } | null | undefined };

export type InitialPurchaseConfirmUpdateResidentialAddressMutationVariables = Exact<{
  residentialAddress: ResidentialAddressCreateInput;
}>;


export type InitialPurchaseConfirmUpdateResidentialAddressMutation = { __typename?: 'Mutation', updateResidentialAddress?: { __typename?: 'ResidentialAddress', id: string, line1: string, line2?: string | null | undefined, state?: string | null | undefined, country: string, company?: string | null | undefined, building?: string | null | undefined, postalCode: string, city: string } | null | undefined };

export type InitialPurchaseConfirmUpdateShippingMutationVariables = Exact<{
  shippingAddress: AddressCreateWithoutUserInput;
}>;


export type InitialPurchaseConfirmUpdateShippingMutation = { __typename?: 'Mutation', updateShipping?: { __typename?: 'User', id: string, address?: { __typename?: 'Address', id: string, line1?: string | null | undefined, line2?: string | null | undefined, state?: string | null | undefined, country?: string | null | undefined, company?: string | null | undefined, building?: string | null | undefined, postalCode?: string | null | undefined, city?: string | null | undefined } | null | undefined } | null | undefined };

export type InitialPurchaseConfirmInitiateZipCheckoutMutationVariables = Exact<{
  input: InitiateFlexiZipCheckoutInput;
}>;


export type InitialPurchaseConfirmInitiateZipCheckoutMutation = { __typename?: 'Mutation', initiateFlexiZipCheckout?: { __typename?: 'ZipCheckoutResponse', redirectUrl: string } | null | undefined };

type OfferingVertical_AddOnOffering_Fragment = { __typename?: 'AddOnOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined };

type OfferingVertical_OtcOffering_Fragment = { __typename?: 'OtcOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined };

type OfferingVertical_RxOffering_Fragment = { __typename?: 'RxOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined };

export type OfferingVerticalFragment = OfferingVertical_AddOnOffering_Fragment | OfferingVertical_OtcOffering_Fragment | OfferingVertical_RxOffering_Fragment;

export type OrderConfirmedPageQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type OrderConfirmedPageQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, email: string } | null | undefined, consultation?: { __typename?: 'Consultation', id: string, status: ConsultationStatus } | null | undefined };

export type PaymentMethodsFragment = { __typename?: 'User', id: string, defaultPaymentGateway?: PaymentGateway | null | undefined, savedPaymentMethods?: Array<{ __typename?: 'SavedCardPaymentMethod', expiry: string, mask: string, brand: string, id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | { __typename?: 'SavedPayPalPaymentMethod', email?: string | null | undefined, id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | { __typename?: 'SavedSofortPaymentMethod', id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | { __typename?: 'SavedZipPaymentMethod', valid: boolean, id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | null | undefined> | null | undefined, zip?: { __typename?: 'Zip', valid: boolean } | null | undefined };

export type PurchaseActivationFlowShippingAddressWithinRangeQueryVariables = Exact<{
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  suburb: Scalars['String']['input'];
  postcode: Scalars['String']['input'];
}>;


export type PurchaseActivationFlowShippingAddressWithinRangeQuery = { __typename?: 'Query', shippingAddressWithinRange?: boolean | null | undefined };

export type PurchaseActivationFlowAddDetailsSectionQueryVariables = Exact<{ [key: string]: never; }>;


export type PurchaseActivationFlowAddDetailsSectionQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, email: string, phone?: string | null | undefined, weightTreatmentCategory?: WeightTreatmentCategory | null | undefined, address?: { __typename?: 'Address', id: string, line1?: string | null | undefined, line2?: string | null | undefined, city?: string | null | undefined, postalCode?: string | null | undefined, country?: string | null | undefined, state?: string | null | undefined, prefecture?: string | null | undefined, municipality?: string | null | undefined, townArea?: string | null | undefined, company?: string | null | undefined, building?: string | null | undefined } | null | undefined } | null | undefined, validPhoneRegions?: Array<{ __typename?: 'ValidPhoneRegion', id: string, countryCode: string }> | null | undefined };

export type PurchaseActivationFlowUpdateDetailsMutationVariables = Exact<{
  phone?: InputMaybe<Scalars['String']['input']>;
  updatePhone: Scalars['Boolean']['input'];
  address?: InputMaybe<AddressCreateWithoutUserInput>;
  updateAddress: Scalars['Boolean']['input'];
}>;


export type PurchaseActivationFlowUpdateDetailsMutation = { __typename?: 'Mutation', updateShipping?: { __typename?: 'User', id: string, address?: { __typename?: 'Address', id: string, line1?: string | null | undefined, line2?: string | null | undefined, city?: string | null | undefined, postalCode?: string | null | undefined, country?: string | null | undefined, state?: string | null | undefined, prefecture?: string | null | undefined, municipality?: string | null | undefined, townArea?: string | null | undefined, company?: string | null | undefined, building?: string | null | undefined } | null | undefined } | null | undefined, updateProfile?: { __typename?: 'User', id: string, phone?: string | null | undefined } | null | undefined };

export type PurchaseActivationFlowAddonPriceQueryVariables = Exact<{
  pricingSessionId: Scalars['ID']['input'];
  offeringSelections: Array<OfferingSelectionInput> | OfferingSelectionInput;
}>;


export type PurchaseActivationFlowAddonPriceQuery = { __typename?: 'Query', initialPurchasePrice?: { __typename?: 'InitialPurchasePriceList', id: string, amount: number } | null | undefined };

export type AddonDrawerFocusedShopItemFragment = { __typename?: 'ShopItem', id: string, title: string, otcOffering?: { __typename?: 'OtcOffering', id: string, photoUrl: string, description: string, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, defaultSequence?: { __typename?: 'OtcSequence', id: string } | { __typename?: 'PrescribableSequence', id: string } | null | undefined, sequences?: Array<{ __typename?: 'OtcSequence', id: string, friendlyName: string, status: SequenceStatus } | { __typename?: 'PrescribableSequence', id: string, friendlyName: string, status: SequenceStatus }> | null | undefined }> | null | undefined } | null | undefined };

export type PurchaseActivationFlowAddonSectionQueryVariables = Exact<{
  problemType: ProblemType;
}>;


export type PurchaseActivationFlowAddonSectionQuery = { __typename?: 'Query', pafAddonSection?: { __typename?: 'PafAddonSection', id: string, bannerMarkdown?: string | null | undefined, shopItems: Array<{ __typename?: 'ShopItem', id: string, title: string, otcOffering?: { __typename?: 'OtcOffering', id: string, advertisedStartingAmount: string, photoUrl: string, description: string, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, defaultSequence?: { __typename?: 'OtcSequence', id: string } | { __typename?: 'PrescribableSequence', id: string } | null | undefined, sequences?: Array<{ __typename?: 'OtcSequence', id: string, friendlyName: string, status: SequenceStatus } | { __typename?: 'PrescribableSequence', id: string, friendlyName: string, status: SequenceStatus }> | null | undefined }> | null | undefined } | null | undefined }> } | null | undefined };

export type PurchaseActivationFlowConfirmPurchaseGroupMutationVariables = Exact<{
  input: ConfirmPurchaseGroupInput;
}>;


export type PurchaseActivationFlowConfirmPurchaseGroupMutation = { __typename?: 'Mutation', confirmPurchaseGroup?: { __typename?: 'ConfirmPurchaseGroupPayload', purchaseGroup: { __typename?: 'PurchaseGroup', id: string } } | null | undefined };

export type ContactInfoFragment = { __typename?: 'User', phone?: string | null | undefined, email: string };

export type ShippingAddressFragment = { __typename?: 'User', weightTreatmentCategory?: WeightTreatmentCategory | null | undefined, address?: { __typename?: 'Address', id: string, building?: string | null | undefined, city?: string | null | undefined, company?: string | null | undefined, country?: string | null | undefined, createdAt: string, line1?: string | null | undefined, line2?: string | null | undefined, municipality?: string | null | undefined, postalCode?: string | null | undefined, prefecture?: string | null | undefined, state?: string | null | undefined, townArea?: string | null | undefined, updatedAt: string, deliveryInstructions?: string | null | undefined } | null | undefined };

export type PurchaseActivationFlowConfirmSectionQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type PurchaseActivationFlowConfirmSectionQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, phone?: string | null | undefined, email: string, weightTreatmentCategory?: WeightTreatmentCategory | null | undefined, defaultPaymentGateway?: PaymentGateway | null | undefined, address?: { __typename?: 'Address', id: string, building?: string | null | undefined, city?: string | null | undefined, company?: string | null | undefined, country?: string | null | undefined, createdAt: string, line1?: string | null | undefined, line2?: string | null | undefined, municipality?: string | null | undefined, postalCode?: string | null | undefined, prefecture?: string | null | undefined, state?: string | null | undefined, townArea?: string | null | undefined, updatedAt: string, deliveryInstructions?: string | null | undefined } | null | undefined, savedPaymentMethods?: Array<{ __typename?: 'SavedCardPaymentMethod', expiry: string, mask: string, brand: string, id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | { __typename?: 'SavedPayPalPaymentMethod', email?: string | null | undefined, id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | { __typename?: 'SavedSofortPaymentMethod', id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | { __typename?: 'SavedZipPaymentMethod', valid: boolean, id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | null | undefined> | null | undefined, zip?: { __typename?: 'Zip', valid: boolean } | null | undefined } | null | undefined, validPhoneRegions?: Array<{ __typename?: 'ValidPhoneRegion', id: string, countryCode: string }> | null | undefined, consultation?: { __typename?: 'Consultation', id: string, purchasePrompt?: { __typename?: 'ConfirmPurchasePrompt', id: string, purchaseGroup: { __typename?: 'PurchaseGroup', id: string } } | { __typename?: 'FurPurchasePrompt', id: string } | { __typename?: 'InitialPurchasePrompt', id: string } | { __typename?: 'RestartFlowPrompt', id: string } | { __typename?: 'SubstitutePurchasePrompt', id: string } | null | undefined } | null | undefined };

export type PurchaseActivationFlowConfirmSectionInitiateZipCheckoutMutationVariables = Exact<{
  input: InitiateFlexiZipCheckoutInput;
}>;


export type PurchaseActivationFlowConfirmSectionInitiateZipCheckoutMutation = { __typename?: 'Mutation', initiateFlexiZipCheckout?: { __typename?: 'ZipCheckoutResponse', redirectUrl: string } | null | undefined };

export type PurchaseActivationFlowUpdateShippingAddressMutationVariables = Exact<{
  address?: InputMaybe<AddressCreateWithoutUserInput>;
}>;


export type PurchaseActivationFlowUpdateShippingAddressMutation = { __typename?: 'Mutation', updateShipping?: { __typename?: 'User', id: string, address?: { __typename?: 'Address', id: string, line1?: string | null | undefined, line2?: string | null | undefined, city?: string | null | undefined, postalCode?: string | null | undefined, country?: string | null | undefined, state?: string | null | undefined, prefecture?: string | null | undefined, municipality?: string | null | undefined, townArea?: string | null | undefined, company?: string | null | undefined, building?: string | null | undefined } | null | undefined } | null | undefined };

export type PurchaseActivationFlowUpdateContactInfoMutationVariables = Exact<{
  phone?: InputMaybe<Scalars['String']['input']>;
}>;


export type PurchaseActivationFlowUpdateContactInfoMutation = { __typename?: 'Mutation', updateProfile?: { __typename?: 'User', id: string, phone?: string | null | undefined } | null | undefined };

type OfferingHighlightsSequence_OtcSequence_Fragment = { __typename?: 'OtcSequence', id: string };

type OfferingHighlightsSequence_PrescribableSequence_Fragment = { __typename?: 'PrescribableSequence', containsRefrigeratedContents?: boolean | null | undefined, id: string };

export type OfferingHighlightsSequenceFragment = OfferingHighlightsSequence_OtcSequence_Fragment | OfferingHighlightsSequence_PrescribableSequence_Fragment;

export type OrderSummaryCardGippFragment = { __typename?: 'InitialPurchasePriceList', id: string, amount: number, discountAmount: number, originalAmount: number, sessionCreditAmount: number, coupons?: Array<{ __typename?: 'InitialPurchasePriceCoupon', id: string, code: string, outcome: CouponOutcome }> | null | undefined, offeringPriceLists: Array<{ __typename?: 'InitialPurchasePriceOfferingPriceList', id: string, offering?: { __typename?: 'AddOnOffering', id: string, advertisedName: string, friendlyName: string, photoUrl: string, advertisedCostCadence?: string | null | undefined } | { __typename?: 'OtcOffering', id: string, advertisedName: string, friendlyName: string, photoUrl: string, advertisedCostCadence?: string | null | undefined } | { __typename?: 'RxOffering', id: string, advertisedName: string, friendlyName: string, photoUrl: string, advertisedCostCadence?: string | null | undefined } | null | undefined, sequencePriceLists: Array<{ __typename?: 'InitialPurchasePriceSequencePriceList', id: string, sequence?: { __typename?: 'OtcSequence', id: string, friendlyName: string } | { __typename?: 'PrescribableSequence', id: string, friendlyName: string } | null | undefined, sequenceSet?: { __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string } | { __typename?: 'PrescribableSequence', id: string }> | null | undefined } | null | undefined, pricedItems: Array<{ __typename?: 'InitialPurchasePriceSequencePricedItem', id: string, unitPrice: number, quantity: number, variant?: { __typename?: 'Variant', id: string, public: boolean, product: { __typename?: 'Product', id: string, name: string, photo?: { __typename?: 'File', id: string, url: string } | null | undefined } } | null | undefined }> }> }> };

export type PurchaseActivationFlowOrderSummarySectionQueryVariables = Exact<{
  problemType: ProblemType;
}>;


export type PurchaseActivationFlowOrderSummarySectionQuery = { __typename?: 'Query', pafAddonSection?: { __typename?: 'PafAddonSection', id: string, shopItems: Array<{ __typename?: 'ShopItem', id: string, title: string, otcOffering?: { __typename?: 'OtcOffering', id: string, photoUrl: string, description: string, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, defaultSequence?: { __typename?: 'OtcSequence', id: string } | { __typename?: 'PrescribableSequence', id: string } | null | undefined, sequences?: Array<{ __typename?: 'OtcSequence', id: string, friendlyName: string, status: SequenceStatus } | { __typename?: 'PrescribableSequence', id: string, friendlyName: string, status: SequenceStatus }> | null | undefined }> | null | undefined } | null | undefined }> } | null | undefined };

export type OrderSummaryGippFragment = { __typename?: 'InitialPurchasePriceList', id: string, amount: number, discountAmount: number, originalAmount: number, sessionCreditAmount: number, coupons?: Array<{ __typename?: 'InitialPurchasePriceCoupon', id: string, code: string, outcome: CouponOutcome }> | null | undefined, offeringPriceLists: Array<{ __typename?: 'InitialPurchasePriceOfferingPriceList', id: string, offering?: { __typename?: 'AddOnOffering', id: string, advertisedName: string, friendlyName: string, photoUrl: string, advertisedCostCadence?: string | null | undefined } | { __typename?: 'OtcOffering', id: string, advertisedName: string, friendlyName: string, photoUrl: string, advertisedCostCadence?: string | null | undefined } | { __typename?: 'RxOffering', id: string, advertisedName: string, friendlyName: string, photoUrl: string, advertisedCostCadence?: string | null | undefined } | null | undefined, sequencePriceLists: Array<{ __typename?: 'InitialPurchasePriceSequencePriceList', id: string, sequence?: { __typename?: 'OtcSequence', id: string, friendlyName: string } | { __typename?: 'PrescribableSequence', id: string, friendlyName: string, containsRefrigeratedContents?: boolean | null | undefined } | null | undefined, sequenceSet?: { __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string } | { __typename?: 'PrescribableSequence', id: string }> | null | undefined } | null | undefined, pricedItems: Array<{ __typename?: 'InitialPurchasePriceSequencePricedItem', id: string, unitPrice: number, quantity: number, variant?: { __typename?: 'Variant', id: string, public: boolean, product: { __typename?: 'Product', id: string, name: string, deliveryInformation?: string | null | undefined, photo?: { __typename?: 'File', id: string, url: string } | null | undefined } } | null | undefined }> }> }> };

export type PurchaseActivationFlowProblemTypeQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type PurchaseActivationFlowProblemTypeQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, type: ProblemType } | null | undefined };

export type PurchaseActivationFlowProviderQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
  problemType: ProblemType;
  stage: PafStage;
}>;


export type PurchaseActivationFlowProviderQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, phone?: string | null | undefined, address?: { __typename?: 'Address', id: string } | null | undefined } | null | undefined, pafAddonSection?: { __typename?: 'PafAddonSection', id: string } | null | undefined, consultation?: { __typename?: 'Consultation', id: string, purchasePrompt?: { __typename?: 'ConfirmPurchasePrompt', id: string, purchaseGroup: { __typename?: 'PurchaseGroup', id: string, pricingSessionId: string, purchases?: Array<{ __typename?: 'Purchase', id: string, offering?: { __typename?: 'AddOnOffering', id: string, upsells?: Array<{ __typename?: 'SwitchCandidate', id: string }> | null | undefined, downsells?: Array<{ __typename?: 'SwitchCandidate', id: string }> | null | undefined } | { __typename?: 'OtcOffering', id: string, upsells?: Array<{ __typename?: 'SwitchCandidate', id: string }> | null | undefined, downsells?: Array<{ __typename?: 'SwitchCandidate', id: string }> | null | undefined } | { __typename?: 'RxOffering', id: string, upsells?: Array<{ __typename?: 'SwitchCandidate', id: string }> | null | undefined, downsells?: Array<{ __typename?: 'SwitchCandidate', id: string }> | null | undefined } | null | undefined, contexts?: Array<{ __typename?: 'SequenceContext', id: string, sequence?: { __typename?: 'OtcSequence', id: string } | { __typename?: 'PrescribableSequence', id: string } | null | undefined, sequenceSet?: { __typename?: 'SequenceSet', id: string } | null | undefined }> | null | undefined }> | null | undefined } } | { __typename?: 'FurPurchasePrompt', id: string } | { __typename?: 'InitialPurchasePrompt', id: string } | { __typename?: 'RestartFlowPrompt', id: string } | { __typename?: 'SubstitutePurchasePrompt', id: string, pricingSessionId: string, substitutions?: Array<{ __typename?: 'PurchaseSubstitution', id: string, substitution: { __typename?: 'OfferingSelection', id: string, offering?: { __typename?: 'AddOnOffering', id: string, upsells?: Array<{ __typename?: 'SwitchCandidate', id: string }> | null | undefined, downsells?: Array<{ __typename?: 'SwitchCandidate', id: string }> | null | undefined } | { __typename?: 'OtcOffering', id: string, upsells?: Array<{ __typename?: 'SwitchCandidate', id: string }> | null | undefined, downsells?: Array<{ __typename?: 'SwitchCandidate', id: string }> | null | undefined } | { __typename?: 'RxOffering', id: string, upsells?: Array<{ __typename?: 'SwitchCandidate', id: string }> | null | undefined, downsells?: Array<{ __typename?: 'SwitchCandidate', id: string }> | null | undefined } | null | undefined, sequenceSelections?: Array<{ __typename?: 'SequenceSelection', id: string, sequence?: { __typename?: 'OtcSequence', id: string } | { __typename?: 'PrescribableSequence', id: string } | null | undefined, sequenceSet?: { __typename?: 'SequenceSet', id: string } | null | undefined }> | null | undefined } }> | null | undefined } | null | undefined } | null | undefined };

type PurchaseActivationFlowOfferingVerticals_AddOnOffering_Fragment = { __typename?: 'AddOnOffering', upsells?: Array<{ __typename?: 'SwitchCandidate', id: string }> | null | undefined, downsells?: Array<{ __typename?: 'SwitchCandidate', id: string }> | null | undefined };

type PurchaseActivationFlowOfferingVerticals_OtcOffering_Fragment = { __typename?: 'OtcOffering', upsells?: Array<{ __typename?: 'SwitchCandidate', id: string }> | null | undefined, downsells?: Array<{ __typename?: 'SwitchCandidate', id: string }> | null | undefined };

type PurchaseActivationFlowOfferingVerticals_RxOffering_Fragment = { __typename?: 'RxOffering', upsells?: Array<{ __typename?: 'SwitchCandidate', id: string }> | null | undefined, downsells?: Array<{ __typename?: 'SwitchCandidate', id: string }> | null | undefined };

export type PurchaseActivationFlowOfferingVerticalsFragment = PurchaseActivationFlowOfferingVerticals_AddOnOffering_Fragment | PurchaseActivationFlowOfferingVerticals_OtcOffering_Fragment | PurchaseActivationFlowOfferingVerticals_RxOffering_Fragment;

export type PurchaseActivationFlowGippQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
  pricingSessionId: Scalars['ID']['input'];
  offeringSelections: Array<OfferingSelectionInput> | OfferingSelectionInput;
  couponCodes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type PurchaseActivationFlowGippQuery = { __typename?: 'Query', initialPurchasePrice?: { __typename?: 'InitialPurchasePriceList', id: string, amount: number, discountAmount: number, originalAmount: number, sessionCreditAmount: number, coupons?: Array<{ __typename?: 'InitialPurchasePriceCoupon', id: string, code: string, outcome: CouponOutcome }> | null | undefined, offeringPriceLists: Array<{ __typename?: 'InitialPurchasePriceOfferingPriceList', id: string, offering?: { __typename?: 'AddOnOffering', id: string, advertisedName: string, friendlyName: string, photoUrl: string, advertisedCostCadence?: string | null | undefined } | { __typename?: 'OtcOffering', id: string, advertisedName: string, friendlyName: string, photoUrl: string, advertisedCostCadence?: string | null | undefined } | { __typename?: 'RxOffering', id: string, advertisedName: string, friendlyName: string, photoUrl: string, advertisedCostCadence?: string | null | undefined } | null | undefined, sequencePriceLists: Array<{ __typename?: 'InitialPurchasePriceSequencePriceList', id: string, sequence?: { __typename?: 'OtcSequence', id: string, friendlyName: string } | { __typename?: 'PrescribableSequence', id: string, friendlyName: string, containsRefrigeratedContents?: boolean | null | undefined } | null | undefined, sequenceSet?: { __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string } | { __typename?: 'PrescribableSequence', id: string }> | null | undefined } | null | undefined, pricedItems: Array<{ __typename?: 'InitialPurchasePriceSequencePricedItem', id: string, unitPrice: number, quantity: number, variant?: { __typename?: 'Variant', id: string, public: boolean, product: { __typename?: 'Product', id: string, name: string, deliveryInformation?: string | null | undefined, photo?: { __typename?: 'File', id: string, url: string } | null | undefined } } | null | undefined }> }> }> } | null | undefined };

export type PurchaseActivationFlowQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type PurchaseActivationFlowQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, purchasePrompt?: { __typename?: 'ConfirmPurchasePrompt', id: string } | { __typename?: 'FurPurchasePrompt', id: string } | { __typename?: 'InitialPurchasePrompt', id: string } | { __typename?: 'RestartFlowPrompt', id: string } | { __typename?: 'SubstitutePurchasePrompt', id: string } | null | undefined } | null | undefined };

export type ReceiptPsatConsultationFragment = { __typename?: 'Consultation', id: string, type: ProblemType, customer: { __typename?: 'User', id: string, firstName?: string | null | undefined }, doctor?: { __typename?: 'User', id: string, shortClinicianName: string } | null | undefined };

export type PurchaseActivationFlowReceiptSectionQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type PurchaseActivationFlowReceiptSectionQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, email: string } | null | undefined, consultation?: { __typename?: 'Consultation', id: string, type: ProblemType, customer: { __typename?: 'User', id: string, firstName?: string | null | undefined }, doctor?: { __typename?: 'User', id: string, shortClinicianName: string } | null | undefined } | null | undefined };

type ReviewSectionOffering_AddOnOffering_Fragment = { __typename?: 'AddOnOffering', id: string, advertisedName: string, advertisedShippingCadence: string, tags: Array<string>, upsells?: Array<{ __typename?: 'SwitchCandidate', id: string }> | null | undefined, downsells?: Array<{ __typename?: 'SwitchCandidate', id: string }> | null | undefined };

type ReviewSectionOffering_OtcOffering_Fragment = { __typename?: 'OtcOffering', id: string, advertisedName: string, advertisedShippingCadence: string, tags: Array<string>, upsells?: Array<{ __typename?: 'SwitchCandidate', id: string }> | null | undefined, downsells?: Array<{ __typename?: 'SwitchCandidate', id: string }> | null | undefined };

type ReviewSectionOffering_RxOffering_Fragment = { __typename?: 'RxOffering', id: string, advertisedName: string, advertisedShippingCadence: string, tags: Array<string>, upsells?: Array<{ __typename?: 'SwitchCandidate', id: string }> | null | undefined, downsells?: Array<{ __typename?: 'SwitchCandidate', id: string }> | null | undefined };

export type ReviewSectionOfferingFragment = ReviewSectionOffering_AddOnOffering_Fragment | ReviewSectionOffering_OtcOffering_Fragment | ReviewSectionOffering_RxOffering_Fragment;

export type PurchaseActivationFlowReviewSectionQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
  offeringSelections: Array<OfferingSelectionInput> | OfferingSelectionInput;
  noSelections: Scalars['Boolean']['input'];
}>;


export type PurchaseActivationFlowReviewSectionQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, phone?: string | null | undefined, address?: { __typename?: 'Address', id: string } | null | undefined, healthCareDetails?: { __typename?: 'HealthCareDetails', id: string, hasIndividualHealthcareIdentifier?: boolean | null | undefined } | null | undefined } | null | undefined, consultation?: { __typename?: 'Consultation', id: string, type: ProblemType, doctor?: { __typename?: 'User', id: string, shortClinicianName: string, fullClinicianName: string } | null | undefined, prescribedSequence?: { __typename?: 'PrescribedSequence', id: string, sequence?: { __typename?: 'OtcSequence', id: string, friendlyName: string } | { __typename?: 'PrescribableSequence', id: string, friendlyName: string, containsRefrigeratedContents?: boolean | null | undefined, faqs: Array<{ __typename?: 'SequenceFaq', id: string, rank?: number | null | undefined, question: string, answerMarkdown: string }> } | null | undefined } | null | undefined, purchasePrompt?: { __typename?: 'ConfirmPurchasePrompt', id: string, purchaseGroup: { __typename?: 'PurchaseGroup', id: string, purchases?: Array<{ __typename?: 'Purchase', id: string, offering?: { __typename?: 'AddOnOffering', id: string, advertisedName: string, advertisedShippingCadence: string, tags: Array<string>, upsells?: Array<{ __typename?: 'SwitchCandidate', id: string }> | null | undefined, downsells?: Array<{ __typename?: 'SwitchCandidate', id: string }> | null | undefined } | { __typename?: 'OtcOffering', id: string, advertisedName: string, advertisedShippingCadence: string, tags: Array<string>, upsells?: Array<{ __typename?: 'SwitchCandidate', id: string }> | null | undefined, downsells?: Array<{ __typename?: 'SwitchCandidate', id: string }> | null | undefined } | { __typename?: 'RxOffering', id: string, advertisedName: string, advertisedShippingCadence: string, tags: Array<string>, upsells?: Array<{ __typename?: 'SwitchCandidate', id: string }> | null | undefined, downsells?: Array<{ __typename?: 'SwitchCandidate', id: string }> | null | undefined } | null | undefined, contexts?: Array<{ __typename?: 'SequenceContext', id: string, sequence?: { __typename?: 'OtcSequence', id: string } | { __typename?: 'PrescribableSequence', id: string } | null | undefined, sequenceSet?: { __typename?: 'SequenceSet', id: string } | null | undefined }> | null | undefined }> | null | undefined } } | { __typename?: 'FurPurchasePrompt', id: string } | { __typename?: 'InitialPurchasePrompt', id: string } | { __typename?: 'RestartFlowPrompt', id: string } | { __typename?: 'SubstitutePurchasePrompt', pricingSessionId: string, id: string, substitutions?: Array<{ __typename?: 'PurchaseSubstitution', id: string, substitution: { __typename?: 'OfferingSelection', id: string, offering?: { __typename?: 'AddOnOffering', id: string, advertisedName: string, advertisedShippingCadence: string, tags: Array<string>, upsells?: Array<{ __typename?: 'SwitchCandidate', id: string }> | null | undefined, downsells?: Array<{ __typename?: 'SwitchCandidate', id: string }> | null | undefined } | { __typename?: 'OtcOffering', id: string, advertisedName: string, advertisedShippingCadence: string, tags: Array<string>, upsells?: Array<{ __typename?: 'SwitchCandidate', id: string }> | null | undefined, downsells?: Array<{ __typename?: 'SwitchCandidate', id: string }> | null | undefined } | { __typename?: 'RxOffering', id: string, advertisedName: string, advertisedShippingCadence: string, tags: Array<string>, upsells?: Array<{ __typename?: 'SwitchCandidate', id: string }> | null | undefined, downsells?: Array<{ __typename?: 'SwitchCandidate', id: string }> | null | undefined } | null | undefined, sequenceSelections?: Array<{ __typename?: 'SequenceSelection', id: string, sequence?: { __typename?: 'OtcSequence', id: string } | { __typename?: 'PrescribableSequence', id: string } | null | undefined, sequenceSet?: { __typename?: 'SequenceSet', id: string } | null | undefined }> | null | undefined } }> | null | undefined } | null | undefined } | null | undefined, offeringsTimeline?: Array<{ __typename?: 'PredictedOfferingTimelineItem', id: string, date: string, totalAmount: number, products?: Array<{ __typename?: 'Product', id: string, friendlyName?: string | null | undefined, erxMedicines: Array<{ __typename?: 'ErxMedicine', id?: string | null | undefined, itemForm?: string | null | undefined, itemStrength?: string | null | undefined }> }> | null | undefined }> | null | undefined };

export type PurchaseActivationSwitchCandidateFragment = { __typename?: 'SwitchCandidate', id: string, advertisedCadencePricingDelta?: string | null | undefined, offering?: { __typename?: 'AddOnOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | { __typename?: 'OtcOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | { __typename?: 'RxOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | null | undefined };

type PurchaseActivationOffering_AddOnOffering_Fragment = { __typename?: 'AddOnOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, upsells?: Array<{ __typename?: 'SwitchCandidate', id: string, advertisedCadencePricingDelta?: string | null | undefined, offering?: { __typename?: 'AddOnOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | { __typename?: 'OtcOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | { __typename?: 'RxOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | null | undefined }> | null | undefined, downsells?: Array<{ __typename?: 'SwitchCandidate', id: string, advertisedCadencePricingDelta?: string | null | undefined, offering?: { __typename?: 'AddOnOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | { __typename?: 'OtcOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | { __typename?: 'RxOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | null | undefined }> | null | undefined, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined };

type PurchaseActivationOffering_OtcOffering_Fragment = { __typename?: 'OtcOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, upsells?: Array<{ __typename?: 'SwitchCandidate', id: string, advertisedCadencePricingDelta?: string | null | undefined, offering?: { __typename?: 'AddOnOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | { __typename?: 'OtcOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | { __typename?: 'RxOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | null | undefined }> | null | undefined, downsells?: Array<{ __typename?: 'SwitchCandidate', id: string, advertisedCadencePricingDelta?: string | null | undefined, offering?: { __typename?: 'AddOnOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | { __typename?: 'OtcOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | { __typename?: 'RxOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | null | undefined }> | null | undefined, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined };

type PurchaseActivationOffering_RxOffering_Fragment = { __typename?: 'RxOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, upsells?: Array<{ __typename?: 'SwitchCandidate', id: string, advertisedCadencePricingDelta?: string | null | undefined, offering?: { __typename?: 'AddOnOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | { __typename?: 'OtcOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | { __typename?: 'RxOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | null | undefined }> | null | undefined, downsells?: Array<{ __typename?: 'SwitchCandidate', id: string, advertisedCadencePricingDelta?: string | null | undefined, offering?: { __typename?: 'AddOnOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | { __typename?: 'OtcOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | { __typename?: 'RxOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | null | undefined }> | null | undefined, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined };

export type PurchaseActivationOfferingFragment = PurchaseActivationOffering_AddOnOffering_Fragment | PurchaseActivationOffering_OtcOffering_Fragment | PurchaseActivationOffering_RxOffering_Fragment;

export type PurchaseActivationFlowTierSelectionSectionQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type PurchaseActivationFlowTierSelectionSectionQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, purchasePrompt?: { __typename?: 'ConfirmPurchasePrompt', id: string, purchaseGroup: { __typename?: 'PurchaseGroup', id: string, purchases?: Array<{ __typename?: 'Purchase', id: string, contexts?: Array<{ __typename?: 'SequenceContext', id: string, sequence?: { __typename?: 'OtcSequence', id: string } | { __typename?: 'PrescribableSequence', id: string } | null | undefined }> | null | undefined, offering?: { __typename?: 'AddOnOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, upsells?: Array<{ __typename?: 'SwitchCandidate', id: string, advertisedCadencePricingDelta?: string | null | undefined, offering?: { __typename?: 'AddOnOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | { __typename?: 'OtcOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | { __typename?: 'RxOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | null | undefined }> | null | undefined, downsells?: Array<{ __typename?: 'SwitchCandidate', id: string, advertisedCadencePricingDelta?: string | null | undefined, offering?: { __typename?: 'AddOnOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | { __typename?: 'OtcOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | { __typename?: 'RxOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | null | undefined }> | null | undefined, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | { __typename?: 'OtcOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, upsells?: Array<{ __typename?: 'SwitchCandidate', id: string, advertisedCadencePricingDelta?: string | null | undefined, offering?: { __typename?: 'AddOnOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | { __typename?: 'OtcOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | { __typename?: 'RxOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | null | undefined }> | null | undefined, downsells?: Array<{ __typename?: 'SwitchCandidate', id: string, advertisedCadencePricingDelta?: string | null | undefined, offering?: { __typename?: 'AddOnOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | { __typename?: 'OtcOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | { __typename?: 'RxOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | null | undefined }> | null | undefined, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | { __typename?: 'RxOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, upsells?: Array<{ __typename?: 'SwitchCandidate', id: string, advertisedCadencePricingDelta?: string | null | undefined, offering?: { __typename?: 'AddOnOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | { __typename?: 'OtcOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | { __typename?: 'RxOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | null | undefined }> | null | undefined, downsells?: Array<{ __typename?: 'SwitchCandidate', id: string, advertisedCadencePricingDelta?: string | null | undefined, offering?: { __typename?: 'AddOnOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | { __typename?: 'OtcOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | { __typename?: 'RxOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | null | undefined }> | null | undefined, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | null | undefined }> | null | undefined } } | { __typename?: 'FurPurchasePrompt', id: string } | { __typename?: 'InitialPurchasePrompt', id: string } | { __typename?: 'RestartFlowPrompt', id: string } | { __typename?: 'SubstitutePurchasePrompt', id: string, substitutions?: Array<{ __typename?: 'PurchaseSubstitution', id: string, substitution: { __typename?: 'OfferingSelection', id: string, sequenceSelections?: Array<{ __typename?: 'SequenceSelection', id: string, sequence?: { __typename?: 'OtcSequence', id: string } | { __typename?: 'PrescribableSequence', id: string } | null | undefined }> | null | undefined, offering?: { __typename?: 'AddOnOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, upsells?: Array<{ __typename?: 'SwitchCandidate', id: string, advertisedCadencePricingDelta?: string | null | undefined, offering?: { __typename?: 'AddOnOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | { __typename?: 'OtcOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | { __typename?: 'RxOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | null | undefined }> | null | undefined, downsells?: Array<{ __typename?: 'SwitchCandidate', id: string, advertisedCadencePricingDelta?: string | null | undefined, offering?: { __typename?: 'AddOnOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | { __typename?: 'OtcOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | { __typename?: 'RxOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | null | undefined }> | null | undefined, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | { __typename?: 'OtcOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, upsells?: Array<{ __typename?: 'SwitchCandidate', id: string, advertisedCadencePricingDelta?: string | null | undefined, offering?: { __typename?: 'AddOnOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | { __typename?: 'OtcOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | { __typename?: 'RxOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | null | undefined }> | null | undefined, downsells?: Array<{ __typename?: 'SwitchCandidate', id: string, advertisedCadencePricingDelta?: string | null | undefined, offering?: { __typename?: 'AddOnOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | { __typename?: 'OtcOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | { __typename?: 'RxOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | null | undefined }> | null | undefined, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | { __typename?: 'RxOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, upsells?: Array<{ __typename?: 'SwitchCandidate', id: string, advertisedCadencePricingDelta?: string | null | undefined, offering?: { __typename?: 'AddOnOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | { __typename?: 'OtcOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | { __typename?: 'RxOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | null | undefined }> | null | undefined, downsells?: Array<{ __typename?: 'SwitchCandidate', id: string, advertisedCadencePricingDelta?: string | null | undefined, offering?: { __typename?: 'AddOnOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | { __typename?: 'OtcOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | { __typename?: 'RxOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | null | undefined }> | null | undefined, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined } | null | undefined } }> | null | undefined } | null | undefined } | null | undefined };

export type PurchaseOfferingsFromIntentHandlerMutationVariables = Exact<{
  input: PurchaseOfferingsInput;
}>;


export type PurchaseOfferingsFromIntentHandlerMutation = { __typename?: 'Mutation', purchaseOfferings?: { __typename?: 'PurchaseOfferingsPayload', purchaseGroup: { __typename?: 'PurchaseGroup', id: string, consultation?: { __typename?: 'Consultation', id: string, status: ConsultationStatus, purchasePrompt?: { __typename?: 'ConfirmPurchasePrompt', id: string } | { __typename?: 'FurPurchasePrompt', id: string } | { __typename?: 'InitialPurchasePrompt', id: string } | { __typename?: 'RestartFlowPrompt', id: string } | { __typename?: 'SubstitutePurchasePrompt', id: string } | null | undefined } | null | undefined } } | null | undefined };

export type PurchaseOfferingsIntentHandlerPageQueryVariables = Exact<{
  consultationId?: InputMaybe<Scalars['String']['input']>;
  pricingSessionId: Scalars['ID']['input'];
  offeringSelections: Array<OfferingSelectionInput> | OfferingSelectionInput;
  couponCodes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type PurchaseOfferingsIntentHandlerPageQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, email: string, zip?: { __typename?: 'Zip', valid: boolean } | null | undefined } | null | undefined, initialPurchasePrice?: { __typename?: 'InitialPurchasePriceList', id: string, amount: number, discountAmount: number, offeringPriceLists: Array<{ __typename?: 'InitialPurchasePriceOfferingPriceList', id: string, offering?: { __typename?: 'AddOnOffering', id: string, problemTypes?: Array<ProblemType> | null | undefined } | { __typename?: 'OtcOffering', id: string, problemTypes?: Array<ProblemType> | null | undefined } | { __typename?: 'RxOffering', id: string, problemTypes?: Array<ProblemType> | null | undefined } | null | undefined, sequencePriceLists: Array<{ __typename?: 'InitialPurchasePriceSequencePriceList', id: string, sequence?: { __typename?: 'OtcSequence', id: string } | { __typename?: 'PrescribableSequence', id: string } | null | undefined, pricedItems: Array<{ __typename?: 'InitialPurchasePriceSequencePricedItem', id: string, quantity: number, unitPrice: number, unitPriceDiscount: number, variant?: { __typename?: 'Variant', id: string, product: { __typename?: 'Product', id: string, problemTypes: Array<ProblemType>, name: string }, inventory?: { __typename?: 'VariantInventory', id: string, sku?: string | null | undefined } | null | undefined } | null | undefined }> }> }> } | null | undefined };

export type SafetyInformationSequenceFragment = { __typename?: 'PrescribableSequence', safetyInformation?: { __typename?: 'SequenceSafetyInformation', id: string, cmiUrl: string, cmiCopyMarkdown: string } | null | undefined };

export type FaqSequenceFragment = { __typename?: 'PrescribableSequence', faqs: Array<{ __typename?: 'SequenceFaq', id: string, rank?: number | null | undefined, question: string, answerMarkdown: string }> };

export type SafetyInformationPageQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type SafetyInformationPageQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, purchasePrompt?: { __typename?: 'ConfirmPurchasePrompt', id: string, purchaseGroup: { __typename?: 'PurchaseGroup', id: string, purchases?: Array<{ __typename?: 'Purchase', id: string, contexts?: Array<{ __typename?: 'SequenceContext', id: string, sequence?: { __typename?: 'OtcSequence', id: string } | { __typename?: 'PrescribableSequence', id: string, safetyInformation?: { __typename?: 'SequenceSafetyInformation', id: string, cmiUrl: string, cmiCopyMarkdown: string } | null | undefined, faqs: Array<{ __typename?: 'SequenceFaq', id: string, rank?: number | null | undefined, question: string, answerMarkdown: string }> } | null | undefined }> | null | undefined }> | null | undefined } } | { __typename?: 'FurPurchasePrompt', id: string, proposedOfferingSelection?: { __typename?: 'OfferingSelection', id: string, sequenceSelections?: Array<{ __typename?: 'SequenceSelection', id: string, sequence?: { __typename?: 'OtcSequence', id: string } | { __typename?: 'PrescribableSequence', id: string, safetyInformation?: { __typename?: 'SequenceSafetyInformation', id: string, cmiUrl: string, cmiCopyMarkdown: string } | null | undefined, faqs: Array<{ __typename?: 'SequenceFaq', id: string, rank?: number | null | undefined, question: string, answerMarkdown: string }> } | null | undefined }> | null | undefined } | null | undefined } | { __typename?: 'InitialPurchasePrompt', id: string, proposedOfferingSelection?: { __typename?: 'OfferingSelection', id: string, sequenceSelections?: Array<{ __typename?: 'SequenceSelection', id: string, sequence?: { __typename?: 'OtcSequence', id: string } | { __typename?: 'PrescribableSequence', id: string, faqs: Array<{ __typename?: 'SequenceFaq', id: string, rank?: number | null | undefined, question: string, answerMarkdown: string }>, safetyInformation?: { __typename?: 'SequenceSafetyInformation', id: string, cmiUrl: string, cmiCopyMarkdown: string } | null | undefined } | null | undefined }> | null | undefined } | null | undefined } | { __typename?: 'RestartFlowPrompt', id: string } | { __typename?: 'SubstitutePurchasePrompt', id: string, substitutions?: Array<{ __typename?: 'PurchaseSubstitution', id: string, substitution: { __typename?: 'OfferingSelection', id: string, sequenceSelections?: Array<{ __typename?: 'SequenceSelection', id: string, sequence?: { __typename?: 'OtcSequence', id: string } | { __typename?: 'PrescribableSequence', id: string, safetyInformation?: { __typename?: 'SequenceSafetyInformation', id: string, cmiUrl: string, cmiCopyMarkdown: string } | null | undefined, faqs: Array<{ __typename?: 'SequenceFaq', id: string, rank?: number | null | undefined, question: string, answerMarkdown: string }> } | null | undefined }> | null | undefined } }> | null | undefined } | null | undefined } | null | undefined };

export type SafetyInformationQuestionMutationVariables = Exact<{
  consultationId: Scalars['String']['input'];
  messageText: Scalars['String']['input'];
  contactMethod?: InputMaybe<ContactMethod>;
}>;


export type SafetyInformationQuestionMutation = { __typename?: 'Mutation', submitConsultationQuestionToPharmacist?: { __typename?: 'SubmitConsultationQuestionToPharmacistPayload', consultation?: { __typename?: 'Consultation', id: string } | null | undefined } | null | undefined };

export type SubstitutePurchaseConfirmAddressRangeQueryVariables = Exact<{
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  suburb: Scalars['String']['input'];
  postcode: Scalars['String']['input'];
}>;


export type SubstitutePurchaseConfirmAddressRangeQuery = { __typename?: 'Query', shippingAddressWithinRange?: boolean | null | undefined };

export type SubstitutePurchaseConfirmQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
  offeringSelections: Array<OfferingSelectionInput> | OfferingSelectionInput;
  noPayload: Scalars['Boolean']['input'];
  couponCodes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  pricingSessionId: Scalars['ID']['input'];
}>;


export type SubstitutePurchaseConfirmQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, defaultPaymentGateway?: PaymentGateway | null | undefined, address?: { __typename?: 'Address', id: string, city?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined, state?: string | null | undefined, country?: string | null | undefined, postalCode?: string | null | undefined, prefecture?: string | null | undefined, municipality?: string | null | undefined, deliveryInstructions?: string | null | undefined, townArea?: string | null | undefined } | null | undefined, residentialAddress?: { __typename?: 'ResidentialAddress', id: string, city: string, line1: string, line2?: string | null | undefined, state?: string | null | undefined, country: string, postalCode: string, prefecture?: string | null | undefined, municipality?: string | null | undefined, townArea?: string | null | undefined } | null | undefined, savedPaymentMethods?: Array<{ __typename?: 'SavedCardPaymentMethod', expiry: string, mask: string, brand: string, id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | { __typename?: 'SavedPayPalPaymentMethod', email?: string | null | undefined, id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | { __typename?: 'SavedSofortPaymentMethod', id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | { __typename?: 'SavedZipPaymentMethod', valid: boolean, id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | null | undefined> | null | undefined, zip?: { __typename?: 'Zip', valid: boolean } | null | undefined } | null | undefined, consultation?: { __typename?: 'Consultation', id: string, purchasePrompt?: { __typename?: 'ConfirmPurchasePrompt', id: string } | { __typename?: 'FurPurchasePrompt', id: string } | { __typename?: 'InitialPurchasePrompt', id: string } | { __typename?: 'RestartFlowPrompt', id: string } | { __typename?: 'SubstitutePurchasePrompt', pricingSessionId: string, id: string, substitutions?: Array<{ __typename?: 'PurchaseSubstitution', id: string, substitution: { __typename?: 'OfferingSelection', id: string, offering?: { __typename?: 'AddOnOffering', id: string, friendlyName: string, photoUrl: string } | { __typename?: 'OtcOffering', id: string, friendlyName: string, photoUrl: string } | { __typename?: 'RxOffering', id: string, friendlyName: string, photoUrl: string } | null | undefined, sequenceSelections?: Array<{ __typename?: 'SequenceSelection', id: string, sequence?: { __typename?: 'OtcSequence', id: string, products?: Array<{ __typename?: 'Product', id: string, deliveryInformation?: string | null | undefined }> | null | undefined } | { __typename?: 'PrescribableSequence', addressValidationExempt?: boolean | null | undefined, id: string, products?: Array<{ __typename?: 'Product', id: string, deliveryInformation?: string | null | undefined }> | null | undefined } | null | undefined, sequenceSet?: { __typename?: 'SequenceSet', id: string } | null | undefined }> | null | undefined } }> | null | undefined } | null | undefined } | null | undefined, initialPurchasePrice?: { __typename?: 'InitialPurchasePriceList', id: string, amount: number, originalAmount: number, discountAmount: number, sessionCreditAmount: number, coupons?: Array<{ __typename?: 'InitialPurchasePriceCoupon', id: string, code: string, outcome: CouponOutcome }> | null | undefined } | null | undefined, offeringsTimeline?: Array<{ __typename?: 'PredictedOfferingTimelineItem', id: string, date: string, totalAmount: number, products?: Array<{ __typename?: 'Product', id: string, friendlyName?: string | null | undefined, erxMedicines: Array<{ __typename?: 'ErxMedicine', id?: string | null | undefined, itemForm?: string | null | undefined, itemStrength?: string | null | undefined }> }> | null | undefined }> | null | undefined };

export type SubstituteConfirmInitiateZipCheckoutMutationVariables = Exact<{
  input: InitiateFlexiZipCheckoutInput;
}>;


export type SubstituteConfirmInitiateZipCheckoutMutation = { __typename?: 'Mutation', initiateFlexiZipCheckout?: { __typename?: 'ZipCheckoutResponse', redirectUrl: string } | null | undefined };

export type SubstitutePurchaseReviewQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
  offeringSelections: Array<OfferingSelectionInput> | OfferingSelectionInput;
  noPayload: Scalars['Boolean']['input'];
  pricingSessionId: Scalars['ID']['input'];
}>;


export type SubstitutePurchaseReviewQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, shortAddressableName?: string | null | undefined } | null | undefined, consultation?: { __typename?: 'Consultation', id: string, type: ProblemType, patientNotes?: string | null | undefined, doctor?: { __typename?: 'User', fullClinicianName: string, id: string, fullName?: string | null | undefined, shortClinicianName: string, lastName?: string | null | undefined, bio?: string | null | undefined, avatar?: { __typename?: 'File', id: string, url: string } | null | undefined, provider?: { __typename?: 'Provider', id: string, clinicianTitle: string, qualifications?: string | null | undefined } | null | undefined } | null | undefined, purchasePrompt?: { __typename?: 'ConfirmPurchasePrompt', id: string } | { __typename?: 'FurPurchasePrompt', id: string } | { __typename?: 'InitialPurchasePrompt', id: string } | { __typename?: 'RestartFlowPrompt', id: string } | { __typename?: 'SubstitutePurchasePrompt', pricingSessionId: string, id: string, substitutions?: Array<{ __typename?: 'PurchaseSubstitution', id: string, substitution: { __typename?: 'OfferingSelection', id: string, offering?: { __typename?: 'AddOnOffering', id: string, friendlyName: string, advertisedShippingCadence: string, photoUrl: string } | { __typename?: 'OtcOffering', id: string, friendlyName: string, advertisedShippingCadence: string, photoUrl: string } | { __typename?: 'RxOffering', id: string, friendlyName: string, advertisedShippingCadence: string, photoUrl: string } | null | undefined, sequenceSelections?: Array<{ __typename?: 'SequenceSelection', id: string, sequence?: { __typename?: 'OtcSequence', id: string, faqs: Array<{ __typename?: 'SequenceFaq', id: string, question: string, answerMarkdown: string, rank?: number | null | undefined }>, externalLinks: Array<{ __typename?: 'SequenceExternalLink', id: string, text: string, url: string }> } | { __typename?: 'PrescribableSequence', id: string, faqs: Array<{ __typename?: 'SequenceFaq', id: string, question: string, answerMarkdown: string, rank?: number | null | undefined }>, externalLinks: Array<{ __typename?: 'SequenceExternalLink', id: string, text: string, url: string }> } | null | undefined, sequenceSet?: { __typename?: 'SequenceSet', id: string } | null | undefined }> | null | undefined } }> | null | undefined } | null | undefined } | null | undefined, initialPurchasePrice?: { __typename?: 'InitialPurchasePriceList', id: string, amount: number } | null | undefined, offeringsTimeline?: Array<{ __typename?: 'PredictedOfferingTimelineItem', id: string, date: string, totalAmount: number, products?: Array<{ __typename?: 'Product', id: string, friendlyName?: string | null | undefined, erxMedicines: Array<{ __typename?: 'ErxMedicine', id?: string | null | undefined, itemForm?: string | null | undefined, itemStrength?: string | null | undefined }> }> | null | undefined }> | null | undefined };

export type MedicationPreferencePageQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
  skus?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type MedicationPreferencePageQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, type: ProblemType, quizApplicationId?: string | null | undefined, medicationPreferenceProduct?: { __typename?: 'MedicationPreferenceProducts', id: string, defaultProduct: { __typename?: 'Product', id: string, photo?: { __typename?: 'File', id: string, url: string } | null | undefined, variants: Array<{ __typename?: 'Variant', id: string, isRefill: boolean, price: number }> } } | null | undefined } | null | undefined, products: Array<{ __typename?: 'Product', id: string, friendlyName?: string | null | undefined, name: string, problemTypes: Array<ProblemType>, shortDescription?: string | null | undefined, photo?: { __typename?: 'File', id: string, url: string } | null | undefined, variants: Array<{ __typename?: 'Variant', id: string, price: number, isRefill: boolean, inventory?: { __typename?: 'VariantInventory', id: string, sku?: string | null | undefined } | null | undefined }> }> };

export type DeleteMedicationPreferenceMutationVariables = Exact<{
  input: DeleteMedicationPreferenceInput;
}>;


export type DeleteMedicationPreferenceMutation = { __typename?: 'Mutation', deleteMedicationPreference?: { __typename?: 'DeleteMedicationPreferencePayload', success?: boolean | null | undefined } | null | undefined };

export type UpdateMedicationPreferenceMutationVariables = Exact<{
  problemType: ProblemType;
  medicationSkuPrefix: Scalars['String']['input'];
  quizApplicationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateMedicationPreferenceMutation = { __typename?: 'Mutation', updateMedicationPreference?: { __typename?: 'UserNominatedMedicationPreference', medicationSkuPrefix: string } | null | undefined };

export type OfferingFaqQueryVariables = Exact<{ [key: string]: never; }>;


export type OfferingFaqQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, email: string, purchases?: Array<{ __typename?: 'Purchase', id: string, status: PurchaseStatus, contexts?: Array<{ __typename?: 'SequenceContext', id: string, sequence?: { __typename: 'OtcSequence', id: string, faqs: Array<{ __typename?: 'SequenceFaq', id: string, question: string, answerMarkdown: string }> } | { __typename: 'PrescribableSequence', id: string, faqs: Array<{ __typename?: 'SequenceFaq', id: string, question: string, answerMarkdown: string }> } | null | undefined }> | null | undefined }> | null | undefined } | null | undefined };

export type PausePurchaseMutationVariables = Exact<{
  input: PausePurchaseInput;
}>;


export type PausePurchaseMutation = { __typename?: 'Mutation', pausePurchase?: { __typename?: 'PausePurchasePayload', purchase: { __typename?: 'Purchase', id: string, status: PurchaseStatus } } | null | undefined };

export type OfferingDoctorLetterConsultationFragment = { __typename?: 'Consultation', id: string, patientNotes?: string | null | undefined, completedAt?: string | null | undefined, allowPatientToSendMessageToDoctor: boolean, doctor?: { __typename?: 'User', id: string, fullName?: string | null | undefined, fullClinicianName: string, shortClinicianName: string, lastName?: string | null | undefined, bio?: string | null | undefined, avatar?: { __typename?: 'File', id: string, url: string } | null | undefined, provider?: { __typename?: 'Provider', id: string, clinicianTitle: string, qualifications?: string | null | undefined } | null | undefined } | null | undefined };

export type OfferingSendMessageDoctorFragment = { __typename?: 'User', id: string, fullClinicianName: string, avatar?: { __typename?: 'File', id: string, url: string } | null | undefined };

export type OfferingNotesQueryVariables = Exact<{ [key: string]: never; }>;


export type OfferingNotesQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, purchases?: Array<{ __typename?: 'Purchase', id: string, contexts?: Array<{ __typename?: 'SequenceContext', id: string, consultations?: Array<{ __typename?: 'Consultation', id: string, patientNotes?: string | null | undefined, completedAt?: string | null | undefined, allowPatientToSendMessageToDoctor: boolean, doctor?: { __typename?: 'User', id: string, fullName?: string | null | undefined, fullClinicianName: string, shortClinicianName: string, lastName?: string | null | undefined, bio?: string | null | undefined, avatar?: { __typename?: 'File', id: string, url: string } | null | undefined, provider?: { __typename?: 'Provider', id: string, clinicianTitle: string, qualifications?: string | null | undefined } | null | undefined } | null | undefined }> | null | undefined, sequence?: { __typename?: 'OtcSequence', id: string } | { __typename?: 'PrescribableSequence', id: string, safetyInformation?: { __typename?: 'SequenceSafetyInformation', id: string, cmiCopyMarkdown: string, cmiUrl: string } | null | undefined } | null | undefined }> | null | undefined }> | null | undefined } | null | undefined };

export type DelayPurchaseSyncGroupMutationVariables = Exact<{
  input: DelayPurchaseSyncGroupInput;
}>;


export type DelayPurchaseSyncGroupMutation = { __typename?: 'Mutation', delayPurchaseSyncGroup?: { __typename?: 'DelayPurchaseSyncGroupPayload', purchaseSyncGroup: { __typename?: 'PurchaseSyncGroup', id: string, status: PurchaseSyncGroupStatus, sequenceContexts?: Array<{ __typename?: 'SequenceContext', id: string, status: SequenceContextStatus }> | null | undefined } } | null | undefined };

export type PsgTimelineFragment = { __typename?: 'PurchaseSyncGroup', id: string, sequenceContexts?: Array<{ __typename?: 'SequenceContext', id: string, sequence?: { __typename: 'OtcSequence', id: string } | { __typename: 'PrescribableSequence', id: string } | null | undefined }> | null | undefined, timeline?: Array<{ __typename?: 'SyncGroupTimelineItem', id: string, date: string, status: SyncGroupTimelineItemStatus, products?: Array<{ __typename?: 'SyncGroupTimelineItemProduct', id: string, displayName: string, type: ProductType }> | null | undefined, addonProducts?: Array<{ __typename?: 'SyncGroupTimelineItemProduct', id: string, displayName: string, type: ProductType }> | null | undefined, preDiscountTotalAmount: { __typename?: 'MonetaryAmount', id: string, baseUnitAmount: number }, totalAmount: { __typename?: 'MonetaryAmount', id: string, baseUnitAmount: number } }> | null | undefined };

export type OfferingPlanQueryVariables = Exact<{ [key: string]: never; }>;


export type OfferingPlanQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, email: string, purchases?: Array<{ __typename?: 'Purchase', id: string, status: PurchaseStatus, problemType?: ProblemType | null | undefined, canBeSwitched?: boolean | null | undefined, contexts?: Array<{ __typename?: 'SequenceContext', id: string, status: SequenceContextStatus, consultations?: Array<{ __typename?: 'Consultation', id: string, type: ProblemType, status: ConsultationStatus }> | null | undefined, sequence?: { __typename: 'OtcSequence', id: string, externalLinks: Array<{ __typename?: 'SequenceExternalLink', id: string, text: string, url: string }>, products?: Array<{ __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined, productType: ProductType, photo?: { __typename?: 'File', id: string, url: string } | null | undefined }> | null | undefined } | { __typename: 'PrescribableSequence', id: string, externalLinks: Array<{ __typename?: 'SequenceExternalLink', id: string, text: string, url: string }>, products?: Array<{ __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined, productType: ProductType, photo?: { __typename?: 'File', id: string, url: string } | null | undefined }> | null | undefined } | null | undefined }> | null | undefined, offering?: { __typename?: 'AddOnOffering', id: string, status: OfferingStatus, friendlyName: string, description: string, advertisedName: string } | { __typename?: 'OtcOffering', id: string, status: OfferingStatus, friendlyName: string, description: string, advertisedName: string } | { __typename?: 'RxOffering', id: string, status: OfferingStatus, friendlyName: string, description: string, advertisedName: string } | null | undefined, syncGroups?: Array<{ __typename?: 'PurchaseSyncGroup', id: string, nextOrderDue?: string | null | undefined, status: PurchaseSyncGroupStatus, nextOrder?: { __typename?: 'PurchaseSyncGroupOrder', id: string, date: string, totalAmount: { __typename?: 'MonetaryAmount', id: string, formattedAmount: string }, discountAmount: { __typename?: 'MonetaryAmount', id: string, baseUnitAmount: number, formattedAmount: string }, preDiscountTotalAmount: { __typename?: 'MonetaryAmount', id: string, formattedAmount: string }, products?: Array<{ __typename?: 'PurchaseSyncGroupOrderProduct', id: string, displayName: string, photoUrl?: string | null | undefined }> | null | undefined, discounts: Array<{ __typename?: 'Discount', id: string, name: string, removable: boolean, amount: { __typename?: 'MonetaryAmount', id: string, formattedAmount: string } }> } | null | undefined, actions?: Array<{ __typename?: 'DelayPurchaseSyncGroupAction', delayableUntil: string, id: string }> | null | undefined, sequenceContexts?: Array<{ __typename?: 'SequenceContext', id: string, sequence?: { __typename: 'OtcSequence', id: string } | { __typename: 'PrescribableSequence', id: string } | null | undefined }> | null | undefined, timeline?: Array<{ __typename?: 'SyncGroupTimelineItem', id: string, date: string, status: SyncGroupTimelineItemStatus, products?: Array<{ __typename?: 'SyncGroupTimelineItemProduct', id: string, displayName: string, type: ProductType }> | null | undefined, addonProducts?: Array<{ __typename?: 'SyncGroupTimelineItemProduct', id: string, displayName: string, type: ProductType }> | null | undefined, preDiscountTotalAmount: { __typename?: 'MonetaryAmount', id: string, baseUnitAmount: number }, totalAmount: { __typename?: 'MonetaryAmount', id: string, baseUnitAmount: number } }> | null | undefined }> | null | undefined, orderTimeline?: Array<{ __typename?: 'OrderTimelineItem', id: string, status: OrderTimelineItemStatus }> | null | undefined, nextOrder?: { __typename?: 'OrderTimelineItem', id: string, date: string, products?: Array<{ __typename?: 'Product', id: string, friendlyName?: string | null | undefined, name: string }> | null | undefined } | null | undefined }> | null | undefined } | null | undefined };

export type AddCouponCodesToPurchaseSyncGroupMutationVariables = Exact<{
  input: AddCouponCodesToPurchaseSyncGroupInput;
}>;


export type AddCouponCodesToPurchaseSyncGroupMutation = { __typename?: 'Mutation', addCouponCodesToPurchaseSyncGroup?: { __typename?: 'AddCouponCodesToPurchaseSyncGroupPayload', purchaseSyncGroupCoupons: Array<{ __typename?: 'PurchaseSyncGroupCoupon', id: string, code: string, outcome: CouponOutcome }> } | null | undefined };

export type SwitchOfferingsReceiptPageQueryVariables = Exact<{
  purchaseId: Scalars['ID']['input'];
}>;


export type SwitchOfferingsReceiptPageQuery = { __typename?: 'Query', purchase?: { __typename?: 'Purchase', id: string, offering?: { __typename?: 'AddOnOffering', id: string, advertisedName: string } | { __typename?: 'OtcOffering', id: string, advertisedName: string } | { __typename?: 'RxOffering', id: string, advertisedName: string } | null | undefined, supersededBy?: { __typename?: 'Purchase', id: string, offering?: { __typename?: 'AddOnOffering', id: string, advertisedName: string } | { __typename?: 'OtcOffering', id: string, advertisedName: string } | { __typename?: 'RxOffering', id: string, advertisedName: string } | null | undefined, nextOrder?: { __typename?: 'OrderTimelineItem', id: string, totalAmount: number, date: string } | null | undefined } | null | undefined } | null | undefined };

export type SwitchOfferingsPageQueryVariables = Exact<{
  purchaseId: Scalars['ID']['input'];
}>;


export type SwitchOfferingsPageQuery = { __typename?: 'Query', purchase?: { __typename?: 'Purchase', id: string, canBeSwitched?: boolean | null | undefined, contexts?: Array<{ __typename?: 'SequenceContext', id: string, sequence?: { __typename?: 'OtcSequence', id: string } | { __typename?: 'PrescribableSequence', id: string } | null | undefined }> | null | undefined, switchCandidates?: Array<{ __typename?: 'SwitchCandidate', id: string, advertisedCadencePricingDelta?: string | null | undefined, offering?: { __typename?: 'AddOnOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, defaultSequence?: { __typename?: 'OtcSequence', id: string } | { __typename?: 'PrescribableSequence', id: string } | null | undefined, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }> } | { __typename?: 'OtcOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, defaultSequence?: { __typename?: 'OtcSequence', id: string } | { __typename?: 'PrescribableSequence', id: string } | null | undefined, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }> } | { __typename?: 'RxOffering', id: string, photoUrl: string, advertisedName: string, advertisedStartingAmount: string, description: string, firstOrderGiftCopy?: string | null | undefined, tags: Array<string>, sequenceSets?: Array<{ __typename?: 'SequenceSet', id: string, defaultSequence?: { __typename?: 'OtcSequence', id: string } | { __typename?: 'PrescribableSequence', id: string } | null | undefined, sequences?: Array<{ __typename?: 'OtcSequence', id: string, tags: Array<string> } | { __typename?: 'PrescribableSequence', id: string, tags: Array<string> }> | null | undefined }> | null | undefined, contents: Array<{ __typename?: 'OfferingContentItem', id: string, description: string, tooltip?: string | null | undefined, rank: number }> } | null | undefined }> | null | undefined, offering?: { __typename?: 'AddOnOffering', id: string, upsells?: Array<{ __typename?: 'SwitchCandidate', id: string, offering?: { __typename?: 'AddOnOffering', id: string } | { __typename?: 'OtcOffering', id: string } | { __typename?: 'RxOffering', id: string } | null | undefined }> | null | undefined, downsells?: Array<{ __typename?: 'SwitchCandidate', id: string, offering?: { __typename?: 'AddOnOffering', id: string } | { __typename?: 'OtcOffering', id: string } | { __typename?: 'RxOffering', id: string } | null | undefined }> | null | undefined } | { __typename?: 'OtcOffering', id: string, upsells?: Array<{ __typename?: 'SwitchCandidate', id: string, offering?: { __typename?: 'AddOnOffering', id: string } | { __typename?: 'OtcOffering', id: string } | { __typename?: 'RxOffering', id: string } | null | undefined }> | null | undefined, downsells?: Array<{ __typename?: 'SwitchCandidate', id: string, offering?: { __typename?: 'AddOnOffering', id: string } | { __typename?: 'OtcOffering', id: string } | { __typename?: 'RxOffering', id: string } | null | undefined }> | null | undefined } | { __typename?: 'RxOffering', id: string, upsells?: Array<{ __typename?: 'SwitchCandidate', id: string, offering?: { __typename?: 'AddOnOffering', id: string } | { __typename?: 'OtcOffering', id: string } | { __typename?: 'RxOffering', id: string } | null | undefined }> | null | undefined, downsells?: Array<{ __typename?: 'SwitchCandidate', id: string, offering?: { __typename?: 'AddOnOffering', id: string } | { __typename?: 'OtcOffering', id: string } | { __typename?: 'RxOffering', id: string } | null | undefined }> | null | undefined } | null | undefined } | null | undefined };

export type SwitchPurchasedOfferingMutationVariables = Exact<{
  input: SwitchPurchasedOfferingInput;
}>;


export type SwitchPurchasedOfferingMutation = { __typename?: 'Mutation', switchPurchasedOffering?: { __typename?: 'SwitchPurchasedOfferingPayload', oldPurchase: { __typename?: 'Purchase', id: string, canBeSwitched?: boolean | null | undefined } } | null | undefined };

export type ProfilePractitionerPageQueryVariables = Exact<{
  treatmentId: Scalars['String']['input'];
}>;


export type ProfilePractitionerPageQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, weightTreatmentCategory?: WeightTreatmentCategory | null | undefined } | null | undefined, treatment?: { __typename?: 'Treatment', id: string, updatedAt: string, weightTreatmentCategory?: WeightTreatmentCategory | null | undefined, product: { __typename?: 'Product', id: string, faqs: Array<{ __typename?: 'Faq', id: string, markdown?: string | null | undefined, title?: string | null | undefined }>, variants: Array<{ __typename?: 'Variant', id: string, inventory?: { __typename?: 'VariantInventory', id: string, sku?: string | null | undefined } | null | undefined }> }, consultation?: { __typename?: 'Consultation', id: string, status: ConsultationStatus, type: ProblemType, completedAt?: string | null | undefined, patientNotes?: string | null | undefined, prescribedSequence?: { __typename?: 'PrescribedSequence', id: string, createdAt: string, sequence?: { __typename?: 'OtcSequence', id: string, faqs: Array<{ __typename?: 'SequenceFaq', id: string, question: string, videoUrl: string, answerMarkdown: string, rank?: number | null | undefined }>, products?: Array<{ __typename?: 'Product', id: string, variants: Array<{ __typename?: 'Variant', id: string, inventory?: { __typename?: 'VariantInventory', id: string, sku?: string | null | undefined } | null | undefined }> }> | null | undefined } | { __typename?: 'PrescribableSequence', id: string, faqs: Array<{ __typename?: 'SequenceFaq', id: string, question: string, videoUrl: string, answerMarkdown: string, rank?: number | null | undefined }>, products?: Array<{ __typename?: 'Product', id: string, variants: Array<{ __typename?: 'Variant', id: string, inventory?: { __typename?: 'VariantInventory', id: string, sku?: string | null | undefined } | null | undefined }> }> | null | undefined } | null | undefined } | null | undefined, doctor?: { __typename?: 'User', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, shortClinicianName: string, fullName?: string | null | undefined, fullClinicianName: string, bio?: string | null | undefined, avatar?: { __typename?: 'File', id: string, url: string } | null | undefined, provider?: { __typename?: 'Provider', id: string, clinicianTitle: string, qualifications?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined } | null | undefined, customerAttributes: { __typename?: 'CustomerAttributes', id: string, weight?: number | null | undefined } };

export type PhoneCallPageTemplateQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type PhoneCallPageTemplateQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, stage: ConsultationStage, status: ConsultationStatus, canSchedulePractitionerBooking: boolean, customer: { __typename?: 'User', id: string, phone?: string | null | undefined }, latestPractitionerBooking?: { __typename?: 'PractitionerBooking', id: string } | null | undefined, doctor?: { __typename?: 'User', id: string, shortClinicianName: string } | null | undefined, nextAvailableCallWindowRange?: { __typename?: 'PractitionerBookingWindowRange', id: string, startWindow: { __typename?: 'PractitionerBookingWindow', id: string, startAt: string, endAt: string }, endWindow: { __typename?: 'PractitionerBookingWindow', id: string, startAt: string, endAt: string } } | null | undefined } | null | undefined, validPhoneRegions?: Array<{ __typename?: 'ValidPhoneRegion', id: string, countryCode: string }> | null | undefined };

export type UpsertPractitionerBookingMutationVariables = Exact<{
  input: UpsertPractitionerBookingInput;
}>;


export type UpsertPractitionerBookingMutation = { __typename?: 'Mutation', upsertPractitionerBooking?: { __typename?: 'UpsertPractitionerBookingPayload', consultation: { __typename?: 'Consultation', id: string, chatThread?: { __typename?: 'ChatThread', id: string } | null | undefined, latestPractitionerBooking?: { __typename?: 'PractitionerBooking', id: string, windowStartAt: string, windowEndAt: string } | null | undefined } } | null | undefined };

export type CheckSuggestedTimeQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type CheckSuggestedTimeQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, practitionerBookingWindows?: Array<{ __typename?: 'PractitionerBookingWindow', id: string, available: boolean }> | null | undefined } | null | undefined };

export type WeightResetQuizApplicationQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type WeightResetQuizApplicationQuery = { __typename?: 'Query', getQuizApplication?: { __typename?: 'QuizApplication', id: string, problemType: ProblemType, submittedAt?: string | null | undefined } | null | undefined };

export type PasswordResetMutationVariables = Exact<{
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  resetToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type PasswordResetMutation = { __typename?: 'Mutation', passwordReset?: { __typename?: 'TriggerPasswordResetPayload', ok?: boolean | null | undefined } | null | undefined };

export type ScheduleCallUserFragment = { __typename?: 'User', id: string, phone?: string | null | undefined };

export type ScheduleCallPractitionerBookingWindowFragment = { __typename?: 'PractitionerBookingWindow', id: string, startAt: string, endAt: string, available: boolean };

export type ScheduleCallPageTemplateQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type ScheduleCallPageTemplateQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, status: ConsultationStatus, canSchedulePractitionerBooking: boolean, customer: { __typename?: 'User', id: string, phone?: string | null | undefined }, latestPractitionerBooking?: { __typename?: 'PractitionerBooking', id: string } | null | undefined, doctor?: { __typename?: 'User', id: string, shortClinicianName: string } | null | undefined, practitionerBookingWindows?: Array<{ __typename?: 'PractitionerBookingWindow', id: string, startAt: string, endAt: string, available: boolean }> | null | undefined, nextAvailableCallWindowRange?: { __typename?: 'PractitionerBookingWindowRange', id: string, startWindow: { __typename?: 'PractitionerBookingWindow', id: string }, endWindow: { __typename?: 'PractitionerBookingWindow', id: string } } | null | undefined } | null | undefined, validPhoneRegions?: Array<{ __typename?: 'ValidPhoneRegion', id: string, countryCode: string }> | null | undefined };

export type CheckSelectedTimeQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type CheckSelectedTimeQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, practitionerBookingWindows?: Array<{ __typename?: 'PractitionerBookingWindow', id: string, available: boolean }> | null | undefined } | null | undefined };

export type ScheduleCallPhoneNumberModalFragment = { __typename?: 'Query', validPhoneRegions?: Array<{ __typename?: 'ValidPhoneRegion', id: string, countryCode: string }> | null | undefined };

export type ScheduleCallUpdatePhoneNumberMutationVariables = Exact<{
  phone?: InputMaybe<Scalars['String']['input']>;
}>;


export type ScheduleCallUpdatePhoneNumberMutation = { __typename?: 'Mutation', updateProfile?: { __typename?: 'User', id: string, phone?: string | null | undefined } | null | undefined };

export type V2SubscriptionPlanPaymentProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type V2SubscriptionPlanPaymentProfileQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, fullName?: string | null | undefined, email: string, phone?: string | null | undefined, address?: { __typename?: 'Address', id: string, line1?: string | null | undefined, line2?: string | null | undefined, city?: string | null | undefined, postalCode?: string | null | undefined, state?: string | null | undefined, country?: string | null | undefined } | null | undefined, savedPaymentMethods?: Array<{ __typename?: 'SavedCardPaymentMethod', brand: string, mask: string, expiry: string, createdAt?: string | null | undefined, default: boolean, gateway: PaymentGateway, id: string } | { __typename?: 'SavedPayPalPaymentMethod', email?: string | null | undefined, createdAt?: string | null | undefined, default: boolean, gateway: PaymentGateway, id: string } | { __typename?: 'SavedSofortPaymentMethod', createdAt?: string | null | undefined, default: boolean, gateway: PaymentGateway, id: string } | { __typename?: 'SavedZipPaymentMethod', valid: boolean, createdAt?: string | null | undefined, default: boolean, gateway: PaymentGateway, id: string } | null | undefined> | null | undefined } | null | undefined };

export type ProfileTreatmentPharmacyInformationPageQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ProfileTreatmentPharmacyInformationPageQuery = { __typename?: 'Query', treatment?: { __typename?: 'Treatment', id: string, status: TreatmentStatus, product: { __typename?: 'Product', id: string, safetyInformation?: string | null | undefined, cmi?: { __typename?: 'File', id: string, url: string } | null | undefined, variants: Array<{ __typename?: 'Variant', id: string, inventory?: { __typename?: 'VariantInventory', id: string, sku?: string | null | undefined } | null | undefined }> }, consultation?: { __typename?: 'Consultation', id: string, customer: { __typename?: 'User', id: string, firstName?: string | null | undefined, healthCareDetails?: { __typename?: 'HealthCareDetails', id: string, hasIndividualHealthcareIdentifier?: boolean | null | undefined } | null | undefined }, prescribedSequence?: { __typename?: 'PrescribedSequence', id: string, sequence?: { __typename?: 'OtcSequence', id: string } | { __typename?: 'PrescribableSequence', id: string, safetyInformation?: { __typename?: 'SequenceSafetyInformation', id: string, cmiUrl: string, cmiCopyMarkdown: string } | null | undefined } | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type UseMedicalProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type UseMedicalProfileQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, birthday?: string | null | undefined, phone?: string | null | undefined, preferredUnitSystem?: UnitSystem | null | undefined, isPasswordSet: boolean, medicalProfile: { __typename?: 'MedicalProfile', id: string, dob?: string | null | undefined, weight?: number | null | undefined, currentMedications?: string | null | undefined, allergies?: string | null | undefined, existingConditions?: string | null | undefined } } | null | undefined };

export type CpPaidEventFieldsQueryVariables = Exact<{ [key: string]: never; }>;


export type CpPaidEventFieldsQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, isPasswordSet: boolean, email: string, phone?: string | null | undefined } | null | undefined };

export type EmailPhonePasswordStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type EmailPhonePasswordStatusQuery = { __typename?: 'Query', validPhoneRegions?: Array<{ __typename?: 'ValidPhoneRegion', id: string, countryCode: string }> | null | undefined, profile?: { __typename?: 'User', id: string, email: string, phone?: string | null | undefined, isPasswordSet: boolean } | null | undefined };

export type CreateAccountCpJuniperMutationVariables = Exact<{
  phone?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateAccountCpJuniperMutation = { __typename?: 'Mutation', updateProfile?: { __typename?: 'User', id: string, phone?: string | null | undefined, isPasswordSet: boolean } | null | undefined };

export type ConfirmConsultationJuniperMutationVariables = Exact<{
  id: Scalars['String']['input'];
  couponCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type ConfirmConsultationJuniperMutation = { __typename?: 'Mutation', payConsultation?: { __typename?: 'Consultation', id: string } | null | undefined };

export type BillingDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type BillingDetailsQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, defaultPaymentGateway?: PaymentGateway | null | undefined, savedPaymentMethods?: Array<{ __typename?: 'SavedCardPaymentMethod', expiry: string, mask: string, brand: string, id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | { __typename?: 'SavedPayPalPaymentMethod', email?: string | null | undefined, id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | { __typename?: 'SavedSofortPaymentMethod', id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | { __typename?: 'SavedZipPaymentMethod', valid: boolean, id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | null | undefined> | null | undefined, zip?: { __typename?: 'Zip', valid: boolean } | null | undefined } | null | undefined };

export type CommsAndPrivacyUserDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type CommsAndPrivacyUserDetailsQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, notificationPrefs?: { __typename?: 'NotificationPrefs', id: string, personalisedMarketing?: boolean | null | undefined } | null | undefined } | null | undefined };

export type UpdateNotificationPrefsMutationVariables = Exact<{
  personalisedMarketing: Scalars['Boolean']['input'];
}>;


export type UpdateNotificationPrefsMutation = { __typename?: 'Mutation', updateNotificationPrefs?: { __typename?: 'UpdateNotificationPrefsPayload', user?: { __typename?: 'User', id: string, notificationPrefs?: { __typename?: 'NotificationPrefs', id: string, personalisedMarketing?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type ProfileWithDvaQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfileWithDvaQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, dvaFileNumber?: string | null | undefined } | null | undefined };

export type UpsertDvaFileNumberMutationVariables = Exact<{
  input: UpsertDvaFileNumberInput;
}>;


export type UpsertDvaFileNumberMutation = { __typename?: 'Mutation', upsertDvaFileNumber?: { __typename?: 'UpsertDvaFileNumberPayload', user?: { __typename?: 'User', id: string, dvaFileNumber?: string | null | undefined } | null | undefined } | null | undefined };

export type MedicareDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type MedicareDetailsQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, healthCareDetails?: { __typename?: 'HealthCareDetails', id: string, hasMedicareDetails?: boolean | null | undefined } | null | undefined } | null | undefined };

export type UpdateProfileUserDetailsMutationVariables = Exact<{
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
}>;


export type UpdateProfileUserDetailsMutation = { __typename?: 'Mutation', updateProfile?: { __typename?: 'User', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, email: string, shortAddressableName?: string | null | undefined, fullName?: string | null | undefined, phone?: string | null | undefined } | null | undefined };

export type PersonalDetailsFragment = { __typename?: 'User', id: string, email: string, fullName?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, phone?: string | null | undefined, residentialAddress?: { __typename?: 'ResidentialAddress', id: string, line1: string, line2?: string | null | undefined, city: string, postalCode: string, prefecture?: string | null | undefined, municipality?: string | null | undefined, townArea?: string | null | undefined, state?: string | null | undefined, building?: string | null | undefined, company?: string | null | undefined, country: string } | null | undefined };

export type AwaitingDoctorCardPractitionerBookingFragment = { __typename?: 'PractitionerBooking', id: string, windowStartAt: string, windowEndAt: string };

export type AwaitingResultsCardPathologyRequestFragment = { __typename?: 'PathologyRequest', id: string, customerStatedCollectedAt?: string | null | undefined };

export type AwaitingSurveyCardScreeningQuizApplicationFragment = { __typename?: 'QuizApplication', id: string, submittedAt?: string | null | undefined };

export type ReminderCardReminderFragment = { __typename?: 'ConsultationReminder', id: string, scheduledAt: string, doneAt?: string | null | undefined };

export type RestartFlowMutationVariables = Exact<{
  input: RestartFlowInput;
}>;


export type RestartFlowMutation = { __typename?: 'Mutation', restartFlow?: { __typename?: 'RestartFlowPayload', consultation: { __typename?: 'Consultation', id: string } } | null | undefined };

export type ReviewAwaitingSurveyCardTreatmentFragment = { __typename?: 'Treatment', id: string, type: ProblemType, active: boolean, refillsLeft?: number | null | undefined, nextPayment?: string | null | undefined, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined }, otcSchedules: Array<{ __typename?: 'OtcSchedule', id: string, cadence: OtcScheduleCadence, quantity: number, isActive: boolean, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined } }> };

export type TreatmentActiveCardTreatmentFragment = { __typename?: 'Treatment', id: string, active: boolean, refillsLeft?: number | null | undefined, nextPayment?: string | null | undefined, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined }, otcSchedules: Array<{ __typename?: 'OtcSchedule', id: string, cadence: OtcScheduleCadence, quantity: number, isActive: boolean, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined } }> };

export type TreatmentFollowUpCardTreatmentFragment = { __typename?: 'Treatment', id: string, active: boolean, nextPayment?: string | null | undefined, refillsLeft?: number | null | undefined, otcSchedules: Array<{ __typename?: 'OtcSchedule', id: string, cadence: OtcScheduleCadence, quantity: number, isActive: boolean, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined } }>, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined } };

export type TreatmentPausedCardTreatmentFragment = { __typename?: 'Treatment', id: string, canRefill: boolean, nextPaymentAmount?: number | null | undefined, refillsLeft?: number | null | undefined, nextPayment?: string | null | undefined, plan?: { __typename?: 'Plan', id: string, amount: number } | null | undefined, otcSchedules: Array<{ __typename?: 'OtcSchedule', id: string, isActive: boolean, quantity: number, cadence: OtcScheduleCadence, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined, variants: Array<{ __typename?: 'Variant', id: string, price: number }> } }>, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined } };

export type TreatmentProcessingOrderCardTreatmentFragment = { __typename?: 'Treatment', id: string, active: boolean, refillsLeft?: number | null | undefined, nextPayment?: string | null | undefined, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined }, otcSchedules: Array<{ __typename?: 'OtcSchedule', id: string, cadence: OtcScheduleCadence, quantity: number, isActive: boolean, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined } }> };

export type ConsultationCardContentConsultationFragment = { __typename?: 'Consultation', id: string, status: ConsultationStatus, type: ProblemType, stage: ConsultationStage, isApproved?: boolean | null | undefined, typeIsFlexi?: boolean | null | undefined, requiresPrescriberCall: boolean, isInNoPickUpQueue?: boolean | null | undefined, allowPatientToSendMessageToDoctor: boolean, practitionerMessagedAt?: string | null | undefined, pathologyRequests?: Array<{ __typename?: 'PathologyRequest', id: string, customerStatedCollectedAt?: string | null | undefined, result?: { __typename?: 'PathologyResult', id: string } | null | undefined } | null | undefined> | null | undefined, chatThread?: { __typename?: 'ChatThread', id: string } | null | undefined, doctor?: { __typename?: 'User', id: string, fullName?: string | null | undefined, fullClinicianName: string } | null | undefined, treatment?: { __typename?: 'Treatment', id: string, status: TreatmentStatus, active: boolean, pendingFollowUpReminderDate?: string | null | undefined, isLastOrderUnfulfilled: boolean, nextPayment?: string | null | undefined, canRefill: boolean, nextPaymentAmount?: number | null | undefined, type: ProblemType, refillsLeft?: number | null | undefined, otcSchedules: Array<{ __typename?: 'OtcSchedule', id: string, cadence: OtcScheduleCadence, quantity: number, isActive: boolean, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined, variants: Array<{ __typename?: 'Variant', id: string, price: number }> } }>, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined }, plan?: { __typename?: 'Plan', id: string, amount: number } | null | undefined } | null | undefined, prescribedSequence?: { __typename?: 'PrescribedSequence', id: string } | null | undefined, quizApplication?: { __typename?: 'QuizApplication', id: string, submittedAt?: string | null | undefined } | null | undefined, screeningQuizApplication?: { __typename?: 'QuizApplication', id: string, submittedAt?: string | null | undefined } | null | undefined, latestPractitionerBooking?: { __typename?: 'PractitionerBooking', id: string, windowStartAt: string, windowEndAt: string } | null | undefined, reminders?: Array<{ __typename?: 'ConsultationReminder', id: string, canceled: boolean, doneAt?: string | null | undefined, scheduledAt: string }> | null | undefined, patientQuestions?: Array<{ __typename?: 'ConsultationPatientQuestion', id: string, createdAt: string }> | null | undefined, purchasePrompt?: { __typename?: 'ConfirmPurchasePrompt', id: string } | { __typename?: 'FurPurchasePrompt', id: string } | { __typename?: 'InitialPurchasePrompt', id: string } | { __typename?: 'RestartFlowPrompt', id: string } | { __typename?: 'SubstitutePurchasePrompt', id: string } | null | undefined };

export type UseConsultationCardContentConsultationFragment = { __typename?: 'Consultation', id: string, type: ProblemType, stage: ConsultationStage, status: ConsultationStatus, isApproved?: boolean | null | undefined, typeIsFlexi?: boolean | null | undefined, requiresPrescriberCall: boolean, isInNoPickUpQueue?: boolean | null | undefined, allowPatientToSendMessageToDoctor: boolean, practitionerMessagedAt?: string | null | undefined, chatThread?: { __typename?: 'ChatThread', id: string } | null | undefined, doctor?: { __typename?: 'User', id: string, fullName?: string | null | undefined, fullClinicianName: string } | null | undefined, treatment?: { __typename?: 'Treatment', id: string, status: TreatmentStatus, active: boolean, pendingFollowUpReminderDate?: string | null | undefined, isLastOrderUnfulfilled: boolean, nextPayment?: string | null | undefined, canRefill: boolean, nextPaymentAmount?: number | null | undefined, type: ProblemType, refillsLeft?: number | null | undefined, otcSchedules: Array<{ __typename?: 'OtcSchedule', id: string, cadence: OtcScheduleCadence, quantity: number, isActive: boolean, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined, variants: Array<{ __typename?: 'Variant', id: string, price: number }> } }>, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined }, plan?: { __typename?: 'Plan', id: string, amount: number } | null | undefined } | null | undefined, prescribedSequence?: { __typename?: 'PrescribedSequence', id: string } | null | undefined, quizApplication?: { __typename?: 'QuizApplication', id: string, submittedAt?: string | null | undefined } | null | undefined, screeningQuizApplication?: { __typename?: 'QuizApplication', id: string, submittedAt?: string | null | undefined } | null | undefined, latestPractitionerBooking?: { __typename?: 'PractitionerBooking', id: string, windowStartAt: string, windowEndAt: string } | null | undefined, pathologyRequests?: Array<{ __typename?: 'PathologyRequest', id: string, customerStatedCollectedAt?: string | null | undefined } | null | undefined> | null | undefined, reminders?: Array<{ __typename?: 'ConsultationReminder', id: string, canceled: boolean, doneAt?: string | null | undefined, scheduledAt: string }> | null | undefined, patientQuestions?: Array<{ __typename?: 'ConsultationPatientQuestion', id: string, createdAt: string }> | null | undefined, purchasePrompt?: { __typename?: 'ConfirmPurchasePrompt', id: string } | { __typename?: 'FurPurchasePrompt', id: string } | { __typename?: 'InitialPurchasePrompt', id: string } | { __typename?: 'RestartFlowPrompt', id: string } | { __typename?: 'SubstitutePurchasePrompt', id: string } | null | undefined };

export type PurchaseActiveCardPurchaseFragment = { __typename?: 'Purchase', id: string, offering?: { __typename?: 'AddOnOffering', id: string, problemTypes?: Array<ProblemType> | null | undefined } | { __typename?: 'OtcOffering', id: string, problemTypes?: Array<ProblemType> | null | undefined } | { __typename?: 'RxOffering', id: string, problemTypes?: Array<ProblemType> | null | undefined } | null | undefined };

export type PurchaseCardConsultationFragment = { __typename?: 'Consultation', id: string, type: ProblemType, stage: ConsultationStage, status: ConsultationStatus, requiresPrescriberCall: boolean, allowPatientToSendMessageToDoctor: boolean, practitionerMessagedAt?: string | null | undefined, doctor?: { __typename?: 'User', id: string, fullName?: string | null | undefined, fullClinicianName: string } | null | undefined, quizApplication?: { __typename?: 'QuizApplication', id: string, submittedAt?: string | null | undefined } | null | undefined, chatThread?: { __typename?: 'ChatThread', id: string } | null | undefined, pathologyRequests?: Array<{ __typename?: 'PathologyRequest', id: string, customerStatedCollectedAt?: string | null | undefined } | null | undefined> | null | undefined };

export type PurchaseCardPurchaseFragment = { __typename?: 'Purchase', id: string, status: PurchaseStatus, problemType?: ProblemType | null | undefined, orderTimeline?: Array<{ __typename?: 'OrderTimelineItem', id: string, status: OrderTimelineItemStatus }> | null | undefined, offering?: { __typename?: 'AddOnOffering', id: string, friendlyName: string, problemTypes?: Array<ProblemType> | null | undefined } | { __typename?: 'OtcOffering', id: string, friendlyName: string, problemTypes?: Array<ProblemType> | null | undefined } | { __typename?: 'RxOffering', id: string, friendlyName: string, problemTypes?: Array<ProblemType> | null | undefined } | null | undefined, nextOrder?: { __typename?: 'OrderTimelineItem', id: string, date: string, totalAmount: number, products?: Array<{ __typename?: 'Product', id: string, friendlyName?: string | null | undefined, name: string }> | null | undefined } | null | undefined, contexts?: Array<{ __typename?: 'SequenceContext', id: string, status: SequenceContextStatus, sequence?: { __typename?: 'OtcSequence', id: string, products?: Array<{ __typename?: 'Product', id: string, productType: ProductType }> | null | undefined } | { __typename?: 'PrescribableSequence', id: string, products?: Array<{ __typename?: 'Product', id: string, productType: ProductType }> | null | undefined } | null | undefined }> | null | undefined, availableActions?: Array<{ __typename?: 'PurchaseResumeAction', id: string }> | null | undefined };

export type PurchaseCompletedCardPurchaseFragment = { __typename?: 'Purchase', id: string, offering?: { __typename?: 'AddOnOffering', id: string, problemTypes?: Array<ProblemType> | null | undefined } | { __typename?: 'OtcOffering', id: string, problemTypes?: Array<ProblemType> | null | undefined } | { __typename?: 'RxOffering', id: string, problemTypes?: Array<ProblemType> | null | undefined } | null | undefined };

export type ResumePurchaseMutationVariables = Exact<{
  input: ResumePurchaseInput;
}>;


export type ResumePurchaseMutation = { __typename?: 'Mutation', resumePurchase?: { __typename?: 'ResumePurchasePayload', purchase: { __typename?: 'Purchase', id: string, status: PurchaseStatus, isVisibleInProfilePage?: boolean | null | undefined, availableActions?: Array<{ __typename?: 'PurchaseResumeAction', id: string }> | null | undefined } } | null | undefined };

export type PurchasePausedCardPurchaseFragment = { __typename?: 'Purchase', id: string, problemType?: ProblemType | null | undefined, offering?: { __typename?: 'AddOnOffering', id: string } | { __typename?: 'OtcOffering', id: string } | { __typename?: 'RxOffering', id: string } | null | undefined, availableActions?: Array<{ __typename?: 'PurchaseResumeAction', id: string }> | null | undefined, nextOrder?: { __typename?: 'OrderTimelineItem', id: string, date: string, totalAmount: number } | null | undefined };

export type PurchaseProcessingCardPurchaseFragment = { __typename?: 'Purchase', id: string, offering?: { __typename?: 'AddOnOffering', id: string, problemTypes?: Array<ProblemType> | null | undefined } | { __typename?: 'OtcOffering', id: string, problemTypes?: Array<ProblemType> | null | undefined } | { __typename?: 'RxOffering', id: string, problemTypes?: Array<ProblemType> | null | undefined } | null | undefined };

export type QuizCompletedCardContentQuizApplicationFragment = { __typename?: 'QuizApplication', id: string, outcomes?: Array<{ __typename?: 'ArticleQuizOutcome', id: string } | { __typename?: 'BuyOtcQuizOutcome', id: string } | { __typename?: 'ConsultationQuizOutcome', id: string } | { __typename?: 'IncreaseUsageQuizOutcome', id: string } | { __typename?: 'NotEligibleQuizOutcome', id: string } | { __typename?: 'OtcQuizOutcome', id: string } | { __typename?: 'ReviewQuizOutcome', id: string } | { __typename?: 'SideEffectProactiveActionQuizOutcome', id: string } | { __typename?: 'ZendeskQuizOutcome', id: string }> | null | undefined };

export type TreatmentDetailsTreatmentFragment = { __typename?: 'Treatment', id: string, refillsLeft?: number | null | undefined, nextPayment?: string | null | undefined, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined }, otcSchedules: Array<{ __typename?: 'OtcSchedule', id: string, cadence: OtcScheduleCadence, quantity: number, isActive: boolean, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined } }> };

export type RefillTreatmentRestartTreatmentJuniperMutationVariables = Exact<{
  treatmentId: Scalars['String']['input'];
}>;


export type RefillTreatmentRestartTreatmentJuniperMutation = { __typename?: 'Mutation', refillTreatment?: { __typename?: 'Treatment', id: string, status: TreatmentStatus, refillsLeft?: number | null | undefined, nextPayment?: string | null | undefined } | null | undefined };

export type PilotShippingDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type PilotShippingDetailsQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, weightTreatmentCategory?: WeightTreatmentCategory | null | undefined, address?: { __typename?: 'Address', id: string, line1?: string | null | undefined, line2?: string | null | undefined, city?: string | null | undefined, state?: string | null | undefined, postalCode?: string | null | undefined, country?: string | null | undefined, building?: string | null | undefined, company?: string | null | undefined } | null | undefined } | null | undefined };

export type UpdateShippingProfileAccountMutationVariables = Exact<{
  address: AddressCreateWithoutUserInput;
}>;


export type UpdateShippingProfileAccountMutation = { __typename?: 'Mutation', updateShipping?: { __typename?: 'User', id: string, address?: { __typename?: 'Address', id: string, line1?: string | null | undefined, line2?: string | null | undefined, city?: string | null | undefined, postalCode?: string | null | undefined, prefecture?: string | null | undefined, municipality?: string | null | undefined, townArea?: string | null | undefined, state?: string | null | undefined, country?: string | null | undefined, building?: string | null | undefined, company?: string | null | undefined } | null | undefined } | null | undefined };

export type JuniperProfileShippingDetailsRangeQueryVariables = Exact<{
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  suburb: Scalars['String']['input'];
  postcode: Scalars['String']['input'];
}>;


export type JuniperProfileShippingDetailsRangeQuery = { __typename?: 'Query', shippingAddressWithinRange?: boolean | null | undefined };

export type RangeShippingDetailsAddressFragment = { __typename?: 'Address', id: string, line1?: string | null | undefined, line2?: string | null | undefined, city?: string | null | undefined, postalCode?: string | null | undefined, prefecture?: string | null | undefined, municipality?: string | null | undefined, townArea?: string | null | undefined, state?: string | null | undefined, building?: string | null | undefined, company?: string | null | undefined, country?: string | null | undefined };

export type PilotProfileShippingDetailsRangeQueryVariables = Exact<{
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  suburb: Scalars['String']['input'];
  postcode: Scalars['String']['input'];
}>;


export type PilotProfileShippingDetailsRangeQuery = { __typename?: 'Query', shippingAddressWithinRange?: boolean | null | undefined };

export type UserDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserDetailsQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, fullName?: string | null | undefined, phone?: string | null | undefined, email: string, residentialAddress?: { __typename?: 'ResidentialAddress', id: string, line1: string, line2?: string | null | undefined, city: string, postalCode: string, state?: string | null | undefined, country: string } | null | undefined } | null | undefined };

export type TreatedForWeightLossQueryVariables = Exact<{ [key: string]: never; }>;


export type TreatedForWeightLossQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, isBeingTreated?: boolean | null | undefined } | null | undefined };

export type QuizQuestionWeightLossGraphQueryVariables = Exact<{ [key: string]: never; }>;


export type QuizQuestionWeightLossGraphQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, firstName?: string | null | undefined, shortAddressableName?: string | null | undefined, preferredUnitSystem?: UnitSystem | null | undefined } | null | undefined };

export type DefaultUnitSystemQueryVariables = Exact<{ [key: string]: never; }>;


export type DefaultUnitSystemQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, preferredUnitSystem?: UnitSystem | null | undefined } | null | undefined };

export type QuizConsultationQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type QuizConsultationQuery = { __typename?: 'Query', customerAttributes: { __typename?: 'CustomerAttributes', id: string, conditions?: string | null | undefined, medications?: string | null | undefined, allergies?: string | null | undefined }, getQuizApplication?: { __typename?: 'QuizApplication', id: string, createdAt: string, customerId: string, purpose: QuizPurpose, problemType: ProblemType, submittedAt?: string | null | undefined, consultation?: { __typename?: 'Consultation', id: string, status: ConsultationStatus, stage: ConsultationStage, isUpfrontPayment: boolean, medium: ConsultationMedium, canSchedulePractitionerBooking: boolean, requiresPrescriberCall: boolean } | null | undefined, answers: Array<{ __typename?: 'QuizApplicationResponse', id: string, answer?: string | null | undefined, answersArray: Array<string>, englishAnswer?: string | null | undefined, englishAnswersArray: Array<string>, question?: { __typename?: 'QuizQuestion', id: string, shortcode?: string | null | undefined } | null | undefined }>, quiz: { __typename?: 'Quiz', id: string, default: boolean, quizCode: string, questionsOrder: Array<string>, questions: Array<{ __typename?: 'QuizQuestion', id: string, title?: string | null | undefined, type: QuizQuestionType, description?: string | null | undefined, required: boolean, optionImgLayout?: QuizQuestionOptionImageLayout | null | undefined, imgUrl?: string | null | undefined, shortcode?: string | null | undefined, options?: any | null | undefined, questionOptions: Array<{ __typename?: 'QuizQuestionOption', id: string, questionId: string, option?: string | null | undefined, position?: number | null | undefined, imgUrl?: string | null | undefined, popup?: { __typename?: 'QuizQuestionPopup', id: string, title?: string | null | undefined, content?: string | null | undefined, linkOutText?: string | null | undefined, imgUrl?: string | null | undefined } | null | undefined }>, popup?: { __typename?: 'QuizQuestionPopup', id: string, title?: string | null | undefined, content?: string | null | undefined, linkOutText?: string | null | undefined, imgUrl?: string | null | undefined } | null | undefined }>, logics: Array<{ __typename?: 'QuizLogic', id: string, from: { __typename?: 'QuizQuestion', id: string }, elseJump: { __typename?: 'QuizQuestion', id: string }, jumps: Array<{ __typename?: 'QuizJump', id: string, conditions: Array<{ __typename?: 'QuizConditions', id: string, value: string, operator: QuizJumpOperator, nextCondition?: QuizValidationCondition | null | undefined, question: { __typename?: 'QuizQuestion', id: string } }>, to: { __typename?: 'QuizQuestion', id: string } }> }>, skips: Array<{ __typename?: 'QuizSkip', id: string, from: { __typename?: 'QuizQuestion', id: string }, conditions: Array<{ __typename?: 'QuizConditions', id: string, value: string, operator: QuizJumpOperator, nextCondition?: QuizValidationCondition | null | undefined, question: { __typename?: 'QuizQuestion', id: string } }> }> }, responses?: Array<{ __typename?: 'QuizResponse', id: string, question?: { __typename?: 'QuizResponseQuestion', id?: string | null | undefined, type?: QuizQuestionType | null | undefined, title?: string | null | undefined, shortcode?: string | null | undefined, options?: Array<{ __typename?: 'QuizResponseQuestionOption', value: string }> | null | undefined } | null | undefined, response?: { __typename?: 'QuizResponseResponse', answers?: Array<{ __typename?: 'QuizResponseResponseAnswer', value: string, imageUrl?: string | null | undefined }> | null | undefined, flag?: { __typename?: 'QuizResponseResponseFlag', level: QuizFlagLevel } | null | undefined } | null | undefined }> | null | undefined, outcomes?: Array<{ __typename?: 'ArticleQuizOutcome', id: string } | { __typename?: 'BuyOtcQuizOutcome', id: string } | { __typename?: 'ConsultationQuizOutcome', id: string } | { __typename?: 'IncreaseUsageQuizOutcome', id: string } | { __typename?: 'NotEligibleQuizOutcome', id: string, reasons?: Array<QuizOutcomeReason> | null | undefined } | { __typename?: 'OtcQuizOutcome', id: string } | { __typename?: 'ReviewQuizOutcome', id: string } | { __typename?: 'SideEffectProactiveActionQuizOutcome', id: string } | { __typename?: 'ZendeskQuizOutcome', id: string }> | null | undefined } | null | undefined };

export type AnswerApplicationQuestionMutationVariables = Exact<{
  applicationId: Scalars['String']['input'];
  questionId: Scalars['String']['input'];
  answer?: InputMaybe<Scalars['String']['input']>;
  answersArray?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  answerId?: InputMaybe<Scalars['String']['input']>;
  optionIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type AnswerApplicationQuestionMutation = { __typename?: 'Mutation', answerApplicationQuestion?: { __typename?: 'QuizApplication', id: string, problemType: ProblemType, customerId: string, submittedAt?: string | null | undefined, answers: Array<{ __typename?: 'QuizApplicationResponse', id: string, answer?: string | null | undefined, answersArray: Array<string>, englishAnswer?: string | null | undefined, englishAnswersArray: Array<string>, question?: { __typename?: 'QuizQuestion', id: string, shortcode?: string | null | undefined } | null | undefined }>, consultation?: { __typename?: 'Consultation', id: string, status: ConsultationStatus, isUpfrontPayment: boolean } | null | undefined, responses?: Array<{ __typename?: 'QuizResponse', id: string, question?: { __typename?: 'QuizResponseQuestion', id?: string | null | undefined, type?: QuizQuestionType | null | undefined, title?: string | null | undefined, shortcode?: string | null | undefined, options?: Array<{ __typename?: 'QuizResponseQuestionOption', value: string }> | null | undefined } | null | undefined, response?: { __typename?: 'QuizResponseResponse', answers?: Array<{ __typename?: 'QuizResponseResponseAnswer', value: string, imageUrl?: string | null | undefined }> | null | undefined, flag?: { __typename?: 'QuizResponseResponseFlag', level: QuizFlagLevel } | null | undefined } | null | undefined }> | null | undefined } | null | undefined };

export type SubmitApplicationMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SubmitApplicationMutation = { __typename?: 'Mutation', submitApplication?: { __typename?: 'QuizApplication', id: string, problemType: ProblemType, customerId: string, submittedAt?: string | null | undefined, answers: Array<{ __typename?: 'QuizApplicationResponse', id: string, answer?: string | null | undefined, answersArray: Array<string>, englishAnswer?: string | null | undefined, englishAnswersArray: Array<string>, question?: { __typename?: 'QuizQuestion', id: string, shortcode?: string | null | undefined } | null | undefined }>, consultation?: { __typename?: 'Consultation', id: string, status: ConsultationStatus, isUpfrontPayment: boolean } | null | undefined, responses?: Array<{ __typename?: 'QuizResponse', id: string, question?: { __typename?: 'QuizResponseQuestion', id?: string | null | undefined, type?: QuizQuestionType | null | undefined, title?: string | null | undefined, shortcode?: string | null | undefined, options?: Array<{ __typename?: 'QuizResponseQuestionOption', value: string }> | null | undefined } | null | undefined, response?: { __typename?: 'QuizResponseResponse', answers?: Array<{ __typename?: 'QuizResponseResponseAnswer', value: string, imageUrl?: string | null | undefined }> | null | undefined, flag?: { __typename?: 'QuizResponseResponseFlag', level: QuizFlagLevel } | null | undefined } | null | undefined }> | null | undefined } | null | undefined };

export type AnswerApplicationQuestionsMutationVariables = Exact<{
  applicationId: Scalars['String']['input'];
  answers?: InputMaybe<Array<InputMaybe<AnswerInput>> | InputMaybe<AnswerInput>>;
}>;


export type AnswerApplicationQuestionsMutation = { __typename?: 'Mutation', answerApplicationQuestions?: { __typename?: 'QuizApplication', id: string, problemType: ProblemType, customerId: string, submittedAt?: string | null | undefined, answers: Array<{ __typename?: 'QuizApplicationResponse', id: string, answer?: string | null | undefined, answersArray: Array<string>, englishAnswer?: string | null | undefined, englishAnswersArray: Array<string>, question?: { __typename?: 'QuizQuestion', id: string, shortcode?: string | null | undefined } | null | undefined }>, consultation?: { __typename?: 'Consultation', id: string, status: ConsultationStatus, isUpfrontPayment: boolean } | null | undefined, responses?: Array<{ __typename?: 'QuizResponse', id: string, question?: { __typename?: 'QuizResponseQuestion', id?: string | null | undefined, type?: QuizQuestionType | null | undefined, title?: string | null | undefined, shortcode?: string | null | undefined, options?: Array<{ __typename?: 'QuizResponseQuestionOption', value: string }> | null | undefined } | null | undefined, response?: { __typename?: 'QuizResponseResponse', answers?: Array<{ __typename?: 'QuizResponseResponseAnswer', value: string, imageUrl?: string | null | undefined }> | null | undefined, flag?: { __typename?: 'QuizResponseResponseFlag', level: QuizFlagLevel } | null | undefined } | null | undefined }> | null | undefined } | null | undefined };

export type QuizPageQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type QuizPageQuery = { __typename?: 'Query', customerAttributes: { __typename?: 'CustomerAttributes', id: string, conditions?: string | null | undefined, medications?: string | null | undefined, allergies?: string | null | undefined }, getQuizApplication?: { __typename?: 'QuizApplication', id: string, createdAt: string, customerId: string, purpose: QuizPurpose, problemType: ProblemType, submittedAt?: string | null | undefined, consultation?: { __typename?: 'Consultation', id: string, status: ConsultationStatus, stage: ConsultationStage, isUpfrontPayment: boolean, medium: ConsultationMedium, canSchedulePractitionerBooking: boolean, requiresPrescriberCall: boolean } | null | undefined, answers: Array<{ __typename?: 'QuizApplicationResponse', id: string, answer?: string | null | undefined, answersArray: Array<string>, englishAnswer?: string | null | undefined, englishAnswersArray: Array<string>, question?: { __typename?: 'QuizQuestion', id: string, shortcode?: string | null | undefined } | null | undefined }>, quiz: { __typename?: 'Quiz', id: string, default: boolean, quizCode: string, questionsOrder: Array<string>, questions: Array<{ __typename?: 'QuizQuestion', id: string, title?: string | null | undefined, type: QuizQuestionType, description?: string | null | undefined, required: boolean, optionImgLayout?: QuizQuestionOptionImageLayout | null | undefined, imgUrl?: string | null | undefined, shortcode?: string | null | undefined, options?: any | null | undefined, questionOptions: Array<{ __typename?: 'QuizQuestionOption', id: string, questionId: string, option?: string | null | undefined, position?: number | null | undefined, imgUrl?: string | null | undefined, popup?: { __typename?: 'QuizQuestionPopup', id: string, title?: string | null | undefined, content?: string | null | undefined, linkOutText?: string | null | undefined, imgUrl?: string | null | undefined } | null | undefined }>, popup?: { __typename?: 'QuizQuestionPopup', id: string, title?: string | null | undefined, content?: string | null | undefined, linkOutText?: string | null | undefined, imgUrl?: string | null | undefined } | null | undefined }>, logics: Array<{ __typename?: 'QuizLogic', id: string, from: { __typename?: 'QuizQuestion', id: string }, elseJump: { __typename?: 'QuizQuestion', id: string }, jumps: Array<{ __typename?: 'QuizJump', id: string, conditions: Array<{ __typename?: 'QuizConditions', id: string, value: string, operator: QuizJumpOperator, nextCondition?: QuizValidationCondition | null | undefined, question: { __typename?: 'QuizQuestion', id: string } }>, to: { __typename?: 'QuizQuestion', id: string } }> }>, skips: Array<{ __typename?: 'QuizSkip', id: string, from: { __typename?: 'QuizQuestion', id: string }, conditions: Array<{ __typename?: 'QuizConditions', id: string, value: string, operator: QuizJumpOperator, nextCondition?: QuizValidationCondition | null | undefined, question: { __typename?: 'QuizQuestion', id: string } }> }> }, responses?: Array<{ __typename?: 'QuizResponse', id: string, question?: { __typename?: 'QuizResponseQuestion', id?: string | null | undefined, type?: QuizQuestionType | null | undefined, title?: string | null | undefined, shortcode?: string | null | undefined, options?: Array<{ __typename?: 'QuizResponseQuestionOption', value: string }> | null | undefined } | null | undefined, response?: { __typename?: 'QuizResponseResponse', answers?: Array<{ __typename?: 'QuizResponseResponseAnswer', value: string, imageUrl?: string | null | undefined }> | null | undefined, flag?: { __typename?: 'QuizResponseResponseFlag', level: QuizFlagLevel } | null | undefined } | null | undefined }> | null | undefined, outcomes?: Array<{ __typename?: 'ArticleQuizOutcome', id: string } | { __typename?: 'BuyOtcQuizOutcome', id: string } | { __typename?: 'ConsultationQuizOutcome', id: string } | { __typename?: 'IncreaseUsageQuizOutcome', id: string } | { __typename?: 'NotEligibleQuizOutcome', id: string, reasons?: Array<QuizOutcomeReason> | null | undefined } | { __typename?: 'OtcQuizOutcome', id: string } | { __typename?: 'ReviewQuizOutcome', id: string } | { __typename?: 'SideEffectProactiveActionQuizOutcome', id: string } | { __typename?: 'ZendeskQuizOutcome', id: string }> | null | undefined } | null | undefined };

export type InitialAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type InitialAttributesQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, fullName?: string | null | undefined, preferredUnitSystem?: UnitSystem | null | undefined } | null | undefined };

export type UpdateShippingAddressMutationVariables = Exact<{
  address: AddressCreateWithoutUserInput;
}>;


export type UpdateShippingAddressMutation = { __typename?: 'Mutation', updateShipping?: { __typename?: 'User', id: string, address?: { __typename?: 'Address', id: string, line1?: string | null | undefined, line2?: string | null | undefined, city?: string | null | undefined, postalCode?: string | null | undefined, state?: string | null | undefined, country?: string | null | undefined, building?: string | null | undefined, company?: string | null | undefined } | null | undefined } | null | undefined };

export type LoginMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type LoginMutation = { __typename?: 'Mutation', auth: { __typename?: 'AuthPayload', token?: string | null | undefined, user?: { __typename?: 'User', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, shortAddressableName?: string | null | undefined, fullName?: string | null | undefined, email: string } | null | undefined } };

export type TriggerPasswordResetMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type TriggerPasswordResetMutation = { __typename?: 'Mutation', triggerPasswordReset?: { __typename?: 'TriggerPasswordResetPayload', ok?: boolean | null | undefined } | null | undefined };

export type UseProfileQueryVariables = Exact<{
  withSubscriptions?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UseProfileQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, shortAddressableName?: string | null | undefined, fullName?: string | null | undefined, legalFirstName?: string | null | undefined, legalLastName?: string | null | undefined, legalFullName?: string | null | undefined, preferredName?: string | null | undefined, email: string, phone?: string | null | undefined, isVerified?: boolean | null | undefined, birthday?: string | null | undefined, hasPaidMasterclass?: boolean | null | undefined, needsSubscriptionMigration?: boolean | null | undefined, isPasswordSet: boolean, weightTreatmentCategory?: WeightTreatmentCategory | null | undefined, preferredUnitSystem?: UnitSystem | null | undefined, defaultPaymentGateway?: PaymentGateway | null | undefined, address?: { __typename?: 'Address', id: string, line1?: string | null | undefined, line2?: string | null | undefined, city?: string | null | undefined, state?: string | null | undefined, postalCode?: string | null | undefined, prefecture?: string | null | undefined, municipality?: string | null | undefined, townArea?: string | null | undefined, country?: string | null | undefined, building?: string | null | undefined, company?: string | null | undefined } | null | undefined, residentialAddress?: { __typename?: 'ResidentialAddress', id: string, line1: string, line2?: string | null | undefined, city: string, state?: string | null | undefined, postalCode: string, prefecture?: string | null | undefined, municipality?: string | null | undefined, townArea?: string | null | undefined, country: string, building?: string | null | undefined, company?: string | null | undefined } | null | undefined, consultations: Array<{ __typename?: 'Consultation', id: string, type: ProblemType, status: ConsultationStatus, allowPatientToSendMessageToDoctor: boolean, isApproved?: boolean | null | undefined, stage: ConsultationStage, patientNotes?: string | null | undefined, rejectReason?: string | null | undefined, medium: ConsultationMedium, completedAt?: string | null | undefined, updatedAt: string, createdAt: string, isUpfrontPayment: boolean, requiresPrescriberCall: boolean, isInNoPickUpQueue?: boolean | null | undefined, typeIsFlexi?: boolean | null | undefined, practitionerMessagedAt?: string | null | undefined, patientQuestions?: Array<{ __typename?: 'ConsultationPatientQuestion', id: string, createdAt: string }> | null | undefined, appointment?: { __typename?: 'Appointment', startsAt?: string | null | undefined, endsAt?: string | null | undefined } | null | undefined, doctor?: { __typename?: 'User', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, shortClinicianName: string, fullClinicianName: string, fullName?: string | null | undefined, provider?: { __typename?: 'Provider', id: string, clinicianType: ClinicianType, clinicianTitle: string } | null | undefined } | null | undefined, latestPractitionerBooking?: { __typename?: 'PractitionerBooking', id: string, windowStartAt: string, windowEndAt: string } | null | undefined, screeningQuizApplication?: { __typename?: 'QuizApplication', id: string, submittedAt?: string | null | undefined } | null | undefined, chatThread?: { __typename?: 'ChatThread', id: string } | null | undefined, quizApplication?: { __typename?: 'QuizApplication', id: string, submittedAt?: string | null | undefined, problemType: ProblemType, answers: Array<{ __typename?: 'QuizApplicationResponse', id: string, answer?: string | null | undefined, answersArray: Array<string>, question?: { __typename?: 'QuizQuestion', id: string, shortcode?: string | null | undefined } | null | undefined }> } | null | undefined, order?: { __typename?: 'Order', id: string } | null | undefined, treatment?: { __typename?: 'Treatment', id: string, status: TreatmentStatus, refillsLeft?: number | null | undefined, nextPayment?: string | null | undefined, pendingFollowUpReminderDate?: string | null | undefined, isLastOrderUnfulfilled: boolean, hasUnfulfilledOrder: boolean, customerStatedTreatmentStartedAt?: string | null | undefined, type: ProblemType, active: boolean, hasScriptExpired: boolean, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined, photo?: { __typename?: 'File', id: string, url: string } | null | undefined, variants: Array<{ __typename?: 'Variant', id: string, inventory?: { __typename?: 'VariantInventory', id: string, sku?: string | null | undefined } | null | undefined }> }, plan?: { __typename?: 'Plan', id: string, amount: number } | null | undefined, otcSchedules: Array<{ __typename?: 'OtcSchedule', id: string, isActive: boolean, quantity: number, product: { __typename?: 'Product', id: string, name: string, productType: ProductType, photo?: { __typename?: 'File', id: string, url: string } | null | undefined, variants: Array<{ __typename?: 'Variant', id: string, price: number }> } }> } | null | undefined, pathologyRequests?: Array<{ __typename?: 'PathologyRequest', id: string, createdAt: string, customerStatedCollectedAt?: string | null | undefined } | null | undefined> | null | undefined, reminders?: Array<{ __typename?: 'ConsultationReminder', id: string, canceled: boolean, createdAt: string, scheduledAt: string, doneAt?: string | null | undefined }> | null | undefined, purchasePrompt?: { __typename?: 'ConfirmPurchasePrompt', id: string } | { __typename?: 'FurPurchasePrompt', id: string } | { __typename?: 'InitialPurchasePrompt', id: string } | { __typename?: 'RestartFlowPrompt', id: string } | { __typename?: 'SubstitutePurchasePrompt', id: string } | null | undefined }>, initialQuizApplications?: Array<{ __typename?: 'QuizApplication', id: string, createdAt: string, updatedAt: string, submittedAt?: string | null | undefined, problemType: ProblemType, purpose: QuizPurpose, archivedAt?: string | null | undefined, outcomes?: Array<{ __typename?: 'ArticleQuizOutcome', id: string } | { __typename?: 'BuyOtcQuizOutcome', id: string } | { __typename?: 'ConsultationQuizOutcome', id: string } | { __typename?: 'IncreaseUsageQuizOutcome', id: string } | { __typename?: 'NotEligibleQuizOutcome', id: string, reasons?: Array<QuizOutcomeReason> | null | undefined } | { __typename?: 'OtcQuizOutcome', id: string } | { __typename?: 'ReviewQuizOutcome', id: string } | { __typename?: 'SideEffectProactiveActionQuizOutcome', id: string } | { __typename?: 'ZendeskQuizOutcome', id: string }> | null | undefined }> | null | undefined, memberships: Array<{ __typename?: 'Membership', id: string, type: ProblemType, createdAt: string, membershipTerms: Array<{ __typename?: 'MembershipTerm', id: string, status: MembershipStatus, startDate?: string | null | undefined, endDate?: string | null | undefined, isValid: boolean }> }>, subscriptions?: Array<{ __typename?: 'SubscriptionV2', id: string, status: SubscriptionStatus, nextPaymentAt?: string | null | undefined, subscriptionOrders?: Array<{ __typename?: 'SubscriptionOrder', id: string, status: SubscriptionOrderStatus, createdAt: string }> | null | undefined, subscriptionPlan: { __typename?: 'SubscriptionPlanV2', id: string, name: string, description: string, interval: SubscriptionPlanInterval, intervalCount: number, price: number, photo: { __typename?: 'File', id: string, url: string } } }> | null | undefined, purchases?: Array<{ __typename?: 'Purchase', id: string, status: PurchaseStatus, problemType?: ProblemType | null | undefined, isVisibleInProfilePage?: boolean | null | undefined, contexts?: Array<{ __typename?: 'SequenceContext', id: string, consultations?: Array<{ __typename?: 'Consultation', id: string }> | null | undefined }> | null | undefined }> | null | undefined, savedPaymentMethods?: Array<{ __typename?: 'SavedCardPaymentMethod', expiry: string, mask: string, brand: string, id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | { __typename?: 'SavedPayPalPaymentMethod', email?: string | null | undefined, id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | { __typename?: 'SavedSofortPaymentMethod', id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | { __typename?: 'SavedZipPaymentMethod', valid: boolean, id: string, gateway: PaymentGateway, default: boolean, createdAt?: string | null | undefined } | null | undefined> | null | undefined, zip?: { __typename?: 'Zip', valid: boolean } | null | undefined } | null | undefined };

export type UseProfileCardsQuizApplicationFragment = { __typename?: 'QuizApplication', id: string, problemType: ProblemType, createdAt: string, archivedAt?: string | null | undefined };

export type UseProfileCardsConsultationFragment = { __typename?: 'Consultation', id: string, type: ProblemType, stage: ConsultationStage, createdAt: string, isApproved?: boolean | null | undefined, typeIsFlexi?: boolean | null | undefined, status: ConsultationStatus, practitionerMessagedAt?: string | null | undefined, purchasePrompt?: { __typename?: 'ConfirmPurchasePrompt', id: string } | { __typename?: 'FurPurchasePrompt', id: string } | { __typename?: 'InitialPurchasePrompt', id: string } | { __typename?: 'RestartFlowPrompt', id: string } | { __typename?: 'SubstitutePurchasePrompt', id: string } | null | undefined, quizApplication?: { __typename?: 'QuizApplication', id: string, problemType: ProblemType } | null | undefined, treatment?: { __typename?: 'Treatment', id: string, status: TreatmentStatus } | null | undefined };

export type UseProfileCardsPurchaseFragment = { __typename?: 'Purchase', id: string, status: PurchaseStatus, problemType?: ProblemType | null | undefined, isVisibleInProfilePage?: boolean | null | undefined, contexts?: Array<{ __typename?: 'SequenceContext', id: string, consultations?: Array<{ __typename?: 'Consultation', id: string }> | null | undefined }> | null | undefined };

export type UseUpdateProfileMutationVariables = Exact<{
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<AddressCreateWithoutUserInput>;
}>;


export type UseUpdateProfileMutation = { __typename?: 'Mutation', updateProfile?: { __typename?: 'User', id: string, email: string, firstName?: string | null | undefined, lastName?: string | null | undefined, shortAddressableName?: string | null | undefined, fullName?: string | null | undefined, phone?: string | null | undefined, role: UserRole, isPasswordSet: boolean, defaultPaymentGateway?: PaymentGateway | null | undefined, birthday?: string | null | undefined, preferredUnitSystem?: UnitSystem | null | undefined, residentialAddress?: { __typename?: 'ResidentialAddress', id: string, line1: string, line2?: string | null | undefined, city: string, postalCode: string, state?: string | null | undefined, country: string, company?: string | null | undefined, building?: string | null | undefined } | null | undefined, address?: { __typename?: 'Address', id: string, line1?: string | null | undefined, line2?: string | null | undefined, city?: string | null | undefined, postalCode?: string | null | undefined, state?: string | null | undefined, country?: string | null | undefined, company?: string | null | undefined, building?: string | null | undefined } | null | undefined, savedPaymentMethods?: Array<{ __typename?: 'SavedCardPaymentMethod', brand: string, expiry: string, mask: string, id: string, gateway: PaymentGateway, default: boolean } | { __typename?: 'SavedPayPalPaymentMethod', email?: string | null | undefined, id: string, gateway: PaymentGateway, default: boolean } | { __typename?: 'SavedSofortPaymentMethod', id: string, gateway: PaymentGateway, default: boolean } | { __typename?: 'SavedZipPaymentMethod', valid: boolean, id: string, gateway: PaymentGateway, default: boolean } | null | undefined> | null | undefined, zip?: { __typename?: 'Zip', valid: boolean } | null | undefined } | null | undefined };

export type UseUpdateProfileWithAddressMutationVariables = Exact<{
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<AddressCreateWithoutUserInput>;
}>;


export type UseUpdateProfileWithAddressMutation = { __typename?: 'Mutation', updateProfile?: { __typename?: 'User', id: string } | null | undefined };

export type UseSignUpLeadMutationVariables = Exact<{
  email: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  marketingCommsConsent?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UseSignUpLeadMutation = { __typename?: 'Mutation', signUpLead?: { __typename?: 'AuthPayload', token?: string | null | undefined, user?: { __typename?: 'User', id: string, email: string, firstName?: string | null | undefined, lastName?: string | null | undefined, shortAddressableName?: string | null | undefined, fullName?: string | null | undefined } | null | undefined } | null | undefined };

export type SignupMutationVariables = Exact<{
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  marketingCommsConsent?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SignupMutation = { __typename?: 'Mutation', signup?: { __typename?: 'AuthPayload', token?: string | null | undefined, user?: { __typename?: 'User', id: string, email: string, firstName?: string | null | undefined, lastName?: string | null | undefined, shortAddressableName?: string | null | undefined, fullName?: string | null | undefined, phone?: string | null | undefined, role: UserRole, isPasswordSet: boolean, defaultPaymentGateway?: PaymentGateway | null | undefined, birthday?: string | null | undefined, preferredUnitSystem?: UnitSystem | null | undefined, residentialAddress?: { __typename?: 'ResidentialAddress', id: string, line1: string, line2?: string | null | undefined, city: string, postalCode: string, state?: string | null | undefined, country: string, company?: string | null | undefined, building?: string | null | undefined } | null | undefined, address?: { __typename?: 'Address', id: string, line1?: string | null | undefined, line2?: string | null | undefined, city?: string | null | undefined, postalCode?: string | null | undefined, state?: string | null | undefined, country?: string | null | undefined, company?: string | null | undefined, building?: string | null | undefined } | null | undefined, zip?: { __typename?: 'Zip', valid: boolean } | null | undefined } | null | undefined } | null | undefined };

export type QuizApplicationFragment = { __typename?: 'QuizApplication', id: string, createdAt: string, customerId: string, purpose: QuizPurpose, problemType: ProblemType, submittedAt?: string | null | undefined, consultation?: { __typename?: 'Consultation', id: string, status: ConsultationStatus, stage: ConsultationStage, isUpfrontPayment: boolean, medium: ConsultationMedium, canSchedulePractitionerBooking: boolean, requiresPrescriberCall: boolean } | null | undefined, answers: Array<{ __typename?: 'QuizApplicationResponse', id: string, answer?: string | null | undefined, answersArray: Array<string>, englishAnswer?: string | null | undefined, englishAnswersArray: Array<string>, question?: { __typename?: 'QuizQuestion', id: string, shortcode?: string | null | undefined } | null | undefined }>, quiz: { __typename?: 'Quiz', id: string, default: boolean, quizCode: string, questionsOrder: Array<string>, questions: Array<{ __typename?: 'QuizQuestion', id: string, title?: string | null | undefined, type: QuizQuestionType, description?: string | null | undefined, required: boolean, optionImgLayout?: QuizQuestionOptionImageLayout | null | undefined, imgUrl?: string | null | undefined, shortcode?: string | null | undefined, options?: any | null | undefined, questionOptions: Array<{ __typename?: 'QuizQuestionOption', id: string, questionId: string, option?: string | null | undefined, position?: number | null | undefined, imgUrl?: string | null | undefined, popup?: { __typename?: 'QuizQuestionPopup', id: string, title?: string | null | undefined, content?: string | null | undefined, linkOutText?: string | null | undefined, imgUrl?: string | null | undefined } | null | undefined }>, popup?: { __typename?: 'QuizQuestionPopup', id: string, title?: string | null | undefined, content?: string | null | undefined, linkOutText?: string | null | undefined, imgUrl?: string | null | undefined } | null | undefined }>, logics: Array<{ __typename?: 'QuizLogic', id: string, from: { __typename?: 'QuizQuestion', id: string }, elseJump: { __typename?: 'QuizQuestion', id: string }, jumps: Array<{ __typename?: 'QuizJump', id: string, conditions: Array<{ __typename?: 'QuizConditions', id: string, value: string, operator: QuizJumpOperator, nextCondition?: QuizValidationCondition | null | undefined, question: { __typename?: 'QuizQuestion', id: string } }>, to: { __typename?: 'QuizQuestion', id: string } }> }>, skips: Array<{ __typename?: 'QuizSkip', id: string, from: { __typename?: 'QuizQuestion', id: string }, conditions: Array<{ __typename?: 'QuizConditions', id: string, value: string, operator: QuizJumpOperator, nextCondition?: QuizValidationCondition | null | undefined, question: { __typename?: 'QuizQuestion', id: string } }> }> }, responses?: Array<{ __typename?: 'QuizResponse', id: string, question?: { __typename?: 'QuizResponseQuestion', id?: string | null | undefined, type?: QuizQuestionType | null | undefined, title?: string | null | undefined, shortcode?: string | null | undefined, options?: Array<{ __typename?: 'QuizResponseQuestionOption', value: string }> | null | undefined } | null | undefined, response?: { __typename?: 'QuizResponseResponse', answers?: Array<{ __typename?: 'QuizResponseResponseAnswer', value: string, imageUrl?: string | null | undefined }> | null | undefined, flag?: { __typename?: 'QuizResponseResponseFlag', level: QuizFlagLevel } | null | undefined } | null | undefined }> | null | undefined, outcomes?: Array<{ __typename?: 'ArticleQuizOutcome', id: string } | { __typename?: 'BuyOtcQuizOutcome', id: string } | { __typename?: 'ConsultationQuizOutcome', id: string } | { __typename?: 'IncreaseUsageQuizOutcome', id: string } | { __typename?: 'NotEligibleQuizOutcome', id: string, reasons?: Array<QuizOutcomeReason> | null | undefined } | { __typename?: 'OtcQuizOutcome', id: string } | { __typename?: 'ReviewQuizOutcome', id: string } | { __typename?: 'SideEffectProactiveActionQuizOutcome', id: string } | { __typename?: 'ZendeskQuizOutcome', id: string }> | null | undefined };

export type QuizApplicationQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type QuizApplicationQuery = { __typename?: 'Query', getQuizApplication?: { __typename?: 'QuizApplication', id: string, createdAt: string, customerId: string, purpose: QuizPurpose, problemType: ProblemType, submittedAt?: string | null | undefined, consultation?: { __typename?: 'Consultation', id: string, status: ConsultationStatus, stage: ConsultationStage, isUpfrontPayment: boolean, medium: ConsultationMedium, canSchedulePractitionerBooking: boolean, requiresPrescriberCall: boolean } | null | undefined, answers: Array<{ __typename?: 'QuizApplicationResponse', id: string, answer?: string | null | undefined, answersArray: Array<string>, englishAnswer?: string | null | undefined, englishAnswersArray: Array<string>, question?: { __typename?: 'QuizQuestion', id: string, shortcode?: string | null | undefined } | null | undefined }>, quiz: { __typename?: 'Quiz', id: string, default: boolean, quizCode: string, questionsOrder: Array<string>, questions: Array<{ __typename?: 'QuizQuestion', id: string, title?: string | null | undefined, type: QuizQuestionType, description?: string | null | undefined, required: boolean, optionImgLayout?: QuizQuestionOptionImageLayout | null | undefined, imgUrl?: string | null | undefined, shortcode?: string | null | undefined, options?: any | null | undefined, questionOptions: Array<{ __typename?: 'QuizQuestionOption', id: string, questionId: string, option?: string | null | undefined, position?: number | null | undefined, imgUrl?: string | null | undefined, popup?: { __typename?: 'QuizQuestionPopup', id: string, title?: string | null | undefined, content?: string | null | undefined, linkOutText?: string | null | undefined, imgUrl?: string | null | undefined } | null | undefined }>, popup?: { __typename?: 'QuizQuestionPopup', id: string, title?: string | null | undefined, content?: string | null | undefined, linkOutText?: string | null | undefined, imgUrl?: string | null | undefined } | null | undefined }>, logics: Array<{ __typename?: 'QuizLogic', id: string, from: { __typename?: 'QuizQuestion', id: string }, elseJump: { __typename?: 'QuizQuestion', id: string }, jumps: Array<{ __typename?: 'QuizJump', id: string, conditions: Array<{ __typename?: 'QuizConditions', id: string, value: string, operator: QuizJumpOperator, nextCondition?: QuizValidationCondition | null | undefined, question: { __typename?: 'QuizQuestion', id: string } }>, to: { __typename?: 'QuizQuestion', id: string } }> }>, skips: Array<{ __typename?: 'QuizSkip', id: string, from: { __typename?: 'QuizQuestion', id: string }, conditions: Array<{ __typename?: 'QuizConditions', id: string, value: string, operator: QuizJumpOperator, nextCondition?: QuizValidationCondition | null | undefined, question: { __typename?: 'QuizQuestion', id: string } }> }> }, responses?: Array<{ __typename?: 'QuizResponse', id: string, question?: { __typename?: 'QuizResponseQuestion', id?: string | null | undefined, type?: QuizQuestionType | null | undefined, title?: string | null | undefined, shortcode?: string | null | undefined, options?: Array<{ __typename?: 'QuizResponseQuestionOption', value: string }> | null | undefined } | null | undefined, response?: { __typename?: 'QuizResponseResponse', answers?: Array<{ __typename?: 'QuizResponseResponseAnswer', value: string, imageUrl?: string | null | undefined }> | null | undefined, flag?: { __typename?: 'QuizResponseResponseFlag', level: QuizFlagLevel } | null | undefined } | null | undefined }> | null | undefined, outcomes?: Array<{ __typename?: 'ArticleQuizOutcome', id: string } | { __typename?: 'BuyOtcQuizOutcome', id: string } | { __typename?: 'ConsultationQuizOutcome', id: string } | { __typename?: 'IncreaseUsageQuizOutcome', id: string } | { __typename?: 'NotEligibleQuizOutcome', id: string, reasons?: Array<QuizOutcomeReason> | null | undefined } | { __typename?: 'OtcQuizOutcome', id: string } | { __typename?: 'ReviewQuizOutcome', id: string } | { __typename?: 'SideEffectProactiveActionQuizOutcome', id: string } | { __typename?: 'ZendeskQuizOutcome', id: string }> | null | undefined } | null | undefined };

export type StartQuizApplicationMutationVariables = Exact<{
  problemType: ProblemType;
  quizPurpose?: InputMaybe<QuizPurpose>;
  errorWhenFollowUpReminderNotDone?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type StartQuizApplicationMutation = { __typename?: 'Mutation', quizApplicationInfo?: { __typename?: 'QuizApplication', id: string, submittedAt?: string | null | undefined, consultation?: { __typename?: 'Consultation', id: string } | null | undefined } | null | undefined };

export type StartQuizApplicationWithQuizCodeMutationVariables = Exact<{
  quizCode: Scalars['String']['input'];
}>;


export type StartQuizApplicationWithQuizCodeMutation = { __typename?: 'Mutation', quizApplicationInfo?: { __typename?: 'QuizApplication', id: string } | null | undefined };

export type CompleteChecklistItemMutationVariables = Exact<{
  code: Scalars['String']['input'];
  checklistId: Scalars['String']['input'];
}>;


export type CompleteChecklistItemMutation = { __typename?: 'Mutation', completeChecklistItem?: { __typename?: 'ChecklistItem', id: string, completed: boolean } | null | undefined };

export type UnCompleteChecklistItemMutationVariables = Exact<{
  code: Scalars['String']['input'];
  checklistId: Scalars['String']['input'];
}>;


export type UnCompleteChecklistItemMutation = { __typename?: 'Mutation', unCompleteChecklistItem?: { __typename?: 'ChecklistItem', id: string, completed: boolean } | null | undefined };

export type FetchChecklistQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type FetchChecklistQuery = { __typename?: 'Query', checklistByConsultation?: { __typename?: 'Checklist', id: string, consultationId: string, attributes?: { __typename?: 'ChecklistAttribute', age?: number | null | undefined, tryingStatus?: TryingStatusType | null | undefined, trimester?: string | null | undefined, expectedNewborns?: string | null | undefined } | null | undefined, groups?: Array<{ __typename?: 'ChecklistGroup', id: string, title: string, items?: Array<{ __typename?: 'ChecklistItem', code: string, completed: boolean, id: string } | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type UseConsultationQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type UseConsultationQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, type: ProblemType, status: ConsultationStatus, isApproved?: boolean | null | undefined, stage: ConsultationStage, isUpfrontPayment: boolean, patientNotes?: string | null | undefined, rejectReason?: string | null | undefined, createdAt: string, completedAt?: string | null | undefined, medium: ConsultationMedium, allowPatientToSendMessageToDoctor: boolean, canSchedulePractitionerBooking: boolean, requiresPrescriberCall: boolean, chatThread?: { __typename?: 'ChatThread', id: string } | null | undefined, payment?: { __typename?: 'PaymentTransaction', id: string, charge?: { __typename?: 'Charge', id: string, createdAt: string, amount: number } | null | undefined } | null | undefined, patientQuestions?: Array<{ __typename?: 'ConsultationPatientQuestion', id: string, createdAt: string, updatedAt: string, value: string }> | null | undefined, treatment?: { __typename?: 'Treatment', id: string, status: TreatmentStatus, refillsLeft?: number | null | undefined, type: ProblemType, experimentPaymentPlan?: { __typename?: 'ExperimentTreatmentPaymentPlan', id: string, paymentPlan: ExperimentPaymentPlanVariant, discountPercentage: number, months?: number | null | undefined, version?: number | null | undefined } | null | undefined, experimentAvailablePaymentPlans: Array<{ __typename?: 'ExperimentAvailablePaymentPlan', paymentPlan: ExperimentPaymentPlanVariant, discountPercentage: number, cadence: string, months: number, amount: { __typename?: 'ExperimentAvailablePaymentPlanAmount', total: number, totalSaved: number, perMonth: number } }>, plan?: { __typename?: 'Plan', id: string, amount: number } | null | undefined, otcSchedules: Array<{ __typename?: 'OtcSchedule', id: string, productId: string, createdAt: string, updatedAt: string, cadence: OtcScheduleCadence, isActive: boolean, quantity: number, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined, photo?: { __typename?: 'File', id: string, url: string } | null | undefined, variants: Array<{ __typename?: 'Variant', id: string, price: number }> } }>, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined, productType: ProductType, safetyInformation?: string | null | undefined, shortDescription?: string | null | undefined, deliveryInformation?: string | null | undefined, usage: ProductUsage, units?: number | null | undefined, photo?: { __typename?: 'File', id: string, url: string } | null | undefined, cmi?: { __typename?: 'File', id: string, url: string } | null | undefined, plan?: { __typename?: 'Plan', id: string, intervalCount: number, interval: BillingInterval, amount: number } | null | undefined, faqs: Array<{ __typename?: 'Faq', id: string, title?: string | null | undefined, markdown?: string | null | undefined, videoEmbedUrl?: string | null | undefined }>, variants: Array<{ __typename?: 'Variant', id: string, price: number, isRefill: boolean, inventory?: { __typename?: 'VariantInventory', id: string, sku?: string | null | undefined } | null | undefined }> } } | null | undefined, customer: { __typename?: 'User', id: string, email: string, firstName?: string | null | undefined, birthday?: string | null | undefined, healthCareDetails?: { __typename?: 'HealthCareDetails', id: string, hasIndividualHealthcareIdentifier?: boolean | null | undefined } | null | undefined }, quizResponses?: Array<{ __typename?: 'QuizResponse', id: string, question?: { __typename?: 'QuizResponseQuestion', id?: string | null | undefined, type?: QuizQuestionType | null | undefined, title?: string | null | undefined, shortcode?: string | null | undefined, options?: Array<{ __typename?: 'QuizResponseQuestionOption', value: string }> | null | undefined } | null | undefined, response?: { __typename?: 'QuizResponseResponse', answers?: Array<{ __typename?: 'QuizResponseResponseAnswer', value: string, imageUrl?: string | null | undefined }> | null | undefined, flag?: { __typename?: 'QuizResponseResponseFlag', level: QuizFlagLevel } | null | undefined } | null | undefined }> | null | undefined, doctorQuestions?: Array<{ __typename?: 'ConsultationQuestion', id: string, createdAt: string, updatedAt: string, value: string, allowedAnswerType: ConsultationAnswerType, answer?: { __typename?: 'ConsultationAnswer', id: string, createdAt: string, updatedAt: string, value: string } | null | undefined, attachments?: Array<{ __typename?: 'ConsultationQuestionAttachment', id: string, mimetype: string, signedUrl?: string | null | undefined, filename: string }> | null | undefined }> | null | undefined, doctor?: { __typename?: 'User', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, shortClinicianName: string, fullClinicianName: string, fullName?: string | null | undefined, role: UserRole, bio?: string | null | undefined, provider?: { __typename?: 'Provider', id: string, qualifications?: string | null | undefined, clinicianTitle: string, clinicianType: ClinicianType } | null | undefined, avatar?: { __typename?: 'File', id: string, createdAt: string, updatedAt: string, filename: string, mimetype: string, url: string } | null | undefined } | null | undefined, quizApplication?: { __typename?: 'QuizApplication', id: string, submittedAt?: string | null | undefined, answers: Array<{ __typename?: 'QuizApplicationResponse', id: string, answer?: string | null | undefined, answersArray: Array<string>, question?: { __typename?: 'QuizQuestion', id: string, shortcode?: string | null | undefined } | null | undefined }>, quiz: { __typename?: 'Quiz', id: string, questionsOrder: Array<string>, questions: Array<{ __typename?: 'QuizQuestion', id: string, title?: string | null | undefined, type: QuizQuestionType, description?: string | null | undefined, required: boolean, options?: any | null | undefined, imgUrl?: string | null | undefined, shortcode?: string | null | undefined, questionOptions: Array<{ __typename?: 'QuizQuestionOption', id: string, questionId: string, option?: string | null | undefined, position?: number | null | undefined }> }>, logics: Array<{ __typename?: 'QuizLogic', id: string, from: { __typename?: 'QuizQuestion', id: string }, elseJump: { __typename?: 'QuizQuestion', id: string }, jumps: Array<{ __typename?: 'QuizJump', id: string, conditions: Array<{ __typename?: 'QuizConditions', id: string, value: string, operator: QuizJumpOperator, nextCondition?: QuizValidationCondition | null | undefined, question: { __typename?: 'QuizQuestion', id: string } }>, to: { __typename?: 'QuizQuestion', id: string } }> }>, skips: Array<{ __typename?: 'QuizSkip', id: string, from: { __typename?: 'QuizQuestion', id: string }, conditions: Array<{ __typename?: 'QuizConditions', id: string, value: string, operator: QuizJumpOperator, nextCondition?: QuizValidationCondition | null | undefined, question: { __typename?: 'QuizQuestion', id: string } }> }> } } | null | undefined, order?: { __typename?: 'Order', id: string, paymentStatus?: OrderPaymentStatus | null | undefined, lineItems?: Array<{ __typename?: 'OrderLineItem', id: string, quantity: number, variant: { __typename?: 'Variant', id: string, price: number, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined, productType: ProductType, shortDescription?: string | null | undefined, photo?: { __typename?: 'File', id: string, url: string } | null | undefined } } }> | null | undefined } | null | undefined, pathologyRequests?: Array<{ __typename?: 'PathologyRequest', id: string, createdAt: string, customerStatedCollectedAt?: string | null | undefined, result?: { __typename?: 'PathologyResult', id: string, lab: string, releasedAt?: string | null | undefined, file?: { __typename?: 'PathologyResultFile', id: string, url: string } | null | undefined } | null | undefined, referral?: { __typename?: 'PathologyReferral', id: string, url: string, signedUrl: string } | null | undefined, panels?: Array<{ __typename?: 'PathologyPanel', id: string, tests?: Array<{ __typename?: 'PathologyPanelTest', id: string, name: PathologyPanelTestNameKey, result?: { __typename?: 'PathologyPanelTestResult', id?: string | null | undefined, note?: string | null | undefined, result: { __typename?: 'PathologyPanelTestResultValue', type: PathologyPanelTestResultValueType, value?: string | null | undefined } } | null | undefined }> | null | undefined }> | null | undefined } | null | undefined> | null | undefined, reminders?: Array<{ __typename?: 'ConsultationReminder', id: string, doneAt?: string | null | undefined, canceled: boolean, scheduledAt: string, createdAt: string }> | null | undefined, screeningQuizApplication?: { __typename?: 'QuizApplication', id: string } | null | undefined } | null | undefined };

export type ConsultationPaymentPageQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ConsultationPaymentPageQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, type: ProblemType, status: ConsultationStatus, stage: ConsultationStage, requiresPrescriberCall: boolean, quizApplication?: { __typename?: 'QuizApplication', id: string, submittedAt?: string | null | undefined } | null | undefined, price?: { __typename?: 'ConsultationPrice', amountOff: number, fullPrice: number, total: number } | null | undefined } | null | undefined };

export type ConsultationTypeQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ConsultationTypeQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, type: ProblemType } | null | undefined };

export type LatestConsultationQueryVariables = Exact<{
  type: ProblemType;
}>;


export type LatestConsultationQuery = { __typename?: 'Query', consultations?: Array<{ __typename?: 'Consultation', id: string, type: ProblemType, status: ConsultationStatus, stage: ConsultationStage, doctor?: { __typename?: 'User', id: string, lastName?: string | null | undefined, shortClinicianName: string, fullClinicianName: string, fullName?: string | null | undefined } | null | undefined, quizApplication?: { __typename?: 'QuizApplication', id: string } | null | undefined }> | null | undefined };

export type PayConsultationPaymentMutationVariables = Exact<{
  id: Scalars['String']['input'];
  couponCode?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  gateway?: InputMaybe<PaymentGateway>;
  zipCheckoutId?: InputMaybe<Scalars['String']['input']>;
  stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
}>;


export type PayConsultationPaymentMutation = { __typename?: 'Mutation', payConsultation?: { __typename?: 'Consultation', id: string } | null | undefined };

export type UseProfileConsultationsQueryVariables = Exact<{ [key: string]: never; }>;


export type UseProfileConsultationsQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, hasPaidMasterclass?: boolean | null | undefined, consultations: Array<{ __typename?: 'Consultation', id: string, type: ProblemType, createdAt: string, stage: ConsultationStage, isApproved?: boolean | null | undefined, allowPatientToSendMessageToDoctor: boolean, status: ConsultationStatus, pathologyRequests?: Array<{ __typename?: 'PathologyRequest', id: string } | null | undefined> | null | undefined, doctor?: { __typename?: 'User', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, shortClinicianName: string, fullClinicianName: string, fullName?: string | null | undefined, provider?: { __typename?: 'Provider', id: string, clinicianType: ClinicianType, clinicianTitle: string } | null | undefined } | null | undefined, patientQuestions?: Array<{ __typename?: 'ConsultationPatientQuestion', id: string, createdAt: string }> | null | undefined, reminders?: Array<{ __typename?: 'ConsultationReminder', id: string, canceled: boolean, createdAt: string, scheduledAt: string, doneAt?: string | null | undefined }> | null | undefined, quizApplication?: { __typename?: 'QuizApplication', id: string } | null | undefined }> } | null | undefined };

export type CustomerAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerAttributesQuery = { __typename?: 'Query', customerAttributes: { __typename?: 'CustomerAttributes', id: string, birthday?: string | null | undefined, age?: number | null | undefined, conditions?: string | null | undefined, medications?: string | null | undefined, allergies?: string | null | undefined, height?: number | null | undefined, weight?: number | null | undefined, bmi?: number | null | undefined, sex?: Sex | null | undefined, smoking?: Smoking | null | undefined, mentalHealthConditions?: string | null | undefined, diabetesRisk: { __typename?: 'CustomerDiabetesRiskAttributes', diabetesRiskLevel?: DiabetesRiskLevel | null | undefined, diabetesRiskProbability?: number | null | undefined }, menopause: { __typename?: 'CustomerMenopauseAttributes', menopauseSymptoms?: Array<MenopauseSymptoms | null | undefined> | null | undefined }, pregnancy: { __typename?: 'CustomerPregnancyAttributes', pregnant?: PregnancyStatus | null | undefined }, hair: { __typename?: 'CustomerHairAttributes', familyHistoryHairLoss?: boolean | null | undefined } } };

export type MoveConsultationPaidToOrderPaidMutationVariables = Exact<{
  consultationId: Scalars['String']['input'];
  doctorId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
}>;


export type MoveConsultationPaidToOrderPaidMutation = { __typename?: 'Mutation', moveConsultationPaidToOrderPaid?: { __typename?: 'MoveConsultationPaidToOrderPaidPayload', success: boolean } | null | undefined };

export type AnswerDoctorQuestionsMutationVariables = Exact<{
  consultationId: Scalars['String']['input'];
  answers: Scalars['Json']['input'];
}>;


export type AnswerDoctorQuestionsMutation = { __typename?: 'Mutation', answerDoctorQuestions?: { __typename?: 'Consultation', id: string } | null | undefined };

export type ConsultationInfoFragment = { __typename?: 'Consultation', id: string, type: ProblemType, status: ConsultationStatus, isApproved?: boolean | null | undefined, stage: ConsultationStage, isUpfrontPayment: boolean, patientNotes?: string | null | undefined, rejectReason?: string | null | undefined, createdAt: string, completedAt?: string | null | undefined, medium: ConsultationMedium, allowPatientToSendMessageToDoctor: boolean, canSchedulePractitionerBooking: boolean, requiresPrescriberCall: boolean, chatThread?: { __typename?: 'ChatThread', id: string } | null | undefined, payment?: { __typename?: 'PaymentTransaction', id: string, charge?: { __typename?: 'Charge', id: string, createdAt: string, amount: number } | null | undefined } | null | undefined, patientQuestions?: Array<{ __typename?: 'ConsultationPatientQuestion', id: string, createdAt: string, updatedAt: string, value: string }> | null | undefined, treatment?: { __typename?: 'Treatment', id: string, status: TreatmentStatus, refillsLeft?: number | null | undefined, type: ProblemType, experimentPaymentPlan?: { __typename?: 'ExperimentTreatmentPaymentPlan', id: string, paymentPlan: ExperimentPaymentPlanVariant, discountPercentage: number, months?: number | null | undefined, version?: number | null | undefined } | null | undefined, experimentAvailablePaymentPlans: Array<{ __typename?: 'ExperimentAvailablePaymentPlan', paymentPlan: ExperimentPaymentPlanVariant, discountPercentage: number, cadence: string, months: number, amount: { __typename?: 'ExperimentAvailablePaymentPlanAmount', total: number, totalSaved: number, perMonth: number } }>, plan?: { __typename?: 'Plan', id: string, amount: number } | null | undefined, otcSchedules: Array<{ __typename?: 'OtcSchedule', id: string, productId: string, createdAt: string, updatedAt: string, cadence: OtcScheduleCadence, isActive: boolean, quantity: number, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined, photo?: { __typename?: 'File', id: string, url: string } | null | undefined, variants: Array<{ __typename?: 'Variant', id: string, price: number }> } }>, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined, productType: ProductType, safetyInformation?: string | null | undefined, shortDescription?: string | null | undefined, deliveryInformation?: string | null | undefined, usage: ProductUsage, units?: number | null | undefined, photo?: { __typename?: 'File', id: string, url: string } | null | undefined, cmi?: { __typename?: 'File', id: string, url: string } | null | undefined, plan?: { __typename?: 'Plan', id: string, intervalCount: number, interval: BillingInterval, amount: number } | null | undefined, faqs: Array<{ __typename?: 'Faq', id: string, title?: string | null | undefined, markdown?: string | null | undefined, videoEmbedUrl?: string | null | undefined }>, variants: Array<{ __typename?: 'Variant', id: string, price: number, isRefill: boolean, inventory?: { __typename?: 'VariantInventory', id: string, sku?: string | null | undefined } | null | undefined }> } } | null | undefined, customer: { __typename?: 'User', id: string, email: string, firstName?: string | null | undefined, birthday?: string | null | undefined, healthCareDetails?: { __typename?: 'HealthCareDetails', id: string, hasIndividualHealthcareIdentifier?: boolean | null | undefined } | null | undefined }, quizResponses?: Array<{ __typename?: 'QuizResponse', id: string, question?: { __typename?: 'QuizResponseQuestion', id?: string | null | undefined, type?: QuizQuestionType | null | undefined, title?: string | null | undefined, shortcode?: string | null | undefined, options?: Array<{ __typename?: 'QuizResponseQuestionOption', value: string }> | null | undefined } | null | undefined, response?: { __typename?: 'QuizResponseResponse', answers?: Array<{ __typename?: 'QuizResponseResponseAnswer', value: string, imageUrl?: string | null | undefined }> | null | undefined, flag?: { __typename?: 'QuizResponseResponseFlag', level: QuizFlagLevel } | null | undefined } | null | undefined }> | null | undefined, doctorQuestions?: Array<{ __typename?: 'ConsultationQuestion', id: string, createdAt: string, updatedAt: string, value: string, allowedAnswerType: ConsultationAnswerType, answer?: { __typename?: 'ConsultationAnswer', id: string, createdAt: string, updatedAt: string, value: string } | null | undefined, attachments?: Array<{ __typename?: 'ConsultationQuestionAttachment', id: string, mimetype: string, signedUrl?: string | null | undefined, filename: string }> | null | undefined }> | null | undefined, doctor?: { __typename?: 'User', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, shortClinicianName: string, fullClinicianName: string, fullName?: string | null | undefined, role: UserRole, bio?: string | null | undefined, provider?: { __typename?: 'Provider', id: string, qualifications?: string | null | undefined, clinicianTitle: string, clinicianType: ClinicianType } | null | undefined, avatar?: { __typename?: 'File', id: string, createdAt: string, updatedAt: string, filename: string, mimetype: string, url: string } | null | undefined } | null | undefined, quizApplication?: { __typename?: 'QuizApplication', id: string, submittedAt?: string | null | undefined, answers: Array<{ __typename?: 'QuizApplicationResponse', id: string, answer?: string | null | undefined, answersArray: Array<string>, question?: { __typename?: 'QuizQuestion', id: string, shortcode?: string | null | undefined } | null | undefined }>, quiz: { __typename?: 'Quiz', id: string, questionsOrder: Array<string>, questions: Array<{ __typename?: 'QuizQuestion', id: string, title?: string | null | undefined, type: QuizQuestionType, description?: string | null | undefined, required: boolean, options?: any | null | undefined, imgUrl?: string | null | undefined, shortcode?: string | null | undefined, questionOptions: Array<{ __typename?: 'QuizQuestionOption', id: string, questionId: string, option?: string | null | undefined, position?: number | null | undefined }> }>, logics: Array<{ __typename?: 'QuizLogic', id: string, from: { __typename?: 'QuizQuestion', id: string }, elseJump: { __typename?: 'QuizQuestion', id: string }, jumps: Array<{ __typename?: 'QuizJump', id: string, conditions: Array<{ __typename?: 'QuizConditions', id: string, value: string, operator: QuizJumpOperator, nextCondition?: QuizValidationCondition | null | undefined, question: { __typename?: 'QuizQuestion', id: string } }>, to: { __typename?: 'QuizQuestion', id: string } }> }>, skips: Array<{ __typename?: 'QuizSkip', id: string, from: { __typename?: 'QuizQuestion', id: string }, conditions: Array<{ __typename?: 'QuizConditions', id: string, value: string, operator: QuizJumpOperator, nextCondition?: QuizValidationCondition | null | undefined, question: { __typename?: 'QuizQuestion', id: string } }> }> } } | null | undefined, order?: { __typename?: 'Order', id: string, paymentStatus?: OrderPaymentStatus | null | undefined, lineItems?: Array<{ __typename?: 'OrderLineItem', id: string, quantity: number, variant: { __typename?: 'Variant', id: string, price: number, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined, productType: ProductType, shortDescription?: string | null | undefined, photo?: { __typename?: 'File', id: string, url: string } | null | undefined } } }> | null | undefined } | null | undefined, pathologyRequests?: Array<{ __typename?: 'PathologyRequest', id: string, createdAt: string, customerStatedCollectedAt?: string | null | undefined, result?: { __typename?: 'PathologyResult', id: string, lab: string, releasedAt?: string | null | undefined, file?: { __typename?: 'PathologyResultFile', id: string, url: string } | null | undefined } | null | undefined, referral?: { __typename?: 'PathologyReferral', id: string, url: string, signedUrl: string } | null | undefined, panels?: Array<{ __typename?: 'PathologyPanel', id: string, tests?: Array<{ __typename?: 'PathologyPanelTest', id: string, name: PathologyPanelTestNameKey, result?: { __typename?: 'PathologyPanelTestResult', id?: string | null | undefined, note?: string | null | undefined, result: { __typename?: 'PathologyPanelTestResultValue', type: PathologyPanelTestResultValueType, value?: string | null | undefined } } | null | undefined }> | null | undefined }> | null | undefined } | null | undefined> | null | undefined, reminders?: Array<{ __typename?: 'ConsultationReminder', id: string, doneAt?: string | null | undefined, canceled: boolean, scheduledAt: string, createdAt: string }> | null | undefined, screeningQuizApplication?: { __typename?: 'QuizApplication', id: string } | null | undefined };

export type CustomerAttributesInfoFragment = { __typename?: 'CustomerAttributes', id: string, birthday?: string | null | undefined, age?: number | null | undefined, conditions?: string | null | undefined, medications?: string | null | undefined, allergies?: string | null | undefined, height?: number | null | undefined, weight?: number | null | undefined, bmi?: number | null | undefined, sex?: Sex | null | undefined, smoking?: Smoking | null | undefined, mentalHealthConditions?: string | null | undefined, diabetesRisk: { __typename?: 'CustomerDiabetesRiskAttributes', diabetesRiskLevel?: DiabetesRiskLevel | null | undefined, diabetesRiskProbability?: number | null | undefined }, menopause: { __typename?: 'CustomerMenopauseAttributes', menopauseSymptoms?: Array<MenopauseSymptoms | null | undefined> | null | undefined }, pregnancy: { __typename?: 'CustomerPregnancyAttributes', pregnant?: PregnancyStatus | null | undefined }, hair: { __typename?: 'CustomerHairAttributes', familyHistoryHairLoss?: boolean | null | undefined } };

export type DiscountCodeFormFragment = { __typename?: 'DiscountCode', id: string, code: string, amount: number, stages: Array<DiscountStage>, type: DiscountType, products: Array<{ __typename?: 'Product', id: string, variants: Array<{ __typename?: 'Variant', id: string }> }> };

export type ExperimentPaymentPlanFragment = { __typename?: 'ExperimentTreatmentPaymentPlan', id: string, paymentPlan: ExperimentPaymentPlanVariant, discountPercentage: number, months?: number | null | undefined, version?: number | null | undefined };

export type QuizApplicationAnswerFragment = { __typename?: 'QuizApplication', id: string, problemType: ProblemType, customerId: string, submittedAt?: string | null | undefined, answers: Array<{ __typename?: 'QuizApplicationResponse', id: string, answer?: string | null | undefined, answersArray: Array<string>, englishAnswer?: string | null | undefined, englishAnswersArray: Array<string>, question?: { __typename?: 'QuizQuestion', id: string, shortcode?: string | null | undefined } | null | undefined }>, consultation?: { __typename?: 'Consultation', id: string, status: ConsultationStatus, isUpfrontPayment: boolean } | null | undefined, responses?: Array<{ __typename?: 'QuizResponse', id: string, question?: { __typename?: 'QuizResponseQuestion', id?: string | null | undefined, type?: QuizQuestionType | null | undefined, title?: string | null | undefined, shortcode?: string | null | undefined, options?: Array<{ __typename?: 'QuizResponseQuestionOption', value: string }> | null | undefined } | null | undefined, response?: { __typename?: 'QuizResponseResponse', answers?: Array<{ __typename?: 'QuizResponseResponseAnswer', value: string, imageUrl?: string | null | undefined }> | null | undefined, flag?: { __typename?: 'QuizResponseResponseFlag', level: QuizFlagLevel } | null | undefined } | null | undefined }> | null | undefined };

export type TreatmentInfoFragment = { __typename?: 'Treatment', id: string, updatedAt: string, status: TreatmentStatus, type: ProblemType, canRefill: boolean, nextPayment?: string | null | undefined, refillsLeft?: number | null | undefined, hasUnfulfilledOrder: boolean, canPause: boolean, canReschedule: boolean, weightTreatmentCategory?: WeightTreatmentCategory | null | undefined, treatmentDiscount?: { __typename?: 'TreatmentDiscount', id: string, discountCode?: { __typename?: 'DiscountCode', id: string, code: string, amount: number, stages: Array<DiscountStage>, type: DiscountType, products: Array<{ __typename?: 'Product', id: string, variants: Array<{ __typename?: 'Variant', id: string }> }> } | null | undefined } | null | undefined, consultation?: { __typename?: 'Consultation', id: string, type: ProblemType, doctor?: { __typename?: 'User', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, fullClinicianName: string, fullName?: string | null | undefined } | null | undefined } | null | undefined, customer: { __typename?: 'User', id: string, email: string }, plan?: { __typename?: 'Plan', id: string, amount: number, products: Array<{ __typename?: 'Product', id: string, variants: Array<{ __typename?: 'Variant', id: string, inventory?: { __typename?: 'VariantInventory', id: string, sku?: string | null | undefined } | null | undefined }> }> } | null | undefined, product: { __typename?: 'Product', id: string, name: string, description?: string | null | undefined, safetyInformation?: string | null | undefined, friendlyName?: string | null | undefined, productType: ProductType, drug?: { __typename?: 'Drug', id: string, name?: string | null | undefined } | null | undefined, variants: Array<{ __typename?: 'Variant', id: string, price: number, inventory?: { __typename?: 'VariantInventory', id: string, sku?: string | null | undefined } | null | undefined }>, faqs: Array<{ __typename?: 'Faq', id: string, title?: string | null | undefined, markdown?: string | null | undefined }>, cmi?: { __typename?: 'File', id: string, url: string } | null | undefined, photo?: { __typename?: 'File', id: string, url: string } | null | undefined }, script?: { __typename?: 'Script', id: string, createdAt: string } | null | undefined, orders: Array<{ __typename?: 'Order', id: string, fulfillment?: FulfillmentStatus | null | undefined, updatedAt: string }>, otcSchedules: Array<{ __typename?: 'OtcSchedule', id: string, createdAt: string, updatedAt: string, cadence: OtcScheduleCadence, isActive: boolean, quantity: number, product: { __typename?: 'Product', id: string, name: string, productType: ProductType, variants: Array<{ __typename?: 'Variant', id: string, price: number }>, photo?: { __typename?: 'File', id: string, url: string } | null | undefined } }>, experimentPaymentPlan?: { __typename?: 'ExperimentTreatmentPaymentPlan', id: string, nextPaymentAmount: number, planEndDate?: string | null | undefined, paymentPlan: ExperimentPaymentPlanVariant, discountPercentage: number, months?: number | null | undefined, otcSchedules?: Array<{ __typename?: 'OtcSchedule', id: string, product: { __typename?: 'Product', id: string, name: string } }> | null | undefined } | null | undefined, experimentAvailablePaymentPlans: Array<{ __typename?: 'ExperimentAvailablePaymentPlan', paymentPlan: ExperimentPaymentPlanVariant, cadence: string }> };

export type UserInfoFragment = { __typename?: 'User', id: string, email: string, firstName?: string | null | undefined, lastName?: string | null | undefined, shortAddressableName?: string | null | undefined, fullName?: string | null | undefined, phone?: string | null | undefined, role: UserRole, isPasswordSet: boolean, defaultPaymentGateway?: PaymentGateway | null | undefined, birthday?: string | null | undefined, preferredUnitSystem?: UnitSystem | null | undefined, residentialAddress?: { __typename?: 'ResidentialAddress', id: string, line1: string, line2?: string | null | undefined, city: string, postalCode: string, state?: string | null | undefined, country: string, company?: string | null | undefined, building?: string | null | undefined } | null | undefined, address?: { __typename?: 'Address', id: string, line1?: string | null | undefined, line2?: string | null | undefined, city?: string | null | undefined, postalCode?: string | null | undefined, state?: string | null | undefined, country?: string | null | undefined, company?: string | null | undefined, building?: string | null | undefined } | null | undefined, savedPaymentMethods?: Array<{ __typename?: 'SavedCardPaymentMethod', brand: string, expiry: string, mask: string, id: string, gateway: PaymentGateway, default: boolean } | { __typename?: 'SavedPayPalPaymentMethod', email?: string | null | undefined, id: string, gateway: PaymentGateway, default: boolean } | { __typename?: 'SavedSofortPaymentMethod', id: string, gateway: PaymentGateway, default: boolean } | { __typename?: 'SavedZipPaymentMethod', valid: boolean, id: string, gateway: PaymentGateway, default: boolean } | null | undefined> | null | undefined, zip?: { __typename?: 'Zip', valid: boolean } | null | undefined };

export type AddPatientQuestionToConsultationMutationVariables = Exact<{
  consultationId: Scalars['String']['input'];
  question: Scalars['String']['input'];
  trigger: Scalars['String']['input'];
}>;


export type AddPatientQuestionToConsultationMutation = { __typename?: 'Mutation', addPatientQuestionToConsultation?: { __typename?: 'Consultation', id: string, status: ConsultationStatus } | null | undefined };

export type CancelExperimentPaymentPlanMutationVariables = Exact<{
  treatmentId: Scalars['String']['input'];
}>;


export type CancelExperimentPaymentPlanMutation = { __typename?: 'Mutation', cancelExperimentPaymentPlan: { __typename?: 'Treatment', id: string, experimentPaymentPlan?: { __typename?: 'ExperimentTreatmentPaymentPlan', id: string, paymentPlan: ExperimentPaymentPlanVariant, discountPercentage: number, months?: number | null | undefined, version?: number | null | undefined } | null | undefined } };

export type ChangeExperimentPaymentPlanMutationVariables = Exact<{
  treatmentId: Scalars['String']['input'];
  paymentPlan: ExperimentPaymentPlanVariant;
  version?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ChangeExperimentPaymentPlanMutation = { __typename?: 'Mutation', changeExperimentPaymentPlan: { __typename?: 'Treatment', id: string, experimentPaymentPlan?: { __typename?: 'ExperimentTreatmentPaymentPlan', id: string, paymentPlan: ExperimentPaymentPlanVariant, discountPercentage: number, months?: number | null | undefined, version?: number | null | undefined } | null | undefined } };

export type ReopenApplicationMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ReopenApplicationMutation = { __typename?: 'Mutation', reopenApplication?: { __typename?: 'QuizApplication', id: string } | null | undefined };

export type RequestReviewTreatmentSupportMutationVariables = Exact<{
  body: Scalars['String']['input'];
  category: TreatmentReviewCategory;
  subject: Scalars['String']['input'];
  treatmentId: Scalars['String']['input'];
  quizApplicationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type RequestReviewTreatmentSupportMutation = { __typename?: 'Mutation', requestReviewTreatmentSupport?: { __typename?: 'Treatment', id: string } | null | undefined };

export type UseUpdateProfileAttrsMutationVariables = Exact<{
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  birthday?: InputMaybe<Scalars['String']['input']>;
}>;


export type UseUpdateProfileAttrsMutation = { __typename?: 'Mutation', updateProfile?: { __typename?: 'User', id: string, email: string, firstName?: string | null | undefined, lastName?: string | null | undefined, shortAddressableName?: string | null | undefined, fullName?: string | null | undefined, phone?: string | null | undefined, role: UserRole, isPasswordSet: boolean, defaultPaymentGateway?: PaymentGateway | null | undefined, birthday?: string | null | undefined, preferredUnitSystem?: UnitSystem | null | undefined, residentialAddress?: { __typename?: 'ResidentialAddress', id: string, line1: string, line2?: string | null | undefined, city: string, postalCode: string, state?: string | null | undefined, country: string, company?: string | null | undefined, building?: string | null | undefined } | null | undefined, address?: { __typename?: 'Address', id: string, line1?: string | null | undefined, line2?: string | null | undefined, city?: string | null | undefined, postalCode?: string | null | undefined, state?: string | null | undefined, country?: string | null | undefined, company?: string | null | undefined, building?: string | null | undefined } | null | undefined, savedPaymentMethods?: Array<{ __typename?: 'SavedCardPaymentMethod', brand: string, expiry: string, mask: string, id: string, gateway: PaymentGateway, default: boolean } | { __typename?: 'SavedPayPalPaymentMethod', email?: string | null | undefined, id: string, gateway: PaymentGateway, default: boolean } | { __typename?: 'SavedSofortPaymentMethod', id: string, gateway: PaymentGateway, default: boolean } | { __typename?: 'SavedZipPaymentMethod', valid: boolean, id: string, gateway: PaymentGateway, default: boolean } | null | undefined> | null | undefined, zip?: { __typename?: 'Zip', valid: boolean } | null | undefined } | null | undefined };

export type ConsultationPricingQueryVariables = Exact<{
  id: Scalars['String']['input'];
  discountCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type ConsultationPricingQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, type: ProblemType, stage: ConsultationStage, price?: { __typename?: 'ConsultationPrice', amountOff: number, fullPrice: number, total: number } | null | undefined } | null | undefined };

export type InSegmentQueryVariables = Exact<{
  segmentName: Segment;
}>;


export type InSegmentQuery = { __typename?: 'Query', inSegment?: boolean | null | undefined };

export type ProfileAndHealthcareQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfileAndHealthcareQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, legalFirstName?: string | null | undefined, legalLastName?: string | null | undefined, birthday?: string | null | undefined, residentialAddress?: { __typename?: 'ResidentialAddress', id: string } | null | undefined, medicalProfile: { __typename?: 'MedicalProfile', id: string, sex?: Sex | null | undefined }, healthCareDetails?: { __typename?: 'HealthCareDetails', id: string, hasMedicareDetails?: boolean | null | undefined, hasIndividualHealthcareIdentifier?: boolean | null | undefined } | null | undefined } | null | undefined };

export type UseProfileAndResidentialAddressQueryVariables = Exact<{ [key: string]: never; }>;


export type UseProfileAndResidentialAddressQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, birthday?: string | null | undefined, residentialAddress?: { __typename?: 'ResidentialAddress', id: string, line1: string, line2?: string | null | undefined, city: string, postalCode: string, state?: string | null | undefined, country: string } | null | undefined } | null | undefined };

export type ProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfileQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, residentialAddress?: { __typename?: 'ResidentialAddress', id: string, line1: string, line2?: string | null | undefined, city: string, postalCode: string, state?: string | null | undefined, country: string } | null | undefined, address?: { __typename?: 'Address', id: string, line1?: string | null | undefined, line2?: string | null | undefined, city?: string | null | undefined, postalCode?: string | null | undefined, state?: string | null | undefined, country?: string | null | undefined } | null | undefined } | null | undefined };

export type IsShippingAddressWithinRangeQueryVariables = Exact<{
  line1: Scalars['String']['input'];
  line2: Scalars['String']['input'];
  postcode: Scalars['String']['input'];
  suburb: Scalars['String']['input'];
}>;


export type IsShippingAddressWithinRangeQuery = { __typename?: 'Query', shippingAddressWithinRange?: boolean | null | undefined };

export type UseMembershipQueryVariables = Exact<{ [key: string]: never; }>;


export type UseMembershipQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, memberships: Array<{ __typename?: 'Membership', id: string, type: ProblemType, createdAt: string, membershipTerms: Array<{ __typename?: 'MembershipTerm', id: string, interval: MembershipInterval, intervalCount: number, subscriptionStatus: MembershipSubscriptionStatus, status: MembershipStatus, startDate?: string | null | undefined, endDate?: string | null | undefined, isValid: boolean }> }> } | null | undefined };

export type ConfirmOrderMutationVariables = Exact<{
  consultationId: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<AddressCreateWithoutUserInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  gateway?: InputMaybe<PaymentGateway>;
  zipCheckoutId?: InputMaybe<Scalars['String']['input']>;
  couponCode?: InputMaybe<Scalars['String']['input']>;
  stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ConfirmOrderMutation = { __typename?: 'Mutation', confirmOrder?: { __typename?: 'Order', id: string } | null | undefined };

export type RefreshUserPaymentDataProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type RefreshUserPaymentDataProfileQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, zip?: { __typename?: 'Zip', valid: boolean } | null | undefined, savedPaymentMethods?: Array<{ __typename?: 'SavedCardPaymentMethod', brand: string, mask: string, expiry: string, id: string, createdAt?: string | null | undefined, default: boolean, gateway: PaymentGateway } | { __typename?: 'SavedPayPalPaymentMethod', email?: string | null | undefined, id: string, createdAt?: string | null | undefined, default: boolean, gateway: PaymentGateway } | { __typename?: 'SavedSofortPaymentMethod', id: string, createdAt?: string | null | undefined, default: boolean, gateway: PaymentGateway } | { __typename?: 'SavedZipPaymentMethod', valid: boolean, id: string, createdAt?: string | null | undefined, default: boolean, gateway: PaymentGateway } | null | undefined> | null | undefined } | null | undefined };

export type RemoveZipMutationVariables = Exact<{ [key: string]: never; }>;


export type RemoveZipMutation = { __typename?: 'Mutation', removeZip?: boolean | null | undefined };

export type UpdateDefaultPaymentGatewayMutationVariables = Exact<{
  gateway: PaymentGateway;
}>;


export type UpdateDefaultPaymentGatewayMutation = { __typename?: 'Mutation', updateDefaultPaymentGateway?: boolean | null | undefined };

export type UpdatePaymentMutationVariables = Exact<{
  stripeTokenId?: InputMaybe<Scalars['String']['input']>;
  stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdatePaymentMutation = { __typename?: 'Mutation', updatePayment?: { __typename?: 'User', id: string, savedPaymentMethods?: Array<{ __typename?: 'SavedCardPaymentMethod', brand: string, expiry: string, mask: string, id: string, gateway: PaymentGateway, default: boolean } | { __typename?: 'SavedPayPalPaymentMethod', id: string, gateway: PaymentGateway, default: boolean } | { __typename?: 'SavedSofortPaymentMethod', id: string, gateway: PaymentGateway, default: boolean } | { __typename?: 'SavedZipPaymentMethod', id: string, gateway: PaymentGateway, default: boolean } | null | undefined> | null | undefined } | null | undefined };

export type InitiateZipCheckoutMutationVariables = Exact<{
  redirectUrl: Scalars['String']['input'];
  address: AddressCreateWithoutUserInput;
  orderId: Scalars['String']['input'];
  couponCode?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
}>;


export type InitiateZipCheckoutMutation = { __typename?: 'Mutation', initiateZipCheckout?: { __typename?: 'ZipCheckoutResponse', redirectUrl: string } | null | undefined };

export type UsePathologyLocationsProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type UsePathologyLocationsProfileQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, residentialAddress?: { __typename?: 'ResidentialAddress', id: string, postalCode: string } | null | undefined, address?: { __typename?: 'Address', id: string, postalCode?: string | null | undefined } | null | undefined } | null | undefined };

export type PathologyLocationsQueryVariables = Exact<{
  postcode: Scalars['String']['input'];
}>;


export type PathologyLocationsQuery = { __typename?: 'Query', pathologyLocations: Array<{ __typename?: 'PathologyLocation', display?: string | null | undefined, url?: string | null | undefined }> };

export type UpdatePathologyCustomerStatedCollectedAtMutationVariables = Exact<{
  collectedAt: Scalars['String']['input'];
  pathologyRequestId: Scalars['String']['input'];
}>;


export type UpdatePathologyCustomerStatedCollectedAtMutation = { __typename?: 'Mutation', updatePathologyCustomerStatedCollectedAt?: { __typename?: 'PathologyRequest', id: string, customerStatedCollectedAt?: string | null | undefined } | null | undefined };

export type UpsertOtcProductToTreatmentMutationVariables = Exact<{
  id: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  cadence: OtcScheduleCadence;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpsertOtcProductToTreatmentMutation = { __typename?: 'Mutation', upsertOtcProductToTreatment?: { __typename?: 'Treatment', id: string, otcSchedules: Array<{ __typename?: 'OtcSchedule', id: string, createdAt: string, updatedAt: string, cadence: OtcScheduleCadence, isActive: boolean, quantity: number, product: { __typename?: 'Product', id: string, name: string, variants: Array<{ __typename?: 'Variant', id: string, price: number }>, photo?: { __typename?: 'File', id: string, url: string } | null | undefined } }> } | null | undefined };

export type RemoveOtcProductFromTreatmentMutationVariables = Exact<{
  id: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
}>;


export type RemoveOtcProductFromTreatmentMutation = { __typename?: 'Mutation', removeOtcProductFromTreatment?: { __typename?: 'Treatment', id: string, otcSchedules: Array<{ __typename?: 'OtcSchedule', id: string, isActive: boolean }> } | null | undefined };

export type UpdateLineItemMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  variantId: Scalars['String']['input'];
}>;


export type UpdateLineItemMutation = { __typename?: 'Mutation', updateLineItem?: { __typename?: 'Order', id: string } | null | undefined };

export type ProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductsQuery = { __typename?: 'Query', products: Array<{ __typename?: 'Product', id: string, name: string, description?: string | null | undefined, priority: number, productType: ProductType, problemTypes: Array<ProblemType>, photo?: { __typename?: 'File', id: string, url: string } | null | undefined, variants: Array<{ __typename?: 'Variant', id: string, price: number, public: boolean, inventory?: { __typename?: 'VariantInventory', id: string, sku?: string | null | undefined } | null | undefined }> }> };

export type NutritionSupportProductsQueryVariables = Exact<{
  productSKU?: InputMaybe<Scalars['String']['input']>;
}>;


export type NutritionSupportProductsQuery = { __typename?: 'Query', products: Array<{ __typename?: 'Product', id: string, name: string, description?: string | null | undefined, priority: number, productType: ProductType, problemTypes: Array<ProblemType>, photo?: { __typename?: 'File', id: string, url: string } | null | undefined, variants: Array<{ __typename?: 'Variant', id: string, price: number, public: boolean, inventory?: { __typename?: 'VariantInventory', id: string, sku?: string | null | undefined } | null | undefined }> }> };

export type NutritionSupportTreatmentFragment = { __typename?: 'Treatment', id: string, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined, variants: Array<{ __typename?: 'Variant', id: string, inventory?: { __typename?: 'VariantInventory', id: string, sku?: string | null | undefined } | null | undefined }> }, specialisedNutritionSupportSchedule: Array<{ __typename?: 'OtcSchedule', id: string, product: { __typename?: 'Product', id: string, name: string, variants: Array<{ __typename?: 'Variant', id: string, name: string, price: number }> } }> };

export type SpecialisedNutritionSupportQueryVariables = Exact<{
  treatmentId: Scalars['String']['input'];
  productSKU?: InputMaybe<Scalars['String']['input']>;
}>;


export type SpecialisedNutritionSupportQuery = { __typename?: 'Query', treatment?: { __typename?: 'Treatment', id: string, product: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined, variants: Array<{ __typename?: 'Variant', id: string, inventory?: { __typename?: 'VariantInventory', id: string, sku?: string | null | undefined } | null | undefined }> }, specialisedNutritionSupportSchedule: Array<{ __typename?: 'OtcSchedule', id: string, product: { __typename?: 'Product', id: string, name: string, variants: Array<{ __typename?: 'Variant', id: string, name: string, price: number }> } }> } | null | undefined };

export type TrackApplicationStopMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type TrackApplicationStopMutation = { __typename?: 'Mutation', trackApplicationStop?: { __typename?: 'QuizApplication', id: string } | null | undefined };

export type AddUserToSegmentMutationVariables = Exact<{
  segmentName: Segment;
  activeFrom?: InputMaybe<Scalars['String']['input']>;
  activeTo?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddUserToSegmentMutation = { __typename?: 'Mutation', addUserToSegment?: Segment | null | undefined };

export type CreateOrRetrieveStripeSetupIntentMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateOrRetrieveStripeSetupIntentMutation = { __typename?: 'Mutation', createOrRetrieveStripeSetupIntent?: { __typename?: 'StripeSetupIntent', id: string, clientSecret: string } | null | undefined };

export type StripePublicKeyQueryVariables = Exact<{ [key: string]: never; }>;


export type StripePublicKeyQuery = { __typename?: 'Query', stripeAccount?: { __typename?: 'StripeAccount', publicKey?: string | null | undefined } | null | undefined };

export type CancelOtcSubMutationVariables = Exact<{
  type: ProblemType;
  cancelReason?: InputMaybe<Scalars['String']['input']>;
  cancelOtherReason?: InputMaybe<Scalars['String']['input']>;
}>;


export type CancelOtcSubMutation = { __typename?: 'Mutation', cancelSubscription?: { __typename?: 'Membership', id: string } | null | undefined };

export type ReactivateMembershipMutationVariables = Exact<{
  type: ProblemType;
}>;


export type ReactivateMembershipMutation = { __typename?: 'Mutation', reactivateMembership?: { __typename?: 'Membership', id: string } | null | undefined };

export type ReactivateOtcSubMutationVariables = Exact<{
  type: ProblemType;
}>;


export type ReactivateOtcSubMutation = { __typename?: 'Mutation', reactivateSubscription?: { __typename?: 'Membership', id: string } | null | undefined };

export type CancelSubscriptionPlanMutationVariables = Exact<{
  subscriptionId: Scalars['String']['input'];
}>;


export type CancelSubscriptionPlanMutation = { __typename?: 'Mutation', cancelSubscriptionPlan?: { __typename?: 'SubscriptionPlan', id: string, active: boolean, amount?: number | null | undefined, cancelAt?: string | null | undefined, cancelAtPeriodEnd: boolean, currentPeriodEnd: string, currentPeriodStart: string, daysUntilDue?: number | null | undefined, interval: string, intervalCount: number, sku?: string | null | undefined, startDate?: string | null | undefined, status: string, product?: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined, photo?: { __typename?: 'File', id: string, url: string } | null | undefined } | null | undefined } | null | undefined };

export type OtcSubscriptionPlanInfoFragment = { __typename?: 'SubscriptionPlan', id: string, active: boolean, amount?: number | null | undefined, cancelAt?: string | null | undefined, cancelAtPeriodEnd: boolean, currentPeriodEnd: string, currentPeriodStart: string, daysUntilDue?: number | null | undefined, interval: string, intervalCount: number, sku?: string | null | undefined, startDate?: string | null | undefined, status: string, product?: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined, photo?: { __typename?: 'File', id: string, url: string } | null | undefined } | null | undefined };

export type OtcSubscriptionPlanQueryVariables = Exact<{ [key: string]: never; }>;


export type OtcSubscriptionPlanQuery = { __typename?: 'Query', subscriptionPlans: Array<{ __typename?: 'SubscriptionPlan', id: string, active: boolean, amount?: number | null | undefined, cancelAt?: string | null | undefined, cancelAtPeriodEnd: boolean, currentPeriodEnd: string, currentPeriodStart: string, daysUntilDue?: number | null | undefined, interval: string, intervalCount: number, sku?: string | null | undefined, startDate?: string | null | undefined, status: string, product?: { __typename?: 'Product', id: string, name: string, friendlyName?: string | null | undefined, photo?: { __typename?: 'File', id: string, url: string } | null | undefined } | null | undefined }> };

export type OtcSubscriptionPlanV2InfoFragment = { __typename?: 'SubscriptionPlanV2', id: string, name: string, description: string, interval: SubscriptionPlanInterval, intervalCount: number, price: number, photo: { __typename?: 'File', id: string, url: string } };

export type CancelSubscriptionV2MutationVariables = Exact<{
  subscriptionId: Scalars['String']['input'];
}>;


export type CancelSubscriptionV2Mutation = { __typename?: 'Mutation', cancelSubscriptionV2?: { __typename?: 'SubscriptionV2', id: string } | null | undefined };

export type MigrateSubscriptionsMutationVariables = Exact<{ [key: string]: never; }>;


export type MigrateSubscriptionsMutation = { __typename?: 'Mutation', migrateCustomerSubscriptions?: Array<{ __typename?: 'SubscriptionV2', id: string } | null | undefined> | null | undefined };

export type UseProfileSubscriptionsV2QueryVariables = Exact<{ [key: string]: never; }>;


export type UseProfileSubscriptionsV2Query = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, needsSubscriptionMigration?: boolean | null | undefined, subscriptions?: Array<{ __typename?: 'SubscriptionV2', id: string, status: SubscriptionStatus, nextPaymentAt?: string | null | undefined, subscriptionOrders?: Array<{ __typename?: 'SubscriptionOrder', id: string, status: SubscriptionOrderStatus, createdAt: string }> | null | undefined, subscriptionPlan: { __typename?: 'SubscriptionPlanV2', id: string, name: string, description: string, interval: SubscriptionPlanInterval, intervalCount: number, price: number, photo: { __typename?: 'File', id: string, url: string } } }> | null | undefined } | null | undefined };

export type ReactivateSubscriptionV2MutationVariables = Exact<{
  subscriptionId: Scalars['String']['input'];
}>;


export type ReactivateSubscriptionV2Mutation = { __typename?: 'Mutation', reactivateSubscriptionV2?: { __typename?: 'SubscriptionV2', id: string, subscriptionOrders?: Array<{ __typename?: 'SubscriptionOrder', id: string, createdAt: string, order: { __typename?: 'Order', id: string, lineItems?: Array<{ __typename?: 'OrderLineItem', id: string, variant: { __typename?: 'Variant', id: string, price: number } }> | null | undefined } }> | null | undefined } | null | undefined };

export type RefillSubscriptionV2MutationVariables = Exact<{
  subscriptionId: Scalars['String']['input'];
}>;


export type RefillSubscriptionV2Mutation = { __typename?: 'Mutation', refillSubscriptionV2?: { __typename?: 'SubscriptionV2', id: string } | null | undefined };

export type SubscribePlanV2MutationVariables = Exact<{
  subscriptionPlanId: Scalars['String']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
}>;


export type SubscribePlanV2Mutation = { __typename?: 'Mutation', subscribePlanV2?: { __typename?: 'SubscriptionV2', id: string, subscriptionOrders?: Array<{ __typename?: 'SubscriptionOrder', id: string, order: { __typename?: 'Order', id: string, lineItems?: Array<{ __typename?: 'OrderLineItem', id: string, variant: { __typename?: 'Variant', id: string, price: number } }> | null | undefined } }> | null | undefined } | null | undefined };

export type OtcSubscriptionPlanV2ByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type OtcSubscriptionPlanV2ByIdQuery = { __typename?: 'Query', subscriptionPlanV2ById?: { __typename?: 'SubscriptionPlanV2', id: string, name: string, description: string, interval: SubscriptionPlanInterval, intervalCount: number, price: number, photo: { __typename?: 'File', id: string, url: string } } | null | undefined };

export type OtcSubscriptionV2QueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type OtcSubscriptionV2Query = { __typename?: 'Query', subscriptionV2: { __typename?: 'SubscriptionV2', id: string, createdAt: string, updatedAt: string, nextPaymentAt?: string | null | undefined, status: SubscriptionStatus, subscriptionPlan: { __typename?: 'SubscriptionPlanV2', id: string, name: string, description: string, interval: SubscriptionPlanInterval, intervalCount: number, price: number, photo: { __typename?: 'File', id: string, url: string } } } };

export type AddTreatmentDiscountMutationVariables = Exact<{
  treatmentId: Scalars['String']['input'];
  discountCode: Scalars['String']['input'];
}>;


export type AddTreatmentDiscountMutation = { __typename?: 'Mutation', addTreatmentDiscount?: { __typename?: 'Treatment', id: string, treatmentDiscount?: { __typename?: 'TreatmentDiscount', id: string, discountCode?: { __typename?: 'DiscountCode', id: string, code: string, amount: number, stages: Array<DiscountStage>, type: DiscountType, products: Array<{ __typename?: 'Product', id: string, variants: Array<{ __typename?: 'Variant', id: string }> }> } | null | undefined } | null | undefined } | null | undefined };

export type UseDelayTreatmentMutationVariables = Exact<{
  id: Scalars['String']['input'];
  newDate: Scalars['String']['input'];
  trigger?: InputMaybe<Scalars['String']['input']>;
}>;


export type UseDelayTreatmentMutation = { __typename?: 'Mutation', delayTreatment?: { __typename?: 'Treatment', id: string, nextPayment?: string | null | undefined, status: TreatmentStatus } | null | undefined };

export type PauseUserTreatmentMutationVariables = Exact<{
  id: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  isReview?: InputMaybe<Scalars['Boolean']['input']>;
  reasonExtended?: InputMaybe<Scalars['String']['input']>;
}>;


export type PauseUserTreatmentMutation = { __typename?: 'Mutation', pauseTreatment?: { __typename?: 'Treatment', id: string, status: TreatmentStatus } | null | undefined };

export type RefillTreatmentMutationVariables = Exact<{
  treatmentId: Scalars['String']['input'];
}>;


export type RefillTreatmentMutation = { __typename?: 'Mutation', refillTreatment?: { __typename?: 'Treatment', id: string, status: TreatmentStatus, canRefill: boolean, nextPayment?: string | null | undefined, experimentPaymentPlan?: { __typename?: 'ExperimentTreatmentPaymentPlan', id: string, nextPaymentAmount: number, planEndDate?: string | null | undefined } | null | undefined } | null | undefined };

export type RemoveTreatmentDiscountMutationVariables = Exact<{
  treatmentId: Scalars['String']['input'];
}>;


export type RemoveTreatmentDiscountMutation = { __typename?: 'Mutation', removeTreatmentDiscount?: { __typename?: 'Treatment', id: string, treatmentDiscount?: { __typename?: 'TreatmentDiscount', id: string, discountCode?: { __typename?: 'DiscountCode', id: string, code: string, amount: number, stages: Array<DiscountStage>, type: DiscountType, products: Array<{ __typename?: 'Product', id: string, variants: Array<{ __typename?: 'Variant', id: string }> }> } | null | undefined } | null | undefined } | null | undefined };

export type RequestReviewTreatmentMutationVariables = Exact<{
  input: RequestReviewTreatmentInput;
}>;


export type RequestReviewTreatmentMutation = { __typename?: 'Mutation', requestReviewTreatment?: { __typename?: 'Consultation', id: string, status: ConsultationStatus } | null | undefined };

export type SubmitPatientPharmacistQuestionMutationVariables = Exact<{
  treatmentId: Scalars['String']['input'];
  messageText: Scalars['String']['input'];
  contactMethod?: InputMaybe<ContactMethod>;
}>;


export type SubmitPatientPharmacistQuestionMutation = { __typename?: 'Mutation', submitPatientPharmacistQuestion?: boolean | null | undefined };

export type UseTreatmentQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type UseTreatmentQuery = { __typename?: 'Query', treatment?: { __typename?: 'Treatment', id: string, updatedAt: string, status: TreatmentStatus, type: ProblemType, canRefill: boolean, nextPayment?: string | null | undefined, refillsLeft?: number | null | undefined, hasUnfulfilledOrder: boolean, canPause: boolean, canReschedule: boolean, weightTreatmentCategory?: WeightTreatmentCategory | null | undefined, treatmentDiscount?: { __typename?: 'TreatmentDiscount', id: string, discountCode?: { __typename?: 'DiscountCode', id: string, code: string, amount: number, stages: Array<DiscountStage>, type: DiscountType, products: Array<{ __typename?: 'Product', id: string, variants: Array<{ __typename?: 'Variant', id: string }> }> } | null | undefined } | null | undefined, consultation?: { __typename?: 'Consultation', id: string, type: ProblemType, doctor?: { __typename?: 'User', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, fullClinicianName: string, fullName?: string | null | undefined } | null | undefined } | null | undefined, customer: { __typename?: 'User', id: string, email: string }, plan?: { __typename?: 'Plan', id: string, amount: number, products: Array<{ __typename?: 'Product', id: string, variants: Array<{ __typename?: 'Variant', id: string, inventory?: { __typename?: 'VariantInventory', id: string, sku?: string | null | undefined } | null | undefined }> }> } | null | undefined, product: { __typename?: 'Product', id: string, name: string, description?: string | null | undefined, safetyInformation?: string | null | undefined, friendlyName?: string | null | undefined, productType: ProductType, drug?: { __typename?: 'Drug', id: string, name?: string | null | undefined } | null | undefined, variants: Array<{ __typename?: 'Variant', id: string, price: number, inventory?: { __typename?: 'VariantInventory', id: string, sku?: string | null | undefined } | null | undefined }>, faqs: Array<{ __typename?: 'Faq', id: string, title?: string | null | undefined, markdown?: string | null | undefined }>, cmi?: { __typename?: 'File', id: string, url: string } | null | undefined, photo?: { __typename?: 'File', id: string, url: string } | null | undefined }, script?: { __typename?: 'Script', id: string, createdAt: string } | null | undefined, orders: Array<{ __typename?: 'Order', id: string, fulfillment?: FulfillmentStatus | null | undefined, updatedAt: string }>, otcSchedules: Array<{ __typename?: 'OtcSchedule', id: string, createdAt: string, updatedAt: string, cadence: OtcScheduleCadence, isActive: boolean, quantity: number, product: { __typename?: 'Product', id: string, name: string, productType: ProductType, variants: Array<{ __typename?: 'Variant', id: string, price: number }>, photo?: { __typename?: 'File', id: string, url: string } | null | undefined } }>, experimentPaymentPlan?: { __typename?: 'ExperimentTreatmentPaymentPlan', id: string, nextPaymentAmount: number, planEndDate?: string | null | undefined, paymentPlan: ExperimentPaymentPlanVariant, discountPercentage: number, months?: number | null | undefined, otcSchedules?: Array<{ __typename?: 'OtcSchedule', id: string, product: { __typename?: 'Product', id: string, name: string } }> | null | undefined } | null | undefined, experimentAvailablePaymentPlans: Array<{ __typename?: 'ExperimentAvailablePaymentPlan', paymentPlan: ExperimentPaymentPlanVariant, cadence: string }> } | null | undefined };

export type UseTreatmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type UseTreatmentsQuery = { __typename?: 'Query', treatments?: Array<{ __typename?: 'Treatment', id: string, type: ProblemType, active: boolean, status: TreatmentStatus, refillsLeft?: number | null | undefined, hasUnfulfilledOrder: boolean, nextScheduledDate?: string | null | undefined, nextPayment?: string | null | undefined, consultation?: { __typename?: 'Consultation', id: string, status: ConsultationStatus, isApproved?: boolean | null | undefined, stage: ConsultationStage, quizApplication?: { __typename?: 'QuizApplication', id: string } | null | undefined, doctor?: { __typename?: 'User', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, shortClinicianName: string, fullClinicianName: string, fullName?: string | null | undefined, provider?: { __typename?: 'Provider', id: string, clinicianType: ClinicianType, clinicianTitle: string } | null | undefined } | null | undefined } | null | undefined, otcSchedules: Array<{ __typename?: 'OtcSchedule', id: string, createdAt: string, updatedAt: string, cadence: OtcScheduleCadence, isActive: boolean, quantity: number, product: { __typename?: 'Product', id: string, name: string, variants: Array<{ __typename?: 'Variant', id: string, price: number }> } }>, followupConsultations: Array<{ __typename?: 'Consultation', id: string, status: ConsultationStatus, stage: ConsultationStage, isApproved?: boolean | null | undefined, doctor?: { __typename?: 'User', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, shortClinicianName: string, fullClinicianName: string, fullName?: string | null | undefined } | null | undefined }>, product: { __typename?: 'Product', id: string, name: string }, script?: { __typename?: 'Script', id: string, createdAt: string } | null | undefined }> | null | undefined };

export type SubscriptionCardListFragment = { __typename?: 'SubscriptionV2', id: string, status: SubscriptionStatus, nextPaymentAt?: string | null | undefined, subscriptionPlan: { __typename?: 'SubscriptionPlanV2', id: string, name: string, interval: SubscriptionPlanInterval, intervalCount: number, price: number, photo: { __typename?: 'File', id: string, url: string } } };

export type TrackerQueryVariables = Exact<{ [key: string]: never; }>;


export type TrackerQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id: string, isBeingTreated?: boolean | null | undefined } | null | undefined, tracker: { __typename?: 'TrackerField', id: string, weightLoss: { __typename?: 'WeightLossTracker', id: string, lastCheckIn?: string | null | undefined, momentum?: number | null | undefined, waist?: Array<{ __typename?: 'ObservedMeasurement', id: string, value: number, effectiveFrom: string }> | null | undefined, weight?: Array<{ __typename?: 'ObservedMeasurement', id: string, value: number, effectiveFrom: string }> | null | undefined } } };

export type TreatmentRefillJuniperMutationVariables = Exact<{
  treatmentId: Scalars['String']['input'];
}>;


export type TreatmentRefillJuniperMutation = { __typename?: 'Mutation', refillTreatment?: { __typename?: 'Treatment', id: string, status: TreatmentStatus, canRefill: boolean, nextPayment?: string | null | undefined, refillsLeft?: number | null | undefined } | null | undefined };

export type UseFlexiEnabledQueryVariables = Exact<{
  consultationId: Scalars['String']['input'];
}>;


export type UseFlexiEnabledQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', id: string, type: ProblemType, stage: ConsultationStage } | null | undefined };

export type WeightInAppOnboardingChecklistQueryVariables = Exact<{ [key: string]: never; }>;


export type WeightInAppOnboardingChecklistQuery = { __typename?: 'Query', weightFacebookCommunityJoined?: boolean | null | undefined };

export const AnytimePurchaseOfferingSelectionFragmentDoc = gql`
    fragment AnytimePurchaseOfferingSelection on OfferingSelection {
  id
  offering {
    id
    friendlyName
    sequenceSets {
      id
      sequences {
        id
        friendlyName
      }
    }
  }
  sequenceSelections {
    id
    sequence {
      id
      friendlyName
    }
    sequenceSet {
      id
    }
  }
}
    `;
export const CompoundProfilePageUserSegmentsFragmentDoc = gql`
    fragment CompoundProfilePageUserSegments on Query {
  completedMobileOnboardingScreens: inSegment(
    segmentName: COMPLETED_MOBILE_ONBOARDING_SCREENS
  )
}
    `;
export const UseProfileCardsConsultationFragmentDoc = gql`
    fragment UseProfileCardsConsultation on Consultation {
  id
  type
  stage
  createdAt
  isApproved
  purchasePrompt {
    id
  }
  typeIsFlexi
  quizApplication {
    id
    problemType
  }
  status
  treatment {
    id
    status
  }
  practitionerMessagedAt
}
    `;
export const CompoundTreatmentStatusCardTreatmentFragmentDoc = gql`
    fragment CompoundTreatmentStatusCardTreatment on Treatment {
  id
  refillsLeft
  nextPayment
  product {
    id
    name
    friendlyName
  }
  otcSchedules {
    id
    cadence
    quantity
    product {
      id
      name
      friendlyName
    }
    isActive
  }
}
    `;
export const TreatmentDetailsTreatmentFragmentDoc = gql`
    fragment TreatmentDetailsTreatment on Treatment {
  id
  refillsLeft
  nextPayment
  product {
    id
    name
    friendlyName
  }
  otcSchedules {
    id
    cadence
    quantity
    product {
      id
      name
      friendlyName
    }
    isActive
  }
}
    `;
export const TreatmentFollowUpCardTreatmentFragmentDoc = gql`
    fragment TreatmentFollowUpCardTreatment on Treatment {
  id
  active
  nextPayment
  otcSchedules {
    id
    cadence
    quantity
    isActive
    product {
      id
      name
    }
  }
  product {
    id
    name
    friendlyName
  }
  ...TreatmentDetailsTreatment
}
    ${TreatmentDetailsTreatmentFragmentDoc}`;
export const TreatmentPausedCardTreatmentFragmentDoc = gql`
    fragment TreatmentPausedCardTreatment on Treatment {
  id
  canRefill
  nextPaymentAmount
  plan {
    id
    amount
  }
  otcSchedules {
    id
    isActive
    quantity
    product {
      id
      variants {
        id
        price
      }
    }
  }
  ...TreatmentDetailsTreatment
}
    ${TreatmentDetailsTreatmentFragmentDoc}`;
export const ReviewAwaitingSurveyCardTreatmentFragmentDoc = gql`
    fragment ReviewAwaitingSurveyCardTreatment on Treatment {
  id
  type
  active
  ...TreatmentDetailsTreatment
}
    ${TreatmentDetailsTreatmentFragmentDoc}`;
export const TreatmentActiveCardTreatmentFragmentDoc = gql`
    fragment TreatmentActiveCardTreatment on Treatment {
  id
  active
  ...TreatmentDetailsTreatment
}
    ${TreatmentDetailsTreatmentFragmentDoc}`;
export const TreatmentProcessingOrderCardTreatmentFragmentDoc = gql`
    fragment TreatmentProcessingOrderCardTreatment on Treatment {
  id
  active
  ...TreatmentDetailsTreatment
}
    ${TreatmentDetailsTreatmentFragmentDoc}`;
export const AwaitingSurveyCardScreeningQuizApplicationFragmentDoc = gql`
    fragment AwaitingSurveyCardScreeningQuizApplication on QuizApplication {
  id
  submittedAt
}
    `;
export const AwaitingDoctorCardPractitionerBookingFragmentDoc = gql`
    fragment AwaitingDoctorCardPractitionerBooking on PractitionerBooking {
  id
  windowStartAt
  windowEndAt
}
    `;
export const AwaitingResultsCardPathologyRequestFragmentDoc = gql`
    fragment AwaitingResultsCardPathologyRequest on PathologyRequest {
  id
  customerStatedCollectedAt
}
    `;
export const ActiveReminderRemindersFragmentDoc = gql`
    fragment ActiveReminderReminders on ConsultationReminder {
  id
  canceled
  doneAt
  scheduledAt
}
    `;
export const ReminderCardReminderFragmentDoc = gql`
    fragment ReminderCardReminder on ConsultationReminder {
  id
  scheduledAt
  doneAt
}
    `;
export const ActiveReminderPatientQuestionsFragmentDoc = gql`
    fragment ActiveReminderPatientQuestions on ConsultationPatientQuestion {
  id
  createdAt
}
    `;
export const UseConsultationCardContentConsultationFragmentDoc = gql`
    fragment UseConsultationCardContentConsultation on Consultation {
  id
  type
  stage
  status
  isApproved
  typeIsFlexi
  requiresPrescriberCall
  isInNoPickUpQueue
  allowPatientToSendMessageToDoctor
  chatThread {
    id
  }
  doctor {
    id
    fullName
    fullClinicianName
  }
  treatment {
    id
    status
    active
    pendingFollowUpReminderDate
    isLastOrderUnfulfilled
    ...TreatmentFollowUpCardTreatment
    ...TreatmentPausedCardTreatment
    ...ReviewAwaitingSurveyCardTreatment
    ...TreatmentActiveCardTreatment
    ...TreatmentDetailsTreatment
    ...TreatmentProcessingOrderCardTreatment
  }
  prescribedSequence {
    id
  }
  quizApplication {
    id
    submittedAt
  }
  screeningQuizApplication {
    id
    ...AwaitingSurveyCardScreeningQuizApplication
  }
  latestPractitionerBooking {
    id
    ...AwaitingDoctorCardPractitionerBooking
  }
  pathologyRequests {
    id
    customerStatedCollectedAt
    ...AwaitingResultsCardPathologyRequest
  }
  reminders {
    id
    ...ActiveReminderReminders
    ...ReminderCardReminder
  }
  patientQuestions {
    id
    ...ActiveReminderPatientQuestions
  }
  purchasePrompt {
    id
  }
  practitionerMessagedAt
}
    ${TreatmentFollowUpCardTreatmentFragmentDoc}
${TreatmentPausedCardTreatmentFragmentDoc}
${ReviewAwaitingSurveyCardTreatmentFragmentDoc}
${TreatmentActiveCardTreatmentFragmentDoc}
${TreatmentDetailsTreatmentFragmentDoc}
${TreatmentProcessingOrderCardTreatmentFragmentDoc}
${AwaitingSurveyCardScreeningQuizApplicationFragmentDoc}
${AwaitingDoctorCardPractitionerBookingFragmentDoc}
${AwaitingResultsCardPathologyRequestFragmentDoc}
${ActiveReminderRemindersFragmentDoc}
${ReminderCardReminderFragmentDoc}
${ActiveReminderPatientQuestionsFragmentDoc}`;
export const ConsultationCardContentConsultationFragmentDoc = gql`
    fragment ConsultationCardContentConsultation on Consultation {
  id
  status
  pathologyRequests {
    id
    result {
      id
    }
  }
  ...UseConsultationCardContentConsultation
}
    ${UseConsultationCardContentConsultationFragmentDoc}`;
export const PurchaseCardConsultationFragmentDoc = gql`
    fragment PurchaseCardConsultation on Consultation {
  id
  type
  stage
  status
  requiresPrescriberCall
  allowPatientToSendMessageToDoctor
  practitionerMessagedAt
  doctor {
    id
    fullName
    fullClinicianName
  }
  quizApplication {
    id
    submittedAt
  }
  chatThread {
    id
  }
  pathologyRequests {
    id
    ...AwaitingResultsCardPathologyRequest
  }
}
    ${AwaitingResultsCardPathologyRequestFragmentDoc}`;
export const CompoundTreatmentStatusCardConsultationFragmentDoc = gql`
    fragment CompoundTreatmentStatusCardConsultation on Consultation {
  id
  type
  treatment {
    id
    ...CompoundTreatmentStatusCardTreatment
  }
  ...UseProfileCardsConsultation
  ...ConsultationCardContentConsultation
  ...PurchaseCardConsultation
}
    ${CompoundTreatmentStatusCardTreatmentFragmentDoc}
${UseProfileCardsConsultationFragmentDoc}
${ConsultationCardContentConsultationFragmentDoc}
${PurchaseCardConsultationFragmentDoc}`;
export const CompoundProfilePageConsultationFragmentDoc = gql`
    fragment CompoundProfilePageConsultation on Consultation {
  id
  ...UseProfileCardsConsultation
  ...CompoundTreatmentStatusCardConsultation
}
    ${UseProfileCardsConsultationFragmentDoc}
${CompoundTreatmentStatusCardConsultationFragmentDoc}`;
export const UseProfileCardsPurchaseFragmentDoc = gql`
    fragment UseProfileCardsPurchase on Purchase {
  id
  status
  problemType
  isVisibleInProfilePage
  contexts {
    id
    consultations {
      id
    }
  }
}
    `;
export const UsePurchaseCardContentPurchaseFragmentDoc = gql`
    fragment UsePurchaseCardContentPurchase on Purchase {
  id
  status
  offering {
    id
    friendlyName
  }
  orderTimeline {
    id
    status
  }
  nextOrder {
    id
    date
    products {
      id
      friendlyName
      name
    }
  }
  contexts {
    id
    status
    sequence {
      id
      products {
        id
        productType
      }
    }
  }
}
    `;
export const PurchaseProcessingCardPurchaseFragmentDoc = gql`
    fragment PurchaseProcessingCardPurchase on Purchase {
  id
  offering {
    id
    problemTypes
  }
}
    `;
export const PurchaseCompletedCardPurchaseFragmentDoc = gql`
    fragment PurchaseCompletedCardPurchase on Purchase {
  id
  offering {
    id
    problemTypes
  }
}
    `;
export const PurchaseActiveCardPurchaseFragmentDoc = gql`
    fragment PurchaseActiveCardPurchase on Purchase {
  id
  offering {
    id
    problemTypes
  }
}
    `;
export const PurchasePausedCardPurchaseFragmentDoc = gql`
    fragment PurchasePausedCardPurchase on Purchase {
  id
  problemType
  offering {
    id
  }
  availableActions {
    id
  }
  nextOrder {
    id
    date
    totalAmount
  }
}
    `;
export const PurchaseCardPurchaseFragmentDoc = gql`
    fragment PurchaseCardPurchase on Purchase {
  id
  status
  orderTimeline {
    id
    status
  }
  offering {
    id
    friendlyName
  }
  ...UsePurchaseCardContentPurchase
  ...PurchaseProcessingCardPurchase
  ...PurchaseCompletedCardPurchase
  ...PurchaseActiveCardPurchase
  ...PurchasePausedCardPurchase
}
    ${UsePurchaseCardContentPurchaseFragmentDoc}
${PurchaseProcessingCardPurchaseFragmentDoc}
${PurchaseCompletedCardPurchaseFragmentDoc}
${PurchaseActiveCardPurchaseFragmentDoc}
${PurchasePausedCardPurchaseFragmentDoc}`;
export const CompoundTreatmentStatusCardPurchaseFragmentDoc = gql`
    fragment CompoundTreatmentStatusCardPurchase on Purchase {
  id
  problemType
  ...UseProfileCardsPurchase
  ...PurchaseCardPurchase
}
    ${UseProfileCardsPurchaseFragmentDoc}
${PurchaseCardPurchaseFragmentDoc}`;
export const CompoundProfilePagePurchaseFragmentDoc = gql`
    fragment CompoundProfilePagePurchase on Purchase {
  id
  ...UseProfileCardsPurchase
  ...CompoundTreatmentStatusCardPurchase
}
    ${UseProfileCardsPurchaseFragmentDoc}
${CompoundTreatmentStatusCardPurchaseFragmentDoc}`;
export const UseProfileCardsQuizApplicationFragmentDoc = gql`
    fragment UseProfileCardsQuizApplication on QuizApplication {
  id
  problemType
  createdAt
  archivedAt
}
    `;
export const QuizCompletedCardContentQuizApplicationFragmentDoc = gql`
    fragment QuizCompletedCardContentQuizApplication on QuizApplication {
  id
  outcomes {
    ... on QuizOutcomeV2 {
      id
    }
  }
}
    `;
export const CompoundTreatmentStatusCardQuizApplicationFragmentDoc = gql`
    fragment CompoundTreatmentStatusCardQuizApplication on QuizApplication {
  id
  submittedAt
  problemType
  ...UseProfileCardsQuizApplication
  ...QuizCompletedCardContentQuizApplication
}
    ${UseProfileCardsQuizApplicationFragmentDoc}
${QuizCompletedCardContentQuizApplicationFragmentDoc}`;
export const CompoundProfilePageInitialQuizApplicationFragmentDoc = gql`
    fragment CompoundProfilePageInitialQuizApplication on QuizApplication {
  id
  ...UseProfileCardsQuizApplication
  ...CompoundTreatmentStatusCardQuizApplication
}
    ${UseProfileCardsQuizApplicationFragmentDoc}
${CompoundTreatmentStatusCardQuizApplicationFragmentDoc}`;
export const ConsultationInfoJuniperEuFragmentDoc = gql`
    fragment ConsultationInfoJuniperEU on Consultation {
  id
  type
  status
  isApproved
  stage
  isUpfrontPayment
  patientNotes
  rejectReason
  completedAt
  patientQuestions {
    id
    createdAt
    updatedAt
    value
  }
  treatment {
    id
    status
    refillsLeft
    plan {
      id
      amount
    }
    otcSchedules {
      id
      productId
      createdAt
      updatedAt
      cadence
      isActive
      quantity
      product {
        id
        name
        variants {
          id
          price
        }
      }
    }
    product {
      id
      name
      productType
      safetyInformation
      photo {
        id
        url
      }
      cmi {
        id
        url
      }
      plan {
        id
        intervalCount
        interval
      }
      faqs {
        id
        title
        markdown
      }
      variants {
        id
        price
        isRefill
      }
    }
  }
  customer {
    id
    firstName
  }
  doctorQuestions(orderBy: {createdAt: asc}) {
    id
    createdAt
    updatedAt
    value
    allowedAnswerType
    answer {
      id
      createdAt
      updatedAt
      value
    }
  }
  doctor {
    id
    firstName
    lastName
    shortClinicianName
    fullClinicianName
    fullName
    role
    bio
    avatar {
      id
      createdAt
      updatedAt
      filename
      mimetype
      url
    }
  }
  quizApplication {
    id
    answers(orderBy: {createdAt: asc}) {
      id
      answer
      answersArray
      question {
        id
        shortcode
      }
    }
    quiz {
      id
      questions {
        id
        title
        type
        description
        required
        options
        imgUrl
        shortcode
        questionOptions {
          id
          questionId
          option
          position
        }
      }
      logics {
        id
        from {
          id
        }
        elseJump {
          id
        }
        jumps {
          id
          conditions(orderBy: {order: asc}) {
            id
            question {
              id
            }
            value
            operator
            nextCondition
          }
          to {
            id
          }
        }
      }
      skips {
        id
        from {
          id
        }
        conditions(orderBy: {order: asc}) {
          id
          question {
            id
          }
          value
          operator
          nextCondition
        }
      }
      questionsOrder
    }
  }
  order {
    id
    lineItems {
      id
      quantity
      variant {
        id
        price
        product {
          id
          name
          productType
        }
      }
    }
  }
  createdAt
}
    `;
export const AddOnsPageProductFragmentDoc = gql`
    fragment AddOnsPageProduct on Product {
  id
  name
  description
  priority
  productType
  problemTypes
  photo {
    id
    url
  }
  variants {
    id
    price
    public
    inventory {
      id
      sku
    }
  }
}
    `;
export const JuniperProfilePageUserSegmentsFragmentDoc = gql`
    fragment JuniperProfilePageUserSegments on Query {
  completedMobileOnboardingScreens: inSegment(
    segmentName: COMPLETED_MOBILE_ONBOARDING_SCREENS
  )
}
    `;
export const JuniperTreatmentStatusCardTreatmentFragmentDoc = gql`
    fragment JuniperTreatmentStatusCardTreatment on Treatment {
  id
  refillsLeft
  nextPayment
  product {
    id
    name
    friendlyName
  }
  otcSchedules {
    id
    cadence
    quantity
    product {
      id
      name
      friendlyName
    }
    isActive
  }
}
    `;
export const JuniperTreatmentStatusCardConsultationFragmentDoc = gql`
    fragment JuniperTreatmentStatusCardConsultation on Consultation {
  id
  type
  treatment {
    id
    ...JuniperTreatmentStatusCardTreatment
  }
  ...UseProfileCardsConsultation
  ...ConsultationCardContentConsultation
  ...PurchaseCardConsultation
}
    ${JuniperTreatmentStatusCardTreatmentFragmentDoc}
${UseProfileCardsConsultationFragmentDoc}
${ConsultationCardContentConsultationFragmentDoc}
${PurchaseCardConsultationFragmentDoc}`;
export const JuniperProfilePageConsultationFragmentDoc = gql`
    fragment JuniperProfilePageConsultation on Consultation {
  id
  ...UseProfileCardsConsultation
  ...JuniperTreatmentStatusCardConsultation
}
    ${UseProfileCardsConsultationFragmentDoc}
${JuniperTreatmentStatusCardConsultationFragmentDoc}`;
export const JuniperTreatmentStatusCardPurchaseFragmentDoc = gql`
    fragment JuniperTreatmentStatusCardPurchase on Purchase {
  id
  problemType
  ...UseProfileCardsPurchase
  ...PurchaseCardPurchase
}
    ${UseProfileCardsPurchaseFragmentDoc}
${PurchaseCardPurchaseFragmentDoc}`;
export const JuniperProfilePagePurchaseFragmentDoc = gql`
    fragment JuniperProfilePagePurchase on Purchase {
  id
  ...UseProfileCardsPurchase
  ...JuniperTreatmentStatusCardPurchase
}
    ${UseProfileCardsPurchaseFragmentDoc}
${JuniperTreatmentStatusCardPurchaseFragmentDoc}`;
export const JuniperTreatmentStatusCardQuizApplicationFragmentDoc = gql`
    fragment JuniperTreatmentStatusCardQuizApplication on QuizApplication {
  id
  submittedAt
  problemType
  ...UseProfileCardsQuizApplication
  ...QuizCompletedCardContentQuizApplication
}
    ${UseProfileCardsQuizApplicationFragmentDoc}
${QuizCompletedCardContentQuizApplicationFragmentDoc}`;
export const JuniperProfilePageInitialQuizApplicationFragmentDoc = gql`
    fragment JuniperProfilePageInitialQuizApplication on QuizApplication {
  id
  ...UseProfileCardsQuizApplication
  ...JuniperTreatmentStatusCardQuizApplication
}
    ${UseProfileCardsQuizApplicationFragmentDoc}
${JuniperTreatmentStatusCardQuizApplicationFragmentDoc}`;
export const TreatmentPageProductFragmentDoc = gql`
    fragment TreatmentPageProduct on Product {
  id
  name
  friendlyName
  description
  shortDescription
  priority
  productType
  problemTypes
  photo {
    id
    url
  }
  variants {
    id
    price
    public
    inventory {
      id
      sku
    }
  }
}
    `;
export const DiscountCodeFormFragmentDoc = gql`
    fragment DiscountCodeForm on DiscountCode {
  id
  code
  amount
  stages
  type
  products {
    id
    variants {
      id
    }
  }
}
    `;
export const ProductListTreatmentProductFragmentDoc = gql`
    fragment ProductListTreatmentProduct on Product {
  id
  name
  friendlyName
  productType
  photo {
    id
    url
  }
  variants {
    id
    price
    inventory {
      id
      sku
    }
  }
}
    `;
export const ProductListTreatmentFragmentDoc = gql`
    fragment ProductListTreatment on Treatment {
  id
  type
  nextPayment
  nextPaymentAmount
  canReschedule
  canRefill
  cooldownActiveUntil
  supersededByFlexiPlans
  treatmentDiscount {
    id
    discountCode {
      ...DiscountCodeForm
    }
  }
  plan {
    id
    amount
  }
  product {
    ...ProductListTreatmentProduct
  }
  otcSchedules {
    id
    cadence
    isActive
    quantity
    product {
      id
      name
      friendlyName
      productType
      photo {
        id
        url
      }
      variants {
        id
        price
        inventory {
          id
          sku
        }
      }
    }
  }
}
    ${DiscountCodeFormFragmentDoc}
${ProductListTreatmentProductFragmentDoc}`;
export const ConsultationInfoKinFragmentDoc = gql`
    fragment ConsultationInfoKin on Consultation {
  id
  type
  status
  patientNotes
  pathologyRequests {
    id
    result {
      id
      collectedDate
      file {
        id
        signedUrl
      }
    }
    panels {
      id
      tests {
        id
        name
        formName
        displayName
        result {
          id
          result {
            type
            value
            number
            unit
            range {
              low
              high
            }
          }
          note
        }
        pathologyPanelId
      }
    }
  }
  doctor {
    id
    firstName
    lastName
    shortClinicianName
    fullClinicianName
    fullName
    avatar {
      id
      url
    }
  }
}
    `;
export const PilotAccountSettingsFragmentDoc = gql`
    fragment PilotAccountSettings on User {
  id
  email
}
    `;
export const PilotSubscriptionsFragmentDoc = gql`
    fragment PilotSubscriptions on SubscriptionPlan {
  id
  amount
  product {
    id
    name
    friendlyName
    photo {
      id
      url
    }
  }
  interval
  intervalCount
  status
  currentPeriodEnd
  cancelAt
}
    `;
export const PilotTreatmentStatusCardsQuizApplicationFragmentDoc = gql`
    fragment PilotTreatmentStatusCardsQuizApplication on QuizApplication {
  id
  submittedAt
  problemType
  ...UseProfileCardsQuizApplication
  ...QuizCompletedCardContentQuizApplication
}
    ${UseProfileCardsQuizApplicationFragmentDoc}
${QuizCompletedCardContentQuizApplicationFragmentDoc}`;
export const PilotTreatmentStatusCardsTreatmentFragmentDoc = gql`
    fragment PilotTreatmentStatusCardsTreatment on Treatment {
  id
  refillsLeft
  nextPayment
  product {
    id
    name
    friendlyName
  }
  otcSchedules {
    id
    cadence
    quantity
    product {
      id
      name
      friendlyName
    }
    isActive
  }
}
    `;
export const PilotTreatmentStatusCardsConsultationFragmentDoc = gql`
    fragment PilotTreatmentStatusCardsConsultation on Consultation {
  id
  type
  treatment {
    id
    ...PilotTreatmentStatusCardsTreatment
  }
  ...UseProfileCardsConsultation
  ...ConsultationCardContentConsultation
  ...PurchaseCardConsultation
}
    ${PilotTreatmentStatusCardsTreatmentFragmentDoc}
${UseProfileCardsConsultationFragmentDoc}
${ConsultationCardContentConsultationFragmentDoc}
${PurchaseCardConsultationFragmentDoc}`;
export const PilotTreatmentStatusCardsPurchaseFragmentDoc = gql`
    fragment PilotTreatmentStatusCardsPurchase on Purchase {
  id
  problemType
  ...UseProfileCardsPurchase
  ...PurchaseCardPurchase
}
    ${UseProfileCardsPurchaseFragmentDoc}
${PurchaseCardPurchaseFragmentDoc}`;
export const ConsultationInfoSoftwareFragmentDoc = gql`
    fragment ConsultationInfoSoftware on Consultation {
  id
  type
  status
  isApproved
  stage
  isUpfrontPayment
  patientNotes
  rejectReason
  completedAt
  patientQuestions {
    id
    createdAt
    updatedAt
    value
  }
  treatment {
    id
    status
    refillsLeft
    otcSchedules {
      id
      productId
      createdAt
      updatedAt
      cadence
      isActive
      quantity
      product {
        id
        name
        variants {
          id
          price
        }
      }
    }
    plan {
      id
      amount
    }
    product {
      id
      name
      productType
      safetyInformation
      photo {
        id
        url
      }
      cmi {
        id
        url
      }
      plan {
        id
        intervalCount
        interval
      }
      faqs {
        id
        title
        markdown
      }
      variants {
        id
        price
        isRefill
      }
    }
  }
  customer {
    id
    firstName
  }
  doctorQuestions(orderBy: {createdAt: asc}) {
    id
    createdAt
    updatedAt
    value
    allowedAnswerType
    answer {
      id
      createdAt
      updatedAt
      value
    }
  }
  doctor {
    id
    firstName
    lastName
    shortClinicianName
    fullClinicianName
    fullName
    role
    bio
    avatar {
      id
      createdAt
      updatedAt
      filename
      mimetype
      url
    }
    provider {
      id
      clinicianType
      clinicianTitle
    }
  }
  quizApplication {
    id
    answers(orderBy: {createdAt: asc}) {
      id
      answer
      answersArray
      question {
        id
        shortcode
      }
    }
    quiz {
      id
      questions {
        id
        title
        type
        description
        required
        options
        imgUrl
        shortcode
        questionOptions {
          id
          questionId
          option
          position
        }
      }
      logics {
        id
        from {
          id
        }
        elseJump {
          id
        }
        jumps {
          id
          conditions(orderBy: {order: asc}) {
            id
            question {
              id
            }
            value
            operator
            nextCondition
          }
          to {
            id
          }
        }
      }
      skips {
        id
        from {
          id
        }
        conditions(orderBy: {order: asc}) {
          id
          question {
            id
          }
          value
          operator
          nextCondition
        }
      }
      questionsOrder
    }
  }
  order {
    id
    lineItems {
      id
      quantity
      variant {
        id
        price
        product {
          id
          name
          productType
        }
      }
    }
  }
  createdAt
}
    `;
export const TreatmentInfoSoftwareFragmentDoc = gql`
    fragment TreatmentInfoSoftware on Treatment {
  id
  type
  refillsLeft
  canReschedule
  canRefill
  cooldownActiveUntil
  canReview
  nextPayment
  status
  treatmentDiscount {
    id
    discountCode {
      ...DiscountCodeForm
    }
  }
  plan {
    id
    amount
  }
  otcSchedules {
    id
    isActive
    cadence
    product {
      id
      name
      productType
      photo {
        id
        url
      }
      variants {
        id
        price
      }
    }
    quantity
  }
  consultation {
    id
    patientNotes
    doctor {
      id
      firstName
      lastName
      shortClinicianName
      fullClinicianName
      fullName
      role
      bio
      avatar {
        id
        createdAt
        updatedAt
        filename
        mimetype
        url
      }
      provider {
        id
        clinicianTitle
        clinicianType
        qualifications
      }
    }
    quizApplication {
      id
      answers {
        id
        answer
        answersArray
        question {
          id
          shortcode
        }
      }
    }
    order {
      id
      lineItems {
        id
        quantity
        variant {
          id
          price
          product {
            id
            name
            productType
          }
        }
      }
    }
  }
  product {
    id
    name
    productType
    instructions
    safetyInformation
    photo {
      id
      url
    }
    faqs {
      id
      title
      markdown
    }
    cmi {
      id
      url
    }
  }
}
    ${DiscountCodeFormFragmentDoc}`;
export const UserInfoSoftwareFragmentDoc = gql`
    fragment UserInfoSoftware on User {
  id
  email
  firstName
  lastName
  legalFirstName
  legalLastName
  phone
  role
  isPasswordSet
  defaultPaymentGateway
  birthday
  zip {
    valid
  }
  residentialAddress {
    id
    line1
    line2
    city
    postalCode
    state
    country
    company
    building
  }
  address {
    id
    line1
    line2
    city
    postalCode
    state
    country
    company
    building
  }
  savedPaymentMethods {
    id
    gateway
    default
    ... on SavedCardPaymentMethod {
      brand
      expiry
      mask
    }
    ... on SavedPayPalPaymentMethod {
      email
    }
    ... on SavedZipPaymentMethod {
      valid
    }
  }
}
    `;
export const EducationCollectionFragmentDoc = gql`
    fragment EducationCollection on EducationCollection {
  id
  name
  description
  readings {
    id
    content
    completedAt
    startedAt
    timeToReadMs
  }
}
    `;
export const UpfrontPaymentConsultProductFragmentDoc = gql`
    fragment UpfrontPaymentConsultProduct on Product {
  id
  name
  friendlyName
  erxMedicines {
    id
    genericName
  }
  faqs {
    id
  }
  variants {
    id
    price
    isRefill
    inventory {
      id
      sku
    }
  }
  photo {
    id
    url
  }
  plan {
    id
    name
    interval
    intervalCount
  }
}
    `;
export const MasterclassEpisodeFragmentDoc = gql`
    fragment MasterclassEpisode on MasterclassVideo {
  id
  created
  description
  duration
  hashed_id
  section
  title
  thumbnail {
    height
    url
    width
  }
  type
  updated
}
    `;
export const BillingDetailsFragmentDoc = gql`
    fragment BillingDetails on User {
  id
  defaultPaymentGateway
  savedPaymentMethods {
    id
    gateway
    default
    createdAt
    ... on SavedCardPaymentMethod {
      expiry
      mask
      brand
    }
    ... on SavedZipPaymentMethod {
      valid
    }
    ... on SavedPayPalPaymentMethod {
      email
    }
  }
  zip {
    valid
  }
}
    `;
export const PaymentFormFragmentDoc = gql`
    fragment PaymentForm on User {
  id
  defaultPaymentGateway
  savedPaymentMethods {
    id
    gateway
    default
    createdAt
    ... on SavedCardPaymentMethod {
      expiry
      mask
      brand
    }
    ... on SavedZipPaymentMethod {
      valid
    }
    ... on SavedPayPalPaymentMethod {
      email
    }
  }
  zip {
    valid
  }
}
    `;
export const ShoppingCartFragmentDoc = gql`
    fragment ShoppingCart on OtcShoppingCart {
  id
  items {
    id
    quantity
    variant {
      id
      name
      price
      product {
        id
        name
        photo {
          id
          url
        }
      }
      inventory {
        id
        sku
      }
    }
  }
}
    `;
export const DoctorInfoFragmentDoc = gql`
    fragment DoctorInfo on User {
  id
  fullClinicianName
  lastName
  bio
  avatar {
    id
    url
  }
  provider {
    id
    clinicianTitle
  }
}
    `;
export const DoctorInfoComponentFragmentDoc = gql`
    fragment DoctorInfoComponent on User {
  id
  fullName
  fullClinicianName
  shortClinicianName
  lastName
  bio
  avatar {
    id
    url
  }
  provider {
    id
    clinicianTitle
    qualifications
  }
}
    `;
export const DoctorBioComponentFragmentDoc = gql`
    fragment DoctorBioComponent on User {
  id
  bio
  provider {
    clinicianTitle
    qualifications
  }
  ...DoctorInfoComponent
}
    ${DoctorInfoComponentFragmentDoc}`;
export const DoctorLetterComponentFragmentDoc = gql`
    fragment DoctorLetterComponent on User {
  id
  shortClinicianName
  fullClinicianName
  ...DoctorBioComponent
}
    ${DoctorBioComponentFragmentDoc}`;
export const PharmacyInformationPageProductFragmentDoc = gql`
    fragment PharmacyInformationPageProduct on Product {
  id
  plan {
    id
    interval
    intervalCount
  }
  variants {
    id
    isRefill
    price
    inventory {
      id
      sku
    }
  }
  photo {
    id
    url
  }
  cmi {
    id
    url
  }
  faqs {
    id
    title
    markdown
    videoEmbedUrl
  }
  name
  shortDescription
  safetyInformation
}
    `;
export const PaymentMethodsFragmentDoc = gql`
    fragment PaymentMethods on User {
  id
  defaultPaymentGateway
  savedPaymentMethods {
    id
    gateway
    default
    createdAt
    ... on SavedCardPaymentMethod {
      expiry
      mask
      brand
    }
    ... on SavedZipPaymentMethod {
      valid
    }
    ... on SavedPayPalPaymentMethod {
      email
    }
  }
  zip {
    valid
  }
}
    `;
export const AddonDrawerFocusedShopItemFragmentDoc = gql`
    fragment AddonDrawerFocusedShopItem on ShopItem {
  id
  title
  otcOffering {
    id
    photoUrl
    description
    sequenceSets {
      id
      defaultSequence {
        id
      }
      sequences {
        id
        friendlyName
        status
      }
    }
  }
}
    `;
export const ContactInfoFragmentDoc = gql`
    fragment ContactInfo on User {
  phone
  email
}
    `;
export const ShippingAddressFragmentDoc = gql`
    fragment ShippingAddress on User {
  weightTreatmentCategory
  address {
    id
    building
    city
    company
    country
    createdAt
    line1
    line2
    municipality
    postalCode
    prefecture
    state
    townArea
    updatedAt
    deliveryInstructions
  }
}
    `;
export const OrderSummaryCardGippFragmentDoc = gql`
    fragment OrderSummaryCardGIPP on InitialPurchasePriceList {
  id
  amount
  coupons {
    id
    code
    outcome
  }
  discountAmount
  originalAmount
  sessionCreditAmount
  offeringPriceLists {
    id
    offering {
      id
      advertisedName
      friendlyName
      photoUrl
      advertisedCostCadence
    }
    sequencePriceLists {
      id
      sequence {
        id
        friendlyName
      }
      sequenceSet {
        id
        sequences {
          id
        }
      }
      pricedItems {
        id
        unitPrice
        quantity
        variant {
          id
          public
          product {
            id
            name
            photo {
              id
              url
            }
          }
        }
      }
    }
  }
}
    `;
export const OfferingHighlightsSequenceFragmentDoc = gql`
    fragment OfferingHighlightsSequence on Sequence {
  id
  ... on PrescribableSequence {
    containsRefrigeratedContents
  }
}
    `;
export const OrderSummaryGippFragmentDoc = gql`
    fragment OrderSummaryGIPP on InitialPurchasePriceList {
  id
  amount
  coupons {
    id
    code
    outcome
  }
  discountAmount
  originalAmount
  sessionCreditAmount
  offeringPriceLists {
    id
    offering {
      id
      advertisedName
      friendlyName
      photoUrl
      advertisedCostCadence
    }
    sequencePriceLists {
      id
      sequence {
        id
        friendlyName
        ...OfferingHighlightsSequence
      }
      sequenceSet {
        id
        sequences {
          id
        }
      }
      pricedItems {
        id
        unitPrice
        quantity
        variant {
          id
          public
          product {
            id
            name
            deliveryInformation
            photo {
              id
              url
            }
          }
        }
      }
    }
  }
}
    ${OfferingHighlightsSequenceFragmentDoc}`;
export const PurchaseActivationFlowOfferingVerticalsFragmentDoc = gql`
    fragment PurchaseActivationFlowOfferingVerticals on Offering {
  upsells {
    id
  }
  downsells {
    id
  }
}
    `;
export const ReceiptPsatConsultationFragmentDoc = gql`
    fragment ReceiptPsatConsultation on Consultation {
  id
  type
  customer {
    id
    firstName
  }
  doctor {
    id
    shortClinicianName
  }
}
    `;
export const ReviewSectionOfferingFragmentDoc = gql`
    fragment ReviewSectionOffering on Offering {
  id
  advertisedName
  advertisedShippingCadence
  upsells {
    id
  }
  downsells {
    id
  }
  tags
}
    `;
export const OfferingVerticalFragmentDoc = gql`
    fragment OfferingVertical on Offering {
  id
  photoUrl
  advertisedName
  advertisedStartingAmount
  description
  firstOrderGiftCopy
  contents {
    id
    description
    tooltip
    rank
  }
  tags
  sequenceSets {
    id
    sequences {
      id
      tags
    }
  }
}
    `;
export const PurchaseActivationSwitchCandidateFragmentDoc = gql`
    fragment PurchaseActivationSwitchCandidate on SwitchCandidate {
  id
  advertisedCadencePricingDelta
  offering {
    ...OfferingVertical
  }
}
    ${OfferingVerticalFragmentDoc}`;
export const PurchaseActivationOfferingFragmentDoc = gql`
    fragment PurchaseActivationOffering on Offering {
  ...OfferingVertical
  upsells {
    ...PurchaseActivationSwitchCandidate
  }
  downsells {
    ...PurchaseActivationSwitchCandidate
  }
}
    ${OfferingVerticalFragmentDoc}
${PurchaseActivationSwitchCandidateFragmentDoc}`;
export const SafetyInformationSequenceFragmentDoc = gql`
    fragment SafetyInformationSequence on PrescribableSequence {
  safetyInformation {
    id
    cmiUrl
    cmiCopyMarkdown
  }
}
    `;
export const FaqSequenceFragmentDoc = gql`
    fragment FaqSequence on PrescribableSequence {
  faqs {
    id
    rank
    question
    answerMarkdown
  }
}
    `;
export const OfferingSendMessageDoctorFragmentDoc = gql`
    fragment OfferingSendMessageDoctor on User {
  id
  fullClinicianName
  avatar {
    id
    url
  }
}
    `;
export const OfferingDoctorLetterConsultationFragmentDoc = gql`
    fragment OfferingDoctorLetterConsultation on Consultation {
  id
  patientNotes
  completedAt
  allowPatientToSendMessageToDoctor
  doctor {
    id
    ...DoctorInfoComponent
    ...OfferingSendMessageDoctor
  }
}
    ${DoctorInfoComponentFragmentDoc}
${OfferingSendMessageDoctorFragmentDoc}`;
export const PsgTimelineFragmentDoc = gql`
    fragment PsgTimeline on PurchaseSyncGroup {
  id
  sequenceContexts {
    id
    sequence {
      id
      __typename
    }
  }
  timeline {
    id
    products {
      id
      displayName
      type
    }
    addonProducts {
      id
      displayName
      type
    }
    date
    status
    preDiscountTotalAmount {
      id
      baseUnitAmount
    }
    totalAmount {
      id
      baseUnitAmount
    }
  }
}
    `;
export const ScheduleCallUserFragmentDoc = gql`
    fragment ScheduleCallUser on User {
  id
  phone
}
    `;
export const ScheduleCallPractitionerBookingWindowFragmentDoc = gql`
    fragment ScheduleCallPractitionerBookingWindow on PractitionerBookingWindow {
  id
  startAt
  endAt
  available
}
    `;
export const ScheduleCallPhoneNumberModalFragmentDoc = gql`
    fragment ScheduleCallPhoneNumberModal on Query {
  validPhoneRegions {
    id
    countryCode
  }
}
    `;
export const PersonalDetailsFragmentDoc = gql`
    fragment PersonalDetails on User {
  id
  email
  fullName
  firstName
  lastName
  phone
  residentialAddress {
    id
    line1
    line2
    city
    postalCode
    prefecture
    municipality
    townArea
    state
    building
    company
    country
  }
}
    `;
export const RangeShippingDetailsAddressFragmentDoc = gql`
    fragment RangeShippingDetailsAddress on Address {
  id
  line1
  line2
  city
  postalCode
  prefecture
  municipality
  townArea
  state
  building
  company
  country
}
    `;
export const QuizApplicationFragmentDoc = gql`
    fragment QuizApplication on QuizApplication {
  id
  createdAt
  customerId
  consultation {
    id
    status
    stage
    isUpfrontPayment
    medium
    canSchedulePractitionerBooking
    requiresPrescriberCall
  }
  purpose
  problemType
  answers(orderBy: {createdAt: asc}) {
    id
    answer
    answersArray
    englishAnswer: answer(languageCode: EN_AU)
    englishAnswersArray: answersArray(languageCode: EN_AU)
    question {
      id
      shortcode
    }
  }
  submittedAt
  quiz {
    id
    default
    quizCode
    questions {
      id
      title
      type
      description
      required
      optionImgLayout
      imgUrl
      shortcode
      options
      questionOptions {
        id
        questionId
        option
        position
        imgUrl
        popup {
          id
          title
          content
          linkOutText
          imgUrl
        }
      }
      popup {
        id
        title
        content
        linkOutText
        imgUrl
      }
    }
    logics {
      id
      from {
        id
      }
      elseJump {
        id
      }
      jumps {
        id
        conditions(orderBy: {order: asc}) {
          id
          question {
            id
          }
          value
          operator
          nextCondition
        }
        to {
          id
        }
      }
    }
    skips {
      id
      from {
        id
      }
      conditions(orderBy: {order: asc}) {
        id
        question {
          id
        }
        value
        operator
        nextCondition
      }
    }
    questionsOrder
  }
  responses {
    id
    question {
      id
      type
      title
      shortcode
      options {
        value
      }
    }
    response {
      answers {
        value
        imageUrl
      }
      flag {
        level
      }
    }
  }
  outcomes {
    ... on QuizOutcomeV2 {
      id
    }
    ... on NotEligibleQuizOutcome {
      reasons
    }
  }
}
    `;
export const ExperimentPaymentPlanFragmentDoc = gql`
    fragment ExperimentPaymentPlan on ExperimentTreatmentPaymentPlan {
  id
  paymentPlan
  discountPercentage
  months
  version
}
    `;
export const ConsultationInfoFragmentDoc = gql`
    fragment ConsultationInfo on Consultation {
  id
  type
  status
  isApproved
  stage
  isUpfrontPayment
  patientNotes
  rejectReason
  createdAt
  completedAt
  medium
  chatThread {
    id
  }
  allowPatientToSendMessageToDoctor
  canSchedulePractitionerBooking
  requiresPrescriberCall
  payment {
    id
    charge {
      id
      createdAt
      amount
    }
  }
  patientQuestions {
    id
    createdAt
    updatedAt
    value
  }
  treatment {
    id
    status
    refillsLeft
    type
    experimentPaymentPlan {
      ...ExperimentPaymentPlan
    }
    experimentAvailablePaymentPlans {
      paymentPlan
      discountPercentage
      cadence
      months
      amount {
        total
        totalSaved
        perMonth
      }
    }
    plan {
      id
      amount
    }
    otcSchedules {
      id
      productId
      createdAt
      updatedAt
      cadence
      isActive
      quantity
      product {
        id
        name
        friendlyName
        photo {
          id
          url
        }
        variants {
          id
          price
        }
      }
    }
    product {
      id
      name
      friendlyName
      productType
      safetyInformation
      shortDescription
      deliveryInformation
      usage
      units
      photo {
        id
        url
      }
      cmi {
        id
        url
      }
      plan {
        id
        intervalCount
        interval
        amount
      }
      faqs {
        id
        title
        markdown
        videoEmbedUrl
      }
      variants {
        id
        price
        isRefill
        inventory {
          id
          sku
        }
      }
    }
  }
  customer {
    id
    email
    firstName
    birthday
    healthCareDetails {
      id
      hasIndividualHealthcareIdentifier
    }
  }
  quizResponses {
    id
    question {
      id
      type
      title
      shortcode
      options {
        value
      }
    }
    response {
      answers {
        value
        imageUrl
      }
      flag {
        level
      }
    }
  }
  doctorQuestions(orderBy: {createdAt: asc}) {
    id
    createdAt
    updatedAt
    value
    allowedAnswerType
    answer {
      id
      createdAt
      updatedAt
      value
    }
    attachments {
      id
      mimetype
      signedUrl
      filename
    }
  }
  doctor {
    id
    firstName
    lastName
    shortClinicianName
    fullClinicianName
    fullName
    role
    bio
    provider {
      id
      qualifications
      clinicianTitle
      clinicianType
    }
    avatar {
      id
      createdAt
      updatedAt
      filename
      mimetype
      url
    }
  }
  quizApplication {
    id
    submittedAt
    answers(orderBy: {createdAt: asc}) {
      id
      answer
      answersArray
      question {
        id
        shortcode
      }
    }
    quiz {
      id
      questions {
        id
        title
        type
        description
        required
        options
        imgUrl
        shortcode
        questionOptions {
          id
          questionId
          option
          position
        }
      }
      logics {
        id
        from {
          id
        }
        elseJump {
          id
        }
        jumps {
          id
          conditions(orderBy: {order: asc}) {
            id
            question {
              id
            }
            value
            operator
            nextCondition
          }
          to {
            id
          }
        }
      }
      skips {
        id
        from {
          id
        }
        conditions(orderBy: {order: asc}) {
          id
          question {
            id
          }
          value
          operator
          nextCondition
        }
      }
      questionsOrder
    }
  }
  order {
    id
    paymentStatus
    lineItems {
      id
      quantity
      variant {
        id
        price
        product {
          id
          name
          friendlyName
          productType
          shortDescription
          photo {
            id
            url
          }
        }
      }
    }
  }
  pathologyRequests {
    id
    createdAt
    customerStatedCollectedAt
    result {
      id
      lab
      releasedAt
      file {
        id
        url
      }
    }
    referral {
      id
      url
      signedUrl
    }
    panels {
      id
      tests {
        id
        name
        result {
          id
          note
          result {
            type
            value
          }
        }
      }
    }
  }
  reminders {
    id
    doneAt
    canceled
    scheduledAt
    createdAt
  }
  screeningQuizApplication {
    id
  }
}
    ${ExperimentPaymentPlanFragmentDoc}`;
export const CustomerAttributesInfoFragmentDoc = gql`
    fragment CustomerAttributesInfo on CustomerAttributes {
  id
  birthday
  age
  conditions
  medications
  allergies
  height
  weight
  bmi
  sex
  smoking
  diabetesRisk {
    diabetesRiskLevel
    diabetesRiskProbability
  }
  menopause {
    menopauseSymptoms
  }
  mentalHealthConditions
  pregnancy {
    pregnant
  }
  hair {
    familyHistoryHairLoss
  }
}
    `;
export const QuizApplicationAnswerFragmentDoc = gql`
    fragment QuizApplicationAnswer on QuizApplication {
  id
  problemType
  customerId
  submittedAt
  answers(orderBy: {createdAt: asc}) {
    id
    answer
    answersArray
    englishAnswer: answer(languageCode: EN_AU)
    englishAnswersArray: answersArray(languageCode: EN_AU)
    question {
      id
      shortcode
    }
  }
  consultation {
    id
    status
    isUpfrontPayment
  }
  responses {
    id
    question {
      id
      type
      title
      shortcode
      options {
        value
      }
    }
    response {
      answers {
        value
        imageUrl
      }
      flag {
        level
      }
    }
  }
}
    `;
export const TreatmentInfoFragmentDoc = gql`
    fragment TreatmentInfo on Treatment {
  id
  updatedAt
  status
  type
  canRefill
  nextPayment
  refillsLeft
  hasUnfulfilledOrder
  canPause
  canReschedule
  weightTreatmentCategory
  treatmentDiscount {
    id
    discountCode {
      ...DiscountCodeForm
    }
  }
  consultation {
    id
    type
    doctor {
      id
      firstName
      lastName
      fullClinicianName
      fullName
    }
  }
  customer {
    id
    email
  }
  plan {
    id
    amount
    products {
      id
      variants {
        id
        inventory {
          id
          sku
        }
      }
    }
  }
  product {
    id
    name
    description
    safetyInformation
    friendlyName
    productType
    drug {
      id
      name
    }
    variants {
      id
      price
      inventory {
        id
        sku
      }
    }
    faqs {
      id
      title
      markdown
    }
    cmi {
      id
      url
    }
    photo {
      id
      url
    }
  }
  script {
    id
    createdAt
  }
  orders(orderBy: {createdAt: desc}) {
    id
    fulfillment
    updatedAt
  }
  otcSchedules {
    id
    createdAt
    updatedAt
    cadence
    isActive
    quantity
    product {
      id
      name
      productType
      variants {
        id
        price
      }
      photo {
        id
        url
      }
    }
  }
  experimentPaymentPlan {
    id
    nextPaymentAmount
    planEndDate
    paymentPlan
    discountPercentage
    months
    otcSchedules {
      id
      product {
        id
        name
      }
    }
  }
  experimentAvailablePaymentPlans {
    paymentPlan
    cadence
  }
}
    ${DiscountCodeFormFragmentDoc}`;
export const UserInfoFragmentDoc = gql`
    fragment UserInfo on User {
  id
  email
  firstName
  lastName
  shortAddressableName
  fullName
  phone
  role
  isPasswordSet
  defaultPaymentGateway
  birthday
  preferredUnitSystem
  residentialAddress {
    id
    line1
    line2
    city
    postalCode
    state
    country
    company
    building
  }
  address {
    id
    line1
    line2
    city
    postalCode
    state
    country
    company
    building
  }
  savedPaymentMethods {
    id
    gateway
    default
    ... on SavedCardPaymentMethod {
      brand
      expiry
      mask
    }
    ... on SavedPayPalPaymentMethod {
      email
    }
    ... on SavedZipPaymentMethod {
      valid
    }
  }
  zip {
    valid
  }
}
    `;
export const NutritionSupportTreatmentFragmentDoc = gql`
    fragment NutritionSupportTreatment on Treatment {
  id
  product {
    id
    name
    friendlyName
    variants {
      id
      inventory {
        id
        sku
      }
    }
  }
  specialisedNutritionSupportSchedule: otcSchedules(
    where: {product: {variants: {some: {inventory: {sku: {equals: $productSKU}}}}}, isActive: {equals: true}}
  ) {
    id
    product {
      id
      name
      variants {
        id
        name
        price
      }
    }
  }
}
    `;
export const OtcSubscriptionPlanInfoFragmentDoc = gql`
    fragment OtcSubscriptionPlanInfo on SubscriptionPlan {
  id
  active
  amount
  cancelAt
  cancelAtPeriodEnd
  currentPeriodEnd
  currentPeriodStart
  daysUntilDue
  interval
  intervalCount
  product {
    id
    name
    friendlyName
    photo {
      id
      url
    }
  }
  sku
  startDate
  status
}
    `;
export const OtcSubscriptionPlanV2InfoFragmentDoc = gql`
    fragment OtcSubscriptionPlanV2Info on SubscriptionPlanV2 {
  id
  name
  description
  photo {
    id
    url
  }
  interval
  intervalCount
  price
}
    `;
export const SubscriptionCardListFragmentDoc = gql`
    fragment SubscriptionCardList on SubscriptionV2 {
  id
  status
  subscriptionPlan {
    id
    name
    interval
    intervalCount
    price
    photo {
      id
      url
    }
  }
  nextPaymentAt
}
    `;
export const CompoundMobileAppBannerDocument = gql`
    query CompoundMobileAppBanner($segmentName: Segment!) {
  inSegment(segmentName: $segmentName)
}
    `;

/**
 * __useCompoundMobileAppBannerQuery__
 *
 * To run a query within a React component, call `useCompoundMobileAppBannerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompoundMobileAppBannerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompoundMobileAppBannerQuery({
 *   variables: {
 *      segmentName: // value for 'segmentName'
 *   },
 * });
 */
export function useCompoundMobileAppBannerQuery(baseOptions: Apollo.QueryHookOptions<CompoundMobileAppBannerQuery, CompoundMobileAppBannerQueryVariables> & ({ variables: CompoundMobileAppBannerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompoundMobileAppBannerQuery, CompoundMobileAppBannerQueryVariables>(CompoundMobileAppBannerDocument, options);
      }
export function useCompoundMobileAppBannerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompoundMobileAppBannerQuery, CompoundMobileAppBannerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompoundMobileAppBannerQuery, CompoundMobileAppBannerQueryVariables>(CompoundMobileAppBannerDocument, options);
        }
export function useCompoundMobileAppBannerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompoundMobileAppBannerQuery, CompoundMobileAppBannerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompoundMobileAppBannerQuery, CompoundMobileAppBannerQueryVariables>(CompoundMobileAppBannerDocument, options);
        }
export type CompoundMobileAppBannerQueryHookResult = ReturnType<typeof useCompoundMobileAppBannerQuery>;
export type CompoundMobileAppBannerLazyQueryHookResult = ReturnType<typeof useCompoundMobileAppBannerLazyQuery>;
export type CompoundMobileAppBannerSuspenseQueryHookResult = ReturnType<typeof useCompoundMobileAppBannerSuspenseQuery>;
export type CompoundMobileAppBannerQueryResult = Apollo.QueryResult<CompoundMobileAppBannerQuery, CompoundMobileAppBannerQueryVariables>;
export const CompoundAsyncConsultConfirmedPageDocument = gql`
    query CompoundAsyncConsultConfirmedPage($consultationId: String!) {
  consultation(id: $consultationId) {
    id
    type
    requiresPrescriberCall
  }
}
    `;

/**
 * __useCompoundAsyncConsultConfirmedPageQuery__
 *
 * To run a query within a React component, call `useCompoundAsyncConsultConfirmedPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompoundAsyncConsultConfirmedPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompoundAsyncConsultConfirmedPageQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function useCompoundAsyncConsultConfirmedPageQuery(baseOptions: Apollo.QueryHookOptions<CompoundAsyncConsultConfirmedPageQuery, CompoundAsyncConsultConfirmedPageQueryVariables> & ({ variables: CompoundAsyncConsultConfirmedPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompoundAsyncConsultConfirmedPageQuery, CompoundAsyncConsultConfirmedPageQueryVariables>(CompoundAsyncConsultConfirmedPageDocument, options);
      }
export function useCompoundAsyncConsultConfirmedPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompoundAsyncConsultConfirmedPageQuery, CompoundAsyncConsultConfirmedPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompoundAsyncConsultConfirmedPageQuery, CompoundAsyncConsultConfirmedPageQueryVariables>(CompoundAsyncConsultConfirmedPageDocument, options);
        }
export function useCompoundAsyncConsultConfirmedPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompoundAsyncConsultConfirmedPageQuery, CompoundAsyncConsultConfirmedPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompoundAsyncConsultConfirmedPageQuery, CompoundAsyncConsultConfirmedPageQueryVariables>(CompoundAsyncConsultConfirmedPageDocument, options);
        }
export type CompoundAsyncConsultConfirmedPageQueryHookResult = ReturnType<typeof useCompoundAsyncConsultConfirmedPageQuery>;
export type CompoundAsyncConsultConfirmedPageLazyQueryHookResult = ReturnType<typeof useCompoundAsyncConsultConfirmedPageLazyQuery>;
export type CompoundAsyncConsultConfirmedPageSuspenseQueryHookResult = ReturnType<typeof useCompoundAsyncConsultConfirmedPageSuspenseQuery>;
export type CompoundAsyncConsultConfirmedPageQueryResult = Apollo.QueryResult<CompoundAsyncConsultConfirmedPageQuery, CompoundAsyncConsultConfirmedPageQueryVariables>;
export const CompoundCollectAddressPageDocument = gql`
    query CompoundCollectAddressPage($consultationId: String!) {
  consultation(id: $consultationId) {
    id
    type
  }
}
    `;

/**
 * __useCompoundCollectAddressPageQuery__
 *
 * To run a query within a React component, call `useCompoundCollectAddressPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompoundCollectAddressPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompoundCollectAddressPageQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function useCompoundCollectAddressPageQuery(baseOptions: Apollo.QueryHookOptions<CompoundCollectAddressPageQuery, CompoundCollectAddressPageQueryVariables> & ({ variables: CompoundCollectAddressPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompoundCollectAddressPageQuery, CompoundCollectAddressPageQueryVariables>(CompoundCollectAddressPageDocument, options);
      }
export function useCompoundCollectAddressPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompoundCollectAddressPageQuery, CompoundCollectAddressPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompoundCollectAddressPageQuery, CompoundCollectAddressPageQueryVariables>(CompoundCollectAddressPageDocument, options);
        }
export function useCompoundCollectAddressPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompoundCollectAddressPageQuery, CompoundCollectAddressPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompoundCollectAddressPageQuery, CompoundCollectAddressPageQueryVariables>(CompoundCollectAddressPageDocument, options);
        }
export type CompoundCollectAddressPageQueryHookResult = ReturnType<typeof useCompoundCollectAddressPageQuery>;
export type CompoundCollectAddressPageLazyQueryHookResult = ReturnType<typeof useCompoundCollectAddressPageLazyQuery>;
export type CompoundCollectAddressPageSuspenseQueryHookResult = ReturnType<typeof useCompoundCollectAddressPageSuspenseQuery>;
export type CompoundCollectAddressPageQueryResult = Apollo.QueryResult<CompoundCollectAddressPageQuery, CompoundCollectAddressPageQueryVariables>;
export const CompoundCollectMedicarePageDocument = gql`
    query CompoundCollectMedicarePage($consultationId: String!) {
  consultation(id: $consultationId) {
    id
    type
    stage
    canSchedulePractitionerBooking
    quizApplication {
      id
      problemType
    }
  }
}
    `;

/**
 * __useCompoundCollectMedicarePageQuery__
 *
 * To run a query within a React component, call `useCompoundCollectMedicarePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompoundCollectMedicarePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompoundCollectMedicarePageQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function useCompoundCollectMedicarePageQuery(baseOptions: Apollo.QueryHookOptions<CompoundCollectMedicarePageQuery, CompoundCollectMedicarePageQueryVariables> & ({ variables: CompoundCollectMedicarePageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompoundCollectMedicarePageQuery, CompoundCollectMedicarePageQueryVariables>(CompoundCollectMedicarePageDocument, options);
      }
export function useCompoundCollectMedicarePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompoundCollectMedicarePageQuery, CompoundCollectMedicarePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompoundCollectMedicarePageQuery, CompoundCollectMedicarePageQueryVariables>(CompoundCollectMedicarePageDocument, options);
        }
export function useCompoundCollectMedicarePageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompoundCollectMedicarePageQuery, CompoundCollectMedicarePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompoundCollectMedicarePageQuery, CompoundCollectMedicarePageQueryVariables>(CompoundCollectMedicarePageDocument, options);
        }
export type CompoundCollectMedicarePageQueryHookResult = ReturnType<typeof useCompoundCollectMedicarePageQuery>;
export type CompoundCollectMedicarePageLazyQueryHookResult = ReturnType<typeof useCompoundCollectMedicarePageLazyQuery>;
export type CompoundCollectMedicarePageSuspenseQueryHookResult = ReturnType<typeof useCompoundCollectMedicarePageSuspenseQuery>;
export type CompoundCollectMedicarePageQueryResult = Apollo.QueryResult<CompoundCollectMedicarePageQuery, CompoundCollectMedicarePageQueryVariables>;
export const CompoundAsyncEligibleMedicarePageDocument = gql`
    query CompoundAsyncEligibleMedicarePage($consultationId: String!, $problemType: ProblemType!) {
  consultation(id: $consultationId) {
    id
    customer {
      id
      ... on User {
        condition(problemType: $problemType) {
          id
          asyncEligible
        }
      }
    }
  }
}
    `;

/**
 * __useCompoundAsyncEligibleMedicarePageQuery__
 *
 * To run a query within a React component, call `useCompoundAsyncEligibleMedicarePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompoundAsyncEligibleMedicarePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompoundAsyncEligibleMedicarePageQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *      problemType: // value for 'problemType'
 *   },
 * });
 */
export function useCompoundAsyncEligibleMedicarePageQuery(baseOptions: Apollo.QueryHookOptions<CompoundAsyncEligibleMedicarePageQuery, CompoundAsyncEligibleMedicarePageQueryVariables> & ({ variables: CompoundAsyncEligibleMedicarePageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompoundAsyncEligibleMedicarePageQuery, CompoundAsyncEligibleMedicarePageQueryVariables>(CompoundAsyncEligibleMedicarePageDocument, options);
      }
export function useCompoundAsyncEligibleMedicarePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompoundAsyncEligibleMedicarePageQuery, CompoundAsyncEligibleMedicarePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompoundAsyncEligibleMedicarePageQuery, CompoundAsyncEligibleMedicarePageQueryVariables>(CompoundAsyncEligibleMedicarePageDocument, options);
        }
export function useCompoundAsyncEligibleMedicarePageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompoundAsyncEligibleMedicarePageQuery, CompoundAsyncEligibleMedicarePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompoundAsyncEligibleMedicarePageQuery, CompoundAsyncEligibleMedicarePageQueryVariables>(CompoundAsyncEligibleMedicarePageDocument, options);
        }
export type CompoundAsyncEligibleMedicarePageQueryHookResult = ReturnType<typeof useCompoundAsyncEligibleMedicarePageQuery>;
export type CompoundAsyncEligibleMedicarePageLazyQueryHookResult = ReturnType<typeof useCompoundAsyncEligibleMedicarePageLazyQuery>;
export type CompoundAsyncEligibleMedicarePageSuspenseQueryHookResult = ReturnType<typeof useCompoundAsyncEligibleMedicarePageSuspenseQuery>;
export type CompoundAsyncEligibleMedicarePageQueryResult = Apollo.QueryResult<CompoundAsyncEligibleMedicarePageQuery, CompoundAsyncEligibleMedicarePageQueryVariables>;
export const CompoundOrderConfirmationPageDocument = gql`
    query CompoundOrderConfirmationPage($consultationId: String!, $segmentName: Segment!) {
  consultation(id: $consultationId) {
    id
    type
    isUpfrontPayment
    doctor {
      id
      fullName
      fullClinicianName
    }
  }
  inSegment(segmentName: $segmentName)
}
    `;

/**
 * __useCompoundOrderConfirmationPageQuery__
 *
 * To run a query within a React component, call `useCompoundOrderConfirmationPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompoundOrderConfirmationPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompoundOrderConfirmationPageQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *      segmentName: // value for 'segmentName'
 *   },
 * });
 */
export function useCompoundOrderConfirmationPageQuery(baseOptions: Apollo.QueryHookOptions<CompoundOrderConfirmationPageQuery, CompoundOrderConfirmationPageQueryVariables> & ({ variables: CompoundOrderConfirmationPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompoundOrderConfirmationPageQuery, CompoundOrderConfirmationPageQueryVariables>(CompoundOrderConfirmationPageDocument, options);
      }
export function useCompoundOrderConfirmationPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompoundOrderConfirmationPageQuery, CompoundOrderConfirmationPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompoundOrderConfirmationPageQuery, CompoundOrderConfirmationPageQueryVariables>(CompoundOrderConfirmationPageDocument, options);
        }
export function useCompoundOrderConfirmationPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompoundOrderConfirmationPageQuery, CompoundOrderConfirmationPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompoundOrderConfirmationPageQuery, CompoundOrderConfirmationPageQueryVariables>(CompoundOrderConfirmationPageDocument, options);
        }
export type CompoundOrderConfirmationPageQueryHookResult = ReturnType<typeof useCompoundOrderConfirmationPageQuery>;
export type CompoundOrderConfirmationPageLazyQueryHookResult = ReturnType<typeof useCompoundOrderConfirmationPageLazyQuery>;
export type CompoundOrderConfirmationPageSuspenseQueryHookResult = ReturnType<typeof useCompoundOrderConfirmationPageSuspenseQuery>;
export type CompoundOrderConfirmationPageQueryResult = Apollo.QueryResult<CompoundOrderConfirmationPageQuery, CompoundOrderConfirmationPageQueryVariables>;
export const CompoundConfirmationPageDocument = gql`
    query CompoundConfirmationPage($consultationId: String!) {
  consultation(id: $consultationId) {
    id
    type
    createdAt
    stage
    isApproved
    screeningQuizApplication {
      id
    }
    isUpfrontPayment
    customer {
      id
      email
    }
  }
}
    `;

/**
 * __useCompoundConfirmationPageQuery__
 *
 * To run a query within a React component, call `useCompoundConfirmationPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompoundConfirmationPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompoundConfirmationPageQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function useCompoundConfirmationPageQuery(baseOptions: Apollo.QueryHookOptions<CompoundConfirmationPageQuery, CompoundConfirmationPageQueryVariables> & ({ variables: CompoundConfirmationPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompoundConfirmationPageQuery, CompoundConfirmationPageQueryVariables>(CompoundConfirmationPageDocument, options);
      }
export function useCompoundConfirmationPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompoundConfirmationPageQuery, CompoundConfirmationPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompoundConfirmationPageQuery, CompoundConfirmationPageQueryVariables>(CompoundConfirmationPageDocument, options);
        }
export function useCompoundConfirmationPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompoundConfirmationPageQuery, CompoundConfirmationPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompoundConfirmationPageQuery, CompoundConfirmationPageQueryVariables>(CompoundConfirmationPageDocument, options);
        }
export type CompoundConfirmationPageQueryHookResult = ReturnType<typeof useCompoundConfirmationPageQuery>;
export type CompoundConfirmationPageLazyQueryHookResult = ReturnType<typeof useCompoundConfirmationPageLazyQuery>;
export type CompoundConfirmationPageSuspenseQueryHookResult = ReturnType<typeof useCompoundConfirmationPageSuspenseQuery>;
export type CompoundConfirmationPageQueryResult = Apollo.QueryResult<CompoundConfirmationPageQuery, CompoundConfirmationPageQueryVariables>;
export const CompoundConsultationCreateAccountDocument = gql`
    query CompoundConsultationCreateAccount($consultationId: String!, $bnplEnabled: Boolean!) {
  consultation(id: $consultationId) {
    id
    type
    isUpfrontPayment
    purchasePrompt @include(if: $bnplEnabled) {
      id
    }
  }
}
    `;

/**
 * __useCompoundConsultationCreateAccountQuery__
 *
 * To run a query within a React component, call `useCompoundConsultationCreateAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompoundConsultationCreateAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompoundConsultationCreateAccountQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *      bnplEnabled: // value for 'bnplEnabled'
 *   },
 * });
 */
export function useCompoundConsultationCreateAccountQuery(baseOptions: Apollo.QueryHookOptions<CompoundConsultationCreateAccountQuery, CompoundConsultationCreateAccountQueryVariables> & ({ variables: CompoundConsultationCreateAccountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompoundConsultationCreateAccountQuery, CompoundConsultationCreateAccountQueryVariables>(CompoundConsultationCreateAccountDocument, options);
      }
export function useCompoundConsultationCreateAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompoundConsultationCreateAccountQuery, CompoundConsultationCreateAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompoundConsultationCreateAccountQuery, CompoundConsultationCreateAccountQueryVariables>(CompoundConsultationCreateAccountDocument, options);
        }
export function useCompoundConsultationCreateAccountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompoundConsultationCreateAccountQuery, CompoundConsultationCreateAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompoundConsultationCreateAccountQuery, CompoundConsultationCreateAccountQueryVariables>(CompoundConsultationCreateAccountDocument, options);
        }
export type CompoundConsultationCreateAccountQueryHookResult = ReturnType<typeof useCompoundConsultationCreateAccountQuery>;
export type CompoundConsultationCreateAccountLazyQueryHookResult = ReturnType<typeof useCompoundConsultationCreateAccountLazyQuery>;
export type CompoundConsultationCreateAccountSuspenseQueryHookResult = ReturnType<typeof useCompoundConsultationCreateAccountSuspenseQuery>;
export type CompoundConsultationCreateAccountQueryResult = Apollo.QueryResult<CompoundConsultationCreateAccountQuery, CompoundConsultationCreateAccountQueryVariables>;
export const GippDocument = gql`
    query GIPP($consultationId: String, $pricingSessionId: ID!, $offeringSelections: [OfferingSelectionInput!]!) {
  initialPurchasePrice(
    consultationId: $consultationId
    pricingSessionId: $pricingSessionId
    offeringSelections: $offeringSelections
  ) {
    id
    amount
  }
}
    `;

/**
 * __useGippQuery__
 *
 * To run a query within a React component, call `useGippQuery` and pass it any options that fit your needs.
 * When your component renders, `useGippQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGippQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *      pricingSessionId: // value for 'pricingSessionId'
 *      offeringSelections: // value for 'offeringSelections'
 *   },
 * });
 */
export function useGippQuery(baseOptions: Apollo.QueryHookOptions<GippQuery, GippQueryVariables> & ({ variables: GippQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GippQuery, GippQueryVariables>(GippDocument, options);
      }
export function useGippLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GippQuery, GippQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GippQuery, GippQueryVariables>(GippDocument, options);
        }
export function useGippSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GippQuery, GippQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GippQuery, GippQueryVariables>(GippDocument, options);
        }
export type GippQueryHookResult = ReturnType<typeof useGippQuery>;
export type GippLazyQueryHookResult = ReturnType<typeof useGippLazyQuery>;
export type GippSuspenseQueryHookResult = ReturnType<typeof useGippSuspenseQuery>;
export type GippQueryResult = Apollo.QueryResult<GippQuery, GippQueryVariables>;
export const AnytimePurchaseDocument = gql`
    query AnytimePurchase {
  profile {
    id
    purchases {
      id
      status
      offering {
        id
        friendlyName
      }
      contexts {
        id
        status
      }
    }
    consultations {
      id
      purchasePrompt {
        __typename
        id
        ... on InitialPurchasePrompt {
          proposedOfferingSelection {
            ...AnytimePurchaseOfferingSelection
          }
        }
        ... on SubstitutePurchasePrompt {
          id
          pricingSessionId
          substitutions {
            id
            purchased {
              id
            }
            substitution {
              ...AnytimePurchaseOfferingSelection
            }
          }
        }
      }
    }
  }
}
    ${AnytimePurchaseOfferingSelectionFragmentDoc}`;

/**
 * __useAnytimePurchaseQuery__
 *
 * To run a query within a React component, call `useAnytimePurchaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnytimePurchaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnytimePurchaseQuery({
 *   variables: {
 *   },
 * });
 */
export function useAnytimePurchaseQuery(baseOptions?: Apollo.QueryHookOptions<AnytimePurchaseQuery, AnytimePurchaseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnytimePurchaseQuery, AnytimePurchaseQueryVariables>(AnytimePurchaseDocument, options);
      }
export function useAnytimePurchaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnytimePurchaseQuery, AnytimePurchaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnytimePurchaseQuery, AnytimePurchaseQueryVariables>(AnytimePurchaseDocument, options);
        }
export function useAnytimePurchaseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AnytimePurchaseQuery, AnytimePurchaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnytimePurchaseQuery, AnytimePurchaseQueryVariables>(AnytimePurchaseDocument, options);
        }
export type AnytimePurchaseQueryHookResult = ReturnType<typeof useAnytimePurchaseQuery>;
export type AnytimePurchaseLazyQueryHookResult = ReturnType<typeof useAnytimePurchaseLazyQuery>;
export type AnytimePurchaseSuspenseQueryHookResult = ReturnType<typeof useAnytimePurchaseSuspenseQuery>;
export type AnytimePurchaseQueryResult = Apollo.QueryResult<AnytimePurchaseQuery, AnytimePurchaseQueryVariables>;
export const AnytimePurchasePurchaseOfferingsDocument = gql`
    mutation AnytimePurchasePurchaseOfferings($input: PurchaseOfferingsInput!) {
  purchaseOfferings(input: $input) {
    purchaseGroup {
      id
      purchases {
        id
      }
    }
  }
}
    `;
export type AnytimePurchasePurchaseOfferingsMutationFn = Apollo.MutationFunction<AnytimePurchasePurchaseOfferingsMutation, AnytimePurchasePurchaseOfferingsMutationVariables>;

/**
 * __useAnytimePurchasePurchaseOfferingsMutation__
 *
 * To run a mutation, you first call `useAnytimePurchasePurchaseOfferingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnytimePurchasePurchaseOfferingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [anytimePurchasePurchaseOfferingsMutation, { data, loading, error }] = useAnytimePurchasePurchaseOfferingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAnytimePurchasePurchaseOfferingsMutation(baseOptions?: Apollo.MutationHookOptions<AnytimePurchasePurchaseOfferingsMutation, AnytimePurchasePurchaseOfferingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnytimePurchasePurchaseOfferingsMutation, AnytimePurchasePurchaseOfferingsMutationVariables>(AnytimePurchasePurchaseOfferingsDocument, options);
      }
export type AnytimePurchasePurchaseOfferingsMutationHookResult = ReturnType<typeof useAnytimePurchasePurchaseOfferingsMutation>;
export type AnytimePurchasePurchaseOfferingsMutationResult = Apollo.MutationResult<AnytimePurchasePurchaseOfferingsMutation>;
export type AnytimePurchasePurchaseOfferingsMutationOptions = Apollo.BaseMutationOptions<AnytimePurchasePurchaseOfferingsMutation, AnytimePurchasePurchaseOfferingsMutationVariables>;
export const CompoundFollowUpConsultationDocument = gql`
    query CompoundFollowUpConsultation($id: String!) {
  consultation(id: $id) {
    id
    status
    type
  }
}
    `;

/**
 * __useCompoundFollowUpConsultationQuery__
 *
 * To run a query within a React component, call `useCompoundFollowUpConsultationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompoundFollowUpConsultationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompoundFollowUpConsultationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompoundFollowUpConsultationQuery(baseOptions: Apollo.QueryHookOptions<CompoundFollowUpConsultationQuery, CompoundFollowUpConsultationQueryVariables> & ({ variables: CompoundFollowUpConsultationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompoundFollowUpConsultationQuery, CompoundFollowUpConsultationQueryVariables>(CompoundFollowUpConsultationDocument, options);
      }
export function useCompoundFollowUpConsultationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompoundFollowUpConsultationQuery, CompoundFollowUpConsultationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompoundFollowUpConsultationQuery, CompoundFollowUpConsultationQueryVariables>(CompoundFollowUpConsultationDocument, options);
        }
export function useCompoundFollowUpConsultationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompoundFollowUpConsultationQuery, CompoundFollowUpConsultationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompoundFollowUpConsultationQuery, CompoundFollowUpConsultationQueryVariables>(CompoundFollowUpConsultationDocument, options);
        }
export type CompoundFollowUpConsultationQueryHookResult = ReturnType<typeof useCompoundFollowUpConsultationQuery>;
export type CompoundFollowUpConsultationLazyQueryHookResult = ReturnType<typeof useCompoundFollowUpConsultationLazyQuery>;
export type CompoundFollowUpConsultationSuspenseQueryHookResult = ReturnType<typeof useCompoundFollowUpConsultationSuspenseQuery>;
export type CompoundFollowUpConsultationQueryResult = Apollo.QueryResult<CompoundFollowUpConsultationQuery, CompoundFollowUpConsultationQueryVariables>;
export const CompoundPracBookingConfirmationPageDocument = gql`
    query CompoundPracBookingConfirmationPage($pracBookingId: ID!) {
  practitionerBooking(id: $pracBookingId) {
    id
    consultation {
      id
      type
    }
    patient {
      id
      email
      phone
    }
    windowStartAt
    windowEndAt
  }
  validPhoneRegions {
    id
    countryCode
  }
}
    `;

/**
 * __useCompoundPracBookingConfirmationPageQuery__
 *
 * To run a query within a React component, call `useCompoundPracBookingConfirmationPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompoundPracBookingConfirmationPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompoundPracBookingConfirmationPageQuery({
 *   variables: {
 *      pracBookingId: // value for 'pracBookingId'
 *   },
 * });
 */
export function useCompoundPracBookingConfirmationPageQuery(baseOptions: Apollo.QueryHookOptions<CompoundPracBookingConfirmationPageQuery, CompoundPracBookingConfirmationPageQueryVariables> & ({ variables: CompoundPracBookingConfirmationPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompoundPracBookingConfirmationPageQuery, CompoundPracBookingConfirmationPageQueryVariables>(CompoundPracBookingConfirmationPageDocument, options);
      }
export function useCompoundPracBookingConfirmationPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompoundPracBookingConfirmationPageQuery, CompoundPracBookingConfirmationPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompoundPracBookingConfirmationPageQuery, CompoundPracBookingConfirmationPageQueryVariables>(CompoundPracBookingConfirmationPageDocument, options);
        }
export function useCompoundPracBookingConfirmationPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompoundPracBookingConfirmationPageQuery, CompoundPracBookingConfirmationPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompoundPracBookingConfirmationPageQuery, CompoundPracBookingConfirmationPageQueryVariables>(CompoundPracBookingConfirmationPageDocument, options);
        }
export type CompoundPracBookingConfirmationPageQueryHookResult = ReturnType<typeof useCompoundPracBookingConfirmationPageQuery>;
export type CompoundPracBookingConfirmationPageLazyQueryHookResult = ReturnType<typeof useCompoundPracBookingConfirmationPageLazyQuery>;
export type CompoundPracBookingConfirmationPageSuspenseQueryHookResult = ReturnType<typeof useCompoundPracBookingConfirmationPageSuspenseQuery>;
export type CompoundPracBookingConfirmationPageQueryResult = Apollo.QueryResult<CompoundPracBookingConfirmationPageQuery, CompoundPracBookingConfirmationPageQueryVariables>;
export const CompoundPractitionerPhoneCallPageDocument = gql`
    query CompoundPractitionerPhoneCallPage($consultationId: String!) {
  consultation(id: $consultationId) {
    id
    latestPractitionerBooking {
      id
    }
  }
}
    `;

/**
 * __useCompoundPractitionerPhoneCallPageQuery__
 *
 * To run a query within a React component, call `useCompoundPractitionerPhoneCallPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompoundPractitionerPhoneCallPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompoundPractitionerPhoneCallPageQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function useCompoundPractitionerPhoneCallPageQuery(baseOptions: Apollo.QueryHookOptions<CompoundPractitionerPhoneCallPageQuery, CompoundPractitionerPhoneCallPageQueryVariables> & ({ variables: CompoundPractitionerPhoneCallPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompoundPractitionerPhoneCallPageQuery, CompoundPractitionerPhoneCallPageQueryVariables>(CompoundPractitionerPhoneCallPageDocument, options);
      }
export function useCompoundPractitionerPhoneCallPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompoundPractitionerPhoneCallPageQuery, CompoundPractitionerPhoneCallPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompoundPractitionerPhoneCallPageQuery, CompoundPractitionerPhoneCallPageQueryVariables>(CompoundPractitionerPhoneCallPageDocument, options);
        }
export function useCompoundPractitionerPhoneCallPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompoundPractitionerPhoneCallPageQuery, CompoundPractitionerPhoneCallPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompoundPractitionerPhoneCallPageQuery, CompoundPractitionerPhoneCallPageQueryVariables>(CompoundPractitionerPhoneCallPageDocument, options);
        }
export type CompoundPractitionerPhoneCallPageQueryHookResult = ReturnType<typeof useCompoundPractitionerPhoneCallPageQuery>;
export type CompoundPractitionerPhoneCallPageLazyQueryHookResult = ReturnType<typeof useCompoundPractitionerPhoneCallPageLazyQuery>;
export type CompoundPractitionerPhoneCallPageSuspenseQueryHookResult = ReturnType<typeof useCompoundPractitionerPhoneCallPageSuspenseQuery>;
export type CompoundPractitionerPhoneCallPageQueryResult = Apollo.QueryResult<CompoundPractitionerPhoneCallPageQuery, CompoundPractitionerPhoneCallPageQueryVariables>;
export const CompoundSchedulePhoneCallPageDocument = gql`
    query CompoundSchedulePhoneCallPage($consultationId: String!) {
  consultation(id: $consultationId) {
    id
    latestPractitionerBooking {
      id
    }
  }
}
    `;

/**
 * __useCompoundSchedulePhoneCallPageQuery__
 *
 * To run a query within a React component, call `useCompoundSchedulePhoneCallPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompoundSchedulePhoneCallPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompoundSchedulePhoneCallPageQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function useCompoundSchedulePhoneCallPageQuery(baseOptions: Apollo.QueryHookOptions<CompoundSchedulePhoneCallPageQuery, CompoundSchedulePhoneCallPageQueryVariables> & ({ variables: CompoundSchedulePhoneCallPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompoundSchedulePhoneCallPageQuery, CompoundSchedulePhoneCallPageQueryVariables>(CompoundSchedulePhoneCallPageDocument, options);
      }
export function useCompoundSchedulePhoneCallPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompoundSchedulePhoneCallPageQuery, CompoundSchedulePhoneCallPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompoundSchedulePhoneCallPageQuery, CompoundSchedulePhoneCallPageQueryVariables>(CompoundSchedulePhoneCallPageDocument, options);
        }
export function useCompoundSchedulePhoneCallPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompoundSchedulePhoneCallPageQuery, CompoundSchedulePhoneCallPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompoundSchedulePhoneCallPageQuery, CompoundSchedulePhoneCallPageQueryVariables>(CompoundSchedulePhoneCallPageDocument, options);
        }
export type CompoundSchedulePhoneCallPageQueryHookResult = ReturnType<typeof useCompoundSchedulePhoneCallPageQuery>;
export type CompoundSchedulePhoneCallPageLazyQueryHookResult = ReturnType<typeof useCompoundSchedulePhoneCallPageLazyQuery>;
export type CompoundSchedulePhoneCallPageSuspenseQueryHookResult = ReturnType<typeof useCompoundSchedulePhoneCallPageSuspenseQuery>;
export type CompoundSchedulePhoneCallPageQueryResult = Apollo.QueryResult<CompoundSchedulePhoneCallPageQuery, CompoundSchedulePhoneCallPageQueryVariables>;
export const CompoundAccountPageDocument = gql`
    query CompoundAccountPage {
  profile {
    id
    weightTreatmentCategory
    zip {
      valid
    }
    address {
      ...RangeShippingDetailsAddress
    }
    ...BillingDetails
    ...PersonalDetails
  }
  validPhoneRegions {
    id
    countryCode
  }
}
    ${RangeShippingDetailsAddressFragmentDoc}
${BillingDetailsFragmentDoc}
${PersonalDetailsFragmentDoc}`;

/**
 * __useCompoundAccountPageQuery__
 *
 * To run a query within a React component, call `useCompoundAccountPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompoundAccountPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompoundAccountPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompoundAccountPageQuery(baseOptions?: Apollo.QueryHookOptions<CompoundAccountPageQuery, CompoundAccountPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompoundAccountPageQuery, CompoundAccountPageQueryVariables>(CompoundAccountPageDocument, options);
      }
export function useCompoundAccountPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompoundAccountPageQuery, CompoundAccountPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompoundAccountPageQuery, CompoundAccountPageQueryVariables>(CompoundAccountPageDocument, options);
        }
export function useCompoundAccountPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompoundAccountPageQuery, CompoundAccountPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompoundAccountPageQuery, CompoundAccountPageQueryVariables>(CompoundAccountPageDocument, options);
        }
export type CompoundAccountPageQueryHookResult = ReturnType<typeof useCompoundAccountPageQuery>;
export type CompoundAccountPageLazyQueryHookResult = ReturnType<typeof useCompoundAccountPageLazyQuery>;
export type CompoundAccountPageSuspenseQueryHookResult = ReturnType<typeof useCompoundAccountPageSuspenseQuery>;
export type CompoundAccountPageQueryResult = Apollo.QueryResult<CompoundAccountPageQuery, CompoundAccountPageQueryVariables>;
export const UpdatePasswordDocument = gql`
    mutation UpdatePassword($currentPassword: String!, $newPassword: String!) {
  updatePassword(currentPassword: $currentPassword, newPassword: $newPassword)
}
    `;
export type UpdatePasswordMutationFn = Apollo.MutationFunction<UpdatePasswordMutation, UpdatePasswordMutationVariables>;

/**
 * __useUpdatePasswordMutation__
 *
 * To run a mutation, you first call `useUpdatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePasswordMutation, { data, loading, error }] = useUpdatePasswordMutation({
 *   variables: {
 *      currentPassword: // value for 'currentPassword'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useUpdatePasswordMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePasswordMutation, UpdatePasswordMutationVariables>(UpdatePasswordDocument, options);
      }
export type UpdatePasswordMutationHookResult = ReturnType<typeof useUpdatePasswordMutation>;
export type UpdatePasswordMutationResult = Apollo.MutationResult<UpdatePasswordMutation>;
export type UpdatePasswordMutationOptions = Apollo.BaseMutationOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>;
export const CompoundProfilePageDocument = gql`
    query CompoundProfilePage {
  profile {
    id
    mobileAppAccess {
      id
    }
    shortAddressableName
    initialQuizApplications: quizApplications(purpose: INITIAL) {
      id
      ...CompoundProfilePageInitialQuizApplication
    }
    needsSubscriptionMigration
    subscriptionsV2: subscriptions {
      id
      status
      nextPaymentAt
      subscriptionPlan {
        id
        name
        interval
        intervalCount
        price
        photo {
          id
          url
        }
      }
    }
    consultations {
      id
      ...CompoundProfilePageConsultation
    }
    purchases {
      id
      ...CompoundProfilePagePurchase
    }
    isBeingTreatedForWeight: isBeingTreated(problemType: WEIGHT_LOSS)
  }
  customerAttributes {
    id
  }
  subscriptionsV1: subscriptionPlans {
    id
    active
    amount
    cancelAt
    cancelAtPeriodEnd
    interval
    intervalCount
    status
    currentPeriodEnd
    product {
      id
      name
      friendlyName
      photo {
        id
        url
      }
    }
  }
  ...CompoundProfilePageUserSegments
}
    ${CompoundProfilePageInitialQuizApplicationFragmentDoc}
${CompoundProfilePageConsultationFragmentDoc}
${CompoundProfilePagePurchaseFragmentDoc}
${CompoundProfilePageUserSegmentsFragmentDoc}`;

/**
 * __useCompoundProfilePageQuery__
 *
 * To run a query within a React component, call `useCompoundProfilePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompoundProfilePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompoundProfilePageQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompoundProfilePageQuery(baseOptions?: Apollo.QueryHookOptions<CompoundProfilePageQuery, CompoundProfilePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompoundProfilePageQuery, CompoundProfilePageQueryVariables>(CompoundProfilePageDocument, options);
      }
export function useCompoundProfilePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompoundProfilePageQuery, CompoundProfilePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompoundProfilePageQuery, CompoundProfilePageQueryVariables>(CompoundProfilePageDocument, options);
        }
export function useCompoundProfilePageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompoundProfilePageQuery, CompoundProfilePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompoundProfilePageQuery, CompoundProfilePageQueryVariables>(CompoundProfilePageDocument, options);
        }
export type CompoundProfilePageQueryHookResult = ReturnType<typeof useCompoundProfilePageQuery>;
export type CompoundProfilePageLazyQueryHookResult = ReturnType<typeof useCompoundProfilePageLazyQuery>;
export type CompoundProfilePageSuspenseQueryHookResult = ReturnType<typeof useCompoundProfilePageSuspenseQuery>;
export type CompoundProfilePageQueryResult = Apollo.QueryResult<CompoundProfilePageQuery, CompoundProfilePageQueryVariables>;
export const CompoundOtcPurchaseDocument = gql`
    query CompoundOtcPurchase($offeringSelections: [OfferingSelectionInput!]!, $pricingSessionId: ID!, $userId: String, $userIsAnonymous: Boolean!, $hasOfferingsSelections: Boolean!, $couponCodes: [String!]) {
  initialPurchasePrice(
    offeringSelections: $offeringSelections
    pricingSessionId: $pricingSessionId
    userId: $userId
    couponCodes: $couponCodes
  ) @include(if: $hasOfferingsSelections) {
    id
    amount
    originalAmount
    coupons {
      id
      code
      outcome
    }
    offeringPriceLists {
      id
      sequencePriceLists {
        id
        pricedItems {
          id
          quantity
          unitPrice
          unitPriceDiscount
          variant {
            id
            product {
              id
              name
            }
          }
        }
      }
      offering {
        id
        photoUrl
        friendlyName
        advertisedShippingCadence
      }
    }
  }
  profile @skip(if: $userIsAnonymous) {
    id
    email
    lastName
    firstName
    address {
      id
    }
    residentialAddress {
      id
      city
      line1
      line2
      state
      country
      postalCode
      prefecture
      municipality
      townArea
    }
  }
}
    `;

/**
 * __useCompoundOtcPurchaseQuery__
 *
 * To run a query within a React component, call `useCompoundOtcPurchaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompoundOtcPurchaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompoundOtcPurchaseQuery({
 *   variables: {
 *      offeringSelections: // value for 'offeringSelections'
 *      pricingSessionId: // value for 'pricingSessionId'
 *      userId: // value for 'userId'
 *      userIsAnonymous: // value for 'userIsAnonymous'
 *      hasOfferingsSelections: // value for 'hasOfferingsSelections'
 *      couponCodes: // value for 'couponCodes'
 *   },
 * });
 */
export function useCompoundOtcPurchaseQuery(baseOptions: Apollo.QueryHookOptions<CompoundOtcPurchaseQuery, CompoundOtcPurchaseQueryVariables> & ({ variables: CompoundOtcPurchaseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompoundOtcPurchaseQuery, CompoundOtcPurchaseQueryVariables>(CompoundOtcPurchaseDocument, options);
      }
export function useCompoundOtcPurchaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompoundOtcPurchaseQuery, CompoundOtcPurchaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompoundOtcPurchaseQuery, CompoundOtcPurchaseQueryVariables>(CompoundOtcPurchaseDocument, options);
        }
export function useCompoundOtcPurchaseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompoundOtcPurchaseQuery, CompoundOtcPurchaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompoundOtcPurchaseQuery, CompoundOtcPurchaseQueryVariables>(CompoundOtcPurchaseDocument, options);
        }
export type CompoundOtcPurchaseQueryHookResult = ReturnType<typeof useCompoundOtcPurchaseQuery>;
export type CompoundOtcPurchaseLazyQueryHookResult = ReturnType<typeof useCompoundOtcPurchaseLazyQuery>;
export type CompoundOtcPurchaseSuspenseQueryHookResult = ReturnType<typeof useCompoundOtcPurchaseSuspenseQuery>;
export type CompoundOtcPurchaseQueryResult = Apollo.QueryResult<CompoundOtcPurchaseQuery, CompoundOtcPurchaseQueryVariables>;
export const CompoundPurchaseConfirmUpdateUserDocument = gql`
    mutation CompoundPurchaseConfirmUpdateUser($firstName: String!, $lastName: String!, $residentialAddress: ResidentialAddressCreateInput!) {
  updateProfile(firstName: $firstName, lastName: $lastName) {
    id
    firstName
    lastName
  }
  updateResidentialAddress(residentialAddress: $residentialAddress) {
    id
    line1
    line2
    state
    country
    company
    building
    postalCode
    city
  }
}
    `;
export type CompoundPurchaseConfirmUpdateUserMutationFn = Apollo.MutationFunction<CompoundPurchaseConfirmUpdateUserMutation, CompoundPurchaseConfirmUpdateUserMutationVariables>;

/**
 * __useCompoundPurchaseConfirmUpdateUserMutation__
 *
 * To run a mutation, you first call `useCompoundPurchaseConfirmUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompoundPurchaseConfirmUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [compoundPurchaseConfirmUpdateUserMutation, { data, loading, error }] = useCompoundPurchaseConfirmUpdateUserMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      residentialAddress: // value for 'residentialAddress'
 *   },
 * });
 */
export function useCompoundPurchaseConfirmUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<CompoundPurchaseConfirmUpdateUserMutation, CompoundPurchaseConfirmUpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompoundPurchaseConfirmUpdateUserMutation, CompoundPurchaseConfirmUpdateUserMutationVariables>(CompoundPurchaseConfirmUpdateUserDocument, options);
      }
export type CompoundPurchaseConfirmUpdateUserMutationHookResult = ReturnType<typeof useCompoundPurchaseConfirmUpdateUserMutation>;
export type CompoundPurchaseConfirmUpdateUserMutationResult = Apollo.MutationResult<CompoundPurchaseConfirmUpdateUserMutation>;
export type CompoundPurchaseConfirmUpdateUserMutationOptions = Apollo.BaseMutationOptions<CompoundPurchaseConfirmUpdateUserMutation, CompoundPurchaseConfirmUpdateUserMutationVariables>;
export const CompletedPurchasesPageDocument = gql`
    query CompletedPurchasesPage {
  profile {
    id
    email
    residentialAddress {
      building
      city
      company
      country
      createdAt
      id
      line1
      line2
      municipality
      postalCode
      prefecture
      state
      townArea
      updatedAt
    }
  }
}
    `;

/**
 * __useCompletedPurchasesPageQuery__
 *
 * To run a query within a React component, call `useCompletedPurchasesPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompletedPurchasesPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompletedPurchasesPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompletedPurchasesPageQuery(baseOptions?: Apollo.QueryHookOptions<CompletedPurchasesPageQuery, CompletedPurchasesPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompletedPurchasesPageQuery, CompletedPurchasesPageQueryVariables>(CompletedPurchasesPageDocument, options);
      }
export function useCompletedPurchasesPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompletedPurchasesPageQuery, CompletedPurchasesPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompletedPurchasesPageQuery, CompletedPurchasesPageQueryVariables>(CompletedPurchasesPageDocument, options);
        }
export function useCompletedPurchasesPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompletedPurchasesPageQuery, CompletedPurchasesPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompletedPurchasesPageQuery, CompletedPurchasesPageQueryVariables>(CompletedPurchasesPageDocument, options);
        }
export type CompletedPurchasesPageQueryHookResult = ReturnType<typeof useCompletedPurchasesPageQuery>;
export type CompletedPurchasesPageLazyQueryHookResult = ReturnType<typeof useCompletedPurchasesPageLazyQuery>;
export type CompletedPurchasesPageSuspenseQueryHookResult = ReturnType<typeof useCompletedPurchasesPageSuspenseQuery>;
export type CompletedPurchasesPageQueryResult = Apollo.QueryResult<CompletedPurchasesPageQuery, CompletedPurchasesPageQueryVariables>;
export const ConfirmAsyncConsultationDocument = gql`
    mutation ConfirmAsyncConsultation($input: ConfirmAsyncConsultationInput!) {
  confirmAsyncConsultation(input: $input) {
    consultation {
      id
    }
  }
}
    `;
export type ConfirmAsyncConsultationMutationFn = Apollo.MutationFunction<ConfirmAsyncConsultationMutation, ConfirmAsyncConsultationMutationVariables>;

/**
 * __useConfirmAsyncConsultationMutation__
 *
 * To run a mutation, you first call `useConfirmAsyncConsultationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmAsyncConsultationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmAsyncConsultationMutation, { data, loading, error }] = useConfirmAsyncConsultationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmAsyncConsultationMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmAsyncConsultationMutation, ConfirmAsyncConsultationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmAsyncConsultationMutation, ConfirmAsyncConsultationMutationVariables>(ConfirmAsyncConsultationDocument, options);
      }
export type ConfirmAsyncConsultationMutationHookResult = ReturnType<typeof useConfirmAsyncConsultationMutation>;
export type ConfirmAsyncConsultationMutationResult = Apollo.MutationResult<ConfirmAsyncConsultationMutation>;
export type ConfirmAsyncConsultationMutationOptions = Apollo.BaseMutationOptions<ConfirmAsyncConsultationMutation, ConfirmAsyncConsultationMutationVariables>;
export const CompoundQuizCompletePageDocument = gql`
    query CompoundQuizCompletePage($id: String!) {
  getQuizApplication(id: $id) {
    id
    purpose
    problemType
    quiz {
      id
      default
      quizCode
    }
    consultation {
      id
      status
      stage
      isUpfrontPayment
      requiresPrescriberCall
      canSchedulePractitionerBooking
    }
    outcomes {
      ... on QuizOutcomeV2 {
        id
      }
    }
  }
  profile {
    id
    residentialAddress {
      id
    }
    phone
    isPasswordSet
  }
}
    `;

/**
 * __useCompoundQuizCompletePageQuery__
 *
 * To run a query within a React component, call `useCompoundQuizCompletePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompoundQuizCompletePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompoundQuizCompletePageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompoundQuizCompletePageQuery(baseOptions: Apollo.QueryHookOptions<CompoundQuizCompletePageQuery, CompoundQuizCompletePageQueryVariables> & ({ variables: CompoundQuizCompletePageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompoundQuizCompletePageQuery, CompoundQuizCompletePageQueryVariables>(CompoundQuizCompletePageDocument, options);
      }
export function useCompoundQuizCompletePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompoundQuizCompletePageQuery, CompoundQuizCompletePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompoundQuizCompletePageQuery, CompoundQuizCompletePageQueryVariables>(CompoundQuizCompletePageDocument, options);
        }
export function useCompoundQuizCompletePageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompoundQuizCompletePageQuery, CompoundQuizCompletePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompoundQuizCompletePageQuery, CompoundQuizCompletePageQueryVariables>(CompoundQuizCompletePageDocument, options);
        }
export type CompoundQuizCompletePageQueryHookResult = ReturnType<typeof useCompoundQuizCompletePageQuery>;
export type CompoundQuizCompletePageLazyQueryHookResult = ReturnType<typeof useCompoundQuizCompletePageLazyQuery>;
export type CompoundQuizCompletePageSuspenseQueryHookResult = ReturnType<typeof useCompoundQuizCompletePageSuspenseQuery>;
export type CompoundQuizCompletePageQueryResult = Apollo.QueryResult<CompoundQuizCompletePageQuery, CompoundQuizCompletePageQueryVariables>;
export const CompoundAsyncEligibleQuizCompletePageDocument = gql`
    query CompoundAsyncEligibleQuizCompletePage($consultationId: String!, $problemType: ProblemType!) {
  consultation(id: $consultationId) {
    id
    customer {
      id
      ... on User {
        condition(problemType: $problemType) {
          id
          asyncEligible
        }
      }
    }
  }
}
    `;

/**
 * __useCompoundAsyncEligibleQuizCompletePageQuery__
 *
 * To run a query within a React component, call `useCompoundAsyncEligibleQuizCompletePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompoundAsyncEligibleQuizCompletePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompoundAsyncEligibleQuizCompletePageQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *      problemType: // value for 'problemType'
 *   },
 * });
 */
export function useCompoundAsyncEligibleQuizCompletePageQuery(baseOptions: Apollo.QueryHookOptions<CompoundAsyncEligibleQuizCompletePageQuery, CompoundAsyncEligibleQuizCompletePageQueryVariables> & ({ variables: CompoundAsyncEligibleQuizCompletePageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompoundAsyncEligibleQuizCompletePageQuery, CompoundAsyncEligibleQuizCompletePageQueryVariables>(CompoundAsyncEligibleQuizCompletePageDocument, options);
      }
export function useCompoundAsyncEligibleQuizCompletePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompoundAsyncEligibleQuizCompletePageQuery, CompoundAsyncEligibleQuizCompletePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompoundAsyncEligibleQuizCompletePageQuery, CompoundAsyncEligibleQuizCompletePageQueryVariables>(CompoundAsyncEligibleQuizCompletePageDocument, options);
        }
export function useCompoundAsyncEligibleQuizCompletePageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompoundAsyncEligibleQuizCompletePageQuery, CompoundAsyncEligibleQuizCompletePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompoundAsyncEligibleQuizCompletePageQuery, CompoundAsyncEligibleQuizCompletePageQueryVariables>(CompoundAsyncEligibleQuizCompletePageDocument, options);
        }
export type CompoundAsyncEligibleQuizCompletePageQueryHookResult = ReturnType<typeof useCompoundAsyncEligibleQuizCompletePageQuery>;
export type CompoundAsyncEligibleQuizCompletePageLazyQueryHookResult = ReturnType<typeof useCompoundAsyncEligibleQuizCompletePageLazyQuery>;
export type CompoundAsyncEligibleQuizCompletePageSuspenseQueryHookResult = ReturnType<typeof useCompoundAsyncEligibleQuizCompletePageSuspenseQuery>;
export type CompoundAsyncEligibleQuizCompletePageQueryResult = Apollo.QueryResult<CompoundAsyncEligibleQuizCompletePageQuery, CompoundAsyncEligibleQuizCompletePageQueryVariables>;
export const CompoundStartConfirmProfileDocument = gql`
    query CompoundStartConfirmProfile {
  profile {
    id
    consultations(orderBy: {createdAt: desc}) {
      id
      type
      status
      isUpfrontPayment
    }
  }
}
    `;

/**
 * __useCompoundStartConfirmProfileQuery__
 *
 * To run a query within a React component, call `useCompoundStartConfirmProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompoundStartConfirmProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompoundStartConfirmProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompoundStartConfirmProfileQuery(baseOptions?: Apollo.QueryHookOptions<CompoundStartConfirmProfileQuery, CompoundStartConfirmProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompoundStartConfirmProfileQuery, CompoundStartConfirmProfileQueryVariables>(CompoundStartConfirmProfileDocument, options);
      }
export function useCompoundStartConfirmProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompoundStartConfirmProfileQuery, CompoundStartConfirmProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompoundStartConfirmProfileQuery, CompoundStartConfirmProfileQueryVariables>(CompoundStartConfirmProfileDocument, options);
        }
export function useCompoundStartConfirmProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompoundStartConfirmProfileQuery, CompoundStartConfirmProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompoundStartConfirmProfileQuery, CompoundStartConfirmProfileQueryVariables>(CompoundStartConfirmProfileDocument, options);
        }
export type CompoundStartConfirmProfileQueryHookResult = ReturnType<typeof useCompoundStartConfirmProfileQuery>;
export type CompoundStartConfirmProfileLazyQueryHookResult = ReturnType<typeof useCompoundStartConfirmProfileLazyQuery>;
export type CompoundStartConfirmProfileSuspenseQueryHookResult = ReturnType<typeof useCompoundStartConfirmProfileSuspenseQuery>;
export type CompoundStartConfirmProfileQueryResult = Apollo.QueryResult<CompoundStartConfirmProfileQuery, CompoundStartConfirmProfileQueryVariables>;
export const JuniperMobileAppBannerDocument = gql`
    query JuniperMobileAppBanner($segmentName: Segment!) {
  inSegment(segmentName: $segmentName)
}
    `;

/**
 * __useJuniperMobileAppBannerQuery__
 *
 * To run a query within a React component, call `useJuniperMobileAppBannerQuery` and pass it any options that fit your needs.
 * When your component renders, `useJuniperMobileAppBannerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJuniperMobileAppBannerQuery({
 *   variables: {
 *      segmentName: // value for 'segmentName'
 *   },
 * });
 */
export function useJuniperMobileAppBannerQuery(baseOptions: Apollo.QueryHookOptions<JuniperMobileAppBannerQuery, JuniperMobileAppBannerQueryVariables> & ({ variables: JuniperMobileAppBannerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JuniperMobileAppBannerQuery, JuniperMobileAppBannerQueryVariables>(JuniperMobileAppBannerDocument, options);
      }
export function useJuniperMobileAppBannerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JuniperMobileAppBannerQuery, JuniperMobileAppBannerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JuniperMobileAppBannerQuery, JuniperMobileAppBannerQueryVariables>(JuniperMobileAppBannerDocument, options);
        }
export function useJuniperMobileAppBannerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JuniperMobileAppBannerQuery, JuniperMobileAppBannerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JuniperMobileAppBannerQuery, JuniperMobileAppBannerQueryVariables>(JuniperMobileAppBannerDocument, options);
        }
export type JuniperMobileAppBannerQueryHookResult = ReturnType<typeof useJuniperMobileAppBannerQuery>;
export type JuniperMobileAppBannerLazyQueryHookResult = ReturnType<typeof useJuniperMobileAppBannerLazyQuery>;
export type JuniperMobileAppBannerSuspenseQueryHookResult = ReturnType<typeof useJuniperMobileAppBannerSuspenseQuery>;
export type JuniperMobileAppBannerQueryResult = Apollo.QueryResult<JuniperMobileAppBannerQuery, JuniperMobileAppBannerQueryVariables>;
export const UpdateResidentialAddressDocument = gql`
    mutation UpdateResidentialAddress($residentialAddress: ResidentialAddressCreateInput!) {
  updateResidentialAddress(residentialAddress: $residentialAddress) {
    id
  }
}
    `;
export type UpdateResidentialAddressMutationFn = Apollo.MutationFunction<UpdateResidentialAddressMutation, UpdateResidentialAddressMutationVariables>;

/**
 * __useUpdateResidentialAddressMutation__
 *
 * To run a mutation, you first call `useUpdateResidentialAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResidentialAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResidentialAddressMutation, { data, loading, error }] = useUpdateResidentialAddressMutation({
 *   variables: {
 *      residentialAddress: // value for 'residentialAddress'
 *   },
 * });
 */
export function useUpdateResidentialAddressMutation(baseOptions?: Apollo.MutationHookOptions<UpdateResidentialAddressMutation, UpdateResidentialAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateResidentialAddressMutation, UpdateResidentialAddressMutationVariables>(UpdateResidentialAddressDocument, options);
      }
export type UpdateResidentialAddressMutationHookResult = ReturnType<typeof useUpdateResidentialAddressMutation>;
export type UpdateResidentialAddressMutationResult = Apollo.MutationResult<UpdateResidentialAddressMutation>;
export type UpdateResidentialAddressMutationOptions = Apollo.BaseMutationOptions<UpdateResidentialAddressMutation, UpdateResidentialAddressMutationVariables>;
export const AddOnsPageProductsDocument = gql`
    query AddOnsPageProducts($productSKU: String) {
  otcProducts: products(productType: OTC) {
    ...AddOnsPageProduct
  }
  nutritionSupportProducts: products(
    productType: CONTENT
    where: {variants: {some: {inventory: {sku: {equals: $productSKU}}}}}
  ) {
    ...AddOnsPageProduct
  }
}
    ${AddOnsPageProductFragmentDoc}`;

/**
 * __useAddOnsPageProductsQuery__
 *
 * To run a query within a React component, call `useAddOnsPageProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddOnsPageProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddOnsPageProductsQuery({
 *   variables: {
 *      productSKU: // value for 'productSKU'
 *   },
 * });
 */
export function useAddOnsPageProductsQuery(baseOptions?: Apollo.QueryHookOptions<AddOnsPageProductsQuery, AddOnsPageProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddOnsPageProductsQuery, AddOnsPageProductsQueryVariables>(AddOnsPageProductsDocument, options);
      }
export function useAddOnsPageProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddOnsPageProductsQuery, AddOnsPageProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddOnsPageProductsQuery, AddOnsPageProductsQueryVariables>(AddOnsPageProductsDocument, options);
        }
export function useAddOnsPageProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AddOnsPageProductsQuery, AddOnsPageProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AddOnsPageProductsQuery, AddOnsPageProductsQueryVariables>(AddOnsPageProductsDocument, options);
        }
export type AddOnsPageProductsQueryHookResult = ReturnType<typeof useAddOnsPageProductsQuery>;
export type AddOnsPageProductsLazyQueryHookResult = ReturnType<typeof useAddOnsPageProductsLazyQuery>;
export type AddOnsPageProductsSuspenseQueryHookResult = ReturnType<typeof useAddOnsPageProductsSuspenseQuery>;
export type AddOnsPageProductsQueryResult = Apollo.QueryResult<AddOnsPageProductsQuery, AddOnsPageProductsQueryVariables>;
export const JuniperAsyncConsultConfirmedPageDocument = gql`
    query JuniperAsyncConsultConfirmedPage($consultationId: String!) {
  consultation(id: $consultationId) {
    id
    type
    requiresPrescriberCall
  }
}
    `;

/**
 * __useJuniperAsyncConsultConfirmedPageQuery__
 *
 * To run a query within a React component, call `useJuniperAsyncConsultConfirmedPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useJuniperAsyncConsultConfirmedPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJuniperAsyncConsultConfirmedPageQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function useJuniperAsyncConsultConfirmedPageQuery(baseOptions: Apollo.QueryHookOptions<JuniperAsyncConsultConfirmedPageQuery, JuniperAsyncConsultConfirmedPageQueryVariables> & ({ variables: JuniperAsyncConsultConfirmedPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JuniperAsyncConsultConfirmedPageQuery, JuniperAsyncConsultConfirmedPageQueryVariables>(JuniperAsyncConsultConfirmedPageDocument, options);
      }
export function useJuniperAsyncConsultConfirmedPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JuniperAsyncConsultConfirmedPageQuery, JuniperAsyncConsultConfirmedPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JuniperAsyncConsultConfirmedPageQuery, JuniperAsyncConsultConfirmedPageQueryVariables>(JuniperAsyncConsultConfirmedPageDocument, options);
        }
export function useJuniperAsyncConsultConfirmedPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JuniperAsyncConsultConfirmedPageQuery, JuniperAsyncConsultConfirmedPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JuniperAsyncConsultConfirmedPageQuery, JuniperAsyncConsultConfirmedPageQueryVariables>(JuniperAsyncConsultConfirmedPageDocument, options);
        }
export type JuniperAsyncConsultConfirmedPageQueryHookResult = ReturnType<typeof useJuniperAsyncConsultConfirmedPageQuery>;
export type JuniperAsyncConsultConfirmedPageLazyQueryHookResult = ReturnType<typeof useJuniperAsyncConsultConfirmedPageLazyQuery>;
export type JuniperAsyncConsultConfirmedPageSuspenseQueryHookResult = ReturnType<typeof useJuniperAsyncConsultConfirmedPageSuspenseQuery>;
export type JuniperAsyncConsultConfirmedPageQueryResult = Apollo.QueryResult<JuniperAsyncConsultConfirmedPageQuery, JuniperAsyncConsultConfirmedPageQueryVariables>;
export const JuniperCollectAddressPageDocument = gql`
    query JuniperCollectAddressPage($consultationId: String!) {
  consultation(id: $consultationId) {
    id
    type
  }
}
    `;

/**
 * __useJuniperCollectAddressPageQuery__
 *
 * To run a query within a React component, call `useJuniperCollectAddressPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useJuniperCollectAddressPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJuniperCollectAddressPageQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function useJuniperCollectAddressPageQuery(baseOptions: Apollo.QueryHookOptions<JuniperCollectAddressPageQuery, JuniperCollectAddressPageQueryVariables> & ({ variables: JuniperCollectAddressPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JuniperCollectAddressPageQuery, JuniperCollectAddressPageQueryVariables>(JuniperCollectAddressPageDocument, options);
      }
export function useJuniperCollectAddressPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JuniperCollectAddressPageQuery, JuniperCollectAddressPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JuniperCollectAddressPageQuery, JuniperCollectAddressPageQueryVariables>(JuniperCollectAddressPageDocument, options);
        }
export function useJuniperCollectAddressPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JuniperCollectAddressPageQuery, JuniperCollectAddressPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JuniperCollectAddressPageQuery, JuniperCollectAddressPageQueryVariables>(JuniperCollectAddressPageDocument, options);
        }
export type JuniperCollectAddressPageQueryHookResult = ReturnType<typeof useJuniperCollectAddressPageQuery>;
export type JuniperCollectAddressPageLazyQueryHookResult = ReturnType<typeof useJuniperCollectAddressPageLazyQuery>;
export type JuniperCollectAddressPageSuspenseQueryHookResult = ReturnType<typeof useJuniperCollectAddressPageSuspenseQuery>;
export type JuniperCollectAddressPageQueryResult = Apollo.QueryResult<JuniperCollectAddressPageQuery, JuniperCollectAddressPageQueryVariables>;
export const JuniperCollectMedicarePageDocument = gql`
    query JuniperCollectMedicarePage($consultationId: String!) {
  consultation(id: $consultationId) {
    id
    type
    stage
    canSchedulePractitionerBooking
    quizApplication {
      id
      problemType
    }
  }
}
    `;

/**
 * __useJuniperCollectMedicarePageQuery__
 *
 * To run a query within a React component, call `useJuniperCollectMedicarePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useJuniperCollectMedicarePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJuniperCollectMedicarePageQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function useJuniperCollectMedicarePageQuery(baseOptions: Apollo.QueryHookOptions<JuniperCollectMedicarePageQuery, JuniperCollectMedicarePageQueryVariables> & ({ variables: JuniperCollectMedicarePageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JuniperCollectMedicarePageQuery, JuniperCollectMedicarePageQueryVariables>(JuniperCollectMedicarePageDocument, options);
      }
export function useJuniperCollectMedicarePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JuniperCollectMedicarePageQuery, JuniperCollectMedicarePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JuniperCollectMedicarePageQuery, JuniperCollectMedicarePageQueryVariables>(JuniperCollectMedicarePageDocument, options);
        }
export function useJuniperCollectMedicarePageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JuniperCollectMedicarePageQuery, JuniperCollectMedicarePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JuniperCollectMedicarePageQuery, JuniperCollectMedicarePageQueryVariables>(JuniperCollectMedicarePageDocument, options);
        }
export type JuniperCollectMedicarePageQueryHookResult = ReturnType<typeof useJuniperCollectMedicarePageQuery>;
export type JuniperCollectMedicarePageLazyQueryHookResult = ReturnType<typeof useJuniperCollectMedicarePageLazyQuery>;
export type JuniperCollectMedicarePageSuspenseQueryHookResult = ReturnType<typeof useJuniperCollectMedicarePageSuspenseQuery>;
export type JuniperCollectMedicarePageQueryResult = Apollo.QueryResult<JuniperCollectMedicarePageQuery, JuniperCollectMedicarePageQueryVariables>;
export const JuniperAsyncEligibleMedicarePageDocument = gql`
    query JuniperAsyncEligibleMedicarePage($consultationId: String!, $problemType: ProblemType!) {
  consultation(id: $consultationId) {
    id
    customer {
      id
      ... on User {
        condition(problemType: $problemType) {
          id
          asyncEligible
        }
      }
    }
  }
}
    `;

/**
 * __useJuniperAsyncEligibleMedicarePageQuery__
 *
 * To run a query within a React component, call `useJuniperAsyncEligibleMedicarePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useJuniperAsyncEligibleMedicarePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJuniperAsyncEligibleMedicarePageQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *      problemType: // value for 'problemType'
 *   },
 * });
 */
export function useJuniperAsyncEligibleMedicarePageQuery(baseOptions: Apollo.QueryHookOptions<JuniperAsyncEligibleMedicarePageQuery, JuniperAsyncEligibleMedicarePageQueryVariables> & ({ variables: JuniperAsyncEligibleMedicarePageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JuniperAsyncEligibleMedicarePageQuery, JuniperAsyncEligibleMedicarePageQueryVariables>(JuniperAsyncEligibleMedicarePageDocument, options);
      }
export function useJuniperAsyncEligibleMedicarePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JuniperAsyncEligibleMedicarePageQuery, JuniperAsyncEligibleMedicarePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JuniperAsyncEligibleMedicarePageQuery, JuniperAsyncEligibleMedicarePageQueryVariables>(JuniperAsyncEligibleMedicarePageDocument, options);
        }
export function useJuniperAsyncEligibleMedicarePageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JuniperAsyncEligibleMedicarePageQuery, JuniperAsyncEligibleMedicarePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JuniperAsyncEligibleMedicarePageQuery, JuniperAsyncEligibleMedicarePageQueryVariables>(JuniperAsyncEligibleMedicarePageDocument, options);
        }
export type JuniperAsyncEligibleMedicarePageQueryHookResult = ReturnType<typeof useJuniperAsyncEligibleMedicarePageQuery>;
export type JuniperAsyncEligibleMedicarePageLazyQueryHookResult = ReturnType<typeof useJuniperAsyncEligibleMedicarePageLazyQuery>;
export type JuniperAsyncEligibleMedicarePageSuspenseQueryHookResult = ReturnType<typeof useJuniperAsyncEligibleMedicarePageSuspenseQuery>;
export type JuniperAsyncEligibleMedicarePageQueryResult = Apollo.QueryResult<JuniperAsyncEligibleMedicarePageQuery, JuniperAsyncEligibleMedicarePageQueryVariables>;
export const JuniperOrderConfirmationPageDocument = gql`
    query JuniperOrderConfirmationPage($consultationId: String!, $type: ProblemType!, $segmentName: Segment!) {
  consultation(id: $consultationId) {
    id
    type
    isUpfrontPayment
    doctor {
      id
      fullName
      fullClinicianName
    }
  }
  profile {
    id
    weightTreatmentCategory
  }
  treatments(where: {type: {equals: $type}}) {
    id
    active
    product {
      id
      variants {
        id
        inventory {
          id
          sku
        }
        isRefill
      }
    }
  }
  inSegment(segmentName: $segmentName)
}
    `;

/**
 * __useJuniperOrderConfirmationPageQuery__
 *
 * To run a query within a React component, call `useJuniperOrderConfirmationPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useJuniperOrderConfirmationPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJuniperOrderConfirmationPageQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *      type: // value for 'type'
 *      segmentName: // value for 'segmentName'
 *   },
 * });
 */
export function useJuniperOrderConfirmationPageQuery(baseOptions: Apollo.QueryHookOptions<JuniperOrderConfirmationPageQuery, JuniperOrderConfirmationPageQueryVariables> & ({ variables: JuniperOrderConfirmationPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JuniperOrderConfirmationPageQuery, JuniperOrderConfirmationPageQueryVariables>(JuniperOrderConfirmationPageDocument, options);
      }
export function useJuniperOrderConfirmationPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JuniperOrderConfirmationPageQuery, JuniperOrderConfirmationPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JuniperOrderConfirmationPageQuery, JuniperOrderConfirmationPageQueryVariables>(JuniperOrderConfirmationPageDocument, options);
        }
export function useJuniperOrderConfirmationPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JuniperOrderConfirmationPageQuery, JuniperOrderConfirmationPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JuniperOrderConfirmationPageQuery, JuniperOrderConfirmationPageQueryVariables>(JuniperOrderConfirmationPageDocument, options);
        }
export type JuniperOrderConfirmationPageQueryHookResult = ReturnType<typeof useJuniperOrderConfirmationPageQuery>;
export type JuniperOrderConfirmationPageLazyQueryHookResult = ReturnType<typeof useJuniperOrderConfirmationPageLazyQuery>;
export type JuniperOrderConfirmationPageSuspenseQueryHookResult = ReturnType<typeof useJuniperOrderConfirmationPageSuspenseQuery>;
export type JuniperOrderConfirmationPageQueryResult = Apollo.QueryResult<JuniperOrderConfirmationPageQuery, JuniperOrderConfirmationPageQueryVariables>;
export const JuniperConfirmationPageDocument = gql`
    query JuniperConfirmationPage($consultationId: String!) {
  consultation(id: $consultationId) {
    id
    type
    createdAt
    stage
    isApproved
    screeningQuizApplication {
      id
    }
    isUpfrontPayment
    customer {
      id
      email
    }
  }
}
    `;

/**
 * __useJuniperConfirmationPageQuery__
 *
 * To run a query within a React component, call `useJuniperConfirmationPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useJuniperConfirmationPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJuniperConfirmationPageQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function useJuniperConfirmationPageQuery(baseOptions: Apollo.QueryHookOptions<JuniperConfirmationPageQuery, JuniperConfirmationPageQueryVariables> & ({ variables: JuniperConfirmationPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JuniperConfirmationPageQuery, JuniperConfirmationPageQueryVariables>(JuniperConfirmationPageDocument, options);
      }
export function useJuniperConfirmationPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JuniperConfirmationPageQuery, JuniperConfirmationPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JuniperConfirmationPageQuery, JuniperConfirmationPageQueryVariables>(JuniperConfirmationPageDocument, options);
        }
export function useJuniperConfirmationPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JuniperConfirmationPageQuery, JuniperConfirmationPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JuniperConfirmationPageQuery, JuniperConfirmationPageQueryVariables>(JuniperConfirmationPageDocument, options);
        }
export type JuniperConfirmationPageQueryHookResult = ReturnType<typeof useJuniperConfirmationPageQuery>;
export type JuniperConfirmationPageLazyQueryHookResult = ReturnType<typeof useJuniperConfirmationPageLazyQuery>;
export type JuniperConfirmationPageSuspenseQueryHookResult = ReturnType<typeof useJuniperConfirmationPageSuspenseQuery>;
export type JuniperConfirmationPageQueryResult = Apollo.QueryResult<JuniperConfirmationPageQuery, JuniperConfirmationPageQueryVariables>;
export const ConsultPayConsultationDocument = gql`
    query ConsultPayConsultation($id: String!) {
  consultation(id: $id) {
    id
    type
    stage
    isUpfrontPayment
    price {
      amountOff
      fullPrice
      total
    }
    quizApplicationId
  }
  customerAttributes {
    id
    menopause {
      menopauseSymptoms
    }
  }
}
    `;

/**
 * __useConsultPayConsultationQuery__
 *
 * To run a query within a React component, call `useConsultPayConsultationQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultPayConsultationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultPayConsultationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConsultPayConsultationQuery(baseOptions: Apollo.QueryHookOptions<ConsultPayConsultationQuery, ConsultPayConsultationQueryVariables> & ({ variables: ConsultPayConsultationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConsultPayConsultationQuery, ConsultPayConsultationQueryVariables>(ConsultPayConsultationDocument, options);
      }
export function useConsultPayConsultationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConsultPayConsultationQuery, ConsultPayConsultationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConsultPayConsultationQuery, ConsultPayConsultationQueryVariables>(ConsultPayConsultationDocument, options);
        }
export function useConsultPayConsultationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ConsultPayConsultationQuery, ConsultPayConsultationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConsultPayConsultationQuery, ConsultPayConsultationQueryVariables>(ConsultPayConsultationDocument, options);
        }
export type ConsultPayConsultationQueryHookResult = ReturnType<typeof useConsultPayConsultationQuery>;
export type ConsultPayConsultationLazyQueryHookResult = ReturnType<typeof useConsultPayConsultationLazyQuery>;
export type ConsultPayConsultationSuspenseQueryHookResult = ReturnType<typeof useConsultPayConsultationSuspenseQuery>;
export type ConsultPayConsultationQueryResult = Apollo.QueryResult<ConsultPayConsultationQuery, ConsultPayConsultationQueryVariables>;
export const JuniperConsultationCreateAccountDocument = gql`
    query JuniperConsultationCreateAccount($consultationId: String!, $bnplEnabled: Boolean!) {
  consultation(id: $consultationId) {
    id
    type
    isUpfrontPayment
    purchasePrompt @include(if: $bnplEnabled) {
      id
    }
  }
}
    `;

/**
 * __useJuniperConsultationCreateAccountQuery__
 *
 * To run a query within a React component, call `useJuniperConsultationCreateAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useJuniperConsultationCreateAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJuniperConsultationCreateAccountQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *      bnplEnabled: // value for 'bnplEnabled'
 *   },
 * });
 */
export function useJuniperConsultationCreateAccountQuery(baseOptions: Apollo.QueryHookOptions<JuniperConsultationCreateAccountQuery, JuniperConsultationCreateAccountQueryVariables> & ({ variables: JuniperConsultationCreateAccountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JuniperConsultationCreateAccountQuery, JuniperConsultationCreateAccountQueryVariables>(JuniperConsultationCreateAccountDocument, options);
      }
export function useJuniperConsultationCreateAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JuniperConsultationCreateAccountQuery, JuniperConsultationCreateAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JuniperConsultationCreateAccountQuery, JuniperConsultationCreateAccountQueryVariables>(JuniperConsultationCreateAccountDocument, options);
        }
export function useJuniperConsultationCreateAccountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JuniperConsultationCreateAccountQuery, JuniperConsultationCreateAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JuniperConsultationCreateAccountQuery, JuniperConsultationCreateAccountQueryVariables>(JuniperConsultationCreateAccountDocument, options);
        }
export type JuniperConsultationCreateAccountQueryHookResult = ReturnType<typeof useJuniperConsultationCreateAccountQuery>;
export type JuniperConsultationCreateAccountLazyQueryHookResult = ReturnType<typeof useJuniperConsultationCreateAccountLazyQuery>;
export type JuniperConsultationCreateAccountSuspenseQueryHookResult = ReturnType<typeof useJuniperConsultationCreateAccountSuspenseQuery>;
export type JuniperConsultationCreateAccountQueryResult = Apollo.QueryResult<JuniperConsultationCreateAccountQuery, JuniperConsultationCreateAccountQueryVariables>;
export const JuniperJpInitialPurchaseConfirmDocument = gql`
    query JuniperJpInitialPurchaseConfirm($consultationId: String!, $pricingSessionId: ID!, $offeringSelections: [OfferingSelectionInput!]!, $noSelections: Boolean!, $couponCodes: [String!], $proposedOfferingSelectionInput: InitialPurchaseProposedOfferingSelectionInput) {
  initialPurchasePrice(
    consultationId: $consultationId
    pricingSessionId: $pricingSessionId
    offeringSelections: $offeringSelections
    couponCodes: $couponCodes
  ) @skip(if: $noSelections) {
    id
    amount
    coupons {
      id
      code
      outcome
    }
  }
  validPhoneRegions {
    id
    countryCode
  }
  profile {
    id
    email
    phone
    isPasswordSet
    birthday
    address {
      id
    }
    residentialAddress {
      id
      city
      line1
      line2
      state
      country
      postalCode
      prefecture
      municipality
      townArea
    }
    ...PaymentMethods
  }
  consultation(id: $consultationId) {
    id
    type
    purchasePrompt {
      id
      ... on InitialPurchasePrompt {
        proposedOfferingSelection(input: $proposedOfferingSelectionInput) {
          id
          offering {
            id
            friendlyName
            photoUrl
          }
          sequenceSelections {
            id
            sequence {
              id
              friendlyName
              description
              faqs {
                id
                rank
                question
                answerMarkdown
              }
            }
            sequenceSet {
              id
            }
          }
        }
      }
    }
  }
  offeringsTimeline(offerings: $offeringSelections) @skip(if: $noSelections) {
    id
    date
    totalAmount
    products {
      id
      friendlyName
      erxMedicines {
        id
        itemForm
      }
    }
  }
}
    ${PaymentMethodsFragmentDoc}`;

/**
 * __useJuniperJpInitialPurchaseConfirmQuery__
 *
 * To run a query within a React component, call `useJuniperJpInitialPurchaseConfirmQuery` and pass it any options that fit your needs.
 * When your component renders, `useJuniperJpInitialPurchaseConfirmQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJuniperJpInitialPurchaseConfirmQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *      pricingSessionId: // value for 'pricingSessionId'
 *      offeringSelections: // value for 'offeringSelections'
 *      noSelections: // value for 'noSelections'
 *      couponCodes: // value for 'couponCodes'
 *      proposedOfferingSelectionInput: // value for 'proposedOfferingSelectionInput'
 *   },
 * });
 */
export function useJuniperJpInitialPurchaseConfirmQuery(baseOptions: Apollo.QueryHookOptions<JuniperJpInitialPurchaseConfirmQuery, JuniperJpInitialPurchaseConfirmQueryVariables> & ({ variables: JuniperJpInitialPurchaseConfirmQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JuniperJpInitialPurchaseConfirmQuery, JuniperJpInitialPurchaseConfirmQueryVariables>(JuniperJpInitialPurchaseConfirmDocument, options);
      }
export function useJuniperJpInitialPurchaseConfirmLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JuniperJpInitialPurchaseConfirmQuery, JuniperJpInitialPurchaseConfirmQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JuniperJpInitialPurchaseConfirmQuery, JuniperJpInitialPurchaseConfirmQueryVariables>(JuniperJpInitialPurchaseConfirmDocument, options);
        }
export function useJuniperJpInitialPurchaseConfirmSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JuniperJpInitialPurchaseConfirmQuery, JuniperJpInitialPurchaseConfirmQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JuniperJpInitialPurchaseConfirmQuery, JuniperJpInitialPurchaseConfirmQueryVariables>(JuniperJpInitialPurchaseConfirmDocument, options);
        }
export type JuniperJpInitialPurchaseConfirmQueryHookResult = ReturnType<typeof useJuniperJpInitialPurchaseConfirmQuery>;
export type JuniperJpInitialPurchaseConfirmLazyQueryHookResult = ReturnType<typeof useJuniperJpInitialPurchaseConfirmLazyQuery>;
export type JuniperJpInitialPurchaseConfirmSuspenseQueryHookResult = ReturnType<typeof useJuniperJpInitialPurchaseConfirmSuspenseQuery>;
export type JuniperJpInitialPurchaseConfirmQueryResult = Apollo.QueryResult<JuniperJpInitialPurchaseConfirmQuery, JuniperJpInitialPurchaseConfirmQueryVariables>;
export const JuniperJpInitialPurchaseConfirmUpdateUserDocument = gql`
    mutation JuniperJpInitialPurchaseConfirmUpdateUser($password: String, $phone: String, $birthday: String, $residentialAddress: ResidentialAddressCreateInput!) {
  updateProfile(password: $password, phone: $phone, birthday: $birthday) {
    id
    phone
    birthday
    isPasswordSet
  }
  updateResidentialAddress(residentialAddress: $residentialAddress) {
    id
    line1
    line2
    state
    country
    company
    building
    postalCode
    city
  }
}
    `;
export type JuniperJpInitialPurchaseConfirmUpdateUserMutationFn = Apollo.MutationFunction<JuniperJpInitialPurchaseConfirmUpdateUserMutation, JuniperJpInitialPurchaseConfirmUpdateUserMutationVariables>;

/**
 * __useJuniperJpInitialPurchaseConfirmUpdateUserMutation__
 *
 * To run a mutation, you first call `useJuniperJpInitialPurchaseConfirmUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJuniperJpInitialPurchaseConfirmUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [juniperJpInitialPurchaseConfirmUpdateUserMutation, { data, loading, error }] = useJuniperJpInitialPurchaseConfirmUpdateUserMutation({
 *   variables: {
 *      password: // value for 'password'
 *      phone: // value for 'phone'
 *      birthday: // value for 'birthday'
 *      residentialAddress: // value for 'residentialAddress'
 *   },
 * });
 */
export function useJuniperJpInitialPurchaseConfirmUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<JuniperJpInitialPurchaseConfirmUpdateUserMutation, JuniperJpInitialPurchaseConfirmUpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JuniperJpInitialPurchaseConfirmUpdateUserMutation, JuniperJpInitialPurchaseConfirmUpdateUserMutationVariables>(JuniperJpInitialPurchaseConfirmUpdateUserDocument, options);
      }
export type JuniperJpInitialPurchaseConfirmUpdateUserMutationHookResult = ReturnType<typeof useJuniperJpInitialPurchaseConfirmUpdateUserMutation>;
export type JuniperJpInitialPurchaseConfirmUpdateUserMutationResult = Apollo.MutationResult<JuniperJpInitialPurchaseConfirmUpdateUserMutation>;
export type JuniperJpInitialPurchaseConfirmUpdateUserMutationOptions = Apollo.BaseMutationOptions<JuniperJpInitialPurchaseConfirmUpdateUserMutation, JuniperJpInitialPurchaseConfirmUpdateUserMutationVariables>;
export const FollowUpConsultationJuniperUkDocument = gql`
    query FollowUpConsultationJuniperUK($id: String!) {
  consultation(id: $id) {
    ...ConsultationInfoJuniperEU
  }
}
    ${ConsultationInfoJuniperEuFragmentDoc}`;

/**
 * __useFollowUpConsultationJuniperUkQuery__
 *
 * To run a query within a React component, call `useFollowUpConsultationJuniperUkQuery` and pass it any options that fit your needs.
 * When your component renders, `useFollowUpConsultationJuniperUkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFollowUpConsultationJuniperUkQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFollowUpConsultationJuniperUkQuery(baseOptions: Apollo.QueryHookOptions<FollowUpConsultationJuniperUkQuery, FollowUpConsultationJuniperUkQueryVariables> & ({ variables: FollowUpConsultationJuniperUkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FollowUpConsultationJuniperUkQuery, FollowUpConsultationJuniperUkQueryVariables>(FollowUpConsultationJuniperUkDocument, options);
      }
export function useFollowUpConsultationJuniperUkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FollowUpConsultationJuniperUkQuery, FollowUpConsultationJuniperUkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FollowUpConsultationJuniperUkQuery, FollowUpConsultationJuniperUkQueryVariables>(FollowUpConsultationJuniperUkDocument, options);
        }
export function useFollowUpConsultationJuniperUkSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FollowUpConsultationJuniperUkQuery, FollowUpConsultationJuniperUkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FollowUpConsultationJuniperUkQuery, FollowUpConsultationJuniperUkQueryVariables>(FollowUpConsultationJuniperUkDocument, options);
        }
export type FollowUpConsultationJuniperUkQueryHookResult = ReturnType<typeof useFollowUpConsultationJuniperUkQuery>;
export type FollowUpConsultationJuniperUkLazyQueryHookResult = ReturnType<typeof useFollowUpConsultationJuniperUkLazyQuery>;
export type FollowUpConsultationJuniperUkSuspenseQueryHookResult = ReturnType<typeof useFollowUpConsultationJuniperUkSuspenseQuery>;
export type FollowUpConsultationJuniperUkQueryResult = Apollo.QueryResult<FollowUpConsultationJuniperUkQuery, FollowUpConsultationJuniperUkQueryVariables>;
export const JuniperConsultationPlanDocument = gql`
    query JuniperConsultationPlan($consultationId: String!) {
  consultation(id: $consultationId) {
    id
    completedAt
    treatment {
      id
      weightTreatmentCategory
    }
  }
}
    `;

/**
 * __useJuniperConsultationPlanQuery__
 *
 * To run a query within a React component, call `useJuniperConsultationPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useJuniperConsultationPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJuniperConsultationPlanQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function useJuniperConsultationPlanQuery(baseOptions: Apollo.QueryHookOptions<JuniperConsultationPlanQuery, JuniperConsultationPlanQueryVariables> & ({ variables: JuniperConsultationPlanQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JuniperConsultationPlanQuery, JuniperConsultationPlanQueryVariables>(JuniperConsultationPlanDocument, options);
      }
export function useJuniperConsultationPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JuniperConsultationPlanQuery, JuniperConsultationPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JuniperConsultationPlanQuery, JuniperConsultationPlanQueryVariables>(JuniperConsultationPlanDocument, options);
        }
export function useJuniperConsultationPlanSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JuniperConsultationPlanQuery, JuniperConsultationPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JuniperConsultationPlanQuery, JuniperConsultationPlanQueryVariables>(JuniperConsultationPlanDocument, options);
        }
export type JuniperConsultationPlanQueryHookResult = ReturnType<typeof useJuniperConsultationPlanQuery>;
export type JuniperConsultationPlanLazyQueryHookResult = ReturnType<typeof useJuniperConsultationPlanLazyQuery>;
export type JuniperConsultationPlanSuspenseQueryHookResult = ReturnType<typeof useJuniperConsultationPlanSuspenseQuery>;
export type JuniperConsultationPlanQueryResult = Apollo.QueryResult<JuniperConsultationPlanQuery, JuniperConsultationPlanQueryVariables>;
export const JuniperPracBookingConfirmationPageDocument = gql`
    query JuniperPracBookingConfirmationPage($pracBookingId: ID!) {
  practitionerBooking(id: $pracBookingId) {
    id
    consultation {
      id
      type
    }
    patient {
      id
      email
      phone
    }
    windowStartAt
    windowEndAt
  }
  validPhoneRegions {
    id
    countryCode
  }
}
    `;

/**
 * __useJuniperPracBookingConfirmationPageQuery__
 *
 * To run a query within a React component, call `useJuniperPracBookingConfirmationPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useJuniperPracBookingConfirmationPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJuniperPracBookingConfirmationPageQuery({
 *   variables: {
 *      pracBookingId: // value for 'pracBookingId'
 *   },
 * });
 */
export function useJuniperPracBookingConfirmationPageQuery(baseOptions: Apollo.QueryHookOptions<JuniperPracBookingConfirmationPageQuery, JuniperPracBookingConfirmationPageQueryVariables> & ({ variables: JuniperPracBookingConfirmationPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JuniperPracBookingConfirmationPageQuery, JuniperPracBookingConfirmationPageQueryVariables>(JuniperPracBookingConfirmationPageDocument, options);
      }
export function useJuniperPracBookingConfirmationPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JuniperPracBookingConfirmationPageQuery, JuniperPracBookingConfirmationPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JuniperPracBookingConfirmationPageQuery, JuniperPracBookingConfirmationPageQueryVariables>(JuniperPracBookingConfirmationPageDocument, options);
        }
export function useJuniperPracBookingConfirmationPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JuniperPracBookingConfirmationPageQuery, JuniperPracBookingConfirmationPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JuniperPracBookingConfirmationPageQuery, JuniperPracBookingConfirmationPageQueryVariables>(JuniperPracBookingConfirmationPageDocument, options);
        }
export type JuniperPracBookingConfirmationPageQueryHookResult = ReturnType<typeof useJuniperPracBookingConfirmationPageQuery>;
export type JuniperPracBookingConfirmationPageLazyQueryHookResult = ReturnType<typeof useJuniperPracBookingConfirmationPageLazyQuery>;
export type JuniperPracBookingConfirmationPageSuspenseQueryHookResult = ReturnType<typeof useJuniperPracBookingConfirmationPageSuspenseQuery>;
export type JuniperPracBookingConfirmationPageQueryResult = Apollo.QueryResult<JuniperPracBookingConfirmationPageQuery, JuniperPracBookingConfirmationPageQueryVariables>;
export const JuniperPractitionerPhoneCallPageDocument = gql`
    query JuniperPractitionerPhoneCallPage($consultationId: String!) {
  consultation(id: $consultationId) {
    id
    latestPractitionerBooking {
      id
    }
  }
}
    `;

/**
 * __useJuniperPractitionerPhoneCallPageQuery__
 *
 * To run a query within a React component, call `useJuniperPractitionerPhoneCallPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useJuniperPractitionerPhoneCallPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJuniperPractitionerPhoneCallPageQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function useJuniperPractitionerPhoneCallPageQuery(baseOptions: Apollo.QueryHookOptions<JuniperPractitionerPhoneCallPageQuery, JuniperPractitionerPhoneCallPageQueryVariables> & ({ variables: JuniperPractitionerPhoneCallPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JuniperPractitionerPhoneCallPageQuery, JuniperPractitionerPhoneCallPageQueryVariables>(JuniperPractitionerPhoneCallPageDocument, options);
      }
export function useJuniperPractitionerPhoneCallPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JuniperPractitionerPhoneCallPageQuery, JuniperPractitionerPhoneCallPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JuniperPractitionerPhoneCallPageQuery, JuniperPractitionerPhoneCallPageQueryVariables>(JuniperPractitionerPhoneCallPageDocument, options);
        }
export function useJuniperPractitionerPhoneCallPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JuniperPractitionerPhoneCallPageQuery, JuniperPractitionerPhoneCallPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JuniperPractitionerPhoneCallPageQuery, JuniperPractitionerPhoneCallPageQueryVariables>(JuniperPractitionerPhoneCallPageDocument, options);
        }
export type JuniperPractitionerPhoneCallPageQueryHookResult = ReturnType<typeof useJuniperPractitionerPhoneCallPageQuery>;
export type JuniperPractitionerPhoneCallPageLazyQueryHookResult = ReturnType<typeof useJuniperPractitionerPhoneCallPageLazyQuery>;
export type JuniperPractitionerPhoneCallPageSuspenseQueryHookResult = ReturnType<typeof useJuniperPractitionerPhoneCallPageSuspenseQuery>;
export type JuniperPractitionerPhoneCallPageQueryResult = Apollo.QueryResult<JuniperPractitionerPhoneCallPageQuery, JuniperPractitionerPhoneCallPageQueryVariables>;
export const JuniperSchedulePhoneCallPageDocument = gql`
    query JuniperSchedulePhoneCallPage($consultationId: String!) {
  consultation(id: $consultationId) {
    id
    latestPractitionerBooking {
      id
    }
  }
}
    `;

/**
 * __useJuniperSchedulePhoneCallPageQuery__
 *
 * To run a query within a React component, call `useJuniperSchedulePhoneCallPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useJuniperSchedulePhoneCallPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJuniperSchedulePhoneCallPageQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function useJuniperSchedulePhoneCallPageQuery(baseOptions: Apollo.QueryHookOptions<JuniperSchedulePhoneCallPageQuery, JuniperSchedulePhoneCallPageQueryVariables> & ({ variables: JuniperSchedulePhoneCallPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JuniperSchedulePhoneCallPageQuery, JuniperSchedulePhoneCallPageQueryVariables>(JuniperSchedulePhoneCallPageDocument, options);
      }
export function useJuniperSchedulePhoneCallPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JuniperSchedulePhoneCallPageQuery, JuniperSchedulePhoneCallPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JuniperSchedulePhoneCallPageQuery, JuniperSchedulePhoneCallPageQueryVariables>(JuniperSchedulePhoneCallPageDocument, options);
        }
export function useJuniperSchedulePhoneCallPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JuniperSchedulePhoneCallPageQuery, JuniperSchedulePhoneCallPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JuniperSchedulePhoneCallPageQuery, JuniperSchedulePhoneCallPageQueryVariables>(JuniperSchedulePhoneCallPageDocument, options);
        }
export type JuniperSchedulePhoneCallPageQueryHookResult = ReturnType<typeof useJuniperSchedulePhoneCallPageQuery>;
export type JuniperSchedulePhoneCallPageLazyQueryHookResult = ReturnType<typeof useJuniperSchedulePhoneCallPageLazyQuery>;
export type JuniperSchedulePhoneCallPageSuspenseQueryHookResult = ReturnType<typeof useJuniperSchedulePhoneCallPageSuspenseQuery>;
export type JuniperSchedulePhoneCallPageQueryResult = Apollo.QueryResult<JuniperSchedulePhoneCallPageQuery, JuniperSchedulePhoneCallPageQueryVariables>;
export const JuniperShippingPageDocument = gql`
    query JuniperShippingPage($consultationId: String!) {
  profile {
    id
    firstName
    lastName
    fullName
    phone
    defaultPaymentGateway
    email
    ...PaymentForm
    zip {
      valid
    }
    address {
      id
      line1
      line2
      city
      postalCode
      state
      deliveryInstructions
    }
    residentialAddress {
      id
      line1
      line2
      city
      postalCode
      state
    }
  }
  consultation(id: $consultationId) {
    id
    type
    typeIsFlexi
    isUpfrontPayment
    payment {
      id
      charge {
        id
        amount
        createdAt
      }
    }
    order {
      id
      lineItems {
        id
        quantity
        variant {
          id
          price
          product {
            id
            name
            productType
            photo {
              id
              url
            }
          }
        }
      }
    }
    treatment {
      id
      status
      experimentPaymentPlan {
        id
        paymentPlan
        discountPercentage
      }
      experimentAvailablePaymentPlans {
        paymentPlan
        discountPercentage
        months
      }
      plan {
        id
        interval
        intervalCount
      }
      product {
        id
        name
        friendlyName
        shortDescription
        deliveryInformation
        photo {
          id
          url
        }
        variants {
          id
          isRefill
          price
          inventory {
            id
            sku
          }
        }
        plan {
          id
          interval
          intervalCount
        }
      }
      otcSchedules {
        id
        cadence
        quantity
        product {
          id
        }
        isActive
      }
    }
  }
  inSegment(segmentName: SEGMENT_JUNIPER_OP_CREDIT)
}
    ${PaymentFormFragmentDoc}`;

/**
 * __useJuniperShippingPageQuery__
 *
 * To run a query within a React component, call `useJuniperShippingPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useJuniperShippingPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJuniperShippingPageQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function useJuniperShippingPageQuery(baseOptions: Apollo.QueryHookOptions<JuniperShippingPageQuery, JuniperShippingPageQueryVariables> & ({ variables: JuniperShippingPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JuniperShippingPageQuery, JuniperShippingPageQueryVariables>(JuniperShippingPageDocument, options);
      }
export function useJuniperShippingPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JuniperShippingPageQuery, JuniperShippingPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JuniperShippingPageQuery, JuniperShippingPageQueryVariables>(JuniperShippingPageDocument, options);
        }
export function useJuniperShippingPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JuniperShippingPageQuery, JuniperShippingPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JuniperShippingPageQuery, JuniperShippingPageQueryVariables>(JuniperShippingPageDocument, options);
        }
export type JuniperShippingPageQueryHookResult = ReturnType<typeof useJuniperShippingPageQuery>;
export type JuniperShippingPageLazyQueryHookResult = ReturnType<typeof useJuniperShippingPageLazyQuery>;
export type JuniperShippingPageSuspenseQueryHookResult = ReturnType<typeof useJuniperShippingPageSuspenseQuery>;
export type JuniperShippingPageQueryResult = Apollo.QueryResult<JuniperShippingPageQuery, JuniperShippingPageQueryVariables>;
export const TreatmentBreakdownPageDocument = gql`
    query TreatmentBreakdownPage($consultationId: String!) {
  profile {
    id
    weightTreatmentCategory
  }
  consultation(id: $consultationId) {
    id
    status
    type
    doctor {
      id
      shortClinicianName
    }
    treatment {
      id
      updatedAt
      product {
        id
        faqs {
          id
          markdown
          title
        }
        variants {
          id
          inventory {
            id
            sku
          }
        }
      }
      weightTreatmentCategory
    }
    patientNotes
  }
  customerAttributes {
    id
    weight
  }
}
    `;

/**
 * __useTreatmentBreakdownPageQuery__
 *
 * To run a query within a React component, call `useTreatmentBreakdownPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useTreatmentBreakdownPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTreatmentBreakdownPageQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function useTreatmentBreakdownPageQuery(baseOptions: Apollo.QueryHookOptions<TreatmentBreakdownPageQuery, TreatmentBreakdownPageQueryVariables> & ({ variables: TreatmentBreakdownPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TreatmentBreakdownPageQuery, TreatmentBreakdownPageQueryVariables>(TreatmentBreakdownPageDocument, options);
      }
export function useTreatmentBreakdownPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TreatmentBreakdownPageQuery, TreatmentBreakdownPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TreatmentBreakdownPageQuery, TreatmentBreakdownPageQueryVariables>(TreatmentBreakdownPageDocument, options);
        }
export function useTreatmentBreakdownPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TreatmentBreakdownPageQuery, TreatmentBreakdownPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TreatmentBreakdownPageQuery, TreatmentBreakdownPageQueryVariables>(TreatmentBreakdownPageDocument, options);
        }
export type TreatmentBreakdownPageQueryHookResult = ReturnType<typeof useTreatmentBreakdownPageQuery>;
export type TreatmentBreakdownPageLazyQueryHookResult = ReturnType<typeof useTreatmentBreakdownPageLazyQuery>;
export type TreatmentBreakdownPageSuspenseQueryHookResult = ReturnType<typeof useTreatmentBreakdownPageSuspenseQuery>;
export type TreatmentBreakdownPageQueryResult = Apollo.QueryResult<TreatmentBreakdownPageQuery, TreatmentBreakdownPageQueryVariables>;
export const UpdateProfileCheckoutFormJuniperUkDocument = gql`
    mutation UpdateProfileCheckoutFormJuniperUK($firstName: String, $lastName: String, $phone: String, $password: String, $birthday: String) {
  updateProfile(
    firstName: $firstName
    lastName: $lastName
    phone: $phone
    password: $password
    birthday: $birthday
  ) {
    id
  }
}
    `;
export type UpdateProfileCheckoutFormJuniperUkMutationFn = Apollo.MutationFunction<UpdateProfileCheckoutFormJuniperUkMutation, UpdateProfileCheckoutFormJuniperUkMutationVariables>;

/**
 * __useUpdateProfileCheckoutFormJuniperUkMutation__
 *
 * To run a mutation, you first call `useUpdateProfileCheckoutFormJuniperUkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileCheckoutFormJuniperUkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileCheckoutFormJuniperUkMutation, { data, loading, error }] = useUpdateProfileCheckoutFormJuniperUkMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      phone: // value for 'phone'
 *      password: // value for 'password'
 *      birthday: // value for 'birthday'
 *   },
 * });
 */
export function useUpdateProfileCheckoutFormJuniperUkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProfileCheckoutFormJuniperUkMutation, UpdateProfileCheckoutFormJuniperUkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProfileCheckoutFormJuniperUkMutation, UpdateProfileCheckoutFormJuniperUkMutationVariables>(UpdateProfileCheckoutFormJuniperUkDocument, options);
      }
export type UpdateProfileCheckoutFormJuniperUkMutationHookResult = ReturnType<typeof useUpdateProfileCheckoutFormJuniperUkMutation>;
export type UpdateProfileCheckoutFormJuniperUkMutationResult = Apollo.MutationResult<UpdateProfileCheckoutFormJuniperUkMutation>;
export type UpdateProfileCheckoutFormJuniperUkMutationOptions = Apollo.BaseMutationOptions<UpdateProfileCheckoutFormJuniperUkMutation, UpdateProfileCheckoutFormJuniperUkMutationVariables>;
export const PayConsultationCheckoutFormJuniperUkDocument = gql`
    mutation PayConsultationCheckoutFormJuniperUK($id: String!, $couponCode: String, $token: String, $gateway: PaymentGateway, $zipCheckoutId: String) {
  payConsultation(
    id: $id
    couponCode: $couponCode
    token: $token
    gateway: $gateway
    zipCheckoutId: $zipCheckoutId
  ) {
    id
  }
}
    `;
export type PayConsultationCheckoutFormJuniperUkMutationFn = Apollo.MutationFunction<PayConsultationCheckoutFormJuniperUkMutation, PayConsultationCheckoutFormJuniperUkMutationVariables>;

/**
 * __usePayConsultationCheckoutFormJuniperUkMutation__
 *
 * To run a mutation, you first call `usePayConsultationCheckoutFormJuniperUkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePayConsultationCheckoutFormJuniperUkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [payConsultationCheckoutFormJuniperUkMutation, { data, loading, error }] = usePayConsultationCheckoutFormJuniperUkMutation({
 *   variables: {
 *      id: // value for 'id'
 *      couponCode: // value for 'couponCode'
 *      token: // value for 'token'
 *      gateway: // value for 'gateway'
 *      zipCheckoutId: // value for 'zipCheckoutId'
 *   },
 * });
 */
export function usePayConsultationCheckoutFormJuniperUkMutation(baseOptions?: Apollo.MutationHookOptions<PayConsultationCheckoutFormJuniperUkMutation, PayConsultationCheckoutFormJuniperUkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PayConsultationCheckoutFormJuniperUkMutation, PayConsultationCheckoutFormJuniperUkMutationVariables>(PayConsultationCheckoutFormJuniperUkDocument, options);
      }
export type PayConsultationCheckoutFormJuniperUkMutationHookResult = ReturnType<typeof usePayConsultationCheckoutFormJuniperUkMutation>;
export type PayConsultationCheckoutFormJuniperUkMutationResult = Apollo.MutationResult<PayConsultationCheckoutFormJuniperUkMutation>;
export type PayConsultationCheckoutFormJuniperUkMutationOptions = Apollo.BaseMutationOptions<PayConsultationCheckoutFormJuniperUkMutation, PayConsultationCheckoutFormJuniperUkMutationVariables>;
export const JuniperConsultationUpfrontPaymentPageDocument = gql`
    query JuniperConsultationUpfrontPaymentPage($consultationId: String!) {
  consultation(id: $consultationId) {
    id
    stage
    status
    type
    medicationPreferenceProduct {
      id
      preferredProduct {
        id
        erxMedicines {
          id
          productName
          genericName
        }
        faqs {
          id
          title
          markdown
        }
        variants {
          id
          price
          isRefill
        }
        plan {
          id
          name
          interval
          intervalCount
        }
      }
      defaultProduct {
        id
        erxMedicines {
          id
          productName
          genericName
        }
        faqs {
          id
          title
          markdown
        }
        variants {
          id
          price
          isRefill
        }
        plan {
          id
          name
          interval
          intervalCount
        }
      }
    }
  }
  profile {
    id
    firstName
    lastName
    email
    phone
    birthday
    isPasswordSet
    consultations(orderBy: {createdAt: desc}) {
      id
      quizApplication {
        id
      }
    }
    ...BillingDetails
    residentialAddress {
      id
      line1
      line2
      city
      state
      postalCode
      country
    }
  }
  validPhoneRegions {
    id
    countryCode
  }
}
    ${BillingDetailsFragmentDoc}`;

/**
 * __useJuniperConsultationUpfrontPaymentPageQuery__
 *
 * To run a query within a React component, call `useJuniperConsultationUpfrontPaymentPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useJuniperConsultationUpfrontPaymentPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJuniperConsultationUpfrontPaymentPageQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function useJuniperConsultationUpfrontPaymentPageQuery(baseOptions: Apollo.QueryHookOptions<JuniperConsultationUpfrontPaymentPageQuery, JuniperConsultationUpfrontPaymentPageQueryVariables> & ({ variables: JuniperConsultationUpfrontPaymentPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JuniperConsultationUpfrontPaymentPageQuery, JuniperConsultationUpfrontPaymentPageQueryVariables>(JuniperConsultationUpfrontPaymentPageDocument, options);
      }
export function useJuniperConsultationUpfrontPaymentPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JuniperConsultationUpfrontPaymentPageQuery, JuniperConsultationUpfrontPaymentPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JuniperConsultationUpfrontPaymentPageQuery, JuniperConsultationUpfrontPaymentPageQueryVariables>(JuniperConsultationUpfrontPaymentPageDocument, options);
        }
export function useJuniperConsultationUpfrontPaymentPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JuniperConsultationUpfrontPaymentPageQuery, JuniperConsultationUpfrontPaymentPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JuniperConsultationUpfrontPaymentPageQuery, JuniperConsultationUpfrontPaymentPageQueryVariables>(JuniperConsultationUpfrontPaymentPageDocument, options);
        }
export type JuniperConsultationUpfrontPaymentPageQueryHookResult = ReturnType<typeof useJuniperConsultationUpfrontPaymentPageQuery>;
export type JuniperConsultationUpfrontPaymentPageLazyQueryHookResult = ReturnType<typeof useJuniperConsultationUpfrontPaymentPageLazyQuery>;
export type JuniperConsultationUpfrontPaymentPageSuspenseQueryHookResult = ReturnType<typeof useJuniperConsultationUpfrontPaymentPageSuspenseQuery>;
export type JuniperConsultationUpfrontPaymentPageQueryResult = Apollo.QueryResult<JuniperConsultationUpfrontPaymentPageQuery, JuniperConsultationUpfrontPaymentPageQueryVariables>;
export const JuniperAccountPageDocument = gql`
    query JuniperAccountPage {
  profile {
    id
    weightTreatmentCategory
    zip {
      valid
    }
    address {
      ...RangeShippingDetailsAddress
    }
    ...BillingDetails
    ...PersonalDetails
  }
  validPhoneRegions {
    id
    countryCode
  }
}
    ${RangeShippingDetailsAddressFragmentDoc}
${BillingDetailsFragmentDoc}
${PersonalDetailsFragmentDoc}`;

/**
 * __useJuniperAccountPageQuery__
 *
 * To run a query within a React component, call `useJuniperAccountPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useJuniperAccountPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJuniperAccountPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useJuniperAccountPageQuery(baseOptions?: Apollo.QueryHookOptions<JuniperAccountPageQuery, JuniperAccountPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JuniperAccountPageQuery, JuniperAccountPageQueryVariables>(JuniperAccountPageDocument, options);
      }
export function useJuniperAccountPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JuniperAccountPageQuery, JuniperAccountPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JuniperAccountPageQuery, JuniperAccountPageQueryVariables>(JuniperAccountPageDocument, options);
        }
export function useJuniperAccountPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JuniperAccountPageQuery, JuniperAccountPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JuniperAccountPageQuery, JuniperAccountPageQueryVariables>(JuniperAccountPageDocument, options);
        }
export type JuniperAccountPageQueryHookResult = ReturnType<typeof useJuniperAccountPageQuery>;
export type JuniperAccountPageLazyQueryHookResult = ReturnType<typeof useJuniperAccountPageLazyQuery>;
export type JuniperAccountPageSuspenseQueryHookResult = ReturnType<typeof useJuniperAccountPageSuspenseQuery>;
export type JuniperAccountPageQueryResult = Apollo.QueryResult<JuniperAccountPageQuery, JuniperAccountPageQueryVariables>;
export const JuniperProfilePageDocument = gql`
    query JuniperProfilePage {
  profile {
    id
    mobileAppAccess {
      id
    }
    shortAddressableName
    initialQuizApplications: quizApplications(purpose: INITIAL) {
      id
      ...JuniperProfilePageInitialQuizApplication
    }
    archivedQuizApplications(purpose: INITIAL, problemType: WEIGHT_LOSS) {
      id
      ...JuniperProfilePageInitialQuizApplication
    }
    needsSubscriptionMigration
    subscriptionsV2: subscriptions {
      id
      status
      nextPaymentAt
      subscriptionPlan {
        id
        name
        interval
        intervalCount
        price
        photo {
          id
          url
        }
      }
    }
    consultations {
      id
      ...JuniperProfilePageConsultation
    }
    purchases {
      id
      ...JuniperProfilePagePurchase
    }
    isBeingTreatedForWeight: isBeingTreated(problemType: WEIGHT_LOSS)
  }
  customerAttributes {
    id
  }
  subscriptionsV1: subscriptionPlans {
    id
    active
    amount
    cancelAt
    cancelAtPeriodEnd
    interval
    intervalCount
    status
    currentPeriodEnd
    product {
      id
      name
      friendlyName
      photo {
        id
        url
      }
    }
  }
  ...JuniperProfilePageUserSegments
}
    ${JuniperProfilePageInitialQuizApplicationFragmentDoc}
${JuniperProfilePageConsultationFragmentDoc}
${JuniperProfilePagePurchaseFragmentDoc}
${JuniperProfilePageUserSegmentsFragmentDoc}`;

/**
 * __useJuniperProfilePageQuery__
 *
 * To run a query within a React component, call `useJuniperProfilePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useJuniperProfilePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJuniperProfilePageQuery({
 *   variables: {
 *   },
 * });
 */
export function useJuniperProfilePageQuery(baseOptions?: Apollo.QueryHookOptions<JuniperProfilePageQuery, JuniperProfilePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JuniperProfilePageQuery, JuniperProfilePageQueryVariables>(JuniperProfilePageDocument, options);
      }
export function useJuniperProfilePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JuniperProfilePageQuery, JuniperProfilePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JuniperProfilePageQuery, JuniperProfilePageQueryVariables>(JuniperProfilePageDocument, options);
        }
export function useJuniperProfilePageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JuniperProfilePageQuery, JuniperProfilePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JuniperProfilePageQuery, JuniperProfilePageQueryVariables>(JuniperProfilePageDocument, options);
        }
export type JuniperProfilePageQueryHookResult = ReturnType<typeof useJuniperProfilePageQuery>;
export type JuniperProfilePageLazyQueryHookResult = ReturnType<typeof useJuniperProfilePageLazyQuery>;
export type JuniperProfilePageSuspenseQueryHookResult = ReturnType<typeof useJuniperProfilePageSuspenseQuery>;
export type JuniperProfilePageQueryResult = Apollo.QueryResult<JuniperProfilePageQuery, JuniperProfilePageQueryVariables>;
export const JuniperOtcPurchaseDocument = gql`
    query JuniperOtcPurchase($offeringSelections: [OfferingSelectionInput!]!, $pricingSessionId: ID!, $userId: String, $userIsAnonymous: Boolean!, $hasOfferingsSelections: Boolean!, $couponCodes: [String!]) {
  initialPurchasePrice(
    offeringSelections: $offeringSelections
    pricingSessionId: $pricingSessionId
    userId: $userId
    couponCodes: $couponCodes
  ) @include(if: $hasOfferingsSelections) {
    id
    amount
    originalAmount
    coupons {
      id
      code
      outcome
    }
    offeringPriceLists {
      id
      sequencePriceLists {
        id
        pricedItems {
          id
          quantity
          unitPrice
          unitPriceDiscount
          variant {
            id
            product {
              id
              name
            }
          }
        }
      }
      offering {
        id
        photoUrl
        friendlyName
        advertisedShippingCadence
      }
    }
  }
  profile @skip(if: $userIsAnonymous) {
    id
    email
    lastName
    firstName
    address {
      id
    }
    residentialAddress {
      id
      city
      line1
      line2
      state
      country
      postalCode
      prefecture
      municipality
      townArea
    }
  }
}
    `;

/**
 * __useJuniperOtcPurchaseQuery__
 *
 * To run a query within a React component, call `useJuniperOtcPurchaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useJuniperOtcPurchaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJuniperOtcPurchaseQuery({
 *   variables: {
 *      offeringSelections: // value for 'offeringSelections'
 *      pricingSessionId: // value for 'pricingSessionId'
 *      userId: // value for 'userId'
 *      userIsAnonymous: // value for 'userIsAnonymous'
 *      hasOfferingsSelections: // value for 'hasOfferingsSelections'
 *      couponCodes: // value for 'couponCodes'
 *   },
 * });
 */
export function useJuniperOtcPurchaseQuery(baseOptions: Apollo.QueryHookOptions<JuniperOtcPurchaseQuery, JuniperOtcPurchaseQueryVariables> & ({ variables: JuniperOtcPurchaseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JuniperOtcPurchaseQuery, JuniperOtcPurchaseQueryVariables>(JuniperOtcPurchaseDocument, options);
      }
export function useJuniperOtcPurchaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JuniperOtcPurchaseQuery, JuniperOtcPurchaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JuniperOtcPurchaseQuery, JuniperOtcPurchaseQueryVariables>(JuniperOtcPurchaseDocument, options);
        }
export function useJuniperOtcPurchaseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JuniperOtcPurchaseQuery, JuniperOtcPurchaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JuniperOtcPurchaseQuery, JuniperOtcPurchaseQueryVariables>(JuniperOtcPurchaseDocument, options);
        }
export type JuniperOtcPurchaseQueryHookResult = ReturnType<typeof useJuniperOtcPurchaseQuery>;
export type JuniperOtcPurchaseLazyQueryHookResult = ReturnType<typeof useJuniperOtcPurchaseLazyQuery>;
export type JuniperOtcPurchaseSuspenseQueryHookResult = ReturnType<typeof useJuniperOtcPurchaseSuspenseQuery>;
export type JuniperOtcPurchaseQueryResult = Apollo.QueryResult<JuniperOtcPurchaseQuery, JuniperOtcPurchaseQueryVariables>;
export const JuniperPurchaseConfirmUpdateUserDocument = gql`
    mutation JuniperPurchaseConfirmUpdateUser($firstName: String!, $lastName: String!, $residentialAddress: ResidentialAddressCreateInput!) {
  updateProfile(firstName: $firstName, lastName: $lastName) {
    id
    firstName
    lastName
  }
  updateResidentialAddress(residentialAddress: $residentialAddress) {
    id
    line1
    line2
    state
    country
    company
    building
    postalCode
    city
  }
}
    `;
export type JuniperPurchaseConfirmUpdateUserMutationFn = Apollo.MutationFunction<JuniperPurchaseConfirmUpdateUserMutation, JuniperPurchaseConfirmUpdateUserMutationVariables>;

/**
 * __useJuniperPurchaseConfirmUpdateUserMutation__
 *
 * To run a mutation, you first call `useJuniperPurchaseConfirmUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJuniperPurchaseConfirmUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [juniperPurchaseConfirmUpdateUserMutation, { data, loading, error }] = useJuniperPurchaseConfirmUpdateUserMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      residentialAddress: // value for 'residentialAddress'
 *   },
 * });
 */
export function useJuniperPurchaseConfirmUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<JuniperPurchaseConfirmUpdateUserMutation, JuniperPurchaseConfirmUpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JuniperPurchaseConfirmUpdateUserMutation, JuniperPurchaseConfirmUpdateUserMutationVariables>(JuniperPurchaseConfirmUpdateUserDocument, options);
      }
export type JuniperPurchaseConfirmUpdateUserMutationHookResult = ReturnType<typeof useJuniperPurchaseConfirmUpdateUserMutation>;
export type JuniperPurchaseConfirmUpdateUserMutationResult = Apollo.MutationResult<JuniperPurchaseConfirmUpdateUserMutation>;
export type JuniperPurchaseConfirmUpdateUserMutationOptions = Apollo.BaseMutationOptions<JuniperPurchaseConfirmUpdateUserMutation, JuniperPurchaseConfirmUpdateUserMutationVariables>;
export const JuniperQuizCompletePageDocument = gql`
    query JuniperQuizCompletePage($id: String!) {
  getQuizApplication(id: $id) {
    id
    purpose
    problemType
    quiz {
      id
      default
      quizCode
    }
    consultation {
      id
      status
      stage
      isUpfrontPayment
      requiresPrescriberCall
      canSchedulePractitionerBooking
    }
    outcomes {
      ... on QuizOutcomeV2 {
        id
      }
    }
  }
  profile {
    id
    residentialAddress {
      id
    }
    phone
    isPasswordSet
    medicalProfile {
      id
      weight
    }
  }
}
    `;

/**
 * __useJuniperQuizCompletePageQuery__
 *
 * To run a query within a React component, call `useJuniperQuizCompletePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useJuniperQuizCompletePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJuniperQuizCompletePageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useJuniperQuizCompletePageQuery(baseOptions: Apollo.QueryHookOptions<JuniperQuizCompletePageQuery, JuniperQuizCompletePageQueryVariables> & ({ variables: JuniperQuizCompletePageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JuniperQuizCompletePageQuery, JuniperQuizCompletePageQueryVariables>(JuniperQuizCompletePageDocument, options);
      }
export function useJuniperQuizCompletePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JuniperQuizCompletePageQuery, JuniperQuizCompletePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JuniperQuizCompletePageQuery, JuniperQuizCompletePageQueryVariables>(JuniperQuizCompletePageDocument, options);
        }
export function useJuniperQuizCompletePageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JuniperQuizCompletePageQuery, JuniperQuizCompletePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JuniperQuizCompletePageQuery, JuniperQuizCompletePageQueryVariables>(JuniperQuizCompletePageDocument, options);
        }
export type JuniperQuizCompletePageQueryHookResult = ReturnType<typeof useJuniperQuizCompletePageQuery>;
export type JuniperQuizCompletePageLazyQueryHookResult = ReturnType<typeof useJuniperQuizCompletePageLazyQuery>;
export type JuniperQuizCompletePageSuspenseQueryHookResult = ReturnType<typeof useJuniperQuizCompletePageSuspenseQuery>;
export type JuniperQuizCompletePageQueryResult = Apollo.QueryResult<JuniperQuizCompletePageQuery, JuniperQuizCompletePageQueryVariables>;
export const JuniperAsyncEligibleQuizCompletePageDocument = gql`
    query JuniperAsyncEligibleQuizCompletePage($consultationId: String!, $problemType: ProblemType!) {
  consultation(id: $consultationId) {
    id
    customer {
      id
      ... on User {
        condition(problemType: $problemType) {
          id
          asyncEligible
        }
      }
    }
  }
}
    `;

/**
 * __useJuniperAsyncEligibleQuizCompletePageQuery__
 *
 * To run a query within a React component, call `useJuniperAsyncEligibleQuizCompletePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useJuniperAsyncEligibleQuizCompletePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJuniperAsyncEligibleQuizCompletePageQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *      problemType: // value for 'problemType'
 *   },
 * });
 */
export function useJuniperAsyncEligibleQuizCompletePageQuery(baseOptions: Apollo.QueryHookOptions<JuniperAsyncEligibleQuizCompletePageQuery, JuniperAsyncEligibleQuizCompletePageQueryVariables> & ({ variables: JuniperAsyncEligibleQuizCompletePageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JuniperAsyncEligibleQuizCompletePageQuery, JuniperAsyncEligibleQuizCompletePageQueryVariables>(JuniperAsyncEligibleQuizCompletePageDocument, options);
      }
export function useJuniperAsyncEligibleQuizCompletePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JuniperAsyncEligibleQuizCompletePageQuery, JuniperAsyncEligibleQuizCompletePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JuniperAsyncEligibleQuizCompletePageQuery, JuniperAsyncEligibleQuizCompletePageQueryVariables>(JuniperAsyncEligibleQuizCompletePageDocument, options);
        }
export function useJuniperAsyncEligibleQuizCompletePageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JuniperAsyncEligibleQuizCompletePageQuery, JuniperAsyncEligibleQuizCompletePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JuniperAsyncEligibleQuizCompletePageQuery, JuniperAsyncEligibleQuizCompletePageQueryVariables>(JuniperAsyncEligibleQuizCompletePageDocument, options);
        }
export type JuniperAsyncEligibleQuizCompletePageQueryHookResult = ReturnType<typeof useJuniperAsyncEligibleQuizCompletePageQuery>;
export type JuniperAsyncEligibleQuizCompletePageLazyQueryHookResult = ReturnType<typeof useJuniperAsyncEligibleQuizCompletePageLazyQuery>;
export type JuniperAsyncEligibleQuizCompletePageSuspenseQueryHookResult = ReturnType<typeof useJuniperAsyncEligibleQuizCompletePageSuspenseQuery>;
export type JuniperAsyncEligibleQuizCompletePageQueryResult = Apollo.QueryResult<JuniperAsyncEligibleQuizCompletePageQuery, JuniperAsyncEligibleQuizCompletePageQueryVariables>;
export const StartConfirmProfileJuniperDocument = gql`
    query StartConfirmProfileJuniper {
  profile {
    id
    consultations(orderBy: {createdAt: desc}) {
      id
      type
      status
      isUpfrontPayment
    }
  }
}
    `;

/**
 * __useStartConfirmProfileJuniperQuery__
 *
 * To run a query within a React component, call `useStartConfirmProfileJuniperQuery` and pass it any options that fit your needs.
 * When your component renders, `useStartConfirmProfileJuniperQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStartConfirmProfileJuniperQuery({
 *   variables: {
 *   },
 * });
 */
export function useStartConfirmProfileJuniperQuery(baseOptions?: Apollo.QueryHookOptions<StartConfirmProfileJuniperQuery, StartConfirmProfileJuniperQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StartConfirmProfileJuniperQuery, StartConfirmProfileJuniperQueryVariables>(StartConfirmProfileJuniperDocument, options);
      }
export function useStartConfirmProfileJuniperLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StartConfirmProfileJuniperQuery, StartConfirmProfileJuniperQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StartConfirmProfileJuniperQuery, StartConfirmProfileJuniperQueryVariables>(StartConfirmProfileJuniperDocument, options);
        }
export function useStartConfirmProfileJuniperSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StartConfirmProfileJuniperQuery, StartConfirmProfileJuniperQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StartConfirmProfileJuniperQuery, StartConfirmProfileJuniperQueryVariables>(StartConfirmProfileJuniperDocument, options);
        }
export type StartConfirmProfileJuniperQueryHookResult = ReturnType<typeof useStartConfirmProfileJuniperQuery>;
export type StartConfirmProfileJuniperLazyQueryHookResult = ReturnType<typeof useStartConfirmProfileJuniperLazyQuery>;
export type StartConfirmProfileJuniperSuspenseQueryHookResult = ReturnType<typeof useStartConfirmProfileJuniperSuspenseQuery>;
export type StartConfirmProfileJuniperQueryResult = Apollo.QueryResult<StartConfirmProfileJuniperQuery, StartConfirmProfileJuniperQueryVariables>;
export const FaqTreatmentJuniperDocument = gql`
    query FaqTreatmentJuniper($id: String!) {
  treatment(id: $id) {
    id
    type
    product {
      id
      faqs {
        id
        title
        markdown
      }
    }
    weightTreatmentCategory
    canPause
    status
    nextPayment
  }
}
    `;

/**
 * __useFaqTreatmentJuniperQuery__
 *
 * To run a query within a React component, call `useFaqTreatmentJuniperQuery` and pass it any options that fit your needs.
 * When your component renders, `useFaqTreatmentJuniperQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFaqTreatmentJuniperQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFaqTreatmentJuniperQuery(baseOptions: Apollo.QueryHookOptions<FaqTreatmentJuniperQuery, FaqTreatmentJuniperQueryVariables> & ({ variables: FaqTreatmentJuniperQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FaqTreatmentJuniperQuery, FaqTreatmentJuniperQueryVariables>(FaqTreatmentJuniperDocument, options);
      }
export function useFaqTreatmentJuniperLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FaqTreatmentJuniperQuery, FaqTreatmentJuniperQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FaqTreatmentJuniperQuery, FaqTreatmentJuniperQueryVariables>(FaqTreatmentJuniperDocument, options);
        }
export function useFaqTreatmentJuniperSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FaqTreatmentJuniperQuery, FaqTreatmentJuniperQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FaqTreatmentJuniperQuery, FaqTreatmentJuniperQueryVariables>(FaqTreatmentJuniperDocument, options);
        }
export type FaqTreatmentJuniperQueryHookResult = ReturnType<typeof useFaqTreatmentJuniperQuery>;
export type FaqTreatmentJuniperLazyQueryHookResult = ReturnType<typeof useFaqTreatmentJuniperLazyQuery>;
export type FaqTreatmentJuniperSuspenseQueryHookResult = ReturnType<typeof useFaqTreatmentJuniperSuspenseQuery>;
export type FaqTreatmentJuniperQueryResult = Apollo.QueryResult<FaqTreatmentJuniperQuery, FaqTreatmentJuniperQueryVariables>;
export const JuniperTreatmentPlanPageDocument = gql`
    query JuniperTreatmentPlanPage($id: String!) {
  profile {
    id
  }
  treatment(id: $id) {
    id
    status
    canRefill
    refillsLeft
    type
    nextPayment
    canReschedule
    cooldownActiveUntil
    plan {
      id
      amount
    }
    product {
      ...TreatmentPageProduct
    }
    otcSchedules {
      id
      cadence
      isActive
      quantity
      product {
        ...TreatmentPageProduct
      }
    }
    treatmentDiscount {
      id
      discountCode {
        ...DiscountCodeForm
      }
    }
    nextPaymentAmount
    weightTreatmentCategory
    consultation {
      id
      type
      doctor {
        id
        firstName
        lastName
        fullClinicianName
        fullName
      }
    }
    ...ProductListTreatment
    ...TreatmentDetailsTreatment
  }
  customerAttributes {
    id
    menopause {
      menopauseSymptoms
    }
  }
}
    ${TreatmentPageProductFragmentDoc}
${DiscountCodeFormFragmentDoc}
${ProductListTreatmentFragmentDoc}
${TreatmentDetailsTreatmentFragmentDoc}`;

/**
 * __useJuniperTreatmentPlanPageQuery__
 *
 * To run a query within a React component, call `useJuniperTreatmentPlanPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useJuniperTreatmentPlanPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJuniperTreatmentPlanPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useJuniperTreatmentPlanPageQuery(baseOptions: Apollo.QueryHookOptions<JuniperTreatmentPlanPageQuery, JuniperTreatmentPlanPageQueryVariables> & ({ variables: JuniperTreatmentPlanPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JuniperTreatmentPlanPageQuery, JuniperTreatmentPlanPageQueryVariables>(JuniperTreatmentPlanPageDocument, options);
      }
export function useJuniperTreatmentPlanPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JuniperTreatmentPlanPageQuery, JuniperTreatmentPlanPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JuniperTreatmentPlanPageQuery, JuniperTreatmentPlanPageQueryVariables>(JuniperTreatmentPlanPageDocument, options);
        }
export function useJuniperTreatmentPlanPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JuniperTreatmentPlanPageQuery, JuniperTreatmentPlanPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JuniperTreatmentPlanPageQuery, JuniperTreatmentPlanPageQueryVariables>(JuniperTreatmentPlanPageDocument, options);
        }
export type JuniperTreatmentPlanPageQueryHookResult = ReturnType<typeof useJuniperTreatmentPlanPageQuery>;
export type JuniperTreatmentPlanPageLazyQueryHookResult = ReturnType<typeof useJuniperTreatmentPlanPageLazyQuery>;
export type JuniperTreatmentPlanPageSuspenseQueryHookResult = ReturnType<typeof useJuniperTreatmentPlanPageSuspenseQuery>;
export type JuniperTreatmentPlanPageQueryResult = Apollo.QueryResult<JuniperTreatmentPlanPageQuery, JuniperTreatmentPlanPageQueryVariables>;
export const JuniperWeightLossDashboardPageDocument = gql`
    query JuniperWeightLossDashboardPage($segmentName: Segment!) {
  weightLossTreatments: treatments(where: {type: {equals: WEIGHT_LOSS}}) {
    id
    active
  }
  profile {
    id
    isBeingTreated(problemType: WEIGHT_LOSS)
    purchases {
      id
      problemType
      status
    }
  }
  tracker {
    id
    weightLoss {
      id
      lastCheckIn
      momentum
      waist {
        id
        value
        effectiveFrom
      }
      weight {
        id
        value
        effectiveFrom
      }
    }
  }
  inSegment(segmentName: $segmentName)
}
    `;

/**
 * __useJuniperWeightLossDashboardPageQuery__
 *
 * To run a query within a React component, call `useJuniperWeightLossDashboardPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useJuniperWeightLossDashboardPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJuniperWeightLossDashboardPageQuery({
 *   variables: {
 *      segmentName: // value for 'segmentName'
 *   },
 * });
 */
export function useJuniperWeightLossDashboardPageQuery(baseOptions: Apollo.QueryHookOptions<JuniperWeightLossDashboardPageQuery, JuniperWeightLossDashboardPageQueryVariables> & ({ variables: JuniperWeightLossDashboardPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JuniperWeightLossDashboardPageQuery, JuniperWeightLossDashboardPageQueryVariables>(JuniperWeightLossDashboardPageDocument, options);
      }
export function useJuniperWeightLossDashboardPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JuniperWeightLossDashboardPageQuery, JuniperWeightLossDashboardPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JuniperWeightLossDashboardPageQuery, JuniperWeightLossDashboardPageQueryVariables>(JuniperWeightLossDashboardPageDocument, options);
        }
export function useJuniperWeightLossDashboardPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JuniperWeightLossDashboardPageQuery, JuniperWeightLossDashboardPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JuniperWeightLossDashboardPageQuery, JuniperWeightLossDashboardPageQueryVariables>(JuniperWeightLossDashboardPageDocument, options);
        }
export type JuniperWeightLossDashboardPageQueryHookResult = ReturnType<typeof useJuniperWeightLossDashboardPageQuery>;
export type JuniperWeightLossDashboardPageLazyQueryHookResult = ReturnType<typeof useJuniperWeightLossDashboardPageLazyQuery>;
export type JuniperWeightLossDashboardPageSuspenseQueryHookResult = ReturnType<typeof useJuniperWeightLossDashboardPageSuspenseQuery>;
export type JuniperWeightLossDashboardPageQueryResult = Apollo.QueryResult<JuniperWeightLossDashboardPageQuery, JuniperWeightLossDashboardPageQueryVariables>;
export const SunsetBpDashboardDocument = gql`
    query SunsetBpDashboard {
  profile {
    id
    shortAddressableName
  }
  completedMobileOnboardingScreens: inSegment(
    segmentName: COMPLETED_MOBILE_ONBOARDING_SCREENS
  )
}
    `;

/**
 * __useSunsetBpDashboardQuery__
 *
 * To run a query within a React component, call `useSunsetBpDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useSunsetBpDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSunsetBpDashboardQuery({
 *   variables: {
 *   },
 * });
 */
export function useSunsetBpDashboardQuery(baseOptions?: Apollo.QueryHookOptions<SunsetBpDashboardQuery, SunsetBpDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SunsetBpDashboardQuery, SunsetBpDashboardQueryVariables>(SunsetBpDashboardDocument, options);
      }
export function useSunsetBpDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SunsetBpDashboardQuery, SunsetBpDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SunsetBpDashboardQuery, SunsetBpDashboardQueryVariables>(SunsetBpDashboardDocument, options);
        }
export function useSunsetBpDashboardSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SunsetBpDashboardQuery, SunsetBpDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SunsetBpDashboardQuery, SunsetBpDashboardQueryVariables>(SunsetBpDashboardDocument, options);
        }
export type SunsetBpDashboardQueryHookResult = ReturnType<typeof useSunsetBpDashboardQuery>;
export type SunsetBpDashboardLazyQueryHookResult = ReturnType<typeof useSunsetBpDashboardLazyQuery>;
export type SunsetBpDashboardSuspenseQueryHookResult = ReturnType<typeof useSunsetBpDashboardSuspenseQuery>;
export type SunsetBpDashboardQueryResult = Apollo.QueryResult<SunsetBpDashboardQuery, SunsetBpDashboardQueryVariables>;
export const UseConsultationKinDocument = gql`
    query UseConsultationKin($id: String!) {
  consultation(id: $id) {
    ...ConsultationInfoKin
  }
}
    ${ConsultationInfoKinFragmentDoc}`;

/**
 * __useUseConsultationKinQuery__
 *
 * To run a query within a React component, call `useUseConsultationKinQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseConsultationKinQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseConsultationKinQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUseConsultationKinQuery(baseOptions: Apollo.QueryHookOptions<UseConsultationKinQuery, UseConsultationKinQueryVariables> & ({ variables: UseConsultationKinQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseConsultationKinQuery, UseConsultationKinQueryVariables>(UseConsultationKinDocument, options);
      }
export function useUseConsultationKinLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseConsultationKinQuery, UseConsultationKinQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseConsultationKinQuery, UseConsultationKinQueryVariables>(UseConsultationKinDocument, options);
        }
export function useUseConsultationKinSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UseConsultationKinQuery, UseConsultationKinQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UseConsultationKinQuery, UseConsultationKinQueryVariables>(UseConsultationKinDocument, options);
        }
export type UseConsultationKinQueryHookResult = ReturnType<typeof useUseConsultationKinQuery>;
export type UseConsultationKinLazyQueryHookResult = ReturnType<typeof useUseConsultationKinLazyQuery>;
export type UseConsultationKinSuspenseQueryHookResult = ReturnType<typeof useUseConsultationKinSuspenseQuery>;
export type UseConsultationKinQueryResult = Apollo.QueryResult<UseConsultationKinQuery, UseConsultationKinQueryVariables>;
export const KinAsyncConsultConfirmedPageDocument = gql`
    query KinAsyncConsultConfirmedPage($consultationId: String!) {
  consultation(id: $consultationId) {
    id
    type
    requiresPrescriberCall
  }
}
    `;

/**
 * __useKinAsyncConsultConfirmedPageQuery__
 *
 * To run a query within a React component, call `useKinAsyncConsultConfirmedPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useKinAsyncConsultConfirmedPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKinAsyncConsultConfirmedPageQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function useKinAsyncConsultConfirmedPageQuery(baseOptions: Apollo.QueryHookOptions<KinAsyncConsultConfirmedPageQuery, KinAsyncConsultConfirmedPageQueryVariables> & ({ variables: KinAsyncConsultConfirmedPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KinAsyncConsultConfirmedPageQuery, KinAsyncConsultConfirmedPageQueryVariables>(KinAsyncConsultConfirmedPageDocument, options);
      }
export function useKinAsyncConsultConfirmedPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KinAsyncConsultConfirmedPageQuery, KinAsyncConsultConfirmedPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KinAsyncConsultConfirmedPageQuery, KinAsyncConsultConfirmedPageQueryVariables>(KinAsyncConsultConfirmedPageDocument, options);
        }
export function useKinAsyncConsultConfirmedPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<KinAsyncConsultConfirmedPageQuery, KinAsyncConsultConfirmedPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<KinAsyncConsultConfirmedPageQuery, KinAsyncConsultConfirmedPageQueryVariables>(KinAsyncConsultConfirmedPageDocument, options);
        }
export type KinAsyncConsultConfirmedPageQueryHookResult = ReturnType<typeof useKinAsyncConsultConfirmedPageQuery>;
export type KinAsyncConsultConfirmedPageLazyQueryHookResult = ReturnType<typeof useKinAsyncConsultConfirmedPageLazyQuery>;
export type KinAsyncConsultConfirmedPageSuspenseQueryHookResult = ReturnType<typeof useKinAsyncConsultConfirmedPageSuspenseQuery>;
export type KinAsyncConsultConfirmedPageQueryResult = Apollo.QueryResult<KinAsyncConsultConfirmedPageQuery, KinAsyncConsultConfirmedPageQueryVariables>;
export const KinAsyncEligibleMedicarePageDocument = gql`
    query KinAsyncEligibleMedicarePage($consultationId: String!, $problemType: ProblemType!) {
  consultation(id: $consultationId) {
    id
    customer {
      id
      ... on User {
        condition(problemType: $problemType) {
          id
          asyncEligible
        }
      }
    }
  }
}
    `;

/**
 * __useKinAsyncEligibleMedicarePageQuery__
 *
 * To run a query within a React component, call `useKinAsyncEligibleMedicarePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useKinAsyncEligibleMedicarePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKinAsyncEligibleMedicarePageQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *      problemType: // value for 'problemType'
 *   },
 * });
 */
export function useKinAsyncEligibleMedicarePageQuery(baseOptions: Apollo.QueryHookOptions<KinAsyncEligibleMedicarePageQuery, KinAsyncEligibleMedicarePageQueryVariables> & ({ variables: KinAsyncEligibleMedicarePageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KinAsyncEligibleMedicarePageQuery, KinAsyncEligibleMedicarePageQueryVariables>(KinAsyncEligibleMedicarePageDocument, options);
      }
export function useKinAsyncEligibleMedicarePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KinAsyncEligibleMedicarePageQuery, KinAsyncEligibleMedicarePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KinAsyncEligibleMedicarePageQuery, KinAsyncEligibleMedicarePageQueryVariables>(KinAsyncEligibleMedicarePageDocument, options);
        }
export function useKinAsyncEligibleMedicarePageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<KinAsyncEligibleMedicarePageQuery, KinAsyncEligibleMedicarePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<KinAsyncEligibleMedicarePageQuery, KinAsyncEligibleMedicarePageQueryVariables>(KinAsyncEligibleMedicarePageDocument, options);
        }
export type KinAsyncEligibleMedicarePageQueryHookResult = ReturnType<typeof useKinAsyncEligibleMedicarePageQuery>;
export type KinAsyncEligibleMedicarePageLazyQueryHookResult = ReturnType<typeof useKinAsyncEligibleMedicarePageLazyQuery>;
export type KinAsyncEligibleMedicarePageSuspenseQueryHookResult = ReturnType<typeof useKinAsyncEligibleMedicarePageSuspenseQuery>;
export type KinAsyncEligibleMedicarePageQueryResult = Apollo.QueryResult<KinAsyncEligibleMedicarePageQuery, KinAsyncEligibleMedicarePageQueryVariables>;
export const FertilityTestConfirmCardPathologyLocationHealiusDocument = gql`
    query FertilityTestConfirmCardPathologyLocationHealius($postcode: String!) {
  pathologyLocationHealius(postcode: $postcode) {
    display
    url
  }
}
    `;

/**
 * __useFertilityTestConfirmCardPathologyLocationHealiusQuery__
 *
 * To run a query within a React component, call `useFertilityTestConfirmCardPathologyLocationHealiusQuery` and pass it any options that fit your needs.
 * When your component renders, `useFertilityTestConfirmCardPathologyLocationHealiusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFertilityTestConfirmCardPathologyLocationHealiusQuery({
 *   variables: {
 *      postcode: // value for 'postcode'
 *   },
 * });
 */
export function useFertilityTestConfirmCardPathologyLocationHealiusQuery(baseOptions: Apollo.QueryHookOptions<FertilityTestConfirmCardPathologyLocationHealiusQuery, FertilityTestConfirmCardPathologyLocationHealiusQueryVariables> & ({ variables: FertilityTestConfirmCardPathologyLocationHealiusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FertilityTestConfirmCardPathologyLocationHealiusQuery, FertilityTestConfirmCardPathologyLocationHealiusQueryVariables>(FertilityTestConfirmCardPathologyLocationHealiusDocument, options);
      }
export function useFertilityTestConfirmCardPathologyLocationHealiusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FertilityTestConfirmCardPathologyLocationHealiusQuery, FertilityTestConfirmCardPathologyLocationHealiusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FertilityTestConfirmCardPathologyLocationHealiusQuery, FertilityTestConfirmCardPathologyLocationHealiusQueryVariables>(FertilityTestConfirmCardPathologyLocationHealiusDocument, options);
        }
export function useFertilityTestConfirmCardPathologyLocationHealiusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FertilityTestConfirmCardPathologyLocationHealiusQuery, FertilityTestConfirmCardPathologyLocationHealiusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FertilityTestConfirmCardPathologyLocationHealiusQuery, FertilityTestConfirmCardPathologyLocationHealiusQueryVariables>(FertilityTestConfirmCardPathologyLocationHealiusDocument, options);
        }
export type FertilityTestConfirmCardPathologyLocationHealiusQueryHookResult = ReturnType<typeof useFertilityTestConfirmCardPathologyLocationHealiusQuery>;
export type FertilityTestConfirmCardPathologyLocationHealiusLazyQueryHookResult = ReturnType<typeof useFertilityTestConfirmCardPathologyLocationHealiusLazyQuery>;
export type FertilityTestConfirmCardPathologyLocationHealiusSuspenseQueryHookResult = ReturnType<typeof useFertilityTestConfirmCardPathologyLocationHealiusSuspenseQuery>;
export type FertilityTestConfirmCardPathologyLocationHealiusQueryResult = Apollo.QueryResult<FertilityTestConfirmCardPathologyLocationHealiusQuery, FertilityTestConfirmCardPathologyLocationHealiusQueryVariables>;
export const FollowUpConsultationDocument = gql`
    query FollowUpConsultation($id: String!) {
  consultation(id: $id) {
    id
    type
    status
  }
}
    `;

/**
 * __useFollowUpConsultationQuery__
 *
 * To run a query within a React component, call `useFollowUpConsultationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFollowUpConsultationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFollowUpConsultationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFollowUpConsultationQuery(baseOptions: Apollo.QueryHookOptions<FollowUpConsultationQuery, FollowUpConsultationQueryVariables> & ({ variables: FollowUpConsultationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FollowUpConsultationQuery, FollowUpConsultationQueryVariables>(FollowUpConsultationDocument, options);
      }
export function useFollowUpConsultationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FollowUpConsultationQuery, FollowUpConsultationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FollowUpConsultationQuery, FollowUpConsultationQueryVariables>(FollowUpConsultationDocument, options);
        }
export function useFollowUpConsultationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FollowUpConsultationQuery, FollowUpConsultationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FollowUpConsultationQuery, FollowUpConsultationQueryVariables>(FollowUpConsultationDocument, options);
        }
export type FollowUpConsultationQueryHookResult = ReturnType<typeof useFollowUpConsultationQuery>;
export type FollowUpConsultationLazyQueryHookResult = ReturnType<typeof useFollowUpConsultationLazyQuery>;
export type FollowUpConsultationSuspenseQueryHookResult = ReturnType<typeof useFollowUpConsultationSuspenseQuery>;
export type FollowUpConsultationQueryResult = Apollo.QueryResult<FollowUpConsultationQuery, FollowUpConsultationQueryVariables>;
export const VideoConsultationNotesDocument = gql`
    query VideoConsultationNotes($id: String!) {
  consultation(id: $id) {
    id
    patientNotes
  }
}
    `;

/**
 * __useVideoConsultationNotesQuery__
 *
 * To run a query within a React component, call `useVideoConsultationNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVideoConsultationNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVideoConsultationNotesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVideoConsultationNotesQuery(baseOptions: Apollo.QueryHookOptions<VideoConsultationNotesQuery, VideoConsultationNotesQueryVariables> & ({ variables: VideoConsultationNotesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VideoConsultationNotesQuery, VideoConsultationNotesQueryVariables>(VideoConsultationNotesDocument, options);
      }
export function useVideoConsultationNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VideoConsultationNotesQuery, VideoConsultationNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VideoConsultationNotesQuery, VideoConsultationNotesQueryVariables>(VideoConsultationNotesDocument, options);
        }
export function useVideoConsultationNotesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<VideoConsultationNotesQuery, VideoConsultationNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VideoConsultationNotesQuery, VideoConsultationNotesQueryVariables>(VideoConsultationNotesDocument, options);
        }
export type VideoConsultationNotesQueryHookResult = ReturnType<typeof useVideoConsultationNotesQuery>;
export type VideoConsultationNotesLazyQueryHookResult = ReturnType<typeof useVideoConsultationNotesLazyQuery>;
export type VideoConsultationNotesSuspenseQueryHookResult = ReturnType<typeof useVideoConsultationNotesSuspenseQuery>;
export type VideoConsultationNotesQueryResult = Apollo.QueryResult<VideoConsultationNotesQuery, VideoConsultationNotesQueryVariables>;
export const FertilityTestPaymentPathologyPanelTestNamesDocument = gql`
    query FertilityTestPaymentPathologyPanelTestNames($type: ProblemType!) {
  pathologyPanelTestNames(type: $type) {
    displayName
    name
  }
}
    `;

/**
 * __useFertilityTestPaymentPathologyPanelTestNamesQuery__
 *
 * To run a query within a React component, call `useFertilityTestPaymentPathologyPanelTestNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFertilityTestPaymentPathologyPanelTestNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFertilityTestPaymentPathologyPanelTestNamesQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useFertilityTestPaymentPathologyPanelTestNamesQuery(baseOptions: Apollo.QueryHookOptions<FertilityTestPaymentPathologyPanelTestNamesQuery, FertilityTestPaymentPathologyPanelTestNamesQueryVariables> & ({ variables: FertilityTestPaymentPathologyPanelTestNamesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FertilityTestPaymentPathologyPanelTestNamesQuery, FertilityTestPaymentPathologyPanelTestNamesQueryVariables>(FertilityTestPaymentPathologyPanelTestNamesDocument, options);
      }
export function useFertilityTestPaymentPathologyPanelTestNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FertilityTestPaymentPathologyPanelTestNamesQuery, FertilityTestPaymentPathologyPanelTestNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FertilityTestPaymentPathologyPanelTestNamesQuery, FertilityTestPaymentPathologyPanelTestNamesQueryVariables>(FertilityTestPaymentPathologyPanelTestNamesDocument, options);
        }
export function useFertilityTestPaymentPathologyPanelTestNamesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FertilityTestPaymentPathologyPanelTestNamesQuery, FertilityTestPaymentPathologyPanelTestNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FertilityTestPaymentPathologyPanelTestNamesQuery, FertilityTestPaymentPathologyPanelTestNamesQueryVariables>(FertilityTestPaymentPathologyPanelTestNamesDocument, options);
        }
export type FertilityTestPaymentPathologyPanelTestNamesQueryHookResult = ReturnType<typeof useFertilityTestPaymentPathologyPanelTestNamesQuery>;
export type FertilityTestPaymentPathologyPanelTestNamesLazyQueryHookResult = ReturnType<typeof useFertilityTestPaymentPathologyPanelTestNamesLazyQuery>;
export type FertilityTestPaymentPathologyPanelTestNamesSuspenseQueryHookResult = ReturnType<typeof useFertilityTestPaymentPathologyPanelTestNamesSuspenseQuery>;
export type FertilityTestPaymentPathologyPanelTestNamesQueryResult = Apollo.QueryResult<FertilityTestPaymentPathologyPanelTestNamesQuery, FertilityTestPaymentPathologyPanelTestNamesQueryVariables>;
export const KinPracBookingConfirmationPageDocument = gql`
    query KinPracBookingConfirmationPage($pracBookingId: ID!) {
  practitionerBooking(id: $pracBookingId) {
    id
    consultation {
      id
      type
    }
    patient {
      id
      email
      phone
    }
    windowStartAt
    windowEndAt
  }
  validPhoneRegions {
    id
    countryCode
  }
}
    `;

/**
 * __useKinPracBookingConfirmationPageQuery__
 *
 * To run a query within a React component, call `useKinPracBookingConfirmationPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useKinPracBookingConfirmationPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKinPracBookingConfirmationPageQuery({
 *   variables: {
 *      pracBookingId: // value for 'pracBookingId'
 *   },
 * });
 */
export function useKinPracBookingConfirmationPageQuery(baseOptions: Apollo.QueryHookOptions<KinPracBookingConfirmationPageQuery, KinPracBookingConfirmationPageQueryVariables> & ({ variables: KinPracBookingConfirmationPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KinPracBookingConfirmationPageQuery, KinPracBookingConfirmationPageQueryVariables>(KinPracBookingConfirmationPageDocument, options);
      }
export function useKinPracBookingConfirmationPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KinPracBookingConfirmationPageQuery, KinPracBookingConfirmationPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KinPracBookingConfirmationPageQuery, KinPracBookingConfirmationPageQueryVariables>(KinPracBookingConfirmationPageDocument, options);
        }
export function useKinPracBookingConfirmationPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<KinPracBookingConfirmationPageQuery, KinPracBookingConfirmationPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<KinPracBookingConfirmationPageQuery, KinPracBookingConfirmationPageQueryVariables>(KinPracBookingConfirmationPageDocument, options);
        }
export type KinPracBookingConfirmationPageQueryHookResult = ReturnType<typeof useKinPracBookingConfirmationPageQuery>;
export type KinPracBookingConfirmationPageLazyQueryHookResult = ReturnType<typeof useKinPracBookingConfirmationPageLazyQuery>;
export type KinPracBookingConfirmationPageSuspenseQueryHookResult = ReturnType<typeof useKinPracBookingConfirmationPageSuspenseQuery>;
export type KinPracBookingConfirmationPageQueryResult = Apollo.QueryResult<KinPracBookingConfirmationPageQuery, KinPracBookingConfirmationPageQueryVariables>;
export const KinPractitionerPhoneCallPageDocument = gql`
    query KinPractitionerPhoneCallPage($consultationId: String!) {
  consultation(id: $consultationId) {
    id
    latestPractitionerBooking {
      id
    }
  }
}
    `;

/**
 * __useKinPractitionerPhoneCallPageQuery__
 *
 * To run a query within a React component, call `useKinPractitionerPhoneCallPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useKinPractitionerPhoneCallPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKinPractitionerPhoneCallPageQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function useKinPractitionerPhoneCallPageQuery(baseOptions: Apollo.QueryHookOptions<KinPractitionerPhoneCallPageQuery, KinPractitionerPhoneCallPageQueryVariables> & ({ variables: KinPractitionerPhoneCallPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KinPractitionerPhoneCallPageQuery, KinPractitionerPhoneCallPageQueryVariables>(KinPractitionerPhoneCallPageDocument, options);
      }
export function useKinPractitionerPhoneCallPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KinPractitionerPhoneCallPageQuery, KinPractitionerPhoneCallPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KinPractitionerPhoneCallPageQuery, KinPractitionerPhoneCallPageQueryVariables>(KinPractitionerPhoneCallPageDocument, options);
        }
export function useKinPractitionerPhoneCallPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<KinPractitionerPhoneCallPageQuery, KinPractitionerPhoneCallPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<KinPractitionerPhoneCallPageQuery, KinPractitionerPhoneCallPageQueryVariables>(KinPractitionerPhoneCallPageDocument, options);
        }
export type KinPractitionerPhoneCallPageQueryHookResult = ReturnType<typeof useKinPractitionerPhoneCallPageQuery>;
export type KinPractitionerPhoneCallPageLazyQueryHookResult = ReturnType<typeof useKinPractitionerPhoneCallPageLazyQuery>;
export type KinPractitionerPhoneCallPageSuspenseQueryHookResult = ReturnType<typeof useKinPractitionerPhoneCallPageSuspenseQuery>;
export type KinPractitionerPhoneCallPageQueryResult = Apollo.QueryResult<KinPractitionerPhoneCallPageQuery, KinPractitionerPhoneCallPageQueryVariables>;
export const KinSchedulePhoneCallPageDocument = gql`
    query KinSchedulePhoneCallPage($consultationId: String!) {
  consultation(id: $consultationId) {
    id
    latestPractitionerBooking {
      id
    }
  }
}
    `;

/**
 * __useKinSchedulePhoneCallPageQuery__
 *
 * To run a query within a React component, call `useKinSchedulePhoneCallPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useKinSchedulePhoneCallPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKinSchedulePhoneCallPageQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function useKinSchedulePhoneCallPageQuery(baseOptions: Apollo.QueryHookOptions<KinSchedulePhoneCallPageQuery, KinSchedulePhoneCallPageQueryVariables> & ({ variables: KinSchedulePhoneCallPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KinSchedulePhoneCallPageQuery, KinSchedulePhoneCallPageQueryVariables>(KinSchedulePhoneCallPageDocument, options);
      }
export function useKinSchedulePhoneCallPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KinSchedulePhoneCallPageQuery, KinSchedulePhoneCallPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KinSchedulePhoneCallPageQuery, KinSchedulePhoneCallPageQueryVariables>(KinSchedulePhoneCallPageDocument, options);
        }
export function useKinSchedulePhoneCallPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<KinSchedulePhoneCallPageQuery, KinSchedulePhoneCallPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<KinSchedulePhoneCallPageQuery, KinSchedulePhoneCallPageQueryVariables>(KinSchedulePhoneCallPageDocument, options);
        }
export type KinSchedulePhoneCallPageQueryHookResult = ReturnType<typeof useKinSchedulePhoneCallPageQuery>;
export type KinSchedulePhoneCallPageLazyQueryHookResult = ReturnType<typeof useKinSchedulePhoneCallPageLazyQuery>;
export type KinSchedulePhoneCallPageSuspenseQueryHookResult = ReturnType<typeof useKinSchedulePhoneCallPageSuspenseQuery>;
export type KinSchedulePhoneCallPageQueryResult = Apollo.QueryResult<KinSchedulePhoneCallPageQuery, KinSchedulePhoneCallPageQueryVariables>;
export const KinRedirectPageDocument = gql`
    query KinRedirectPage($id: String!) {
  consultation(id: $id) {
    id
    isApproved
    customerId
    quizApplication {
      id
      problemType
    }
    screeningQuizApplication {
      id
      submittedAt
    }
    allowPatientToSendMessageToDoctor
    requiresPrescriberCall
    isInNoPickUpQueue
    latestPractitionerBooking {
      id
    }
    chatThread {
      id
    }
    stage
    status
    type
    medium
  }
}
    `;

/**
 * __useKinRedirectPageQuery__
 *
 * To run a query within a React component, call `useKinRedirectPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useKinRedirectPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKinRedirectPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useKinRedirectPageQuery(baseOptions: Apollo.QueryHookOptions<KinRedirectPageQuery, KinRedirectPageQueryVariables> & ({ variables: KinRedirectPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KinRedirectPageQuery, KinRedirectPageQueryVariables>(KinRedirectPageDocument, options);
      }
export function useKinRedirectPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KinRedirectPageQuery, KinRedirectPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KinRedirectPageQuery, KinRedirectPageQueryVariables>(KinRedirectPageDocument, options);
        }
export function useKinRedirectPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<KinRedirectPageQuery, KinRedirectPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<KinRedirectPageQuery, KinRedirectPageQueryVariables>(KinRedirectPageDocument, options);
        }
export type KinRedirectPageQueryHookResult = ReturnType<typeof useKinRedirectPageQuery>;
export type KinRedirectPageLazyQueryHookResult = ReturnType<typeof useKinRedirectPageLazyQuery>;
export type KinRedirectPageSuspenseQueryHookResult = ReturnType<typeof useKinRedirectPageSuspenseQuery>;
export type KinRedirectPageQueryResult = Apollo.QueryResult<KinRedirectPageQuery, KinRedirectPageQueryVariables>;
export const ScheduleVideoConsultDocument = gql`
    query ScheduleVideoConsult($consultationId: String!) {
  consultation(id: $consultationId) {
    id
    type
    doctor {
      id
      acuityId
    }
  }
  profile {
    id
    firstName
    lastName
    phone
    email
  }
}
    `;

/**
 * __useScheduleVideoConsultQuery__
 *
 * To run a query within a React component, call `useScheduleVideoConsultQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleVideoConsultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleVideoConsultQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function useScheduleVideoConsultQuery(baseOptions: Apollo.QueryHookOptions<ScheduleVideoConsultQuery, ScheduleVideoConsultQueryVariables> & ({ variables: ScheduleVideoConsultQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduleVideoConsultQuery, ScheduleVideoConsultQueryVariables>(ScheduleVideoConsultDocument, options);
      }
export function useScheduleVideoConsultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduleVideoConsultQuery, ScheduleVideoConsultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduleVideoConsultQuery, ScheduleVideoConsultQueryVariables>(ScheduleVideoConsultDocument, options);
        }
export function useScheduleVideoConsultSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ScheduleVideoConsultQuery, ScheduleVideoConsultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScheduleVideoConsultQuery, ScheduleVideoConsultQueryVariables>(ScheduleVideoConsultDocument, options);
        }
export type ScheduleVideoConsultQueryHookResult = ReturnType<typeof useScheduleVideoConsultQuery>;
export type ScheduleVideoConsultLazyQueryHookResult = ReturnType<typeof useScheduleVideoConsultLazyQuery>;
export type ScheduleVideoConsultSuspenseQueryHookResult = ReturnType<typeof useScheduleVideoConsultSuspenseQuery>;
export type ScheduleVideoConsultQueryResult = Apollo.QueryResult<ScheduleVideoConsultQuery, ScheduleVideoConsultQueryVariables>;
export const ScheduleFertilityTestVideoConsultDocument = gql`
    query ScheduleFertilityTestVideoConsult($consultationId: String!) {
  consultation(id: $consultationId) {
    id
    type
    doctor {
      id
      acuityId
    }
  }
  profile {
    id
    firstName
    lastName
    phone
    email
  }
}
    `;

/**
 * __useScheduleFertilityTestVideoConsultQuery__
 *
 * To run a query within a React component, call `useScheduleFertilityTestVideoConsultQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleFertilityTestVideoConsultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleFertilityTestVideoConsultQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function useScheduleFertilityTestVideoConsultQuery(baseOptions: Apollo.QueryHookOptions<ScheduleFertilityTestVideoConsultQuery, ScheduleFertilityTestVideoConsultQueryVariables> & ({ variables: ScheduleFertilityTestVideoConsultQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduleFertilityTestVideoConsultQuery, ScheduleFertilityTestVideoConsultQueryVariables>(ScheduleFertilityTestVideoConsultDocument, options);
      }
export function useScheduleFertilityTestVideoConsultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduleFertilityTestVideoConsultQuery, ScheduleFertilityTestVideoConsultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduleFertilityTestVideoConsultQuery, ScheduleFertilityTestVideoConsultQueryVariables>(ScheduleFertilityTestVideoConsultDocument, options);
        }
export function useScheduleFertilityTestVideoConsultSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ScheduleFertilityTestVideoConsultQuery, ScheduleFertilityTestVideoConsultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScheduleFertilityTestVideoConsultQuery, ScheduleFertilityTestVideoConsultQueryVariables>(ScheduleFertilityTestVideoConsultDocument, options);
        }
export type ScheduleFertilityTestVideoConsultQueryHookResult = ReturnType<typeof useScheduleFertilityTestVideoConsultQuery>;
export type ScheduleFertilityTestVideoConsultLazyQueryHookResult = ReturnType<typeof useScheduleFertilityTestVideoConsultLazyQuery>;
export type ScheduleFertilityTestVideoConsultSuspenseQueryHookResult = ReturnType<typeof useScheduleFertilityTestVideoConsultSuspenseQuery>;
export type ScheduleFertilityTestVideoConsultQueryResult = Apollo.QueryResult<ScheduleFertilityTestVideoConsultQuery, ScheduleFertilityTestVideoConsultQueryVariables>;
export const KinProfilePageDocument = gql`
    query KinProfilePage($crossSellContext: CrossSellContextType!) {
  profile {
    id
    shortAddressableName
    savedPaymentMethods {
      createdAt
      default
      gateway
      id
      ... on SavedCardPaymentMethod {
        brand
        mask
        expiry
      }
      ... on SavedPayPalPaymentMethod {
        email
      }
      ... on SavedZipPaymentMethod {
        valid
      }
    }
  }
  crossSellRecommendations(crossSellContext: $crossSellContext) {
    recommendations
  }
}
    `;

/**
 * __useKinProfilePageQuery__
 *
 * To run a query within a React component, call `useKinProfilePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useKinProfilePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKinProfilePageQuery({
 *   variables: {
 *      crossSellContext: // value for 'crossSellContext'
 *   },
 * });
 */
export function useKinProfilePageQuery(baseOptions: Apollo.QueryHookOptions<KinProfilePageQuery, KinProfilePageQueryVariables> & ({ variables: KinProfilePageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KinProfilePageQuery, KinProfilePageQueryVariables>(KinProfilePageDocument, options);
      }
export function useKinProfilePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KinProfilePageQuery, KinProfilePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KinProfilePageQuery, KinProfilePageQueryVariables>(KinProfilePageDocument, options);
        }
export function useKinProfilePageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<KinProfilePageQuery, KinProfilePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<KinProfilePageQuery, KinProfilePageQueryVariables>(KinProfilePageDocument, options);
        }
export type KinProfilePageQueryHookResult = ReturnType<typeof useKinProfilePageQuery>;
export type KinProfilePageLazyQueryHookResult = ReturnType<typeof useKinProfilePageLazyQuery>;
export type KinProfilePageSuspenseQueryHookResult = ReturnType<typeof useKinProfilePageSuspenseQuery>;
export type KinProfilePageQueryResult = Apollo.QueryResult<KinProfilePageQuery, KinProfilePageQueryVariables>;
export const CreateConceptionChecklistDocument = gql`
    mutation CreateConceptionChecklist($consultationId: String!, $type: String!) {
  createChecklist(consultationId: $consultationId, type: $type) {
    id
    consultationId
    attributes {
      age
      tryingStatus
      trimester
      expectedNewborns
    }
    groups {
      id
      items {
        id
        code
        completed
      }
    }
  }
}
    `;
export type CreateConceptionChecklistMutationFn = Apollo.MutationFunction<CreateConceptionChecklistMutation, CreateConceptionChecklistMutationVariables>;

/**
 * __useCreateConceptionChecklistMutation__
 *
 * To run a mutation, you first call `useCreateConceptionChecklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConceptionChecklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConceptionChecklistMutation, { data, loading, error }] = useCreateConceptionChecklistMutation({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreateConceptionChecklistMutation(baseOptions?: Apollo.MutationHookOptions<CreateConceptionChecklistMutation, CreateConceptionChecklistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateConceptionChecklistMutation, CreateConceptionChecklistMutationVariables>(CreateConceptionChecklistDocument, options);
      }
export type CreateConceptionChecklistMutationHookResult = ReturnType<typeof useCreateConceptionChecklistMutation>;
export type CreateConceptionChecklistMutationResult = Apollo.MutationResult<CreateConceptionChecklistMutation>;
export type CreateConceptionChecklistMutationOptions = Apollo.BaseMutationOptions<CreateConceptionChecklistMutation, CreateConceptionChecklistMutationVariables>;
export const KinQuizCompletePageDocument = gql`
    query KinQuizCompletePage($id: String!) {
  getQuizApplication(id: $id) {
    id
    purpose
    problemType
    quiz {
      id
      default
      quizCode
    }
    consultation {
      id
      stage
    }
    outcomes {
      ... on QuizOutcomeV2 {
        id
      }
    }
  }
}
    `;

/**
 * __useKinQuizCompletePageQuery__
 *
 * To run a query within a React component, call `useKinQuizCompletePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useKinQuizCompletePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKinQuizCompletePageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useKinQuizCompletePageQuery(baseOptions: Apollo.QueryHookOptions<KinQuizCompletePageQuery, KinQuizCompletePageQueryVariables> & ({ variables: KinQuizCompletePageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KinQuizCompletePageQuery, KinQuizCompletePageQueryVariables>(KinQuizCompletePageDocument, options);
      }
export function useKinQuizCompletePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KinQuizCompletePageQuery, KinQuizCompletePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KinQuizCompletePageQuery, KinQuizCompletePageQueryVariables>(KinQuizCompletePageDocument, options);
        }
export function useKinQuizCompletePageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<KinQuizCompletePageQuery, KinQuizCompletePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<KinQuizCompletePageQuery, KinQuizCompletePageQueryVariables>(KinQuizCompletePageDocument, options);
        }
export type KinQuizCompletePageQueryHookResult = ReturnType<typeof useKinQuizCompletePageQuery>;
export type KinQuizCompletePageLazyQueryHookResult = ReturnType<typeof useKinQuizCompletePageLazyQuery>;
export type KinQuizCompletePageSuspenseQueryHookResult = ReturnType<typeof useKinQuizCompletePageSuspenseQuery>;
export type KinQuizCompletePageQueryResult = Apollo.QueryResult<KinQuizCompletePageQuery, KinQuizCompletePageQueryVariables>;
export const KinAsyncEligibleQuizCompleteDocument = gql`
    query KinAsyncEligibleQuizComplete($consultationId: String!, $problemType: ProblemType!) {
  consultation(id: $consultationId) {
    id
    customer {
      id
      ... on User {
        condition(problemType: $problemType) {
          id
          asyncEligible
        }
      }
    }
  }
}
    `;

/**
 * __useKinAsyncEligibleQuizCompleteQuery__
 *
 * To run a query within a React component, call `useKinAsyncEligibleQuizCompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useKinAsyncEligibleQuizCompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKinAsyncEligibleQuizCompleteQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *      problemType: // value for 'problemType'
 *   },
 * });
 */
export function useKinAsyncEligibleQuizCompleteQuery(baseOptions: Apollo.QueryHookOptions<KinAsyncEligibleQuizCompleteQuery, KinAsyncEligibleQuizCompleteQueryVariables> & ({ variables: KinAsyncEligibleQuizCompleteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KinAsyncEligibleQuizCompleteQuery, KinAsyncEligibleQuizCompleteQueryVariables>(KinAsyncEligibleQuizCompleteDocument, options);
      }
export function useKinAsyncEligibleQuizCompleteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KinAsyncEligibleQuizCompleteQuery, KinAsyncEligibleQuizCompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KinAsyncEligibleQuizCompleteQuery, KinAsyncEligibleQuizCompleteQueryVariables>(KinAsyncEligibleQuizCompleteDocument, options);
        }
export function useKinAsyncEligibleQuizCompleteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<KinAsyncEligibleQuizCompleteQuery, KinAsyncEligibleQuizCompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<KinAsyncEligibleQuizCompleteQuery, KinAsyncEligibleQuizCompleteQueryVariables>(KinAsyncEligibleQuizCompleteDocument, options);
        }
export type KinAsyncEligibleQuizCompleteQueryHookResult = ReturnType<typeof useKinAsyncEligibleQuizCompleteQuery>;
export type KinAsyncEligibleQuizCompleteLazyQueryHookResult = ReturnType<typeof useKinAsyncEligibleQuizCompleteLazyQuery>;
export type KinAsyncEligibleQuizCompleteSuspenseQueryHookResult = ReturnType<typeof useKinAsyncEligibleQuizCompleteSuspenseQuery>;
export type KinAsyncEligibleQuizCompleteQueryResult = Apollo.QueryResult<KinAsyncEligibleQuizCompleteQuery, KinAsyncEligibleQuizCompleteQueryVariables>;
export const TreatmentOrdersDocument = gql`
    query TreatmentOrders($where: TreatmentWhereInput) {
  treatments(where: $where) {
    id
    orders {
      id
      paymentStatus
    }
  }
}
    `;

/**
 * __useTreatmentOrdersQuery__
 *
 * To run a query within a React component, call `useTreatmentOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTreatmentOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTreatmentOrdersQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useTreatmentOrdersQuery(baseOptions?: Apollo.QueryHookOptions<TreatmentOrdersQuery, TreatmentOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TreatmentOrdersQuery, TreatmentOrdersQueryVariables>(TreatmentOrdersDocument, options);
      }
export function useTreatmentOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TreatmentOrdersQuery, TreatmentOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TreatmentOrdersQuery, TreatmentOrdersQueryVariables>(TreatmentOrdersDocument, options);
        }
export function useTreatmentOrdersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TreatmentOrdersQuery, TreatmentOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TreatmentOrdersQuery, TreatmentOrdersQueryVariables>(TreatmentOrdersDocument, options);
        }
export type TreatmentOrdersQueryHookResult = ReturnType<typeof useTreatmentOrdersQuery>;
export type TreatmentOrdersLazyQueryHookResult = ReturnType<typeof useTreatmentOrdersLazyQuery>;
export type TreatmentOrdersSuspenseQueryHookResult = ReturnType<typeof useTreatmentOrdersSuspenseQuery>;
export type TreatmentOrdersQueryResult = Apollo.QueryResult<TreatmentOrdersQuery, TreatmentOrdersQueryVariables>;
export const PilotAsyncConsultConfirmedPageDocument = gql`
    query PilotAsyncConsultConfirmedPage($consultationId: String!) {
  consultation(id: $consultationId) {
    id
    type
    requiresPrescriberCall
  }
}
    `;

/**
 * __usePilotAsyncConsultConfirmedPageQuery__
 *
 * To run a query within a React component, call `usePilotAsyncConsultConfirmedPageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePilotAsyncConsultConfirmedPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePilotAsyncConsultConfirmedPageQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function usePilotAsyncConsultConfirmedPageQuery(baseOptions: Apollo.QueryHookOptions<PilotAsyncConsultConfirmedPageQuery, PilotAsyncConsultConfirmedPageQueryVariables> & ({ variables: PilotAsyncConsultConfirmedPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PilotAsyncConsultConfirmedPageQuery, PilotAsyncConsultConfirmedPageQueryVariables>(PilotAsyncConsultConfirmedPageDocument, options);
      }
export function usePilotAsyncConsultConfirmedPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PilotAsyncConsultConfirmedPageQuery, PilotAsyncConsultConfirmedPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PilotAsyncConsultConfirmedPageQuery, PilotAsyncConsultConfirmedPageQueryVariables>(PilotAsyncConsultConfirmedPageDocument, options);
        }
export function usePilotAsyncConsultConfirmedPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PilotAsyncConsultConfirmedPageQuery, PilotAsyncConsultConfirmedPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PilotAsyncConsultConfirmedPageQuery, PilotAsyncConsultConfirmedPageQueryVariables>(PilotAsyncConsultConfirmedPageDocument, options);
        }
export type PilotAsyncConsultConfirmedPageQueryHookResult = ReturnType<typeof usePilotAsyncConsultConfirmedPageQuery>;
export type PilotAsyncConsultConfirmedPageLazyQueryHookResult = ReturnType<typeof usePilotAsyncConsultConfirmedPageLazyQuery>;
export type PilotAsyncConsultConfirmedPageSuspenseQueryHookResult = ReturnType<typeof usePilotAsyncConsultConfirmedPageSuspenseQuery>;
export type PilotAsyncConsultConfirmedPageQueryResult = Apollo.QueryResult<PilotAsyncConsultConfirmedPageQuery, PilotAsyncConsultConfirmedPageQueryVariables>;
export const PilotCollectAddressPageDocument = gql`
    query PilotCollectAddressPage($consultationId: String!) {
  consultation(id: $consultationId) {
    id
    type
  }
}
    `;

/**
 * __usePilotCollectAddressPageQuery__
 *
 * To run a query within a React component, call `usePilotCollectAddressPageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePilotCollectAddressPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePilotCollectAddressPageQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function usePilotCollectAddressPageQuery(baseOptions: Apollo.QueryHookOptions<PilotCollectAddressPageQuery, PilotCollectAddressPageQueryVariables> & ({ variables: PilotCollectAddressPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PilotCollectAddressPageQuery, PilotCollectAddressPageQueryVariables>(PilotCollectAddressPageDocument, options);
      }
export function usePilotCollectAddressPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PilotCollectAddressPageQuery, PilotCollectAddressPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PilotCollectAddressPageQuery, PilotCollectAddressPageQueryVariables>(PilotCollectAddressPageDocument, options);
        }
export function usePilotCollectAddressPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PilotCollectAddressPageQuery, PilotCollectAddressPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PilotCollectAddressPageQuery, PilotCollectAddressPageQueryVariables>(PilotCollectAddressPageDocument, options);
        }
export type PilotCollectAddressPageQueryHookResult = ReturnType<typeof usePilotCollectAddressPageQuery>;
export type PilotCollectAddressPageLazyQueryHookResult = ReturnType<typeof usePilotCollectAddressPageLazyQuery>;
export type PilotCollectAddressPageSuspenseQueryHookResult = ReturnType<typeof usePilotCollectAddressPageSuspenseQuery>;
export type PilotCollectAddressPageQueryResult = Apollo.QueryResult<PilotCollectAddressPageQuery, PilotCollectAddressPageQueryVariables>;
export const PilotCollectMedicarePageDocument = gql`
    query PilotCollectMedicarePage($consultationId: String!) {
  consultation(id: $consultationId) {
    id
    type
    stage
    isUpfrontPayment
    canSchedulePractitionerBooking
    quizApplication {
      id
      problemType
    }
  }
}
    `;

/**
 * __usePilotCollectMedicarePageQuery__
 *
 * To run a query within a React component, call `usePilotCollectMedicarePageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePilotCollectMedicarePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePilotCollectMedicarePageQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function usePilotCollectMedicarePageQuery(baseOptions: Apollo.QueryHookOptions<PilotCollectMedicarePageQuery, PilotCollectMedicarePageQueryVariables> & ({ variables: PilotCollectMedicarePageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PilotCollectMedicarePageQuery, PilotCollectMedicarePageQueryVariables>(PilotCollectMedicarePageDocument, options);
      }
export function usePilotCollectMedicarePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PilotCollectMedicarePageQuery, PilotCollectMedicarePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PilotCollectMedicarePageQuery, PilotCollectMedicarePageQueryVariables>(PilotCollectMedicarePageDocument, options);
        }
export function usePilotCollectMedicarePageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PilotCollectMedicarePageQuery, PilotCollectMedicarePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PilotCollectMedicarePageQuery, PilotCollectMedicarePageQueryVariables>(PilotCollectMedicarePageDocument, options);
        }
export type PilotCollectMedicarePageQueryHookResult = ReturnType<typeof usePilotCollectMedicarePageQuery>;
export type PilotCollectMedicarePageLazyQueryHookResult = ReturnType<typeof usePilotCollectMedicarePageLazyQuery>;
export type PilotCollectMedicarePageSuspenseQueryHookResult = ReturnType<typeof usePilotCollectMedicarePageSuspenseQuery>;
export type PilotCollectMedicarePageQueryResult = Apollo.QueryResult<PilotCollectMedicarePageQuery, PilotCollectMedicarePageQueryVariables>;
export const PilotAsyncEligibleMedicarePageDocument = gql`
    query PilotAsyncEligibleMedicarePage($consultationId: String!, $problemType: ProblemType!) {
  consultation(id: $consultationId) {
    id
    customer {
      id
      ... on User {
        condition(problemType: $problemType) {
          id
          asyncEligible
        }
      }
    }
  }
}
    `;

/**
 * __usePilotAsyncEligibleMedicarePageQuery__
 *
 * To run a query within a React component, call `usePilotAsyncEligibleMedicarePageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePilotAsyncEligibleMedicarePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePilotAsyncEligibleMedicarePageQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *      problemType: // value for 'problemType'
 *   },
 * });
 */
export function usePilotAsyncEligibleMedicarePageQuery(baseOptions: Apollo.QueryHookOptions<PilotAsyncEligibleMedicarePageQuery, PilotAsyncEligibleMedicarePageQueryVariables> & ({ variables: PilotAsyncEligibleMedicarePageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PilotAsyncEligibleMedicarePageQuery, PilotAsyncEligibleMedicarePageQueryVariables>(PilotAsyncEligibleMedicarePageDocument, options);
      }
export function usePilotAsyncEligibleMedicarePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PilotAsyncEligibleMedicarePageQuery, PilotAsyncEligibleMedicarePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PilotAsyncEligibleMedicarePageQuery, PilotAsyncEligibleMedicarePageQueryVariables>(PilotAsyncEligibleMedicarePageDocument, options);
        }
export function usePilotAsyncEligibleMedicarePageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PilotAsyncEligibleMedicarePageQuery, PilotAsyncEligibleMedicarePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PilotAsyncEligibleMedicarePageQuery, PilotAsyncEligibleMedicarePageQueryVariables>(PilotAsyncEligibleMedicarePageDocument, options);
        }
export type PilotAsyncEligibleMedicarePageQueryHookResult = ReturnType<typeof usePilotAsyncEligibleMedicarePageQuery>;
export type PilotAsyncEligibleMedicarePageLazyQueryHookResult = ReturnType<typeof usePilotAsyncEligibleMedicarePageLazyQuery>;
export type PilotAsyncEligibleMedicarePageSuspenseQueryHookResult = ReturnType<typeof usePilotAsyncEligibleMedicarePageSuspenseQuery>;
export type PilotAsyncEligibleMedicarePageQueryResult = Apollo.QueryResult<PilotAsyncEligibleMedicarePageQuery, PilotAsyncEligibleMedicarePageQueryVariables>;
export const PilotConfirmationPageDocument = gql`
    query PilotConfirmationPage($consultationId: String!) {
  consultation(id: $consultationId) {
    id
    type
    screeningQuizApplication {
      id
    }
    customer {
      id
      email
    }
  }
}
    `;

/**
 * __usePilotConfirmationPageQuery__
 *
 * To run a query within a React component, call `usePilotConfirmationPageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePilotConfirmationPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePilotConfirmationPageQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function usePilotConfirmationPageQuery(baseOptions: Apollo.QueryHookOptions<PilotConfirmationPageQuery, PilotConfirmationPageQueryVariables> & ({ variables: PilotConfirmationPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PilotConfirmationPageQuery, PilotConfirmationPageQueryVariables>(PilotConfirmationPageDocument, options);
      }
export function usePilotConfirmationPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PilotConfirmationPageQuery, PilotConfirmationPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PilotConfirmationPageQuery, PilotConfirmationPageQueryVariables>(PilotConfirmationPageDocument, options);
        }
export function usePilotConfirmationPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PilotConfirmationPageQuery, PilotConfirmationPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PilotConfirmationPageQuery, PilotConfirmationPageQueryVariables>(PilotConfirmationPageDocument, options);
        }
export type PilotConfirmationPageQueryHookResult = ReturnType<typeof usePilotConfirmationPageQuery>;
export type PilotConfirmationPageLazyQueryHookResult = ReturnType<typeof usePilotConfirmationPageLazyQuery>;
export type PilotConfirmationPageSuspenseQueryHookResult = ReturnType<typeof usePilotConfirmationPageSuspenseQuery>;
export type PilotConfirmationPageQueryResult = Apollo.QueryResult<PilotConfirmationPageQuery, PilotConfirmationPageQueryVariables>;
export const PilotPayConsultationDocument = gql`
    query PilotPayConsultation($id: String!) {
  consultation(id: $id) {
    id
    type
    isUpfrontPayment
  }
}
    `;

/**
 * __usePilotPayConsultationQuery__
 *
 * To run a query within a React component, call `usePilotPayConsultationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePilotPayConsultationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePilotPayConsultationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePilotPayConsultationQuery(baseOptions: Apollo.QueryHookOptions<PilotPayConsultationQuery, PilotPayConsultationQueryVariables> & ({ variables: PilotPayConsultationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PilotPayConsultationQuery, PilotPayConsultationQueryVariables>(PilotPayConsultationDocument, options);
      }
export function usePilotPayConsultationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PilotPayConsultationQuery, PilotPayConsultationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PilotPayConsultationQuery, PilotPayConsultationQueryVariables>(PilotPayConsultationDocument, options);
        }
export function usePilotPayConsultationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PilotPayConsultationQuery, PilotPayConsultationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PilotPayConsultationQuery, PilotPayConsultationQueryVariables>(PilotPayConsultationDocument, options);
        }
export type PilotPayConsultationQueryHookResult = ReturnType<typeof usePilotPayConsultationQuery>;
export type PilotPayConsultationLazyQueryHookResult = ReturnType<typeof usePilotPayConsultationLazyQuery>;
export type PilotPayConsultationSuspenseQueryHookResult = ReturnType<typeof usePilotPayConsultationSuspenseQuery>;
export type PilotPayConsultationQueryResult = Apollo.QueryResult<PilotPayConsultationQuery, PilotPayConsultationQueryVariables>;
export const PilotConsultationPaidPageDocument = gql`
    query PilotConsultationPaidPage($consultationId: String!) {
  consultation(id: $consultationId) {
    id
    type
    status
    isUpfrontPayment
    requiresPrescriberCall
    quizApplication {
      id
      submittedAt
    }
    medicationPreferenceProduct {
      id
      preferredProduct {
        id
        photo {
          id
          url
        }
        plan {
          id
          interval
          intervalCount
          amount
        }
      }
      defaultProduct {
        id
        photo {
          id
          url
        }
        plan {
          id
          interval
          intervalCount
          amount
        }
      }
    }
  }
}
    `;

/**
 * __usePilotConsultationPaidPageQuery__
 *
 * To run a query within a React component, call `usePilotConsultationPaidPageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePilotConsultationPaidPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePilotConsultationPaidPageQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function usePilotConsultationPaidPageQuery(baseOptions: Apollo.QueryHookOptions<PilotConsultationPaidPageQuery, PilotConsultationPaidPageQueryVariables> & ({ variables: PilotConsultationPaidPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PilotConsultationPaidPageQuery, PilotConsultationPaidPageQueryVariables>(PilotConsultationPaidPageDocument, options);
      }
export function usePilotConsultationPaidPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PilotConsultationPaidPageQuery, PilotConsultationPaidPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PilotConsultationPaidPageQuery, PilotConsultationPaidPageQueryVariables>(PilotConsultationPaidPageDocument, options);
        }
export function usePilotConsultationPaidPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PilotConsultationPaidPageQuery, PilotConsultationPaidPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PilotConsultationPaidPageQuery, PilotConsultationPaidPageQueryVariables>(PilotConsultationPaidPageDocument, options);
        }
export type PilotConsultationPaidPageQueryHookResult = ReturnType<typeof usePilotConsultationPaidPageQuery>;
export type PilotConsultationPaidPageLazyQueryHookResult = ReturnType<typeof usePilotConsultationPaidPageLazyQuery>;
export type PilotConsultationPaidPageSuspenseQueryHookResult = ReturnType<typeof usePilotConsultationPaidPageSuspenseQuery>;
export type PilotConsultationPaidPageQueryResult = Apollo.QueryResult<PilotConsultationPaidPageQuery, PilotConsultationPaidPageQueryVariables>;
export const ProblemTypeFromConsultationDocument = gql`
    query ProblemTypeFromConsultation($consultationId: String!, $bnplEnabled: Boolean!) {
  consultation(id: $consultationId) {
    id
    type
    isUpfrontPayment
    purchasePrompt @include(if: $bnplEnabled) {
      id
    }
  }
}
    `;

/**
 * __useProblemTypeFromConsultationQuery__
 *
 * To run a query within a React component, call `useProblemTypeFromConsultationQuery` and pass it any options that fit your needs.
 * When your component renders, `useProblemTypeFromConsultationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProblemTypeFromConsultationQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *      bnplEnabled: // value for 'bnplEnabled'
 *   },
 * });
 */
export function useProblemTypeFromConsultationQuery(baseOptions: Apollo.QueryHookOptions<ProblemTypeFromConsultationQuery, ProblemTypeFromConsultationQueryVariables> & ({ variables: ProblemTypeFromConsultationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProblemTypeFromConsultationQuery, ProblemTypeFromConsultationQueryVariables>(ProblemTypeFromConsultationDocument, options);
      }
export function useProblemTypeFromConsultationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProblemTypeFromConsultationQuery, ProblemTypeFromConsultationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProblemTypeFromConsultationQuery, ProblemTypeFromConsultationQueryVariables>(ProblemTypeFromConsultationDocument, options);
        }
export function useProblemTypeFromConsultationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProblemTypeFromConsultationQuery, ProblemTypeFromConsultationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProblemTypeFromConsultationQuery, ProblemTypeFromConsultationQueryVariables>(ProblemTypeFromConsultationDocument, options);
        }
export type ProblemTypeFromConsultationQueryHookResult = ReturnType<typeof useProblemTypeFromConsultationQuery>;
export type ProblemTypeFromConsultationLazyQueryHookResult = ReturnType<typeof useProblemTypeFromConsultationLazyQuery>;
export type ProblemTypeFromConsultationSuspenseQueryHookResult = ReturnType<typeof useProblemTypeFromConsultationSuspenseQuery>;
export type ProblemTypeFromConsultationQueryResult = Apollo.QueryResult<ProblemTypeFromConsultationQuery, ProblemTypeFromConsultationQueryVariables>;
export const PilotDoctorsNoteDocument = gql`
    query PilotDoctorsNote($consultationId: String!) {
  consultation(id: $consultationId) {
    id
    treatment {
      id
      product {
        id
        variants {
          id
          inventory {
            id
            sku
          }
        }
      }
    }
  }
}
    `;

/**
 * __usePilotDoctorsNoteQuery__
 *
 * To run a query within a React component, call `usePilotDoctorsNoteQuery` and pass it any options that fit your needs.
 * When your component renders, `usePilotDoctorsNoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePilotDoctorsNoteQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function usePilotDoctorsNoteQuery(baseOptions: Apollo.QueryHookOptions<PilotDoctorsNoteQuery, PilotDoctorsNoteQueryVariables> & ({ variables: PilotDoctorsNoteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PilotDoctorsNoteQuery, PilotDoctorsNoteQueryVariables>(PilotDoctorsNoteDocument, options);
      }
export function usePilotDoctorsNoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PilotDoctorsNoteQuery, PilotDoctorsNoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PilotDoctorsNoteQuery, PilotDoctorsNoteQueryVariables>(PilotDoctorsNoteDocument, options);
        }
export function usePilotDoctorsNoteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PilotDoctorsNoteQuery, PilotDoctorsNoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PilotDoctorsNoteQuery, PilotDoctorsNoteQueryVariables>(PilotDoctorsNoteDocument, options);
        }
export type PilotDoctorsNoteQueryHookResult = ReturnType<typeof usePilotDoctorsNoteQuery>;
export type PilotDoctorsNoteLazyQueryHookResult = ReturnType<typeof usePilotDoctorsNoteLazyQuery>;
export type PilotDoctorsNoteSuspenseQueryHookResult = ReturnType<typeof usePilotDoctorsNoteSuspenseQuery>;
export type PilotDoctorsNoteQueryResult = Apollo.QueryResult<PilotDoctorsNoteQuery, PilotDoctorsNoteQueryVariables>;
export const PilotOrderConfirmedPageDocument = gql`
    query PilotOrderConfirmedPage($consultationId: String!) {
  consultation(id: $consultationId) {
    id
    type
    patientNotes
    isUpfrontPayment
    customer {
      id
      firstName
    }
    doctor {
      id
      shortClinicianName
      fullClinicianName
      fullName
    }
    treatment {
      id
      experimentPaymentPlan {
        id
        paymentPlan
        discountPercentage
      }
      experimentAvailablePaymentPlans {
        paymentPlan
        discountPercentage
        months
      }
      otcSchedules {
        id
        cadence
        quantity
        product {
          id
        }
        isActive
      }
    }
    order {
      id
      lineItems {
        id
        quantity
        variant {
          id
          price
          product {
            id
            name
            productType
            photo {
              id
              url
            }
            shortDescription
          }
        }
      }
    }
  }
}
    `;

/**
 * __usePilotOrderConfirmedPageQuery__
 *
 * To run a query within a React component, call `usePilotOrderConfirmedPageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePilotOrderConfirmedPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePilotOrderConfirmedPageQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function usePilotOrderConfirmedPageQuery(baseOptions: Apollo.QueryHookOptions<PilotOrderConfirmedPageQuery, PilotOrderConfirmedPageQueryVariables> & ({ variables: PilotOrderConfirmedPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PilotOrderConfirmedPageQuery, PilotOrderConfirmedPageQueryVariables>(PilotOrderConfirmedPageDocument, options);
      }
export function usePilotOrderConfirmedPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PilotOrderConfirmedPageQuery, PilotOrderConfirmedPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PilotOrderConfirmedPageQuery, PilotOrderConfirmedPageQueryVariables>(PilotOrderConfirmedPageDocument, options);
        }
export function usePilotOrderConfirmedPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PilotOrderConfirmedPageQuery, PilotOrderConfirmedPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PilotOrderConfirmedPageQuery, PilotOrderConfirmedPageQueryVariables>(PilotOrderConfirmedPageDocument, options);
        }
export type PilotOrderConfirmedPageQueryHookResult = ReturnType<typeof usePilotOrderConfirmedPageQuery>;
export type PilotOrderConfirmedPageLazyQueryHookResult = ReturnType<typeof usePilotOrderConfirmedPageLazyQuery>;
export type PilotOrderConfirmedPageSuspenseQueryHookResult = ReturnType<typeof usePilotOrderConfirmedPageSuspenseQuery>;
export type PilotOrderConfirmedPageQueryResult = Apollo.QueryResult<PilotOrderConfirmedPageQuery, PilotOrderConfirmedPageQueryVariables>;
export const PilotConsultationPayConfirmPageDocument = gql`
    query PilotConsultationPayConfirmPage($consultationId: String!) {
  consultation(id: $consultationId) {
    id
    stage
    isUpfrontPayment
    type
  }
  profile {
    id
    email
    shortAddressableName
    phone
  }
}
    `;

/**
 * __usePilotConsultationPayConfirmPageQuery__
 *
 * To run a query within a React component, call `usePilotConsultationPayConfirmPageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePilotConsultationPayConfirmPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePilotConsultationPayConfirmPageQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function usePilotConsultationPayConfirmPageQuery(baseOptions: Apollo.QueryHookOptions<PilotConsultationPayConfirmPageQuery, PilotConsultationPayConfirmPageQueryVariables> & ({ variables: PilotConsultationPayConfirmPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PilotConsultationPayConfirmPageQuery, PilotConsultationPayConfirmPageQueryVariables>(PilotConsultationPayConfirmPageDocument, options);
      }
export function usePilotConsultationPayConfirmPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PilotConsultationPayConfirmPageQuery, PilotConsultationPayConfirmPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PilotConsultationPayConfirmPageQuery, PilotConsultationPayConfirmPageQueryVariables>(PilotConsultationPayConfirmPageDocument, options);
        }
export function usePilotConsultationPayConfirmPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PilotConsultationPayConfirmPageQuery, PilotConsultationPayConfirmPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PilotConsultationPayConfirmPageQuery, PilotConsultationPayConfirmPageQueryVariables>(PilotConsultationPayConfirmPageDocument, options);
        }
export type PilotConsultationPayConfirmPageQueryHookResult = ReturnType<typeof usePilotConsultationPayConfirmPageQuery>;
export type PilotConsultationPayConfirmPageLazyQueryHookResult = ReturnType<typeof usePilotConsultationPayConfirmPageLazyQuery>;
export type PilotConsultationPayConfirmPageSuspenseQueryHookResult = ReturnType<typeof usePilotConsultationPayConfirmPageSuspenseQuery>;
export type PilotConsultationPayConfirmPageQueryResult = Apollo.QueryResult<PilotConsultationPayConfirmPageQuery, PilotConsultationPayConfirmPageQueryVariables>;
export const PilotConsultationPlanDocument = gql`
    query PilotConsultationPlan($consultationId: String!) {
  consultation(id: $consultationId) {
    id
    treatment {
      id
      product {
        id
        variants {
          id
          inventory {
            id
            sku
          }
        }
      }
    }
  }
}
    `;

/**
 * __usePilotConsultationPlanQuery__
 *
 * To run a query within a React component, call `usePilotConsultationPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `usePilotConsultationPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePilotConsultationPlanQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function usePilotConsultationPlanQuery(baseOptions: Apollo.QueryHookOptions<PilotConsultationPlanQuery, PilotConsultationPlanQueryVariables> & ({ variables: PilotConsultationPlanQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PilotConsultationPlanQuery, PilotConsultationPlanQueryVariables>(PilotConsultationPlanDocument, options);
      }
export function usePilotConsultationPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PilotConsultationPlanQuery, PilotConsultationPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PilotConsultationPlanQuery, PilotConsultationPlanQueryVariables>(PilotConsultationPlanDocument, options);
        }
export function usePilotConsultationPlanSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PilotConsultationPlanQuery, PilotConsultationPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PilotConsultationPlanQuery, PilotConsultationPlanQueryVariables>(PilotConsultationPlanDocument, options);
        }
export type PilotConsultationPlanQueryHookResult = ReturnType<typeof usePilotConsultationPlanQuery>;
export type PilotConsultationPlanLazyQueryHookResult = ReturnType<typeof usePilotConsultationPlanLazyQuery>;
export type PilotConsultationPlanSuspenseQueryHookResult = ReturnType<typeof usePilotConsultationPlanSuspenseQuery>;
export type PilotConsultationPlanQueryResult = Apollo.QueryResult<PilotConsultationPlanQuery, PilotConsultationPlanQueryVariables>;
export const PilotPracBookingConfirmationPageDocument = gql`
    query PilotPracBookingConfirmationPage($pracBookingId: ID!) {
  practitionerBooking(id: $pracBookingId) {
    id
    consultation {
      id
      type
    }
    patient {
      id
      email
      phone
    }
    windowStartAt
    windowEndAt
  }
  validPhoneRegions {
    id
    countryCode
  }
}
    `;

/**
 * __usePilotPracBookingConfirmationPageQuery__
 *
 * To run a query within a React component, call `usePilotPracBookingConfirmationPageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePilotPracBookingConfirmationPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePilotPracBookingConfirmationPageQuery({
 *   variables: {
 *      pracBookingId: // value for 'pracBookingId'
 *   },
 * });
 */
export function usePilotPracBookingConfirmationPageQuery(baseOptions: Apollo.QueryHookOptions<PilotPracBookingConfirmationPageQuery, PilotPracBookingConfirmationPageQueryVariables> & ({ variables: PilotPracBookingConfirmationPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PilotPracBookingConfirmationPageQuery, PilotPracBookingConfirmationPageQueryVariables>(PilotPracBookingConfirmationPageDocument, options);
      }
export function usePilotPracBookingConfirmationPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PilotPracBookingConfirmationPageQuery, PilotPracBookingConfirmationPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PilotPracBookingConfirmationPageQuery, PilotPracBookingConfirmationPageQueryVariables>(PilotPracBookingConfirmationPageDocument, options);
        }
export function usePilotPracBookingConfirmationPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PilotPracBookingConfirmationPageQuery, PilotPracBookingConfirmationPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PilotPracBookingConfirmationPageQuery, PilotPracBookingConfirmationPageQueryVariables>(PilotPracBookingConfirmationPageDocument, options);
        }
export type PilotPracBookingConfirmationPageQueryHookResult = ReturnType<typeof usePilotPracBookingConfirmationPageQuery>;
export type PilotPracBookingConfirmationPageLazyQueryHookResult = ReturnType<typeof usePilotPracBookingConfirmationPageLazyQuery>;
export type PilotPracBookingConfirmationPageSuspenseQueryHookResult = ReturnType<typeof usePilotPracBookingConfirmationPageSuspenseQuery>;
export type PilotPracBookingConfirmationPageQueryResult = Apollo.QueryResult<PilotPracBookingConfirmationPageQuery, PilotPracBookingConfirmationPageQueryVariables>;
export const PilotPractitionerPhoneCallPageDocument = gql`
    query PilotPractitionerPhoneCallPage($consultationId: String!) {
  consultation(id: $consultationId) {
    id
    latestPractitionerBooking {
      id
    }
  }
}
    `;

/**
 * __usePilotPractitionerPhoneCallPageQuery__
 *
 * To run a query within a React component, call `usePilotPractitionerPhoneCallPageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePilotPractitionerPhoneCallPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePilotPractitionerPhoneCallPageQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function usePilotPractitionerPhoneCallPageQuery(baseOptions: Apollo.QueryHookOptions<PilotPractitionerPhoneCallPageQuery, PilotPractitionerPhoneCallPageQueryVariables> & ({ variables: PilotPractitionerPhoneCallPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PilotPractitionerPhoneCallPageQuery, PilotPractitionerPhoneCallPageQueryVariables>(PilotPractitionerPhoneCallPageDocument, options);
      }
export function usePilotPractitionerPhoneCallPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PilotPractitionerPhoneCallPageQuery, PilotPractitionerPhoneCallPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PilotPractitionerPhoneCallPageQuery, PilotPractitionerPhoneCallPageQueryVariables>(PilotPractitionerPhoneCallPageDocument, options);
        }
export function usePilotPractitionerPhoneCallPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PilotPractitionerPhoneCallPageQuery, PilotPractitionerPhoneCallPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PilotPractitionerPhoneCallPageQuery, PilotPractitionerPhoneCallPageQueryVariables>(PilotPractitionerPhoneCallPageDocument, options);
        }
export type PilotPractitionerPhoneCallPageQueryHookResult = ReturnType<typeof usePilotPractitionerPhoneCallPageQuery>;
export type PilotPractitionerPhoneCallPageLazyQueryHookResult = ReturnType<typeof usePilotPractitionerPhoneCallPageLazyQuery>;
export type PilotPractitionerPhoneCallPageSuspenseQueryHookResult = ReturnType<typeof usePilotPractitionerPhoneCallPageSuspenseQuery>;
export type PilotPractitionerPhoneCallPageQueryResult = Apollo.QueryResult<PilotPractitionerPhoneCallPageQuery, PilotPractitionerPhoneCallPageQueryVariables>;
export const PilotRedirectPageDocument = gql`
    query PilotRedirectPage($id: String!) {
  consultation(id: $id) {
    id
    isApproved
    isUpfrontPayment
    requiresPrescriberCall
    allowPatientToSendMessageToDoctor
    latestPractitionerBooking {
      id
    }
    screeningQuizApplication {
      id
      submittedAt
    }
    quizApplication {
      id
    }
    stage
    status
    type
  }
}
    `;

/**
 * __usePilotRedirectPageQuery__
 *
 * To run a query within a React component, call `usePilotRedirectPageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePilotRedirectPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePilotRedirectPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePilotRedirectPageQuery(baseOptions: Apollo.QueryHookOptions<PilotRedirectPageQuery, PilotRedirectPageQueryVariables> & ({ variables: PilotRedirectPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PilotRedirectPageQuery, PilotRedirectPageQueryVariables>(PilotRedirectPageDocument, options);
      }
export function usePilotRedirectPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PilotRedirectPageQuery, PilotRedirectPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PilotRedirectPageQuery, PilotRedirectPageQueryVariables>(PilotRedirectPageDocument, options);
        }
export function usePilotRedirectPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PilotRedirectPageQuery, PilotRedirectPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PilotRedirectPageQuery, PilotRedirectPageQueryVariables>(PilotRedirectPageDocument, options);
        }
export type PilotRedirectPageQueryHookResult = ReturnType<typeof usePilotRedirectPageQuery>;
export type PilotRedirectPageLazyQueryHookResult = ReturnType<typeof usePilotRedirectPageLazyQuery>;
export type PilotRedirectPageSuspenseQueryHookResult = ReturnType<typeof usePilotRedirectPageSuspenseQuery>;
export type PilotRedirectPageQueryResult = Apollo.QueryResult<PilotRedirectPageQuery, PilotRedirectPageQueryVariables>;
export const PilotSchedulePhoneCallPageDocument = gql`
    query PilotSchedulePhoneCallPage($consultationId: String!) {
  consultation(id: $consultationId) {
    id
    latestPractitionerBooking {
      id
    }
  }
}
    `;

/**
 * __usePilotSchedulePhoneCallPageQuery__
 *
 * To run a query within a React component, call `usePilotSchedulePhoneCallPageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePilotSchedulePhoneCallPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePilotSchedulePhoneCallPageQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function usePilotSchedulePhoneCallPageQuery(baseOptions: Apollo.QueryHookOptions<PilotSchedulePhoneCallPageQuery, PilotSchedulePhoneCallPageQueryVariables> & ({ variables: PilotSchedulePhoneCallPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PilotSchedulePhoneCallPageQuery, PilotSchedulePhoneCallPageQueryVariables>(PilotSchedulePhoneCallPageDocument, options);
      }
export function usePilotSchedulePhoneCallPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PilotSchedulePhoneCallPageQuery, PilotSchedulePhoneCallPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PilotSchedulePhoneCallPageQuery, PilotSchedulePhoneCallPageQueryVariables>(PilotSchedulePhoneCallPageDocument, options);
        }
export function usePilotSchedulePhoneCallPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PilotSchedulePhoneCallPageQuery, PilotSchedulePhoneCallPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PilotSchedulePhoneCallPageQuery, PilotSchedulePhoneCallPageQueryVariables>(PilotSchedulePhoneCallPageDocument, options);
        }
export type PilotSchedulePhoneCallPageQueryHookResult = ReturnType<typeof usePilotSchedulePhoneCallPageQuery>;
export type PilotSchedulePhoneCallPageLazyQueryHookResult = ReturnType<typeof usePilotSchedulePhoneCallPageLazyQuery>;
export type PilotSchedulePhoneCallPageSuspenseQueryHookResult = ReturnType<typeof usePilotSchedulePhoneCallPageSuspenseQuery>;
export type PilotSchedulePhoneCallPageQueryResult = Apollo.QueryResult<PilotSchedulePhoneCallPageQuery, PilotSchedulePhoneCallPageQueryVariables>;
export const TestResultsDocument = gql`
    query TestResults($consultationId: String!) {
  consultation(id: $consultationId) {
    id
    patientNotes
    pathologyRequests {
      id
      createdAt
      customerStatedCollectedAt
      result {
        id
        lab
        releasedAt
        file {
          id
          url
        }
      }
      referral {
        id
        url
      }
      panels {
        id
        tests {
          id
          name
          result {
            id
            note
            result {
              type
              value
            }
          }
        }
      }
    }
    doctor {
      id
      fullClinicianName
      avatar {
        id
        url
      }
      provider {
        id
        clinicianTitle
        qualifications
      }
    }
  }
}
    `;

/**
 * __useTestResultsQuery__
 *
 * To run a query within a React component, call `useTestResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestResultsQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function useTestResultsQuery(baseOptions: Apollo.QueryHookOptions<TestResultsQuery, TestResultsQueryVariables> & ({ variables: TestResultsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TestResultsQuery, TestResultsQueryVariables>(TestResultsDocument, options);
      }
export function useTestResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TestResultsQuery, TestResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TestResultsQuery, TestResultsQueryVariables>(TestResultsDocument, options);
        }
export function useTestResultsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TestResultsQuery, TestResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TestResultsQuery, TestResultsQueryVariables>(TestResultsDocument, options);
        }
export type TestResultsQueryHookResult = ReturnType<typeof useTestResultsQuery>;
export type TestResultsLazyQueryHookResult = ReturnType<typeof useTestResultsLazyQuery>;
export type TestResultsSuspenseQueryHookResult = ReturnType<typeof useTestResultsSuspenseQuery>;
export type TestResultsQueryResult = Apollo.QueryResult<TestResultsQuery, TestResultsQueryVariables>;
export const PilotProfilePageDocument = gql`
    query PilotProfilePage {
  profile {
    id
    needsSubscriptionMigration
    isBeingTreatedForWeight: isBeingTreated(problemType: WEIGHT_LOSS)
    initialQuizApplications: quizApplications(purpose: INITIAL) {
      id
      createdAt
      updatedAt
      submittedAt
      purpose
      ...UseProfileCardsQuizApplication
      ...PilotTreatmentStatusCardsQuizApplication
    }
    archivedQuizApplications(purpose: INITIAL, problemType: WEIGHT_LOSS) {
      id
      createdAt
      updatedAt
      submittedAt
      purpose
      ...UseProfileCardsQuizApplication
      ...PilotTreatmentStatusCardsQuizApplication
    }
    consultations {
      id
      createdAt
      ...UseProfileCardsConsultation
      ...PilotTreatmentStatusCardsConsultation
    }
    firstName
    hasPaidMasterclass
    subscriptions {
      ...SubscriptionCardList
    }
    purchases {
      id
      ...UseProfileCardsPurchase
      ...PilotTreatmentStatusCardsPurchase
    }
    ...PilotAccountSettings
  }
  treatments {
    id
    ...PilotTreatmentStatusCardsTreatment
  }
  subscriptionPlans {
    ...PilotSubscriptions
  }
}
    ${UseProfileCardsQuizApplicationFragmentDoc}
${PilotTreatmentStatusCardsQuizApplicationFragmentDoc}
${UseProfileCardsConsultationFragmentDoc}
${PilotTreatmentStatusCardsConsultationFragmentDoc}
${SubscriptionCardListFragmentDoc}
${UseProfileCardsPurchaseFragmentDoc}
${PilotTreatmentStatusCardsPurchaseFragmentDoc}
${PilotAccountSettingsFragmentDoc}
${PilotTreatmentStatusCardsTreatmentFragmentDoc}
${PilotSubscriptionsFragmentDoc}`;

/**
 * __usePilotProfilePageQuery__
 *
 * To run a query within a React component, call `usePilotProfilePageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePilotProfilePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePilotProfilePageQuery({
 *   variables: {
 *   },
 * });
 */
export function usePilotProfilePageQuery(baseOptions?: Apollo.QueryHookOptions<PilotProfilePageQuery, PilotProfilePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PilotProfilePageQuery, PilotProfilePageQueryVariables>(PilotProfilePageDocument, options);
      }
export function usePilotProfilePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PilotProfilePageQuery, PilotProfilePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PilotProfilePageQuery, PilotProfilePageQueryVariables>(PilotProfilePageDocument, options);
        }
export function usePilotProfilePageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PilotProfilePageQuery, PilotProfilePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PilotProfilePageQuery, PilotProfilePageQueryVariables>(PilotProfilePageDocument, options);
        }
export type PilotProfilePageQueryHookResult = ReturnType<typeof usePilotProfilePageQuery>;
export type PilotProfilePageLazyQueryHookResult = ReturnType<typeof usePilotProfilePageLazyQuery>;
export type PilotProfilePageSuspenseQueryHookResult = ReturnType<typeof usePilotProfilePageSuspenseQuery>;
export type PilotProfilePageQueryResult = Apollo.QueryResult<PilotProfilePageQuery, PilotProfilePageQueryVariables>;
export const PilotQuizCompletePageDocument = gql`
    query PilotQuizCompletePage($id: String!) {
  getQuizApplication(id: $id) {
    id
    purpose
    problemType
    quiz {
      id
      default
      quizCode
    }
    consultation {
      id
      status
      stage
      type
      isUpfrontPayment
      canSchedulePractitionerBooking
    }
    outcomes {
      ... on QuizOutcomeV2 {
        id
      }
    }
  }
  profile {
    id
    phone
    isPasswordSet
  }
}
    `;

/**
 * __usePilotQuizCompletePageQuery__
 *
 * To run a query within a React component, call `usePilotQuizCompletePageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePilotQuizCompletePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePilotQuizCompletePageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePilotQuizCompletePageQuery(baseOptions: Apollo.QueryHookOptions<PilotQuizCompletePageQuery, PilotQuizCompletePageQueryVariables> & ({ variables: PilotQuizCompletePageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PilotQuizCompletePageQuery, PilotQuizCompletePageQueryVariables>(PilotQuizCompletePageDocument, options);
      }
export function usePilotQuizCompletePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PilotQuizCompletePageQuery, PilotQuizCompletePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PilotQuizCompletePageQuery, PilotQuizCompletePageQueryVariables>(PilotQuizCompletePageDocument, options);
        }
export function usePilotQuizCompletePageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PilotQuizCompletePageQuery, PilotQuizCompletePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PilotQuizCompletePageQuery, PilotQuizCompletePageQueryVariables>(PilotQuizCompletePageDocument, options);
        }
export type PilotQuizCompletePageQueryHookResult = ReturnType<typeof usePilotQuizCompletePageQuery>;
export type PilotQuizCompletePageLazyQueryHookResult = ReturnType<typeof usePilotQuizCompletePageLazyQuery>;
export type PilotQuizCompletePageSuspenseQueryHookResult = ReturnType<typeof usePilotQuizCompletePageSuspenseQuery>;
export type PilotQuizCompletePageQueryResult = Apollo.QueryResult<PilotQuizCompletePageQuery, PilotQuizCompletePageQueryVariables>;
export const PilotAsyncEligibleQuizCompletePageDocument = gql`
    query PilotAsyncEligibleQuizCompletePage($consultationId: String!, $problemType: ProblemType!) {
  consultation(id: $consultationId) {
    id
    customer {
      id
      ... on User {
        condition(problemType: $problemType) {
          id
          asyncEligible
        }
      }
    }
  }
}
    `;

/**
 * __usePilotAsyncEligibleQuizCompletePageQuery__
 *
 * To run a query within a React component, call `usePilotAsyncEligibleQuizCompletePageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePilotAsyncEligibleQuizCompletePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePilotAsyncEligibleQuizCompletePageQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *      problemType: // value for 'problemType'
 *   },
 * });
 */
export function usePilotAsyncEligibleQuizCompletePageQuery(baseOptions: Apollo.QueryHookOptions<PilotAsyncEligibleQuizCompletePageQuery, PilotAsyncEligibleQuizCompletePageQueryVariables> & ({ variables: PilotAsyncEligibleQuizCompletePageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PilotAsyncEligibleQuizCompletePageQuery, PilotAsyncEligibleQuizCompletePageQueryVariables>(PilotAsyncEligibleQuizCompletePageDocument, options);
      }
export function usePilotAsyncEligibleQuizCompletePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PilotAsyncEligibleQuizCompletePageQuery, PilotAsyncEligibleQuizCompletePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PilotAsyncEligibleQuizCompletePageQuery, PilotAsyncEligibleQuizCompletePageQueryVariables>(PilotAsyncEligibleQuizCompletePageDocument, options);
        }
export function usePilotAsyncEligibleQuizCompletePageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PilotAsyncEligibleQuizCompletePageQuery, PilotAsyncEligibleQuizCompletePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PilotAsyncEligibleQuizCompletePageQuery, PilotAsyncEligibleQuizCompletePageQueryVariables>(PilotAsyncEligibleQuizCompletePageDocument, options);
        }
export type PilotAsyncEligibleQuizCompletePageQueryHookResult = ReturnType<typeof usePilotAsyncEligibleQuizCompletePageQuery>;
export type PilotAsyncEligibleQuizCompletePageLazyQueryHookResult = ReturnType<typeof usePilotAsyncEligibleQuizCompletePageLazyQuery>;
export type PilotAsyncEligibleQuizCompletePageSuspenseQueryHookResult = ReturnType<typeof usePilotAsyncEligibleQuizCompletePageSuspenseQuery>;
export type PilotAsyncEligibleQuizCompletePageQueryResult = Apollo.QueryResult<PilotAsyncEligibleQuizCompletePageQuery, PilotAsyncEligibleQuizCompletePageQueryVariables>;
export const PilotProfileTreatmentHelpPageDocument = gql`
    query PilotProfileTreatmentHelpPage($id: String!) {
  treatment(id: $id) {
    id
    status
    experimentPaymentPlan {
      id
    }
    weightTreatmentCategory
    type
    nextPayment
    canPause
    consultation {
      id
      status
    }
    product {
      id
      faqs {
        id
        title
        markdown
        videoEmbedUrl
      }
    }
    customer {
      id
      email
    }
  }
}
    `;

/**
 * __usePilotProfileTreatmentHelpPageQuery__
 *
 * To run a query within a React component, call `usePilotProfileTreatmentHelpPageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePilotProfileTreatmentHelpPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePilotProfileTreatmentHelpPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePilotProfileTreatmentHelpPageQuery(baseOptions: Apollo.QueryHookOptions<PilotProfileTreatmentHelpPageQuery, PilotProfileTreatmentHelpPageQueryVariables> & ({ variables: PilotProfileTreatmentHelpPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PilotProfileTreatmentHelpPageQuery, PilotProfileTreatmentHelpPageQueryVariables>(PilotProfileTreatmentHelpPageDocument, options);
      }
export function usePilotProfileTreatmentHelpPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PilotProfileTreatmentHelpPageQuery, PilotProfileTreatmentHelpPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PilotProfileTreatmentHelpPageQuery, PilotProfileTreatmentHelpPageQueryVariables>(PilotProfileTreatmentHelpPageDocument, options);
        }
export function usePilotProfileTreatmentHelpPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PilotProfileTreatmentHelpPageQuery, PilotProfileTreatmentHelpPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PilotProfileTreatmentHelpPageQuery, PilotProfileTreatmentHelpPageQueryVariables>(PilotProfileTreatmentHelpPageDocument, options);
        }
export type PilotProfileTreatmentHelpPageQueryHookResult = ReturnType<typeof usePilotProfileTreatmentHelpPageQuery>;
export type PilotProfileTreatmentHelpPageLazyQueryHookResult = ReturnType<typeof usePilotProfileTreatmentHelpPageLazyQuery>;
export type PilotProfileTreatmentHelpPageSuspenseQueryHookResult = ReturnType<typeof usePilotProfileTreatmentHelpPageSuspenseQuery>;
export type PilotProfileTreatmentHelpPageQueryResult = Apollo.QueryResult<PilotProfileTreatmentHelpPageQuery, PilotProfileTreatmentHelpPageQueryVariables>;
export const PilotTreatmentPlanPageDocument = gql`
    query PilotTreatmentPlanPage($id: String!) {
  profile {
    id
  }
  treatment(id: $id) {
    ...TreatmentInfo
    consultation {
      id
      isUpfrontPayment
      treatment {
        id
        experimentPaymentPlan {
          id
          paymentPlan
          discountPercentage
        }
        experimentAvailablePaymentPlans {
          paymentPlan
          discountPercentage
          months
        }
        otcSchedules {
          id
          cadence
          quantity
          product {
            id
          }
          isActive
        }
      }
      order {
        id
        lineItems {
          id
          quantity
          variant {
            id
            price
            product {
              id
              name
              productType
              shortDescription
              photo {
                id
                url
              }
            }
          }
        }
      }
    }
  }
}
    ${TreatmentInfoFragmentDoc}`;

/**
 * __usePilotTreatmentPlanPageQuery__
 *
 * To run a query within a React component, call `usePilotTreatmentPlanPageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePilotTreatmentPlanPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePilotTreatmentPlanPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePilotTreatmentPlanPageQuery(baseOptions: Apollo.QueryHookOptions<PilotTreatmentPlanPageQuery, PilotTreatmentPlanPageQueryVariables> & ({ variables: PilotTreatmentPlanPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PilotTreatmentPlanPageQuery, PilotTreatmentPlanPageQueryVariables>(PilotTreatmentPlanPageDocument, options);
      }
export function usePilotTreatmentPlanPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PilotTreatmentPlanPageQuery, PilotTreatmentPlanPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PilotTreatmentPlanPageQuery, PilotTreatmentPlanPageQueryVariables>(PilotTreatmentPlanPageDocument, options);
        }
export function usePilotTreatmentPlanPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PilotTreatmentPlanPageQuery, PilotTreatmentPlanPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PilotTreatmentPlanPageQuery, PilotTreatmentPlanPageQueryVariables>(PilotTreatmentPlanPageDocument, options);
        }
export type PilotTreatmentPlanPageQueryHookResult = ReturnType<typeof usePilotTreatmentPlanPageQuery>;
export type PilotTreatmentPlanPageLazyQueryHookResult = ReturnType<typeof usePilotTreatmentPlanPageLazyQuery>;
export type PilotTreatmentPlanPageSuspenseQueryHookResult = ReturnType<typeof usePilotTreatmentPlanPageSuspenseQuery>;
export type PilotTreatmentPlanPageQueryResult = Apollo.QueryResult<PilotTreatmentPlanPageQuery, PilotTreatmentPlanPageQueryVariables>;
export const ProgressEntriesDocument = gql`
    query ProgressEntries($type: ProgressEntryType!) {
  progressEntries(type: $type) {
    date
    userId
    type
    photos {
      id
      angle
      signedUrl
    }
    responses {
      id
      answer
      questionCode
    }
    id
  }
}
    `;

/**
 * __useProgressEntriesQuery__
 *
 * To run a query within a React component, call `useProgressEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgressEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgressEntriesQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useProgressEntriesQuery(baseOptions: Apollo.QueryHookOptions<ProgressEntriesQuery, ProgressEntriesQueryVariables> & ({ variables: ProgressEntriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgressEntriesQuery, ProgressEntriesQueryVariables>(ProgressEntriesDocument, options);
      }
export function useProgressEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgressEntriesQuery, ProgressEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgressEntriesQuery, ProgressEntriesQueryVariables>(ProgressEntriesDocument, options);
        }
export function useProgressEntriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProgressEntriesQuery, ProgressEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProgressEntriesQuery, ProgressEntriesQueryVariables>(ProgressEntriesDocument, options);
        }
export type ProgressEntriesQueryHookResult = ReturnType<typeof useProgressEntriesQuery>;
export type ProgressEntriesLazyQueryHookResult = ReturnType<typeof useProgressEntriesLazyQuery>;
export type ProgressEntriesSuspenseQueryHookResult = ReturnType<typeof useProgressEntriesSuspenseQuery>;
export type ProgressEntriesQueryResult = Apollo.QueryResult<ProgressEntriesQuery, ProgressEntriesQueryVariables>;
export const SoftwareAsyncConsultConfirmedPageDocument = gql`
    query SoftwareAsyncConsultConfirmedPage($consultationId: String!) {
  consultation(id: $consultationId) {
    id
    type
    requiresPrescriberCall
  }
}
    `;

/**
 * __useSoftwareAsyncConsultConfirmedPageQuery__
 *
 * To run a query within a React component, call `useSoftwareAsyncConsultConfirmedPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSoftwareAsyncConsultConfirmedPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSoftwareAsyncConsultConfirmedPageQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function useSoftwareAsyncConsultConfirmedPageQuery(baseOptions: Apollo.QueryHookOptions<SoftwareAsyncConsultConfirmedPageQuery, SoftwareAsyncConsultConfirmedPageQueryVariables> & ({ variables: SoftwareAsyncConsultConfirmedPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SoftwareAsyncConsultConfirmedPageQuery, SoftwareAsyncConsultConfirmedPageQueryVariables>(SoftwareAsyncConsultConfirmedPageDocument, options);
      }
export function useSoftwareAsyncConsultConfirmedPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SoftwareAsyncConsultConfirmedPageQuery, SoftwareAsyncConsultConfirmedPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SoftwareAsyncConsultConfirmedPageQuery, SoftwareAsyncConsultConfirmedPageQueryVariables>(SoftwareAsyncConsultConfirmedPageDocument, options);
        }
export function useSoftwareAsyncConsultConfirmedPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SoftwareAsyncConsultConfirmedPageQuery, SoftwareAsyncConsultConfirmedPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SoftwareAsyncConsultConfirmedPageQuery, SoftwareAsyncConsultConfirmedPageQueryVariables>(SoftwareAsyncConsultConfirmedPageDocument, options);
        }
export type SoftwareAsyncConsultConfirmedPageQueryHookResult = ReturnType<typeof useSoftwareAsyncConsultConfirmedPageQuery>;
export type SoftwareAsyncConsultConfirmedPageLazyQueryHookResult = ReturnType<typeof useSoftwareAsyncConsultConfirmedPageLazyQuery>;
export type SoftwareAsyncConsultConfirmedPageSuspenseQueryHookResult = ReturnType<typeof useSoftwareAsyncConsultConfirmedPageSuspenseQuery>;
export type SoftwareAsyncConsultConfirmedPageQueryResult = Apollo.QueryResult<SoftwareAsyncConsultConfirmedPageQuery, SoftwareAsyncConsultConfirmedPageQueryVariables>;
export const SoftwareAsyncEligibleMedicarePageDocument = gql`
    query SoftwareAsyncEligibleMedicarePage($consultationId: String!, $problemType: ProblemType!) {
  consultation(id: $consultationId) {
    id
    customer {
      id
      ... on User {
        condition(problemType: $problemType) {
          id
          asyncEligible
        }
      }
    }
  }
}
    `;

/**
 * __useSoftwareAsyncEligibleMedicarePageQuery__
 *
 * To run a query within a React component, call `useSoftwareAsyncEligibleMedicarePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSoftwareAsyncEligibleMedicarePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSoftwareAsyncEligibleMedicarePageQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *      problemType: // value for 'problemType'
 *   },
 * });
 */
export function useSoftwareAsyncEligibleMedicarePageQuery(baseOptions: Apollo.QueryHookOptions<SoftwareAsyncEligibleMedicarePageQuery, SoftwareAsyncEligibleMedicarePageQueryVariables> & ({ variables: SoftwareAsyncEligibleMedicarePageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SoftwareAsyncEligibleMedicarePageQuery, SoftwareAsyncEligibleMedicarePageQueryVariables>(SoftwareAsyncEligibleMedicarePageDocument, options);
      }
export function useSoftwareAsyncEligibleMedicarePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SoftwareAsyncEligibleMedicarePageQuery, SoftwareAsyncEligibleMedicarePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SoftwareAsyncEligibleMedicarePageQuery, SoftwareAsyncEligibleMedicarePageQueryVariables>(SoftwareAsyncEligibleMedicarePageDocument, options);
        }
export function useSoftwareAsyncEligibleMedicarePageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SoftwareAsyncEligibleMedicarePageQuery, SoftwareAsyncEligibleMedicarePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SoftwareAsyncEligibleMedicarePageQuery, SoftwareAsyncEligibleMedicarePageQueryVariables>(SoftwareAsyncEligibleMedicarePageDocument, options);
        }
export type SoftwareAsyncEligibleMedicarePageQueryHookResult = ReturnType<typeof useSoftwareAsyncEligibleMedicarePageQuery>;
export type SoftwareAsyncEligibleMedicarePageLazyQueryHookResult = ReturnType<typeof useSoftwareAsyncEligibleMedicarePageLazyQuery>;
export type SoftwareAsyncEligibleMedicarePageSuspenseQueryHookResult = ReturnType<typeof useSoftwareAsyncEligibleMedicarePageSuspenseQuery>;
export type SoftwareAsyncEligibleMedicarePageQueryResult = Apollo.QueryResult<SoftwareAsyncEligibleMedicarePageQuery, SoftwareAsyncEligibleMedicarePageQueryVariables>;
export const ConsultationConfirmationRootDocument = gql`
    query ConsultationConfirmationRoot($id: String!) {
  consultation(id: $id) {
    id
    type
    screeningQuizApplication {
      id
    }
  }
}
    `;

/**
 * __useConsultationConfirmationRootQuery__
 *
 * To run a query within a React component, call `useConsultationConfirmationRootQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultationConfirmationRootQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultationConfirmationRootQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConsultationConfirmationRootQuery(baseOptions: Apollo.QueryHookOptions<ConsultationConfirmationRootQuery, ConsultationConfirmationRootQueryVariables> & ({ variables: ConsultationConfirmationRootQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConsultationConfirmationRootQuery, ConsultationConfirmationRootQueryVariables>(ConsultationConfirmationRootDocument, options);
      }
export function useConsultationConfirmationRootLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConsultationConfirmationRootQuery, ConsultationConfirmationRootQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConsultationConfirmationRootQuery, ConsultationConfirmationRootQueryVariables>(ConsultationConfirmationRootDocument, options);
        }
export function useConsultationConfirmationRootSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ConsultationConfirmationRootQuery, ConsultationConfirmationRootQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConsultationConfirmationRootQuery, ConsultationConfirmationRootQueryVariables>(ConsultationConfirmationRootDocument, options);
        }
export type ConsultationConfirmationRootQueryHookResult = ReturnType<typeof useConsultationConfirmationRootQuery>;
export type ConsultationConfirmationRootLazyQueryHookResult = ReturnType<typeof useConsultationConfirmationRootLazyQuery>;
export type ConsultationConfirmationRootSuspenseQueryHookResult = ReturnType<typeof useConsultationConfirmationRootSuspenseQuery>;
export type ConsultationConfirmationRootQueryResult = Apollo.QueryResult<ConsultationConfirmationRootQuery, ConsultationConfirmationRootQueryVariables>;
export const CreateAccountSoftwarePageDocument = gql`
    query CreateAccountSoftwarePage($id: String!) {
  consultation(id: $id) {
    id
    type
  }
}
    `;

/**
 * __useCreateAccountSoftwarePageQuery__
 *
 * To run a query within a React component, call `useCreateAccountSoftwarePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountSoftwarePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateAccountSoftwarePageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCreateAccountSoftwarePageQuery(baseOptions: Apollo.QueryHookOptions<CreateAccountSoftwarePageQuery, CreateAccountSoftwarePageQueryVariables> & ({ variables: CreateAccountSoftwarePageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreateAccountSoftwarePageQuery, CreateAccountSoftwarePageQueryVariables>(CreateAccountSoftwarePageDocument, options);
      }
export function useCreateAccountSoftwarePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateAccountSoftwarePageQuery, CreateAccountSoftwarePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreateAccountSoftwarePageQuery, CreateAccountSoftwarePageQueryVariables>(CreateAccountSoftwarePageDocument, options);
        }
export function useCreateAccountSoftwarePageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CreateAccountSoftwarePageQuery, CreateAccountSoftwarePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CreateAccountSoftwarePageQuery, CreateAccountSoftwarePageQueryVariables>(CreateAccountSoftwarePageDocument, options);
        }
export type CreateAccountSoftwarePageQueryHookResult = ReturnType<typeof useCreateAccountSoftwarePageQuery>;
export type CreateAccountSoftwarePageLazyQueryHookResult = ReturnType<typeof useCreateAccountSoftwarePageLazyQuery>;
export type CreateAccountSoftwarePageSuspenseQueryHookResult = ReturnType<typeof useCreateAccountSoftwarePageSuspenseQuery>;
export type CreateAccountSoftwarePageQueryResult = Apollo.QueryResult<CreateAccountSoftwarePageQuery, CreateAccountSoftwarePageQueryVariables>;
export const FollowUpConsultationSoftwareDocument = gql`
    query FollowUpConsultationSoftware($id: String!) {
  consultation(id: $id) {
    ...ConsultationInfoSoftware
  }
}
    ${ConsultationInfoSoftwareFragmentDoc}`;

/**
 * __useFollowUpConsultationSoftwareQuery__
 *
 * To run a query within a React component, call `useFollowUpConsultationSoftwareQuery` and pass it any options that fit your needs.
 * When your component renders, `useFollowUpConsultationSoftwareQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFollowUpConsultationSoftwareQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFollowUpConsultationSoftwareQuery(baseOptions: Apollo.QueryHookOptions<FollowUpConsultationSoftwareQuery, FollowUpConsultationSoftwareQueryVariables> & ({ variables: FollowUpConsultationSoftwareQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FollowUpConsultationSoftwareQuery, FollowUpConsultationSoftwareQueryVariables>(FollowUpConsultationSoftwareDocument, options);
      }
export function useFollowUpConsultationSoftwareLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FollowUpConsultationSoftwareQuery, FollowUpConsultationSoftwareQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FollowUpConsultationSoftwareQuery, FollowUpConsultationSoftwareQueryVariables>(FollowUpConsultationSoftwareDocument, options);
        }
export function useFollowUpConsultationSoftwareSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FollowUpConsultationSoftwareQuery, FollowUpConsultationSoftwareQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FollowUpConsultationSoftwareQuery, FollowUpConsultationSoftwareQueryVariables>(FollowUpConsultationSoftwareDocument, options);
        }
export type FollowUpConsultationSoftwareQueryHookResult = ReturnType<typeof useFollowUpConsultationSoftwareQuery>;
export type FollowUpConsultationSoftwareLazyQueryHookResult = ReturnType<typeof useFollowUpConsultationSoftwareLazyQuery>;
export type FollowUpConsultationSoftwareSuspenseQueryHookResult = ReturnType<typeof useFollowUpConsultationSoftwareSuspenseQuery>;
export type FollowUpConsultationSoftwareQueryResult = Apollo.QueryResult<FollowUpConsultationSoftwareQuery, FollowUpConsultationSoftwareQueryVariables>;
export const PaymentProfileSoftwareDocument = gql`
    query PaymentProfileSoftware {
  profile {
    ...UserInfoSoftware
  }
}
    ${UserInfoSoftwareFragmentDoc}`;

/**
 * __usePaymentProfileSoftwareQuery__
 *
 * To run a query within a React component, call `usePaymentProfileSoftwareQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentProfileSoftwareQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentProfileSoftwareQuery({
 *   variables: {
 *   },
 * });
 */
export function usePaymentProfileSoftwareQuery(baseOptions?: Apollo.QueryHookOptions<PaymentProfileSoftwareQuery, PaymentProfileSoftwareQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentProfileSoftwareQuery, PaymentProfileSoftwareQueryVariables>(PaymentProfileSoftwareDocument, options);
      }
export function usePaymentProfileSoftwareLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentProfileSoftwareQuery, PaymentProfileSoftwareQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentProfileSoftwareQuery, PaymentProfileSoftwareQueryVariables>(PaymentProfileSoftwareDocument, options);
        }
export function usePaymentProfileSoftwareSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PaymentProfileSoftwareQuery, PaymentProfileSoftwareQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaymentProfileSoftwareQuery, PaymentProfileSoftwareQueryVariables>(PaymentProfileSoftwareDocument, options);
        }
export type PaymentProfileSoftwareQueryHookResult = ReturnType<typeof usePaymentProfileSoftwareQuery>;
export type PaymentProfileSoftwareLazyQueryHookResult = ReturnType<typeof usePaymentProfileSoftwareLazyQuery>;
export type PaymentProfileSoftwareSuspenseQueryHookResult = ReturnType<typeof usePaymentProfileSoftwareSuspenseQuery>;
export type PaymentProfileSoftwareQueryResult = Apollo.QueryResult<PaymentProfileSoftwareQuery, PaymentProfileSoftwareQueryVariables>;
export const UpdateProfilePaymentSoftwareDocument = gql`
    mutation UpdateProfilePaymentSoftware($firstName: String, $lastName: String, $phone: String, $password: String, $birthday: String) {
  updateProfile(
    firstName: $firstName
    lastName: $lastName
    phone: $phone
    password: $password
    birthday: $birthday
  ) {
    id
  }
}
    `;
export type UpdateProfilePaymentSoftwareMutationFn = Apollo.MutationFunction<UpdateProfilePaymentSoftwareMutation, UpdateProfilePaymentSoftwareMutationVariables>;

/**
 * __useUpdateProfilePaymentSoftwareMutation__
 *
 * To run a mutation, you first call `useUpdateProfilePaymentSoftwareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfilePaymentSoftwareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfilePaymentSoftwareMutation, { data, loading, error }] = useUpdateProfilePaymentSoftwareMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      phone: // value for 'phone'
 *      password: // value for 'password'
 *      birthday: // value for 'birthday'
 *   },
 * });
 */
export function useUpdateProfilePaymentSoftwareMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProfilePaymentSoftwareMutation, UpdateProfilePaymentSoftwareMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProfilePaymentSoftwareMutation, UpdateProfilePaymentSoftwareMutationVariables>(UpdateProfilePaymentSoftwareDocument, options);
      }
export type UpdateProfilePaymentSoftwareMutationHookResult = ReturnType<typeof useUpdateProfilePaymentSoftwareMutation>;
export type UpdateProfilePaymentSoftwareMutationResult = Apollo.MutationResult<UpdateProfilePaymentSoftwareMutation>;
export type UpdateProfilePaymentSoftwareMutationOptions = Apollo.BaseMutationOptions<UpdateProfilePaymentSoftwareMutation, UpdateProfilePaymentSoftwareMutationVariables>;
export const PayConsultationPaymentSoftwareDocument = gql`
    mutation PayConsultationPaymentSoftware($id: String!, $couponCode: String, $token: String, $gateway: PaymentGateway, $zipCheckoutId: String, $method: String) {
  payConsultation(
    id: $id
    couponCode: $couponCode
    token: $token
    gateway: $gateway
    zipCheckoutId: $zipCheckoutId
    method: $method
  ) {
    id
  }
}
    `;
export type PayConsultationPaymentSoftwareMutationFn = Apollo.MutationFunction<PayConsultationPaymentSoftwareMutation, PayConsultationPaymentSoftwareMutationVariables>;

/**
 * __usePayConsultationPaymentSoftwareMutation__
 *
 * To run a mutation, you first call `usePayConsultationPaymentSoftwareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePayConsultationPaymentSoftwareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [payConsultationPaymentSoftwareMutation, { data, loading, error }] = usePayConsultationPaymentSoftwareMutation({
 *   variables: {
 *      id: // value for 'id'
 *      couponCode: // value for 'couponCode'
 *      token: // value for 'token'
 *      gateway: // value for 'gateway'
 *      zipCheckoutId: // value for 'zipCheckoutId'
 *      method: // value for 'method'
 *   },
 * });
 */
export function usePayConsultationPaymentSoftwareMutation(baseOptions?: Apollo.MutationHookOptions<PayConsultationPaymentSoftwareMutation, PayConsultationPaymentSoftwareMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PayConsultationPaymentSoftwareMutation, PayConsultationPaymentSoftwareMutationVariables>(PayConsultationPaymentSoftwareDocument, options);
      }
export type PayConsultationPaymentSoftwareMutationHookResult = ReturnType<typeof usePayConsultationPaymentSoftwareMutation>;
export type PayConsultationPaymentSoftwareMutationResult = Apollo.MutationResult<PayConsultationPaymentSoftwareMutation>;
export type PayConsultationPaymentSoftwareMutationOptions = Apollo.BaseMutationOptions<PayConsultationPaymentSoftwareMutation, PayConsultationPaymentSoftwareMutationVariables>;
export const InitiateZipConsultationPaymentDocument = gql`
    mutation InitiateZipConsultationPayment($consultationId: String!, $redirectUrl: String!, $couponCode: String) {
  initiateZipConsultationPayment(
    consultationId: $consultationId
    redirectUrl: $redirectUrl
    couponCode: $couponCode
  ) {
    redirectUrl
  }
}
    `;
export type InitiateZipConsultationPaymentMutationFn = Apollo.MutationFunction<InitiateZipConsultationPaymentMutation, InitiateZipConsultationPaymentMutationVariables>;

/**
 * __useInitiateZipConsultationPaymentMutation__
 *
 * To run a mutation, you first call `useInitiateZipConsultationPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateZipConsultationPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateZipConsultationPaymentMutation, { data, loading, error }] = useInitiateZipConsultationPaymentMutation({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *      redirectUrl: // value for 'redirectUrl'
 *      couponCode: // value for 'couponCode'
 *   },
 * });
 */
export function useInitiateZipConsultationPaymentMutation(baseOptions?: Apollo.MutationHookOptions<InitiateZipConsultationPaymentMutation, InitiateZipConsultationPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitiateZipConsultationPaymentMutation, InitiateZipConsultationPaymentMutationVariables>(InitiateZipConsultationPaymentDocument, options);
      }
export type InitiateZipConsultationPaymentMutationHookResult = ReturnType<typeof useInitiateZipConsultationPaymentMutation>;
export type InitiateZipConsultationPaymentMutationResult = Apollo.MutationResult<InitiateZipConsultationPaymentMutation>;
export type InitiateZipConsultationPaymentMutationOptions = Apollo.BaseMutationOptions<InitiateZipConsultationPaymentMutation, InitiateZipConsultationPaymentMutationVariables>;
export const SoftwareConsultationPlanDocument = gql`
    query SoftwareConsultationPlan($consultationId: String!) {
  consultation(id: $consultationId) {
    id
    type
    requiresPrescriberCall
  }
}
    `;

/**
 * __useSoftwareConsultationPlanQuery__
 *
 * To run a query within a React component, call `useSoftwareConsultationPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useSoftwareConsultationPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSoftwareConsultationPlanQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function useSoftwareConsultationPlanQuery(baseOptions: Apollo.QueryHookOptions<SoftwareConsultationPlanQuery, SoftwareConsultationPlanQueryVariables> & ({ variables: SoftwareConsultationPlanQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SoftwareConsultationPlanQuery, SoftwareConsultationPlanQueryVariables>(SoftwareConsultationPlanDocument, options);
      }
export function useSoftwareConsultationPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SoftwareConsultationPlanQuery, SoftwareConsultationPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SoftwareConsultationPlanQuery, SoftwareConsultationPlanQueryVariables>(SoftwareConsultationPlanDocument, options);
        }
export function useSoftwareConsultationPlanSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SoftwareConsultationPlanQuery, SoftwareConsultationPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SoftwareConsultationPlanQuery, SoftwareConsultationPlanQueryVariables>(SoftwareConsultationPlanDocument, options);
        }
export type SoftwareConsultationPlanQueryHookResult = ReturnType<typeof useSoftwareConsultationPlanQuery>;
export type SoftwareConsultationPlanLazyQueryHookResult = ReturnType<typeof useSoftwareConsultationPlanLazyQuery>;
export type SoftwareConsultationPlanSuspenseQueryHookResult = ReturnType<typeof useSoftwareConsultationPlanSuspenseQuery>;
export type SoftwareConsultationPlanQueryResult = Apollo.QueryResult<SoftwareConsultationPlanQuery, SoftwareConsultationPlanQueryVariables>;
export const SoftwarePracBookingConfirmationPageDocument = gql`
    query SoftwarePracBookingConfirmationPage($pracBookingId: ID!) {
  practitionerBooking(id: $pracBookingId) {
    id
    consultation {
      id
    }
    patient {
      id
      email
      phone
    }
    windowStartAt
    windowEndAt
  }
  validPhoneRegions {
    id
    countryCode
  }
}
    `;

/**
 * __useSoftwarePracBookingConfirmationPageQuery__
 *
 * To run a query within a React component, call `useSoftwarePracBookingConfirmationPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSoftwarePracBookingConfirmationPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSoftwarePracBookingConfirmationPageQuery({
 *   variables: {
 *      pracBookingId: // value for 'pracBookingId'
 *   },
 * });
 */
export function useSoftwarePracBookingConfirmationPageQuery(baseOptions: Apollo.QueryHookOptions<SoftwarePracBookingConfirmationPageQuery, SoftwarePracBookingConfirmationPageQueryVariables> & ({ variables: SoftwarePracBookingConfirmationPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SoftwarePracBookingConfirmationPageQuery, SoftwarePracBookingConfirmationPageQueryVariables>(SoftwarePracBookingConfirmationPageDocument, options);
      }
export function useSoftwarePracBookingConfirmationPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SoftwarePracBookingConfirmationPageQuery, SoftwarePracBookingConfirmationPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SoftwarePracBookingConfirmationPageQuery, SoftwarePracBookingConfirmationPageQueryVariables>(SoftwarePracBookingConfirmationPageDocument, options);
        }
export function useSoftwarePracBookingConfirmationPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SoftwarePracBookingConfirmationPageQuery, SoftwarePracBookingConfirmationPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SoftwarePracBookingConfirmationPageQuery, SoftwarePracBookingConfirmationPageQueryVariables>(SoftwarePracBookingConfirmationPageDocument, options);
        }
export type SoftwarePracBookingConfirmationPageQueryHookResult = ReturnType<typeof useSoftwarePracBookingConfirmationPageQuery>;
export type SoftwarePracBookingConfirmationPageLazyQueryHookResult = ReturnType<typeof useSoftwarePracBookingConfirmationPageLazyQuery>;
export type SoftwarePracBookingConfirmationPageSuspenseQueryHookResult = ReturnType<typeof useSoftwarePracBookingConfirmationPageSuspenseQuery>;
export type SoftwarePracBookingConfirmationPageQueryResult = Apollo.QueryResult<SoftwarePracBookingConfirmationPageQuery, SoftwarePracBookingConfirmationPageQueryVariables>;
export const SoftwarePractitionerPhoneCallPageDocument = gql`
    query SoftwarePractitionerPhoneCallPage($consultationId: String!) {
  consultation(id: $consultationId) {
    id
    latestPractitionerBooking {
      id
    }
  }
}
    `;

/**
 * __useSoftwarePractitionerPhoneCallPageQuery__
 *
 * To run a query within a React component, call `useSoftwarePractitionerPhoneCallPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSoftwarePractitionerPhoneCallPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSoftwarePractitionerPhoneCallPageQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function useSoftwarePractitionerPhoneCallPageQuery(baseOptions: Apollo.QueryHookOptions<SoftwarePractitionerPhoneCallPageQuery, SoftwarePractitionerPhoneCallPageQueryVariables> & ({ variables: SoftwarePractitionerPhoneCallPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SoftwarePractitionerPhoneCallPageQuery, SoftwarePractitionerPhoneCallPageQueryVariables>(SoftwarePractitionerPhoneCallPageDocument, options);
      }
export function useSoftwarePractitionerPhoneCallPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SoftwarePractitionerPhoneCallPageQuery, SoftwarePractitionerPhoneCallPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SoftwarePractitionerPhoneCallPageQuery, SoftwarePractitionerPhoneCallPageQueryVariables>(SoftwarePractitionerPhoneCallPageDocument, options);
        }
export function useSoftwarePractitionerPhoneCallPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SoftwarePractitionerPhoneCallPageQuery, SoftwarePractitionerPhoneCallPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SoftwarePractitionerPhoneCallPageQuery, SoftwarePractitionerPhoneCallPageQueryVariables>(SoftwarePractitionerPhoneCallPageDocument, options);
        }
export type SoftwarePractitionerPhoneCallPageQueryHookResult = ReturnType<typeof useSoftwarePractitionerPhoneCallPageQuery>;
export type SoftwarePractitionerPhoneCallPageLazyQueryHookResult = ReturnType<typeof useSoftwarePractitionerPhoneCallPageLazyQuery>;
export type SoftwarePractitionerPhoneCallPageSuspenseQueryHookResult = ReturnType<typeof useSoftwarePractitionerPhoneCallPageSuspenseQuery>;
export type SoftwarePractitionerPhoneCallPageQueryResult = Apollo.QueryResult<SoftwarePractitionerPhoneCallPageQuery, SoftwarePractitionerPhoneCallPageQueryVariables>;
export const RegimenVariationDocument = gql`
    query RegimenVariation($consultationId: String!) {
  skinRegimen(consultationId: $consultationId) {
    skinType
    primarySkinGoal
    unorderedSkinGoals
    skinGoalBasedRecommendedOTC {
      id
      name
      photo {
        id
        url
      }
      description
      shortDescription
      variants {
        id
        name
        price
        inventory {
          id
          sku
        }
      }
    }
    restOfRange {
      id
      name
      photo {
        id
        url
      }
      description
      shortDescription
      variants {
        id
        name
        price
        inventory {
          id
          sku
        }
      }
    }
  }
}
    `;

/**
 * __useRegimenVariationQuery__
 *
 * To run a query within a React component, call `useRegimenVariationQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegimenVariationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegimenVariationQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function useRegimenVariationQuery(baseOptions: Apollo.QueryHookOptions<RegimenVariationQuery, RegimenVariationQueryVariables> & ({ variables: RegimenVariationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegimenVariationQuery, RegimenVariationQueryVariables>(RegimenVariationDocument, options);
      }
export function useRegimenVariationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegimenVariationQuery, RegimenVariationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegimenVariationQuery, RegimenVariationQueryVariables>(RegimenVariationDocument, options);
        }
export function useRegimenVariationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RegimenVariationQuery, RegimenVariationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RegimenVariationQuery, RegimenVariationQueryVariables>(RegimenVariationDocument, options);
        }
export type RegimenVariationQueryHookResult = ReturnType<typeof useRegimenVariationQuery>;
export type RegimenVariationLazyQueryHookResult = ReturnType<typeof useRegimenVariationLazyQuery>;
export type RegimenVariationSuspenseQueryHookResult = ReturnType<typeof useRegimenVariationSuspenseQuery>;
export type RegimenVariationQueryResult = Apollo.QueryResult<RegimenVariationQuery, RegimenVariationQueryVariables>;
export const SoftwareSchedulePhoneCallPageDocument = gql`
    query SoftwareSchedulePhoneCallPage($consultationId: String!) {
  consultation(id: $consultationId) {
    id
    latestPractitionerBooking {
      id
    }
  }
}
    `;

/**
 * __useSoftwareSchedulePhoneCallPageQuery__
 *
 * To run a query within a React component, call `useSoftwareSchedulePhoneCallPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSoftwareSchedulePhoneCallPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSoftwareSchedulePhoneCallPageQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function useSoftwareSchedulePhoneCallPageQuery(baseOptions: Apollo.QueryHookOptions<SoftwareSchedulePhoneCallPageQuery, SoftwareSchedulePhoneCallPageQueryVariables> & ({ variables: SoftwareSchedulePhoneCallPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SoftwareSchedulePhoneCallPageQuery, SoftwareSchedulePhoneCallPageQueryVariables>(SoftwareSchedulePhoneCallPageDocument, options);
      }
export function useSoftwareSchedulePhoneCallPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SoftwareSchedulePhoneCallPageQuery, SoftwareSchedulePhoneCallPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SoftwareSchedulePhoneCallPageQuery, SoftwareSchedulePhoneCallPageQueryVariables>(SoftwareSchedulePhoneCallPageDocument, options);
        }
export function useSoftwareSchedulePhoneCallPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SoftwareSchedulePhoneCallPageQuery, SoftwareSchedulePhoneCallPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SoftwareSchedulePhoneCallPageQuery, SoftwareSchedulePhoneCallPageQueryVariables>(SoftwareSchedulePhoneCallPageDocument, options);
        }
export type SoftwareSchedulePhoneCallPageQueryHookResult = ReturnType<typeof useSoftwareSchedulePhoneCallPageQuery>;
export type SoftwareSchedulePhoneCallPageLazyQueryHookResult = ReturnType<typeof useSoftwareSchedulePhoneCallPageLazyQuery>;
export type SoftwareSchedulePhoneCallPageSuspenseQueryHookResult = ReturnType<typeof useSoftwareSchedulePhoneCallPageSuspenseQuery>;
export type SoftwareSchedulePhoneCallPageQueryResult = Apollo.QueryResult<SoftwareSchedulePhoneCallPageQuery, SoftwareSchedulePhoneCallPageQueryVariables>;
export const ConfirmOrderSoftwareDocument = gql`
    mutation ConfirmOrderSoftware($consultationId: String!, $firstName: String, $lastName: String, $address: AddressCreateWithoutUserInput!, $phone: String, $token: String, $gateway: PaymentGateway, $zipCheckoutId: String, $couponCode: String) {
  confirmOrder(
    consultationId: $consultationId
    firstName: $firstName
    lastName: $lastName
    address: $address
    phone: $phone
    token: $token
    gateway: $gateway
    couponCode: $couponCode
    zipCheckoutId: $zipCheckoutId
  ) {
    id
  }
}
    `;
export type ConfirmOrderSoftwareMutationFn = Apollo.MutationFunction<ConfirmOrderSoftwareMutation, ConfirmOrderSoftwareMutationVariables>;

/**
 * __useConfirmOrderSoftwareMutation__
 *
 * To run a mutation, you first call `useConfirmOrderSoftwareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmOrderSoftwareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmOrderSoftwareMutation, { data, loading, error }] = useConfirmOrderSoftwareMutation({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      address: // value for 'address'
 *      phone: // value for 'phone'
 *      token: // value for 'token'
 *      gateway: // value for 'gateway'
 *      zipCheckoutId: // value for 'zipCheckoutId'
 *      couponCode: // value for 'couponCode'
 *   },
 * });
 */
export function useConfirmOrderSoftwareMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmOrderSoftwareMutation, ConfirmOrderSoftwareMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmOrderSoftwareMutation, ConfirmOrderSoftwareMutationVariables>(ConfirmOrderSoftwareDocument, options);
      }
export type ConfirmOrderSoftwareMutationHookResult = ReturnType<typeof useConfirmOrderSoftwareMutation>;
export type ConfirmOrderSoftwareMutationResult = Apollo.MutationResult<ConfirmOrderSoftwareMutation>;
export type ConfirmOrderSoftwareMutationOptions = Apollo.BaseMutationOptions<ConfirmOrderSoftwareMutation, ConfirmOrderSoftwareMutationVariables>;
export const InitiateZipCheckoutSoftwareDocument = gql`
    mutation InitiateZipCheckoutSoftware($redirectUrl: String!, $address: AddressCreateWithoutUserInput!, $orderId: String!, $couponCode: String, $phone: String) {
  initiateZipCheckout(
    redirectUrl: $redirectUrl
    address: $address
    orderId: $orderId
    couponCode: $couponCode
    phone: $phone
  ) {
    redirectUrl
  }
}
    `;
export type InitiateZipCheckoutSoftwareMutationFn = Apollo.MutationFunction<InitiateZipCheckoutSoftwareMutation, InitiateZipCheckoutSoftwareMutationVariables>;

/**
 * __useInitiateZipCheckoutSoftwareMutation__
 *
 * To run a mutation, you first call `useInitiateZipCheckoutSoftwareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateZipCheckoutSoftwareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateZipCheckoutSoftwareMutation, { data, loading, error }] = useInitiateZipCheckoutSoftwareMutation({
 *   variables: {
 *      redirectUrl: // value for 'redirectUrl'
 *      address: // value for 'address'
 *      orderId: // value for 'orderId'
 *      couponCode: // value for 'couponCode'
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useInitiateZipCheckoutSoftwareMutation(baseOptions?: Apollo.MutationHookOptions<InitiateZipCheckoutSoftwareMutation, InitiateZipCheckoutSoftwareMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitiateZipCheckoutSoftwareMutation, InitiateZipCheckoutSoftwareMutationVariables>(InitiateZipCheckoutSoftwareDocument, options);
      }
export type InitiateZipCheckoutSoftwareMutationHookResult = ReturnType<typeof useInitiateZipCheckoutSoftwareMutation>;
export type InitiateZipCheckoutSoftwareMutationResult = Apollo.MutationResult<InitiateZipCheckoutSoftwareMutation>;
export type InitiateZipCheckoutSoftwareMutationOptions = Apollo.BaseMutationOptions<InitiateZipCheckoutSoftwareMutation, InitiateZipCheckoutSoftwareMutationVariables>;
export const ShippingContainerProfileSoftwareDocument = gql`
    query ShippingContainerProfileSoftware {
  profile {
    ...UserInfoSoftware
  }
}
    ${UserInfoSoftwareFragmentDoc}`;

/**
 * __useShippingContainerProfileSoftwareQuery__
 *
 * To run a query within a React component, call `useShippingContainerProfileSoftwareQuery` and pass it any options that fit your needs.
 * When your component renders, `useShippingContainerProfileSoftwareQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShippingContainerProfileSoftwareQuery({
 *   variables: {
 *   },
 * });
 */
export function useShippingContainerProfileSoftwareQuery(baseOptions?: Apollo.QueryHookOptions<ShippingContainerProfileSoftwareQuery, ShippingContainerProfileSoftwareQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShippingContainerProfileSoftwareQuery, ShippingContainerProfileSoftwareQueryVariables>(ShippingContainerProfileSoftwareDocument, options);
      }
export function useShippingContainerProfileSoftwareLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShippingContainerProfileSoftwareQuery, ShippingContainerProfileSoftwareQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShippingContainerProfileSoftwareQuery, ShippingContainerProfileSoftwareQueryVariables>(ShippingContainerProfileSoftwareDocument, options);
        }
export function useShippingContainerProfileSoftwareSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ShippingContainerProfileSoftwareQuery, ShippingContainerProfileSoftwareQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ShippingContainerProfileSoftwareQuery, ShippingContainerProfileSoftwareQueryVariables>(ShippingContainerProfileSoftwareDocument, options);
        }
export type ShippingContainerProfileSoftwareQueryHookResult = ReturnType<typeof useShippingContainerProfileSoftwareQuery>;
export type ShippingContainerProfileSoftwareLazyQueryHookResult = ReturnType<typeof useShippingContainerProfileSoftwareLazyQuery>;
export type ShippingContainerProfileSoftwareSuspenseQueryHookResult = ReturnType<typeof useShippingContainerProfileSoftwareSuspenseQuery>;
export type ShippingContainerProfileSoftwareQueryResult = Apollo.QueryResult<ShippingContainerProfileSoftwareQuery, ShippingContainerProfileSoftwareQueryVariables>;
export const SoftwareEducationReadingDocument = gql`
    query SoftwareEducationReading($id: ID!) {
  educationReading(id: $id) {
    id
    content
    timeToReadMs
  }
}
    `;

/**
 * __useSoftwareEducationReadingQuery__
 *
 * To run a query within a React component, call `useSoftwareEducationReadingQuery` and pass it any options that fit your needs.
 * When your component renders, `useSoftwareEducationReadingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSoftwareEducationReadingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSoftwareEducationReadingQuery(baseOptions: Apollo.QueryHookOptions<SoftwareEducationReadingQuery, SoftwareEducationReadingQueryVariables> & ({ variables: SoftwareEducationReadingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SoftwareEducationReadingQuery, SoftwareEducationReadingQueryVariables>(SoftwareEducationReadingDocument, options);
      }
export function useSoftwareEducationReadingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SoftwareEducationReadingQuery, SoftwareEducationReadingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SoftwareEducationReadingQuery, SoftwareEducationReadingQueryVariables>(SoftwareEducationReadingDocument, options);
        }
export function useSoftwareEducationReadingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SoftwareEducationReadingQuery, SoftwareEducationReadingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SoftwareEducationReadingQuery, SoftwareEducationReadingQueryVariables>(SoftwareEducationReadingDocument, options);
        }
export type SoftwareEducationReadingQueryHookResult = ReturnType<typeof useSoftwareEducationReadingQuery>;
export type SoftwareEducationReadingLazyQueryHookResult = ReturnType<typeof useSoftwareEducationReadingLazyQuery>;
export type SoftwareEducationReadingSuspenseQueryHookResult = ReturnType<typeof useSoftwareEducationReadingSuspenseQuery>;
export type SoftwareEducationReadingQueryResult = Apollo.QueryResult<SoftwareEducationReadingQuery, SoftwareEducationReadingQueryVariables>;
export const SoftwareEducationCollectionDocument = gql`
    query SoftwareEducationCollection($essentialId: ID!, $treatmentId: ID!, $skincareId: ID!, $sideEffectsId: ID!, $progressId: ID!) {
  collectionEssentialReading: educationCollection(id: $essentialId) {
    ...EducationCollection
  }
  collectionTreatment: educationCollection(id: $treatmentId) {
    ...EducationCollection
  }
  collectionSkinCare: educationCollection(id: $skincareId) {
    ...EducationCollection
  }
  collectionSideEffects: educationCollection(id: $sideEffectsId) {
    ...EducationCollection
  }
  collectionProgress: educationCollection(id: $progressId) {
    ...EducationCollection
  }
}
    ${EducationCollectionFragmentDoc}`;

/**
 * __useSoftwareEducationCollectionQuery__
 *
 * To run a query within a React component, call `useSoftwareEducationCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSoftwareEducationCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSoftwareEducationCollectionQuery({
 *   variables: {
 *      essentialId: // value for 'essentialId'
 *      treatmentId: // value for 'treatmentId'
 *      skincareId: // value for 'skincareId'
 *      sideEffectsId: // value for 'sideEffectsId'
 *      progressId: // value for 'progressId'
 *   },
 * });
 */
export function useSoftwareEducationCollectionQuery(baseOptions: Apollo.QueryHookOptions<SoftwareEducationCollectionQuery, SoftwareEducationCollectionQueryVariables> & ({ variables: SoftwareEducationCollectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SoftwareEducationCollectionQuery, SoftwareEducationCollectionQueryVariables>(SoftwareEducationCollectionDocument, options);
      }
export function useSoftwareEducationCollectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SoftwareEducationCollectionQuery, SoftwareEducationCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SoftwareEducationCollectionQuery, SoftwareEducationCollectionQueryVariables>(SoftwareEducationCollectionDocument, options);
        }
export function useSoftwareEducationCollectionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SoftwareEducationCollectionQuery, SoftwareEducationCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SoftwareEducationCollectionQuery, SoftwareEducationCollectionQueryVariables>(SoftwareEducationCollectionDocument, options);
        }
export type SoftwareEducationCollectionQueryHookResult = ReturnType<typeof useSoftwareEducationCollectionQuery>;
export type SoftwareEducationCollectionLazyQueryHookResult = ReturnType<typeof useSoftwareEducationCollectionLazyQuery>;
export type SoftwareEducationCollectionSuspenseQueryHookResult = ReturnType<typeof useSoftwareEducationCollectionSuspenseQuery>;
export type SoftwareEducationCollectionQueryResult = Apollo.QueryResult<SoftwareEducationCollectionQuery, SoftwareEducationCollectionQueryVariables>;
export const UpdateShippingDocument = gql`
    mutation UpdateShipping($address: AddressCreateWithoutUserInput!) {
  updateShipping(address: $address) {
    id
    address {
      id
      line1
      line2
      city
      postalCode
      state
      country
      building
      company
    }
  }
}
    `;
export type UpdateShippingMutationFn = Apollo.MutationFunction<UpdateShippingMutation, UpdateShippingMutationVariables>;

/**
 * __useUpdateShippingMutation__
 *
 * To run a mutation, you first call `useUpdateShippingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShippingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShippingMutation, { data, loading, error }] = useUpdateShippingMutation({
 *   variables: {
 *      address: // value for 'address'
 *   },
 * });
 */
export function useUpdateShippingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateShippingMutation, UpdateShippingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateShippingMutation, UpdateShippingMutationVariables>(UpdateShippingDocument, options);
      }
export type UpdateShippingMutationHookResult = ReturnType<typeof useUpdateShippingMutation>;
export type UpdateShippingMutationResult = Apollo.MutationResult<UpdateShippingMutation>;
export type UpdateShippingMutationOptions = Apollo.BaseMutationOptions<UpdateShippingMutation, UpdateShippingMutationVariables>;
export const UpdateProfileUserDetailsSoftwareDocument = gql`
    mutation UpdateProfileUserDetailsSoftware($firstName: String!, $lastName: String!, $phone: String!, $namePreference: NamePreferenceCreateWithoutUserInput) {
  updateProfile(
    firstName: $firstName
    lastName: $lastName
    phone: $phone
    namePreference: $namePreference
  ) {
    id
    firstName
    lastName
    email
    shortAddressableName
    fullName
    phone
    preferredName
  }
}
    `;
export type UpdateProfileUserDetailsSoftwareMutationFn = Apollo.MutationFunction<UpdateProfileUserDetailsSoftwareMutation, UpdateProfileUserDetailsSoftwareMutationVariables>;

/**
 * __useUpdateProfileUserDetailsSoftwareMutation__
 *
 * To run a mutation, you first call `useUpdateProfileUserDetailsSoftwareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileUserDetailsSoftwareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileUserDetailsSoftwareMutation, { data, loading, error }] = useUpdateProfileUserDetailsSoftwareMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      phone: // value for 'phone'
 *      namePreference: // value for 'namePreference'
 *   },
 * });
 */
export function useUpdateProfileUserDetailsSoftwareMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProfileUserDetailsSoftwareMutation, UpdateProfileUserDetailsSoftwareMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProfileUserDetailsSoftwareMutation, UpdateProfileUserDetailsSoftwareMutationVariables>(UpdateProfileUserDetailsSoftwareDocument, options);
      }
export type UpdateProfileUserDetailsSoftwareMutationHookResult = ReturnType<typeof useUpdateProfileUserDetailsSoftwareMutation>;
export type UpdateProfileUserDetailsSoftwareMutationResult = Apollo.MutationResult<UpdateProfileUserDetailsSoftwareMutation>;
export type UpdateProfileUserDetailsSoftwareMutationOptions = Apollo.BaseMutationOptions<UpdateProfileUserDetailsSoftwareMutation, UpdateProfileUserDetailsSoftwareMutationVariables>;
export const SoftwareProfileDocument = gql`
    query SoftwareProfile {
  consultations {
    id
    type
    treatment {
      id
      status
      hasUnfulfilledOrder
      type
    }
  }
}
    `;

/**
 * __useSoftwareProfileQuery__
 *
 * To run a query within a React component, call `useSoftwareProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useSoftwareProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSoftwareProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useSoftwareProfileQuery(baseOptions?: Apollo.QueryHookOptions<SoftwareProfileQuery, SoftwareProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SoftwareProfileQuery, SoftwareProfileQueryVariables>(SoftwareProfileDocument, options);
      }
export function useSoftwareProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SoftwareProfileQuery, SoftwareProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SoftwareProfileQuery, SoftwareProfileQueryVariables>(SoftwareProfileDocument, options);
        }
export function useSoftwareProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SoftwareProfileQuery, SoftwareProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SoftwareProfileQuery, SoftwareProfileQueryVariables>(SoftwareProfileDocument, options);
        }
export type SoftwareProfileQueryHookResult = ReturnType<typeof useSoftwareProfileQuery>;
export type SoftwareProfileLazyQueryHookResult = ReturnType<typeof useSoftwareProfileLazyQuery>;
export type SoftwareProfileSuspenseQueryHookResult = ReturnType<typeof useSoftwareProfileSuspenseQuery>;
export type SoftwareProfileQueryResult = Apollo.QueryResult<SoftwareProfileQuery, SoftwareProfileQueryVariables>;
export const UserProfileWithConsultationsDocument = gql`
    query UserProfileWithConsultations {
  profile {
    id
    firstName
    consultations(orderBy: {createdAt: desc}) {
      id
      type
      createdAt
      completedAt
      treatment {
        id
        customerStatedTreatmentStartedAt
      }
    }
  }
}
    `;

/**
 * __useUserProfileWithConsultationsQuery__
 *
 * To run a query within a React component, call `useUserProfileWithConsultationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProfileWithConsultationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProfileWithConsultationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserProfileWithConsultationsQuery(baseOptions?: Apollo.QueryHookOptions<UserProfileWithConsultationsQuery, UserProfileWithConsultationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserProfileWithConsultationsQuery, UserProfileWithConsultationsQueryVariables>(UserProfileWithConsultationsDocument, options);
      }
export function useUserProfileWithConsultationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserProfileWithConsultationsQuery, UserProfileWithConsultationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserProfileWithConsultationsQuery, UserProfileWithConsultationsQueryVariables>(UserProfileWithConsultationsDocument, options);
        }
export function useUserProfileWithConsultationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserProfileWithConsultationsQuery, UserProfileWithConsultationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserProfileWithConsultationsQuery, UserProfileWithConsultationsQueryVariables>(UserProfileWithConsultationsDocument, options);
        }
export type UserProfileWithConsultationsQueryHookResult = ReturnType<typeof useUserProfileWithConsultationsQuery>;
export type UserProfileWithConsultationsLazyQueryHookResult = ReturnType<typeof useUserProfileWithConsultationsLazyQuery>;
export type UserProfileWithConsultationsSuspenseQueryHookResult = ReturnType<typeof useUserProfileWithConsultationsSuspenseQuery>;
export type UserProfileWithConsultationsQueryResult = Apollo.QueryResult<UserProfileWithConsultationsQuery, UserProfileWithConsultationsQueryVariables>;
export const RefillTreatmentRestartTreatmentSoftwareDocument = gql`
    mutation RefillTreatmentRestartTreatmentSoftware($treatmentId: String!) {
  refillTreatment(treatmentId: $treatmentId) {
    id
    status
    refillsLeft
    nextPayment
  }
}
    `;
export type RefillTreatmentRestartTreatmentSoftwareMutationFn = Apollo.MutationFunction<RefillTreatmentRestartTreatmentSoftwareMutation, RefillTreatmentRestartTreatmentSoftwareMutationVariables>;

/**
 * __useRefillTreatmentRestartTreatmentSoftwareMutation__
 *
 * To run a mutation, you first call `useRefillTreatmentRestartTreatmentSoftwareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefillTreatmentRestartTreatmentSoftwareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refillTreatmentRestartTreatmentSoftwareMutation, { data, loading, error }] = useRefillTreatmentRestartTreatmentSoftwareMutation({
 *   variables: {
 *      treatmentId: // value for 'treatmentId'
 *   },
 * });
 */
export function useRefillTreatmentRestartTreatmentSoftwareMutation(baseOptions?: Apollo.MutationHookOptions<RefillTreatmentRestartTreatmentSoftwareMutation, RefillTreatmentRestartTreatmentSoftwareMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefillTreatmentRestartTreatmentSoftwareMutation, RefillTreatmentRestartTreatmentSoftwareMutationVariables>(RefillTreatmentRestartTreatmentSoftwareDocument, options);
      }
export type RefillTreatmentRestartTreatmentSoftwareMutationHookResult = ReturnType<typeof useRefillTreatmentRestartTreatmentSoftwareMutation>;
export type RefillTreatmentRestartTreatmentSoftwareMutationResult = Apollo.MutationResult<RefillTreatmentRestartTreatmentSoftwareMutation>;
export type RefillTreatmentRestartTreatmentSoftwareMutationOptions = Apollo.BaseMutationOptions<RefillTreatmentRestartTreatmentSoftwareMutation, RefillTreatmentRestartTreatmentSoftwareMutationVariables>;
export const ProductListTreatmentSoftwareDocument = gql`
    query ProductListTreatmentSoftware($id: String!) {
  treatment(id: $id) {
    id
    otcSchedules {
      id
      cadence
      isActive
    }
  }
}
    `;

/**
 * __useProductListTreatmentSoftwareQuery__
 *
 * To run a query within a React component, call `useProductListTreatmentSoftwareQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductListTreatmentSoftwareQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductListTreatmentSoftwareQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProductListTreatmentSoftwareQuery(baseOptions: Apollo.QueryHookOptions<ProductListTreatmentSoftwareQuery, ProductListTreatmentSoftwareQueryVariables> & ({ variables: ProductListTreatmentSoftwareQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductListTreatmentSoftwareQuery, ProductListTreatmentSoftwareQueryVariables>(ProductListTreatmentSoftwareDocument, options);
      }
export function useProductListTreatmentSoftwareLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductListTreatmentSoftwareQuery, ProductListTreatmentSoftwareQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductListTreatmentSoftwareQuery, ProductListTreatmentSoftwareQueryVariables>(ProductListTreatmentSoftwareDocument, options);
        }
export function useProductListTreatmentSoftwareSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductListTreatmentSoftwareQuery, ProductListTreatmentSoftwareQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductListTreatmentSoftwareQuery, ProductListTreatmentSoftwareQueryVariables>(ProductListTreatmentSoftwareDocument, options);
        }
export type ProductListTreatmentSoftwareQueryHookResult = ReturnType<typeof useProductListTreatmentSoftwareQuery>;
export type ProductListTreatmentSoftwareLazyQueryHookResult = ReturnType<typeof useProductListTreatmentSoftwareLazyQuery>;
export type ProductListTreatmentSoftwareSuspenseQueryHookResult = ReturnType<typeof useProductListTreatmentSoftwareSuspenseQuery>;
export type ProductListTreatmentSoftwareQueryResult = Apollo.QueryResult<ProductListTreatmentSoftwareQuery, ProductListTreatmentSoftwareQueryVariables>;
export const SupportPageDocument = gql`
    query SupportPage {
  treatments {
    id
    type
    status
    product {
      id
      faqs {
        id
        title
        markdown
      }
    }
  }
}
    `;

/**
 * __useSupportPageQuery__
 *
 * To run a query within a React component, call `useSupportPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupportPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupportPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useSupportPageQuery(baseOptions?: Apollo.QueryHookOptions<SupportPageQuery, SupportPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SupportPageQuery, SupportPageQueryVariables>(SupportPageDocument, options);
      }
export function useSupportPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SupportPageQuery, SupportPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SupportPageQuery, SupportPageQueryVariables>(SupportPageDocument, options);
        }
export function useSupportPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SupportPageQuery, SupportPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SupportPageQuery, SupportPageQueryVariables>(SupportPageDocument, options);
        }
export type SupportPageQueryHookResult = ReturnType<typeof useSupportPageQuery>;
export type SupportPageLazyQueryHookResult = ReturnType<typeof useSupportPageLazyQuery>;
export type SupportPageSuspenseQueryHookResult = ReturnType<typeof useSupportPageSuspenseQuery>;
export type SupportPageQueryResult = Apollo.QueryResult<SupportPageQuery, SupportPageQueryVariables>;
export const EducationCardCollectionDocument = gql`
    query EducationCardCollection($id: ID!) {
  educationCollection(id: $id) {
    id
    name
    description
    readings {
      id
      content
      completedAt
      startedAt
      timeToReadMs
    }
  }
}
    `;

/**
 * __useEducationCardCollectionQuery__
 *
 * To run a query within a React component, call `useEducationCardCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useEducationCardCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEducationCardCollectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEducationCardCollectionQuery(baseOptions: Apollo.QueryHookOptions<EducationCardCollectionQuery, EducationCardCollectionQueryVariables> & ({ variables: EducationCardCollectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EducationCardCollectionQuery, EducationCardCollectionQueryVariables>(EducationCardCollectionDocument, options);
      }
export function useEducationCardCollectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EducationCardCollectionQuery, EducationCardCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EducationCardCollectionQuery, EducationCardCollectionQueryVariables>(EducationCardCollectionDocument, options);
        }
export function useEducationCardCollectionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EducationCardCollectionQuery, EducationCardCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EducationCardCollectionQuery, EducationCardCollectionQueryVariables>(EducationCardCollectionDocument, options);
        }
export type EducationCardCollectionQueryHookResult = ReturnType<typeof useEducationCardCollectionQuery>;
export type EducationCardCollectionLazyQueryHookResult = ReturnType<typeof useEducationCardCollectionLazyQuery>;
export type EducationCardCollectionSuspenseQueryHookResult = ReturnType<typeof useEducationCardCollectionSuspenseQuery>;
export type EducationCardCollectionQueryResult = Apollo.QueryResult<EducationCardCollectionQuery, EducationCardCollectionQueryVariables>;
export const SoftwareProfileHomeDocument = gql`
    query SoftwareProfileHome {
  customerAttributes {
    id
    skinSeeingResults
    skinSideEffects
    skinTreatmentUsage
  }
  profile {
    id
    firstName
    email
    consultations(orderBy: {createdAt: desc}) {
      id
      type
      status
      createdAt
      updatedAt
      completedAt
      stage
      isUpfrontPayment
      isApproved
      requiresPrescriberCall
      isInNoPickUpQueue
      latestPractitionerBooking {
        id
        windowStartAt
        windowEndAt
      }
      doctor {
        id
        fullName
        fullClinicianName
        shortClinicianName
        provider {
          id
          clinicianType
        }
      }
      reminders {
        id
        canceled
        doneAt
        scheduledAt
      }
      chatThread {
        id
      }
      allowPatientToSendMessageToDoctor
      treatment {
        id
        type
        status
        isLastOrderUnfulfilled
        refillsLeft
        nextPayment
        createdAt
        customerStatedTreatmentStartedAt
        pendingFollowUpReminderDate
        hasScriptExpired
        plan {
          id
          amount
        }
        orders {
          id
          createdAt
          fulfilledAt
          fulfillment
        }
        otcSchedules {
          id
          isActive
          cadence
          quantity
          product {
            id
            name
            variants {
              id
              price
            }
            photo {
              id
              url
            }
          }
        }
        hasUnfulfilledOrder
        product {
          id
          name
          variants {
            id
            price
          }
          photo {
            id
            url
          }
        }
      }
      quizApplication {
        id
        submittedAt
        answers {
          id
          answer
          answersArray
          question {
            id
            shortcode
          }
        }
      }
      screeningQuizApplication {
        id
        submittedAt
      }
      rejectReason
      ...UseProfileCardsConsultation
    }
    initialQuizApplications: quizApplications(purpose: INITIAL) {
      id
      createdAt
      updatedAt
      submittedAt
      problemType
      purpose
      ...UseProfileCardsQuizApplication
    }
    trackerQuizApplications: quizApplications(purpose: TRACKER) {
      id
      quiz {
        id
        quizCode
      }
      outcomeSummary
      outcomes {
        ... on QuizOutcomeV2 {
          id
        }
        ... on ArticleQuizOutcome {
          link
        }
        ... on NotEligibleQuizOutcome {
          reasons
        }
        ... on BuyOtcQuizOutcome {
          products {
            id
            name
            variants {
              id
              public
            }
            photo {
              id
              url
            }
          }
        }
        ... on ZendeskQuizOutcome {
          id
        }
      }
      createdAt
      submittedAt
    }
    purchases {
      id
      ...UseProfileCardsPurchase
    }
  }
  progressEntries(type: SKIN) {
    id
    date
    type
    photos {
      id
      angle
      signedUrl
    }
  }
}
    ${UseProfileCardsConsultationFragmentDoc}
${UseProfileCardsQuizApplicationFragmentDoc}
${UseProfileCardsPurchaseFragmentDoc}`;

/**
 * __useSoftwareProfileHomeQuery__
 *
 * To run a query within a React component, call `useSoftwareProfileHomeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSoftwareProfileHomeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSoftwareProfileHomeQuery({
 *   variables: {
 *   },
 * });
 */
export function useSoftwareProfileHomeQuery(baseOptions?: Apollo.QueryHookOptions<SoftwareProfileHomeQuery, SoftwareProfileHomeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SoftwareProfileHomeQuery, SoftwareProfileHomeQueryVariables>(SoftwareProfileHomeDocument, options);
      }
export function useSoftwareProfileHomeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SoftwareProfileHomeQuery, SoftwareProfileHomeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SoftwareProfileHomeQuery, SoftwareProfileHomeQueryVariables>(SoftwareProfileHomeDocument, options);
        }
export function useSoftwareProfileHomeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SoftwareProfileHomeQuery, SoftwareProfileHomeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SoftwareProfileHomeQuery, SoftwareProfileHomeQueryVariables>(SoftwareProfileHomeDocument, options);
        }
export type SoftwareProfileHomeQueryHookResult = ReturnType<typeof useSoftwareProfileHomeQuery>;
export type SoftwareProfileHomeLazyQueryHookResult = ReturnType<typeof useSoftwareProfileHomeLazyQuery>;
export type SoftwareProfileHomeSuspenseQueryHookResult = ReturnType<typeof useSoftwareProfileHomeSuspenseQuery>;
export type SoftwareProfileHomeQueryResult = Apollo.QueryResult<SoftwareProfileHomeQuery, SoftwareProfileHomeQueryVariables>;
export const UpdateCustomerStartedTreatmentStartedAtDocument = gql`
    mutation UpdateCustomerStartedTreatmentStartedAt($date: String!, $treatmentId: String!) {
  updateCustomerStatedTreatmentStatedAt(date: $date, treatmentId: $treatmentId) {
    id
    customerStatedTreatmentStartedAt
  }
}
    `;
export type UpdateCustomerStartedTreatmentStartedAtMutationFn = Apollo.MutationFunction<UpdateCustomerStartedTreatmentStartedAtMutation, UpdateCustomerStartedTreatmentStartedAtMutationVariables>;

/**
 * __useUpdateCustomerStartedTreatmentStartedAtMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerStartedTreatmentStartedAtMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerStartedTreatmentStartedAtMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerStartedTreatmentStartedAtMutation, { data, loading, error }] = useUpdateCustomerStartedTreatmentStartedAtMutation({
 *   variables: {
 *      date: // value for 'date'
 *      treatmentId: // value for 'treatmentId'
 *   },
 * });
 */
export function useUpdateCustomerStartedTreatmentStartedAtMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerStartedTreatmentStartedAtMutation, UpdateCustomerStartedTreatmentStartedAtMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerStartedTreatmentStartedAtMutation, UpdateCustomerStartedTreatmentStartedAtMutationVariables>(UpdateCustomerStartedTreatmentStartedAtDocument, options);
      }
export type UpdateCustomerStartedTreatmentStartedAtMutationHookResult = ReturnType<typeof useUpdateCustomerStartedTreatmentStartedAtMutation>;
export type UpdateCustomerStartedTreatmentStartedAtMutationResult = Apollo.MutationResult<UpdateCustomerStartedTreatmentStartedAtMutation>;
export type UpdateCustomerStartedTreatmentStartedAtMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerStartedTreatmentStartedAtMutation, UpdateCustomerStartedTreatmentStartedAtMutationVariables>;
export const SoftwareCheckinDocument = gql`
    query SoftwareCheckin {
  consultations {
    id
    type
    treatment {
      id
      customerStatedTreatmentStartedAt
      orders {
        id
        createdAt
        fulfillment
        fulfilledAt
      }
    }
  }
}
    `;

/**
 * __useSoftwareCheckinQuery__
 *
 * To run a query within a React component, call `useSoftwareCheckinQuery` and pass it any options that fit your needs.
 * When your component renders, `useSoftwareCheckinQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSoftwareCheckinQuery({
 *   variables: {
 *   },
 * });
 */
export function useSoftwareCheckinQuery(baseOptions?: Apollo.QueryHookOptions<SoftwareCheckinQuery, SoftwareCheckinQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SoftwareCheckinQuery, SoftwareCheckinQueryVariables>(SoftwareCheckinDocument, options);
      }
export function useSoftwareCheckinLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SoftwareCheckinQuery, SoftwareCheckinQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SoftwareCheckinQuery, SoftwareCheckinQueryVariables>(SoftwareCheckinDocument, options);
        }
export function useSoftwareCheckinSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SoftwareCheckinQuery, SoftwareCheckinQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SoftwareCheckinQuery, SoftwareCheckinQueryVariables>(SoftwareCheckinDocument, options);
        }
export type SoftwareCheckinQueryHookResult = ReturnType<typeof useSoftwareCheckinQuery>;
export type SoftwareCheckinLazyQueryHookResult = ReturnType<typeof useSoftwareCheckinLazyQuery>;
export type SoftwareCheckinSuspenseQueryHookResult = ReturnType<typeof useSoftwareCheckinSuspenseQuery>;
export type SoftwareCheckinQueryResult = Apollo.QueryResult<SoftwareCheckinQuery, SoftwareCheckinQueryVariables>;
export const ProfileTrackerQuizzesDocument = gql`
    query ProfileTrackerQuizzes {
  profile {
    id
    firstName
    consultations {
      id
      type
      treatment {
        id
      }
    }
    quizApplications(purpose: TRACKER) {
      id
      quiz {
        id
        quizCode
      }
      outcomeSummary
      outcomes {
        ... on QuizOutcomeV2 {
          id
        }
        ... on ArticleQuizOutcome {
          link
        }
        ... on NotEligibleQuizOutcome {
          reasons
        }
        ... on BuyOtcQuizOutcome {
          products {
            id
            name
            variants {
              id
              public
            }
            photo {
              id
              url
            }
          }
        }
        ... on ZendeskQuizOutcome {
          id
        }
      }
      createdAt
      submittedAt
    }
  }
  customerAttributes {
    id
    skinSeeingResults
    skinSideEffects
    skinTreatmentUsage
  }
}
    `;

/**
 * __useProfileTrackerQuizzesQuery__
 *
 * To run a query within a React component, call `useProfileTrackerQuizzesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileTrackerQuizzesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileTrackerQuizzesQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfileTrackerQuizzesQuery(baseOptions?: Apollo.QueryHookOptions<ProfileTrackerQuizzesQuery, ProfileTrackerQuizzesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileTrackerQuizzesQuery, ProfileTrackerQuizzesQueryVariables>(ProfileTrackerQuizzesDocument, options);
      }
export function useProfileTrackerQuizzesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileTrackerQuizzesQuery, ProfileTrackerQuizzesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileTrackerQuizzesQuery, ProfileTrackerQuizzesQueryVariables>(ProfileTrackerQuizzesDocument, options);
        }
export function useProfileTrackerQuizzesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProfileTrackerQuizzesQuery, ProfileTrackerQuizzesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProfileTrackerQuizzesQuery, ProfileTrackerQuizzesQueryVariables>(ProfileTrackerQuizzesDocument, options);
        }
export type ProfileTrackerQuizzesQueryHookResult = ReturnType<typeof useProfileTrackerQuizzesQuery>;
export type ProfileTrackerQuizzesLazyQueryHookResult = ReturnType<typeof useProfileTrackerQuizzesLazyQuery>;
export type ProfileTrackerQuizzesSuspenseQueryHookResult = ReturnType<typeof useProfileTrackerQuizzesSuspenseQuery>;
export type ProfileTrackerQuizzesQueryResult = Apollo.QueryResult<ProfileTrackerQuizzesQuery, ProfileTrackerQuizzesQueryVariables>;
export const SoftwareQuizCompleteQuizApplicationProblemTypeDocument = gql`
    query SoftwareQuizCompleteQuizApplicationProblemType($id: String!) {
  getQuizApplication(id: $id) {
    id
    purpose
    problemType
    quiz {
      id
      default
      quizCode
    }
    consultation {
      id
      stage
      status
      canSchedulePractitionerBooking
    }
  }
  profile {
    id
    phone
    isPasswordSet
  }
}
    `;

/**
 * __useSoftwareQuizCompleteQuizApplicationProblemTypeQuery__
 *
 * To run a query within a React component, call `useSoftwareQuizCompleteQuizApplicationProblemTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSoftwareQuizCompleteQuizApplicationProblemTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSoftwareQuizCompleteQuizApplicationProblemTypeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSoftwareQuizCompleteQuizApplicationProblemTypeQuery(baseOptions: Apollo.QueryHookOptions<SoftwareQuizCompleteQuizApplicationProblemTypeQuery, SoftwareQuizCompleteQuizApplicationProblemTypeQueryVariables> & ({ variables: SoftwareQuizCompleteQuizApplicationProblemTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SoftwareQuizCompleteQuizApplicationProblemTypeQuery, SoftwareQuizCompleteQuizApplicationProblemTypeQueryVariables>(SoftwareQuizCompleteQuizApplicationProblemTypeDocument, options);
      }
export function useSoftwareQuizCompleteQuizApplicationProblemTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SoftwareQuizCompleteQuizApplicationProblemTypeQuery, SoftwareQuizCompleteQuizApplicationProblemTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SoftwareQuizCompleteQuizApplicationProblemTypeQuery, SoftwareQuizCompleteQuizApplicationProblemTypeQueryVariables>(SoftwareQuizCompleteQuizApplicationProblemTypeDocument, options);
        }
export function useSoftwareQuizCompleteQuizApplicationProblemTypeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SoftwareQuizCompleteQuizApplicationProblemTypeQuery, SoftwareQuizCompleteQuizApplicationProblemTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SoftwareQuizCompleteQuizApplicationProblemTypeQuery, SoftwareQuizCompleteQuizApplicationProblemTypeQueryVariables>(SoftwareQuizCompleteQuizApplicationProblemTypeDocument, options);
        }
export type SoftwareQuizCompleteQuizApplicationProblemTypeQueryHookResult = ReturnType<typeof useSoftwareQuizCompleteQuizApplicationProblemTypeQuery>;
export type SoftwareQuizCompleteQuizApplicationProblemTypeLazyQueryHookResult = ReturnType<typeof useSoftwareQuizCompleteQuizApplicationProblemTypeLazyQuery>;
export type SoftwareQuizCompleteQuizApplicationProblemTypeSuspenseQueryHookResult = ReturnType<typeof useSoftwareQuizCompleteQuizApplicationProblemTypeSuspenseQuery>;
export type SoftwareQuizCompleteQuizApplicationProblemTypeQueryResult = Apollo.QueryResult<SoftwareQuizCompleteQuizApplicationProblemTypeQuery, SoftwareQuizCompleteQuizApplicationProblemTypeQueryVariables>;
export const SoftwareAsyncEligibleQuizCompletePageDocument = gql`
    query SoftwareAsyncEligibleQuizCompletePage($consultationId: String!, $problemType: ProblemType!) {
  consultation(id: $consultationId) {
    id
    customer {
      id
      ... on User {
        condition(problemType: $problemType) {
          id
          asyncEligible
        }
      }
    }
  }
}
    `;

/**
 * __useSoftwareAsyncEligibleQuizCompletePageQuery__
 *
 * To run a query within a React component, call `useSoftwareAsyncEligibleQuizCompletePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSoftwareAsyncEligibleQuizCompletePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSoftwareAsyncEligibleQuizCompletePageQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *      problemType: // value for 'problemType'
 *   },
 * });
 */
export function useSoftwareAsyncEligibleQuizCompletePageQuery(baseOptions: Apollo.QueryHookOptions<SoftwareAsyncEligibleQuizCompletePageQuery, SoftwareAsyncEligibleQuizCompletePageQueryVariables> & ({ variables: SoftwareAsyncEligibleQuizCompletePageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SoftwareAsyncEligibleQuizCompletePageQuery, SoftwareAsyncEligibleQuizCompletePageQueryVariables>(SoftwareAsyncEligibleQuizCompletePageDocument, options);
      }
export function useSoftwareAsyncEligibleQuizCompletePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SoftwareAsyncEligibleQuizCompletePageQuery, SoftwareAsyncEligibleQuizCompletePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SoftwareAsyncEligibleQuizCompletePageQuery, SoftwareAsyncEligibleQuizCompletePageQueryVariables>(SoftwareAsyncEligibleQuizCompletePageDocument, options);
        }
export function useSoftwareAsyncEligibleQuizCompletePageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SoftwareAsyncEligibleQuizCompletePageQuery, SoftwareAsyncEligibleQuizCompletePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SoftwareAsyncEligibleQuizCompletePageQuery, SoftwareAsyncEligibleQuizCompletePageQueryVariables>(SoftwareAsyncEligibleQuizCompletePageDocument, options);
        }
export type SoftwareAsyncEligibleQuizCompletePageQueryHookResult = ReturnType<typeof useSoftwareAsyncEligibleQuizCompletePageQuery>;
export type SoftwareAsyncEligibleQuizCompletePageLazyQueryHookResult = ReturnType<typeof useSoftwareAsyncEligibleQuizCompletePageLazyQuery>;
export type SoftwareAsyncEligibleQuizCompletePageSuspenseQueryHookResult = ReturnType<typeof useSoftwareAsyncEligibleQuizCompletePageSuspenseQuery>;
export type SoftwareAsyncEligibleQuizCompletePageQueryResult = Apollo.QueryResult<SoftwareAsyncEligibleQuizCompletePageQuery, SoftwareAsyncEligibleQuizCompletePageQueryVariables>;
export const StartProblemTypeProfileSoftwareDocument = gql`
    query StartProblemTypeProfileSoftware {
  profile {
    id
    consultations(orderBy: {createdAt: desc}) {
      id
      type
      status
      stage
    }
  }
}
    `;

/**
 * __useStartProblemTypeProfileSoftwareQuery__
 *
 * To run a query within a React component, call `useStartProblemTypeProfileSoftwareQuery` and pass it any options that fit your needs.
 * When your component renders, `useStartProblemTypeProfileSoftwareQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStartProblemTypeProfileSoftwareQuery({
 *   variables: {
 *   },
 * });
 */
export function useStartProblemTypeProfileSoftwareQuery(baseOptions?: Apollo.QueryHookOptions<StartProblemTypeProfileSoftwareQuery, StartProblemTypeProfileSoftwareQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StartProblemTypeProfileSoftwareQuery, StartProblemTypeProfileSoftwareQueryVariables>(StartProblemTypeProfileSoftwareDocument, options);
      }
export function useStartProblemTypeProfileSoftwareLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StartProblemTypeProfileSoftwareQuery, StartProblemTypeProfileSoftwareQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StartProblemTypeProfileSoftwareQuery, StartProblemTypeProfileSoftwareQueryVariables>(StartProblemTypeProfileSoftwareDocument, options);
        }
export function useStartProblemTypeProfileSoftwareSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StartProblemTypeProfileSoftwareQuery, StartProblemTypeProfileSoftwareQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StartProblemTypeProfileSoftwareQuery, StartProblemTypeProfileSoftwareQueryVariables>(StartProblemTypeProfileSoftwareDocument, options);
        }
export type StartProblemTypeProfileSoftwareQueryHookResult = ReturnType<typeof useStartProblemTypeProfileSoftwareQuery>;
export type StartProblemTypeProfileSoftwareLazyQueryHookResult = ReturnType<typeof useStartProblemTypeProfileSoftwareLazyQuery>;
export type StartProblemTypeProfileSoftwareSuspenseQueryHookResult = ReturnType<typeof useStartProblemTypeProfileSoftwareSuspenseQuery>;
export type StartProblemTypeProfileSoftwareQueryResult = Apollo.QueryResult<StartProblemTypeProfileSoftwareQuery, StartProblemTypeProfileSoftwareQueryVariables>;
export const StartConfirmProfileSoftwareDocument = gql`
    query StartConfirmProfileSoftware {
  profile {
    id
    consultations(orderBy: {createdAt: desc}) {
      id
      type
      status
    }
  }
}
    `;

/**
 * __useStartConfirmProfileSoftwareQuery__
 *
 * To run a query within a React component, call `useStartConfirmProfileSoftwareQuery` and pass it any options that fit your needs.
 * When your component renders, `useStartConfirmProfileSoftwareQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStartConfirmProfileSoftwareQuery({
 *   variables: {
 *   },
 * });
 */
export function useStartConfirmProfileSoftwareQuery(baseOptions?: Apollo.QueryHookOptions<StartConfirmProfileSoftwareQuery, StartConfirmProfileSoftwareQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StartConfirmProfileSoftwareQuery, StartConfirmProfileSoftwareQueryVariables>(StartConfirmProfileSoftwareDocument, options);
      }
export function useStartConfirmProfileSoftwareLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StartConfirmProfileSoftwareQuery, StartConfirmProfileSoftwareQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StartConfirmProfileSoftwareQuery, StartConfirmProfileSoftwareQueryVariables>(StartConfirmProfileSoftwareDocument, options);
        }
export function useStartConfirmProfileSoftwareSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StartConfirmProfileSoftwareQuery, StartConfirmProfileSoftwareQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StartConfirmProfileSoftwareQuery, StartConfirmProfileSoftwareQueryVariables>(StartConfirmProfileSoftwareDocument, options);
        }
export type StartConfirmProfileSoftwareQueryHookResult = ReturnType<typeof useStartConfirmProfileSoftwareQuery>;
export type StartConfirmProfileSoftwareLazyQueryHookResult = ReturnType<typeof useStartConfirmProfileSoftwareLazyQuery>;
export type StartConfirmProfileSoftwareSuspenseQueryHookResult = ReturnType<typeof useStartConfirmProfileSoftwareSuspenseQuery>;
export type StartConfirmProfileSoftwareQueryResult = Apollo.QueryResult<StartConfirmProfileSoftwareQuery, StartConfirmProfileSoftwareQueryVariables>;
export const SignUpLeadStartSignupSoftwareDocument = gql`
    mutation SignUpLeadStartSignupSoftware($email: String!, $firstName: String, $lastName: String) {
  signUpLead(email: $email, firstName: $firstName, lastName: $lastName) {
    token
    user {
      id
      email
      firstName
      lastName
      shortAddressableName
      fullName
    }
  }
}
    `;
export type SignUpLeadStartSignupSoftwareMutationFn = Apollo.MutationFunction<SignUpLeadStartSignupSoftwareMutation, SignUpLeadStartSignupSoftwareMutationVariables>;

/**
 * __useSignUpLeadStartSignupSoftwareMutation__
 *
 * To run a mutation, you first call `useSignUpLeadStartSignupSoftwareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpLeadStartSignupSoftwareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpLeadStartSignupSoftwareMutation, { data, loading, error }] = useSignUpLeadStartSignupSoftwareMutation({
 *   variables: {
 *      email: // value for 'email'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *   },
 * });
 */
export function useSignUpLeadStartSignupSoftwareMutation(baseOptions?: Apollo.MutationHookOptions<SignUpLeadStartSignupSoftwareMutation, SignUpLeadStartSignupSoftwareMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignUpLeadStartSignupSoftwareMutation, SignUpLeadStartSignupSoftwareMutationVariables>(SignUpLeadStartSignupSoftwareDocument, options);
      }
export type SignUpLeadStartSignupSoftwareMutationHookResult = ReturnType<typeof useSignUpLeadStartSignupSoftwareMutation>;
export type SignUpLeadStartSignupSoftwareMutationResult = Apollo.MutationResult<SignUpLeadStartSignupSoftwareMutation>;
export type SignUpLeadStartSignupSoftwareMutationOptions = Apollo.BaseMutationOptions<SignUpLeadStartSignupSoftwareMutation, SignUpLeadStartSignupSoftwareMutationVariables>;
export const DelayTreatmentDocument = gql`
    mutation DelayTreatment($id: String!, $newDate: String!, $trigger: String!) {
  delayTreatment(id: $id, newDate: $newDate, trigger: $trigger) {
    id
    nextPayment
    status
  }
}
    `;
export type DelayTreatmentMutationFn = Apollo.MutationFunction<DelayTreatmentMutation, DelayTreatmentMutationVariables>;

/**
 * __useDelayTreatmentMutation__
 *
 * To run a mutation, you first call `useDelayTreatmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDelayTreatmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [delayTreatmentMutation, { data, loading, error }] = useDelayTreatmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      newDate: // value for 'newDate'
 *      trigger: // value for 'trigger'
 *   },
 * });
 */
export function useDelayTreatmentMutation(baseOptions?: Apollo.MutationHookOptions<DelayTreatmentMutation, DelayTreatmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DelayTreatmentMutation, DelayTreatmentMutationVariables>(DelayTreatmentDocument, options);
      }
export type DelayTreatmentMutationHookResult = ReturnType<typeof useDelayTreatmentMutation>;
export type DelayTreatmentMutationResult = Apollo.MutationResult<DelayTreatmentMutation>;
export type DelayTreatmentMutationOptions = Apollo.BaseMutationOptions<DelayTreatmentMutation, DelayTreatmentMutationVariables>;
export const TreatmentOverviewSoftwareDocument = gql`
    query TreatmentOverviewSoftware($id: String!) {
  treatment(id: $id) {
    id
    type
  }
}
    `;

/**
 * __useTreatmentOverviewSoftwareQuery__
 *
 * To run a query within a React component, call `useTreatmentOverviewSoftwareQuery` and pass it any options that fit your needs.
 * When your component renders, `useTreatmentOverviewSoftwareQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTreatmentOverviewSoftwareQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTreatmentOverviewSoftwareQuery(baseOptions: Apollo.QueryHookOptions<TreatmentOverviewSoftwareQuery, TreatmentOverviewSoftwareQueryVariables> & ({ variables: TreatmentOverviewSoftwareQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TreatmentOverviewSoftwareQuery, TreatmentOverviewSoftwareQueryVariables>(TreatmentOverviewSoftwareDocument, options);
      }
export function useTreatmentOverviewSoftwareLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TreatmentOverviewSoftwareQuery, TreatmentOverviewSoftwareQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TreatmentOverviewSoftwareQuery, TreatmentOverviewSoftwareQueryVariables>(TreatmentOverviewSoftwareDocument, options);
        }
export function useTreatmentOverviewSoftwareSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TreatmentOverviewSoftwareQuery, TreatmentOverviewSoftwareQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TreatmentOverviewSoftwareQuery, TreatmentOverviewSoftwareQueryVariables>(TreatmentOverviewSoftwareDocument, options);
        }
export type TreatmentOverviewSoftwareQueryHookResult = ReturnType<typeof useTreatmentOverviewSoftwareQuery>;
export type TreatmentOverviewSoftwareLazyQueryHookResult = ReturnType<typeof useTreatmentOverviewSoftwareLazyQuery>;
export type TreatmentOverviewSoftwareSuspenseQueryHookResult = ReturnType<typeof useTreatmentOverviewSoftwareSuspenseQuery>;
export type TreatmentOverviewSoftwareQueryResult = Apollo.QueryResult<TreatmentOverviewSoftwareQuery, TreatmentOverviewSoftwareQueryVariables>;
export const NotesTreatmentSoftwareDocument = gql`
    query NotesTreatmentSoftware($id: String!) {
  treatment(id: $id) {
    ...TreatmentInfoSoftware
  }
}
    ${TreatmentInfoSoftwareFragmentDoc}`;

/**
 * __useNotesTreatmentSoftwareQuery__
 *
 * To run a query within a React component, call `useNotesTreatmentSoftwareQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotesTreatmentSoftwareQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotesTreatmentSoftwareQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useNotesTreatmentSoftwareQuery(baseOptions: Apollo.QueryHookOptions<NotesTreatmentSoftwareQuery, NotesTreatmentSoftwareQueryVariables> & ({ variables: NotesTreatmentSoftwareQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotesTreatmentSoftwareQuery, NotesTreatmentSoftwareQueryVariables>(NotesTreatmentSoftwareDocument, options);
      }
export function useNotesTreatmentSoftwareLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotesTreatmentSoftwareQuery, NotesTreatmentSoftwareQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotesTreatmentSoftwareQuery, NotesTreatmentSoftwareQueryVariables>(NotesTreatmentSoftwareDocument, options);
        }
export function useNotesTreatmentSoftwareSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NotesTreatmentSoftwareQuery, NotesTreatmentSoftwareQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NotesTreatmentSoftwareQuery, NotesTreatmentSoftwareQueryVariables>(NotesTreatmentSoftwareDocument, options);
        }
export type NotesTreatmentSoftwareQueryHookResult = ReturnType<typeof useNotesTreatmentSoftwareQuery>;
export type NotesTreatmentSoftwareLazyQueryHookResult = ReturnType<typeof useNotesTreatmentSoftwareLazyQuery>;
export type NotesTreatmentSoftwareSuspenseQueryHookResult = ReturnType<typeof useNotesTreatmentSoftwareSuspenseQuery>;
export type NotesTreatmentSoftwareQueryResult = Apollo.QueryResult<NotesTreatmentSoftwareQuery, NotesTreatmentSoftwareQueryVariables>;
export const PlanTreatmentSoftwareDocument = gql`
    query PlanTreatmentSoftware($id: String!) {
  treatment(id: $id) {
    ...TreatmentInfoSoftware
  }
  hairTreatments: treatments(where: {type: {equals: HAIR}}) {
    id
    active
  }
}
    ${TreatmentInfoSoftwareFragmentDoc}`;

/**
 * __usePlanTreatmentSoftwareQuery__
 *
 * To run a query within a React component, call `usePlanTreatmentSoftwareQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanTreatmentSoftwareQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanTreatmentSoftwareQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePlanTreatmentSoftwareQuery(baseOptions: Apollo.QueryHookOptions<PlanTreatmentSoftwareQuery, PlanTreatmentSoftwareQueryVariables> & ({ variables: PlanTreatmentSoftwareQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlanTreatmentSoftwareQuery, PlanTreatmentSoftwareQueryVariables>(PlanTreatmentSoftwareDocument, options);
      }
export function usePlanTreatmentSoftwareLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlanTreatmentSoftwareQuery, PlanTreatmentSoftwareQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlanTreatmentSoftwareQuery, PlanTreatmentSoftwareQueryVariables>(PlanTreatmentSoftwareDocument, options);
        }
export function usePlanTreatmentSoftwareSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PlanTreatmentSoftwareQuery, PlanTreatmentSoftwareQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlanTreatmentSoftwareQuery, PlanTreatmentSoftwareQueryVariables>(PlanTreatmentSoftwareDocument, options);
        }
export type PlanTreatmentSoftwareQueryHookResult = ReturnType<typeof usePlanTreatmentSoftwareQuery>;
export type PlanTreatmentSoftwareLazyQueryHookResult = ReturnType<typeof usePlanTreatmentSoftwareLazyQuery>;
export type PlanTreatmentSoftwareSuspenseQueryHookResult = ReturnType<typeof usePlanTreatmentSoftwareSuspenseQuery>;
export type PlanTreatmentSoftwareQueryResult = Apollo.QueryResult<PlanTreatmentSoftwareQuery, PlanTreatmentSoftwareQueryVariables>;
export const TreatmentExploreProductsSoftwareDocument = gql`
    query TreatmentExploreProductsSoftware($id: String!) {
  treatment(id: $id) {
    ...TreatmentInfoSoftware
  }
  hairTreatments: treatments(where: {type: {equals: HAIR}}) {
    id
    active
  }
}
    ${TreatmentInfoSoftwareFragmentDoc}`;

/**
 * __useTreatmentExploreProductsSoftwareQuery__
 *
 * To run a query within a React component, call `useTreatmentExploreProductsSoftwareQuery` and pass it any options that fit your needs.
 * When your component renders, `useTreatmentExploreProductsSoftwareQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTreatmentExploreProductsSoftwareQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTreatmentExploreProductsSoftwareQuery(baseOptions: Apollo.QueryHookOptions<TreatmentExploreProductsSoftwareQuery, TreatmentExploreProductsSoftwareQueryVariables> & ({ variables: TreatmentExploreProductsSoftwareQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TreatmentExploreProductsSoftwareQuery, TreatmentExploreProductsSoftwareQueryVariables>(TreatmentExploreProductsSoftwareDocument, options);
      }
export function useTreatmentExploreProductsSoftwareLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TreatmentExploreProductsSoftwareQuery, TreatmentExploreProductsSoftwareQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TreatmentExploreProductsSoftwareQuery, TreatmentExploreProductsSoftwareQueryVariables>(TreatmentExploreProductsSoftwareDocument, options);
        }
export function useTreatmentExploreProductsSoftwareSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TreatmentExploreProductsSoftwareQuery, TreatmentExploreProductsSoftwareQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TreatmentExploreProductsSoftwareQuery, TreatmentExploreProductsSoftwareQueryVariables>(TreatmentExploreProductsSoftwareDocument, options);
        }
export type TreatmentExploreProductsSoftwareQueryHookResult = ReturnType<typeof useTreatmentExploreProductsSoftwareQuery>;
export type TreatmentExploreProductsSoftwareLazyQueryHookResult = ReturnType<typeof useTreatmentExploreProductsSoftwareLazyQuery>;
export type TreatmentExploreProductsSoftwareSuspenseQueryHookResult = ReturnType<typeof useTreatmentExploreProductsSoftwareSuspenseQuery>;
export type TreatmentExploreProductsSoftwareQueryResult = Apollo.QueryResult<TreatmentExploreProductsSoftwareQuery, TreatmentExploreProductsSoftwareQueryVariables>;
export const RefillTreatmentSoftwareDocument = gql`
    mutation RefillTreatmentSoftware($treatmentId: String!) {
  refillTreatment(treatmentId: $treatmentId, isPaused: false) {
    id
    status
    canRefill
    nextPayment
    refillsLeft
  }
}
    `;
export type RefillTreatmentSoftwareMutationFn = Apollo.MutationFunction<RefillTreatmentSoftwareMutation, RefillTreatmentSoftwareMutationVariables>;

/**
 * __useRefillTreatmentSoftwareMutation__
 *
 * To run a mutation, you first call `useRefillTreatmentSoftwareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefillTreatmentSoftwareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refillTreatmentSoftwareMutation, { data, loading, error }] = useRefillTreatmentSoftwareMutation({
 *   variables: {
 *      treatmentId: // value for 'treatmentId'
 *   },
 * });
 */
export function useRefillTreatmentSoftwareMutation(baseOptions?: Apollo.MutationHookOptions<RefillTreatmentSoftwareMutation, RefillTreatmentSoftwareMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefillTreatmentSoftwareMutation, RefillTreatmentSoftwareMutationVariables>(RefillTreatmentSoftwareDocument, options);
      }
export type RefillTreatmentSoftwareMutationHookResult = ReturnType<typeof useRefillTreatmentSoftwareMutation>;
export type RefillTreatmentSoftwareMutationResult = Apollo.MutationResult<RefillTreatmentSoftwareMutation>;
export type RefillTreatmentSoftwareMutationOptions = Apollo.BaseMutationOptions<RefillTreatmentSoftwareMutation, RefillTreatmentSoftwareMutationVariables>;
export const AuthProviderProfileDocument = gql`
    query AuthProviderProfile {
  profile {
    id
    firstName
    lastName
    shortAddressableName
    fullName
    email
  }
}
    `;

/**
 * __useAuthProviderProfileQuery__
 *
 * To run a query within a React component, call `useAuthProviderProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthProviderProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthProviderProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useAuthProviderProfileQuery(baseOptions?: Apollo.QueryHookOptions<AuthProviderProfileQuery, AuthProviderProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthProviderProfileQuery, AuthProviderProfileQueryVariables>(AuthProviderProfileDocument, options);
      }
export function useAuthProviderProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthProviderProfileQuery, AuthProviderProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthProviderProfileQuery, AuthProviderProfileQueryVariables>(AuthProviderProfileDocument, options);
        }
export function useAuthProviderProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AuthProviderProfileQuery, AuthProviderProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AuthProviderProfileQuery, AuthProviderProfileQueryVariables>(AuthProviderProfileDocument, options);
        }
export type AuthProviderProfileQueryHookResult = ReturnType<typeof useAuthProviderProfileQuery>;
export type AuthProviderProfileLazyQueryHookResult = ReturnType<typeof useAuthProviderProfileLazyQuery>;
export type AuthProviderProfileSuspenseQueryHookResult = ReturnType<typeof useAuthProviderProfileSuspenseQuery>;
export type AuthProviderProfileQueryResult = Apollo.QueryResult<AuthProviderProfileQuery, AuthProviderProfileQueryVariables>;
export const ChatTokenDocument = gql`
    query ChatToken {
  chatToken
}
    `;

/**
 * __useChatTokenQuery__
 *
 * To run a query within a React component, call `useChatTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useChatTokenQuery(baseOptions?: Apollo.QueryHookOptions<ChatTokenQuery, ChatTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChatTokenQuery, ChatTokenQueryVariables>(ChatTokenDocument, options);
      }
export function useChatTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChatTokenQuery, ChatTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChatTokenQuery, ChatTokenQueryVariables>(ChatTokenDocument, options);
        }
export function useChatTokenSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ChatTokenQuery, ChatTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChatTokenQuery, ChatTokenQueryVariables>(ChatTokenDocument, options);
        }
export type ChatTokenQueryHookResult = ReturnType<typeof useChatTokenQuery>;
export type ChatTokenLazyQueryHookResult = ReturnType<typeof useChatTokenLazyQuery>;
export type ChatTokenSuspenseQueryHookResult = ReturnType<typeof useChatTokenSuspenseQuery>;
export type ChatTokenQueryResult = Apollo.QueryResult<ChatTokenQuery, ChatTokenQueryVariables>;
export const ChatProviderDocument = gql`
    query ChatProvider {
  profile {
    id
  }
}
    `;

/**
 * __useChatProviderQuery__
 *
 * To run a query within a React component, call `useChatProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatProviderQuery({
 *   variables: {
 *   },
 * });
 */
export function useChatProviderQuery(baseOptions?: Apollo.QueryHookOptions<ChatProviderQuery, ChatProviderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChatProviderQuery, ChatProviderQueryVariables>(ChatProviderDocument, options);
      }
export function useChatProviderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChatProviderQuery, ChatProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChatProviderQuery, ChatProviderQueryVariables>(ChatProviderDocument, options);
        }
export function useChatProviderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ChatProviderQuery, ChatProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChatProviderQuery, ChatProviderQueryVariables>(ChatProviderDocument, options);
        }
export type ChatProviderQueryHookResult = ReturnType<typeof useChatProviderQuery>;
export type ChatProviderLazyQueryHookResult = ReturnType<typeof useChatProviderLazyQuery>;
export type ChatProviderSuspenseQueryHookResult = ReturnType<typeof useChatProviderSuspenseQuery>;
export type ChatProviderQueryResult = Apollo.QueryResult<ChatProviderQuery, ChatProviderQueryVariables>;
export const UpdateProfilePhoneNumberDocument = gql`
    mutation UpdateProfilePhoneNumber($phone: String!) {
  updateProfile(phone: $phone) {
    id
    phone
  }
}
    `;
export type UpdateProfilePhoneNumberMutationFn = Apollo.MutationFunction<UpdateProfilePhoneNumberMutation, UpdateProfilePhoneNumberMutationVariables>;

/**
 * __useUpdateProfilePhoneNumberMutation__
 *
 * To run a mutation, you first call `useUpdateProfilePhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfilePhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfilePhoneNumberMutation, { data, loading, error }] = useUpdateProfilePhoneNumberMutation({
 *   variables: {
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useUpdateProfilePhoneNumberMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProfilePhoneNumberMutation, UpdateProfilePhoneNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProfilePhoneNumberMutation, UpdateProfilePhoneNumberMutationVariables>(UpdateProfilePhoneNumberDocument, options);
      }
export type UpdateProfilePhoneNumberMutationHookResult = ReturnType<typeof useUpdateProfilePhoneNumberMutation>;
export type UpdateProfilePhoneNumberMutationResult = Apollo.MutationResult<UpdateProfilePhoneNumberMutation>;
export type UpdateProfilePhoneNumberMutationOptions = Apollo.BaseMutationOptions<UpdateProfilePhoneNumberMutation, UpdateProfilePhoneNumberMutationVariables>;
export const ConsultStripePaymentResultHandlerDocument = gql`
    query ConsultStripePaymentResultHandler($consultationId: String!) {
  consultation(id: $consultationId) {
    id
    type
    price {
      total
    }
    customer {
      id
      firstName
      lastName
      phone
    }
  }
}
    `;

/**
 * __useConsultStripePaymentResultHandlerQuery__
 *
 * To run a query within a React component, call `useConsultStripePaymentResultHandlerQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultStripePaymentResultHandlerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultStripePaymentResultHandlerQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function useConsultStripePaymentResultHandlerQuery(baseOptions: Apollo.QueryHookOptions<ConsultStripePaymentResultHandlerQuery, ConsultStripePaymentResultHandlerQueryVariables> & ({ variables: ConsultStripePaymentResultHandlerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConsultStripePaymentResultHandlerQuery, ConsultStripePaymentResultHandlerQueryVariables>(ConsultStripePaymentResultHandlerDocument, options);
      }
export function useConsultStripePaymentResultHandlerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConsultStripePaymentResultHandlerQuery, ConsultStripePaymentResultHandlerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConsultStripePaymentResultHandlerQuery, ConsultStripePaymentResultHandlerQueryVariables>(ConsultStripePaymentResultHandlerDocument, options);
        }
export function useConsultStripePaymentResultHandlerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ConsultStripePaymentResultHandlerQuery, ConsultStripePaymentResultHandlerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConsultStripePaymentResultHandlerQuery, ConsultStripePaymentResultHandlerQueryVariables>(ConsultStripePaymentResultHandlerDocument, options);
        }
export type ConsultStripePaymentResultHandlerQueryHookResult = ReturnType<typeof useConsultStripePaymentResultHandlerQuery>;
export type ConsultStripePaymentResultHandlerLazyQueryHookResult = ReturnType<typeof useConsultStripePaymentResultHandlerLazyQuery>;
export type ConsultStripePaymentResultHandlerSuspenseQueryHookResult = ReturnType<typeof useConsultStripePaymentResultHandlerSuspenseQuery>;
export type ConsultStripePaymentResultHandlerQueryResult = Apollo.QueryResult<ConsultStripePaymentResultHandlerQuery, ConsultStripePaymentResultHandlerQueryVariables>;
export const UpfrontConsultPayPageDocument = gql`
    query UpfrontConsultPayPage($consultationId: String!) {
  profile {
    id
    firstName
    lastName
    legalFirstName
    legalLastName
    email
    phone
    address {
      id
      line1
      line2
      city
      postalCode
      state
      deliveryInstructions
    }
    defaultPaymentGateway
    savedPaymentMethods {
      createdAt
      default
      gateway
      id
      ... on SavedCardPaymentMethod {
        brand
        mask
        expiry
      }
      ... on SavedPayPalPaymentMethod {
        email
      }
      ... on SavedZipPaymentMethod {
        valid
      }
    }
    zip {
      valid
    }
  }
  consultation(id: $consultationId) {
    id
    type
    order {
      id
    }
    isUpfrontPayment
    requiresPrescriberCall
    medicationPreferenceProduct {
      id
      preferredProduct {
        ...UpfrontPaymentConsultProduct
      }
      defaultProduct {
        ...UpfrontPaymentConsultProduct
      }
    }
  }
}
    ${UpfrontPaymentConsultProductFragmentDoc}`;

/**
 * __useUpfrontConsultPayPageQuery__
 *
 * To run a query within a React component, call `useUpfrontConsultPayPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpfrontConsultPayPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpfrontConsultPayPageQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function useUpfrontConsultPayPageQuery(baseOptions: Apollo.QueryHookOptions<UpfrontConsultPayPageQuery, UpfrontConsultPayPageQueryVariables> & ({ variables: UpfrontConsultPayPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UpfrontConsultPayPageQuery, UpfrontConsultPayPageQueryVariables>(UpfrontConsultPayPageDocument, options);
      }
export function useUpfrontConsultPayPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UpfrontConsultPayPageQuery, UpfrontConsultPayPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UpfrontConsultPayPageQuery, UpfrontConsultPayPageQueryVariables>(UpfrontConsultPayPageDocument, options);
        }
export function useUpfrontConsultPayPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UpfrontConsultPayPageQuery, UpfrontConsultPayPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UpfrontConsultPayPageQuery, UpfrontConsultPayPageQueryVariables>(UpfrontConsultPayPageDocument, options);
        }
export type UpfrontConsultPayPageQueryHookResult = ReturnType<typeof useUpfrontConsultPayPageQuery>;
export type UpfrontConsultPayPageLazyQueryHookResult = ReturnType<typeof useUpfrontConsultPayPageLazyQuery>;
export type UpfrontConsultPayPageSuspenseQueryHookResult = ReturnType<typeof useUpfrontConsultPayPageSuspenseQuery>;
export type UpfrontConsultPayPageQueryResult = Apollo.QueryResult<UpfrontConsultPayPageQuery, UpfrontConsultPayPageQueryVariables>;
export const NextReadingCardDocument = gql`
    query NextReadingCard($id: ID!) {
  educationProgram(id: $id) {
    id
    nextUnreadReading {
      id
      content
      startedAt
      timeToReadMs
    }
  }
}
    `;

/**
 * __useNextReadingCardQuery__
 *
 * To run a query within a React component, call `useNextReadingCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useNextReadingCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNextReadingCardQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useNextReadingCardQuery(baseOptions: Apollo.QueryHookOptions<NextReadingCardQuery, NextReadingCardQueryVariables> & ({ variables: NextReadingCardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NextReadingCardQuery, NextReadingCardQueryVariables>(NextReadingCardDocument, options);
      }
export function useNextReadingCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NextReadingCardQuery, NextReadingCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NextReadingCardQuery, NextReadingCardQueryVariables>(NextReadingCardDocument, options);
        }
export function useNextReadingCardSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NextReadingCardQuery, NextReadingCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NextReadingCardQuery, NextReadingCardQueryVariables>(NextReadingCardDocument, options);
        }
export type NextReadingCardQueryHookResult = ReturnType<typeof useNextReadingCardQuery>;
export type NextReadingCardLazyQueryHookResult = ReturnType<typeof useNextReadingCardLazyQuery>;
export type NextReadingCardSuspenseQueryHookResult = ReturnType<typeof useNextReadingCardSuspenseQuery>;
export type NextReadingCardQueryResult = Apollo.QueryResult<NextReadingCardQuery, NextReadingCardQueryVariables>;
export const NextReadingRedirectDocument = gql`
    query NextReadingRedirect($id: ID!) {
  educationProgram(id: $id) {
    id
    nextUnreadReading {
      id
      content
      startedAt
      timeToReadMs
    }
  }
}
    `;

/**
 * __useNextReadingRedirectQuery__
 *
 * To run a query within a React component, call `useNextReadingRedirectQuery` and pass it any options that fit your needs.
 * When your component renders, `useNextReadingRedirectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNextReadingRedirectQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useNextReadingRedirectQuery(baseOptions: Apollo.QueryHookOptions<NextReadingRedirectQuery, NextReadingRedirectQueryVariables> & ({ variables: NextReadingRedirectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NextReadingRedirectQuery, NextReadingRedirectQueryVariables>(NextReadingRedirectDocument, options);
      }
export function useNextReadingRedirectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NextReadingRedirectQuery, NextReadingRedirectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NextReadingRedirectQuery, NextReadingRedirectQueryVariables>(NextReadingRedirectDocument, options);
        }
export function useNextReadingRedirectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NextReadingRedirectQuery, NextReadingRedirectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NextReadingRedirectQuery, NextReadingRedirectQueryVariables>(NextReadingRedirectDocument, options);
        }
export type NextReadingRedirectQueryHookResult = ReturnType<typeof useNextReadingRedirectQuery>;
export type NextReadingRedirectLazyQueryHookResult = ReturnType<typeof useNextReadingRedirectLazyQuery>;
export type NextReadingRedirectSuspenseQueryHookResult = ReturnType<typeof useNextReadingRedirectSuspenseQuery>;
export type NextReadingRedirectQueryResult = Apollo.QueryResult<NextReadingRedirectQuery, NextReadingRedirectQueryVariables>;
export const IhiDocument = gql`
    query IHI {
  profile {
    id
    residentialAddress {
      id
    }
    healthCareDetails {
      id
      hasMedicareDetails
      hasIndividualHealthcareIdentifier
    }
  }
}
    `;

/**
 * __useIhiQuery__
 *
 * To run a query within a React component, call `useIhiQuery` and pass it any options that fit your needs.
 * When your component renders, `useIhiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIhiQuery({
 *   variables: {
 *   },
 * });
 */
export function useIhiQuery(baseOptions?: Apollo.QueryHookOptions<IhiQuery, IhiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IhiQuery, IhiQueryVariables>(IhiDocument, options);
      }
export function useIhiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IhiQuery, IhiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IhiQuery, IhiQueryVariables>(IhiDocument, options);
        }
export function useIhiSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IhiQuery, IhiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IhiQuery, IhiQueryVariables>(IhiDocument, options);
        }
export type IhiQueryHookResult = ReturnType<typeof useIhiQuery>;
export type IhiLazyQueryHookResult = ReturnType<typeof useIhiLazyQuery>;
export type IhiSuspenseQueryHookResult = ReturnType<typeof useIhiSuspenseQuery>;
export type IhiQueryResult = Apollo.QueryResult<IhiQuery, IhiQueryVariables>;
export const MedicareRedirectDocument = gql`
    query MedicareRedirect($id: String!) {
  consultation(id: $id) {
    id
    type
    stage
  }
  profile {
    id
    residentialAddress {
      id
    }
  }
}
    `;

/**
 * __useMedicareRedirectQuery__
 *
 * To run a query within a React component, call `useMedicareRedirectQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedicareRedirectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedicareRedirectQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMedicareRedirectQuery(baseOptions: Apollo.QueryHookOptions<MedicareRedirectQuery, MedicareRedirectQueryVariables> & ({ variables: MedicareRedirectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MedicareRedirectQuery, MedicareRedirectQueryVariables>(MedicareRedirectDocument, options);
      }
export function useMedicareRedirectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MedicareRedirectQuery, MedicareRedirectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MedicareRedirectQuery, MedicareRedirectQueryVariables>(MedicareRedirectDocument, options);
        }
export function useMedicareRedirectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MedicareRedirectQuery, MedicareRedirectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MedicareRedirectQuery, MedicareRedirectQueryVariables>(MedicareRedirectDocument, options);
        }
export type MedicareRedirectQueryHookResult = ReturnType<typeof useMedicareRedirectQuery>;
export type MedicareRedirectLazyQueryHookResult = ReturnType<typeof useMedicareRedirectLazyQuery>;
export type MedicareRedirectSuspenseQueryHookResult = ReturnType<typeof useMedicareRedirectSuspenseQuery>;
export type MedicareRedirectQueryResult = Apollo.QueryResult<MedicareRedirectQuery, MedicareRedirectQueryVariables>;
export const UpdateMedicareDetailsDocument = gql`
    mutation UpdateMedicareDetails($familyName: String!, $firstName: String!, $medicareNumber: String!, $medicareIrn: Int!, $validToMonth: Int!, $validToYear: Int!, $sex: MedicareSexType!, $dateOfBirth: String!) {
  updateMedicareDetails(
    familyName: $familyName
    firstName: $firstName
    medicareNumber: $medicareNumber
    medicareIrn: $medicareIrn
    validToMonth: $validToMonth
    validToYear: $validToYear
    sex: $sex
    dateOfBirth: $dateOfBirth
  )
}
    `;
export type UpdateMedicareDetailsMutationFn = Apollo.MutationFunction<UpdateMedicareDetailsMutation, UpdateMedicareDetailsMutationVariables>;

/**
 * __useUpdateMedicareDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateMedicareDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMedicareDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMedicareDetailsMutation, { data, loading, error }] = useUpdateMedicareDetailsMutation({
 *   variables: {
 *      familyName: // value for 'familyName'
 *      firstName: // value for 'firstName'
 *      medicareNumber: // value for 'medicareNumber'
 *      medicareIrn: // value for 'medicareIrn'
 *      validToMonth: // value for 'validToMonth'
 *      validToYear: // value for 'validToYear'
 *      sex: // value for 'sex'
 *      dateOfBirth: // value for 'dateOfBirth'
 *   },
 * });
 */
export function useUpdateMedicareDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMedicareDetailsMutation, UpdateMedicareDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMedicareDetailsMutation, UpdateMedicareDetailsMutationVariables>(UpdateMedicareDetailsDocument, options);
      }
export type UpdateMedicareDetailsMutationHookResult = ReturnType<typeof useUpdateMedicareDetailsMutation>;
export type UpdateMedicareDetailsMutationResult = Apollo.MutationResult<UpdateMedicareDetailsMutation>;
export type UpdateMedicareDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateMedicareDetailsMutation, UpdateMedicareDetailsMutationVariables>;
export const MasterclassClassPageContentDocument = gql`
    query MasterclassClassPageContent {
  masterclassVideos {
    ...MasterclassEpisode
  }
  profile {
    id
    hasPaidMasterclass
  }
}
    ${MasterclassEpisodeFragmentDoc}`;

/**
 * __useMasterclassClassPageContentQuery__
 *
 * To run a query within a React component, call `useMasterclassClassPageContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useMasterclassClassPageContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMasterclassClassPageContentQuery({
 *   variables: {
 *   },
 * });
 */
export function useMasterclassClassPageContentQuery(baseOptions?: Apollo.QueryHookOptions<MasterclassClassPageContentQuery, MasterclassClassPageContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MasterclassClassPageContentQuery, MasterclassClassPageContentQueryVariables>(MasterclassClassPageContentDocument, options);
      }
export function useMasterclassClassPageContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MasterclassClassPageContentQuery, MasterclassClassPageContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MasterclassClassPageContentQuery, MasterclassClassPageContentQueryVariables>(MasterclassClassPageContentDocument, options);
        }
export function useMasterclassClassPageContentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MasterclassClassPageContentQuery, MasterclassClassPageContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MasterclassClassPageContentQuery, MasterclassClassPageContentQueryVariables>(MasterclassClassPageContentDocument, options);
        }
export type MasterclassClassPageContentQueryHookResult = ReturnType<typeof useMasterclassClassPageContentQuery>;
export type MasterclassClassPageContentLazyQueryHookResult = ReturnType<typeof useMasterclassClassPageContentLazyQuery>;
export type MasterclassClassPageContentSuspenseQueryHookResult = ReturnType<typeof useMasterclassClassPageContentSuspenseQuery>;
export type MasterclassClassPageContentQueryResult = Apollo.QueryResult<MasterclassClassPageContentQuery, MasterclassClassPageContentQueryVariables>;
export const SaveProgressDocument = gql`
    mutation SaveProgress($videoId: String!, $progressPercentage: Float!) {
  saveProgress(videoId: $videoId, progressPercentage: $progressPercentage) {
    id
    videoProgresses {
      id
      videoId
      progressPercentage
    }
  }
}
    `;
export type SaveProgressMutationFn = Apollo.MutationFunction<SaveProgressMutation, SaveProgressMutationVariables>;

/**
 * __useSaveProgressMutation__
 *
 * To run a mutation, you first call `useSaveProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveProgressMutation, { data, loading, error }] = useSaveProgressMutation({
 *   variables: {
 *      videoId: // value for 'videoId'
 *      progressPercentage: // value for 'progressPercentage'
 *   },
 * });
 */
export function useSaveProgressMutation(baseOptions?: Apollo.MutationHookOptions<SaveProgressMutation, SaveProgressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveProgressMutation, SaveProgressMutationVariables>(SaveProgressDocument, options);
      }
export type SaveProgressMutationHookResult = ReturnType<typeof useSaveProgressMutation>;
export type SaveProgressMutationResult = Apollo.MutationResult<SaveProgressMutation>;
export type SaveProgressMutationOptions = Apollo.BaseMutationOptions<SaveProgressMutation, SaveProgressMutationVariables>;
export const MasterclassHomePageContentDocument = gql`
    query MasterclassHomePageContent {
  masterclassVideos {
    ...MasterclassEpisode
  }
  profile {
    id
    hasPaidMasterclass
  }
}
    ${MasterclassEpisodeFragmentDoc}`;

/**
 * __useMasterclassHomePageContentQuery__
 *
 * To run a query within a React component, call `useMasterclassHomePageContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useMasterclassHomePageContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMasterclassHomePageContentQuery({
 *   variables: {
 *   },
 * });
 */
export function useMasterclassHomePageContentQuery(baseOptions?: Apollo.QueryHookOptions<MasterclassHomePageContentQuery, MasterclassHomePageContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MasterclassHomePageContentQuery, MasterclassHomePageContentQueryVariables>(MasterclassHomePageContentDocument, options);
      }
export function useMasterclassHomePageContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MasterclassHomePageContentQuery, MasterclassHomePageContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MasterclassHomePageContentQuery, MasterclassHomePageContentQueryVariables>(MasterclassHomePageContentDocument, options);
        }
export function useMasterclassHomePageContentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MasterclassHomePageContentQuery, MasterclassHomePageContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MasterclassHomePageContentQuery, MasterclassHomePageContentQueryVariables>(MasterclassHomePageContentDocument, options);
        }
export type MasterclassHomePageContentQueryHookResult = ReturnType<typeof useMasterclassHomePageContentQuery>;
export type MasterclassHomePageContentLazyQueryHookResult = ReturnType<typeof useMasterclassHomePageContentLazyQuery>;
export type MasterclassHomePageContentSuspenseQueryHookResult = ReturnType<typeof useMasterclassHomePageContentSuspenseQuery>;
export type MasterclassHomePageContentQueryResult = Apollo.QueryResult<MasterclassHomePageContentQuery, MasterclassHomePageContentQueryVariables>;
export const AutoAddOtcToTreatmentDocument = gql`
    mutation AutoAddOtcToTreatment($id: String!, $productId: String!, $cadence: OtcScheduleCadence!, $quantity: Int, $source: String) {
  upsertOtcProductToTreatment(
    id: $id
    productId: $productId
    cadence: $cadence
    quantity: $quantity
    source: $source
  ) {
    id
    otcSchedules {
      id
      isActive
      cadence
      createdAt
      updatedAt
      quantity
      product {
        id
        name
        productType
        photo {
          id
          url
        }
        variants {
          id
          price
        }
      }
    }
  }
}
    `;
export type AutoAddOtcToTreatmentMutationFn = Apollo.MutationFunction<AutoAddOtcToTreatmentMutation, AutoAddOtcToTreatmentMutationVariables>;

/**
 * __useAutoAddOtcToTreatmentMutation__
 *
 * To run a mutation, you first call `useAutoAddOtcToTreatmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAutoAddOtcToTreatmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [autoAddOtcToTreatmentMutation, { data, loading, error }] = useAutoAddOtcToTreatmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      productId: // value for 'productId'
 *      cadence: // value for 'cadence'
 *      quantity: // value for 'quantity'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useAutoAddOtcToTreatmentMutation(baseOptions?: Apollo.MutationHookOptions<AutoAddOtcToTreatmentMutation, AutoAddOtcToTreatmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AutoAddOtcToTreatmentMutation, AutoAddOtcToTreatmentMutationVariables>(AutoAddOtcToTreatmentDocument, options);
      }
export type AutoAddOtcToTreatmentMutationHookResult = ReturnType<typeof useAutoAddOtcToTreatmentMutation>;
export type AutoAddOtcToTreatmentMutationResult = Apollo.MutationResult<AutoAddOtcToTreatmentMutation>;
export type AutoAddOtcToTreatmentMutationOptions = Apollo.BaseMutationOptions<AutoAddOtcToTreatmentMutation, AutoAddOtcToTreatmentMutationVariables>;
export const RemoveOtcLineItemDocument = gql`
    mutation RemoveOtcLineItem($orderId: String!, $variantId: String!) {
  updateLineItem(orderId: $orderId, quantity: 0, variantId: $variantId) {
    id
    consultation {
      id
      order {
        id
        lineItems {
          id
          quantity
          variant {
            id
            price
            product {
              id
              name
              friendlyName
              productType
              photo {
                id
                url
              }
            }
          }
        }
      }
    }
  }
}
    `;
export type RemoveOtcLineItemMutationFn = Apollo.MutationFunction<RemoveOtcLineItemMutation, RemoveOtcLineItemMutationVariables>;

/**
 * __useRemoveOtcLineItemMutation__
 *
 * To run a mutation, you first call `useRemoveOtcLineItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveOtcLineItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeOtcLineItemMutation, { data, loading, error }] = useRemoveOtcLineItemMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      variantId: // value for 'variantId'
 *   },
 * });
 */
export function useRemoveOtcLineItemMutation(baseOptions?: Apollo.MutationHookOptions<RemoveOtcLineItemMutation, RemoveOtcLineItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveOtcLineItemMutation, RemoveOtcLineItemMutationVariables>(RemoveOtcLineItemDocument, options);
      }
export type RemoveOtcLineItemMutationHookResult = ReturnType<typeof useRemoveOtcLineItemMutation>;
export type RemoveOtcLineItemMutationResult = Apollo.MutationResult<RemoveOtcLineItemMutation>;
export type RemoveOtcLineItemMutationOptions = Apollo.BaseMutationOptions<RemoveOtcLineItemMutation, RemoveOtcLineItemMutationVariables>;
export const OtcPurchaseCompletedDocument = gql`
    query OTCPurchaseCompleted {
  profile {
    id
    firstName
    lastName
    fullName
    email
    phone
    ...BillingDetails
    address {
      id
      line1
      line2
      city
      state
      postalCode
      country
    }
  }
}
    ${BillingDetailsFragmentDoc}`;

/**
 * __useOtcPurchaseCompletedQuery__
 *
 * To run a query within a React component, call `useOtcPurchaseCompletedQuery` and pass it any options that fit your needs.
 * When your component renders, `useOtcPurchaseCompletedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOtcPurchaseCompletedQuery({
 *   variables: {
 *   },
 * });
 */
export function useOtcPurchaseCompletedQuery(baseOptions?: Apollo.QueryHookOptions<OtcPurchaseCompletedQuery, OtcPurchaseCompletedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OtcPurchaseCompletedQuery, OtcPurchaseCompletedQueryVariables>(OtcPurchaseCompletedDocument, options);
      }
export function useOtcPurchaseCompletedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OtcPurchaseCompletedQuery, OtcPurchaseCompletedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OtcPurchaseCompletedQuery, OtcPurchaseCompletedQueryVariables>(OtcPurchaseCompletedDocument, options);
        }
export function useOtcPurchaseCompletedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OtcPurchaseCompletedQuery, OtcPurchaseCompletedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OtcPurchaseCompletedQuery, OtcPurchaseCompletedQueryVariables>(OtcPurchaseCompletedDocument, options);
        }
export type OtcPurchaseCompletedQueryHookResult = ReturnType<typeof useOtcPurchaseCompletedQuery>;
export type OtcPurchaseCompletedLazyQueryHookResult = ReturnType<typeof useOtcPurchaseCompletedLazyQuery>;
export type OtcPurchaseCompletedSuspenseQueryHookResult = ReturnType<typeof useOtcPurchaseCompletedSuspenseQuery>;
export type OtcPurchaseCompletedQueryResult = Apollo.QueryResult<OtcPurchaseCompletedQuery, OtcPurchaseCompletedQueryVariables>;
export const OtcPurchaseDetailsDocument = gql`
    query OTCPurchaseDetails {
  profile {
    id
    firstName
    lastName
    fullName
    email
    phone
    ...BillingDetails
    address {
      id
      line1
      line2
      city
      state
      postalCode
      country
    }
  }
}
    ${BillingDetailsFragmentDoc}`;

/**
 * __useOtcPurchaseDetailsQuery__
 *
 * To run a query within a React component, call `useOtcPurchaseDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOtcPurchaseDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOtcPurchaseDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOtcPurchaseDetailsQuery(baseOptions?: Apollo.QueryHookOptions<OtcPurchaseDetailsQuery, OtcPurchaseDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OtcPurchaseDetailsQuery, OtcPurchaseDetailsQueryVariables>(OtcPurchaseDetailsDocument, options);
      }
export function useOtcPurchaseDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OtcPurchaseDetailsQuery, OtcPurchaseDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OtcPurchaseDetailsQuery, OtcPurchaseDetailsQueryVariables>(OtcPurchaseDetailsDocument, options);
        }
export function useOtcPurchaseDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OtcPurchaseDetailsQuery, OtcPurchaseDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OtcPurchaseDetailsQuery, OtcPurchaseDetailsQueryVariables>(OtcPurchaseDetailsDocument, options);
        }
export type OtcPurchaseDetailsQueryHookResult = ReturnType<typeof useOtcPurchaseDetailsQuery>;
export type OtcPurchaseDetailsLazyQueryHookResult = ReturnType<typeof useOtcPurchaseDetailsLazyQuery>;
export type OtcPurchaseDetailsSuspenseQueryHookResult = ReturnType<typeof useOtcPurchaseDetailsSuspenseQuery>;
export type OtcPurchaseDetailsQueryResult = Apollo.QueryResult<OtcPurchaseDetailsQuery, OtcPurchaseDetailsQueryVariables>;
export const DiscountCodeDocument = gql`
    query DiscountCode($code: String!, $checkoutStage: DiscountStage, $productIds: [String!]!, $skipProductValidation: Boolean!) {
  discountCode(
    code: $code
    checkoutStage: $checkoutStage
    productIds: $productIds
    skipProductValidation: $skipProductValidation
  ) {
    ...DiscountCodeForm
  }
}
    ${DiscountCodeFormFragmentDoc}`;

/**
 * __useDiscountCodeQuery__
 *
 * To run a query within a React component, call `useDiscountCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscountCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscountCodeQuery({
 *   variables: {
 *      code: // value for 'code'
 *      checkoutStage: // value for 'checkoutStage'
 *      productIds: // value for 'productIds'
 *      skipProductValidation: // value for 'skipProductValidation'
 *   },
 * });
 */
export function useDiscountCodeQuery(baseOptions: Apollo.QueryHookOptions<DiscountCodeQuery, DiscountCodeQueryVariables> & ({ variables: DiscountCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DiscountCodeQuery, DiscountCodeQueryVariables>(DiscountCodeDocument, options);
      }
export function useDiscountCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DiscountCodeQuery, DiscountCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DiscountCodeQuery, DiscountCodeQueryVariables>(DiscountCodeDocument, options);
        }
export function useDiscountCodeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DiscountCodeQuery, DiscountCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DiscountCodeQuery, DiscountCodeQueryVariables>(DiscountCodeDocument, options);
        }
export type DiscountCodeQueryHookResult = ReturnType<typeof useDiscountCodeQuery>;
export type DiscountCodeLazyQueryHookResult = ReturnType<typeof useDiscountCodeLazyQuery>;
export type DiscountCodeSuspenseQueryHookResult = ReturnType<typeof useDiscountCodeSuspenseQuery>;
export type DiscountCodeQueryResult = Apollo.QueryResult<DiscountCodeQuery, DiscountCodeQueryVariables>;
export const PurchaseOrderDocument = gql`
    mutation PurchaseOrder($couponCode: String, $token: String) {
  purchaseOrder(couponCode: $couponCode, token: $token) {
    id
    status
  }
}
    `;
export type PurchaseOrderMutationFn = Apollo.MutationFunction<PurchaseOrderMutation, PurchaseOrderMutationVariables>;

/**
 * __usePurchaseOrderMutation__
 *
 * To run a mutation, you first call `usePurchaseOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [purchaseOrderMutation, { data, loading, error }] = usePurchaseOrderMutation({
 *   variables: {
 *      couponCode: // value for 'couponCode'
 *      token: // value for 'token'
 *   },
 * });
 */
export function usePurchaseOrderMutation(baseOptions?: Apollo.MutationHookOptions<PurchaseOrderMutation, PurchaseOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PurchaseOrderMutation, PurchaseOrderMutationVariables>(PurchaseOrderDocument, options);
      }
export type PurchaseOrderMutationHookResult = ReturnType<typeof usePurchaseOrderMutation>;
export type PurchaseOrderMutationResult = Apollo.MutationResult<PurchaseOrderMutation>;
export type PurchaseOrderMutationOptions = Apollo.BaseMutationOptions<PurchaseOrderMutation, PurchaseOrderMutationVariables>;
export const UpdateOtcShoppingCartDocument = gql`
    mutation UpdateOtcShoppingCart($item: OTCShoppingCartItemInput!) {
  updateOtcShoppingCart(item: $item) {
    ...ShoppingCart
  }
}
    ${ShoppingCartFragmentDoc}`;
export type UpdateOtcShoppingCartMutationFn = Apollo.MutationFunction<UpdateOtcShoppingCartMutation, UpdateOtcShoppingCartMutationVariables>;

/**
 * __useUpdateOtcShoppingCartMutation__
 *
 * To run a mutation, you first call `useUpdateOtcShoppingCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOtcShoppingCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOtcShoppingCartMutation, { data, loading, error }] = useUpdateOtcShoppingCartMutation({
 *   variables: {
 *      item: // value for 'item'
 *   },
 * });
 */
export function useUpdateOtcShoppingCartMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOtcShoppingCartMutation, UpdateOtcShoppingCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOtcShoppingCartMutation, UpdateOtcShoppingCartMutationVariables>(UpdateOtcShoppingCartDocument, options);
      }
export type UpdateOtcShoppingCartMutationHookResult = ReturnType<typeof useUpdateOtcShoppingCartMutation>;
export type UpdateOtcShoppingCartMutationResult = Apollo.MutationResult<UpdateOtcShoppingCartMutation>;
export type UpdateOtcShoppingCartMutationOptions = Apollo.BaseMutationOptions<UpdateOtcShoppingCartMutation, UpdateOtcShoppingCartMutationVariables>;
export const PurchaseOtcShoppingCartDocument = gql`
    mutation PurchaseOtcShoppingCart($cartId: String!, $discountCode: String) {
  purchaseOtcShoppingCart(cartId: $cartId, discountCode: $discountCode) {
    ...ShoppingCart
  }
}
    ${ShoppingCartFragmentDoc}`;
export type PurchaseOtcShoppingCartMutationFn = Apollo.MutationFunction<PurchaseOtcShoppingCartMutation, PurchaseOtcShoppingCartMutationVariables>;

/**
 * __usePurchaseOtcShoppingCartMutation__
 *
 * To run a mutation, you first call `usePurchaseOtcShoppingCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseOtcShoppingCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [purchaseOtcShoppingCartMutation, { data, loading, error }] = usePurchaseOtcShoppingCartMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *      discountCode: // value for 'discountCode'
 *   },
 * });
 */
export function usePurchaseOtcShoppingCartMutation(baseOptions?: Apollo.MutationHookOptions<PurchaseOtcShoppingCartMutation, PurchaseOtcShoppingCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PurchaseOtcShoppingCartMutation, PurchaseOtcShoppingCartMutationVariables>(PurchaseOtcShoppingCartDocument, options);
      }
export type PurchaseOtcShoppingCartMutationHookResult = ReturnType<typeof usePurchaseOtcShoppingCartMutation>;
export type PurchaseOtcShoppingCartMutationResult = Apollo.MutationResult<PurchaseOtcShoppingCartMutation>;
export type PurchaseOtcShoppingCartMutationOptions = Apollo.BaseMutationOptions<PurchaseOtcShoppingCartMutation, PurchaseOtcShoppingCartMutationVariables>;
export const RemoveOtcShoppingCartItemDocument = gql`
    mutation RemoveOtcShoppingCartItem($cartId: String!, $variantId: String!) {
  removeOtcShoppingCartItem(cartId: $cartId, variantId: $variantId) {
    ...ShoppingCart
  }
}
    ${ShoppingCartFragmentDoc}`;
export type RemoveOtcShoppingCartItemMutationFn = Apollo.MutationFunction<RemoveOtcShoppingCartItemMutation, RemoveOtcShoppingCartItemMutationVariables>;

/**
 * __useRemoveOtcShoppingCartItemMutation__
 *
 * To run a mutation, you first call `useRemoveOtcShoppingCartItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveOtcShoppingCartItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeOtcShoppingCartItemMutation, { data, loading, error }] = useRemoveOtcShoppingCartItemMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *      variantId: // value for 'variantId'
 *   },
 * });
 */
export function useRemoveOtcShoppingCartItemMutation(baseOptions?: Apollo.MutationHookOptions<RemoveOtcShoppingCartItemMutation, RemoveOtcShoppingCartItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveOtcShoppingCartItemMutation, RemoveOtcShoppingCartItemMutationVariables>(RemoveOtcShoppingCartItemDocument, options);
      }
export type RemoveOtcShoppingCartItemMutationHookResult = ReturnType<typeof useRemoveOtcShoppingCartItemMutation>;
export type RemoveOtcShoppingCartItemMutationResult = Apollo.MutationResult<RemoveOtcShoppingCartItemMutation>;
export type RemoveOtcShoppingCartItemMutationOptions = Apollo.BaseMutationOptions<RemoveOtcShoppingCartItemMutation, RemoveOtcShoppingCartItemMutationVariables>;
export const OtcShoppingCartDocument = gql`
    query OtcShoppingCart {
  otcShoppingCart {
    ...ShoppingCart
  }
}
    ${ShoppingCartFragmentDoc}`;

/**
 * __useOtcShoppingCartQuery__
 *
 * To run a query within a React component, call `useOtcShoppingCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useOtcShoppingCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOtcShoppingCartQuery({
 *   variables: {
 *   },
 * });
 */
export function useOtcShoppingCartQuery(baseOptions?: Apollo.QueryHookOptions<OtcShoppingCartQuery, OtcShoppingCartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OtcShoppingCartQuery, OtcShoppingCartQueryVariables>(OtcShoppingCartDocument, options);
      }
export function useOtcShoppingCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OtcShoppingCartQuery, OtcShoppingCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OtcShoppingCartQuery, OtcShoppingCartQueryVariables>(OtcShoppingCartDocument, options);
        }
export function useOtcShoppingCartSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OtcShoppingCartQuery, OtcShoppingCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OtcShoppingCartQuery, OtcShoppingCartQueryVariables>(OtcShoppingCartDocument, options);
        }
export type OtcShoppingCartQueryHookResult = ReturnType<typeof useOtcShoppingCartQuery>;
export type OtcShoppingCartLazyQueryHookResult = ReturnType<typeof useOtcShoppingCartLazyQuery>;
export type OtcShoppingCartSuspenseQueryHookResult = ReturnType<typeof useOtcShoppingCartSuspenseQuery>;
export type OtcShoppingCartQueryResult = Apollo.QueryResult<OtcShoppingCartQuery, OtcShoppingCartQueryVariables>;
export const ConfirmPathologyDocument = gql`
    query ConfirmPathology($consultationId: String!) {
  consultation(id: $consultationId) {
    id
    type
    doctor {
      id
      fullName
      fullClinicianName
      shortClinicianName
      lastName
      avatar {
        id
        url
      }
      bio
      provider {
        id
        clinicianTitle
        qualifications
      }
    }
    pathologyRequests {
      id
      createdAt
      customerStatedCollectedAt
      referral {
        id
        signedUrl
      }
    }
  }
  customerAttributes {
    id
    diabetesRisk {
      diabetesRiskLevel
      diabetesRiskProbability
    }
  }
}
    `;

/**
 * __useConfirmPathologyQuery__
 *
 * To run a query within a React component, call `useConfirmPathologyQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfirmPathologyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfirmPathologyQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function useConfirmPathologyQuery(baseOptions: Apollo.QueryHookOptions<ConfirmPathologyQuery, ConfirmPathologyQueryVariables> & ({ variables: ConfirmPathologyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConfirmPathologyQuery, ConfirmPathologyQueryVariables>(ConfirmPathologyDocument, options);
      }
export function useConfirmPathologyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConfirmPathologyQuery, ConfirmPathologyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConfirmPathologyQuery, ConfirmPathologyQueryVariables>(ConfirmPathologyDocument, options);
        }
export function useConfirmPathologySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ConfirmPathologyQuery, ConfirmPathologyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConfirmPathologyQuery, ConfirmPathologyQueryVariables>(ConfirmPathologyDocument, options);
        }
export type ConfirmPathologyQueryHookResult = ReturnType<typeof useConfirmPathologyQuery>;
export type ConfirmPathologyLazyQueryHookResult = ReturnType<typeof useConfirmPathologyLazyQuery>;
export type ConfirmPathologySuspenseQueryHookResult = ReturnType<typeof useConfirmPathologySuspenseQuery>;
export type ConfirmPathologyQueryResult = Apollo.QueryResult<ConfirmPathologyQuery, ConfirmPathologyQueryVariables>;
export const ChatPageDocument = gql`
    query ChatPage($consultationId: String!) {
  consultation(id: $consultationId) {
    id
    doctor {
      ...DoctorInfo
    }
    chatThread {
      id
    }
  }
}
    ${DoctorInfoFragmentDoc}`;

/**
 * __useChatPageQuery__
 *
 * To run a query within a React component, call `useChatPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatPageQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function useChatPageQuery(baseOptions: Apollo.QueryHookOptions<ChatPageQuery, ChatPageQueryVariables> & ({ variables: ChatPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChatPageQuery, ChatPageQueryVariables>(ChatPageDocument, options);
      }
export function useChatPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChatPageQuery, ChatPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChatPageQuery, ChatPageQueryVariables>(ChatPageDocument, options);
        }
export function useChatPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ChatPageQuery, ChatPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChatPageQuery, ChatPageQueryVariables>(ChatPageDocument, options);
        }
export type ChatPageQueryHookResult = ReturnType<typeof useChatPageQuery>;
export type ChatPageLazyQueryHookResult = ReturnType<typeof useChatPageLazyQuery>;
export type ChatPageSuspenseQueryHookResult = ReturnType<typeof useChatPageSuspenseQuery>;
export type ChatPageQueryResult = Apollo.QueryResult<ChatPageQuery, ChatPageQueryVariables>;
export const ConsultationPlanDocument = gql`
    query ConsultationPlan($consultationId: String!) {
  consultation(id: $consultationId) {
    id
    isUpfrontPayment
    typeIsFlexi
    completedAt
    doctor {
      id
      fullName
      fullClinicianName
      shortClinicianName
      lastName
      avatar {
        id
        url
      }
    }
    patientNotes
    customer {
      id
      firstName
    }
    treatment {
      id
      status
      product {
        id
        plan {
          id
          interval
          intervalCount
        }
        variants {
          id
          isRefill
          price
          inventory {
            id
            sku
          }
        }
        photo {
          id
          url
        }
        name
        friendlyName
        shortDescription
        faqs {
          id
          title
          markdown
        }
      }
      experimentAvailablePaymentPlans {
        paymentPlan
      }
    }
  }
  customerAttributes {
    id
    menopause {
      menopauseSymptoms
    }
  }
  inBatchingExperimentSegment: inSegment(
    segmentName: PRICING_BATCHING_EXPERIMENT_VARIATION
  )
}
    `;

/**
 * __useConsultationPlanQuery__
 *
 * To run a query within a React component, call `useConsultationPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultationPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultationPlanQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function useConsultationPlanQuery(baseOptions: Apollo.QueryHookOptions<ConsultationPlanQuery, ConsultationPlanQueryVariables> & ({ variables: ConsultationPlanQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConsultationPlanQuery, ConsultationPlanQueryVariables>(ConsultationPlanDocument, options);
      }
export function useConsultationPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConsultationPlanQuery, ConsultationPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConsultationPlanQuery, ConsultationPlanQueryVariables>(ConsultationPlanDocument, options);
        }
export function useConsultationPlanSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ConsultationPlanQuery, ConsultationPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConsultationPlanQuery, ConsultationPlanQueryVariables>(ConsultationPlanDocument, options);
        }
export type ConsultationPlanQueryHookResult = ReturnType<typeof useConsultationPlanQuery>;
export type ConsultationPlanLazyQueryHookResult = ReturnType<typeof useConsultationPlanLazyQuery>;
export type ConsultationPlanSuspenseQueryHookResult = ReturnType<typeof useConsultationPlanSuspenseQuery>;
export type ConsultationPlanQueryResult = Apollo.QueryResult<ConsultationPlanQuery, ConsultationPlanQueryVariables>;
export const DoctorsNotePageDocument = gql`
    query DoctorsNotePage($consultationId: String!) {
  consultation(id: $consultationId) {
    id
    status
    type
    doctor {
      id
      avatar {
        id
        url
      }
      provider {
        id
        clinicianTitle
        qualifications
      }
      shortClinicianName
      fullClinicianName
      bio
    }
    completedAt
    treatment {
      id
      createdAt
      updatedAt
      product {
        id
        faqs {
          id
          markdown
          title
        }
      }
    }
    patientNotes
  }
}
    `;

/**
 * __useDoctorsNotePageQuery__
 *
 * To run a query within a React component, call `useDoctorsNotePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorsNotePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorsNotePageQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function useDoctorsNotePageQuery(baseOptions: Apollo.QueryHookOptions<DoctorsNotePageQuery, DoctorsNotePageQueryVariables> & ({ variables: DoctorsNotePageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorsNotePageQuery, DoctorsNotePageQueryVariables>(DoctorsNotePageDocument, options);
      }
export function useDoctorsNotePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorsNotePageQuery, DoctorsNotePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorsNotePageQuery, DoctorsNotePageQueryVariables>(DoctorsNotePageDocument, options);
        }
export function useDoctorsNotePageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DoctorsNotePageQuery, DoctorsNotePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorsNotePageQuery, DoctorsNotePageQueryVariables>(DoctorsNotePageDocument, options);
        }
export type DoctorsNotePageQueryHookResult = ReturnType<typeof useDoctorsNotePageQuery>;
export type DoctorsNotePageLazyQueryHookResult = ReturnType<typeof useDoctorsNotePageLazyQuery>;
export type DoctorsNotePageSuspenseQueryHookResult = ReturnType<typeof useDoctorsNotePageSuspenseQuery>;
export type DoctorsNotePageQueryResult = Apollo.QueryResult<DoctorsNotePageQuery, DoctorsNotePageQueryVariables>;
export const PharmacyInformationPageTemplateDocument = gql`
    query PharmacyInformationPageTemplate($id: String!) {
  consultation(id: $id) {
    id
    customer {
      id
      firstName
      healthCareDetails {
        id
        hasIndividualHealthcareIdentifier
      }
    }
    treatment {
      id
      status
      weightTreatmentCategory
      product {
        ...PharmacyInformationPageProduct
      }
    }
  }
}
    ${PharmacyInformationPageProductFragmentDoc}`;

/**
 * __usePharmacyInformationPageTemplateQuery__
 *
 * To run a query within a React component, call `usePharmacyInformationPageTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `usePharmacyInformationPageTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePharmacyInformationPageTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePharmacyInformationPageTemplateQuery(baseOptions: Apollo.QueryHookOptions<PharmacyInformationPageTemplateQuery, PharmacyInformationPageTemplateQueryVariables> & ({ variables: PharmacyInformationPageTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PharmacyInformationPageTemplateQuery, PharmacyInformationPageTemplateQueryVariables>(PharmacyInformationPageTemplateDocument, options);
      }
export function usePharmacyInformationPageTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PharmacyInformationPageTemplateQuery, PharmacyInformationPageTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PharmacyInformationPageTemplateQuery, PharmacyInformationPageTemplateQueryVariables>(PharmacyInformationPageTemplateDocument, options);
        }
export function usePharmacyInformationPageTemplateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PharmacyInformationPageTemplateQuery, PharmacyInformationPageTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PharmacyInformationPageTemplateQuery, PharmacyInformationPageTemplateQueryVariables>(PharmacyInformationPageTemplateDocument, options);
        }
export type PharmacyInformationPageTemplateQueryHookResult = ReturnType<typeof usePharmacyInformationPageTemplateQuery>;
export type PharmacyInformationPageTemplateLazyQueryHookResult = ReturnType<typeof usePharmacyInformationPageTemplateLazyQuery>;
export type PharmacyInformationPageTemplateSuspenseQueryHookResult = ReturnType<typeof usePharmacyInformationPageTemplateSuspenseQuery>;
export type PharmacyInformationPageTemplateQueryResult = Apollo.QueryResult<PharmacyInformationPageTemplateQuery, PharmacyInformationPageTemplateQueryVariables>;
export const NextUnreadEducationReadingDocument = gql`
    query NextUnreadEducationReading($id: ID!) {
  educationProgram(id: $id) {
    id
    nextUnreadReading {
      id
      content
      startedAt
      timeToReadMs
    }
  }
}
    `;

/**
 * __useNextUnreadEducationReadingQuery__
 *
 * To run a query within a React component, call `useNextUnreadEducationReadingQuery` and pass it any options that fit your needs.
 * When your component renders, `useNextUnreadEducationReadingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNextUnreadEducationReadingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useNextUnreadEducationReadingQuery(baseOptions: Apollo.QueryHookOptions<NextUnreadEducationReadingQuery, NextUnreadEducationReadingQueryVariables> & ({ variables: NextUnreadEducationReadingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NextUnreadEducationReadingQuery, NextUnreadEducationReadingQueryVariables>(NextUnreadEducationReadingDocument, options);
      }
export function useNextUnreadEducationReadingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NextUnreadEducationReadingQuery, NextUnreadEducationReadingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NextUnreadEducationReadingQuery, NextUnreadEducationReadingQueryVariables>(NextUnreadEducationReadingDocument, options);
        }
export function useNextUnreadEducationReadingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NextUnreadEducationReadingQuery, NextUnreadEducationReadingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NextUnreadEducationReadingQuery, NextUnreadEducationReadingQueryVariables>(NextUnreadEducationReadingDocument, options);
        }
export type NextUnreadEducationReadingQueryHookResult = ReturnType<typeof useNextUnreadEducationReadingQuery>;
export type NextUnreadEducationReadingLazyQueryHookResult = ReturnType<typeof useNextUnreadEducationReadingLazyQuery>;
export type NextUnreadEducationReadingSuspenseQueryHookResult = ReturnType<typeof useNextUnreadEducationReadingSuspenseQuery>;
export type NextUnreadEducationReadingQueryResult = Apollo.QueryResult<NextUnreadEducationReadingQuery, NextUnreadEducationReadingQueryVariables>;
export const MarkEducationReadingStartedDocument = gql`
    mutation MarkEducationReadingStarted($readingId: ID!) {
  markEducationReadingStarted(readingId: $readingId) {
    id
  }
}
    `;
export type MarkEducationReadingStartedMutationFn = Apollo.MutationFunction<MarkEducationReadingStartedMutation, MarkEducationReadingStartedMutationVariables>;

/**
 * __useMarkEducationReadingStartedMutation__
 *
 * To run a mutation, you first call `useMarkEducationReadingStartedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkEducationReadingStartedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markEducationReadingStartedMutation, { data, loading, error }] = useMarkEducationReadingStartedMutation({
 *   variables: {
 *      readingId: // value for 'readingId'
 *   },
 * });
 */
export function useMarkEducationReadingStartedMutation(baseOptions?: Apollo.MutationHookOptions<MarkEducationReadingStartedMutation, MarkEducationReadingStartedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkEducationReadingStartedMutation, MarkEducationReadingStartedMutationVariables>(MarkEducationReadingStartedDocument, options);
      }
export type MarkEducationReadingStartedMutationHookResult = ReturnType<typeof useMarkEducationReadingStartedMutation>;
export type MarkEducationReadingStartedMutationResult = Apollo.MutationResult<MarkEducationReadingStartedMutation>;
export type MarkEducationReadingStartedMutationOptions = Apollo.BaseMutationOptions<MarkEducationReadingStartedMutation, MarkEducationReadingStartedMutationVariables>;
export const MarkEducationReadingCompletedDocument = gql`
    mutation MarkEducationReadingCompleted($readingId: ID!) {
  markEducationReadingCompleted(readingId: $readingId) {
    id
  }
}
    `;
export type MarkEducationReadingCompletedMutationFn = Apollo.MutationFunction<MarkEducationReadingCompletedMutation, MarkEducationReadingCompletedMutationVariables>;

/**
 * __useMarkEducationReadingCompletedMutation__
 *
 * To run a mutation, you first call `useMarkEducationReadingCompletedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkEducationReadingCompletedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markEducationReadingCompletedMutation, { data, loading, error }] = useMarkEducationReadingCompletedMutation({
 *   variables: {
 *      readingId: // value for 'readingId'
 *   },
 * });
 */
export function useMarkEducationReadingCompletedMutation(baseOptions?: Apollo.MutationHookOptions<MarkEducationReadingCompletedMutation, MarkEducationReadingCompletedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkEducationReadingCompletedMutation, MarkEducationReadingCompletedMutationVariables>(MarkEducationReadingCompletedDocument, options);
      }
export type MarkEducationReadingCompletedMutationHookResult = ReturnType<typeof useMarkEducationReadingCompletedMutation>;
export type MarkEducationReadingCompletedMutationResult = Apollo.MutationResult<MarkEducationReadingCompletedMutation>;
export type MarkEducationReadingCompletedMutationOptions = Apollo.BaseMutationOptions<MarkEducationReadingCompletedMutation, MarkEducationReadingCompletedMutationVariables>;
export const EducationReadingDocument = gql`
    query EducationReading($id: ID!) {
  educationReading(id: $id) {
    id
    content
    completedAt
    startedAt
    timeToReadMs
  }
}
    `;

/**
 * __useEducationReadingQuery__
 *
 * To run a query within a React component, call `useEducationReadingQuery` and pass it any options that fit your needs.
 * When your component renders, `useEducationReadingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEducationReadingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEducationReadingQuery(baseOptions: Apollo.QueryHookOptions<EducationReadingQuery, EducationReadingQueryVariables> & ({ variables: EducationReadingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EducationReadingQuery, EducationReadingQueryVariables>(EducationReadingDocument, options);
      }
export function useEducationReadingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EducationReadingQuery, EducationReadingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EducationReadingQuery, EducationReadingQueryVariables>(EducationReadingDocument, options);
        }
export function useEducationReadingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EducationReadingQuery, EducationReadingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EducationReadingQuery, EducationReadingQueryVariables>(EducationReadingDocument, options);
        }
export type EducationReadingQueryHookResult = ReturnType<typeof useEducationReadingQuery>;
export type EducationReadingLazyQueryHookResult = ReturnType<typeof useEducationReadingLazyQuery>;
export type EducationReadingSuspenseQueryHookResult = ReturnType<typeof useEducationReadingSuspenseQuery>;
export type EducationReadingQueryResult = Apollo.QueryResult<EducationReadingQuery, EducationReadingQueryVariables>;
export const EducationProgramDocument = gql`
    query EducationProgram($id: ID!) {
  educationProgram(id: $id) {
    id
    name
    nextUnreadReading {
      id
      content
      startedAt
      readStatus
      timeToReadMs
    }
    modules {
      id
      name
      description
      readings {
        id
        content
        readStatus
        timeToReadMs
      }
    }
  }
}
    `;

/**
 * __useEducationProgramQuery__
 *
 * To run a query within a React component, call `useEducationProgramQuery` and pass it any options that fit your needs.
 * When your component renders, `useEducationProgramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEducationProgramQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEducationProgramQuery(baseOptions: Apollo.QueryHookOptions<EducationProgramQuery, EducationProgramQueryVariables> & ({ variables: EducationProgramQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EducationProgramQuery, EducationProgramQueryVariables>(EducationProgramDocument, options);
      }
export function useEducationProgramLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EducationProgramQuery, EducationProgramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EducationProgramQuery, EducationProgramQueryVariables>(EducationProgramDocument, options);
        }
export function useEducationProgramSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EducationProgramQuery, EducationProgramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EducationProgramQuery, EducationProgramQueryVariables>(EducationProgramDocument, options);
        }
export type EducationProgramQueryHookResult = ReturnType<typeof useEducationProgramQuery>;
export type EducationProgramLazyQueryHookResult = ReturnType<typeof useEducationProgramLazyQuery>;
export type EducationProgramSuspenseQueryHookResult = ReturnType<typeof useEducationProgramSuspenseQuery>;
export type EducationProgramQueryResult = Apollo.QueryResult<EducationProgramQuery, EducationProgramQueryVariables>;
export const EducationReadingCollectionDocument = gql`
    query EducationReadingCollection($id: ID!) {
  educationCollection(id: $id) {
    id
    name
    description
    readings {
      id
      content
      completedAt
      startedAt
      timeToReadMs
    }
  }
}
    `;

/**
 * __useEducationReadingCollectionQuery__
 *
 * To run a query within a React component, call `useEducationReadingCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useEducationReadingCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEducationReadingCollectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEducationReadingCollectionQuery(baseOptions: Apollo.QueryHookOptions<EducationReadingCollectionQuery, EducationReadingCollectionQueryVariables> & ({ variables: EducationReadingCollectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EducationReadingCollectionQuery, EducationReadingCollectionQueryVariables>(EducationReadingCollectionDocument, options);
      }
export function useEducationReadingCollectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EducationReadingCollectionQuery, EducationReadingCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EducationReadingCollectionQuery, EducationReadingCollectionQueryVariables>(EducationReadingCollectionDocument, options);
        }
export function useEducationReadingCollectionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EducationReadingCollectionQuery, EducationReadingCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EducationReadingCollectionQuery, EducationReadingCollectionQueryVariables>(EducationReadingCollectionDocument, options);
        }
export type EducationReadingCollectionQueryHookResult = ReturnType<typeof useEducationReadingCollectionQuery>;
export type EducationReadingCollectionLazyQueryHookResult = ReturnType<typeof useEducationReadingCollectionLazyQuery>;
export type EducationReadingCollectionSuspenseQueryHookResult = ReturnType<typeof useEducationReadingCollectionSuspenseQuery>;
export type EducationReadingCollectionQueryResult = Apollo.QueryResult<EducationReadingCollectionQuery, EducationReadingCollectionQueryVariables>;
export const DoctorLetterPageDocument = gql`
    query DoctorLetterPage($consultationId: String!) {
  consultation(id: $consultationId) {
    id
    purchasePrompt {
      id
    }
    patientNotes
    doctor {
      id
      ...DoctorLetterComponent
    }
    prescribedSequence {
      id
      createdAt
      sequence {
        id
        faqs {
          id
          rank
          question
          answerMarkdown
        }
      }
    }
  }
}
    ${DoctorLetterComponentFragmentDoc}`;

/**
 * __useDoctorLetterPageQuery__
 *
 * To run a query within a React component, call `useDoctorLetterPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorLetterPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorLetterPageQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function useDoctorLetterPageQuery(baseOptions: Apollo.QueryHookOptions<DoctorLetterPageQuery, DoctorLetterPageQueryVariables> & ({ variables: DoctorLetterPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorLetterPageQuery, DoctorLetterPageQueryVariables>(DoctorLetterPageDocument, options);
      }
export function useDoctorLetterPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorLetterPageQuery, DoctorLetterPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorLetterPageQuery, DoctorLetterPageQueryVariables>(DoctorLetterPageDocument, options);
        }
export function useDoctorLetterPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DoctorLetterPageQuery, DoctorLetterPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorLetterPageQuery, DoctorLetterPageQueryVariables>(DoctorLetterPageDocument, options);
        }
export type DoctorLetterPageQueryHookResult = ReturnType<typeof useDoctorLetterPageQuery>;
export type DoctorLetterPageLazyQueryHookResult = ReturnType<typeof useDoctorLetterPageLazyQuery>;
export type DoctorLetterPageSuspenseQueryHookResult = ReturnType<typeof useDoctorLetterPageSuspenseQuery>;
export type DoctorLetterPageQueryResult = Apollo.QueryResult<DoctorLetterPageQuery, DoctorLetterPageQueryVariables>;
export const FurPurchaseConfirmAddressRangeDocument = gql`
    query FurPurchaseConfirmAddressRange($line1: String!, $line2: String, $suburb: String!, $postcode: String!) {
  shippingAddressWithinRange(
    line1: $line1
    line2: $line2
    postcode: $postcode
    suburb: $suburb
  )
}
    `;

/**
 * __useFurPurchaseConfirmAddressRangeQuery__
 *
 * To run a query within a React component, call `useFurPurchaseConfirmAddressRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFurPurchaseConfirmAddressRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFurPurchaseConfirmAddressRangeQuery({
 *   variables: {
 *      line1: // value for 'line1'
 *      line2: // value for 'line2'
 *      suburb: // value for 'suburb'
 *      postcode: // value for 'postcode'
 *   },
 * });
 */
export function useFurPurchaseConfirmAddressRangeQuery(baseOptions: Apollo.QueryHookOptions<FurPurchaseConfirmAddressRangeQuery, FurPurchaseConfirmAddressRangeQueryVariables> & ({ variables: FurPurchaseConfirmAddressRangeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FurPurchaseConfirmAddressRangeQuery, FurPurchaseConfirmAddressRangeQueryVariables>(FurPurchaseConfirmAddressRangeDocument, options);
      }
export function useFurPurchaseConfirmAddressRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FurPurchaseConfirmAddressRangeQuery, FurPurchaseConfirmAddressRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FurPurchaseConfirmAddressRangeQuery, FurPurchaseConfirmAddressRangeQueryVariables>(FurPurchaseConfirmAddressRangeDocument, options);
        }
export function useFurPurchaseConfirmAddressRangeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FurPurchaseConfirmAddressRangeQuery, FurPurchaseConfirmAddressRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FurPurchaseConfirmAddressRangeQuery, FurPurchaseConfirmAddressRangeQueryVariables>(FurPurchaseConfirmAddressRangeDocument, options);
        }
export type FurPurchaseConfirmAddressRangeQueryHookResult = ReturnType<typeof useFurPurchaseConfirmAddressRangeQuery>;
export type FurPurchaseConfirmAddressRangeLazyQueryHookResult = ReturnType<typeof useFurPurchaseConfirmAddressRangeLazyQuery>;
export type FurPurchaseConfirmAddressRangeSuspenseQueryHookResult = ReturnType<typeof useFurPurchaseConfirmAddressRangeSuspenseQuery>;
export type FurPurchaseConfirmAddressRangeQueryResult = Apollo.QueryResult<FurPurchaseConfirmAddressRangeQuery, FurPurchaseConfirmAddressRangeQueryVariables>;
export const FollowUpOrReviewPurchaseConfirmDocument = gql`
    query FollowUpOrReviewPurchaseConfirm($consultationId: String!, $offeringSelections: [OfferingSelectionInput!]!, $noSelections: Boolean!, $couponCodes: [String!], $pricingSessionId: ID!) {
  profile {
    id
    address {
      id
      city
      line1
      line2
      state
      country
      postalCode
      prefecture
      municipality
      deliveryInstructions
      townArea
    }
    residentialAddress {
      id
      city
      line1
      line2
      state
      country
      postalCode
      prefecture
      municipality
      townArea
    }
    ...PaymentMethods
  }
  consultation(id: $consultationId) {
    id
    purchasePrompt {
      id
      ... on FurPurchasePrompt {
        proposedOfferingSelection {
          id
          offering {
            id
            friendlyName
            photoUrl
          }
          sequenceSelections {
            id
            sequence {
              id
              products {
                id
                deliveryInformation
              }
              ... on PrescribableSequence {
                addressValidationExempt
              }
            }
            sequenceSet {
              id
            }
          }
        }
      }
    }
  }
  initialPurchasePrice(
    consultationId: $consultationId
    pricingSessionId: $pricingSessionId
    offeringSelections: $offeringSelections
    couponCodes: $couponCodes
  ) @skip(if: $noSelections) {
    id
    amount
    coupons {
      id
      code
      outcome
    }
    originalAmount
    discountAmount
    sessionCreditAmount
  }
  offeringsTimeline(offerings: $offeringSelections) @skip(if: $noSelections) {
    id
    date
    totalAmount
    products {
      id
      friendlyName
      erxMedicines {
        id
        itemForm
        itemStrength
      }
    }
  }
}
    ${PaymentMethodsFragmentDoc}`;

/**
 * __useFollowUpOrReviewPurchaseConfirmQuery__
 *
 * To run a query within a React component, call `useFollowUpOrReviewPurchaseConfirmQuery` and pass it any options that fit your needs.
 * When your component renders, `useFollowUpOrReviewPurchaseConfirmQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFollowUpOrReviewPurchaseConfirmQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *      offeringSelections: // value for 'offeringSelections'
 *      noSelections: // value for 'noSelections'
 *      couponCodes: // value for 'couponCodes'
 *      pricingSessionId: // value for 'pricingSessionId'
 *   },
 * });
 */
export function useFollowUpOrReviewPurchaseConfirmQuery(baseOptions: Apollo.QueryHookOptions<FollowUpOrReviewPurchaseConfirmQuery, FollowUpOrReviewPurchaseConfirmQueryVariables> & ({ variables: FollowUpOrReviewPurchaseConfirmQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FollowUpOrReviewPurchaseConfirmQuery, FollowUpOrReviewPurchaseConfirmQueryVariables>(FollowUpOrReviewPurchaseConfirmDocument, options);
      }
export function useFollowUpOrReviewPurchaseConfirmLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FollowUpOrReviewPurchaseConfirmQuery, FollowUpOrReviewPurchaseConfirmQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FollowUpOrReviewPurchaseConfirmQuery, FollowUpOrReviewPurchaseConfirmQueryVariables>(FollowUpOrReviewPurchaseConfirmDocument, options);
        }
export function useFollowUpOrReviewPurchaseConfirmSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FollowUpOrReviewPurchaseConfirmQuery, FollowUpOrReviewPurchaseConfirmQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FollowUpOrReviewPurchaseConfirmQuery, FollowUpOrReviewPurchaseConfirmQueryVariables>(FollowUpOrReviewPurchaseConfirmDocument, options);
        }
export type FollowUpOrReviewPurchaseConfirmQueryHookResult = ReturnType<typeof useFollowUpOrReviewPurchaseConfirmQuery>;
export type FollowUpOrReviewPurchaseConfirmLazyQueryHookResult = ReturnType<typeof useFollowUpOrReviewPurchaseConfirmLazyQuery>;
export type FollowUpOrReviewPurchaseConfirmSuspenseQueryHookResult = ReturnType<typeof useFollowUpOrReviewPurchaseConfirmSuspenseQuery>;
export type FollowUpOrReviewPurchaseConfirmQueryResult = Apollo.QueryResult<FollowUpOrReviewPurchaseConfirmQuery, FollowUpOrReviewPurchaseConfirmQueryVariables>;
export const FurConfirmInitiateZipCheckoutDocument = gql`
    mutation FurConfirmInitiateZipCheckout($input: InitiateFlexiZipCheckoutInput!) {
  initiateFlexiZipCheckout(input: $input) {
    redirectUrl
  }
}
    `;
export type FurConfirmInitiateZipCheckoutMutationFn = Apollo.MutationFunction<FurConfirmInitiateZipCheckoutMutation, FurConfirmInitiateZipCheckoutMutationVariables>;

/**
 * __useFurConfirmInitiateZipCheckoutMutation__
 *
 * To run a mutation, you first call `useFurConfirmInitiateZipCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFurConfirmInitiateZipCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [furConfirmInitiateZipCheckoutMutation, { data, loading, error }] = useFurConfirmInitiateZipCheckoutMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFurConfirmInitiateZipCheckoutMutation(baseOptions?: Apollo.MutationHookOptions<FurConfirmInitiateZipCheckoutMutation, FurConfirmInitiateZipCheckoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FurConfirmInitiateZipCheckoutMutation, FurConfirmInitiateZipCheckoutMutationVariables>(FurConfirmInitiateZipCheckoutDocument, options);
      }
export type FurConfirmInitiateZipCheckoutMutationHookResult = ReturnType<typeof useFurConfirmInitiateZipCheckoutMutation>;
export type FurConfirmInitiateZipCheckoutMutationResult = Apollo.MutationResult<FurConfirmInitiateZipCheckoutMutation>;
export type FurConfirmInitiateZipCheckoutMutationOptions = Apollo.BaseMutationOptions<FurConfirmInitiateZipCheckoutMutation, FurConfirmInitiateZipCheckoutMutationVariables>;
export const FollowUpOrReviewPurchaseReviewDocument = gql`
    query FollowUpOrReviewPurchaseReview($consultationId: String!, $offeringSelections: [OfferingSelectionInput!]!, $noSelections: Boolean!) {
  profile {
    id
    shortAddressableName
  }
  consultation(id: $consultationId) {
    id
    type
    patientNotes
    doctor {
      fullClinicianName
      ...DoctorInfoComponent
    }
    purchasePrompt {
      id
      ... on FurPurchasePrompt {
        proposedOfferingSelection {
          id
          offering {
            id
            friendlyName
            photoUrl
            advertisedShippingCadence
          }
          sequenceSelections {
            id
            sequence {
              id
              faqs {
                id
                question
                answerMarkdown
                rank
              }
              externalLinks {
                id
                text
                url
              }
            }
            sequenceSet {
              id
            }
          }
        }
      }
    }
  }
  offeringsTimeline(offerings: $offeringSelections) @skip(if: $noSelections) {
    id
    date
    totalAmount
    products {
      id
      friendlyName
      erxMedicines {
        id
        itemForm
        itemStrength
      }
    }
  }
}
    ${DoctorInfoComponentFragmentDoc}`;

/**
 * __useFollowUpOrReviewPurchaseReviewQuery__
 *
 * To run a query within a React component, call `useFollowUpOrReviewPurchaseReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useFollowUpOrReviewPurchaseReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFollowUpOrReviewPurchaseReviewQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *      offeringSelections: // value for 'offeringSelections'
 *      noSelections: // value for 'noSelections'
 *   },
 * });
 */
export function useFollowUpOrReviewPurchaseReviewQuery(baseOptions: Apollo.QueryHookOptions<FollowUpOrReviewPurchaseReviewQuery, FollowUpOrReviewPurchaseReviewQueryVariables> & ({ variables: FollowUpOrReviewPurchaseReviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FollowUpOrReviewPurchaseReviewQuery, FollowUpOrReviewPurchaseReviewQueryVariables>(FollowUpOrReviewPurchaseReviewDocument, options);
      }
export function useFollowUpOrReviewPurchaseReviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FollowUpOrReviewPurchaseReviewQuery, FollowUpOrReviewPurchaseReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FollowUpOrReviewPurchaseReviewQuery, FollowUpOrReviewPurchaseReviewQueryVariables>(FollowUpOrReviewPurchaseReviewDocument, options);
        }
export function useFollowUpOrReviewPurchaseReviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FollowUpOrReviewPurchaseReviewQuery, FollowUpOrReviewPurchaseReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FollowUpOrReviewPurchaseReviewQuery, FollowUpOrReviewPurchaseReviewQueryVariables>(FollowUpOrReviewPurchaseReviewDocument, options);
        }
export type FollowUpOrReviewPurchaseReviewQueryHookResult = ReturnType<typeof useFollowUpOrReviewPurchaseReviewQuery>;
export type FollowUpOrReviewPurchaseReviewLazyQueryHookResult = ReturnType<typeof useFollowUpOrReviewPurchaseReviewLazyQuery>;
export type FollowUpOrReviewPurchaseReviewSuspenseQueryHookResult = ReturnType<typeof useFollowUpOrReviewPurchaseReviewSuspenseQuery>;
export type FollowUpOrReviewPurchaseReviewQueryResult = Apollo.QueryResult<FollowUpOrReviewPurchaseReviewQuery, FollowUpOrReviewPurchaseReviewQueryVariables>;
export const InitialPurchaseConfirmDocument = gql`
    query InitialPurchaseConfirm($consultationId: String!, $pricingSessionId: ID!, $offeringSelections: [OfferingSelectionInput!]!, $noSelections: Boolean!, $couponCodes: [String!], $proposedOfferingSelectionInput: InitialPurchaseProposedOfferingSelectionInput) {
  initialPurchasePrice(
    consultationId: $consultationId
    pricingSessionId: $pricingSessionId
    offeringSelections: $offeringSelections
    couponCodes: $couponCodes
  ) @skip(if: $noSelections) {
    id
    amount
    originalAmount
    coupons {
      id
      code
      outcome
    }
  }
  validPhoneRegions {
    id
    countryCode
  }
  profile {
    id
    email
    phone
    isPasswordSet
    birthday
    lastName
    firstName
    shortAddressableName
    preferredUnitSystem
    address {
      id
      city
      line1
      line2
      state
      country
      postalCode
      prefecture
      municipality
      deliveryInstructions
      townArea
    }
    residentialAddress {
      id
      city
      line1
      line2
      state
      country
      postalCode
      prefecture
      municipality
      townArea
    }
    medicalProfile {
      id
      weight
    }
    ...PaymentMethods
  }
  initialPurchaseConfirmPage(consultationId: $consultationId) {
    id
    faqs {
      id
      question
      answer
    }
  }
  consultation(id: $consultationId) {
    id
    type
    purchasePrompt {
      id
      ... on InitialPurchasePrompt {
        proposedOfferingSelection(input: $proposedOfferingSelectionInput) {
          id
          offering {
            id
            friendlyName
            advertisedShippingCadence
            photoUrl
            tags
            contents {
              id
              rank
              description
            }
          }
          sequenceSelections {
            id
            sequence {
              id
              ... on PrescribableSequence {
                addressValidationExempt
              }
            }
            sequenceSet {
              id
            }
          }
        }
      }
    }
  }
}
    ${PaymentMethodsFragmentDoc}`;

/**
 * __useInitialPurchaseConfirmQuery__
 *
 * To run a query within a React component, call `useInitialPurchaseConfirmQuery` and pass it any options that fit your needs.
 * When your component renders, `useInitialPurchaseConfirmQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInitialPurchaseConfirmQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *      pricingSessionId: // value for 'pricingSessionId'
 *      offeringSelections: // value for 'offeringSelections'
 *      noSelections: // value for 'noSelections'
 *      couponCodes: // value for 'couponCodes'
 *      proposedOfferingSelectionInput: // value for 'proposedOfferingSelectionInput'
 *   },
 * });
 */
export function useInitialPurchaseConfirmQuery(baseOptions: Apollo.QueryHookOptions<InitialPurchaseConfirmQuery, InitialPurchaseConfirmQueryVariables> & ({ variables: InitialPurchaseConfirmQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InitialPurchaseConfirmQuery, InitialPurchaseConfirmQueryVariables>(InitialPurchaseConfirmDocument, options);
      }
export function useInitialPurchaseConfirmLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InitialPurchaseConfirmQuery, InitialPurchaseConfirmQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InitialPurchaseConfirmQuery, InitialPurchaseConfirmQueryVariables>(InitialPurchaseConfirmDocument, options);
        }
export function useInitialPurchaseConfirmSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InitialPurchaseConfirmQuery, InitialPurchaseConfirmQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InitialPurchaseConfirmQuery, InitialPurchaseConfirmQueryVariables>(InitialPurchaseConfirmDocument, options);
        }
export type InitialPurchaseConfirmQueryHookResult = ReturnType<typeof useInitialPurchaseConfirmQuery>;
export type InitialPurchaseConfirmLazyQueryHookResult = ReturnType<typeof useInitialPurchaseConfirmLazyQuery>;
export type InitialPurchaseConfirmSuspenseQueryHookResult = ReturnType<typeof useInitialPurchaseConfirmSuspenseQuery>;
export type InitialPurchaseConfirmQueryResult = Apollo.QueryResult<InitialPurchaseConfirmQuery, InitialPurchaseConfirmQueryVariables>;
export const InitialPurchaseConfirmShippingAddressWithinRangeDocument = gql`
    query InitialPurchaseConfirmShippingAddressWithinRange($line1: String!, $line2: String, $suburb: String!, $postcode: String!) {
  shippingAddressWithinRange(
    line1: $line1
    line2: $line2
    postcode: $postcode
    suburb: $suburb
  )
}
    `;

/**
 * __useInitialPurchaseConfirmShippingAddressWithinRangeQuery__
 *
 * To run a query within a React component, call `useInitialPurchaseConfirmShippingAddressWithinRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useInitialPurchaseConfirmShippingAddressWithinRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInitialPurchaseConfirmShippingAddressWithinRangeQuery({
 *   variables: {
 *      line1: // value for 'line1'
 *      line2: // value for 'line2'
 *      suburb: // value for 'suburb'
 *      postcode: // value for 'postcode'
 *   },
 * });
 */
export function useInitialPurchaseConfirmShippingAddressWithinRangeQuery(baseOptions: Apollo.QueryHookOptions<InitialPurchaseConfirmShippingAddressWithinRangeQuery, InitialPurchaseConfirmShippingAddressWithinRangeQueryVariables> & ({ variables: InitialPurchaseConfirmShippingAddressWithinRangeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InitialPurchaseConfirmShippingAddressWithinRangeQuery, InitialPurchaseConfirmShippingAddressWithinRangeQueryVariables>(InitialPurchaseConfirmShippingAddressWithinRangeDocument, options);
      }
export function useInitialPurchaseConfirmShippingAddressWithinRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InitialPurchaseConfirmShippingAddressWithinRangeQuery, InitialPurchaseConfirmShippingAddressWithinRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InitialPurchaseConfirmShippingAddressWithinRangeQuery, InitialPurchaseConfirmShippingAddressWithinRangeQueryVariables>(InitialPurchaseConfirmShippingAddressWithinRangeDocument, options);
        }
export function useInitialPurchaseConfirmShippingAddressWithinRangeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InitialPurchaseConfirmShippingAddressWithinRangeQuery, InitialPurchaseConfirmShippingAddressWithinRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InitialPurchaseConfirmShippingAddressWithinRangeQuery, InitialPurchaseConfirmShippingAddressWithinRangeQueryVariables>(InitialPurchaseConfirmShippingAddressWithinRangeDocument, options);
        }
export type InitialPurchaseConfirmShippingAddressWithinRangeQueryHookResult = ReturnType<typeof useInitialPurchaseConfirmShippingAddressWithinRangeQuery>;
export type InitialPurchaseConfirmShippingAddressWithinRangeLazyQueryHookResult = ReturnType<typeof useInitialPurchaseConfirmShippingAddressWithinRangeLazyQuery>;
export type InitialPurchaseConfirmShippingAddressWithinRangeSuspenseQueryHookResult = ReturnType<typeof useInitialPurchaseConfirmShippingAddressWithinRangeSuspenseQuery>;
export type InitialPurchaseConfirmShippingAddressWithinRangeQueryResult = Apollo.QueryResult<InitialPurchaseConfirmShippingAddressWithinRangeQuery, InitialPurchaseConfirmShippingAddressWithinRangeQueryVariables>;
export const InitialPurchaseConfirmUpdateProfileDocument = gql`
    mutation InitialPurchaseConfirmUpdateProfile($firstName: String, $lastName: String, $phone: String, $password: String, $birthday: String) {
  updateProfile(
    firstName: $firstName
    lastName: $lastName
    phone: $phone
    password: $password
    birthday: $birthday
  ) {
    id
    firstName
    phone
    birthday
  }
}
    `;
export type InitialPurchaseConfirmUpdateProfileMutationFn = Apollo.MutationFunction<InitialPurchaseConfirmUpdateProfileMutation, InitialPurchaseConfirmUpdateProfileMutationVariables>;

/**
 * __useInitialPurchaseConfirmUpdateProfileMutation__
 *
 * To run a mutation, you first call `useInitialPurchaseConfirmUpdateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitialPurchaseConfirmUpdateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initialPurchaseConfirmUpdateProfileMutation, { data, loading, error }] = useInitialPurchaseConfirmUpdateProfileMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      phone: // value for 'phone'
 *      password: // value for 'password'
 *      birthday: // value for 'birthday'
 *   },
 * });
 */
export function useInitialPurchaseConfirmUpdateProfileMutation(baseOptions?: Apollo.MutationHookOptions<InitialPurchaseConfirmUpdateProfileMutation, InitialPurchaseConfirmUpdateProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitialPurchaseConfirmUpdateProfileMutation, InitialPurchaseConfirmUpdateProfileMutationVariables>(InitialPurchaseConfirmUpdateProfileDocument, options);
      }
export type InitialPurchaseConfirmUpdateProfileMutationHookResult = ReturnType<typeof useInitialPurchaseConfirmUpdateProfileMutation>;
export type InitialPurchaseConfirmUpdateProfileMutationResult = Apollo.MutationResult<InitialPurchaseConfirmUpdateProfileMutation>;
export type InitialPurchaseConfirmUpdateProfileMutationOptions = Apollo.BaseMutationOptions<InitialPurchaseConfirmUpdateProfileMutation, InitialPurchaseConfirmUpdateProfileMutationVariables>;
export const InitialPurchaseConfirmUpdateResidentialAddressDocument = gql`
    mutation InitialPurchaseConfirmUpdateResidentialAddress($residentialAddress: ResidentialAddressCreateInput!) {
  updateResidentialAddress(residentialAddress: $residentialAddress) {
    id
    line1
    line2
    state
    country
    company
    building
    postalCode
    city
  }
}
    `;
export type InitialPurchaseConfirmUpdateResidentialAddressMutationFn = Apollo.MutationFunction<InitialPurchaseConfirmUpdateResidentialAddressMutation, InitialPurchaseConfirmUpdateResidentialAddressMutationVariables>;

/**
 * __useInitialPurchaseConfirmUpdateResidentialAddressMutation__
 *
 * To run a mutation, you first call `useInitialPurchaseConfirmUpdateResidentialAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitialPurchaseConfirmUpdateResidentialAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initialPurchaseConfirmUpdateResidentialAddressMutation, { data, loading, error }] = useInitialPurchaseConfirmUpdateResidentialAddressMutation({
 *   variables: {
 *      residentialAddress: // value for 'residentialAddress'
 *   },
 * });
 */
export function useInitialPurchaseConfirmUpdateResidentialAddressMutation(baseOptions?: Apollo.MutationHookOptions<InitialPurchaseConfirmUpdateResidentialAddressMutation, InitialPurchaseConfirmUpdateResidentialAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitialPurchaseConfirmUpdateResidentialAddressMutation, InitialPurchaseConfirmUpdateResidentialAddressMutationVariables>(InitialPurchaseConfirmUpdateResidentialAddressDocument, options);
      }
export type InitialPurchaseConfirmUpdateResidentialAddressMutationHookResult = ReturnType<typeof useInitialPurchaseConfirmUpdateResidentialAddressMutation>;
export type InitialPurchaseConfirmUpdateResidentialAddressMutationResult = Apollo.MutationResult<InitialPurchaseConfirmUpdateResidentialAddressMutation>;
export type InitialPurchaseConfirmUpdateResidentialAddressMutationOptions = Apollo.BaseMutationOptions<InitialPurchaseConfirmUpdateResidentialAddressMutation, InitialPurchaseConfirmUpdateResidentialAddressMutationVariables>;
export const InitialPurchaseConfirmUpdateShippingDocument = gql`
    mutation InitialPurchaseConfirmUpdateShipping($shippingAddress: AddressCreateWithoutUserInput!) {
  updateShipping(address: $shippingAddress) {
    id
    address {
      id
      line1
      line2
      state
      country
      company
      building
      postalCode
      city
    }
  }
}
    `;
export type InitialPurchaseConfirmUpdateShippingMutationFn = Apollo.MutationFunction<InitialPurchaseConfirmUpdateShippingMutation, InitialPurchaseConfirmUpdateShippingMutationVariables>;

/**
 * __useInitialPurchaseConfirmUpdateShippingMutation__
 *
 * To run a mutation, you first call `useInitialPurchaseConfirmUpdateShippingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitialPurchaseConfirmUpdateShippingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initialPurchaseConfirmUpdateShippingMutation, { data, loading, error }] = useInitialPurchaseConfirmUpdateShippingMutation({
 *   variables: {
 *      shippingAddress: // value for 'shippingAddress'
 *   },
 * });
 */
export function useInitialPurchaseConfirmUpdateShippingMutation(baseOptions?: Apollo.MutationHookOptions<InitialPurchaseConfirmUpdateShippingMutation, InitialPurchaseConfirmUpdateShippingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitialPurchaseConfirmUpdateShippingMutation, InitialPurchaseConfirmUpdateShippingMutationVariables>(InitialPurchaseConfirmUpdateShippingDocument, options);
      }
export type InitialPurchaseConfirmUpdateShippingMutationHookResult = ReturnType<typeof useInitialPurchaseConfirmUpdateShippingMutation>;
export type InitialPurchaseConfirmUpdateShippingMutationResult = Apollo.MutationResult<InitialPurchaseConfirmUpdateShippingMutation>;
export type InitialPurchaseConfirmUpdateShippingMutationOptions = Apollo.BaseMutationOptions<InitialPurchaseConfirmUpdateShippingMutation, InitialPurchaseConfirmUpdateShippingMutationVariables>;
export const InitialPurchaseConfirmInitiateZipCheckoutDocument = gql`
    mutation InitialPurchaseConfirmInitiateZipCheckout($input: InitiateFlexiZipCheckoutInput!) {
  initiateFlexiZipCheckout(input: $input) {
    redirectUrl
  }
}
    `;
export type InitialPurchaseConfirmInitiateZipCheckoutMutationFn = Apollo.MutationFunction<InitialPurchaseConfirmInitiateZipCheckoutMutation, InitialPurchaseConfirmInitiateZipCheckoutMutationVariables>;

/**
 * __useInitialPurchaseConfirmInitiateZipCheckoutMutation__
 *
 * To run a mutation, you first call `useInitialPurchaseConfirmInitiateZipCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitialPurchaseConfirmInitiateZipCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initialPurchaseConfirmInitiateZipCheckoutMutation, { data, loading, error }] = useInitialPurchaseConfirmInitiateZipCheckoutMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInitialPurchaseConfirmInitiateZipCheckoutMutation(baseOptions?: Apollo.MutationHookOptions<InitialPurchaseConfirmInitiateZipCheckoutMutation, InitialPurchaseConfirmInitiateZipCheckoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitialPurchaseConfirmInitiateZipCheckoutMutation, InitialPurchaseConfirmInitiateZipCheckoutMutationVariables>(InitialPurchaseConfirmInitiateZipCheckoutDocument, options);
      }
export type InitialPurchaseConfirmInitiateZipCheckoutMutationHookResult = ReturnType<typeof useInitialPurchaseConfirmInitiateZipCheckoutMutation>;
export type InitialPurchaseConfirmInitiateZipCheckoutMutationResult = Apollo.MutationResult<InitialPurchaseConfirmInitiateZipCheckoutMutation>;
export type InitialPurchaseConfirmInitiateZipCheckoutMutationOptions = Apollo.BaseMutationOptions<InitialPurchaseConfirmInitiateZipCheckoutMutation, InitialPurchaseConfirmInitiateZipCheckoutMutationVariables>;
export const OrderConfirmedPageDocument = gql`
    query OrderConfirmedPage($consultationId: String!) {
  profile {
    id
    email
  }
  consultation(id: $consultationId) {
    id
    status
  }
}
    `;

/**
 * __useOrderConfirmedPageQuery__
 *
 * To run a query within a React component, call `useOrderConfirmedPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderConfirmedPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderConfirmedPageQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function useOrderConfirmedPageQuery(baseOptions: Apollo.QueryHookOptions<OrderConfirmedPageQuery, OrderConfirmedPageQueryVariables> & ({ variables: OrderConfirmedPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderConfirmedPageQuery, OrderConfirmedPageQueryVariables>(OrderConfirmedPageDocument, options);
      }
export function useOrderConfirmedPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderConfirmedPageQuery, OrderConfirmedPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderConfirmedPageQuery, OrderConfirmedPageQueryVariables>(OrderConfirmedPageDocument, options);
        }
export function useOrderConfirmedPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrderConfirmedPageQuery, OrderConfirmedPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderConfirmedPageQuery, OrderConfirmedPageQueryVariables>(OrderConfirmedPageDocument, options);
        }
export type OrderConfirmedPageQueryHookResult = ReturnType<typeof useOrderConfirmedPageQuery>;
export type OrderConfirmedPageLazyQueryHookResult = ReturnType<typeof useOrderConfirmedPageLazyQuery>;
export type OrderConfirmedPageSuspenseQueryHookResult = ReturnType<typeof useOrderConfirmedPageSuspenseQuery>;
export type OrderConfirmedPageQueryResult = Apollo.QueryResult<OrderConfirmedPageQuery, OrderConfirmedPageQueryVariables>;
export const PurchaseActivationFlowShippingAddressWithinRangeDocument = gql`
    query PurchaseActivationFlowShippingAddressWithinRange($line1: String!, $line2: String, $suburb: String!, $postcode: String!) {
  shippingAddressWithinRange(
    line1: $line1
    line2: $line2
    postcode: $postcode
    suburb: $suburb
  )
}
    `;

/**
 * __usePurchaseActivationFlowShippingAddressWithinRangeQuery__
 *
 * To run a query within a React component, call `usePurchaseActivationFlowShippingAddressWithinRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `usePurchaseActivationFlowShippingAddressWithinRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePurchaseActivationFlowShippingAddressWithinRangeQuery({
 *   variables: {
 *      line1: // value for 'line1'
 *      line2: // value for 'line2'
 *      suburb: // value for 'suburb'
 *      postcode: // value for 'postcode'
 *   },
 * });
 */
export function usePurchaseActivationFlowShippingAddressWithinRangeQuery(baseOptions: Apollo.QueryHookOptions<PurchaseActivationFlowShippingAddressWithinRangeQuery, PurchaseActivationFlowShippingAddressWithinRangeQueryVariables> & ({ variables: PurchaseActivationFlowShippingAddressWithinRangeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PurchaseActivationFlowShippingAddressWithinRangeQuery, PurchaseActivationFlowShippingAddressWithinRangeQueryVariables>(PurchaseActivationFlowShippingAddressWithinRangeDocument, options);
      }
export function usePurchaseActivationFlowShippingAddressWithinRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PurchaseActivationFlowShippingAddressWithinRangeQuery, PurchaseActivationFlowShippingAddressWithinRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PurchaseActivationFlowShippingAddressWithinRangeQuery, PurchaseActivationFlowShippingAddressWithinRangeQueryVariables>(PurchaseActivationFlowShippingAddressWithinRangeDocument, options);
        }
export function usePurchaseActivationFlowShippingAddressWithinRangeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PurchaseActivationFlowShippingAddressWithinRangeQuery, PurchaseActivationFlowShippingAddressWithinRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PurchaseActivationFlowShippingAddressWithinRangeQuery, PurchaseActivationFlowShippingAddressWithinRangeQueryVariables>(PurchaseActivationFlowShippingAddressWithinRangeDocument, options);
        }
export type PurchaseActivationFlowShippingAddressWithinRangeQueryHookResult = ReturnType<typeof usePurchaseActivationFlowShippingAddressWithinRangeQuery>;
export type PurchaseActivationFlowShippingAddressWithinRangeLazyQueryHookResult = ReturnType<typeof usePurchaseActivationFlowShippingAddressWithinRangeLazyQuery>;
export type PurchaseActivationFlowShippingAddressWithinRangeSuspenseQueryHookResult = ReturnType<typeof usePurchaseActivationFlowShippingAddressWithinRangeSuspenseQuery>;
export type PurchaseActivationFlowShippingAddressWithinRangeQueryResult = Apollo.QueryResult<PurchaseActivationFlowShippingAddressWithinRangeQuery, PurchaseActivationFlowShippingAddressWithinRangeQueryVariables>;
export const PurchaseActivationFlowAddDetailsSectionDocument = gql`
    query PurchaseActivationFlowAddDetailsSection {
  profile {
    id
    email
    phone
    weightTreatmentCategory
    address {
      id
      line1
      line2
      city
      postalCode
      country
      state
      prefecture
      municipality
      townArea
      company
      building
    }
  }
  validPhoneRegions {
    id
    countryCode
  }
}
    `;

/**
 * __usePurchaseActivationFlowAddDetailsSectionQuery__
 *
 * To run a query within a React component, call `usePurchaseActivationFlowAddDetailsSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePurchaseActivationFlowAddDetailsSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePurchaseActivationFlowAddDetailsSectionQuery({
 *   variables: {
 *   },
 * });
 */
export function usePurchaseActivationFlowAddDetailsSectionQuery(baseOptions?: Apollo.QueryHookOptions<PurchaseActivationFlowAddDetailsSectionQuery, PurchaseActivationFlowAddDetailsSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PurchaseActivationFlowAddDetailsSectionQuery, PurchaseActivationFlowAddDetailsSectionQueryVariables>(PurchaseActivationFlowAddDetailsSectionDocument, options);
      }
export function usePurchaseActivationFlowAddDetailsSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PurchaseActivationFlowAddDetailsSectionQuery, PurchaseActivationFlowAddDetailsSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PurchaseActivationFlowAddDetailsSectionQuery, PurchaseActivationFlowAddDetailsSectionQueryVariables>(PurchaseActivationFlowAddDetailsSectionDocument, options);
        }
export function usePurchaseActivationFlowAddDetailsSectionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PurchaseActivationFlowAddDetailsSectionQuery, PurchaseActivationFlowAddDetailsSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PurchaseActivationFlowAddDetailsSectionQuery, PurchaseActivationFlowAddDetailsSectionQueryVariables>(PurchaseActivationFlowAddDetailsSectionDocument, options);
        }
export type PurchaseActivationFlowAddDetailsSectionQueryHookResult = ReturnType<typeof usePurchaseActivationFlowAddDetailsSectionQuery>;
export type PurchaseActivationFlowAddDetailsSectionLazyQueryHookResult = ReturnType<typeof usePurchaseActivationFlowAddDetailsSectionLazyQuery>;
export type PurchaseActivationFlowAddDetailsSectionSuspenseQueryHookResult = ReturnType<typeof usePurchaseActivationFlowAddDetailsSectionSuspenseQuery>;
export type PurchaseActivationFlowAddDetailsSectionQueryResult = Apollo.QueryResult<PurchaseActivationFlowAddDetailsSectionQuery, PurchaseActivationFlowAddDetailsSectionQueryVariables>;
export const PurchaseActivationFlowUpdateDetailsDocument = gql`
    mutation PurchaseActivationFlowUpdateDetails($phone: String, $updatePhone: Boolean!, $address: AddressCreateWithoutUserInput, $updateAddress: Boolean!) {
  updateShipping(address: $address) @include(if: $updateAddress) {
    id
    address {
      id
      line1
      line2
      city
      postalCode
      country
      state
      prefecture
      municipality
      townArea
      company
      building
    }
  }
  updateProfile(phone: $phone) @include(if: $updatePhone) {
    id
    phone
  }
}
    `;
export type PurchaseActivationFlowUpdateDetailsMutationFn = Apollo.MutationFunction<PurchaseActivationFlowUpdateDetailsMutation, PurchaseActivationFlowUpdateDetailsMutationVariables>;

/**
 * __usePurchaseActivationFlowUpdateDetailsMutation__
 *
 * To run a mutation, you first call `usePurchaseActivationFlowUpdateDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseActivationFlowUpdateDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [purchaseActivationFlowUpdateDetailsMutation, { data, loading, error }] = usePurchaseActivationFlowUpdateDetailsMutation({
 *   variables: {
 *      phone: // value for 'phone'
 *      updatePhone: // value for 'updatePhone'
 *      address: // value for 'address'
 *      updateAddress: // value for 'updateAddress'
 *   },
 * });
 */
export function usePurchaseActivationFlowUpdateDetailsMutation(baseOptions?: Apollo.MutationHookOptions<PurchaseActivationFlowUpdateDetailsMutation, PurchaseActivationFlowUpdateDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PurchaseActivationFlowUpdateDetailsMutation, PurchaseActivationFlowUpdateDetailsMutationVariables>(PurchaseActivationFlowUpdateDetailsDocument, options);
      }
export type PurchaseActivationFlowUpdateDetailsMutationHookResult = ReturnType<typeof usePurchaseActivationFlowUpdateDetailsMutation>;
export type PurchaseActivationFlowUpdateDetailsMutationResult = Apollo.MutationResult<PurchaseActivationFlowUpdateDetailsMutation>;
export type PurchaseActivationFlowUpdateDetailsMutationOptions = Apollo.BaseMutationOptions<PurchaseActivationFlowUpdateDetailsMutation, PurchaseActivationFlowUpdateDetailsMutationVariables>;
export const PurchaseActivationFlowAddonPriceDocument = gql`
    query PurchaseActivationFlowAddonPrice($pricingSessionId: ID!, $offeringSelections: [OfferingSelectionInput!]!) {
  initialPurchasePrice(
    pricingSessionId: $pricingSessionId
    offeringSelections: $offeringSelections
  ) {
    id
    amount
  }
}
    `;

/**
 * __usePurchaseActivationFlowAddonPriceQuery__
 *
 * To run a query within a React component, call `usePurchaseActivationFlowAddonPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `usePurchaseActivationFlowAddonPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePurchaseActivationFlowAddonPriceQuery({
 *   variables: {
 *      pricingSessionId: // value for 'pricingSessionId'
 *      offeringSelections: // value for 'offeringSelections'
 *   },
 * });
 */
export function usePurchaseActivationFlowAddonPriceQuery(baseOptions: Apollo.QueryHookOptions<PurchaseActivationFlowAddonPriceQuery, PurchaseActivationFlowAddonPriceQueryVariables> & ({ variables: PurchaseActivationFlowAddonPriceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PurchaseActivationFlowAddonPriceQuery, PurchaseActivationFlowAddonPriceQueryVariables>(PurchaseActivationFlowAddonPriceDocument, options);
      }
export function usePurchaseActivationFlowAddonPriceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PurchaseActivationFlowAddonPriceQuery, PurchaseActivationFlowAddonPriceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PurchaseActivationFlowAddonPriceQuery, PurchaseActivationFlowAddonPriceQueryVariables>(PurchaseActivationFlowAddonPriceDocument, options);
        }
export function usePurchaseActivationFlowAddonPriceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PurchaseActivationFlowAddonPriceQuery, PurchaseActivationFlowAddonPriceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PurchaseActivationFlowAddonPriceQuery, PurchaseActivationFlowAddonPriceQueryVariables>(PurchaseActivationFlowAddonPriceDocument, options);
        }
export type PurchaseActivationFlowAddonPriceQueryHookResult = ReturnType<typeof usePurchaseActivationFlowAddonPriceQuery>;
export type PurchaseActivationFlowAddonPriceLazyQueryHookResult = ReturnType<typeof usePurchaseActivationFlowAddonPriceLazyQuery>;
export type PurchaseActivationFlowAddonPriceSuspenseQueryHookResult = ReturnType<typeof usePurchaseActivationFlowAddonPriceSuspenseQuery>;
export type PurchaseActivationFlowAddonPriceQueryResult = Apollo.QueryResult<PurchaseActivationFlowAddonPriceQuery, PurchaseActivationFlowAddonPriceQueryVariables>;
export const PurchaseActivationFlowAddonSectionDocument = gql`
    query PurchaseActivationFlowAddonSection($problemType: ProblemType!) {
  pafAddonSection(stage: INITIAL, problemType: $problemType) {
    id
    bannerMarkdown
    shopItems {
      id
      title
      otcOffering {
        id
        advertisedStartingAmount
        photoUrl
        sequenceSets {
          id
          defaultSequence {
            id
          }
        }
      }
      ...AddonDrawerFocusedShopItem
    }
  }
}
    ${AddonDrawerFocusedShopItemFragmentDoc}`;

/**
 * __usePurchaseActivationFlowAddonSectionQuery__
 *
 * To run a query within a React component, call `usePurchaseActivationFlowAddonSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePurchaseActivationFlowAddonSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePurchaseActivationFlowAddonSectionQuery({
 *   variables: {
 *      problemType: // value for 'problemType'
 *   },
 * });
 */
export function usePurchaseActivationFlowAddonSectionQuery(baseOptions: Apollo.QueryHookOptions<PurchaseActivationFlowAddonSectionQuery, PurchaseActivationFlowAddonSectionQueryVariables> & ({ variables: PurchaseActivationFlowAddonSectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PurchaseActivationFlowAddonSectionQuery, PurchaseActivationFlowAddonSectionQueryVariables>(PurchaseActivationFlowAddonSectionDocument, options);
      }
export function usePurchaseActivationFlowAddonSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PurchaseActivationFlowAddonSectionQuery, PurchaseActivationFlowAddonSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PurchaseActivationFlowAddonSectionQuery, PurchaseActivationFlowAddonSectionQueryVariables>(PurchaseActivationFlowAddonSectionDocument, options);
        }
export function usePurchaseActivationFlowAddonSectionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PurchaseActivationFlowAddonSectionQuery, PurchaseActivationFlowAddonSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PurchaseActivationFlowAddonSectionQuery, PurchaseActivationFlowAddonSectionQueryVariables>(PurchaseActivationFlowAddonSectionDocument, options);
        }
export type PurchaseActivationFlowAddonSectionQueryHookResult = ReturnType<typeof usePurchaseActivationFlowAddonSectionQuery>;
export type PurchaseActivationFlowAddonSectionLazyQueryHookResult = ReturnType<typeof usePurchaseActivationFlowAddonSectionLazyQuery>;
export type PurchaseActivationFlowAddonSectionSuspenseQueryHookResult = ReturnType<typeof usePurchaseActivationFlowAddonSectionSuspenseQuery>;
export type PurchaseActivationFlowAddonSectionQueryResult = Apollo.QueryResult<PurchaseActivationFlowAddonSectionQuery, PurchaseActivationFlowAddonSectionQueryVariables>;
export const PurchaseActivationFlowConfirmPurchaseGroupDocument = gql`
    mutation PurchaseActivationFlowConfirmPurchaseGroup($input: ConfirmPurchaseGroupInput!) {
  confirmPurchaseGroup(input: $input) {
    purchaseGroup {
      id
    }
  }
}
    `;
export type PurchaseActivationFlowConfirmPurchaseGroupMutationFn = Apollo.MutationFunction<PurchaseActivationFlowConfirmPurchaseGroupMutation, PurchaseActivationFlowConfirmPurchaseGroupMutationVariables>;

/**
 * __usePurchaseActivationFlowConfirmPurchaseGroupMutation__
 *
 * To run a mutation, you first call `usePurchaseActivationFlowConfirmPurchaseGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseActivationFlowConfirmPurchaseGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [purchaseActivationFlowConfirmPurchaseGroupMutation, { data, loading, error }] = usePurchaseActivationFlowConfirmPurchaseGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePurchaseActivationFlowConfirmPurchaseGroupMutation(baseOptions?: Apollo.MutationHookOptions<PurchaseActivationFlowConfirmPurchaseGroupMutation, PurchaseActivationFlowConfirmPurchaseGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PurchaseActivationFlowConfirmPurchaseGroupMutation, PurchaseActivationFlowConfirmPurchaseGroupMutationVariables>(PurchaseActivationFlowConfirmPurchaseGroupDocument, options);
      }
export type PurchaseActivationFlowConfirmPurchaseGroupMutationHookResult = ReturnType<typeof usePurchaseActivationFlowConfirmPurchaseGroupMutation>;
export type PurchaseActivationFlowConfirmPurchaseGroupMutationResult = Apollo.MutationResult<PurchaseActivationFlowConfirmPurchaseGroupMutation>;
export type PurchaseActivationFlowConfirmPurchaseGroupMutationOptions = Apollo.BaseMutationOptions<PurchaseActivationFlowConfirmPurchaseGroupMutation, PurchaseActivationFlowConfirmPurchaseGroupMutationVariables>;
export const PurchaseActivationFlowConfirmSectionDocument = gql`
    query PurchaseActivationFlowConfirmSection($consultationId: String!) {
  profile {
    id
    ...ContactInfo
    ...ShippingAddress
    ...PaymentMethods
  }
  validPhoneRegions {
    id
    countryCode
  }
  consultation(id: $consultationId) {
    id
    purchasePrompt {
      id
      ... on ConfirmPurchasePrompt {
        purchaseGroup {
          id
        }
      }
    }
  }
}
    ${ContactInfoFragmentDoc}
${ShippingAddressFragmentDoc}
${PaymentMethodsFragmentDoc}`;

/**
 * __usePurchaseActivationFlowConfirmSectionQuery__
 *
 * To run a query within a React component, call `usePurchaseActivationFlowConfirmSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePurchaseActivationFlowConfirmSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePurchaseActivationFlowConfirmSectionQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function usePurchaseActivationFlowConfirmSectionQuery(baseOptions: Apollo.QueryHookOptions<PurchaseActivationFlowConfirmSectionQuery, PurchaseActivationFlowConfirmSectionQueryVariables> & ({ variables: PurchaseActivationFlowConfirmSectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PurchaseActivationFlowConfirmSectionQuery, PurchaseActivationFlowConfirmSectionQueryVariables>(PurchaseActivationFlowConfirmSectionDocument, options);
      }
export function usePurchaseActivationFlowConfirmSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PurchaseActivationFlowConfirmSectionQuery, PurchaseActivationFlowConfirmSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PurchaseActivationFlowConfirmSectionQuery, PurchaseActivationFlowConfirmSectionQueryVariables>(PurchaseActivationFlowConfirmSectionDocument, options);
        }
export function usePurchaseActivationFlowConfirmSectionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PurchaseActivationFlowConfirmSectionQuery, PurchaseActivationFlowConfirmSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PurchaseActivationFlowConfirmSectionQuery, PurchaseActivationFlowConfirmSectionQueryVariables>(PurchaseActivationFlowConfirmSectionDocument, options);
        }
export type PurchaseActivationFlowConfirmSectionQueryHookResult = ReturnType<typeof usePurchaseActivationFlowConfirmSectionQuery>;
export type PurchaseActivationFlowConfirmSectionLazyQueryHookResult = ReturnType<typeof usePurchaseActivationFlowConfirmSectionLazyQuery>;
export type PurchaseActivationFlowConfirmSectionSuspenseQueryHookResult = ReturnType<typeof usePurchaseActivationFlowConfirmSectionSuspenseQuery>;
export type PurchaseActivationFlowConfirmSectionQueryResult = Apollo.QueryResult<PurchaseActivationFlowConfirmSectionQuery, PurchaseActivationFlowConfirmSectionQueryVariables>;
export const PurchaseActivationFlowConfirmSectionInitiateZipCheckoutDocument = gql`
    mutation PurchaseActivationFlowConfirmSectionInitiateZipCheckout($input: InitiateFlexiZipCheckoutInput!) {
  initiateFlexiZipCheckout(input: $input) {
    redirectUrl
  }
}
    `;
export type PurchaseActivationFlowConfirmSectionInitiateZipCheckoutMutationFn = Apollo.MutationFunction<PurchaseActivationFlowConfirmSectionInitiateZipCheckoutMutation, PurchaseActivationFlowConfirmSectionInitiateZipCheckoutMutationVariables>;

/**
 * __usePurchaseActivationFlowConfirmSectionInitiateZipCheckoutMutation__
 *
 * To run a mutation, you first call `usePurchaseActivationFlowConfirmSectionInitiateZipCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseActivationFlowConfirmSectionInitiateZipCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [purchaseActivationFlowConfirmSectionInitiateZipCheckoutMutation, { data, loading, error }] = usePurchaseActivationFlowConfirmSectionInitiateZipCheckoutMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePurchaseActivationFlowConfirmSectionInitiateZipCheckoutMutation(baseOptions?: Apollo.MutationHookOptions<PurchaseActivationFlowConfirmSectionInitiateZipCheckoutMutation, PurchaseActivationFlowConfirmSectionInitiateZipCheckoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PurchaseActivationFlowConfirmSectionInitiateZipCheckoutMutation, PurchaseActivationFlowConfirmSectionInitiateZipCheckoutMutationVariables>(PurchaseActivationFlowConfirmSectionInitiateZipCheckoutDocument, options);
      }
export type PurchaseActivationFlowConfirmSectionInitiateZipCheckoutMutationHookResult = ReturnType<typeof usePurchaseActivationFlowConfirmSectionInitiateZipCheckoutMutation>;
export type PurchaseActivationFlowConfirmSectionInitiateZipCheckoutMutationResult = Apollo.MutationResult<PurchaseActivationFlowConfirmSectionInitiateZipCheckoutMutation>;
export type PurchaseActivationFlowConfirmSectionInitiateZipCheckoutMutationOptions = Apollo.BaseMutationOptions<PurchaseActivationFlowConfirmSectionInitiateZipCheckoutMutation, PurchaseActivationFlowConfirmSectionInitiateZipCheckoutMutationVariables>;
export const PurchaseActivationFlowUpdateShippingAddressDocument = gql`
    mutation PurchaseActivationFlowUpdateShippingAddress($address: AddressCreateWithoutUserInput) {
  updateShipping(address: $address) {
    id
    address {
      id
      line1
      line2
      city
      postalCode
      country
      state
      prefecture
      municipality
      townArea
      company
      building
    }
  }
}
    `;
export type PurchaseActivationFlowUpdateShippingAddressMutationFn = Apollo.MutationFunction<PurchaseActivationFlowUpdateShippingAddressMutation, PurchaseActivationFlowUpdateShippingAddressMutationVariables>;

/**
 * __usePurchaseActivationFlowUpdateShippingAddressMutation__
 *
 * To run a mutation, you first call `usePurchaseActivationFlowUpdateShippingAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseActivationFlowUpdateShippingAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [purchaseActivationFlowUpdateShippingAddressMutation, { data, loading, error }] = usePurchaseActivationFlowUpdateShippingAddressMutation({
 *   variables: {
 *      address: // value for 'address'
 *   },
 * });
 */
export function usePurchaseActivationFlowUpdateShippingAddressMutation(baseOptions?: Apollo.MutationHookOptions<PurchaseActivationFlowUpdateShippingAddressMutation, PurchaseActivationFlowUpdateShippingAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PurchaseActivationFlowUpdateShippingAddressMutation, PurchaseActivationFlowUpdateShippingAddressMutationVariables>(PurchaseActivationFlowUpdateShippingAddressDocument, options);
      }
export type PurchaseActivationFlowUpdateShippingAddressMutationHookResult = ReturnType<typeof usePurchaseActivationFlowUpdateShippingAddressMutation>;
export type PurchaseActivationFlowUpdateShippingAddressMutationResult = Apollo.MutationResult<PurchaseActivationFlowUpdateShippingAddressMutation>;
export type PurchaseActivationFlowUpdateShippingAddressMutationOptions = Apollo.BaseMutationOptions<PurchaseActivationFlowUpdateShippingAddressMutation, PurchaseActivationFlowUpdateShippingAddressMutationVariables>;
export const PurchaseActivationFlowUpdateContactInfoDocument = gql`
    mutation PurchaseActivationFlowUpdateContactInfo($phone: String) {
  updateProfile(phone: $phone) {
    id
    phone
  }
}
    `;
export type PurchaseActivationFlowUpdateContactInfoMutationFn = Apollo.MutationFunction<PurchaseActivationFlowUpdateContactInfoMutation, PurchaseActivationFlowUpdateContactInfoMutationVariables>;

/**
 * __usePurchaseActivationFlowUpdateContactInfoMutation__
 *
 * To run a mutation, you first call `usePurchaseActivationFlowUpdateContactInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseActivationFlowUpdateContactInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [purchaseActivationFlowUpdateContactInfoMutation, { data, loading, error }] = usePurchaseActivationFlowUpdateContactInfoMutation({
 *   variables: {
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function usePurchaseActivationFlowUpdateContactInfoMutation(baseOptions?: Apollo.MutationHookOptions<PurchaseActivationFlowUpdateContactInfoMutation, PurchaseActivationFlowUpdateContactInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PurchaseActivationFlowUpdateContactInfoMutation, PurchaseActivationFlowUpdateContactInfoMutationVariables>(PurchaseActivationFlowUpdateContactInfoDocument, options);
      }
export type PurchaseActivationFlowUpdateContactInfoMutationHookResult = ReturnType<typeof usePurchaseActivationFlowUpdateContactInfoMutation>;
export type PurchaseActivationFlowUpdateContactInfoMutationResult = Apollo.MutationResult<PurchaseActivationFlowUpdateContactInfoMutation>;
export type PurchaseActivationFlowUpdateContactInfoMutationOptions = Apollo.BaseMutationOptions<PurchaseActivationFlowUpdateContactInfoMutation, PurchaseActivationFlowUpdateContactInfoMutationVariables>;
export const PurchaseActivationFlowOrderSummarySectionDocument = gql`
    query PurchaseActivationFlowOrderSummarySection($problemType: ProblemType!) {
  pafAddonSection(problemType: $problemType, stage: INITIAL) {
    id
    shopItems {
      id
      ...AddonDrawerFocusedShopItem
    }
  }
}
    ${AddonDrawerFocusedShopItemFragmentDoc}`;

/**
 * __usePurchaseActivationFlowOrderSummarySectionQuery__
 *
 * To run a query within a React component, call `usePurchaseActivationFlowOrderSummarySectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePurchaseActivationFlowOrderSummarySectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePurchaseActivationFlowOrderSummarySectionQuery({
 *   variables: {
 *      problemType: // value for 'problemType'
 *   },
 * });
 */
export function usePurchaseActivationFlowOrderSummarySectionQuery(baseOptions: Apollo.QueryHookOptions<PurchaseActivationFlowOrderSummarySectionQuery, PurchaseActivationFlowOrderSummarySectionQueryVariables> & ({ variables: PurchaseActivationFlowOrderSummarySectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PurchaseActivationFlowOrderSummarySectionQuery, PurchaseActivationFlowOrderSummarySectionQueryVariables>(PurchaseActivationFlowOrderSummarySectionDocument, options);
      }
export function usePurchaseActivationFlowOrderSummarySectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PurchaseActivationFlowOrderSummarySectionQuery, PurchaseActivationFlowOrderSummarySectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PurchaseActivationFlowOrderSummarySectionQuery, PurchaseActivationFlowOrderSummarySectionQueryVariables>(PurchaseActivationFlowOrderSummarySectionDocument, options);
        }
export function usePurchaseActivationFlowOrderSummarySectionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PurchaseActivationFlowOrderSummarySectionQuery, PurchaseActivationFlowOrderSummarySectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PurchaseActivationFlowOrderSummarySectionQuery, PurchaseActivationFlowOrderSummarySectionQueryVariables>(PurchaseActivationFlowOrderSummarySectionDocument, options);
        }
export type PurchaseActivationFlowOrderSummarySectionQueryHookResult = ReturnType<typeof usePurchaseActivationFlowOrderSummarySectionQuery>;
export type PurchaseActivationFlowOrderSummarySectionLazyQueryHookResult = ReturnType<typeof usePurchaseActivationFlowOrderSummarySectionLazyQuery>;
export type PurchaseActivationFlowOrderSummarySectionSuspenseQueryHookResult = ReturnType<typeof usePurchaseActivationFlowOrderSummarySectionSuspenseQuery>;
export type PurchaseActivationFlowOrderSummarySectionQueryResult = Apollo.QueryResult<PurchaseActivationFlowOrderSummarySectionQuery, PurchaseActivationFlowOrderSummarySectionQueryVariables>;
export const PurchaseActivationFlowProblemTypeDocument = gql`
    query PurchaseActivationFlowProblemType($consultationId: String!) {
  consultation(id: $consultationId) {
    id
    type
  }
}
    `;

/**
 * __usePurchaseActivationFlowProblemTypeQuery__
 *
 * To run a query within a React component, call `usePurchaseActivationFlowProblemTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `usePurchaseActivationFlowProblemTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePurchaseActivationFlowProblemTypeQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function usePurchaseActivationFlowProblemTypeQuery(baseOptions: Apollo.QueryHookOptions<PurchaseActivationFlowProblemTypeQuery, PurchaseActivationFlowProblemTypeQueryVariables> & ({ variables: PurchaseActivationFlowProblemTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PurchaseActivationFlowProblemTypeQuery, PurchaseActivationFlowProblemTypeQueryVariables>(PurchaseActivationFlowProblemTypeDocument, options);
      }
export function usePurchaseActivationFlowProblemTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PurchaseActivationFlowProblemTypeQuery, PurchaseActivationFlowProblemTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PurchaseActivationFlowProblemTypeQuery, PurchaseActivationFlowProblemTypeQueryVariables>(PurchaseActivationFlowProblemTypeDocument, options);
        }
export function usePurchaseActivationFlowProblemTypeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PurchaseActivationFlowProblemTypeQuery, PurchaseActivationFlowProblemTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PurchaseActivationFlowProblemTypeQuery, PurchaseActivationFlowProblemTypeQueryVariables>(PurchaseActivationFlowProblemTypeDocument, options);
        }
export type PurchaseActivationFlowProblemTypeQueryHookResult = ReturnType<typeof usePurchaseActivationFlowProblemTypeQuery>;
export type PurchaseActivationFlowProblemTypeLazyQueryHookResult = ReturnType<typeof usePurchaseActivationFlowProblemTypeLazyQuery>;
export type PurchaseActivationFlowProblemTypeSuspenseQueryHookResult = ReturnType<typeof usePurchaseActivationFlowProblemTypeSuspenseQuery>;
export type PurchaseActivationFlowProblemTypeQueryResult = Apollo.QueryResult<PurchaseActivationFlowProblemTypeQuery, PurchaseActivationFlowProblemTypeQueryVariables>;
export const PurchaseActivationFlowProviderDocument = gql`
    query PurchaseActivationFlowProvider($consultationId: String!, $problemType: ProblemType!, $stage: PafStage!) {
  profile {
    id
    phone
    address {
      id
    }
  }
  pafAddonSection(problemType: $problemType, stage: $stage) {
    id
  }
  consultation(id: $consultationId) {
    id
    purchasePrompt {
      id
      ... on ConfirmPurchasePrompt {
        id
        purchaseGroup {
          id
          pricingSessionId
          purchases {
            id
            offering {
              id
              ...PurchaseActivationFlowOfferingVerticals
            }
            contexts {
              id
              sequence {
                id
              }
              sequenceSet {
                id
              }
            }
          }
        }
      }
      ... on SubstitutePurchasePrompt {
        id
        pricingSessionId
        substitutions {
          id
          substitution {
            id
            offering {
              id
              ...PurchaseActivationFlowOfferingVerticals
            }
            sequenceSelections {
              id
              sequence {
                id
              }
              sequenceSet {
                id
              }
            }
          }
        }
      }
    }
  }
}
    ${PurchaseActivationFlowOfferingVerticalsFragmentDoc}`;

/**
 * __usePurchaseActivationFlowProviderQuery__
 *
 * To run a query within a React component, call `usePurchaseActivationFlowProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `usePurchaseActivationFlowProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePurchaseActivationFlowProviderQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *      problemType: // value for 'problemType'
 *      stage: // value for 'stage'
 *   },
 * });
 */
export function usePurchaseActivationFlowProviderQuery(baseOptions: Apollo.QueryHookOptions<PurchaseActivationFlowProviderQuery, PurchaseActivationFlowProviderQueryVariables> & ({ variables: PurchaseActivationFlowProviderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PurchaseActivationFlowProviderQuery, PurchaseActivationFlowProviderQueryVariables>(PurchaseActivationFlowProviderDocument, options);
      }
export function usePurchaseActivationFlowProviderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PurchaseActivationFlowProviderQuery, PurchaseActivationFlowProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PurchaseActivationFlowProviderQuery, PurchaseActivationFlowProviderQueryVariables>(PurchaseActivationFlowProviderDocument, options);
        }
export function usePurchaseActivationFlowProviderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PurchaseActivationFlowProviderQuery, PurchaseActivationFlowProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PurchaseActivationFlowProviderQuery, PurchaseActivationFlowProviderQueryVariables>(PurchaseActivationFlowProviderDocument, options);
        }
export type PurchaseActivationFlowProviderQueryHookResult = ReturnType<typeof usePurchaseActivationFlowProviderQuery>;
export type PurchaseActivationFlowProviderLazyQueryHookResult = ReturnType<typeof usePurchaseActivationFlowProviderLazyQuery>;
export type PurchaseActivationFlowProviderSuspenseQueryHookResult = ReturnType<typeof usePurchaseActivationFlowProviderSuspenseQuery>;
export type PurchaseActivationFlowProviderQueryResult = Apollo.QueryResult<PurchaseActivationFlowProviderQuery, PurchaseActivationFlowProviderQueryVariables>;
export const PurchaseActivationFlowGippDocument = gql`
    query PurchaseActivationFlowGIPP($consultationId: String!, $pricingSessionId: ID!, $offeringSelections: [OfferingSelectionInput!]!, $couponCodes: [String!]) {
  initialPurchasePrice(
    consultationId: $consultationId
    pricingSessionId: $pricingSessionId
    offeringSelections: $offeringSelections
    couponCodes: $couponCodes
  ) {
    id
    ...OrderSummaryGIPP
  }
}
    ${OrderSummaryGippFragmentDoc}`;

/**
 * __usePurchaseActivationFlowGippQuery__
 *
 * To run a query within a React component, call `usePurchaseActivationFlowGippQuery` and pass it any options that fit your needs.
 * When your component renders, `usePurchaseActivationFlowGippQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePurchaseActivationFlowGippQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *      pricingSessionId: // value for 'pricingSessionId'
 *      offeringSelections: // value for 'offeringSelections'
 *      couponCodes: // value for 'couponCodes'
 *   },
 * });
 */
export function usePurchaseActivationFlowGippQuery(baseOptions: Apollo.QueryHookOptions<PurchaseActivationFlowGippQuery, PurchaseActivationFlowGippQueryVariables> & ({ variables: PurchaseActivationFlowGippQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PurchaseActivationFlowGippQuery, PurchaseActivationFlowGippQueryVariables>(PurchaseActivationFlowGippDocument, options);
      }
export function usePurchaseActivationFlowGippLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PurchaseActivationFlowGippQuery, PurchaseActivationFlowGippQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PurchaseActivationFlowGippQuery, PurchaseActivationFlowGippQueryVariables>(PurchaseActivationFlowGippDocument, options);
        }
export function usePurchaseActivationFlowGippSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PurchaseActivationFlowGippQuery, PurchaseActivationFlowGippQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PurchaseActivationFlowGippQuery, PurchaseActivationFlowGippQueryVariables>(PurchaseActivationFlowGippDocument, options);
        }
export type PurchaseActivationFlowGippQueryHookResult = ReturnType<typeof usePurchaseActivationFlowGippQuery>;
export type PurchaseActivationFlowGippLazyQueryHookResult = ReturnType<typeof usePurchaseActivationFlowGippLazyQuery>;
export type PurchaseActivationFlowGippSuspenseQueryHookResult = ReturnType<typeof usePurchaseActivationFlowGippSuspenseQuery>;
export type PurchaseActivationFlowGippQueryResult = Apollo.QueryResult<PurchaseActivationFlowGippQuery, PurchaseActivationFlowGippQueryVariables>;
export const PurchaseActivationFlowDocument = gql`
    query PurchaseActivationFlow($consultationId: String!) {
  consultation(id: $consultationId) {
    id
    purchasePrompt {
      id
      ... on ConfirmPurchasePrompt {
        id
      }
      ... on SubstitutePurchasePrompt {
        id
      }
    }
  }
}
    `;

/**
 * __usePurchaseActivationFlowQuery__
 *
 * To run a query within a React component, call `usePurchaseActivationFlowQuery` and pass it any options that fit your needs.
 * When your component renders, `usePurchaseActivationFlowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePurchaseActivationFlowQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function usePurchaseActivationFlowQuery(baseOptions: Apollo.QueryHookOptions<PurchaseActivationFlowQuery, PurchaseActivationFlowQueryVariables> & ({ variables: PurchaseActivationFlowQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PurchaseActivationFlowQuery, PurchaseActivationFlowQueryVariables>(PurchaseActivationFlowDocument, options);
      }
export function usePurchaseActivationFlowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PurchaseActivationFlowQuery, PurchaseActivationFlowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PurchaseActivationFlowQuery, PurchaseActivationFlowQueryVariables>(PurchaseActivationFlowDocument, options);
        }
export function usePurchaseActivationFlowSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PurchaseActivationFlowQuery, PurchaseActivationFlowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PurchaseActivationFlowQuery, PurchaseActivationFlowQueryVariables>(PurchaseActivationFlowDocument, options);
        }
export type PurchaseActivationFlowQueryHookResult = ReturnType<typeof usePurchaseActivationFlowQuery>;
export type PurchaseActivationFlowLazyQueryHookResult = ReturnType<typeof usePurchaseActivationFlowLazyQuery>;
export type PurchaseActivationFlowSuspenseQueryHookResult = ReturnType<typeof usePurchaseActivationFlowSuspenseQuery>;
export type PurchaseActivationFlowQueryResult = Apollo.QueryResult<PurchaseActivationFlowQuery, PurchaseActivationFlowQueryVariables>;
export const PurchaseActivationFlowReceiptSectionDocument = gql`
    query PurchaseActivationFlowReceiptSection($consultationId: String!) {
  profile {
    id
    email
  }
  consultation(id: $consultationId) {
    ...ReceiptPsatConsultation
  }
}
    ${ReceiptPsatConsultationFragmentDoc}`;

/**
 * __usePurchaseActivationFlowReceiptSectionQuery__
 *
 * To run a query within a React component, call `usePurchaseActivationFlowReceiptSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePurchaseActivationFlowReceiptSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePurchaseActivationFlowReceiptSectionQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function usePurchaseActivationFlowReceiptSectionQuery(baseOptions: Apollo.QueryHookOptions<PurchaseActivationFlowReceiptSectionQuery, PurchaseActivationFlowReceiptSectionQueryVariables> & ({ variables: PurchaseActivationFlowReceiptSectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PurchaseActivationFlowReceiptSectionQuery, PurchaseActivationFlowReceiptSectionQueryVariables>(PurchaseActivationFlowReceiptSectionDocument, options);
      }
export function usePurchaseActivationFlowReceiptSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PurchaseActivationFlowReceiptSectionQuery, PurchaseActivationFlowReceiptSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PurchaseActivationFlowReceiptSectionQuery, PurchaseActivationFlowReceiptSectionQueryVariables>(PurchaseActivationFlowReceiptSectionDocument, options);
        }
export function usePurchaseActivationFlowReceiptSectionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PurchaseActivationFlowReceiptSectionQuery, PurchaseActivationFlowReceiptSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PurchaseActivationFlowReceiptSectionQuery, PurchaseActivationFlowReceiptSectionQueryVariables>(PurchaseActivationFlowReceiptSectionDocument, options);
        }
export type PurchaseActivationFlowReceiptSectionQueryHookResult = ReturnType<typeof usePurchaseActivationFlowReceiptSectionQuery>;
export type PurchaseActivationFlowReceiptSectionLazyQueryHookResult = ReturnType<typeof usePurchaseActivationFlowReceiptSectionLazyQuery>;
export type PurchaseActivationFlowReceiptSectionSuspenseQueryHookResult = ReturnType<typeof usePurchaseActivationFlowReceiptSectionSuspenseQuery>;
export type PurchaseActivationFlowReceiptSectionQueryResult = Apollo.QueryResult<PurchaseActivationFlowReceiptSectionQuery, PurchaseActivationFlowReceiptSectionQueryVariables>;
export const PurchaseActivationFlowReviewSectionDocument = gql`
    query PurchaseActivationFlowReviewSection($consultationId: String!, $offeringSelections: [OfferingSelectionInput!]!, $noSelections: Boolean!) {
  profile {
    id
    phone
    address {
      id
    }
    healthCareDetails {
      id
      hasIndividualHealthcareIdentifier
    }
  }
  consultation(id: $consultationId) {
    id
    type
    doctor {
      id
      shortClinicianName
      fullClinicianName
    }
    prescribedSequence {
      id
      sequence {
        id
        ...OfferingHighlightsSequence
        friendlyName
        ... on PrescribableSequence {
          faqs {
            id
            rank
            question
            answerMarkdown
          }
        }
      }
    }
    purchasePrompt {
      id
      ... on SubstitutePurchasePrompt {
        pricingSessionId
        substitutions {
          id
          substitution {
            id
            offering {
              ...ReviewSectionOffering
            }
            sequenceSelections {
              id
              sequence {
                id
              }
              sequenceSet {
                id
              }
            }
          }
        }
      }
      ... on ConfirmPurchasePrompt {
        purchaseGroup {
          id
          purchases {
            id
            offering {
              ...ReviewSectionOffering
            }
            contexts {
              id
              sequence {
                id
              }
              sequenceSet {
                id
              }
            }
          }
        }
      }
    }
  }
  offeringsTimeline(offerings: $offeringSelections) @skip(if: $noSelections) {
    id
    date
    totalAmount
    products {
      id
      friendlyName
      erxMedicines {
        id
        itemForm
        itemStrength
      }
    }
  }
}
    ${OfferingHighlightsSequenceFragmentDoc}
${ReviewSectionOfferingFragmentDoc}`;

/**
 * __usePurchaseActivationFlowReviewSectionQuery__
 *
 * To run a query within a React component, call `usePurchaseActivationFlowReviewSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePurchaseActivationFlowReviewSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePurchaseActivationFlowReviewSectionQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *      offeringSelections: // value for 'offeringSelections'
 *      noSelections: // value for 'noSelections'
 *   },
 * });
 */
export function usePurchaseActivationFlowReviewSectionQuery(baseOptions: Apollo.QueryHookOptions<PurchaseActivationFlowReviewSectionQuery, PurchaseActivationFlowReviewSectionQueryVariables> & ({ variables: PurchaseActivationFlowReviewSectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PurchaseActivationFlowReviewSectionQuery, PurchaseActivationFlowReviewSectionQueryVariables>(PurchaseActivationFlowReviewSectionDocument, options);
      }
export function usePurchaseActivationFlowReviewSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PurchaseActivationFlowReviewSectionQuery, PurchaseActivationFlowReviewSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PurchaseActivationFlowReviewSectionQuery, PurchaseActivationFlowReviewSectionQueryVariables>(PurchaseActivationFlowReviewSectionDocument, options);
        }
export function usePurchaseActivationFlowReviewSectionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PurchaseActivationFlowReviewSectionQuery, PurchaseActivationFlowReviewSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PurchaseActivationFlowReviewSectionQuery, PurchaseActivationFlowReviewSectionQueryVariables>(PurchaseActivationFlowReviewSectionDocument, options);
        }
export type PurchaseActivationFlowReviewSectionQueryHookResult = ReturnType<typeof usePurchaseActivationFlowReviewSectionQuery>;
export type PurchaseActivationFlowReviewSectionLazyQueryHookResult = ReturnType<typeof usePurchaseActivationFlowReviewSectionLazyQuery>;
export type PurchaseActivationFlowReviewSectionSuspenseQueryHookResult = ReturnType<typeof usePurchaseActivationFlowReviewSectionSuspenseQuery>;
export type PurchaseActivationFlowReviewSectionQueryResult = Apollo.QueryResult<PurchaseActivationFlowReviewSectionQuery, PurchaseActivationFlowReviewSectionQueryVariables>;
export const PurchaseActivationFlowTierSelectionSectionDocument = gql`
    query PurchaseActivationFlowTierSelectionSection($consultationId: String!) {
  consultation(id: $consultationId) {
    id
    purchasePrompt {
      id
      ... on SubstitutePurchasePrompt {
        substitutions {
          id
          substitution {
            id
            sequenceSelections {
              id
              sequence {
                id
              }
            }
            offering {
              ...PurchaseActivationOffering
            }
          }
        }
      }
      ... on ConfirmPurchasePrompt {
        purchaseGroup {
          id
          purchases {
            id
            contexts {
              id
              sequence {
                id
              }
            }
            offering {
              ...PurchaseActivationOffering
            }
          }
        }
      }
    }
  }
}
    ${PurchaseActivationOfferingFragmentDoc}`;

/**
 * __usePurchaseActivationFlowTierSelectionSectionQuery__
 *
 * To run a query within a React component, call `usePurchaseActivationFlowTierSelectionSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePurchaseActivationFlowTierSelectionSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePurchaseActivationFlowTierSelectionSectionQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function usePurchaseActivationFlowTierSelectionSectionQuery(baseOptions: Apollo.QueryHookOptions<PurchaseActivationFlowTierSelectionSectionQuery, PurchaseActivationFlowTierSelectionSectionQueryVariables> & ({ variables: PurchaseActivationFlowTierSelectionSectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PurchaseActivationFlowTierSelectionSectionQuery, PurchaseActivationFlowTierSelectionSectionQueryVariables>(PurchaseActivationFlowTierSelectionSectionDocument, options);
      }
export function usePurchaseActivationFlowTierSelectionSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PurchaseActivationFlowTierSelectionSectionQuery, PurchaseActivationFlowTierSelectionSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PurchaseActivationFlowTierSelectionSectionQuery, PurchaseActivationFlowTierSelectionSectionQueryVariables>(PurchaseActivationFlowTierSelectionSectionDocument, options);
        }
export function usePurchaseActivationFlowTierSelectionSectionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PurchaseActivationFlowTierSelectionSectionQuery, PurchaseActivationFlowTierSelectionSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PurchaseActivationFlowTierSelectionSectionQuery, PurchaseActivationFlowTierSelectionSectionQueryVariables>(PurchaseActivationFlowTierSelectionSectionDocument, options);
        }
export type PurchaseActivationFlowTierSelectionSectionQueryHookResult = ReturnType<typeof usePurchaseActivationFlowTierSelectionSectionQuery>;
export type PurchaseActivationFlowTierSelectionSectionLazyQueryHookResult = ReturnType<typeof usePurchaseActivationFlowTierSelectionSectionLazyQuery>;
export type PurchaseActivationFlowTierSelectionSectionSuspenseQueryHookResult = ReturnType<typeof usePurchaseActivationFlowTierSelectionSectionSuspenseQuery>;
export type PurchaseActivationFlowTierSelectionSectionQueryResult = Apollo.QueryResult<PurchaseActivationFlowTierSelectionSectionQuery, PurchaseActivationFlowTierSelectionSectionQueryVariables>;
export const PurchaseOfferingsFromIntentHandlerDocument = gql`
    mutation PurchaseOfferingsFromIntentHandler($input: PurchaseOfferingsInput!) {
  purchaseOfferings(input: $input) {
    purchaseGroup {
      id
      consultation {
        id
        status
        purchasePrompt {
          id
        }
      }
    }
  }
}
    `;
export type PurchaseOfferingsFromIntentHandlerMutationFn = Apollo.MutationFunction<PurchaseOfferingsFromIntentHandlerMutation, PurchaseOfferingsFromIntentHandlerMutationVariables>;

/**
 * __usePurchaseOfferingsFromIntentHandlerMutation__
 *
 * To run a mutation, you first call `usePurchaseOfferingsFromIntentHandlerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseOfferingsFromIntentHandlerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [purchaseOfferingsFromIntentHandlerMutation, { data, loading, error }] = usePurchaseOfferingsFromIntentHandlerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePurchaseOfferingsFromIntentHandlerMutation(baseOptions?: Apollo.MutationHookOptions<PurchaseOfferingsFromIntentHandlerMutation, PurchaseOfferingsFromIntentHandlerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PurchaseOfferingsFromIntentHandlerMutation, PurchaseOfferingsFromIntentHandlerMutationVariables>(PurchaseOfferingsFromIntentHandlerDocument, options);
      }
export type PurchaseOfferingsFromIntentHandlerMutationHookResult = ReturnType<typeof usePurchaseOfferingsFromIntentHandlerMutation>;
export type PurchaseOfferingsFromIntentHandlerMutationResult = Apollo.MutationResult<PurchaseOfferingsFromIntentHandlerMutation>;
export type PurchaseOfferingsFromIntentHandlerMutationOptions = Apollo.BaseMutationOptions<PurchaseOfferingsFromIntentHandlerMutation, PurchaseOfferingsFromIntentHandlerMutationVariables>;
export const PurchaseOfferingsIntentHandlerPageDocument = gql`
    query PurchaseOfferingsIntentHandlerPage($consultationId: String, $pricingSessionId: ID!, $offeringSelections: [OfferingSelectionInput!]!, $couponCodes: [String!]) {
  profile {
    id
    email
    zip {
      valid
    }
  }
  initialPurchasePrice(
    consultationId: $consultationId
    pricingSessionId: $pricingSessionId
    offeringSelections: $offeringSelections
    couponCodes: $couponCodes
  ) {
    id
    amount
    discountAmount
    offeringPriceLists {
      id
      offering {
        id
        problemTypes
      }
      sequencePriceLists {
        id
        sequence {
          id
        }
        pricedItems {
          id
          quantity
          unitPrice
          unitPriceDiscount
          variant {
            id
            product {
              id
              problemTypes
              name
            }
            inventory {
              id
              sku
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __usePurchaseOfferingsIntentHandlerPageQuery__
 *
 * To run a query within a React component, call `usePurchaseOfferingsIntentHandlerPageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePurchaseOfferingsIntentHandlerPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePurchaseOfferingsIntentHandlerPageQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *      pricingSessionId: // value for 'pricingSessionId'
 *      offeringSelections: // value for 'offeringSelections'
 *      couponCodes: // value for 'couponCodes'
 *   },
 * });
 */
export function usePurchaseOfferingsIntentHandlerPageQuery(baseOptions: Apollo.QueryHookOptions<PurchaseOfferingsIntentHandlerPageQuery, PurchaseOfferingsIntentHandlerPageQueryVariables> & ({ variables: PurchaseOfferingsIntentHandlerPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PurchaseOfferingsIntentHandlerPageQuery, PurchaseOfferingsIntentHandlerPageQueryVariables>(PurchaseOfferingsIntentHandlerPageDocument, options);
      }
export function usePurchaseOfferingsIntentHandlerPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PurchaseOfferingsIntentHandlerPageQuery, PurchaseOfferingsIntentHandlerPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PurchaseOfferingsIntentHandlerPageQuery, PurchaseOfferingsIntentHandlerPageQueryVariables>(PurchaseOfferingsIntentHandlerPageDocument, options);
        }
export function usePurchaseOfferingsIntentHandlerPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PurchaseOfferingsIntentHandlerPageQuery, PurchaseOfferingsIntentHandlerPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PurchaseOfferingsIntentHandlerPageQuery, PurchaseOfferingsIntentHandlerPageQueryVariables>(PurchaseOfferingsIntentHandlerPageDocument, options);
        }
export type PurchaseOfferingsIntentHandlerPageQueryHookResult = ReturnType<typeof usePurchaseOfferingsIntentHandlerPageQuery>;
export type PurchaseOfferingsIntentHandlerPageLazyQueryHookResult = ReturnType<typeof usePurchaseOfferingsIntentHandlerPageLazyQuery>;
export type PurchaseOfferingsIntentHandlerPageSuspenseQueryHookResult = ReturnType<typeof usePurchaseOfferingsIntentHandlerPageSuspenseQuery>;
export type PurchaseOfferingsIntentHandlerPageQueryResult = Apollo.QueryResult<PurchaseOfferingsIntentHandlerPageQuery, PurchaseOfferingsIntentHandlerPageQueryVariables>;
export const SafetyInformationPageDocument = gql`
    query SafetyInformationPage($consultationId: String!) {
  consultation(id: $consultationId) {
    id
    purchasePrompt {
      id
      ... on InitialPurchasePrompt {
        proposedOfferingSelection {
          id
          sequenceSelections {
            id
            sequence {
              id
              ... on PrescribableSequence {
                ...FaqSequence
                ...SafetyInformationSequence
              }
            }
          }
        }
      }
      ... on ConfirmPurchasePrompt {
        purchaseGroup {
          id
          purchases {
            id
            contexts {
              id
              sequence {
                id
                ... on PrescribableSequence {
                  ...SafetyInformationSequence
                  ...FaqSequence
                }
              }
            }
          }
        }
      }
      ... on FurPurchasePrompt {
        proposedOfferingSelection {
          id
          sequenceSelections {
            id
            sequence {
              id
              ... on PrescribableSequence {
                ...SafetyInformationSequence
                ...FaqSequence
              }
            }
          }
        }
      }
      ... on SubstitutePurchasePrompt {
        substitutions {
          id
          substitution {
            id
            sequenceSelections {
              id
              sequence {
                id
                ... on PrescribableSequence {
                  ...SafetyInformationSequence
                  ...FaqSequence
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${FaqSequenceFragmentDoc}
${SafetyInformationSequenceFragmentDoc}`;

/**
 * __useSafetyInformationPageQuery__
 *
 * To run a query within a React component, call `useSafetyInformationPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSafetyInformationPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSafetyInformationPageQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function useSafetyInformationPageQuery(baseOptions: Apollo.QueryHookOptions<SafetyInformationPageQuery, SafetyInformationPageQueryVariables> & ({ variables: SafetyInformationPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SafetyInformationPageQuery, SafetyInformationPageQueryVariables>(SafetyInformationPageDocument, options);
      }
export function useSafetyInformationPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SafetyInformationPageQuery, SafetyInformationPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SafetyInformationPageQuery, SafetyInformationPageQueryVariables>(SafetyInformationPageDocument, options);
        }
export function useSafetyInformationPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SafetyInformationPageQuery, SafetyInformationPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SafetyInformationPageQuery, SafetyInformationPageQueryVariables>(SafetyInformationPageDocument, options);
        }
export type SafetyInformationPageQueryHookResult = ReturnType<typeof useSafetyInformationPageQuery>;
export type SafetyInformationPageLazyQueryHookResult = ReturnType<typeof useSafetyInformationPageLazyQuery>;
export type SafetyInformationPageSuspenseQueryHookResult = ReturnType<typeof useSafetyInformationPageSuspenseQuery>;
export type SafetyInformationPageQueryResult = Apollo.QueryResult<SafetyInformationPageQuery, SafetyInformationPageQueryVariables>;
export const SafetyInformationQuestionDocument = gql`
    mutation SafetyInformationQuestion($consultationId: String!, $messageText: String!, $contactMethod: ContactMethod) {
  submitConsultationQuestionToPharmacist(
    consultationId: $consultationId
    messageText: $messageText
    contactMethod: $contactMethod
  ) {
    consultation {
      id
    }
  }
}
    `;
export type SafetyInformationQuestionMutationFn = Apollo.MutationFunction<SafetyInformationQuestionMutation, SafetyInformationQuestionMutationVariables>;

/**
 * __useSafetyInformationQuestionMutation__
 *
 * To run a mutation, you first call `useSafetyInformationQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSafetyInformationQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [safetyInformationQuestionMutation, { data, loading, error }] = useSafetyInformationQuestionMutation({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *      messageText: // value for 'messageText'
 *      contactMethod: // value for 'contactMethod'
 *   },
 * });
 */
export function useSafetyInformationQuestionMutation(baseOptions?: Apollo.MutationHookOptions<SafetyInformationQuestionMutation, SafetyInformationQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SafetyInformationQuestionMutation, SafetyInformationQuestionMutationVariables>(SafetyInformationQuestionDocument, options);
      }
export type SafetyInformationQuestionMutationHookResult = ReturnType<typeof useSafetyInformationQuestionMutation>;
export type SafetyInformationQuestionMutationResult = Apollo.MutationResult<SafetyInformationQuestionMutation>;
export type SafetyInformationQuestionMutationOptions = Apollo.BaseMutationOptions<SafetyInformationQuestionMutation, SafetyInformationQuestionMutationVariables>;
export const SubstitutePurchaseConfirmAddressRangeDocument = gql`
    query SubstitutePurchaseConfirmAddressRange($line1: String!, $line2: String, $suburb: String!, $postcode: String!) {
  shippingAddressWithinRange(
    line1: $line1
    line2: $line2
    postcode: $postcode
    suburb: $suburb
  )
}
    `;

/**
 * __useSubstitutePurchaseConfirmAddressRangeQuery__
 *
 * To run a query within a React component, call `useSubstitutePurchaseConfirmAddressRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubstitutePurchaseConfirmAddressRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubstitutePurchaseConfirmAddressRangeQuery({
 *   variables: {
 *      line1: // value for 'line1'
 *      line2: // value for 'line2'
 *      suburb: // value for 'suburb'
 *      postcode: // value for 'postcode'
 *   },
 * });
 */
export function useSubstitutePurchaseConfirmAddressRangeQuery(baseOptions: Apollo.QueryHookOptions<SubstitutePurchaseConfirmAddressRangeQuery, SubstitutePurchaseConfirmAddressRangeQueryVariables> & ({ variables: SubstitutePurchaseConfirmAddressRangeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubstitutePurchaseConfirmAddressRangeQuery, SubstitutePurchaseConfirmAddressRangeQueryVariables>(SubstitutePurchaseConfirmAddressRangeDocument, options);
      }
export function useSubstitutePurchaseConfirmAddressRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubstitutePurchaseConfirmAddressRangeQuery, SubstitutePurchaseConfirmAddressRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubstitutePurchaseConfirmAddressRangeQuery, SubstitutePurchaseConfirmAddressRangeQueryVariables>(SubstitutePurchaseConfirmAddressRangeDocument, options);
        }
export function useSubstitutePurchaseConfirmAddressRangeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SubstitutePurchaseConfirmAddressRangeQuery, SubstitutePurchaseConfirmAddressRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubstitutePurchaseConfirmAddressRangeQuery, SubstitutePurchaseConfirmAddressRangeQueryVariables>(SubstitutePurchaseConfirmAddressRangeDocument, options);
        }
export type SubstitutePurchaseConfirmAddressRangeQueryHookResult = ReturnType<typeof useSubstitutePurchaseConfirmAddressRangeQuery>;
export type SubstitutePurchaseConfirmAddressRangeLazyQueryHookResult = ReturnType<typeof useSubstitutePurchaseConfirmAddressRangeLazyQuery>;
export type SubstitutePurchaseConfirmAddressRangeSuspenseQueryHookResult = ReturnType<typeof useSubstitutePurchaseConfirmAddressRangeSuspenseQuery>;
export type SubstitutePurchaseConfirmAddressRangeQueryResult = Apollo.QueryResult<SubstitutePurchaseConfirmAddressRangeQuery, SubstitutePurchaseConfirmAddressRangeQueryVariables>;
export const SubstitutePurchaseConfirmDocument = gql`
    query SubstitutePurchaseConfirm($consultationId: String!, $offeringSelections: [OfferingSelectionInput!]!, $noPayload: Boolean!, $couponCodes: [String!], $pricingSessionId: ID!) {
  profile {
    id
    defaultPaymentGateway
    address {
      id
      city
      line1
      line2
      state
      country
      postalCode
      prefecture
      municipality
      deliveryInstructions
      townArea
    }
    residentialAddress {
      id
      city
      line1
      line2
      state
      country
      postalCode
      prefecture
      municipality
      townArea
    }
    ...PaymentMethods
  }
  consultation(id: $consultationId) {
    id
    purchasePrompt {
      id
      ... on SubstitutePurchasePrompt {
        pricingSessionId
        substitutions {
          id
          substitution {
            id
            offering {
              id
              friendlyName
              photoUrl
            }
            sequenceSelections {
              id
              sequence {
                id
                products {
                  id
                  deliveryInformation
                }
                ... on PrescribableSequence {
                  addressValidationExempt
                }
              }
              sequenceSet {
                id
              }
            }
          }
        }
      }
    }
  }
  initialPurchasePrice(
    consultationId: $consultationId
    pricingSessionId: $pricingSessionId
    offeringSelections: $offeringSelections
    couponCodes: $couponCodes
  ) @skip(if: $noPayload) {
    id
    amount
    coupons {
      id
      code
      outcome
    }
    originalAmount
    discountAmount
    sessionCreditAmount
  }
  offeringsTimeline(offerings: $offeringSelections) @skip(if: $noPayload) {
    id
    date
    totalAmount
    products {
      id
      friendlyName
      erxMedicines {
        id
        itemForm
        itemStrength
      }
    }
  }
}
    ${PaymentMethodsFragmentDoc}`;

/**
 * __useSubstitutePurchaseConfirmQuery__
 *
 * To run a query within a React component, call `useSubstitutePurchaseConfirmQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubstitutePurchaseConfirmQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubstitutePurchaseConfirmQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *      offeringSelections: // value for 'offeringSelections'
 *      noPayload: // value for 'noPayload'
 *      couponCodes: // value for 'couponCodes'
 *      pricingSessionId: // value for 'pricingSessionId'
 *   },
 * });
 */
export function useSubstitutePurchaseConfirmQuery(baseOptions: Apollo.QueryHookOptions<SubstitutePurchaseConfirmQuery, SubstitutePurchaseConfirmQueryVariables> & ({ variables: SubstitutePurchaseConfirmQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubstitutePurchaseConfirmQuery, SubstitutePurchaseConfirmQueryVariables>(SubstitutePurchaseConfirmDocument, options);
      }
export function useSubstitutePurchaseConfirmLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubstitutePurchaseConfirmQuery, SubstitutePurchaseConfirmQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubstitutePurchaseConfirmQuery, SubstitutePurchaseConfirmQueryVariables>(SubstitutePurchaseConfirmDocument, options);
        }
export function useSubstitutePurchaseConfirmSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SubstitutePurchaseConfirmQuery, SubstitutePurchaseConfirmQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubstitutePurchaseConfirmQuery, SubstitutePurchaseConfirmQueryVariables>(SubstitutePurchaseConfirmDocument, options);
        }
export type SubstitutePurchaseConfirmQueryHookResult = ReturnType<typeof useSubstitutePurchaseConfirmQuery>;
export type SubstitutePurchaseConfirmLazyQueryHookResult = ReturnType<typeof useSubstitutePurchaseConfirmLazyQuery>;
export type SubstitutePurchaseConfirmSuspenseQueryHookResult = ReturnType<typeof useSubstitutePurchaseConfirmSuspenseQuery>;
export type SubstitutePurchaseConfirmQueryResult = Apollo.QueryResult<SubstitutePurchaseConfirmQuery, SubstitutePurchaseConfirmQueryVariables>;
export const SubstituteConfirmInitiateZipCheckoutDocument = gql`
    mutation SubstituteConfirmInitiateZipCheckout($input: InitiateFlexiZipCheckoutInput!) {
  initiateFlexiZipCheckout(input: $input) {
    redirectUrl
  }
}
    `;
export type SubstituteConfirmInitiateZipCheckoutMutationFn = Apollo.MutationFunction<SubstituteConfirmInitiateZipCheckoutMutation, SubstituteConfirmInitiateZipCheckoutMutationVariables>;

/**
 * __useSubstituteConfirmInitiateZipCheckoutMutation__
 *
 * To run a mutation, you first call `useSubstituteConfirmInitiateZipCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubstituteConfirmInitiateZipCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [substituteConfirmInitiateZipCheckoutMutation, { data, loading, error }] = useSubstituteConfirmInitiateZipCheckoutMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubstituteConfirmInitiateZipCheckoutMutation(baseOptions?: Apollo.MutationHookOptions<SubstituteConfirmInitiateZipCheckoutMutation, SubstituteConfirmInitiateZipCheckoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubstituteConfirmInitiateZipCheckoutMutation, SubstituteConfirmInitiateZipCheckoutMutationVariables>(SubstituteConfirmInitiateZipCheckoutDocument, options);
      }
export type SubstituteConfirmInitiateZipCheckoutMutationHookResult = ReturnType<typeof useSubstituteConfirmInitiateZipCheckoutMutation>;
export type SubstituteConfirmInitiateZipCheckoutMutationResult = Apollo.MutationResult<SubstituteConfirmInitiateZipCheckoutMutation>;
export type SubstituteConfirmInitiateZipCheckoutMutationOptions = Apollo.BaseMutationOptions<SubstituteConfirmInitiateZipCheckoutMutation, SubstituteConfirmInitiateZipCheckoutMutationVariables>;
export const SubstitutePurchaseReviewDocument = gql`
    query SubstitutePurchaseReview($consultationId: String!, $offeringSelections: [OfferingSelectionInput!]!, $noPayload: Boolean!, $pricingSessionId: ID!) {
  profile {
    id
    shortAddressableName
  }
  consultation(id: $consultationId) {
    id
    type
    patientNotes
    doctor {
      fullClinicianName
      ...DoctorInfoComponent
    }
    purchasePrompt {
      id
      ... on SubstitutePurchasePrompt {
        pricingSessionId
        substitutions {
          id
          substitution {
            id
            offering {
              id
              friendlyName
              advertisedShippingCadence
              photoUrl
            }
            sequenceSelections {
              id
              sequence {
                id
                faqs {
                  id
                  question
                  answerMarkdown
                  rank
                }
                externalLinks {
                  id
                  text
                  url
                }
              }
              sequenceSet {
                id
              }
            }
          }
        }
      }
    }
  }
  initialPurchasePrice(
    consultationId: $consultationId
    pricingSessionId: $pricingSessionId
    offeringSelections: $offeringSelections
  ) @skip(if: $noPayload) {
    id
    amount
  }
  offeringsTimeline(offerings: $offeringSelections) @skip(if: $noPayload) {
    id
    date
    totalAmount
    products {
      id
      friendlyName
      erxMedicines {
        id
        itemForm
        itemStrength
      }
    }
  }
}
    ${DoctorInfoComponentFragmentDoc}`;

/**
 * __useSubstitutePurchaseReviewQuery__
 *
 * To run a query within a React component, call `useSubstitutePurchaseReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubstitutePurchaseReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubstitutePurchaseReviewQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *      offeringSelections: // value for 'offeringSelections'
 *      noPayload: // value for 'noPayload'
 *      pricingSessionId: // value for 'pricingSessionId'
 *   },
 * });
 */
export function useSubstitutePurchaseReviewQuery(baseOptions: Apollo.QueryHookOptions<SubstitutePurchaseReviewQuery, SubstitutePurchaseReviewQueryVariables> & ({ variables: SubstitutePurchaseReviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubstitutePurchaseReviewQuery, SubstitutePurchaseReviewQueryVariables>(SubstitutePurchaseReviewDocument, options);
      }
export function useSubstitutePurchaseReviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubstitutePurchaseReviewQuery, SubstitutePurchaseReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubstitutePurchaseReviewQuery, SubstitutePurchaseReviewQueryVariables>(SubstitutePurchaseReviewDocument, options);
        }
export function useSubstitutePurchaseReviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SubstitutePurchaseReviewQuery, SubstitutePurchaseReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubstitutePurchaseReviewQuery, SubstitutePurchaseReviewQueryVariables>(SubstitutePurchaseReviewDocument, options);
        }
export type SubstitutePurchaseReviewQueryHookResult = ReturnType<typeof useSubstitutePurchaseReviewQuery>;
export type SubstitutePurchaseReviewLazyQueryHookResult = ReturnType<typeof useSubstitutePurchaseReviewLazyQuery>;
export type SubstitutePurchaseReviewSuspenseQueryHookResult = ReturnType<typeof useSubstitutePurchaseReviewSuspenseQuery>;
export type SubstitutePurchaseReviewQueryResult = Apollo.QueryResult<SubstitutePurchaseReviewQuery, SubstitutePurchaseReviewQueryVariables>;
export const MedicationPreferencePageDocument = gql`
    query MedicationPreferencePage($consultationId: String!, $skus: [String!]) {
  consultation(id: $consultationId) {
    id
    type
    quizApplicationId
    medicationPreferenceProduct {
      id
      defaultProduct {
        id
        photo {
          id
          url
        }
        variants {
          id
          isRefill
          price
        }
      }
    }
  }
  products(where: {variants: {some: {inventory: {sku: {in: $skus}}}}}) {
    id
    friendlyName
    name
    problemTypes
    shortDescription
    photo {
      id
      url
    }
    variants {
      id
      price
      isRefill
      inventory {
        id
        sku
      }
    }
  }
}
    `;

/**
 * __useMedicationPreferencePageQuery__
 *
 * To run a query within a React component, call `useMedicationPreferencePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedicationPreferencePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedicationPreferencePageQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *      skus: // value for 'skus'
 *   },
 * });
 */
export function useMedicationPreferencePageQuery(baseOptions: Apollo.QueryHookOptions<MedicationPreferencePageQuery, MedicationPreferencePageQueryVariables> & ({ variables: MedicationPreferencePageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MedicationPreferencePageQuery, MedicationPreferencePageQueryVariables>(MedicationPreferencePageDocument, options);
      }
export function useMedicationPreferencePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MedicationPreferencePageQuery, MedicationPreferencePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MedicationPreferencePageQuery, MedicationPreferencePageQueryVariables>(MedicationPreferencePageDocument, options);
        }
export function useMedicationPreferencePageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MedicationPreferencePageQuery, MedicationPreferencePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MedicationPreferencePageQuery, MedicationPreferencePageQueryVariables>(MedicationPreferencePageDocument, options);
        }
export type MedicationPreferencePageQueryHookResult = ReturnType<typeof useMedicationPreferencePageQuery>;
export type MedicationPreferencePageLazyQueryHookResult = ReturnType<typeof useMedicationPreferencePageLazyQuery>;
export type MedicationPreferencePageSuspenseQueryHookResult = ReturnType<typeof useMedicationPreferencePageSuspenseQuery>;
export type MedicationPreferencePageQueryResult = Apollo.QueryResult<MedicationPreferencePageQuery, MedicationPreferencePageQueryVariables>;
export const DeleteMedicationPreferenceDocument = gql`
    mutation DeleteMedicationPreference($input: DeleteMedicationPreferenceInput!) {
  deleteMedicationPreference(input: $input) {
    success
  }
}
    `;
export type DeleteMedicationPreferenceMutationFn = Apollo.MutationFunction<DeleteMedicationPreferenceMutation, DeleteMedicationPreferenceMutationVariables>;

/**
 * __useDeleteMedicationPreferenceMutation__
 *
 * To run a mutation, you first call `useDeleteMedicationPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMedicationPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMedicationPreferenceMutation, { data, loading, error }] = useDeleteMedicationPreferenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteMedicationPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMedicationPreferenceMutation, DeleteMedicationPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMedicationPreferenceMutation, DeleteMedicationPreferenceMutationVariables>(DeleteMedicationPreferenceDocument, options);
      }
export type DeleteMedicationPreferenceMutationHookResult = ReturnType<typeof useDeleteMedicationPreferenceMutation>;
export type DeleteMedicationPreferenceMutationResult = Apollo.MutationResult<DeleteMedicationPreferenceMutation>;
export type DeleteMedicationPreferenceMutationOptions = Apollo.BaseMutationOptions<DeleteMedicationPreferenceMutation, DeleteMedicationPreferenceMutationVariables>;
export const UpdateMedicationPreferenceDocument = gql`
    mutation UpdateMedicationPreference($problemType: ProblemType!, $medicationSkuPrefix: String!, $quizApplicationId: String) {
  updateMedicationPreference(
    problemType: $problemType
    medicationSkuPrefix: $medicationSkuPrefix
    quizApplicationId: $quizApplicationId
  ) {
    medicationSkuPrefix
  }
}
    `;
export type UpdateMedicationPreferenceMutationFn = Apollo.MutationFunction<UpdateMedicationPreferenceMutation, UpdateMedicationPreferenceMutationVariables>;

/**
 * __useUpdateMedicationPreferenceMutation__
 *
 * To run a mutation, you first call `useUpdateMedicationPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMedicationPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMedicationPreferenceMutation, { data, loading, error }] = useUpdateMedicationPreferenceMutation({
 *   variables: {
 *      problemType: // value for 'problemType'
 *      medicationSkuPrefix: // value for 'medicationSkuPrefix'
 *      quizApplicationId: // value for 'quizApplicationId'
 *   },
 * });
 */
export function useUpdateMedicationPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMedicationPreferenceMutation, UpdateMedicationPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMedicationPreferenceMutation, UpdateMedicationPreferenceMutationVariables>(UpdateMedicationPreferenceDocument, options);
      }
export type UpdateMedicationPreferenceMutationHookResult = ReturnType<typeof useUpdateMedicationPreferenceMutation>;
export type UpdateMedicationPreferenceMutationResult = Apollo.MutationResult<UpdateMedicationPreferenceMutation>;
export type UpdateMedicationPreferenceMutationOptions = Apollo.BaseMutationOptions<UpdateMedicationPreferenceMutation, UpdateMedicationPreferenceMutationVariables>;
export const OfferingFaqDocument = gql`
    query OfferingFaq {
  profile {
    id
    email
    purchases {
      id
      status
      contexts {
        id
        sequence {
          __typename
          id
          faqs {
            id
            question
            answerMarkdown
          }
        }
      }
    }
  }
}
    `;

/**
 * __useOfferingFaqQuery__
 *
 * To run a query within a React component, call `useOfferingFaqQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfferingFaqQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfferingFaqQuery({
 *   variables: {
 *   },
 * });
 */
export function useOfferingFaqQuery(baseOptions?: Apollo.QueryHookOptions<OfferingFaqQuery, OfferingFaqQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OfferingFaqQuery, OfferingFaqQueryVariables>(OfferingFaqDocument, options);
      }
export function useOfferingFaqLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OfferingFaqQuery, OfferingFaqQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OfferingFaqQuery, OfferingFaqQueryVariables>(OfferingFaqDocument, options);
        }
export function useOfferingFaqSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OfferingFaqQuery, OfferingFaqQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OfferingFaqQuery, OfferingFaqQueryVariables>(OfferingFaqDocument, options);
        }
export type OfferingFaqQueryHookResult = ReturnType<typeof useOfferingFaqQuery>;
export type OfferingFaqLazyQueryHookResult = ReturnType<typeof useOfferingFaqLazyQuery>;
export type OfferingFaqSuspenseQueryHookResult = ReturnType<typeof useOfferingFaqSuspenseQuery>;
export type OfferingFaqQueryResult = Apollo.QueryResult<OfferingFaqQuery, OfferingFaqQueryVariables>;
export const PausePurchaseDocument = gql`
    mutation PausePurchase($input: PausePurchaseInput!) {
  pausePurchase(input: $input) {
    purchase {
      id
      status
    }
  }
}
    `;
export type PausePurchaseMutationFn = Apollo.MutationFunction<PausePurchaseMutation, PausePurchaseMutationVariables>;

/**
 * __usePausePurchaseMutation__
 *
 * To run a mutation, you first call `usePausePurchaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePausePurchaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pausePurchaseMutation, { data, loading, error }] = usePausePurchaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePausePurchaseMutation(baseOptions?: Apollo.MutationHookOptions<PausePurchaseMutation, PausePurchaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PausePurchaseMutation, PausePurchaseMutationVariables>(PausePurchaseDocument, options);
      }
export type PausePurchaseMutationHookResult = ReturnType<typeof usePausePurchaseMutation>;
export type PausePurchaseMutationResult = Apollo.MutationResult<PausePurchaseMutation>;
export type PausePurchaseMutationOptions = Apollo.BaseMutationOptions<PausePurchaseMutation, PausePurchaseMutationVariables>;
export const OfferingNotesDocument = gql`
    query OfferingNotes {
  profile {
    id
    purchases {
      id
      contexts {
        id
        consultations {
          id
          ...OfferingDoctorLetterConsultation
        }
        sequence {
          id
          ... on PrescribableSequence {
            safetyInformation {
              id
              cmiCopyMarkdown
              cmiUrl
            }
          }
        }
      }
    }
  }
}
    ${OfferingDoctorLetterConsultationFragmentDoc}`;

/**
 * __useOfferingNotesQuery__
 *
 * To run a query within a React component, call `useOfferingNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfferingNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfferingNotesQuery({
 *   variables: {
 *   },
 * });
 */
export function useOfferingNotesQuery(baseOptions?: Apollo.QueryHookOptions<OfferingNotesQuery, OfferingNotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OfferingNotesQuery, OfferingNotesQueryVariables>(OfferingNotesDocument, options);
      }
export function useOfferingNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OfferingNotesQuery, OfferingNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OfferingNotesQuery, OfferingNotesQueryVariables>(OfferingNotesDocument, options);
        }
export function useOfferingNotesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OfferingNotesQuery, OfferingNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OfferingNotesQuery, OfferingNotesQueryVariables>(OfferingNotesDocument, options);
        }
export type OfferingNotesQueryHookResult = ReturnType<typeof useOfferingNotesQuery>;
export type OfferingNotesLazyQueryHookResult = ReturnType<typeof useOfferingNotesLazyQuery>;
export type OfferingNotesSuspenseQueryHookResult = ReturnType<typeof useOfferingNotesSuspenseQuery>;
export type OfferingNotesQueryResult = Apollo.QueryResult<OfferingNotesQuery, OfferingNotesQueryVariables>;
export const DelayPurchaseSyncGroupDocument = gql`
    mutation DelayPurchaseSyncGroup($input: DelayPurchaseSyncGroupInput!) {
  delayPurchaseSyncGroup(input: $input) {
    purchaseSyncGroup {
      id
      status
      sequenceContexts {
        id
        status
      }
    }
  }
}
    `;
export type DelayPurchaseSyncGroupMutationFn = Apollo.MutationFunction<DelayPurchaseSyncGroupMutation, DelayPurchaseSyncGroupMutationVariables>;

/**
 * __useDelayPurchaseSyncGroupMutation__
 *
 * To run a mutation, you first call `useDelayPurchaseSyncGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDelayPurchaseSyncGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [delayPurchaseSyncGroupMutation, { data, loading, error }] = useDelayPurchaseSyncGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDelayPurchaseSyncGroupMutation(baseOptions?: Apollo.MutationHookOptions<DelayPurchaseSyncGroupMutation, DelayPurchaseSyncGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DelayPurchaseSyncGroupMutation, DelayPurchaseSyncGroupMutationVariables>(DelayPurchaseSyncGroupDocument, options);
      }
export type DelayPurchaseSyncGroupMutationHookResult = ReturnType<typeof useDelayPurchaseSyncGroupMutation>;
export type DelayPurchaseSyncGroupMutationResult = Apollo.MutationResult<DelayPurchaseSyncGroupMutation>;
export type DelayPurchaseSyncGroupMutationOptions = Apollo.BaseMutationOptions<DelayPurchaseSyncGroupMutation, DelayPurchaseSyncGroupMutationVariables>;
export const OfferingPlanDocument = gql`
    query OfferingPlan {
  profile {
    id
    email
    purchases {
      ...UsePurchaseCardContentPurchase
      id
      status
      problemType
      contexts {
        id
        status
        consultations {
          id
          type
          status
        }
        sequence {
          __typename
          id
          externalLinks {
            id
            text
            url
          }
          products {
            id
            name
            friendlyName
            productType
            photo {
              id
              url
            }
          }
        }
      }
      offering {
        id
        status
        friendlyName
        description
        advertisedName
      }
      canBeSwitched
      syncGroups {
        id
        nextOrderDue
        nextOrder {
          id
          date
          totalAmount {
            id
            formattedAmount
          }
          discountAmount {
            id
            baseUnitAmount
            formattedAmount
          }
          preDiscountTotalAmount {
            id
            formattedAmount
          }
          products {
            id
            displayName
            photoUrl
          }
          discounts {
            id
            name
            removable
            amount {
              id
              formattedAmount
            }
          }
        }
        status
        actions {
          id
          ... on DelayPurchaseSyncGroupAction {
            delayableUntil
          }
        }
        sequenceContexts {
          id
          sequence {
            id
          }
        }
        ...PsgTimeline
      }
    }
  }
}
    ${UsePurchaseCardContentPurchaseFragmentDoc}
${PsgTimelineFragmentDoc}`;

/**
 * __useOfferingPlanQuery__
 *
 * To run a query within a React component, call `useOfferingPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfferingPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfferingPlanQuery({
 *   variables: {
 *   },
 * });
 */
export function useOfferingPlanQuery(baseOptions?: Apollo.QueryHookOptions<OfferingPlanQuery, OfferingPlanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OfferingPlanQuery, OfferingPlanQueryVariables>(OfferingPlanDocument, options);
      }
export function useOfferingPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OfferingPlanQuery, OfferingPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OfferingPlanQuery, OfferingPlanQueryVariables>(OfferingPlanDocument, options);
        }
export function useOfferingPlanSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OfferingPlanQuery, OfferingPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OfferingPlanQuery, OfferingPlanQueryVariables>(OfferingPlanDocument, options);
        }
export type OfferingPlanQueryHookResult = ReturnType<typeof useOfferingPlanQuery>;
export type OfferingPlanLazyQueryHookResult = ReturnType<typeof useOfferingPlanLazyQuery>;
export type OfferingPlanSuspenseQueryHookResult = ReturnType<typeof useOfferingPlanSuspenseQuery>;
export type OfferingPlanQueryResult = Apollo.QueryResult<OfferingPlanQuery, OfferingPlanQueryVariables>;
export const AddCouponCodesToPurchaseSyncGroupDocument = gql`
    mutation AddCouponCodesToPurchaseSyncGroup($input: AddCouponCodesToPurchaseSyncGroupInput!) {
  addCouponCodesToPurchaseSyncGroup(input: $input) {
    purchaseSyncGroupCoupons {
      id
      code
      outcome
    }
  }
}
    `;
export type AddCouponCodesToPurchaseSyncGroupMutationFn = Apollo.MutationFunction<AddCouponCodesToPurchaseSyncGroupMutation, AddCouponCodesToPurchaseSyncGroupMutationVariables>;

/**
 * __useAddCouponCodesToPurchaseSyncGroupMutation__
 *
 * To run a mutation, you first call `useAddCouponCodesToPurchaseSyncGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCouponCodesToPurchaseSyncGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCouponCodesToPurchaseSyncGroupMutation, { data, loading, error }] = useAddCouponCodesToPurchaseSyncGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCouponCodesToPurchaseSyncGroupMutation(baseOptions?: Apollo.MutationHookOptions<AddCouponCodesToPurchaseSyncGroupMutation, AddCouponCodesToPurchaseSyncGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCouponCodesToPurchaseSyncGroupMutation, AddCouponCodesToPurchaseSyncGroupMutationVariables>(AddCouponCodesToPurchaseSyncGroupDocument, options);
      }
export type AddCouponCodesToPurchaseSyncGroupMutationHookResult = ReturnType<typeof useAddCouponCodesToPurchaseSyncGroupMutation>;
export type AddCouponCodesToPurchaseSyncGroupMutationResult = Apollo.MutationResult<AddCouponCodesToPurchaseSyncGroupMutation>;
export type AddCouponCodesToPurchaseSyncGroupMutationOptions = Apollo.BaseMutationOptions<AddCouponCodesToPurchaseSyncGroupMutation, AddCouponCodesToPurchaseSyncGroupMutationVariables>;
export const SwitchOfferingsReceiptPageDocument = gql`
    query SwitchOfferingsReceiptPage($purchaseId: ID!) {
  purchase(id: $purchaseId) {
    id
    offering {
      id
      advertisedName
    }
    supersededBy {
      id
      offering {
        id
        advertisedName
      }
      nextOrder {
        id
        totalAmount
        date
      }
    }
  }
}
    `;

/**
 * __useSwitchOfferingsReceiptPageQuery__
 *
 * To run a query within a React component, call `useSwitchOfferingsReceiptPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSwitchOfferingsReceiptPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSwitchOfferingsReceiptPageQuery({
 *   variables: {
 *      purchaseId: // value for 'purchaseId'
 *   },
 * });
 */
export function useSwitchOfferingsReceiptPageQuery(baseOptions: Apollo.QueryHookOptions<SwitchOfferingsReceiptPageQuery, SwitchOfferingsReceiptPageQueryVariables> & ({ variables: SwitchOfferingsReceiptPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SwitchOfferingsReceiptPageQuery, SwitchOfferingsReceiptPageQueryVariables>(SwitchOfferingsReceiptPageDocument, options);
      }
export function useSwitchOfferingsReceiptPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SwitchOfferingsReceiptPageQuery, SwitchOfferingsReceiptPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SwitchOfferingsReceiptPageQuery, SwitchOfferingsReceiptPageQueryVariables>(SwitchOfferingsReceiptPageDocument, options);
        }
export function useSwitchOfferingsReceiptPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SwitchOfferingsReceiptPageQuery, SwitchOfferingsReceiptPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SwitchOfferingsReceiptPageQuery, SwitchOfferingsReceiptPageQueryVariables>(SwitchOfferingsReceiptPageDocument, options);
        }
export type SwitchOfferingsReceiptPageQueryHookResult = ReturnType<typeof useSwitchOfferingsReceiptPageQuery>;
export type SwitchOfferingsReceiptPageLazyQueryHookResult = ReturnType<typeof useSwitchOfferingsReceiptPageLazyQuery>;
export type SwitchOfferingsReceiptPageSuspenseQueryHookResult = ReturnType<typeof useSwitchOfferingsReceiptPageSuspenseQuery>;
export type SwitchOfferingsReceiptPageQueryResult = Apollo.QueryResult<SwitchOfferingsReceiptPageQuery, SwitchOfferingsReceiptPageQueryVariables>;
export const SwitchOfferingsPageDocument = gql`
    query SwitchOfferingsPage($purchaseId: ID!) {
  purchase(id: $purchaseId) {
    id
    canBeSwitched
    contexts {
      id
      sequence {
        id
      }
    }
    switchCandidates {
      id
      advertisedCadencePricingDelta
      offering {
        ...OfferingVertical
        sequenceSets {
          id
          defaultSequence {
            id
          }
        }
      }
    }
    offering {
      id
      upsells {
        id
        offering {
          id
        }
      }
      downsells {
        id
        offering {
          id
        }
      }
    }
  }
}
    ${OfferingVerticalFragmentDoc}`;

/**
 * __useSwitchOfferingsPageQuery__
 *
 * To run a query within a React component, call `useSwitchOfferingsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSwitchOfferingsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSwitchOfferingsPageQuery({
 *   variables: {
 *      purchaseId: // value for 'purchaseId'
 *   },
 * });
 */
export function useSwitchOfferingsPageQuery(baseOptions: Apollo.QueryHookOptions<SwitchOfferingsPageQuery, SwitchOfferingsPageQueryVariables> & ({ variables: SwitchOfferingsPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SwitchOfferingsPageQuery, SwitchOfferingsPageQueryVariables>(SwitchOfferingsPageDocument, options);
      }
export function useSwitchOfferingsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SwitchOfferingsPageQuery, SwitchOfferingsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SwitchOfferingsPageQuery, SwitchOfferingsPageQueryVariables>(SwitchOfferingsPageDocument, options);
        }
export function useSwitchOfferingsPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SwitchOfferingsPageQuery, SwitchOfferingsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SwitchOfferingsPageQuery, SwitchOfferingsPageQueryVariables>(SwitchOfferingsPageDocument, options);
        }
export type SwitchOfferingsPageQueryHookResult = ReturnType<typeof useSwitchOfferingsPageQuery>;
export type SwitchOfferingsPageLazyQueryHookResult = ReturnType<typeof useSwitchOfferingsPageLazyQuery>;
export type SwitchOfferingsPageSuspenseQueryHookResult = ReturnType<typeof useSwitchOfferingsPageSuspenseQuery>;
export type SwitchOfferingsPageQueryResult = Apollo.QueryResult<SwitchOfferingsPageQuery, SwitchOfferingsPageQueryVariables>;
export const SwitchPurchasedOfferingDocument = gql`
    mutation SwitchPurchasedOffering($input: SwitchPurchasedOfferingInput!) {
  switchPurchasedOffering(input: $input) {
    oldPurchase {
      id
      canBeSwitched
    }
  }
}
    `;
export type SwitchPurchasedOfferingMutationFn = Apollo.MutationFunction<SwitchPurchasedOfferingMutation, SwitchPurchasedOfferingMutationVariables>;

/**
 * __useSwitchPurchasedOfferingMutation__
 *
 * To run a mutation, you first call `useSwitchPurchasedOfferingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitchPurchasedOfferingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switchPurchasedOfferingMutation, { data, loading, error }] = useSwitchPurchasedOfferingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSwitchPurchasedOfferingMutation(baseOptions?: Apollo.MutationHookOptions<SwitchPurchasedOfferingMutation, SwitchPurchasedOfferingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SwitchPurchasedOfferingMutation, SwitchPurchasedOfferingMutationVariables>(SwitchPurchasedOfferingDocument, options);
      }
export type SwitchPurchasedOfferingMutationHookResult = ReturnType<typeof useSwitchPurchasedOfferingMutation>;
export type SwitchPurchasedOfferingMutationResult = Apollo.MutationResult<SwitchPurchasedOfferingMutation>;
export type SwitchPurchasedOfferingMutationOptions = Apollo.BaseMutationOptions<SwitchPurchasedOfferingMutation, SwitchPurchasedOfferingMutationVariables>;
export const ProfilePractitionerPageDocument = gql`
    query ProfilePractitionerPage($treatmentId: String!) {
  profile {
    id
    weightTreatmentCategory
  }
  treatment(id: $treatmentId) {
    id
    updatedAt
    product {
      id
      faqs {
        id
        markdown
        title
      }
      variants {
        id
        inventory {
          id
          sku
        }
      }
    }
    weightTreatmentCategory
    consultation {
      id
      status
      type
      completedAt
      prescribedSequence {
        id
        createdAt
        sequence {
          id
          faqs {
            id
            question
            videoUrl
            answerMarkdown
            rank
          }
          products {
            id
            variants {
              id
              inventory {
                id
                sku
              }
            }
          }
        }
      }
      doctor {
        id
        firstName
        avatar {
          id
          url
        }
        lastName
        provider {
          id
          clinicianTitle
          qualifications
        }
        shortClinicianName
        fullName
        fullClinicianName
        bio
      }
      patientNotes
    }
  }
  customerAttributes {
    id
    weight
  }
}
    `;

/**
 * __useProfilePractitionerPageQuery__
 *
 * To run a query within a React component, call `useProfilePractitionerPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfilePractitionerPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfilePractitionerPageQuery({
 *   variables: {
 *      treatmentId: // value for 'treatmentId'
 *   },
 * });
 */
export function useProfilePractitionerPageQuery(baseOptions: Apollo.QueryHookOptions<ProfilePractitionerPageQuery, ProfilePractitionerPageQueryVariables> & ({ variables: ProfilePractitionerPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfilePractitionerPageQuery, ProfilePractitionerPageQueryVariables>(ProfilePractitionerPageDocument, options);
      }
export function useProfilePractitionerPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfilePractitionerPageQuery, ProfilePractitionerPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfilePractitionerPageQuery, ProfilePractitionerPageQueryVariables>(ProfilePractitionerPageDocument, options);
        }
export function useProfilePractitionerPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProfilePractitionerPageQuery, ProfilePractitionerPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProfilePractitionerPageQuery, ProfilePractitionerPageQueryVariables>(ProfilePractitionerPageDocument, options);
        }
export type ProfilePractitionerPageQueryHookResult = ReturnType<typeof useProfilePractitionerPageQuery>;
export type ProfilePractitionerPageLazyQueryHookResult = ReturnType<typeof useProfilePractitionerPageLazyQuery>;
export type ProfilePractitionerPageSuspenseQueryHookResult = ReturnType<typeof useProfilePractitionerPageSuspenseQuery>;
export type ProfilePractitionerPageQueryResult = Apollo.QueryResult<ProfilePractitionerPageQuery, ProfilePractitionerPageQueryVariables>;
export const PhoneCallPageTemplateDocument = gql`
    query PhoneCallPageTemplate($consultationId: String!) {
  ...ScheduleCallPhoneNumberModal
  consultation(id: $consultationId) {
    id
    customer {
      id
      phone
    }
    latestPractitionerBooking {
      id
    }
    stage
    status
    canSchedulePractitionerBooking
    doctor {
      id
      shortClinicianName
    }
    nextAvailableCallWindowRange {
      id
      startWindow {
        id
        startAt
        endAt
      }
      endWindow {
        id
        startAt
        endAt
      }
    }
  }
}
    ${ScheduleCallPhoneNumberModalFragmentDoc}`;

/**
 * __usePhoneCallPageTemplateQuery__
 *
 * To run a query within a React component, call `usePhoneCallPageTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `usePhoneCallPageTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePhoneCallPageTemplateQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function usePhoneCallPageTemplateQuery(baseOptions: Apollo.QueryHookOptions<PhoneCallPageTemplateQuery, PhoneCallPageTemplateQueryVariables> & ({ variables: PhoneCallPageTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PhoneCallPageTemplateQuery, PhoneCallPageTemplateQueryVariables>(PhoneCallPageTemplateDocument, options);
      }
export function usePhoneCallPageTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PhoneCallPageTemplateQuery, PhoneCallPageTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PhoneCallPageTemplateQuery, PhoneCallPageTemplateQueryVariables>(PhoneCallPageTemplateDocument, options);
        }
export function usePhoneCallPageTemplateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PhoneCallPageTemplateQuery, PhoneCallPageTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PhoneCallPageTemplateQuery, PhoneCallPageTemplateQueryVariables>(PhoneCallPageTemplateDocument, options);
        }
export type PhoneCallPageTemplateQueryHookResult = ReturnType<typeof usePhoneCallPageTemplateQuery>;
export type PhoneCallPageTemplateLazyQueryHookResult = ReturnType<typeof usePhoneCallPageTemplateLazyQuery>;
export type PhoneCallPageTemplateSuspenseQueryHookResult = ReturnType<typeof usePhoneCallPageTemplateSuspenseQuery>;
export type PhoneCallPageTemplateQueryResult = Apollo.QueryResult<PhoneCallPageTemplateQuery, PhoneCallPageTemplateQueryVariables>;
export const UpsertPractitionerBookingDocument = gql`
    mutation UpsertPractitionerBooking($input: UpsertPractitionerBookingInput!) {
  upsertPractitionerBooking(input: $input) {
    consultation {
      id
      chatThread {
        id
      }
      latestPractitionerBooking {
        id
        windowStartAt
        windowEndAt
      }
    }
  }
}
    `;
export type UpsertPractitionerBookingMutationFn = Apollo.MutationFunction<UpsertPractitionerBookingMutation, UpsertPractitionerBookingMutationVariables>;

/**
 * __useUpsertPractitionerBookingMutation__
 *
 * To run a mutation, you first call `useUpsertPractitionerBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPractitionerBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPractitionerBookingMutation, { data, loading, error }] = useUpsertPractitionerBookingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertPractitionerBookingMutation(baseOptions?: Apollo.MutationHookOptions<UpsertPractitionerBookingMutation, UpsertPractitionerBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertPractitionerBookingMutation, UpsertPractitionerBookingMutationVariables>(UpsertPractitionerBookingDocument, options);
      }
export type UpsertPractitionerBookingMutationHookResult = ReturnType<typeof useUpsertPractitionerBookingMutation>;
export type UpsertPractitionerBookingMutationResult = Apollo.MutationResult<UpsertPractitionerBookingMutation>;
export type UpsertPractitionerBookingMutationOptions = Apollo.BaseMutationOptions<UpsertPractitionerBookingMutation, UpsertPractitionerBookingMutationVariables>;
export const CheckSuggestedTimeDocument = gql`
    query CheckSuggestedTime($consultationId: String!) {
  consultation(id: $consultationId) {
    id
    practitionerBookingWindows {
      id
      available
    }
  }
}
    `;

/**
 * __useCheckSuggestedTimeQuery__
 *
 * To run a query within a React component, call `useCheckSuggestedTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckSuggestedTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckSuggestedTimeQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function useCheckSuggestedTimeQuery(baseOptions: Apollo.QueryHookOptions<CheckSuggestedTimeQuery, CheckSuggestedTimeQueryVariables> & ({ variables: CheckSuggestedTimeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckSuggestedTimeQuery, CheckSuggestedTimeQueryVariables>(CheckSuggestedTimeDocument, options);
      }
export function useCheckSuggestedTimeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckSuggestedTimeQuery, CheckSuggestedTimeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckSuggestedTimeQuery, CheckSuggestedTimeQueryVariables>(CheckSuggestedTimeDocument, options);
        }
export function useCheckSuggestedTimeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckSuggestedTimeQuery, CheckSuggestedTimeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckSuggestedTimeQuery, CheckSuggestedTimeQueryVariables>(CheckSuggestedTimeDocument, options);
        }
export type CheckSuggestedTimeQueryHookResult = ReturnType<typeof useCheckSuggestedTimeQuery>;
export type CheckSuggestedTimeLazyQueryHookResult = ReturnType<typeof useCheckSuggestedTimeLazyQuery>;
export type CheckSuggestedTimeSuspenseQueryHookResult = ReturnType<typeof useCheckSuggestedTimeSuspenseQuery>;
export type CheckSuggestedTimeQueryResult = Apollo.QueryResult<CheckSuggestedTimeQuery, CheckSuggestedTimeQueryVariables>;
export const WeightResetQuizApplicationDocument = gql`
    query WeightResetQuizApplication($id: String!) {
  getQuizApplication(id: $id) {
    id
    problemType
    submittedAt
  }
}
    `;

/**
 * __useWeightResetQuizApplicationQuery__
 *
 * To run a query within a React component, call `useWeightResetQuizApplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useWeightResetQuizApplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWeightResetQuizApplicationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWeightResetQuizApplicationQuery(baseOptions: Apollo.QueryHookOptions<WeightResetQuizApplicationQuery, WeightResetQuizApplicationQueryVariables> & ({ variables: WeightResetQuizApplicationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WeightResetQuizApplicationQuery, WeightResetQuizApplicationQueryVariables>(WeightResetQuizApplicationDocument, options);
      }
export function useWeightResetQuizApplicationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WeightResetQuizApplicationQuery, WeightResetQuizApplicationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WeightResetQuizApplicationQuery, WeightResetQuizApplicationQueryVariables>(WeightResetQuizApplicationDocument, options);
        }
export function useWeightResetQuizApplicationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WeightResetQuizApplicationQuery, WeightResetQuizApplicationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WeightResetQuizApplicationQuery, WeightResetQuizApplicationQueryVariables>(WeightResetQuizApplicationDocument, options);
        }
export type WeightResetQuizApplicationQueryHookResult = ReturnType<typeof useWeightResetQuizApplicationQuery>;
export type WeightResetQuizApplicationLazyQueryHookResult = ReturnType<typeof useWeightResetQuizApplicationLazyQuery>;
export type WeightResetQuizApplicationSuspenseQueryHookResult = ReturnType<typeof useWeightResetQuizApplicationSuspenseQuery>;
export type WeightResetQuizApplicationQueryResult = Apollo.QueryResult<WeightResetQuizApplicationQuery, WeightResetQuizApplicationQueryVariables>;
export const PasswordResetDocument = gql`
    mutation PasswordReset($email: String, $password: String, $resetToken: String) {
  passwordReset(email: $email, password: $password, resetToken: $resetToken) {
    ok
  }
}
    `;
export type PasswordResetMutationFn = Apollo.MutationFunction<PasswordResetMutation, PasswordResetMutationVariables>;

/**
 * __usePasswordResetMutation__
 *
 * To run a mutation, you first call `usePasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passwordResetMutation, { data, loading, error }] = usePasswordResetMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      resetToken: // value for 'resetToken'
 *   },
 * });
 */
export function usePasswordResetMutation(baseOptions?: Apollo.MutationHookOptions<PasswordResetMutation, PasswordResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PasswordResetMutation, PasswordResetMutationVariables>(PasswordResetDocument, options);
      }
export type PasswordResetMutationHookResult = ReturnType<typeof usePasswordResetMutation>;
export type PasswordResetMutationResult = Apollo.MutationResult<PasswordResetMutation>;
export type PasswordResetMutationOptions = Apollo.BaseMutationOptions<PasswordResetMutation, PasswordResetMutationVariables>;
export const ScheduleCallPageTemplateDocument = gql`
    query ScheduleCallPageTemplate($consultationId: String!) {
  ...ScheduleCallPhoneNumberModal
  consultation(id: $consultationId) {
    id
    customer {
      ...ScheduleCallUser
    }
    latestPractitionerBooking {
      id
    }
    status
    canSchedulePractitionerBooking
    doctor {
      id
      shortClinicianName
    }
    practitionerBookingWindows {
      ...ScheduleCallPractitionerBookingWindow
    }
    nextAvailableCallWindowRange {
      id
      startWindow {
        id
      }
      endWindow {
        id
      }
    }
  }
}
    ${ScheduleCallPhoneNumberModalFragmentDoc}
${ScheduleCallUserFragmentDoc}
${ScheduleCallPractitionerBookingWindowFragmentDoc}`;

/**
 * __useScheduleCallPageTemplateQuery__
 *
 * To run a query within a React component, call `useScheduleCallPageTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleCallPageTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleCallPageTemplateQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function useScheduleCallPageTemplateQuery(baseOptions: Apollo.QueryHookOptions<ScheduleCallPageTemplateQuery, ScheduleCallPageTemplateQueryVariables> & ({ variables: ScheduleCallPageTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduleCallPageTemplateQuery, ScheduleCallPageTemplateQueryVariables>(ScheduleCallPageTemplateDocument, options);
      }
export function useScheduleCallPageTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduleCallPageTemplateQuery, ScheduleCallPageTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduleCallPageTemplateQuery, ScheduleCallPageTemplateQueryVariables>(ScheduleCallPageTemplateDocument, options);
        }
export function useScheduleCallPageTemplateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ScheduleCallPageTemplateQuery, ScheduleCallPageTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScheduleCallPageTemplateQuery, ScheduleCallPageTemplateQueryVariables>(ScheduleCallPageTemplateDocument, options);
        }
export type ScheduleCallPageTemplateQueryHookResult = ReturnType<typeof useScheduleCallPageTemplateQuery>;
export type ScheduleCallPageTemplateLazyQueryHookResult = ReturnType<typeof useScheduleCallPageTemplateLazyQuery>;
export type ScheduleCallPageTemplateSuspenseQueryHookResult = ReturnType<typeof useScheduleCallPageTemplateSuspenseQuery>;
export type ScheduleCallPageTemplateQueryResult = Apollo.QueryResult<ScheduleCallPageTemplateQuery, ScheduleCallPageTemplateQueryVariables>;
export const CheckSelectedTimeDocument = gql`
    query CheckSelectedTime($consultationId: String!) {
  consultation(id: $consultationId) {
    id
    practitionerBookingWindows {
      id
      available
    }
  }
}
    `;

/**
 * __useCheckSelectedTimeQuery__
 *
 * To run a query within a React component, call `useCheckSelectedTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckSelectedTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckSelectedTimeQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function useCheckSelectedTimeQuery(baseOptions: Apollo.QueryHookOptions<CheckSelectedTimeQuery, CheckSelectedTimeQueryVariables> & ({ variables: CheckSelectedTimeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckSelectedTimeQuery, CheckSelectedTimeQueryVariables>(CheckSelectedTimeDocument, options);
      }
export function useCheckSelectedTimeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckSelectedTimeQuery, CheckSelectedTimeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckSelectedTimeQuery, CheckSelectedTimeQueryVariables>(CheckSelectedTimeDocument, options);
        }
export function useCheckSelectedTimeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckSelectedTimeQuery, CheckSelectedTimeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckSelectedTimeQuery, CheckSelectedTimeQueryVariables>(CheckSelectedTimeDocument, options);
        }
export type CheckSelectedTimeQueryHookResult = ReturnType<typeof useCheckSelectedTimeQuery>;
export type CheckSelectedTimeLazyQueryHookResult = ReturnType<typeof useCheckSelectedTimeLazyQuery>;
export type CheckSelectedTimeSuspenseQueryHookResult = ReturnType<typeof useCheckSelectedTimeSuspenseQuery>;
export type CheckSelectedTimeQueryResult = Apollo.QueryResult<CheckSelectedTimeQuery, CheckSelectedTimeQueryVariables>;
export const ScheduleCallUpdatePhoneNumberDocument = gql`
    mutation ScheduleCallUpdatePhoneNumber($phone: String) {
  updateProfile(phone: $phone) {
    id
    phone
  }
}
    `;
export type ScheduleCallUpdatePhoneNumberMutationFn = Apollo.MutationFunction<ScheduleCallUpdatePhoneNumberMutation, ScheduleCallUpdatePhoneNumberMutationVariables>;

/**
 * __useScheduleCallUpdatePhoneNumberMutation__
 *
 * To run a mutation, you first call `useScheduleCallUpdatePhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleCallUpdatePhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleCallUpdatePhoneNumberMutation, { data, loading, error }] = useScheduleCallUpdatePhoneNumberMutation({
 *   variables: {
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useScheduleCallUpdatePhoneNumberMutation(baseOptions?: Apollo.MutationHookOptions<ScheduleCallUpdatePhoneNumberMutation, ScheduleCallUpdatePhoneNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScheduleCallUpdatePhoneNumberMutation, ScheduleCallUpdatePhoneNumberMutationVariables>(ScheduleCallUpdatePhoneNumberDocument, options);
      }
export type ScheduleCallUpdatePhoneNumberMutationHookResult = ReturnType<typeof useScheduleCallUpdatePhoneNumberMutation>;
export type ScheduleCallUpdatePhoneNumberMutationResult = Apollo.MutationResult<ScheduleCallUpdatePhoneNumberMutation>;
export type ScheduleCallUpdatePhoneNumberMutationOptions = Apollo.BaseMutationOptions<ScheduleCallUpdatePhoneNumberMutation, ScheduleCallUpdatePhoneNumberMutationVariables>;
export const V2SubscriptionPlanPaymentProfileDocument = gql`
    query V2SubscriptionPlanPaymentProfile {
  profile {
    id
    firstName
    lastName
    fullName
    email
    phone
    address {
      id
      line1
      line2
      city
      postalCode
      state
      country
    }
    savedPaymentMethods {
      createdAt
      default
      gateway
      id
      ... on SavedCardPaymentMethod {
        brand
        mask
        expiry
      }
      ... on SavedPayPalPaymentMethod {
        email
      }
      ... on SavedZipPaymentMethod {
        valid
      }
    }
  }
}
    `;

/**
 * __useV2SubscriptionPlanPaymentProfileQuery__
 *
 * To run a query within a React component, call `useV2SubscriptionPlanPaymentProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2SubscriptionPlanPaymentProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2SubscriptionPlanPaymentProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useV2SubscriptionPlanPaymentProfileQuery(baseOptions?: Apollo.QueryHookOptions<V2SubscriptionPlanPaymentProfileQuery, V2SubscriptionPlanPaymentProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2SubscriptionPlanPaymentProfileQuery, V2SubscriptionPlanPaymentProfileQueryVariables>(V2SubscriptionPlanPaymentProfileDocument, options);
      }
export function useV2SubscriptionPlanPaymentProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2SubscriptionPlanPaymentProfileQuery, V2SubscriptionPlanPaymentProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2SubscriptionPlanPaymentProfileQuery, V2SubscriptionPlanPaymentProfileQueryVariables>(V2SubscriptionPlanPaymentProfileDocument, options);
        }
export function useV2SubscriptionPlanPaymentProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<V2SubscriptionPlanPaymentProfileQuery, V2SubscriptionPlanPaymentProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2SubscriptionPlanPaymentProfileQuery, V2SubscriptionPlanPaymentProfileQueryVariables>(V2SubscriptionPlanPaymentProfileDocument, options);
        }
export type V2SubscriptionPlanPaymentProfileQueryHookResult = ReturnType<typeof useV2SubscriptionPlanPaymentProfileQuery>;
export type V2SubscriptionPlanPaymentProfileLazyQueryHookResult = ReturnType<typeof useV2SubscriptionPlanPaymentProfileLazyQuery>;
export type V2SubscriptionPlanPaymentProfileSuspenseQueryHookResult = ReturnType<typeof useV2SubscriptionPlanPaymentProfileSuspenseQuery>;
export type V2SubscriptionPlanPaymentProfileQueryResult = Apollo.QueryResult<V2SubscriptionPlanPaymentProfileQuery, V2SubscriptionPlanPaymentProfileQueryVariables>;
export const ProfileTreatmentPharmacyInformationPageDocument = gql`
    query ProfileTreatmentPharmacyInformationPage($id: String!) {
  treatment(id: $id) {
    id
    status
    product {
      id
      safetyInformation
      cmi {
        id
        url
      }
      variants {
        id
        inventory {
          id
          sku
        }
      }
    }
    consultation {
      id
      customer {
        id
        firstName
        healthCareDetails {
          id
          hasIndividualHealthcareIdentifier
        }
      }
      prescribedSequence {
        id
        sequence {
          id
          ... on PrescribableSequence {
            safetyInformation {
              id
              cmiUrl
              cmiCopyMarkdown
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useProfileTreatmentPharmacyInformationPageQuery__
 *
 * To run a query within a React component, call `useProfileTreatmentPharmacyInformationPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileTreatmentPharmacyInformationPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileTreatmentPharmacyInformationPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProfileTreatmentPharmacyInformationPageQuery(baseOptions: Apollo.QueryHookOptions<ProfileTreatmentPharmacyInformationPageQuery, ProfileTreatmentPharmacyInformationPageQueryVariables> & ({ variables: ProfileTreatmentPharmacyInformationPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileTreatmentPharmacyInformationPageQuery, ProfileTreatmentPharmacyInformationPageQueryVariables>(ProfileTreatmentPharmacyInformationPageDocument, options);
      }
export function useProfileTreatmentPharmacyInformationPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileTreatmentPharmacyInformationPageQuery, ProfileTreatmentPharmacyInformationPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileTreatmentPharmacyInformationPageQuery, ProfileTreatmentPharmacyInformationPageQueryVariables>(ProfileTreatmentPharmacyInformationPageDocument, options);
        }
export function useProfileTreatmentPharmacyInformationPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProfileTreatmentPharmacyInformationPageQuery, ProfileTreatmentPharmacyInformationPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProfileTreatmentPharmacyInformationPageQuery, ProfileTreatmentPharmacyInformationPageQueryVariables>(ProfileTreatmentPharmacyInformationPageDocument, options);
        }
export type ProfileTreatmentPharmacyInformationPageQueryHookResult = ReturnType<typeof useProfileTreatmentPharmacyInformationPageQuery>;
export type ProfileTreatmentPharmacyInformationPageLazyQueryHookResult = ReturnType<typeof useProfileTreatmentPharmacyInformationPageLazyQuery>;
export type ProfileTreatmentPharmacyInformationPageSuspenseQueryHookResult = ReturnType<typeof useProfileTreatmentPharmacyInformationPageSuspenseQuery>;
export type ProfileTreatmentPharmacyInformationPageQueryResult = Apollo.QueryResult<ProfileTreatmentPharmacyInformationPageQuery, ProfileTreatmentPharmacyInformationPageQueryVariables>;
export const UseMedicalProfileDocument = gql`
    query UseMedicalProfile {
  profile {
    id
    firstName
    lastName
    birthday
    phone
    preferredUnitSystem
    medicalProfile {
      id
      dob
      weight
      currentMedications
      allergies
      existingConditions
    }
    isPasswordSet
  }
}
    `;

/**
 * __useUseMedicalProfileQuery__
 *
 * To run a query within a React component, call `useUseMedicalProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseMedicalProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseMedicalProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useUseMedicalProfileQuery(baseOptions?: Apollo.QueryHookOptions<UseMedicalProfileQuery, UseMedicalProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseMedicalProfileQuery, UseMedicalProfileQueryVariables>(UseMedicalProfileDocument, options);
      }
export function useUseMedicalProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseMedicalProfileQuery, UseMedicalProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseMedicalProfileQuery, UseMedicalProfileQueryVariables>(UseMedicalProfileDocument, options);
        }
export function useUseMedicalProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UseMedicalProfileQuery, UseMedicalProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UseMedicalProfileQuery, UseMedicalProfileQueryVariables>(UseMedicalProfileDocument, options);
        }
export type UseMedicalProfileQueryHookResult = ReturnType<typeof useUseMedicalProfileQuery>;
export type UseMedicalProfileLazyQueryHookResult = ReturnType<typeof useUseMedicalProfileLazyQuery>;
export type UseMedicalProfileSuspenseQueryHookResult = ReturnType<typeof useUseMedicalProfileSuspenseQuery>;
export type UseMedicalProfileQueryResult = Apollo.QueryResult<UseMedicalProfileQuery, UseMedicalProfileQueryVariables>;
export const CpPaidEventFieldsDocument = gql`
    query CpPaidEventFields {
  profile {
    id
    firstName
    lastName
    isPasswordSet
    email
    phone
  }
}
    `;

/**
 * __useCpPaidEventFieldsQuery__
 *
 * To run a query within a React component, call `useCpPaidEventFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCpPaidEventFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCpPaidEventFieldsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCpPaidEventFieldsQuery(baseOptions?: Apollo.QueryHookOptions<CpPaidEventFieldsQuery, CpPaidEventFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CpPaidEventFieldsQuery, CpPaidEventFieldsQueryVariables>(CpPaidEventFieldsDocument, options);
      }
export function useCpPaidEventFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CpPaidEventFieldsQuery, CpPaidEventFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CpPaidEventFieldsQuery, CpPaidEventFieldsQueryVariables>(CpPaidEventFieldsDocument, options);
        }
export function useCpPaidEventFieldsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CpPaidEventFieldsQuery, CpPaidEventFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CpPaidEventFieldsQuery, CpPaidEventFieldsQueryVariables>(CpPaidEventFieldsDocument, options);
        }
export type CpPaidEventFieldsQueryHookResult = ReturnType<typeof useCpPaidEventFieldsQuery>;
export type CpPaidEventFieldsLazyQueryHookResult = ReturnType<typeof useCpPaidEventFieldsLazyQuery>;
export type CpPaidEventFieldsSuspenseQueryHookResult = ReturnType<typeof useCpPaidEventFieldsSuspenseQuery>;
export type CpPaidEventFieldsQueryResult = Apollo.QueryResult<CpPaidEventFieldsQuery, CpPaidEventFieldsQueryVariables>;
export const EmailPhonePasswordStatusDocument = gql`
    query EmailPhonePasswordStatus {
  validPhoneRegions {
    id
    countryCode
  }
  profile {
    id
    email
    phone
    isPasswordSet
  }
}
    `;

/**
 * __useEmailPhonePasswordStatusQuery__
 *
 * To run a query within a React component, call `useEmailPhonePasswordStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailPhonePasswordStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailPhonePasswordStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useEmailPhonePasswordStatusQuery(baseOptions?: Apollo.QueryHookOptions<EmailPhonePasswordStatusQuery, EmailPhonePasswordStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailPhonePasswordStatusQuery, EmailPhonePasswordStatusQueryVariables>(EmailPhonePasswordStatusDocument, options);
      }
export function useEmailPhonePasswordStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailPhonePasswordStatusQuery, EmailPhonePasswordStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailPhonePasswordStatusQuery, EmailPhonePasswordStatusQueryVariables>(EmailPhonePasswordStatusDocument, options);
        }
export function useEmailPhonePasswordStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmailPhonePasswordStatusQuery, EmailPhonePasswordStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmailPhonePasswordStatusQuery, EmailPhonePasswordStatusQueryVariables>(EmailPhonePasswordStatusDocument, options);
        }
export type EmailPhonePasswordStatusQueryHookResult = ReturnType<typeof useEmailPhonePasswordStatusQuery>;
export type EmailPhonePasswordStatusLazyQueryHookResult = ReturnType<typeof useEmailPhonePasswordStatusLazyQuery>;
export type EmailPhonePasswordStatusSuspenseQueryHookResult = ReturnType<typeof useEmailPhonePasswordStatusSuspenseQuery>;
export type EmailPhonePasswordStatusQueryResult = Apollo.QueryResult<EmailPhonePasswordStatusQuery, EmailPhonePasswordStatusQueryVariables>;
export const CreateAccountCpJuniperDocument = gql`
    mutation CreateAccountCpJuniper($phone: String, $password: String) {
  updateProfile(phone: $phone, password: $password) {
    id
    phone
    isPasswordSet
  }
}
    `;
export type CreateAccountCpJuniperMutationFn = Apollo.MutationFunction<CreateAccountCpJuniperMutation, CreateAccountCpJuniperMutationVariables>;

/**
 * __useCreateAccountCpJuniperMutation__
 *
 * To run a mutation, you first call `useCreateAccountCpJuniperMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountCpJuniperMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountCpJuniperMutation, { data, loading, error }] = useCreateAccountCpJuniperMutation({
 *   variables: {
 *      phone: // value for 'phone'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useCreateAccountCpJuniperMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccountCpJuniperMutation, CreateAccountCpJuniperMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccountCpJuniperMutation, CreateAccountCpJuniperMutationVariables>(CreateAccountCpJuniperDocument, options);
      }
export type CreateAccountCpJuniperMutationHookResult = ReturnType<typeof useCreateAccountCpJuniperMutation>;
export type CreateAccountCpJuniperMutationResult = Apollo.MutationResult<CreateAccountCpJuniperMutation>;
export type CreateAccountCpJuniperMutationOptions = Apollo.BaseMutationOptions<CreateAccountCpJuniperMutation, CreateAccountCpJuniperMutationVariables>;
export const ConfirmConsultationJuniperDocument = gql`
    mutation ConfirmConsultationJuniper($id: String!, $couponCode: String) {
  payConsultation(id: $id, couponCode: $couponCode) {
    id
  }
}
    `;
export type ConfirmConsultationJuniperMutationFn = Apollo.MutationFunction<ConfirmConsultationJuniperMutation, ConfirmConsultationJuniperMutationVariables>;

/**
 * __useConfirmConsultationJuniperMutation__
 *
 * To run a mutation, you first call `useConfirmConsultationJuniperMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmConsultationJuniperMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmConsultationJuniperMutation, { data, loading, error }] = useConfirmConsultationJuniperMutation({
 *   variables: {
 *      id: // value for 'id'
 *      couponCode: // value for 'couponCode'
 *   },
 * });
 */
export function useConfirmConsultationJuniperMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmConsultationJuniperMutation, ConfirmConsultationJuniperMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmConsultationJuniperMutation, ConfirmConsultationJuniperMutationVariables>(ConfirmConsultationJuniperDocument, options);
      }
export type ConfirmConsultationJuniperMutationHookResult = ReturnType<typeof useConfirmConsultationJuniperMutation>;
export type ConfirmConsultationJuniperMutationResult = Apollo.MutationResult<ConfirmConsultationJuniperMutation>;
export type ConfirmConsultationJuniperMutationOptions = Apollo.BaseMutationOptions<ConfirmConsultationJuniperMutation, ConfirmConsultationJuniperMutationVariables>;
export const BillingDetailsDocument = gql`
    query BillingDetails {
  profile {
    ...BillingDetails
  }
}
    ${BillingDetailsFragmentDoc}`;

/**
 * __useBillingDetailsQuery__
 *
 * To run a query within a React component, call `useBillingDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useBillingDetailsQuery(baseOptions?: Apollo.QueryHookOptions<BillingDetailsQuery, BillingDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BillingDetailsQuery, BillingDetailsQueryVariables>(BillingDetailsDocument, options);
      }
export function useBillingDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BillingDetailsQuery, BillingDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BillingDetailsQuery, BillingDetailsQueryVariables>(BillingDetailsDocument, options);
        }
export function useBillingDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BillingDetailsQuery, BillingDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BillingDetailsQuery, BillingDetailsQueryVariables>(BillingDetailsDocument, options);
        }
export type BillingDetailsQueryHookResult = ReturnType<typeof useBillingDetailsQuery>;
export type BillingDetailsLazyQueryHookResult = ReturnType<typeof useBillingDetailsLazyQuery>;
export type BillingDetailsSuspenseQueryHookResult = ReturnType<typeof useBillingDetailsSuspenseQuery>;
export type BillingDetailsQueryResult = Apollo.QueryResult<BillingDetailsQuery, BillingDetailsQueryVariables>;
export const CommsAndPrivacyUserDetailsDocument = gql`
    query CommsAndPrivacyUserDetails {
  profile {
    id
    notificationPrefs {
      id
      personalisedMarketing
    }
  }
}
    `;

/**
 * __useCommsAndPrivacyUserDetailsQuery__
 *
 * To run a query within a React component, call `useCommsAndPrivacyUserDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommsAndPrivacyUserDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommsAndPrivacyUserDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCommsAndPrivacyUserDetailsQuery(baseOptions?: Apollo.QueryHookOptions<CommsAndPrivacyUserDetailsQuery, CommsAndPrivacyUserDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommsAndPrivacyUserDetailsQuery, CommsAndPrivacyUserDetailsQueryVariables>(CommsAndPrivacyUserDetailsDocument, options);
      }
export function useCommsAndPrivacyUserDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommsAndPrivacyUserDetailsQuery, CommsAndPrivacyUserDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommsAndPrivacyUserDetailsQuery, CommsAndPrivacyUserDetailsQueryVariables>(CommsAndPrivacyUserDetailsDocument, options);
        }
export function useCommsAndPrivacyUserDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CommsAndPrivacyUserDetailsQuery, CommsAndPrivacyUserDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CommsAndPrivacyUserDetailsQuery, CommsAndPrivacyUserDetailsQueryVariables>(CommsAndPrivacyUserDetailsDocument, options);
        }
export type CommsAndPrivacyUserDetailsQueryHookResult = ReturnType<typeof useCommsAndPrivacyUserDetailsQuery>;
export type CommsAndPrivacyUserDetailsLazyQueryHookResult = ReturnType<typeof useCommsAndPrivacyUserDetailsLazyQuery>;
export type CommsAndPrivacyUserDetailsSuspenseQueryHookResult = ReturnType<typeof useCommsAndPrivacyUserDetailsSuspenseQuery>;
export type CommsAndPrivacyUserDetailsQueryResult = Apollo.QueryResult<CommsAndPrivacyUserDetailsQuery, CommsAndPrivacyUserDetailsQueryVariables>;
export const UpdateNotificationPrefsDocument = gql`
    mutation UpdateNotificationPrefs($personalisedMarketing: Boolean!) {
  updateNotificationPrefs(personalisedMarketing: $personalisedMarketing) {
    user {
      id
      notificationPrefs {
        id
        personalisedMarketing
      }
    }
  }
}
    `;
export type UpdateNotificationPrefsMutationFn = Apollo.MutationFunction<UpdateNotificationPrefsMutation, UpdateNotificationPrefsMutationVariables>;

/**
 * __useUpdateNotificationPrefsMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationPrefsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationPrefsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationPrefsMutation, { data, loading, error }] = useUpdateNotificationPrefsMutation({
 *   variables: {
 *      personalisedMarketing: // value for 'personalisedMarketing'
 *   },
 * });
 */
export function useUpdateNotificationPrefsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationPrefsMutation, UpdateNotificationPrefsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotificationPrefsMutation, UpdateNotificationPrefsMutationVariables>(UpdateNotificationPrefsDocument, options);
      }
export type UpdateNotificationPrefsMutationHookResult = ReturnType<typeof useUpdateNotificationPrefsMutation>;
export type UpdateNotificationPrefsMutationResult = Apollo.MutationResult<UpdateNotificationPrefsMutation>;
export type UpdateNotificationPrefsMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationPrefsMutation, UpdateNotificationPrefsMutationVariables>;
export const ProfileWithDvaDocument = gql`
    query ProfileWithDva {
  profile {
    id
    dvaFileNumber
  }
}
    `;

/**
 * __useProfileWithDvaQuery__
 *
 * To run a query within a React component, call `useProfileWithDvaQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileWithDvaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileWithDvaQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfileWithDvaQuery(baseOptions?: Apollo.QueryHookOptions<ProfileWithDvaQuery, ProfileWithDvaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileWithDvaQuery, ProfileWithDvaQueryVariables>(ProfileWithDvaDocument, options);
      }
export function useProfileWithDvaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileWithDvaQuery, ProfileWithDvaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileWithDvaQuery, ProfileWithDvaQueryVariables>(ProfileWithDvaDocument, options);
        }
export function useProfileWithDvaSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProfileWithDvaQuery, ProfileWithDvaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProfileWithDvaQuery, ProfileWithDvaQueryVariables>(ProfileWithDvaDocument, options);
        }
export type ProfileWithDvaQueryHookResult = ReturnType<typeof useProfileWithDvaQuery>;
export type ProfileWithDvaLazyQueryHookResult = ReturnType<typeof useProfileWithDvaLazyQuery>;
export type ProfileWithDvaSuspenseQueryHookResult = ReturnType<typeof useProfileWithDvaSuspenseQuery>;
export type ProfileWithDvaQueryResult = Apollo.QueryResult<ProfileWithDvaQuery, ProfileWithDvaQueryVariables>;
export const UpsertDvaFileNumberDocument = gql`
    mutation UpsertDvaFileNumber($input: UpsertDvaFileNumberInput!) {
  upsertDvaFileNumber(input: $input) {
    user {
      id
      dvaFileNumber
    }
  }
}
    `;
export type UpsertDvaFileNumberMutationFn = Apollo.MutationFunction<UpsertDvaFileNumberMutation, UpsertDvaFileNumberMutationVariables>;

/**
 * __useUpsertDvaFileNumberMutation__
 *
 * To run a mutation, you first call `useUpsertDvaFileNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertDvaFileNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertDvaFileNumberMutation, { data, loading, error }] = useUpsertDvaFileNumberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertDvaFileNumberMutation(baseOptions?: Apollo.MutationHookOptions<UpsertDvaFileNumberMutation, UpsertDvaFileNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertDvaFileNumberMutation, UpsertDvaFileNumberMutationVariables>(UpsertDvaFileNumberDocument, options);
      }
export type UpsertDvaFileNumberMutationHookResult = ReturnType<typeof useUpsertDvaFileNumberMutation>;
export type UpsertDvaFileNumberMutationResult = Apollo.MutationResult<UpsertDvaFileNumberMutation>;
export type UpsertDvaFileNumberMutationOptions = Apollo.BaseMutationOptions<UpsertDvaFileNumberMutation, UpsertDvaFileNumberMutationVariables>;
export const MedicareDetailsDocument = gql`
    query MedicareDetails {
  profile {
    id
    healthCareDetails {
      id
      hasMedicareDetails
    }
  }
}
    `;

/**
 * __useMedicareDetailsQuery__
 *
 * To run a query within a React component, call `useMedicareDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedicareDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedicareDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMedicareDetailsQuery(baseOptions?: Apollo.QueryHookOptions<MedicareDetailsQuery, MedicareDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MedicareDetailsQuery, MedicareDetailsQueryVariables>(MedicareDetailsDocument, options);
      }
export function useMedicareDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MedicareDetailsQuery, MedicareDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MedicareDetailsQuery, MedicareDetailsQueryVariables>(MedicareDetailsDocument, options);
        }
export function useMedicareDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MedicareDetailsQuery, MedicareDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MedicareDetailsQuery, MedicareDetailsQueryVariables>(MedicareDetailsDocument, options);
        }
export type MedicareDetailsQueryHookResult = ReturnType<typeof useMedicareDetailsQuery>;
export type MedicareDetailsLazyQueryHookResult = ReturnType<typeof useMedicareDetailsLazyQuery>;
export type MedicareDetailsSuspenseQueryHookResult = ReturnType<typeof useMedicareDetailsSuspenseQuery>;
export type MedicareDetailsQueryResult = Apollo.QueryResult<MedicareDetailsQuery, MedicareDetailsQueryVariables>;
export const UpdateProfileUserDetailsDocument = gql`
    mutation UpdateProfileUserDetails($firstName: String!, $lastName: String!, $phone: String!) {
  updateProfile(firstName: $firstName, lastName: $lastName, phone: $phone) {
    id
    firstName
    lastName
    email
    shortAddressableName
    fullName
    phone
  }
}
    `;
export type UpdateProfileUserDetailsMutationFn = Apollo.MutationFunction<UpdateProfileUserDetailsMutation, UpdateProfileUserDetailsMutationVariables>;

/**
 * __useUpdateProfileUserDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateProfileUserDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileUserDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileUserDetailsMutation, { data, loading, error }] = useUpdateProfileUserDetailsMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useUpdateProfileUserDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProfileUserDetailsMutation, UpdateProfileUserDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProfileUserDetailsMutation, UpdateProfileUserDetailsMutationVariables>(UpdateProfileUserDetailsDocument, options);
      }
export type UpdateProfileUserDetailsMutationHookResult = ReturnType<typeof useUpdateProfileUserDetailsMutation>;
export type UpdateProfileUserDetailsMutationResult = Apollo.MutationResult<UpdateProfileUserDetailsMutation>;
export type UpdateProfileUserDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateProfileUserDetailsMutation, UpdateProfileUserDetailsMutationVariables>;
export const RestartFlowDocument = gql`
    mutation RestartFlow($input: RestartFlowInput!) {
  restartFlow(input: $input) {
    consultation {
      id
    }
  }
}
    `;
export type RestartFlowMutationFn = Apollo.MutationFunction<RestartFlowMutation, RestartFlowMutationVariables>;

/**
 * __useRestartFlowMutation__
 *
 * To run a mutation, you first call `useRestartFlowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestartFlowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restartFlowMutation, { data, loading, error }] = useRestartFlowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestartFlowMutation(baseOptions?: Apollo.MutationHookOptions<RestartFlowMutation, RestartFlowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestartFlowMutation, RestartFlowMutationVariables>(RestartFlowDocument, options);
      }
export type RestartFlowMutationHookResult = ReturnType<typeof useRestartFlowMutation>;
export type RestartFlowMutationResult = Apollo.MutationResult<RestartFlowMutation>;
export type RestartFlowMutationOptions = Apollo.BaseMutationOptions<RestartFlowMutation, RestartFlowMutationVariables>;
export const ResumePurchaseDocument = gql`
    mutation ResumePurchase($input: ResumePurchaseInput!) {
  resumePurchase(input: $input) {
    purchase {
      id
      status
      isVisibleInProfilePage
      availableActions {
        id
      }
    }
  }
}
    `;
export type ResumePurchaseMutationFn = Apollo.MutationFunction<ResumePurchaseMutation, ResumePurchaseMutationVariables>;

/**
 * __useResumePurchaseMutation__
 *
 * To run a mutation, you first call `useResumePurchaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResumePurchaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resumePurchaseMutation, { data, loading, error }] = useResumePurchaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResumePurchaseMutation(baseOptions?: Apollo.MutationHookOptions<ResumePurchaseMutation, ResumePurchaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResumePurchaseMutation, ResumePurchaseMutationVariables>(ResumePurchaseDocument, options);
      }
export type ResumePurchaseMutationHookResult = ReturnType<typeof useResumePurchaseMutation>;
export type ResumePurchaseMutationResult = Apollo.MutationResult<ResumePurchaseMutation>;
export type ResumePurchaseMutationOptions = Apollo.BaseMutationOptions<ResumePurchaseMutation, ResumePurchaseMutationVariables>;
export const RefillTreatmentRestartTreatmentJuniperDocument = gql`
    mutation RefillTreatmentRestartTreatmentJuniper($treatmentId: String!) {
  refillTreatment(treatmentId: $treatmentId) {
    id
    status
    refillsLeft
    nextPayment
  }
}
    `;
export type RefillTreatmentRestartTreatmentJuniperMutationFn = Apollo.MutationFunction<RefillTreatmentRestartTreatmentJuniperMutation, RefillTreatmentRestartTreatmentJuniperMutationVariables>;

/**
 * __useRefillTreatmentRestartTreatmentJuniperMutation__
 *
 * To run a mutation, you first call `useRefillTreatmentRestartTreatmentJuniperMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefillTreatmentRestartTreatmentJuniperMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refillTreatmentRestartTreatmentJuniperMutation, { data, loading, error }] = useRefillTreatmentRestartTreatmentJuniperMutation({
 *   variables: {
 *      treatmentId: // value for 'treatmentId'
 *   },
 * });
 */
export function useRefillTreatmentRestartTreatmentJuniperMutation(baseOptions?: Apollo.MutationHookOptions<RefillTreatmentRestartTreatmentJuniperMutation, RefillTreatmentRestartTreatmentJuniperMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefillTreatmentRestartTreatmentJuniperMutation, RefillTreatmentRestartTreatmentJuniperMutationVariables>(RefillTreatmentRestartTreatmentJuniperDocument, options);
      }
export type RefillTreatmentRestartTreatmentJuniperMutationHookResult = ReturnType<typeof useRefillTreatmentRestartTreatmentJuniperMutation>;
export type RefillTreatmentRestartTreatmentJuniperMutationResult = Apollo.MutationResult<RefillTreatmentRestartTreatmentJuniperMutation>;
export type RefillTreatmentRestartTreatmentJuniperMutationOptions = Apollo.BaseMutationOptions<RefillTreatmentRestartTreatmentJuniperMutation, RefillTreatmentRestartTreatmentJuniperMutationVariables>;
export const PilotShippingDetailsDocument = gql`
    query PilotShippingDetails {
  profile {
    id
    weightTreatmentCategory
    address {
      id
      line1
      line2
      city
      state
      postalCode
      country
      building
      company
    }
  }
}
    `;

/**
 * __usePilotShippingDetailsQuery__
 *
 * To run a query within a React component, call `usePilotShippingDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePilotShippingDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePilotShippingDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePilotShippingDetailsQuery(baseOptions?: Apollo.QueryHookOptions<PilotShippingDetailsQuery, PilotShippingDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PilotShippingDetailsQuery, PilotShippingDetailsQueryVariables>(PilotShippingDetailsDocument, options);
      }
export function usePilotShippingDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PilotShippingDetailsQuery, PilotShippingDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PilotShippingDetailsQuery, PilotShippingDetailsQueryVariables>(PilotShippingDetailsDocument, options);
        }
export function usePilotShippingDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PilotShippingDetailsQuery, PilotShippingDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PilotShippingDetailsQuery, PilotShippingDetailsQueryVariables>(PilotShippingDetailsDocument, options);
        }
export type PilotShippingDetailsQueryHookResult = ReturnType<typeof usePilotShippingDetailsQuery>;
export type PilotShippingDetailsLazyQueryHookResult = ReturnType<typeof usePilotShippingDetailsLazyQuery>;
export type PilotShippingDetailsSuspenseQueryHookResult = ReturnType<typeof usePilotShippingDetailsSuspenseQuery>;
export type PilotShippingDetailsQueryResult = Apollo.QueryResult<PilotShippingDetailsQuery, PilotShippingDetailsQueryVariables>;
export const UpdateShippingProfileAccountDocument = gql`
    mutation UpdateShippingProfileAccount($address: AddressCreateWithoutUserInput!) {
  updateShipping(address: $address) {
    id
    address {
      id
      line1
      line2
      city
      postalCode
      prefecture
      municipality
      townArea
      state
      country
      building
      company
    }
  }
}
    `;
export type UpdateShippingProfileAccountMutationFn = Apollo.MutationFunction<UpdateShippingProfileAccountMutation, UpdateShippingProfileAccountMutationVariables>;

/**
 * __useUpdateShippingProfileAccountMutation__
 *
 * To run a mutation, you first call `useUpdateShippingProfileAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShippingProfileAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShippingProfileAccountMutation, { data, loading, error }] = useUpdateShippingProfileAccountMutation({
 *   variables: {
 *      address: // value for 'address'
 *   },
 * });
 */
export function useUpdateShippingProfileAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateShippingProfileAccountMutation, UpdateShippingProfileAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateShippingProfileAccountMutation, UpdateShippingProfileAccountMutationVariables>(UpdateShippingProfileAccountDocument, options);
      }
export type UpdateShippingProfileAccountMutationHookResult = ReturnType<typeof useUpdateShippingProfileAccountMutation>;
export type UpdateShippingProfileAccountMutationResult = Apollo.MutationResult<UpdateShippingProfileAccountMutation>;
export type UpdateShippingProfileAccountMutationOptions = Apollo.BaseMutationOptions<UpdateShippingProfileAccountMutation, UpdateShippingProfileAccountMutationVariables>;
export const JuniperProfileShippingDetailsRangeDocument = gql`
    query JuniperProfileShippingDetailsRange($line1: String!, $line2: String, $suburb: String!, $postcode: String!) {
  shippingAddressWithinRange(
    line1: $line1
    line2: $line2
    postcode: $postcode
    suburb: $suburb
  )
}
    `;

/**
 * __useJuniperProfileShippingDetailsRangeQuery__
 *
 * To run a query within a React component, call `useJuniperProfileShippingDetailsRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useJuniperProfileShippingDetailsRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJuniperProfileShippingDetailsRangeQuery({
 *   variables: {
 *      line1: // value for 'line1'
 *      line2: // value for 'line2'
 *      suburb: // value for 'suburb'
 *      postcode: // value for 'postcode'
 *   },
 * });
 */
export function useJuniperProfileShippingDetailsRangeQuery(baseOptions: Apollo.QueryHookOptions<JuniperProfileShippingDetailsRangeQuery, JuniperProfileShippingDetailsRangeQueryVariables> & ({ variables: JuniperProfileShippingDetailsRangeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JuniperProfileShippingDetailsRangeQuery, JuniperProfileShippingDetailsRangeQueryVariables>(JuniperProfileShippingDetailsRangeDocument, options);
      }
export function useJuniperProfileShippingDetailsRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JuniperProfileShippingDetailsRangeQuery, JuniperProfileShippingDetailsRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JuniperProfileShippingDetailsRangeQuery, JuniperProfileShippingDetailsRangeQueryVariables>(JuniperProfileShippingDetailsRangeDocument, options);
        }
export function useJuniperProfileShippingDetailsRangeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JuniperProfileShippingDetailsRangeQuery, JuniperProfileShippingDetailsRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JuniperProfileShippingDetailsRangeQuery, JuniperProfileShippingDetailsRangeQueryVariables>(JuniperProfileShippingDetailsRangeDocument, options);
        }
export type JuniperProfileShippingDetailsRangeQueryHookResult = ReturnType<typeof useJuniperProfileShippingDetailsRangeQuery>;
export type JuniperProfileShippingDetailsRangeLazyQueryHookResult = ReturnType<typeof useJuniperProfileShippingDetailsRangeLazyQuery>;
export type JuniperProfileShippingDetailsRangeSuspenseQueryHookResult = ReturnType<typeof useJuniperProfileShippingDetailsRangeSuspenseQuery>;
export type JuniperProfileShippingDetailsRangeQueryResult = Apollo.QueryResult<JuniperProfileShippingDetailsRangeQuery, JuniperProfileShippingDetailsRangeQueryVariables>;
export const PilotProfileShippingDetailsRangeDocument = gql`
    query PilotProfileShippingDetailsRange($line1: String!, $line2: String, $suburb: String!, $postcode: String!) {
  shippingAddressWithinRange(
    line1: $line1
    line2: $line2
    postcode: $postcode
    suburb: $suburb
  )
}
    `;

/**
 * __usePilotProfileShippingDetailsRangeQuery__
 *
 * To run a query within a React component, call `usePilotProfileShippingDetailsRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `usePilotProfileShippingDetailsRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePilotProfileShippingDetailsRangeQuery({
 *   variables: {
 *      line1: // value for 'line1'
 *      line2: // value for 'line2'
 *      suburb: // value for 'suburb'
 *      postcode: // value for 'postcode'
 *   },
 * });
 */
export function usePilotProfileShippingDetailsRangeQuery(baseOptions: Apollo.QueryHookOptions<PilotProfileShippingDetailsRangeQuery, PilotProfileShippingDetailsRangeQueryVariables> & ({ variables: PilotProfileShippingDetailsRangeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PilotProfileShippingDetailsRangeQuery, PilotProfileShippingDetailsRangeQueryVariables>(PilotProfileShippingDetailsRangeDocument, options);
      }
export function usePilotProfileShippingDetailsRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PilotProfileShippingDetailsRangeQuery, PilotProfileShippingDetailsRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PilotProfileShippingDetailsRangeQuery, PilotProfileShippingDetailsRangeQueryVariables>(PilotProfileShippingDetailsRangeDocument, options);
        }
export function usePilotProfileShippingDetailsRangeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PilotProfileShippingDetailsRangeQuery, PilotProfileShippingDetailsRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PilotProfileShippingDetailsRangeQuery, PilotProfileShippingDetailsRangeQueryVariables>(PilotProfileShippingDetailsRangeDocument, options);
        }
export type PilotProfileShippingDetailsRangeQueryHookResult = ReturnType<typeof usePilotProfileShippingDetailsRangeQuery>;
export type PilotProfileShippingDetailsRangeLazyQueryHookResult = ReturnType<typeof usePilotProfileShippingDetailsRangeLazyQuery>;
export type PilotProfileShippingDetailsRangeSuspenseQueryHookResult = ReturnType<typeof usePilotProfileShippingDetailsRangeSuspenseQuery>;
export type PilotProfileShippingDetailsRangeQueryResult = Apollo.QueryResult<PilotProfileShippingDetailsRangeQuery, PilotProfileShippingDetailsRangeQueryVariables>;
export const UserDetailsDocument = gql`
    query UserDetails {
  profile {
    id
    fullName
    phone
    email
    residentialAddress {
      id
      line1
      line2
      city
      postalCode
      state
      country
    }
  }
}
    `;

/**
 * __useUserDetailsQuery__
 *
 * To run a query within a React component, call `useUserDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserDetailsQuery(baseOptions?: Apollo.QueryHookOptions<UserDetailsQuery, UserDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserDetailsQuery, UserDetailsQueryVariables>(UserDetailsDocument, options);
      }
export function useUserDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserDetailsQuery, UserDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserDetailsQuery, UserDetailsQueryVariables>(UserDetailsDocument, options);
        }
export function useUserDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserDetailsQuery, UserDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserDetailsQuery, UserDetailsQueryVariables>(UserDetailsDocument, options);
        }
export type UserDetailsQueryHookResult = ReturnType<typeof useUserDetailsQuery>;
export type UserDetailsLazyQueryHookResult = ReturnType<typeof useUserDetailsLazyQuery>;
export type UserDetailsSuspenseQueryHookResult = ReturnType<typeof useUserDetailsSuspenseQuery>;
export type UserDetailsQueryResult = Apollo.QueryResult<UserDetailsQuery, UserDetailsQueryVariables>;
export const TreatedForWeightLossDocument = gql`
    query TreatedForWeightLoss {
  profile {
    id
    isBeingTreated(problemType: WEIGHT_LOSS)
  }
}
    `;

/**
 * __useTreatedForWeightLossQuery__
 *
 * To run a query within a React component, call `useTreatedForWeightLossQuery` and pass it any options that fit your needs.
 * When your component renders, `useTreatedForWeightLossQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTreatedForWeightLossQuery({
 *   variables: {
 *   },
 * });
 */
export function useTreatedForWeightLossQuery(baseOptions?: Apollo.QueryHookOptions<TreatedForWeightLossQuery, TreatedForWeightLossQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TreatedForWeightLossQuery, TreatedForWeightLossQueryVariables>(TreatedForWeightLossDocument, options);
      }
export function useTreatedForWeightLossLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TreatedForWeightLossQuery, TreatedForWeightLossQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TreatedForWeightLossQuery, TreatedForWeightLossQueryVariables>(TreatedForWeightLossDocument, options);
        }
export function useTreatedForWeightLossSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TreatedForWeightLossQuery, TreatedForWeightLossQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TreatedForWeightLossQuery, TreatedForWeightLossQueryVariables>(TreatedForWeightLossDocument, options);
        }
export type TreatedForWeightLossQueryHookResult = ReturnType<typeof useTreatedForWeightLossQuery>;
export type TreatedForWeightLossLazyQueryHookResult = ReturnType<typeof useTreatedForWeightLossLazyQuery>;
export type TreatedForWeightLossSuspenseQueryHookResult = ReturnType<typeof useTreatedForWeightLossSuspenseQuery>;
export type TreatedForWeightLossQueryResult = Apollo.QueryResult<TreatedForWeightLossQuery, TreatedForWeightLossQueryVariables>;
export const QuizQuestionWeightLossGraphDocument = gql`
    query QuizQuestionWeightLossGraph {
  profile {
    id
    firstName
    shortAddressableName
    preferredUnitSystem
  }
}
    `;

/**
 * __useQuizQuestionWeightLossGraphQuery__
 *
 * To run a query within a React component, call `useQuizQuestionWeightLossGraphQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuizQuestionWeightLossGraphQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuizQuestionWeightLossGraphQuery({
 *   variables: {
 *   },
 * });
 */
export function useQuizQuestionWeightLossGraphQuery(baseOptions?: Apollo.QueryHookOptions<QuizQuestionWeightLossGraphQuery, QuizQuestionWeightLossGraphQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuizQuestionWeightLossGraphQuery, QuizQuestionWeightLossGraphQueryVariables>(QuizQuestionWeightLossGraphDocument, options);
      }
export function useQuizQuestionWeightLossGraphLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuizQuestionWeightLossGraphQuery, QuizQuestionWeightLossGraphQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuizQuestionWeightLossGraphQuery, QuizQuestionWeightLossGraphQueryVariables>(QuizQuestionWeightLossGraphDocument, options);
        }
export function useQuizQuestionWeightLossGraphSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QuizQuestionWeightLossGraphQuery, QuizQuestionWeightLossGraphQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QuizQuestionWeightLossGraphQuery, QuizQuestionWeightLossGraphQueryVariables>(QuizQuestionWeightLossGraphDocument, options);
        }
export type QuizQuestionWeightLossGraphQueryHookResult = ReturnType<typeof useQuizQuestionWeightLossGraphQuery>;
export type QuizQuestionWeightLossGraphLazyQueryHookResult = ReturnType<typeof useQuizQuestionWeightLossGraphLazyQuery>;
export type QuizQuestionWeightLossGraphSuspenseQueryHookResult = ReturnType<typeof useQuizQuestionWeightLossGraphSuspenseQuery>;
export type QuizQuestionWeightLossGraphQueryResult = Apollo.QueryResult<QuizQuestionWeightLossGraphQuery, QuizQuestionWeightLossGraphQueryVariables>;
export const DefaultUnitSystemDocument = gql`
    query DefaultUnitSystem {
  profile {
    id
    preferredUnitSystem
  }
}
    `;

/**
 * __useDefaultUnitSystemQuery__
 *
 * To run a query within a React component, call `useDefaultUnitSystemQuery` and pass it any options that fit your needs.
 * When your component renders, `useDefaultUnitSystemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDefaultUnitSystemQuery({
 *   variables: {
 *   },
 * });
 */
export function useDefaultUnitSystemQuery(baseOptions?: Apollo.QueryHookOptions<DefaultUnitSystemQuery, DefaultUnitSystemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DefaultUnitSystemQuery, DefaultUnitSystemQueryVariables>(DefaultUnitSystemDocument, options);
      }
export function useDefaultUnitSystemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DefaultUnitSystemQuery, DefaultUnitSystemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DefaultUnitSystemQuery, DefaultUnitSystemQueryVariables>(DefaultUnitSystemDocument, options);
        }
export function useDefaultUnitSystemSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DefaultUnitSystemQuery, DefaultUnitSystemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DefaultUnitSystemQuery, DefaultUnitSystemQueryVariables>(DefaultUnitSystemDocument, options);
        }
export type DefaultUnitSystemQueryHookResult = ReturnType<typeof useDefaultUnitSystemQuery>;
export type DefaultUnitSystemLazyQueryHookResult = ReturnType<typeof useDefaultUnitSystemLazyQuery>;
export type DefaultUnitSystemSuspenseQueryHookResult = ReturnType<typeof useDefaultUnitSystemSuspenseQuery>;
export type DefaultUnitSystemQueryResult = Apollo.QueryResult<DefaultUnitSystemQuery, DefaultUnitSystemQueryVariables>;
export const QuizConsultationDocument = gql`
    query QuizConsultation($id: String!) {
  customerAttributes {
    id
    conditions
    medications
    allergies
  }
  getQuizApplication(id: $id) {
    ...QuizApplication
  }
}
    ${QuizApplicationFragmentDoc}`;

/**
 * __useQuizConsultationQuery__
 *
 * To run a query within a React component, call `useQuizConsultationQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuizConsultationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuizConsultationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useQuizConsultationQuery(baseOptions: Apollo.QueryHookOptions<QuizConsultationQuery, QuizConsultationQueryVariables> & ({ variables: QuizConsultationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuizConsultationQuery, QuizConsultationQueryVariables>(QuizConsultationDocument, options);
      }
export function useQuizConsultationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuizConsultationQuery, QuizConsultationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuizConsultationQuery, QuizConsultationQueryVariables>(QuizConsultationDocument, options);
        }
export function useQuizConsultationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QuizConsultationQuery, QuizConsultationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QuizConsultationQuery, QuizConsultationQueryVariables>(QuizConsultationDocument, options);
        }
export type QuizConsultationQueryHookResult = ReturnType<typeof useQuizConsultationQuery>;
export type QuizConsultationLazyQueryHookResult = ReturnType<typeof useQuizConsultationLazyQuery>;
export type QuizConsultationSuspenseQueryHookResult = ReturnType<typeof useQuizConsultationSuspenseQuery>;
export type QuizConsultationQueryResult = Apollo.QueryResult<QuizConsultationQuery, QuizConsultationQueryVariables>;
export const AnswerApplicationQuestionDocument = gql`
    mutation AnswerApplicationQuestion($applicationId: String!, $questionId: String!, $answer: String, $answersArray: [String!], $answerId: String, $optionIds: [String!]) {
  answerApplicationQuestion(
    applicationId: $applicationId
    questionId: $questionId
    answer: $answer
    answersArray: $answersArray
    answerId: $answerId
    optionIds: $optionIds
  ) {
    ...QuizApplicationAnswer
  }
}
    ${QuizApplicationAnswerFragmentDoc}`;
export type AnswerApplicationQuestionMutationFn = Apollo.MutationFunction<AnswerApplicationQuestionMutation, AnswerApplicationQuestionMutationVariables>;

/**
 * __useAnswerApplicationQuestionMutation__
 *
 * To run a mutation, you first call `useAnswerApplicationQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnswerApplicationQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [answerApplicationQuestionMutation, { data, loading, error }] = useAnswerApplicationQuestionMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      questionId: // value for 'questionId'
 *      answer: // value for 'answer'
 *      answersArray: // value for 'answersArray'
 *      answerId: // value for 'answerId'
 *      optionIds: // value for 'optionIds'
 *   },
 * });
 */
export function useAnswerApplicationQuestionMutation(baseOptions?: Apollo.MutationHookOptions<AnswerApplicationQuestionMutation, AnswerApplicationQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnswerApplicationQuestionMutation, AnswerApplicationQuestionMutationVariables>(AnswerApplicationQuestionDocument, options);
      }
export type AnswerApplicationQuestionMutationHookResult = ReturnType<typeof useAnswerApplicationQuestionMutation>;
export type AnswerApplicationQuestionMutationResult = Apollo.MutationResult<AnswerApplicationQuestionMutation>;
export type AnswerApplicationQuestionMutationOptions = Apollo.BaseMutationOptions<AnswerApplicationQuestionMutation, AnswerApplicationQuestionMutationVariables>;
export const SubmitApplicationDocument = gql`
    mutation SubmitApplication($id: String!) {
  submitApplication(id: $id) {
    id
    ...QuizApplicationAnswer
  }
}
    ${QuizApplicationAnswerFragmentDoc}`;
export type SubmitApplicationMutationFn = Apollo.MutationFunction<SubmitApplicationMutation, SubmitApplicationMutationVariables>;

/**
 * __useSubmitApplicationMutation__
 *
 * To run a mutation, you first call `useSubmitApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitApplicationMutation, { data, loading, error }] = useSubmitApplicationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSubmitApplicationMutation(baseOptions?: Apollo.MutationHookOptions<SubmitApplicationMutation, SubmitApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitApplicationMutation, SubmitApplicationMutationVariables>(SubmitApplicationDocument, options);
      }
export type SubmitApplicationMutationHookResult = ReturnType<typeof useSubmitApplicationMutation>;
export type SubmitApplicationMutationResult = Apollo.MutationResult<SubmitApplicationMutation>;
export type SubmitApplicationMutationOptions = Apollo.BaseMutationOptions<SubmitApplicationMutation, SubmitApplicationMutationVariables>;
export const AnswerApplicationQuestionsDocument = gql`
    mutation AnswerApplicationQuestions($applicationId: String!, $answers: [AnswerInput]) {
  answerApplicationQuestions(applicationId: $applicationId, answers: $answers) {
    ...QuizApplicationAnswer
  }
}
    ${QuizApplicationAnswerFragmentDoc}`;
export type AnswerApplicationQuestionsMutationFn = Apollo.MutationFunction<AnswerApplicationQuestionsMutation, AnswerApplicationQuestionsMutationVariables>;

/**
 * __useAnswerApplicationQuestionsMutation__
 *
 * To run a mutation, you first call `useAnswerApplicationQuestionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnswerApplicationQuestionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [answerApplicationQuestionsMutation, { data, loading, error }] = useAnswerApplicationQuestionsMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      answers: // value for 'answers'
 *   },
 * });
 */
export function useAnswerApplicationQuestionsMutation(baseOptions?: Apollo.MutationHookOptions<AnswerApplicationQuestionsMutation, AnswerApplicationQuestionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnswerApplicationQuestionsMutation, AnswerApplicationQuestionsMutationVariables>(AnswerApplicationQuestionsDocument, options);
      }
export type AnswerApplicationQuestionsMutationHookResult = ReturnType<typeof useAnswerApplicationQuestionsMutation>;
export type AnswerApplicationQuestionsMutationResult = Apollo.MutationResult<AnswerApplicationQuestionsMutation>;
export type AnswerApplicationQuestionsMutationOptions = Apollo.BaseMutationOptions<AnswerApplicationQuestionsMutation, AnswerApplicationQuestionsMutationVariables>;
export const QuizPageDocument = gql`
    query QuizPage($id: String!) {
  customerAttributes {
    id
    conditions
    medications
    allergies
  }
  getQuizApplication(id: $id) {
    ...QuizApplication
  }
}
    ${QuizApplicationFragmentDoc}`;

/**
 * __useQuizPageQuery__
 *
 * To run a query within a React component, call `useQuizPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuizPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuizPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useQuizPageQuery(baseOptions: Apollo.QueryHookOptions<QuizPageQuery, QuizPageQueryVariables> & ({ variables: QuizPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuizPageQuery, QuizPageQueryVariables>(QuizPageDocument, options);
      }
export function useQuizPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuizPageQuery, QuizPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuizPageQuery, QuizPageQueryVariables>(QuizPageDocument, options);
        }
export function useQuizPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QuizPageQuery, QuizPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QuizPageQuery, QuizPageQueryVariables>(QuizPageDocument, options);
        }
export type QuizPageQueryHookResult = ReturnType<typeof useQuizPageQuery>;
export type QuizPageLazyQueryHookResult = ReturnType<typeof useQuizPageLazyQuery>;
export type QuizPageSuspenseQueryHookResult = ReturnType<typeof useQuizPageSuspenseQuery>;
export type QuizPageQueryResult = Apollo.QueryResult<QuizPageQuery, QuizPageQueryVariables>;
export const InitialAttributesDocument = gql`
    query InitialAttributes {
  profile {
    id
    fullName
    preferredUnitSystem
  }
}
    `;

/**
 * __useInitialAttributesQuery__
 *
 * To run a query within a React component, call `useInitialAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInitialAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInitialAttributesQuery({
 *   variables: {
 *   },
 * });
 */
export function useInitialAttributesQuery(baseOptions?: Apollo.QueryHookOptions<InitialAttributesQuery, InitialAttributesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InitialAttributesQuery, InitialAttributesQueryVariables>(InitialAttributesDocument, options);
      }
export function useInitialAttributesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InitialAttributesQuery, InitialAttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InitialAttributesQuery, InitialAttributesQueryVariables>(InitialAttributesDocument, options);
        }
export function useInitialAttributesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InitialAttributesQuery, InitialAttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InitialAttributesQuery, InitialAttributesQueryVariables>(InitialAttributesDocument, options);
        }
export type InitialAttributesQueryHookResult = ReturnType<typeof useInitialAttributesQuery>;
export type InitialAttributesLazyQueryHookResult = ReturnType<typeof useInitialAttributesLazyQuery>;
export type InitialAttributesSuspenseQueryHookResult = ReturnType<typeof useInitialAttributesSuspenseQuery>;
export type InitialAttributesQueryResult = Apollo.QueryResult<InitialAttributesQuery, InitialAttributesQueryVariables>;
export const UpdateShippingAddressDocument = gql`
    mutation UpdateShippingAddress($address: AddressCreateWithoutUserInput!) {
  updateShipping(address: $address) {
    id
    address {
      id
      line1
      line2
      city
      postalCode
      state
      country
      building
      company
    }
  }
}
    `;
export type UpdateShippingAddressMutationFn = Apollo.MutationFunction<UpdateShippingAddressMutation, UpdateShippingAddressMutationVariables>;

/**
 * __useUpdateShippingAddressMutation__
 *
 * To run a mutation, you first call `useUpdateShippingAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShippingAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShippingAddressMutation, { data, loading, error }] = useUpdateShippingAddressMutation({
 *   variables: {
 *      address: // value for 'address'
 *   },
 * });
 */
export function useUpdateShippingAddressMutation(baseOptions?: Apollo.MutationHookOptions<UpdateShippingAddressMutation, UpdateShippingAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateShippingAddressMutation, UpdateShippingAddressMutationVariables>(UpdateShippingAddressDocument, options);
      }
export type UpdateShippingAddressMutationHookResult = ReturnType<typeof useUpdateShippingAddressMutation>;
export type UpdateShippingAddressMutationResult = Apollo.MutationResult<UpdateShippingAddressMutation>;
export type UpdateShippingAddressMutationOptions = Apollo.BaseMutationOptions<UpdateShippingAddressMutation, UpdateShippingAddressMutationVariables>;
export const LoginDocument = gql`
    mutation Login($email: String!, $password: String!) {
  auth: login(email: $email, password: $password) {
    token
    user {
      id
      firstName
      lastName
      shortAddressableName
      fullName
      email
    }
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const TriggerPasswordResetDocument = gql`
    mutation TriggerPasswordReset($email: String!) {
  triggerPasswordReset(email: $email) {
    ok
  }
}
    `;
export type TriggerPasswordResetMutationFn = Apollo.MutationFunction<TriggerPasswordResetMutation, TriggerPasswordResetMutationVariables>;

/**
 * __useTriggerPasswordResetMutation__
 *
 * To run a mutation, you first call `useTriggerPasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerPasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerPasswordResetMutation, { data, loading, error }] = useTriggerPasswordResetMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useTriggerPasswordResetMutation(baseOptions?: Apollo.MutationHookOptions<TriggerPasswordResetMutation, TriggerPasswordResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerPasswordResetMutation, TriggerPasswordResetMutationVariables>(TriggerPasswordResetDocument, options);
      }
export type TriggerPasswordResetMutationHookResult = ReturnType<typeof useTriggerPasswordResetMutation>;
export type TriggerPasswordResetMutationResult = Apollo.MutationResult<TriggerPasswordResetMutation>;
export type TriggerPasswordResetMutationOptions = Apollo.BaseMutationOptions<TriggerPasswordResetMutation, TriggerPasswordResetMutationVariables>;
export const UseProfileDocument = gql`
    query UseProfile($withSubscriptions: Boolean = false) {
  profile {
    id
    firstName
    lastName
    shortAddressableName
    fullName
    legalFirstName
    legalLastName
    legalFullName
    preferredName
    email
    phone
    isVerified
    birthday
    hasPaidMasterclass
    needsSubscriptionMigration
    isPasswordSet
    weightTreatmentCategory
    ...BillingDetails
    preferredUnitSystem
    address {
      id
      line1
      line2
      city
      state
      postalCode
      prefecture
      municipality
      townArea
      country
      building
      company
    }
    residentialAddress {
      id
      line1
      line2
      city
      state
      postalCode
      prefecture
      municipality
      townArea
      country
      building
      company
    }
    consultations(orderBy: {createdAt: desc}) {
      id
      type
      status
      allowPatientToSendMessageToDoctor
      isApproved
      stage
      patientNotes
      rejectReason
      medium
      completedAt
      updatedAt
      createdAt
      patientQuestions {
        id
        createdAt
      }
      appointment {
        startsAt
        endsAt
      }
      doctor {
        id
        firstName
        lastName
        shortClinicianName
        fullClinicianName
        fullName
        provider {
          id
          clinicianType
          clinicianTitle
        }
      }
      isUpfrontPayment
      latestPractitionerBooking {
        id
        windowStartAt
        windowEndAt
      }
      requiresPrescriberCall
      isInNoPickUpQueue
      screeningQuizApplication {
        id
        submittedAt
      }
      chatThread {
        id
      }
      quizApplication {
        id
        submittedAt
        answers {
          id
          answer
          answersArray
          question {
            id
            shortcode
          }
        }
      }
      order {
        id
      }
      treatment {
        id
        status
        refillsLeft
        nextPayment
        pendingFollowUpReminderDate
        isLastOrderUnfulfilled
        hasUnfulfilledOrder
        customerStatedTreatmentStartedAt
        type
        active
        hasScriptExpired
        product {
          id
          name
          friendlyName
          photo {
            id
            url
          }
          variants {
            id
            inventory {
              id
              sku
            }
          }
        }
        plan {
          id
          amount
        }
        otcSchedules {
          id
          isActive
          quantity
          product {
            id
            name
            productType
            photo {
              id
              url
            }
            variants {
              id
              price
            }
          }
        }
      }
      pathologyRequests {
        id
        createdAt
        customerStatedCollectedAt
      }
      reminders {
        id
        canceled
        createdAt
        scheduledAt
        doneAt
      }
      ...UseProfileCardsConsultation
    }
    initialQuizApplications: quizApplications(purpose: INITIAL) {
      id
      createdAt
      updatedAt
      submittedAt
      problemType
      purpose
      outcomes {
        ... on QuizOutcomeV2 {
          id
        }
        ... on NotEligibleQuizOutcome {
          reasons
        }
      }
      ...UseProfileCardsQuizApplication
    }
    memberships {
      id
      type
      createdAt
      membershipTerms(orderBy: {createdAt: desc}, take: 1) {
        id
        status
        startDate
        endDate
        isValid
      }
    }
    subscriptions @include(if: $withSubscriptions) {
      id
      status
      nextPaymentAt
      subscriptionOrders {
        id
        status
        createdAt
      }
      subscriptionPlan {
        ...OtcSubscriptionPlanV2Info
      }
    }
    purchases {
      id
      ...UseProfileCardsPurchase
    }
  }
}
    ${BillingDetailsFragmentDoc}
${UseProfileCardsConsultationFragmentDoc}
${UseProfileCardsQuizApplicationFragmentDoc}
${OtcSubscriptionPlanV2InfoFragmentDoc}
${UseProfileCardsPurchaseFragmentDoc}`;

/**
 * __useUseProfileQuery__
 *
 * To run a query within a React component, call `useUseProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseProfileQuery({
 *   variables: {
 *      withSubscriptions: // value for 'withSubscriptions'
 *   },
 * });
 */
export function useUseProfileQuery(baseOptions?: Apollo.QueryHookOptions<UseProfileQuery, UseProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseProfileQuery, UseProfileQueryVariables>(UseProfileDocument, options);
      }
export function useUseProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseProfileQuery, UseProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseProfileQuery, UseProfileQueryVariables>(UseProfileDocument, options);
        }
export function useUseProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UseProfileQuery, UseProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UseProfileQuery, UseProfileQueryVariables>(UseProfileDocument, options);
        }
export type UseProfileQueryHookResult = ReturnType<typeof useUseProfileQuery>;
export type UseProfileLazyQueryHookResult = ReturnType<typeof useUseProfileLazyQuery>;
export type UseProfileSuspenseQueryHookResult = ReturnType<typeof useUseProfileSuspenseQuery>;
export type UseProfileQueryResult = Apollo.QueryResult<UseProfileQuery, UseProfileQueryVariables>;
export const UseUpdateProfileDocument = gql`
    mutation UseUpdateProfile($firstName: String, $lastName: String, $phone: String, $password: String, $address: AddressCreateWithoutUserInput) {
  updateProfile(
    firstName: $firstName
    lastName: $lastName
    phone: $phone
    password: $password
    address: $address
  ) {
    ...UserInfo
  }
}
    ${UserInfoFragmentDoc}`;
export type UseUpdateProfileMutationFn = Apollo.MutationFunction<UseUpdateProfileMutation, UseUpdateProfileMutationVariables>;

/**
 * __useUseUpdateProfileMutation__
 *
 * To run a mutation, you first call `useUseUpdateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUseUpdateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [useUpdateProfileMutation, { data, loading, error }] = useUseUpdateProfileMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      phone: // value for 'phone'
 *      password: // value for 'password'
 *      address: // value for 'address'
 *   },
 * });
 */
export function useUseUpdateProfileMutation(baseOptions?: Apollo.MutationHookOptions<UseUpdateProfileMutation, UseUpdateProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UseUpdateProfileMutation, UseUpdateProfileMutationVariables>(UseUpdateProfileDocument, options);
      }
export type UseUpdateProfileMutationHookResult = ReturnType<typeof useUseUpdateProfileMutation>;
export type UseUpdateProfileMutationResult = Apollo.MutationResult<UseUpdateProfileMutation>;
export type UseUpdateProfileMutationOptions = Apollo.BaseMutationOptions<UseUpdateProfileMutation, UseUpdateProfileMutationVariables>;
export const UseUpdateProfileWithAddressDocument = gql`
    mutation UseUpdateProfileWithAddress($firstName: String, $lastName: String, $phone: String, $password: String, $address: AddressCreateWithoutUserInput) {
  updateProfile(
    firstName: $firstName
    lastName: $lastName
    phone: $phone
    password: $password
    address: $address
  ) {
    id
  }
}
    `;
export type UseUpdateProfileWithAddressMutationFn = Apollo.MutationFunction<UseUpdateProfileWithAddressMutation, UseUpdateProfileWithAddressMutationVariables>;

/**
 * __useUseUpdateProfileWithAddressMutation__
 *
 * To run a mutation, you first call `useUseUpdateProfileWithAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUseUpdateProfileWithAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [useUpdateProfileWithAddressMutation, { data, loading, error }] = useUseUpdateProfileWithAddressMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      phone: // value for 'phone'
 *      password: // value for 'password'
 *      address: // value for 'address'
 *   },
 * });
 */
export function useUseUpdateProfileWithAddressMutation(baseOptions?: Apollo.MutationHookOptions<UseUpdateProfileWithAddressMutation, UseUpdateProfileWithAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UseUpdateProfileWithAddressMutation, UseUpdateProfileWithAddressMutationVariables>(UseUpdateProfileWithAddressDocument, options);
      }
export type UseUpdateProfileWithAddressMutationHookResult = ReturnType<typeof useUseUpdateProfileWithAddressMutation>;
export type UseUpdateProfileWithAddressMutationResult = Apollo.MutationResult<UseUpdateProfileWithAddressMutation>;
export type UseUpdateProfileWithAddressMutationOptions = Apollo.BaseMutationOptions<UseUpdateProfileWithAddressMutation, UseUpdateProfileWithAddressMutationVariables>;
export const UseSignUpLeadDocument = gql`
    mutation UseSignUpLead($email: String!, $id: ID, $firstName: String, $lastName: String, $marketingCommsConsent: Boolean) {
  signUpLead(
    email: $email
    id: $id
    firstName: $firstName
    lastName: $lastName
    marketingCommsConsent: $marketingCommsConsent
  ) {
    token
    user {
      id
      email
      firstName
      lastName
      shortAddressableName
      fullName
    }
  }
}
    `;
export type UseSignUpLeadMutationFn = Apollo.MutationFunction<UseSignUpLeadMutation, UseSignUpLeadMutationVariables>;

/**
 * __useUseSignUpLeadMutation__
 *
 * To run a mutation, you first call `useUseSignUpLeadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUseSignUpLeadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [useSignUpLeadMutation, { data, loading, error }] = useUseSignUpLeadMutation({
 *   variables: {
 *      email: // value for 'email'
 *      id: // value for 'id'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      marketingCommsConsent: // value for 'marketingCommsConsent'
 *   },
 * });
 */
export function useUseSignUpLeadMutation(baseOptions?: Apollo.MutationHookOptions<UseSignUpLeadMutation, UseSignUpLeadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UseSignUpLeadMutation, UseSignUpLeadMutationVariables>(UseSignUpLeadDocument, options);
      }
export type UseSignUpLeadMutationHookResult = ReturnType<typeof useUseSignUpLeadMutation>;
export type UseSignUpLeadMutationResult = Apollo.MutationResult<UseSignUpLeadMutation>;
export type UseSignUpLeadMutationOptions = Apollo.BaseMutationOptions<UseSignUpLeadMutation, UseSignUpLeadMutationVariables>;
export const SignupDocument = gql`
    mutation Signup($firstName: String!, $lastName: String!, $email: String!, $password: String!, $phone: String, $id: ID, $marketingCommsConsent: Boolean) {
  signup(
    firstName: $firstName
    lastName: $lastName
    email: $email
    password: $password
    phone: $phone
    id: $id
    marketingCommsConsent: $marketingCommsConsent
  ) {
    token
    user {
      id
      email
      firstName
      lastName
      shortAddressableName
      fullName
      phone
      role
      isPasswordSet
      defaultPaymentGateway
      birthday
      preferredUnitSystem
      residentialAddress {
        id
        line1
        line2
        city
        postalCode
        state
        country
        company
        building
      }
      address {
        id
        line1
        line2
        city
        postalCode
        state
        country
        company
        building
      }
      zip {
        valid
      }
    }
  }
}
    `;
export type SignupMutationFn = Apollo.MutationFunction<SignupMutation, SignupMutationVariables>;

/**
 * __useSignupMutation__
 *
 * To run a mutation, you first call `useSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signupMutation, { data, loading, error }] = useSignupMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      phone: // value for 'phone'
 *      id: // value for 'id'
 *      marketingCommsConsent: // value for 'marketingCommsConsent'
 *   },
 * });
 */
export function useSignupMutation(baseOptions?: Apollo.MutationHookOptions<SignupMutation, SignupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignupMutation, SignupMutationVariables>(SignupDocument, options);
      }
export type SignupMutationHookResult = ReturnType<typeof useSignupMutation>;
export type SignupMutationResult = Apollo.MutationResult<SignupMutation>;
export type SignupMutationOptions = Apollo.BaseMutationOptions<SignupMutation, SignupMutationVariables>;
export const QuizApplicationDocument = gql`
    query QuizApplication($id: String!) {
  getQuizApplication(id: $id) {
    ...QuizApplication
  }
}
    ${QuizApplicationFragmentDoc}`;

/**
 * __useQuizApplicationQuery__
 *
 * To run a query within a React component, call `useQuizApplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuizApplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuizApplicationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useQuizApplicationQuery(baseOptions: Apollo.QueryHookOptions<QuizApplicationQuery, QuizApplicationQueryVariables> & ({ variables: QuizApplicationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuizApplicationQuery, QuizApplicationQueryVariables>(QuizApplicationDocument, options);
      }
export function useQuizApplicationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuizApplicationQuery, QuizApplicationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuizApplicationQuery, QuizApplicationQueryVariables>(QuizApplicationDocument, options);
        }
export function useQuizApplicationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QuizApplicationQuery, QuizApplicationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QuizApplicationQuery, QuizApplicationQueryVariables>(QuizApplicationDocument, options);
        }
export type QuizApplicationQueryHookResult = ReturnType<typeof useQuizApplicationQuery>;
export type QuizApplicationLazyQueryHookResult = ReturnType<typeof useQuizApplicationLazyQuery>;
export type QuizApplicationSuspenseQueryHookResult = ReturnType<typeof useQuizApplicationSuspenseQuery>;
export type QuizApplicationQueryResult = Apollo.QueryResult<QuizApplicationQuery, QuizApplicationQueryVariables>;
export const StartQuizApplicationDocument = gql`
    mutation StartQuizApplication($problemType: ProblemType!, $quizPurpose: QuizPurpose, $errorWhenFollowUpReminderNotDone: Boolean) {
  quizApplicationInfo: startQuizApplication(
    problemType: $problemType
    quizPurpose: $quizPurpose
    errorWhenFollowUpReminderNotDone: $errorWhenFollowUpReminderNotDone
  ) {
    id
    submittedAt
    consultation {
      id
    }
  }
}
    `;
export type StartQuizApplicationMutationFn = Apollo.MutationFunction<StartQuizApplicationMutation, StartQuizApplicationMutationVariables>;

/**
 * __useStartQuizApplicationMutation__
 *
 * To run a mutation, you first call `useStartQuizApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartQuizApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startQuizApplicationMutation, { data, loading, error }] = useStartQuizApplicationMutation({
 *   variables: {
 *      problemType: // value for 'problemType'
 *      quizPurpose: // value for 'quizPurpose'
 *      errorWhenFollowUpReminderNotDone: // value for 'errorWhenFollowUpReminderNotDone'
 *   },
 * });
 */
export function useStartQuizApplicationMutation(baseOptions?: Apollo.MutationHookOptions<StartQuizApplicationMutation, StartQuizApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartQuizApplicationMutation, StartQuizApplicationMutationVariables>(StartQuizApplicationDocument, options);
      }
export type StartQuizApplicationMutationHookResult = ReturnType<typeof useStartQuizApplicationMutation>;
export type StartQuizApplicationMutationResult = Apollo.MutationResult<StartQuizApplicationMutation>;
export type StartQuizApplicationMutationOptions = Apollo.BaseMutationOptions<StartQuizApplicationMutation, StartQuizApplicationMutationVariables>;
export const StartQuizApplicationWithQuizCodeDocument = gql`
    mutation StartQuizApplicationWithQuizCode($quizCode: String!) {
  quizApplicationInfo: startQuizApplicationWithQuizCode(quizCode: $quizCode) {
    id
  }
}
    `;
export type StartQuizApplicationWithQuizCodeMutationFn = Apollo.MutationFunction<StartQuizApplicationWithQuizCodeMutation, StartQuizApplicationWithQuizCodeMutationVariables>;

/**
 * __useStartQuizApplicationWithQuizCodeMutation__
 *
 * To run a mutation, you first call `useStartQuizApplicationWithQuizCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartQuizApplicationWithQuizCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startQuizApplicationWithQuizCodeMutation, { data, loading, error }] = useStartQuizApplicationWithQuizCodeMutation({
 *   variables: {
 *      quizCode: // value for 'quizCode'
 *   },
 * });
 */
export function useStartQuizApplicationWithQuizCodeMutation(baseOptions?: Apollo.MutationHookOptions<StartQuizApplicationWithQuizCodeMutation, StartQuizApplicationWithQuizCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartQuizApplicationWithQuizCodeMutation, StartQuizApplicationWithQuizCodeMutationVariables>(StartQuizApplicationWithQuizCodeDocument, options);
      }
export type StartQuizApplicationWithQuizCodeMutationHookResult = ReturnType<typeof useStartQuizApplicationWithQuizCodeMutation>;
export type StartQuizApplicationWithQuizCodeMutationResult = Apollo.MutationResult<StartQuizApplicationWithQuizCodeMutation>;
export type StartQuizApplicationWithQuizCodeMutationOptions = Apollo.BaseMutationOptions<StartQuizApplicationWithQuizCodeMutation, StartQuizApplicationWithQuizCodeMutationVariables>;
export const CompleteChecklistItemDocument = gql`
    mutation CompleteChecklistItem($code: String!, $checklistId: String!) {
  completeChecklistItem(code: $code, checklistId: $checklistId) {
    id
    completed
  }
}
    `;
export type CompleteChecklistItemMutationFn = Apollo.MutationFunction<CompleteChecklistItemMutation, CompleteChecklistItemMutationVariables>;

/**
 * __useCompleteChecklistItemMutation__
 *
 * To run a mutation, you first call `useCompleteChecklistItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteChecklistItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeChecklistItemMutation, { data, loading, error }] = useCompleteChecklistItemMutation({
 *   variables: {
 *      code: // value for 'code'
 *      checklistId: // value for 'checklistId'
 *   },
 * });
 */
export function useCompleteChecklistItemMutation(baseOptions?: Apollo.MutationHookOptions<CompleteChecklistItemMutation, CompleteChecklistItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteChecklistItemMutation, CompleteChecklistItemMutationVariables>(CompleteChecklistItemDocument, options);
      }
export type CompleteChecklistItemMutationHookResult = ReturnType<typeof useCompleteChecklistItemMutation>;
export type CompleteChecklistItemMutationResult = Apollo.MutationResult<CompleteChecklistItemMutation>;
export type CompleteChecklistItemMutationOptions = Apollo.BaseMutationOptions<CompleteChecklistItemMutation, CompleteChecklistItemMutationVariables>;
export const UnCompleteChecklistItemDocument = gql`
    mutation UnCompleteChecklistItem($code: String!, $checklistId: String!) {
  unCompleteChecklistItem(code: $code, checklistId: $checklistId) {
    id
    completed
  }
}
    `;
export type UnCompleteChecklistItemMutationFn = Apollo.MutationFunction<UnCompleteChecklistItemMutation, UnCompleteChecklistItemMutationVariables>;

/**
 * __useUnCompleteChecklistItemMutation__
 *
 * To run a mutation, you first call `useUnCompleteChecklistItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnCompleteChecklistItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unCompleteChecklistItemMutation, { data, loading, error }] = useUnCompleteChecklistItemMutation({
 *   variables: {
 *      code: // value for 'code'
 *      checklistId: // value for 'checklistId'
 *   },
 * });
 */
export function useUnCompleteChecklistItemMutation(baseOptions?: Apollo.MutationHookOptions<UnCompleteChecklistItemMutation, UnCompleteChecklistItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnCompleteChecklistItemMutation, UnCompleteChecklistItemMutationVariables>(UnCompleteChecklistItemDocument, options);
      }
export type UnCompleteChecklistItemMutationHookResult = ReturnType<typeof useUnCompleteChecklistItemMutation>;
export type UnCompleteChecklistItemMutationResult = Apollo.MutationResult<UnCompleteChecklistItemMutation>;
export type UnCompleteChecklistItemMutationOptions = Apollo.BaseMutationOptions<UnCompleteChecklistItemMutation, UnCompleteChecklistItemMutationVariables>;
export const FetchChecklistDocument = gql`
    query FetchChecklist($consultationId: String!) {
  checklistByConsultation(consultationId: $consultationId) {
    id
    consultationId
    attributes {
      age
      tryingStatus
      trimester
      expectedNewborns
    }
    groups {
      id
      title
      items {
        code
        completed
        id
      }
    }
  }
}
    `;

/**
 * __useFetchChecklistQuery__
 *
 * To run a query within a React component, call `useFetchChecklistQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchChecklistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchChecklistQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function useFetchChecklistQuery(baseOptions: Apollo.QueryHookOptions<FetchChecklistQuery, FetchChecklistQueryVariables> & ({ variables: FetchChecklistQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchChecklistQuery, FetchChecklistQueryVariables>(FetchChecklistDocument, options);
      }
export function useFetchChecklistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchChecklistQuery, FetchChecklistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchChecklistQuery, FetchChecklistQueryVariables>(FetchChecklistDocument, options);
        }
export function useFetchChecklistSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchChecklistQuery, FetchChecklistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchChecklistQuery, FetchChecklistQueryVariables>(FetchChecklistDocument, options);
        }
export type FetchChecklistQueryHookResult = ReturnType<typeof useFetchChecklistQuery>;
export type FetchChecklistLazyQueryHookResult = ReturnType<typeof useFetchChecklistLazyQuery>;
export type FetchChecklistSuspenseQueryHookResult = ReturnType<typeof useFetchChecklistSuspenseQuery>;
export type FetchChecklistQueryResult = Apollo.QueryResult<FetchChecklistQuery, FetchChecklistQueryVariables>;
export const UseConsultationDocument = gql`
    query UseConsultation($id: String!) {
  consultation(id: $id) {
    ...ConsultationInfo
  }
}
    ${ConsultationInfoFragmentDoc}`;

/**
 * __useUseConsultationQuery__
 *
 * To run a query within a React component, call `useUseConsultationQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseConsultationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseConsultationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUseConsultationQuery(baseOptions: Apollo.QueryHookOptions<UseConsultationQuery, UseConsultationQueryVariables> & ({ variables: UseConsultationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseConsultationQuery, UseConsultationQueryVariables>(UseConsultationDocument, options);
      }
export function useUseConsultationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseConsultationQuery, UseConsultationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseConsultationQuery, UseConsultationQueryVariables>(UseConsultationDocument, options);
        }
export function useUseConsultationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UseConsultationQuery, UseConsultationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UseConsultationQuery, UseConsultationQueryVariables>(UseConsultationDocument, options);
        }
export type UseConsultationQueryHookResult = ReturnType<typeof useUseConsultationQuery>;
export type UseConsultationLazyQueryHookResult = ReturnType<typeof useUseConsultationLazyQuery>;
export type UseConsultationSuspenseQueryHookResult = ReturnType<typeof useUseConsultationSuspenseQuery>;
export type UseConsultationQueryResult = Apollo.QueryResult<UseConsultationQuery, UseConsultationQueryVariables>;
export const ConsultationPaymentPageDocument = gql`
    query ConsultationPaymentPage($id: String!) {
  consultation(id: $id) {
    id
    type
    status
    stage
    requiresPrescriberCall
    quizApplication {
      id
      submittedAt
    }
    price {
      amountOff
      fullPrice
      total
    }
  }
}
    `;

/**
 * __useConsultationPaymentPageQuery__
 *
 * To run a query within a React component, call `useConsultationPaymentPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultationPaymentPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultationPaymentPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConsultationPaymentPageQuery(baseOptions: Apollo.QueryHookOptions<ConsultationPaymentPageQuery, ConsultationPaymentPageQueryVariables> & ({ variables: ConsultationPaymentPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConsultationPaymentPageQuery, ConsultationPaymentPageQueryVariables>(ConsultationPaymentPageDocument, options);
      }
export function useConsultationPaymentPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConsultationPaymentPageQuery, ConsultationPaymentPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConsultationPaymentPageQuery, ConsultationPaymentPageQueryVariables>(ConsultationPaymentPageDocument, options);
        }
export function useConsultationPaymentPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ConsultationPaymentPageQuery, ConsultationPaymentPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConsultationPaymentPageQuery, ConsultationPaymentPageQueryVariables>(ConsultationPaymentPageDocument, options);
        }
export type ConsultationPaymentPageQueryHookResult = ReturnType<typeof useConsultationPaymentPageQuery>;
export type ConsultationPaymentPageLazyQueryHookResult = ReturnType<typeof useConsultationPaymentPageLazyQuery>;
export type ConsultationPaymentPageSuspenseQueryHookResult = ReturnType<typeof useConsultationPaymentPageSuspenseQuery>;
export type ConsultationPaymentPageQueryResult = Apollo.QueryResult<ConsultationPaymentPageQuery, ConsultationPaymentPageQueryVariables>;
export const ConsultationTypeDocument = gql`
    query ConsultationType($id: String!) {
  consultation(id: $id) {
    id
    type
  }
}
    `;

/**
 * __useConsultationTypeQuery__
 *
 * To run a query within a React component, call `useConsultationTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultationTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultationTypeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConsultationTypeQuery(baseOptions: Apollo.QueryHookOptions<ConsultationTypeQuery, ConsultationTypeQueryVariables> & ({ variables: ConsultationTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConsultationTypeQuery, ConsultationTypeQueryVariables>(ConsultationTypeDocument, options);
      }
export function useConsultationTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConsultationTypeQuery, ConsultationTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConsultationTypeQuery, ConsultationTypeQueryVariables>(ConsultationTypeDocument, options);
        }
export function useConsultationTypeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ConsultationTypeQuery, ConsultationTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConsultationTypeQuery, ConsultationTypeQueryVariables>(ConsultationTypeDocument, options);
        }
export type ConsultationTypeQueryHookResult = ReturnType<typeof useConsultationTypeQuery>;
export type ConsultationTypeLazyQueryHookResult = ReturnType<typeof useConsultationTypeLazyQuery>;
export type ConsultationTypeSuspenseQueryHookResult = ReturnType<typeof useConsultationTypeSuspenseQuery>;
export type ConsultationTypeQueryResult = Apollo.QueryResult<ConsultationTypeQuery, ConsultationTypeQueryVariables>;
export const LatestConsultationDocument = gql`
    query LatestConsultation($type: ProblemType!) {
  consultations(
    where: {type: {equals: $type}}
    orderBy: {createdAt: desc}
    take: 1
  ) {
    id
    type
    status
    stage
    doctor {
      id
      lastName
      shortClinicianName
      fullClinicianName
      fullName
    }
    quizApplication {
      id
    }
  }
}
    `;

/**
 * __useLatestConsultationQuery__
 *
 * To run a query within a React component, call `useLatestConsultationQuery` and pass it any options that fit your needs.
 * When your component renders, `useLatestConsultationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLatestConsultationQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useLatestConsultationQuery(baseOptions: Apollo.QueryHookOptions<LatestConsultationQuery, LatestConsultationQueryVariables> & ({ variables: LatestConsultationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LatestConsultationQuery, LatestConsultationQueryVariables>(LatestConsultationDocument, options);
      }
export function useLatestConsultationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LatestConsultationQuery, LatestConsultationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LatestConsultationQuery, LatestConsultationQueryVariables>(LatestConsultationDocument, options);
        }
export function useLatestConsultationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LatestConsultationQuery, LatestConsultationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LatestConsultationQuery, LatestConsultationQueryVariables>(LatestConsultationDocument, options);
        }
export type LatestConsultationQueryHookResult = ReturnType<typeof useLatestConsultationQuery>;
export type LatestConsultationLazyQueryHookResult = ReturnType<typeof useLatestConsultationLazyQuery>;
export type LatestConsultationSuspenseQueryHookResult = ReturnType<typeof useLatestConsultationSuspenseQuery>;
export type LatestConsultationQueryResult = Apollo.QueryResult<LatestConsultationQuery, LatestConsultationQueryVariables>;
export const PayConsultationPaymentDocument = gql`
    mutation PayConsultationPayment($id: String!, $couponCode: String, $token: String, $gateway: PaymentGateway, $zipCheckoutId: String, $stripePaymentMethodId: String) {
  payConsultation(
    id: $id
    couponCode: $couponCode
    token: $token
    gateway: $gateway
    zipCheckoutId: $zipCheckoutId
    stripePaymentMethodId: $stripePaymentMethodId
  ) {
    id
  }
}
    `;
export type PayConsultationPaymentMutationFn = Apollo.MutationFunction<PayConsultationPaymentMutation, PayConsultationPaymentMutationVariables>;

/**
 * __usePayConsultationPaymentMutation__
 *
 * To run a mutation, you first call `usePayConsultationPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePayConsultationPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [payConsultationPaymentMutation, { data, loading, error }] = usePayConsultationPaymentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      couponCode: // value for 'couponCode'
 *      token: // value for 'token'
 *      gateway: // value for 'gateway'
 *      zipCheckoutId: // value for 'zipCheckoutId'
 *      stripePaymentMethodId: // value for 'stripePaymentMethodId'
 *   },
 * });
 */
export function usePayConsultationPaymentMutation(baseOptions?: Apollo.MutationHookOptions<PayConsultationPaymentMutation, PayConsultationPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PayConsultationPaymentMutation, PayConsultationPaymentMutationVariables>(PayConsultationPaymentDocument, options);
      }
export type PayConsultationPaymentMutationHookResult = ReturnType<typeof usePayConsultationPaymentMutation>;
export type PayConsultationPaymentMutationResult = Apollo.MutationResult<PayConsultationPaymentMutation>;
export type PayConsultationPaymentMutationOptions = Apollo.BaseMutationOptions<PayConsultationPaymentMutation, PayConsultationPaymentMutationVariables>;
export const UseProfileConsultationsDocument = gql`
    query UseProfileConsultations {
  profile {
    id
    hasPaidMasterclass
    consultations(orderBy: {createdAt: desc}) {
      id
      type
      createdAt
      stage
      isApproved
      allowPatientToSendMessageToDoctor
      status
      pathologyRequests {
        id
      }
      doctor {
        id
        firstName
        lastName
        shortClinicianName
        fullClinicianName
        fullName
        provider {
          id
          clinicianType
          clinicianTitle
        }
      }
      patientQuestions {
        id
        createdAt
      }
      reminders {
        id
        canceled
        createdAt
        scheduledAt
        doneAt
      }
      quizApplication {
        id
      }
    }
  }
}
    `;

/**
 * __useUseProfileConsultationsQuery__
 *
 * To run a query within a React component, call `useUseProfileConsultationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseProfileConsultationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseProfileConsultationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUseProfileConsultationsQuery(baseOptions?: Apollo.QueryHookOptions<UseProfileConsultationsQuery, UseProfileConsultationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseProfileConsultationsQuery, UseProfileConsultationsQueryVariables>(UseProfileConsultationsDocument, options);
      }
export function useUseProfileConsultationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseProfileConsultationsQuery, UseProfileConsultationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseProfileConsultationsQuery, UseProfileConsultationsQueryVariables>(UseProfileConsultationsDocument, options);
        }
export function useUseProfileConsultationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UseProfileConsultationsQuery, UseProfileConsultationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UseProfileConsultationsQuery, UseProfileConsultationsQueryVariables>(UseProfileConsultationsDocument, options);
        }
export type UseProfileConsultationsQueryHookResult = ReturnType<typeof useUseProfileConsultationsQuery>;
export type UseProfileConsultationsLazyQueryHookResult = ReturnType<typeof useUseProfileConsultationsLazyQuery>;
export type UseProfileConsultationsSuspenseQueryHookResult = ReturnType<typeof useUseProfileConsultationsSuspenseQuery>;
export type UseProfileConsultationsQueryResult = Apollo.QueryResult<UseProfileConsultationsQuery, UseProfileConsultationsQueryVariables>;
export const CustomerAttributesDocument = gql`
    query CustomerAttributes {
  customerAttributes {
    id
    ...CustomerAttributesInfo
  }
}
    ${CustomerAttributesInfoFragmentDoc}`;

/**
 * __useCustomerAttributesQuery__
 *
 * To run a query within a React component, call `useCustomerAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerAttributesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomerAttributesQuery(baseOptions?: Apollo.QueryHookOptions<CustomerAttributesQuery, CustomerAttributesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerAttributesQuery, CustomerAttributesQueryVariables>(CustomerAttributesDocument, options);
      }
export function useCustomerAttributesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerAttributesQuery, CustomerAttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerAttributesQuery, CustomerAttributesQueryVariables>(CustomerAttributesDocument, options);
        }
export function useCustomerAttributesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CustomerAttributesQuery, CustomerAttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomerAttributesQuery, CustomerAttributesQueryVariables>(CustomerAttributesDocument, options);
        }
export type CustomerAttributesQueryHookResult = ReturnType<typeof useCustomerAttributesQuery>;
export type CustomerAttributesLazyQueryHookResult = ReturnType<typeof useCustomerAttributesLazyQuery>;
export type CustomerAttributesSuspenseQueryHookResult = ReturnType<typeof useCustomerAttributesSuspenseQuery>;
export type CustomerAttributesQueryResult = Apollo.QueryResult<CustomerAttributesQuery, CustomerAttributesQueryVariables>;
export const MoveConsultationPaidToOrderPaidDocument = gql`
    mutation MoveConsultationPaidToOrderPaid($consultationId: String!, $doctorId: String, $productId: String) {
  moveConsultationPaidToOrderPaid(
    consultationId: $consultationId
    doctorId: $doctorId
    productId: $productId
  ) {
    success
  }
}
    `;
export type MoveConsultationPaidToOrderPaidMutationFn = Apollo.MutationFunction<MoveConsultationPaidToOrderPaidMutation, MoveConsultationPaidToOrderPaidMutationVariables>;

/**
 * __useMoveConsultationPaidToOrderPaidMutation__
 *
 * To run a mutation, you first call `useMoveConsultationPaidToOrderPaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveConsultationPaidToOrderPaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveConsultationPaidToOrderPaidMutation, { data, loading, error }] = useMoveConsultationPaidToOrderPaidMutation({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *      doctorId: // value for 'doctorId'
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useMoveConsultationPaidToOrderPaidMutation(baseOptions?: Apollo.MutationHookOptions<MoveConsultationPaidToOrderPaidMutation, MoveConsultationPaidToOrderPaidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveConsultationPaidToOrderPaidMutation, MoveConsultationPaidToOrderPaidMutationVariables>(MoveConsultationPaidToOrderPaidDocument, options);
      }
export type MoveConsultationPaidToOrderPaidMutationHookResult = ReturnType<typeof useMoveConsultationPaidToOrderPaidMutation>;
export type MoveConsultationPaidToOrderPaidMutationResult = Apollo.MutationResult<MoveConsultationPaidToOrderPaidMutation>;
export type MoveConsultationPaidToOrderPaidMutationOptions = Apollo.BaseMutationOptions<MoveConsultationPaidToOrderPaidMutation, MoveConsultationPaidToOrderPaidMutationVariables>;
export const AnswerDoctorQuestionsDocument = gql`
    mutation AnswerDoctorQuestions($consultationId: String!, $answers: Json!) {
  answerDoctorQuestions(consultationId: $consultationId, answers: $answers) {
    id
  }
}
    `;
export type AnswerDoctorQuestionsMutationFn = Apollo.MutationFunction<AnswerDoctorQuestionsMutation, AnswerDoctorQuestionsMutationVariables>;

/**
 * __useAnswerDoctorQuestionsMutation__
 *
 * To run a mutation, you first call `useAnswerDoctorQuestionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnswerDoctorQuestionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [answerDoctorQuestionsMutation, { data, loading, error }] = useAnswerDoctorQuestionsMutation({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *      answers: // value for 'answers'
 *   },
 * });
 */
export function useAnswerDoctorQuestionsMutation(baseOptions?: Apollo.MutationHookOptions<AnswerDoctorQuestionsMutation, AnswerDoctorQuestionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnswerDoctorQuestionsMutation, AnswerDoctorQuestionsMutationVariables>(AnswerDoctorQuestionsDocument, options);
      }
export type AnswerDoctorQuestionsMutationHookResult = ReturnType<typeof useAnswerDoctorQuestionsMutation>;
export type AnswerDoctorQuestionsMutationResult = Apollo.MutationResult<AnswerDoctorQuestionsMutation>;
export type AnswerDoctorQuestionsMutationOptions = Apollo.BaseMutationOptions<AnswerDoctorQuestionsMutation, AnswerDoctorQuestionsMutationVariables>;
export const AddPatientQuestionToConsultationDocument = gql`
    mutation AddPatientQuestionToConsultation($consultationId: String!, $question: String!, $trigger: String!) {
  addPatientQuestionToConsultation(
    id: $consultationId
    question: $question
    trigger: $trigger
  ) {
    id
    status
  }
}
    `;
export type AddPatientQuestionToConsultationMutationFn = Apollo.MutationFunction<AddPatientQuestionToConsultationMutation, AddPatientQuestionToConsultationMutationVariables>;

/**
 * __useAddPatientQuestionToConsultationMutation__
 *
 * To run a mutation, you first call `useAddPatientQuestionToConsultationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPatientQuestionToConsultationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPatientQuestionToConsultationMutation, { data, loading, error }] = useAddPatientQuestionToConsultationMutation({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *      question: // value for 'question'
 *      trigger: // value for 'trigger'
 *   },
 * });
 */
export function useAddPatientQuestionToConsultationMutation(baseOptions?: Apollo.MutationHookOptions<AddPatientQuestionToConsultationMutation, AddPatientQuestionToConsultationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPatientQuestionToConsultationMutation, AddPatientQuestionToConsultationMutationVariables>(AddPatientQuestionToConsultationDocument, options);
      }
export type AddPatientQuestionToConsultationMutationHookResult = ReturnType<typeof useAddPatientQuestionToConsultationMutation>;
export type AddPatientQuestionToConsultationMutationResult = Apollo.MutationResult<AddPatientQuestionToConsultationMutation>;
export type AddPatientQuestionToConsultationMutationOptions = Apollo.BaseMutationOptions<AddPatientQuestionToConsultationMutation, AddPatientQuestionToConsultationMutationVariables>;
export const CancelExperimentPaymentPlanDocument = gql`
    mutation CancelExperimentPaymentPlan($treatmentId: String!) {
  cancelExperimentPaymentPlan(treatmentId: $treatmentId) {
    id
    experimentPaymentPlan {
      ...ExperimentPaymentPlan
    }
  }
}
    ${ExperimentPaymentPlanFragmentDoc}`;
export type CancelExperimentPaymentPlanMutationFn = Apollo.MutationFunction<CancelExperimentPaymentPlanMutation, CancelExperimentPaymentPlanMutationVariables>;

/**
 * __useCancelExperimentPaymentPlanMutation__
 *
 * To run a mutation, you first call `useCancelExperimentPaymentPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelExperimentPaymentPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelExperimentPaymentPlanMutation, { data, loading, error }] = useCancelExperimentPaymentPlanMutation({
 *   variables: {
 *      treatmentId: // value for 'treatmentId'
 *   },
 * });
 */
export function useCancelExperimentPaymentPlanMutation(baseOptions?: Apollo.MutationHookOptions<CancelExperimentPaymentPlanMutation, CancelExperimentPaymentPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelExperimentPaymentPlanMutation, CancelExperimentPaymentPlanMutationVariables>(CancelExperimentPaymentPlanDocument, options);
      }
export type CancelExperimentPaymentPlanMutationHookResult = ReturnType<typeof useCancelExperimentPaymentPlanMutation>;
export type CancelExperimentPaymentPlanMutationResult = Apollo.MutationResult<CancelExperimentPaymentPlanMutation>;
export type CancelExperimentPaymentPlanMutationOptions = Apollo.BaseMutationOptions<CancelExperimentPaymentPlanMutation, CancelExperimentPaymentPlanMutationVariables>;
export const ChangeExperimentPaymentPlanDocument = gql`
    mutation ChangeExperimentPaymentPlan($treatmentId: String!, $paymentPlan: ExperimentPaymentPlanVariant!, $version: Int) {
  changeExperimentPaymentPlan(
    treatmentId: $treatmentId
    paymentPlan: $paymentPlan
    version: $version
  ) {
    id
    experimentPaymentPlan {
      ...ExperimentPaymentPlan
    }
  }
}
    ${ExperimentPaymentPlanFragmentDoc}`;
export type ChangeExperimentPaymentPlanMutationFn = Apollo.MutationFunction<ChangeExperimentPaymentPlanMutation, ChangeExperimentPaymentPlanMutationVariables>;

/**
 * __useChangeExperimentPaymentPlanMutation__
 *
 * To run a mutation, you first call `useChangeExperimentPaymentPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeExperimentPaymentPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeExperimentPaymentPlanMutation, { data, loading, error }] = useChangeExperimentPaymentPlanMutation({
 *   variables: {
 *      treatmentId: // value for 'treatmentId'
 *      paymentPlan: // value for 'paymentPlan'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useChangeExperimentPaymentPlanMutation(baseOptions?: Apollo.MutationHookOptions<ChangeExperimentPaymentPlanMutation, ChangeExperimentPaymentPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeExperimentPaymentPlanMutation, ChangeExperimentPaymentPlanMutationVariables>(ChangeExperimentPaymentPlanDocument, options);
      }
export type ChangeExperimentPaymentPlanMutationHookResult = ReturnType<typeof useChangeExperimentPaymentPlanMutation>;
export type ChangeExperimentPaymentPlanMutationResult = Apollo.MutationResult<ChangeExperimentPaymentPlanMutation>;
export type ChangeExperimentPaymentPlanMutationOptions = Apollo.BaseMutationOptions<ChangeExperimentPaymentPlanMutation, ChangeExperimentPaymentPlanMutationVariables>;
export const ReopenApplicationDocument = gql`
    mutation ReopenApplication($id: String!) {
  reopenApplication(id: $id) {
    id
  }
}
    `;
export type ReopenApplicationMutationFn = Apollo.MutationFunction<ReopenApplicationMutation, ReopenApplicationMutationVariables>;

/**
 * __useReopenApplicationMutation__
 *
 * To run a mutation, you first call `useReopenApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReopenApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reopenApplicationMutation, { data, loading, error }] = useReopenApplicationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReopenApplicationMutation(baseOptions?: Apollo.MutationHookOptions<ReopenApplicationMutation, ReopenApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReopenApplicationMutation, ReopenApplicationMutationVariables>(ReopenApplicationDocument, options);
      }
export type ReopenApplicationMutationHookResult = ReturnType<typeof useReopenApplicationMutation>;
export type ReopenApplicationMutationResult = Apollo.MutationResult<ReopenApplicationMutation>;
export type ReopenApplicationMutationOptions = Apollo.BaseMutationOptions<ReopenApplicationMutation, ReopenApplicationMutationVariables>;
export const RequestReviewTreatmentSupportDocument = gql`
    mutation RequestReviewTreatmentSupport($body: String!, $category: TreatmentReviewCategory!, $subject: String!, $treatmentId: String!, $quizApplicationId: String) {
  requestReviewTreatmentSupport(
    body: $body
    category: $category
    subject: $subject
    treatmentId: $treatmentId
    quizApplicationId: $quizApplicationId
  ) {
    id
  }
}
    `;
export type RequestReviewTreatmentSupportMutationFn = Apollo.MutationFunction<RequestReviewTreatmentSupportMutation, RequestReviewTreatmentSupportMutationVariables>;

/**
 * __useRequestReviewTreatmentSupportMutation__
 *
 * To run a mutation, you first call `useRequestReviewTreatmentSupportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestReviewTreatmentSupportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestReviewTreatmentSupportMutation, { data, loading, error }] = useRequestReviewTreatmentSupportMutation({
 *   variables: {
 *      body: // value for 'body'
 *      category: // value for 'category'
 *      subject: // value for 'subject'
 *      treatmentId: // value for 'treatmentId'
 *      quizApplicationId: // value for 'quizApplicationId'
 *   },
 * });
 */
export function useRequestReviewTreatmentSupportMutation(baseOptions?: Apollo.MutationHookOptions<RequestReviewTreatmentSupportMutation, RequestReviewTreatmentSupportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestReviewTreatmentSupportMutation, RequestReviewTreatmentSupportMutationVariables>(RequestReviewTreatmentSupportDocument, options);
      }
export type RequestReviewTreatmentSupportMutationHookResult = ReturnType<typeof useRequestReviewTreatmentSupportMutation>;
export type RequestReviewTreatmentSupportMutationResult = Apollo.MutationResult<RequestReviewTreatmentSupportMutation>;
export type RequestReviewTreatmentSupportMutationOptions = Apollo.BaseMutationOptions<RequestReviewTreatmentSupportMutation, RequestReviewTreatmentSupportMutationVariables>;
export const UseUpdateProfileAttrsDocument = gql`
    mutation UseUpdateProfileAttrs($firstName: String, $lastName: String, $birthday: String) {
  updateProfile(firstName: $firstName, lastName: $lastName, birthday: $birthday) {
    ...UserInfo
  }
}
    ${UserInfoFragmentDoc}`;
export type UseUpdateProfileAttrsMutationFn = Apollo.MutationFunction<UseUpdateProfileAttrsMutation, UseUpdateProfileAttrsMutationVariables>;

/**
 * __useUseUpdateProfileAttrsMutation__
 *
 * To run a mutation, you first call `useUseUpdateProfileAttrsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUseUpdateProfileAttrsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [useUpdateProfileAttrsMutation, { data, loading, error }] = useUseUpdateProfileAttrsMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      birthday: // value for 'birthday'
 *   },
 * });
 */
export function useUseUpdateProfileAttrsMutation(baseOptions?: Apollo.MutationHookOptions<UseUpdateProfileAttrsMutation, UseUpdateProfileAttrsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UseUpdateProfileAttrsMutation, UseUpdateProfileAttrsMutationVariables>(UseUpdateProfileAttrsDocument, options);
      }
export type UseUpdateProfileAttrsMutationHookResult = ReturnType<typeof useUseUpdateProfileAttrsMutation>;
export type UseUpdateProfileAttrsMutationResult = Apollo.MutationResult<UseUpdateProfileAttrsMutation>;
export type UseUpdateProfileAttrsMutationOptions = Apollo.BaseMutationOptions<UseUpdateProfileAttrsMutation, UseUpdateProfileAttrsMutationVariables>;
export const ConsultationPricingDocument = gql`
    query ConsultationPricing($id: String!, $discountCode: String) {
  consultation(id: $id) {
    id
    type
    stage
    price(discount: $discountCode) {
      amountOff
      fullPrice
      total
    }
  }
}
    `;

/**
 * __useConsultationPricingQuery__
 *
 * To run a query within a React component, call `useConsultationPricingQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultationPricingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultationPricingQuery({
 *   variables: {
 *      id: // value for 'id'
 *      discountCode: // value for 'discountCode'
 *   },
 * });
 */
export function useConsultationPricingQuery(baseOptions: Apollo.QueryHookOptions<ConsultationPricingQuery, ConsultationPricingQueryVariables> & ({ variables: ConsultationPricingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConsultationPricingQuery, ConsultationPricingQueryVariables>(ConsultationPricingDocument, options);
      }
export function useConsultationPricingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConsultationPricingQuery, ConsultationPricingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConsultationPricingQuery, ConsultationPricingQueryVariables>(ConsultationPricingDocument, options);
        }
export function useConsultationPricingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ConsultationPricingQuery, ConsultationPricingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConsultationPricingQuery, ConsultationPricingQueryVariables>(ConsultationPricingDocument, options);
        }
export type ConsultationPricingQueryHookResult = ReturnType<typeof useConsultationPricingQuery>;
export type ConsultationPricingLazyQueryHookResult = ReturnType<typeof useConsultationPricingLazyQuery>;
export type ConsultationPricingSuspenseQueryHookResult = ReturnType<typeof useConsultationPricingSuspenseQuery>;
export type ConsultationPricingQueryResult = Apollo.QueryResult<ConsultationPricingQuery, ConsultationPricingQueryVariables>;
export const InSegmentDocument = gql`
    query InSegment($segmentName: Segment!) {
  inSegment(segmentName: $segmentName)
}
    `;

/**
 * __useInSegmentQuery__
 *
 * To run a query within a React component, call `useInSegmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useInSegmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInSegmentQuery({
 *   variables: {
 *      segmentName: // value for 'segmentName'
 *   },
 * });
 */
export function useInSegmentQuery(baseOptions: Apollo.QueryHookOptions<InSegmentQuery, InSegmentQueryVariables> & ({ variables: InSegmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InSegmentQuery, InSegmentQueryVariables>(InSegmentDocument, options);
      }
export function useInSegmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InSegmentQuery, InSegmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InSegmentQuery, InSegmentQueryVariables>(InSegmentDocument, options);
        }
export function useInSegmentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InSegmentQuery, InSegmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InSegmentQuery, InSegmentQueryVariables>(InSegmentDocument, options);
        }
export type InSegmentQueryHookResult = ReturnType<typeof useInSegmentQuery>;
export type InSegmentLazyQueryHookResult = ReturnType<typeof useInSegmentLazyQuery>;
export type InSegmentSuspenseQueryHookResult = ReturnType<typeof useInSegmentSuspenseQuery>;
export type InSegmentQueryResult = Apollo.QueryResult<InSegmentQuery, InSegmentQueryVariables>;
export const ProfileAndHealthcareDocument = gql`
    query ProfileAndHealthcare {
  profile {
    id
    legalFirstName
    legalLastName
    birthday
    residentialAddress {
      id
    }
    medicalProfile {
      id
      sex
    }
    healthCareDetails {
      id
      hasMedicareDetails
      hasIndividualHealthcareIdentifier
    }
  }
}
    `;

/**
 * __useProfileAndHealthcareQuery__
 *
 * To run a query within a React component, call `useProfileAndHealthcareQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileAndHealthcareQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileAndHealthcareQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfileAndHealthcareQuery(baseOptions?: Apollo.QueryHookOptions<ProfileAndHealthcareQuery, ProfileAndHealthcareQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileAndHealthcareQuery, ProfileAndHealthcareQueryVariables>(ProfileAndHealthcareDocument, options);
      }
export function useProfileAndHealthcareLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileAndHealthcareQuery, ProfileAndHealthcareQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileAndHealthcareQuery, ProfileAndHealthcareQueryVariables>(ProfileAndHealthcareDocument, options);
        }
export function useProfileAndHealthcareSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProfileAndHealthcareQuery, ProfileAndHealthcareQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProfileAndHealthcareQuery, ProfileAndHealthcareQueryVariables>(ProfileAndHealthcareDocument, options);
        }
export type ProfileAndHealthcareQueryHookResult = ReturnType<typeof useProfileAndHealthcareQuery>;
export type ProfileAndHealthcareLazyQueryHookResult = ReturnType<typeof useProfileAndHealthcareLazyQuery>;
export type ProfileAndHealthcareSuspenseQueryHookResult = ReturnType<typeof useProfileAndHealthcareSuspenseQuery>;
export type ProfileAndHealthcareQueryResult = Apollo.QueryResult<ProfileAndHealthcareQuery, ProfileAndHealthcareQueryVariables>;
export const UseProfileAndResidentialAddressDocument = gql`
    query UseProfileAndResidentialAddress {
  profile {
    id
    firstName
    lastName
    birthday
    residentialAddress {
      id
      line1
      line2
      city
      postalCode
      state
      country
    }
  }
}
    `;

/**
 * __useUseProfileAndResidentialAddressQuery__
 *
 * To run a query within a React component, call `useUseProfileAndResidentialAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseProfileAndResidentialAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseProfileAndResidentialAddressQuery({
 *   variables: {
 *   },
 * });
 */
export function useUseProfileAndResidentialAddressQuery(baseOptions?: Apollo.QueryHookOptions<UseProfileAndResidentialAddressQuery, UseProfileAndResidentialAddressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseProfileAndResidentialAddressQuery, UseProfileAndResidentialAddressQueryVariables>(UseProfileAndResidentialAddressDocument, options);
      }
export function useUseProfileAndResidentialAddressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseProfileAndResidentialAddressQuery, UseProfileAndResidentialAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseProfileAndResidentialAddressQuery, UseProfileAndResidentialAddressQueryVariables>(UseProfileAndResidentialAddressDocument, options);
        }
export function useUseProfileAndResidentialAddressSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UseProfileAndResidentialAddressQuery, UseProfileAndResidentialAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UseProfileAndResidentialAddressQuery, UseProfileAndResidentialAddressQueryVariables>(UseProfileAndResidentialAddressDocument, options);
        }
export type UseProfileAndResidentialAddressQueryHookResult = ReturnType<typeof useUseProfileAndResidentialAddressQuery>;
export type UseProfileAndResidentialAddressLazyQueryHookResult = ReturnType<typeof useUseProfileAndResidentialAddressLazyQuery>;
export type UseProfileAndResidentialAddressSuspenseQueryHookResult = ReturnType<typeof useUseProfileAndResidentialAddressSuspenseQuery>;
export type UseProfileAndResidentialAddressQueryResult = Apollo.QueryResult<UseProfileAndResidentialAddressQuery, UseProfileAndResidentialAddressQueryVariables>;
export const ProfileDocument = gql`
    query Profile {
  profile {
    id
    residentialAddress {
      id
      line1
      line2
      city
      postalCode
      state
      country
    }
    address {
      id
      line1
      line2
      city
      postalCode
      state
      country
    }
  }
}
    `;

/**
 * __useProfileQuery__
 *
 * To run a query within a React component, call `useProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfileQuery(baseOptions?: Apollo.QueryHookOptions<ProfileQuery, ProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileQuery, ProfileQueryVariables>(ProfileDocument, options);
      }
export function useProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileQuery, ProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileQuery, ProfileQueryVariables>(ProfileDocument, options);
        }
export function useProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProfileQuery, ProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProfileQuery, ProfileQueryVariables>(ProfileDocument, options);
        }
export type ProfileQueryHookResult = ReturnType<typeof useProfileQuery>;
export type ProfileLazyQueryHookResult = ReturnType<typeof useProfileLazyQuery>;
export type ProfileSuspenseQueryHookResult = ReturnType<typeof useProfileSuspenseQuery>;
export type ProfileQueryResult = Apollo.QueryResult<ProfileQuery, ProfileQueryVariables>;
export const IsShippingAddressWithinRangeDocument = gql`
    query IsShippingAddressWithinRange($line1: String!, $line2: String!, $postcode: String!, $suburb: String!) {
  shippingAddressWithinRange(
    line1: $line1
    line2: $line2
    postcode: $postcode
    suburb: $suburb
  )
}
    `;

/**
 * __useIsShippingAddressWithinRangeQuery__
 *
 * To run a query within a React component, call `useIsShippingAddressWithinRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsShippingAddressWithinRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsShippingAddressWithinRangeQuery({
 *   variables: {
 *      line1: // value for 'line1'
 *      line2: // value for 'line2'
 *      postcode: // value for 'postcode'
 *      suburb: // value for 'suburb'
 *   },
 * });
 */
export function useIsShippingAddressWithinRangeQuery(baseOptions: Apollo.QueryHookOptions<IsShippingAddressWithinRangeQuery, IsShippingAddressWithinRangeQueryVariables> & ({ variables: IsShippingAddressWithinRangeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsShippingAddressWithinRangeQuery, IsShippingAddressWithinRangeQueryVariables>(IsShippingAddressWithinRangeDocument, options);
      }
export function useIsShippingAddressWithinRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsShippingAddressWithinRangeQuery, IsShippingAddressWithinRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsShippingAddressWithinRangeQuery, IsShippingAddressWithinRangeQueryVariables>(IsShippingAddressWithinRangeDocument, options);
        }
export function useIsShippingAddressWithinRangeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IsShippingAddressWithinRangeQuery, IsShippingAddressWithinRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IsShippingAddressWithinRangeQuery, IsShippingAddressWithinRangeQueryVariables>(IsShippingAddressWithinRangeDocument, options);
        }
export type IsShippingAddressWithinRangeQueryHookResult = ReturnType<typeof useIsShippingAddressWithinRangeQuery>;
export type IsShippingAddressWithinRangeLazyQueryHookResult = ReturnType<typeof useIsShippingAddressWithinRangeLazyQuery>;
export type IsShippingAddressWithinRangeSuspenseQueryHookResult = ReturnType<typeof useIsShippingAddressWithinRangeSuspenseQuery>;
export type IsShippingAddressWithinRangeQueryResult = Apollo.QueryResult<IsShippingAddressWithinRangeQuery, IsShippingAddressWithinRangeQueryVariables>;
export const UseMembershipDocument = gql`
    query UseMembership {
  profile {
    id
    memberships {
      id
      type
      createdAt
      membershipTerms(orderBy: {createdAt: desc}, take: 1) {
        id
        interval
        intervalCount
        subscriptionStatus
        status
        startDate
        endDate
        isValid
      }
    }
  }
}
    `;

/**
 * __useUseMembershipQuery__
 *
 * To run a query within a React component, call `useUseMembershipQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseMembershipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseMembershipQuery({
 *   variables: {
 *   },
 * });
 */
export function useUseMembershipQuery(baseOptions?: Apollo.QueryHookOptions<UseMembershipQuery, UseMembershipQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseMembershipQuery, UseMembershipQueryVariables>(UseMembershipDocument, options);
      }
export function useUseMembershipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseMembershipQuery, UseMembershipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseMembershipQuery, UseMembershipQueryVariables>(UseMembershipDocument, options);
        }
export function useUseMembershipSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UseMembershipQuery, UseMembershipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UseMembershipQuery, UseMembershipQueryVariables>(UseMembershipDocument, options);
        }
export type UseMembershipQueryHookResult = ReturnType<typeof useUseMembershipQuery>;
export type UseMembershipLazyQueryHookResult = ReturnType<typeof useUseMembershipLazyQuery>;
export type UseMembershipSuspenseQueryHookResult = ReturnType<typeof useUseMembershipSuspenseQuery>;
export type UseMembershipQueryResult = Apollo.QueryResult<UseMembershipQuery, UseMembershipQueryVariables>;
export const ConfirmOrderDocument = gql`
    mutation ConfirmOrder($consultationId: String!, $firstName: String, $lastName: String, $address: AddressCreateWithoutUserInput, $phone: String, $token: String, $gateway: PaymentGateway, $zipCheckoutId: String, $couponCode: String, $stripePaymentMethodId: String) {
  confirmOrder(
    consultationId: $consultationId
    firstName: $firstName
    lastName: $lastName
    address: $address
    phone: $phone
    token: $token
    gateway: $gateway
    stripePaymentMethodId: $stripePaymentMethodId
    couponCode: $couponCode
    zipCheckoutId: $zipCheckoutId
  ) {
    id
  }
}
    `;
export type ConfirmOrderMutationFn = Apollo.MutationFunction<ConfirmOrderMutation, ConfirmOrderMutationVariables>;

/**
 * __useConfirmOrderMutation__
 *
 * To run a mutation, you first call `useConfirmOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmOrderMutation, { data, loading, error }] = useConfirmOrderMutation({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      address: // value for 'address'
 *      phone: // value for 'phone'
 *      token: // value for 'token'
 *      gateway: // value for 'gateway'
 *      zipCheckoutId: // value for 'zipCheckoutId'
 *      couponCode: // value for 'couponCode'
 *      stripePaymentMethodId: // value for 'stripePaymentMethodId'
 *   },
 * });
 */
export function useConfirmOrderMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmOrderMutation, ConfirmOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmOrderMutation, ConfirmOrderMutationVariables>(ConfirmOrderDocument, options);
      }
export type ConfirmOrderMutationHookResult = ReturnType<typeof useConfirmOrderMutation>;
export type ConfirmOrderMutationResult = Apollo.MutationResult<ConfirmOrderMutation>;
export type ConfirmOrderMutationOptions = Apollo.BaseMutationOptions<ConfirmOrderMutation, ConfirmOrderMutationVariables>;
export const RefreshUserPaymentDataProfileDocument = gql`
    query RefreshUserPaymentDataProfile {
  profile {
    id
    zip {
      valid
    }
    savedPaymentMethods {
      id
      createdAt
      default
      gateway
      ... on SavedCardPaymentMethod {
        brand
        mask
        expiry
      }
      ... on SavedPayPalPaymentMethod {
        email
      }
      ... on SavedZipPaymentMethod {
        valid
      }
    }
  }
}
    `;

/**
 * __useRefreshUserPaymentDataProfileQuery__
 *
 * To run a query within a React component, call `useRefreshUserPaymentDataProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useRefreshUserPaymentDataProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRefreshUserPaymentDataProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useRefreshUserPaymentDataProfileQuery(baseOptions?: Apollo.QueryHookOptions<RefreshUserPaymentDataProfileQuery, RefreshUserPaymentDataProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RefreshUserPaymentDataProfileQuery, RefreshUserPaymentDataProfileQueryVariables>(RefreshUserPaymentDataProfileDocument, options);
      }
export function useRefreshUserPaymentDataProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RefreshUserPaymentDataProfileQuery, RefreshUserPaymentDataProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RefreshUserPaymentDataProfileQuery, RefreshUserPaymentDataProfileQueryVariables>(RefreshUserPaymentDataProfileDocument, options);
        }
export function useRefreshUserPaymentDataProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RefreshUserPaymentDataProfileQuery, RefreshUserPaymentDataProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RefreshUserPaymentDataProfileQuery, RefreshUserPaymentDataProfileQueryVariables>(RefreshUserPaymentDataProfileDocument, options);
        }
export type RefreshUserPaymentDataProfileQueryHookResult = ReturnType<typeof useRefreshUserPaymentDataProfileQuery>;
export type RefreshUserPaymentDataProfileLazyQueryHookResult = ReturnType<typeof useRefreshUserPaymentDataProfileLazyQuery>;
export type RefreshUserPaymentDataProfileSuspenseQueryHookResult = ReturnType<typeof useRefreshUserPaymentDataProfileSuspenseQuery>;
export type RefreshUserPaymentDataProfileQueryResult = Apollo.QueryResult<RefreshUserPaymentDataProfileQuery, RefreshUserPaymentDataProfileQueryVariables>;
export const RemoveZipDocument = gql`
    mutation RemoveZip {
  removeZip
}
    `;
export type RemoveZipMutationFn = Apollo.MutationFunction<RemoveZipMutation, RemoveZipMutationVariables>;

/**
 * __useRemoveZipMutation__
 *
 * To run a mutation, you first call `useRemoveZipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveZipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeZipMutation, { data, loading, error }] = useRemoveZipMutation({
 *   variables: {
 *   },
 * });
 */
export function useRemoveZipMutation(baseOptions?: Apollo.MutationHookOptions<RemoveZipMutation, RemoveZipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveZipMutation, RemoveZipMutationVariables>(RemoveZipDocument, options);
      }
export type RemoveZipMutationHookResult = ReturnType<typeof useRemoveZipMutation>;
export type RemoveZipMutationResult = Apollo.MutationResult<RemoveZipMutation>;
export type RemoveZipMutationOptions = Apollo.BaseMutationOptions<RemoveZipMutation, RemoveZipMutationVariables>;
export const UpdateDefaultPaymentGatewayDocument = gql`
    mutation UpdateDefaultPaymentGateway($gateway: PaymentGateway!) {
  updateDefaultPaymentGateway(gateway: $gateway)
}
    `;
export type UpdateDefaultPaymentGatewayMutationFn = Apollo.MutationFunction<UpdateDefaultPaymentGatewayMutation, UpdateDefaultPaymentGatewayMutationVariables>;

/**
 * __useUpdateDefaultPaymentGatewayMutation__
 *
 * To run a mutation, you first call `useUpdateDefaultPaymentGatewayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDefaultPaymentGatewayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDefaultPaymentGatewayMutation, { data, loading, error }] = useUpdateDefaultPaymentGatewayMutation({
 *   variables: {
 *      gateway: // value for 'gateway'
 *   },
 * });
 */
export function useUpdateDefaultPaymentGatewayMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDefaultPaymentGatewayMutation, UpdateDefaultPaymentGatewayMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDefaultPaymentGatewayMutation, UpdateDefaultPaymentGatewayMutationVariables>(UpdateDefaultPaymentGatewayDocument, options);
      }
export type UpdateDefaultPaymentGatewayMutationHookResult = ReturnType<typeof useUpdateDefaultPaymentGatewayMutation>;
export type UpdateDefaultPaymentGatewayMutationResult = Apollo.MutationResult<UpdateDefaultPaymentGatewayMutation>;
export type UpdateDefaultPaymentGatewayMutationOptions = Apollo.BaseMutationOptions<UpdateDefaultPaymentGatewayMutation, UpdateDefaultPaymentGatewayMutationVariables>;
export const UpdatePaymentDocument = gql`
    mutation UpdatePayment($stripeTokenId: String, $stripePaymentMethodId: String) {
  updatePayment(
    stripeTokenId: $stripeTokenId
    stripePaymentMethodId: $stripePaymentMethodId
  ) {
    id
    savedPaymentMethods {
      id
      gateway
      default
      ... on SavedCardPaymentMethod {
        brand
        expiry
        mask
      }
    }
  }
}
    `;
export type UpdatePaymentMutationFn = Apollo.MutationFunction<UpdatePaymentMutation, UpdatePaymentMutationVariables>;

/**
 * __useUpdatePaymentMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentMutation, { data, loading, error }] = useUpdatePaymentMutation({
 *   variables: {
 *      stripeTokenId: // value for 'stripeTokenId'
 *      stripePaymentMethodId: // value for 'stripePaymentMethodId'
 *   },
 * });
 */
export function useUpdatePaymentMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaymentMutation, UpdatePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePaymentMutation, UpdatePaymentMutationVariables>(UpdatePaymentDocument, options);
      }
export type UpdatePaymentMutationHookResult = ReturnType<typeof useUpdatePaymentMutation>;
export type UpdatePaymentMutationResult = Apollo.MutationResult<UpdatePaymentMutation>;
export type UpdatePaymentMutationOptions = Apollo.BaseMutationOptions<UpdatePaymentMutation, UpdatePaymentMutationVariables>;
export const InitiateZipCheckoutDocument = gql`
    mutation InitiateZipCheckout($redirectUrl: String!, $address: AddressCreateWithoutUserInput!, $orderId: String!, $couponCode: String, $phone: String) {
  initiateZipCheckout(
    redirectUrl: $redirectUrl
    address: $address
    orderId: $orderId
    couponCode: $couponCode
    phone: $phone
  ) {
    redirectUrl
  }
}
    `;
export type InitiateZipCheckoutMutationFn = Apollo.MutationFunction<InitiateZipCheckoutMutation, InitiateZipCheckoutMutationVariables>;

/**
 * __useInitiateZipCheckoutMutation__
 *
 * To run a mutation, you first call `useInitiateZipCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateZipCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateZipCheckoutMutation, { data, loading, error }] = useInitiateZipCheckoutMutation({
 *   variables: {
 *      redirectUrl: // value for 'redirectUrl'
 *      address: // value for 'address'
 *      orderId: // value for 'orderId'
 *      couponCode: // value for 'couponCode'
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useInitiateZipCheckoutMutation(baseOptions?: Apollo.MutationHookOptions<InitiateZipCheckoutMutation, InitiateZipCheckoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitiateZipCheckoutMutation, InitiateZipCheckoutMutationVariables>(InitiateZipCheckoutDocument, options);
      }
export type InitiateZipCheckoutMutationHookResult = ReturnType<typeof useInitiateZipCheckoutMutation>;
export type InitiateZipCheckoutMutationResult = Apollo.MutationResult<InitiateZipCheckoutMutation>;
export type InitiateZipCheckoutMutationOptions = Apollo.BaseMutationOptions<InitiateZipCheckoutMutation, InitiateZipCheckoutMutationVariables>;
export const UsePathologyLocationsProfileDocument = gql`
    query UsePathologyLocationsProfile {
  profile {
    id
    residentialAddress {
      id
      postalCode
    }
    address {
      id
      postalCode
    }
  }
}
    `;

/**
 * __useUsePathologyLocationsProfileQuery__
 *
 * To run a query within a React component, call `useUsePathologyLocationsProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsePathologyLocationsProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsePathologyLocationsProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useUsePathologyLocationsProfileQuery(baseOptions?: Apollo.QueryHookOptions<UsePathologyLocationsProfileQuery, UsePathologyLocationsProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsePathologyLocationsProfileQuery, UsePathologyLocationsProfileQueryVariables>(UsePathologyLocationsProfileDocument, options);
      }
export function useUsePathologyLocationsProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsePathologyLocationsProfileQuery, UsePathologyLocationsProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsePathologyLocationsProfileQuery, UsePathologyLocationsProfileQueryVariables>(UsePathologyLocationsProfileDocument, options);
        }
export function useUsePathologyLocationsProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UsePathologyLocationsProfileQuery, UsePathologyLocationsProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UsePathologyLocationsProfileQuery, UsePathologyLocationsProfileQueryVariables>(UsePathologyLocationsProfileDocument, options);
        }
export type UsePathologyLocationsProfileQueryHookResult = ReturnType<typeof useUsePathologyLocationsProfileQuery>;
export type UsePathologyLocationsProfileLazyQueryHookResult = ReturnType<typeof useUsePathologyLocationsProfileLazyQuery>;
export type UsePathologyLocationsProfileSuspenseQueryHookResult = ReturnType<typeof useUsePathologyLocationsProfileSuspenseQuery>;
export type UsePathologyLocationsProfileQueryResult = Apollo.QueryResult<UsePathologyLocationsProfileQuery, UsePathologyLocationsProfileQueryVariables>;
export const PathologyLocationsDocument = gql`
    query PathologyLocations($postcode: String!) {
  pathologyLocations(postcode: $postcode) {
    display
    url
  }
}
    `;

/**
 * __usePathologyLocationsQuery__
 *
 * To run a query within a React component, call `usePathologyLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePathologyLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePathologyLocationsQuery({
 *   variables: {
 *      postcode: // value for 'postcode'
 *   },
 * });
 */
export function usePathologyLocationsQuery(baseOptions: Apollo.QueryHookOptions<PathologyLocationsQuery, PathologyLocationsQueryVariables> & ({ variables: PathologyLocationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PathologyLocationsQuery, PathologyLocationsQueryVariables>(PathologyLocationsDocument, options);
      }
export function usePathologyLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PathologyLocationsQuery, PathologyLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PathologyLocationsQuery, PathologyLocationsQueryVariables>(PathologyLocationsDocument, options);
        }
export function usePathologyLocationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PathologyLocationsQuery, PathologyLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PathologyLocationsQuery, PathologyLocationsQueryVariables>(PathologyLocationsDocument, options);
        }
export type PathologyLocationsQueryHookResult = ReturnType<typeof usePathologyLocationsQuery>;
export type PathologyLocationsLazyQueryHookResult = ReturnType<typeof usePathologyLocationsLazyQuery>;
export type PathologyLocationsSuspenseQueryHookResult = ReturnType<typeof usePathologyLocationsSuspenseQuery>;
export type PathologyLocationsQueryResult = Apollo.QueryResult<PathologyLocationsQuery, PathologyLocationsQueryVariables>;
export const UpdatePathologyCustomerStatedCollectedAtDocument = gql`
    mutation UpdatePathologyCustomerStatedCollectedAt($collectedAt: String!, $pathologyRequestId: String!) {
  updatePathologyCustomerStatedCollectedAt(
    collectedAt: $collectedAt
    pathologyRequestId: $pathologyRequestId
  ) {
    id
    customerStatedCollectedAt
  }
}
    `;
export type UpdatePathologyCustomerStatedCollectedAtMutationFn = Apollo.MutationFunction<UpdatePathologyCustomerStatedCollectedAtMutation, UpdatePathologyCustomerStatedCollectedAtMutationVariables>;

/**
 * __useUpdatePathologyCustomerStatedCollectedAtMutation__
 *
 * To run a mutation, you first call `useUpdatePathologyCustomerStatedCollectedAtMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePathologyCustomerStatedCollectedAtMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePathologyCustomerStatedCollectedAtMutation, { data, loading, error }] = useUpdatePathologyCustomerStatedCollectedAtMutation({
 *   variables: {
 *      collectedAt: // value for 'collectedAt'
 *      pathologyRequestId: // value for 'pathologyRequestId'
 *   },
 * });
 */
export function useUpdatePathologyCustomerStatedCollectedAtMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePathologyCustomerStatedCollectedAtMutation, UpdatePathologyCustomerStatedCollectedAtMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePathologyCustomerStatedCollectedAtMutation, UpdatePathologyCustomerStatedCollectedAtMutationVariables>(UpdatePathologyCustomerStatedCollectedAtDocument, options);
      }
export type UpdatePathologyCustomerStatedCollectedAtMutationHookResult = ReturnType<typeof useUpdatePathologyCustomerStatedCollectedAtMutation>;
export type UpdatePathologyCustomerStatedCollectedAtMutationResult = Apollo.MutationResult<UpdatePathologyCustomerStatedCollectedAtMutation>;
export type UpdatePathologyCustomerStatedCollectedAtMutationOptions = Apollo.BaseMutationOptions<UpdatePathologyCustomerStatedCollectedAtMutation, UpdatePathologyCustomerStatedCollectedAtMutationVariables>;
export const UpsertOtcProductToTreatmentDocument = gql`
    mutation UpsertOtcProductToTreatment($id: String!, $productId: String!, $cadence: OtcScheduleCadence!, $quantity: Int, $source: String) {
  upsertOtcProductToTreatment(
    id: $id
    productId: $productId
    cadence: $cadence
    quantity: $quantity
    source: $source
  ) {
    id
    otcSchedules {
      id
      createdAt
      updatedAt
      cadence
      isActive
      quantity
      product {
        id
        name
        variants {
          id
          price
        }
        photo {
          id
          url
        }
      }
    }
  }
}
    `;
export type UpsertOtcProductToTreatmentMutationFn = Apollo.MutationFunction<UpsertOtcProductToTreatmentMutation, UpsertOtcProductToTreatmentMutationVariables>;

/**
 * __useUpsertOtcProductToTreatmentMutation__
 *
 * To run a mutation, you first call `useUpsertOtcProductToTreatmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertOtcProductToTreatmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertOtcProductToTreatmentMutation, { data, loading, error }] = useUpsertOtcProductToTreatmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      productId: // value for 'productId'
 *      cadence: // value for 'cadence'
 *      quantity: // value for 'quantity'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useUpsertOtcProductToTreatmentMutation(baseOptions?: Apollo.MutationHookOptions<UpsertOtcProductToTreatmentMutation, UpsertOtcProductToTreatmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertOtcProductToTreatmentMutation, UpsertOtcProductToTreatmentMutationVariables>(UpsertOtcProductToTreatmentDocument, options);
      }
export type UpsertOtcProductToTreatmentMutationHookResult = ReturnType<typeof useUpsertOtcProductToTreatmentMutation>;
export type UpsertOtcProductToTreatmentMutationResult = Apollo.MutationResult<UpsertOtcProductToTreatmentMutation>;
export type UpsertOtcProductToTreatmentMutationOptions = Apollo.BaseMutationOptions<UpsertOtcProductToTreatmentMutation, UpsertOtcProductToTreatmentMutationVariables>;
export const RemoveOtcProductFromTreatmentDocument = gql`
    mutation RemoveOtcProductFromTreatment($id: String!, $productId: String!, $source: String) {
  removeOtcProductFromTreatment(id: $id, productId: $productId, source: $source) {
    id
    otcSchedules {
      id
      isActive
    }
  }
}
    `;
export type RemoveOtcProductFromTreatmentMutationFn = Apollo.MutationFunction<RemoveOtcProductFromTreatmentMutation, RemoveOtcProductFromTreatmentMutationVariables>;

/**
 * __useRemoveOtcProductFromTreatmentMutation__
 *
 * To run a mutation, you first call `useRemoveOtcProductFromTreatmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveOtcProductFromTreatmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeOtcProductFromTreatmentMutation, { data, loading, error }] = useRemoveOtcProductFromTreatmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      productId: // value for 'productId'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useRemoveOtcProductFromTreatmentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveOtcProductFromTreatmentMutation, RemoveOtcProductFromTreatmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveOtcProductFromTreatmentMutation, RemoveOtcProductFromTreatmentMutationVariables>(RemoveOtcProductFromTreatmentDocument, options);
      }
export type RemoveOtcProductFromTreatmentMutationHookResult = ReturnType<typeof useRemoveOtcProductFromTreatmentMutation>;
export type RemoveOtcProductFromTreatmentMutationResult = Apollo.MutationResult<RemoveOtcProductFromTreatmentMutation>;
export type RemoveOtcProductFromTreatmentMutationOptions = Apollo.BaseMutationOptions<RemoveOtcProductFromTreatmentMutation, RemoveOtcProductFromTreatmentMutationVariables>;
export const UpdateLineItemDocument = gql`
    mutation UpdateLineItem($orderId: String!, $quantity: Int!, $variantId: String!) {
  updateLineItem(orderId: $orderId, quantity: $quantity, variantId: $variantId) {
    id
  }
}
    `;
export type UpdateLineItemMutationFn = Apollo.MutationFunction<UpdateLineItemMutation, UpdateLineItemMutationVariables>;

/**
 * __useUpdateLineItemMutation__
 *
 * To run a mutation, you first call `useUpdateLineItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLineItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLineItemMutation, { data, loading, error }] = useUpdateLineItemMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      quantity: // value for 'quantity'
 *      variantId: // value for 'variantId'
 *   },
 * });
 */
export function useUpdateLineItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLineItemMutation, UpdateLineItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLineItemMutation, UpdateLineItemMutationVariables>(UpdateLineItemDocument, options);
      }
export type UpdateLineItemMutationHookResult = ReturnType<typeof useUpdateLineItemMutation>;
export type UpdateLineItemMutationResult = Apollo.MutationResult<UpdateLineItemMutation>;
export type UpdateLineItemMutationOptions = Apollo.BaseMutationOptions<UpdateLineItemMutation, UpdateLineItemMutationVariables>;
export const ProductsDocument = gql`
    query Products {
  products(productType: OTC) {
    id
    name
    description
    priority
    productType
    problemTypes
    photo {
      id
      url
    }
    variants {
      id
      price
      public
      inventory {
        id
        sku
      }
    }
  }
}
    `;

/**
 * __useProductsQuery__
 *
 * To run a query within a React component, call `useProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductsQuery(baseOptions?: Apollo.QueryHookOptions<ProductsQuery, ProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductsQuery, ProductsQueryVariables>(ProductsDocument, options);
      }
export function useProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductsQuery, ProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductsQuery, ProductsQueryVariables>(ProductsDocument, options);
        }
export function useProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductsQuery, ProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductsQuery, ProductsQueryVariables>(ProductsDocument, options);
        }
export type ProductsQueryHookResult = ReturnType<typeof useProductsQuery>;
export type ProductsLazyQueryHookResult = ReturnType<typeof useProductsLazyQuery>;
export type ProductsSuspenseQueryHookResult = ReturnType<typeof useProductsSuspenseQuery>;
export type ProductsQueryResult = Apollo.QueryResult<ProductsQuery, ProductsQueryVariables>;
export const NutritionSupportProductsDocument = gql`
    query NutritionSupportProducts($productSKU: String) {
  products(
    productType: CONTENT
    where: {variants: {some: {inventory: {sku: {equals: $productSKU}}}}}
  ) {
    id
    name
    description
    priority
    productType
    problemTypes
    photo {
      id
      url
    }
    variants {
      id
      price
      public
      inventory {
        id
        sku
      }
    }
  }
}
    `;

/**
 * __useNutritionSupportProductsQuery__
 *
 * To run a query within a React component, call `useNutritionSupportProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNutritionSupportProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNutritionSupportProductsQuery({
 *   variables: {
 *      productSKU: // value for 'productSKU'
 *   },
 * });
 */
export function useNutritionSupportProductsQuery(baseOptions?: Apollo.QueryHookOptions<NutritionSupportProductsQuery, NutritionSupportProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NutritionSupportProductsQuery, NutritionSupportProductsQueryVariables>(NutritionSupportProductsDocument, options);
      }
export function useNutritionSupportProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NutritionSupportProductsQuery, NutritionSupportProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NutritionSupportProductsQuery, NutritionSupportProductsQueryVariables>(NutritionSupportProductsDocument, options);
        }
export function useNutritionSupportProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NutritionSupportProductsQuery, NutritionSupportProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NutritionSupportProductsQuery, NutritionSupportProductsQueryVariables>(NutritionSupportProductsDocument, options);
        }
export type NutritionSupportProductsQueryHookResult = ReturnType<typeof useNutritionSupportProductsQuery>;
export type NutritionSupportProductsLazyQueryHookResult = ReturnType<typeof useNutritionSupportProductsLazyQuery>;
export type NutritionSupportProductsSuspenseQueryHookResult = ReturnType<typeof useNutritionSupportProductsSuspenseQuery>;
export type NutritionSupportProductsQueryResult = Apollo.QueryResult<NutritionSupportProductsQuery, NutritionSupportProductsQueryVariables>;
export const SpecialisedNutritionSupportDocument = gql`
    query SpecialisedNutritionSupport($treatmentId: String!, $productSKU: String) {
  treatment(id: $treatmentId) {
    ...NutritionSupportTreatment
  }
}
    ${NutritionSupportTreatmentFragmentDoc}`;

/**
 * __useSpecialisedNutritionSupportQuery__
 *
 * To run a query within a React component, call `useSpecialisedNutritionSupportQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpecialisedNutritionSupportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpecialisedNutritionSupportQuery({
 *   variables: {
 *      treatmentId: // value for 'treatmentId'
 *      productSKU: // value for 'productSKU'
 *   },
 * });
 */
export function useSpecialisedNutritionSupportQuery(baseOptions: Apollo.QueryHookOptions<SpecialisedNutritionSupportQuery, SpecialisedNutritionSupportQueryVariables> & ({ variables: SpecialisedNutritionSupportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SpecialisedNutritionSupportQuery, SpecialisedNutritionSupportQueryVariables>(SpecialisedNutritionSupportDocument, options);
      }
export function useSpecialisedNutritionSupportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SpecialisedNutritionSupportQuery, SpecialisedNutritionSupportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SpecialisedNutritionSupportQuery, SpecialisedNutritionSupportQueryVariables>(SpecialisedNutritionSupportDocument, options);
        }
export function useSpecialisedNutritionSupportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SpecialisedNutritionSupportQuery, SpecialisedNutritionSupportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SpecialisedNutritionSupportQuery, SpecialisedNutritionSupportQueryVariables>(SpecialisedNutritionSupportDocument, options);
        }
export type SpecialisedNutritionSupportQueryHookResult = ReturnType<typeof useSpecialisedNutritionSupportQuery>;
export type SpecialisedNutritionSupportLazyQueryHookResult = ReturnType<typeof useSpecialisedNutritionSupportLazyQuery>;
export type SpecialisedNutritionSupportSuspenseQueryHookResult = ReturnType<typeof useSpecialisedNutritionSupportSuspenseQuery>;
export type SpecialisedNutritionSupportQueryResult = Apollo.QueryResult<SpecialisedNutritionSupportQuery, SpecialisedNutritionSupportQueryVariables>;
export const TrackApplicationStopDocument = gql`
    mutation TrackApplicationStop($id: String!) {
  trackApplicationStop(id: $id) {
    id
  }
}
    `;
export type TrackApplicationStopMutationFn = Apollo.MutationFunction<TrackApplicationStopMutation, TrackApplicationStopMutationVariables>;

/**
 * __useTrackApplicationStopMutation__
 *
 * To run a mutation, you first call `useTrackApplicationStopMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackApplicationStopMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackApplicationStopMutation, { data, loading, error }] = useTrackApplicationStopMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTrackApplicationStopMutation(baseOptions?: Apollo.MutationHookOptions<TrackApplicationStopMutation, TrackApplicationStopMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TrackApplicationStopMutation, TrackApplicationStopMutationVariables>(TrackApplicationStopDocument, options);
      }
export type TrackApplicationStopMutationHookResult = ReturnType<typeof useTrackApplicationStopMutation>;
export type TrackApplicationStopMutationResult = Apollo.MutationResult<TrackApplicationStopMutation>;
export type TrackApplicationStopMutationOptions = Apollo.BaseMutationOptions<TrackApplicationStopMutation, TrackApplicationStopMutationVariables>;
export const AddUserToSegmentDocument = gql`
    mutation AddUserToSegment($segmentName: Segment!, $activeFrom: String, $activeTo: String) {
  addUserToSegment(
    segmentName: $segmentName
    activeFrom: $activeFrom
    activeTo: $activeTo
  )
}
    `;
export type AddUserToSegmentMutationFn = Apollo.MutationFunction<AddUserToSegmentMutation, AddUserToSegmentMutationVariables>;

/**
 * __useAddUserToSegmentMutation__
 *
 * To run a mutation, you first call `useAddUserToSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserToSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserToSegmentMutation, { data, loading, error }] = useAddUserToSegmentMutation({
 *   variables: {
 *      segmentName: // value for 'segmentName'
 *      activeFrom: // value for 'activeFrom'
 *      activeTo: // value for 'activeTo'
 *   },
 * });
 */
export function useAddUserToSegmentMutation(baseOptions?: Apollo.MutationHookOptions<AddUserToSegmentMutation, AddUserToSegmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserToSegmentMutation, AddUserToSegmentMutationVariables>(AddUserToSegmentDocument, options);
      }
export type AddUserToSegmentMutationHookResult = ReturnType<typeof useAddUserToSegmentMutation>;
export type AddUserToSegmentMutationResult = Apollo.MutationResult<AddUserToSegmentMutation>;
export type AddUserToSegmentMutationOptions = Apollo.BaseMutationOptions<AddUserToSegmentMutation, AddUserToSegmentMutationVariables>;
export const CreateOrRetrieveStripeSetupIntentDocument = gql`
    mutation CreateOrRetrieveStripeSetupIntent {
  createOrRetrieveStripeSetupIntent {
    id
    clientSecret
  }
}
    `;
export type CreateOrRetrieveStripeSetupIntentMutationFn = Apollo.MutationFunction<CreateOrRetrieveStripeSetupIntentMutation, CreateOrRetrieveStripeSetupIntentMutationVariables>;

/**
 * __useCreateOrRetrieveStripeSetupIntentMutation__
 *
 * To run a mutation, you first call `useCreateOrRetrieveStripeSetupIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrRetrieveStripeSetupIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrRetrieveStripeSetupIntentMutation, { data, loading, error }] = useCreateOrRetrieveStripeSetupIntentMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateOrRetrieveStripeSetupIntentMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrRetrieveStripeSetupIntentMutation, CreateOrRetrieveStripeSetupIntentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrRetrieveStripeSetupIntentMutation, CreateOrRetrieveStripeSetupIntentMutationVariables>(CreateOrRetrieveStripeSetupIntentDocument, options);
      }
export type CreateOrRetrieveStripeSetupIntentMutationHookResult = ReturnType<typeof useCreateOrRetrieveStripeSetupIntentMutation>;
export type CreateOrRetrieveStripeSetupIntentMutationResult = Apollo.MutationResult<CreateOrRetrieveStripeSetupIntentMutation>;
export type CreateOrRetrieveStripeSetupIntentMutationOptions = Apollo.BaseMutationOptions<CreateOrRetrieveStripeSetupIntentMutation, CreateOrRetrieveStripeSetupIntentMutationVariables>;
export const StripePublicKeyDocument = gql`
    query StripePublicKey {
  stripeAccount {
    publicKey
  }
}
    `;

/**
 * __useStripePublicKeyQuery__
 *
 * To run a query within a React component, call `useStripePublicKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useStripePublicKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStripePublicKeyQuery({
 *   variables: {
 *   },
 * });
 */
export function useStripePublicKeyQuery(baseOptions?: Apollo.QueryHookOptions<StripePublicKeyQuery, StripePublicKeyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StripePublicKeyQuery, StripePublicKeyQueryVariables>(StripePublicKeyDocument, options);
      }
export function useStripePublicKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StripePublicKeyQuery, StripePublicKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StripePublicKeyQuery, StripePublicKeyQueryVariables>(StripePublicKeyDocument, options);
        }
export function useStripePublicKeySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StripePublicKeyQuery, StripePublicKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StripePublicKeyQuery, StripePublicKeyQueryVariables>(StripePublicKeyDocument, options);
        }
export type StripePublicKeyQueryHookResult = ReturnType<typeof useStripePublicKeyQuery>;
export type StripePublicKeyLazyQueryHookResult = ReturnType<typeof useStripePublicKeyLazyQuery>;
export type StripePublicKeySuspenseQueryHookResult = ReturnType<typeof useStripePublicKeySuspenseQuery>;
export type StripePublicKeyQueryResult = Apollo.QueryResult<StripePublicKeyQuery, StripePublicKeyQueryVariables>;
export const CancelOtcSubDocument = gql`
    mutation CancelOtcSub($type: ProblemType!, $cancelReason: String, $cancelOtherReason: String) {
  cancelSubscription(
    type: $type
    cancelReason: $cancelReason
    cancelOtherReason: $cancelOtherReason
  ) {
    id
  }
}
    `;
export type CancelOtcSubMutationFn = Apollo.MutationFunction<CancelOtcSubMutation, CancelOtcSubMutationVariables>;

/**
 * __useCancelOtcSubMutation__
 *
 * To run a mutation, you first call `useCancelOtcSubMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelOtcSubMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelOtcSubMutation, { data, loading, error }] = useCancelOtcSubMutation({
 *   variables: {
 *      type: // value for 'type'
 *      cancelReason: // value for 'cancelReason'
 *      cancelOtherReason: // value for 'cancelOtherReason'
 *   },
 * });
 */
export function useCancelOtcSubMutation(baseOptions?: Apollo.MutationHookOptions<CancelOtcSubMutation, CancelOtcSubMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelOtcSubMutation, CancelOtcSubMutationVariables>(CancelOtcSubDocument, options);
      }
export type CancelOtcSubMutationHookResult = ReturnType<typeof useCancelOtcSubMutation>;
export type CancelOtcSubMutationResult = Apollo.MutationResult<CancelOtcSubMutation>;
export type CancelOtcSubMutationOptions = Apollo.BaseMutationOptions<CancelOtcSubMutation, CancelOtcSubMutationVariables>;
export const ReactivateMembershipDocument = gql`
    mutation ReactivateMembership($type: ProblemType!) {
  reactivateMembership(type: $type) {
    id
  }
}
    `;
export type ReactivateMembershipMutationFn = Apollo.MutationFunction<ReactivateMembershipMutation, ReactivateMembershipMutationVariables>;

/**
 * __useReactivateMembershipMutation__
 *
 * To run a mutation, you first call `useReactivateMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactivateMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactivateMembershipMutation, { data, loading, error }] = useReactivateMembershipMutation({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useReactivateMembershipMutation(baseOptions?: Apollo.MutationHookOptions<ReactivateMembershipMutation, ReactivateMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReactivateMembershipMutation, ReactivateMembershipMutationVariables>(ReactivateMembershipDocument, options);
      }
export type ReactivateMembershipMutationHookResult = ReturnType<typeof useReactivateMembershipMutation>;
export type ReactivateMembershipMutationResult = Apollo.MutationResult<ReactivateMembershipMutation>;
export type ReactivateMembershipMutationOptions = Apollo.BaseMutationOptions<ReactivateMembershipMutation, ReactivateMembershipMutationVariables>;
export const ReactivateOtcSubDocument = gql`
    mutation ReactivateOtcSub($type: ProblemType!) {
  reactivateSubscription(type: $type) {
    id
  }
}
    `;
export type ReactivateOtcSubMutationFn = Apollo.MutationFunction<ReactivateOtcSubMutation, ReactivateOtcSubMutationVariables>;

/**
 * __useReactivateOtcSubMutation__
 *
 * To run a mutation, you first call `useReactivateOtcSubMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactivateOtcSubMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactivateOtcSubMutation, { data, loading, error }] = useReactivateOtcSubMutation({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useReactivateOtcSubMutation(baseOptions?: Apollo.MutationHookOptions<ReactivateOtcSubMutation, ReactivateOtcSubMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReactivateOtcSubMutation, ReactivateOtcSubMutationVariables>(ReactivateOtcSubDocument, options);
      }
export type ReactivateOtcSubMutationHookResult = ReturnType<typeof useReactivateOtcSubMutation>;
export type ReactivateOtcSubMutationResult = Apollo.MutationResult<ReactivateOtcSubMutation>;
export type ReactivateOtcSubMutationOptions = Apollo.BaseMutationOptions<ReactivateOtcSubMutation, ReactivateOtcSubMutationVariables>;
export const CancelSubscriptionPlanDocument = gql`
    mutation CancelSubscriptionPlan($subscriptionId: String!) {
  cancelSubscriptionPlan(subscriptionId: $subscriptionId) {
    ...OtcSubscriptionPlanInfo
  }
}
    ${OtcSubscriptionPlanInfoFragmentDoc}`;
export type CancelSubscriptionPlanMutationFn = Apollo.MutationFunction<CancelSubscriptionPlanMutation, CancelSubscriptionPlanMutationVariables>;

/**
 * __useCancelSubscriptionPlanMutation__
 *
 * To run a mutation, you first call `useCancelSubscriptionPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSubscriptionPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSubscriptionPlanMutation, { data, loading, error }] = useCancelSubscriptionPlanMutation({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function useCancelSubscriptionPlanMutation(baseOptions?: Apollo.MutationHookOptions<CancelSubscriptionPlanMutation, CancelSubscriptionPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelSubscriptionPlanMutation, CancelSubscriptionPlanMutationVariables>(CancelSubscriptionPlanDocument, options);
      }
export type CancelSubscriptionPlanMutationHookResult = ReturnType<typeof useCancelSubscriptionPlanMutation>;
export type CancelSubscriptionPlanMutationResult = Apollo.MutationResult<CancelSubscriptionPlanMutation>;
export type CancelSubscriptionPlanMutationOptions = Apollo.BaseMutationOptions<CancelSubscriptionPlanMutation, CancelSubscriptionPlanMutationVariables>;
export const OtcSubscriptionPlanDocument = gql`
    query OtcSubscriptionPlan {
  subscriptionPlans {
    ...OtcSubscriptionPlanInfo
  }
}
    ${OtcSubscriptionPlanInfoFragmentDoc}`;

/**
 * __useOtcSubscriptionPlanQuery__
 *
 * To run a query within a React component, call `useOtcSubscriptionPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useOtcSubscriptionPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOtcSubscriptionPlanQuery({
 *   variables: {
 *   },
 * });
 */
export function useOtcSubscriptionPlanQuery(baseOptions?: Apollo.QueryHookOptions<OtcSubscriptionPlanQuery, OtcSubscriptionPlanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OtcSubscriptionPlanQuery, OtcSubscriptionPlanQueryVariables>(OtcSubscriptionPlanDocument, options);
      }
export function useOtcSubscriptionPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OtcSubscriptionPlanQuery, OtcSubscriptionPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OtcSubscriptionPlanQuery, OtcSubscriptionPlanQueryVariables>(OtcSubscriptionPlanDocument, options);
        }
export function useOtcSubscriptionPlanSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OtcSubscriptionPlanQuery, OtcSubscriptionPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OtcSubscriptionPlanQuery, OtcSubscriptionPlanQueryVariables>(OtcSubscriptionPlanDocument, options);
        }
export type OtcSubscriptionPlanQueryHookResult = ReturnType<typeof useOtcSubscriptionPlanQuery>;
export type OtcSubscriptionPlanLazyQueryHookResult = ReturnType<typeof useOtcSubscriptionPlanLazyQuery>;
export type OtcSubscriptionPlanSuspenseQueryHookResult = ReturnType<typeof useOtcSubscriptionPlanSuspenseQuery>;
export type OtcSubscriptionPlanQueryResult = Apollo.QueryResult<OtcSubscriptionPlanQuery, OtcSubscriptionPlanQueryVariables>;
export const CancelSubscriptionV2Document = gql`
    mutation CancelSubscriptionV2($subscriptionId: String!) {
  cancelSubscriptionV2(subscriptionId: $subscriptionId) {
    id
  }
}
    `;
export type CancelSubscriptionV2MutationFn = Apollo.MutationFunction<CancelSubscriptionV2Mutation, CancelSubscriptionV2MutationVariables>;

/**
 * __useCancelSubscriptionV2Mutation__
 *
 * To run a mutation, you first call `useCancelSubscriptionV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSubscriptionV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSubscriptionV2Mutation, { data, loading, error }] = useCancelSubscriptionV2Mutation({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function useCancelSubscriptionV2Mutation(baseOptions?: Apollo.MutationHookOptions<CancelSubscriptionV2Mutation, CancelSubscriptionV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelSubscriptionV2Mutation, CancelSubscriptionV2MutationVariables>(CancelSubscriptionV2Document, options);
      }
export type CancelSubscriptionV2MutationHookResult = ReturnType<typeof useCancelSubscriptionV2Mutation>;
export type CancelSubscriptionV2MutationResult = Apollo.MutationResult<CancelSubscriptionV2Mutation>;
export type CancelSubscriptionV2MutationOptions = Apollo.BaseMutationOptions<CancelSubscriptionV2Mutation, CancelSubscriptionV2MutationVariables>;
export const MigrateSubscriptionsDocument = gql`
    mutation MigrateSubscriptions {
  migrateCustomerSubscriptions {
    id
  }
}
    `;
export type MigrateSubscriptionsMutationFn = Apollo.MutationFunction<MigrateSubscriptionsMutation, MigrateSubscriptionsMutationVariables>;

/**
 * __useMigrateSubscriptionsMutation__
 *
 * To run a mutation, you first call `useMigrateSubscriptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMigrateSubscriptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [migrateSubscriptionsMutation, { data, loading, error }] = useMigrateSubscriptionsMutation({
 *   variables: {
 *   },
 * });
 */
export function useMigrateSubscriptionsMutation(baseOptions?: Apollo.MutationHookOptions<MigrateSubscriptionsMutation, MigrateSubscriptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MigrateSubscriptionsMutation, MigrateSubscriptionsMutationVariables>(MigrateSubscriptionsDocument, options);
      }
export type MigrateSubscriptionsMutationHookResult = ReturnType<typeof useMigrateSubscriptionsMutation>;
export type MigrateSubscriptionsMutationResult = Apollo.MutationResult<MigrateSubscriptionsMutation>;
export type MigrateSubscriptionsMutationOptions = Apollo.BaseMutationOptions<MigrateSubscriptionsMutation, MigrateSubscriptionsMutationVariables>;
export const UseProfileSubscriptionsV2Document = gql`
    query UseProfileSubscriptionsV2 {
  profile {
    id
    needsSubscriptionMigration
    subscriptions {
      id
      status
      nextPaymentAt
      subscriptionOrders {
        id
        status
        createdAt
      }
      subscriptionPlan {
        ...OtcSubscriptionPlanV2Info
      }
    }
  }
}
    ${OtcSubscriptionPlanV2InfoFragmentDoc}`;

/**
 * __useUseProfileSubscriptionsV2Query__
 *
 * To run a query within a React component, call `useUseProfileSubscriptionsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useUseProfileSubscriptionsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseProfileSubscriptionsV2Query({
 *   variables: {
 *   },
 * });
 */
export function useUseProfileSubscriptionsV2Query(baseOptions?: Apollo.QueryHookOptions<UseProfileSubscriptionsV2Query, UseProfileSubscriptionsV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseProfileSubscriptionsV2Query, UseProfileSubscriptionsV2QueryVariables>(UseProfileSubscriptionsV2Document, options);
      }
export function useUseProfileSubscriptionsV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseProfileSubscriptionsV2Query, UseProfileSubscriptionsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseProfileSubscriptionsV2Query, UseProfileSubscriptionsV2QueryVariables>(UseProfileSubscriptionsV2Document, options);
        }
export function useUseProfileSubscriptionsV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UseProfileSubscriptionsV2Query, UseProfileSubscriptionsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UseProfileSubscriptionsV2Query, UseProfileSubscriptionsV2QueryVariables>(UseProfileSubscriptionsV2Document, options);
        }
export type UseProfileSubscriptionsV2QueryHookResult = ReturnType<typeof useUseProfileSubscriptionsV2Query>;
export type UseProfileSubscriptionsV2LazyQueryHookResult = ReturnType<typeof useUseProfileSubscriptionsV2LazyQuery>;
export type UseProfileSubscriptionsV2SuspenseQueryHookResult = ReturnType<typeof useUseProfileSubscriptionsV2SuspenseQuery>;
export type UseProfileSubscriptionsV2QueryResult = Apollo.QueryResult<UseProfileSubscriptionsV2Query, UseProfileSubscriptionsV2QueryVariables>;
export const ReactivateSubscriptionV2Document = gql`
    mutation ReactivateSubscriptionV2($subscriptionId: String!) {
  reactivateSubscriptionV2(subscriptionId: $subscriptionId) {
    id
    subscriptionOrders(pagination: {pageSize: 1, skip: 0}) {
      id
      createdAt
      order {
        id
        lineItems {
          id
          variant {
            id
            price
          }
        }
      }
    }
  }
}
    `;
export type ReactivateSubscriptionV2MutationFn = Apollo.MutationFunction<ReactivateSubscriptionV2Mutation, ReactivateSubscriptionV2MutationVariables>;

/**
 * __useReactivateSubscriptionV2Mutation__
 *
 * To run a mutation, you first call `useReactivateSubscriptionV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactivateSubscriptionV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactivateSubscriptionV2Mutation, { data, loading, error }] = useReactivateSubscriptionV2Mutation({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function useReactivateSubscriptionV2Mutation(baseOptions?: Apollo.MutationHookOptions<ReactivateSubscriptionV2Mutation, ReactivateSubscriptionV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReactivateSubscriptionV2Mutation, ReactivateSubscriptionV2MutationVariables>(ReactivateSubscriptionV2Document, options);
      }
export type ReactivateSubscriptionV2MutationHookResult = ReturnType<typeof useReactivateSubscriptionV2Mutation>;
export type ReactivateSubscriptionV2MutationResult = Apollo.MutationResult<ReactivateSubscriptionV2Mutation>;
export type ReactivateSubscriptionV2MutationOptions = Apollo.BaseMutationOptions<ReactivateSubscriptionV2Mutation, ReactivateSubscriptionV2MutationVariables>;
export const RefillSubscriptionV2Document = gql`
    mutation RefillSubscriptionV2($subscriptionId: String!) {
  refillSubscriptionV2(subscriptionId: $subscriptionId) {
    id
  }
}
    `;
export type RefillSubscriptionV2MutationFn = Apollo.MutationFunction<RefillSubscriptionV2Mutation, RefillSubscriptionV2MutationVariables>;

/**
 * __useRefillSubscriptionV2Mutation__
 *
 * To run a mutation, you first call `useRefillSubscriptionV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefillSubscriptionV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refillSubscriptionV2Mutation, { data, loading, error }] = useRefillSubscriptionV2Mutation({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function useRefillSubscriptionV2Mutation(baseOptions?: Apollo.MutationHookOptions<RefillSubscriptionV2Mutation, RefillSubscriptionV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefillSubscriptionV2Mutation, RefillSubscriptionV2MutationVariables>(RefillSubscriptionV2Document, options);
      }
export type RefillSubscriptionV2MutationHookResult = ReturnType<typeof useRefillSubscriptionV2Mutation>;
export type RefillSubscriptionV2MutationResult = Apollo.MutationResult<RefillSubscriptionV2Mutation>;
export type RefillSubscriptionV2MutationOptions = Apollo.BaseMutationOptions<RefillSubscriptionV2Mutation, RefillSubscriptionV2MutationVariables>;
export const SubscribePlanV2Document = gql`
    mutation SubscribePlanV2($subscriptionPlanId: String!, $token: String) {
  subscribePlanV2(subscriptionPlanId: $subscriptionPlanId, token: $token) {
    id
    subscriptionOrders(pagination: {pageSize: 1, skip: 0}) {
      id
      order {
        id
        lineItems {
          id
          variant {
            id
            price
          }
        }
      }
    }
  }
}
    `;
export type SubscribePlanV2MutationFn = Apollo.MutationFunction<SubscribePlanV2Mutation, SubscribePlanV2MutationVariables>;

/**
 * __useSubscribePlanV2Mutation__
 *
 * To run a mutation, you first call `useSubscribePlanV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribePlanV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribePlanV2Mutation, { data, loading, error }] = useSubscribePlanV2Mutation({
 *   variables: {
 *      subscriptionPlanId: // value for 'subscriptionPlanId'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useSubscribePlanV2Mutation(baseOptions?: Apollo.MutationHookOptions<SubscribePlanV2Mutation, SubscribePlanV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubscribePlanV2Mutation, SubscribePlanV2MutationVariables>(SubscribePlanV2Document, options);
      }
export type SubscribePlanV2MutationHookResult = ReturnType<typeof useSubscribePlanV2Mutation>;
export type SubscribePlanV2MutationResult = Apollo.MutationResult<SubscribePlanV2Mutation>;
export type SubscribePlanV2MutationOptions = Apollo.BaseMutationOptions<SubscribePlanV2Mutation, SubscribePlanV2MutationVariables>;
export const OtcSubscriptionPlanV2ByIdDocument = gql`
    query OtcSubscriptionPlanV2ById($id: String!) {
  subscriptionPlanV2ById(id: $id) {
    ...OtcSubscriptionPlanV2Info
  }
}
    ${OtcSubscriptionPlanV2InfoFragmentDoc}`;

/**
 * __useOtcSubscriptionPlanV2ByIdQuery__
 *
 * To run a query within a React component, call `useOtcSubscriptionPlanV2ByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useOtcSubscriptionPlanV2ByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOtcSubscriptionPlanV2ByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOtcSubscriptionPlanV2ByIdQuery(baseOptions: Apollo.QueryHookOptions<OtcSubscriptionPlanV2ByIdQuery, OtcSubscriptionPlanV2ByIdQueryVariables> & ({ variables: OtcSubscriptionPlanV2ByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OtcSubscriptionPlanV2ByIdQuery, OtcSubscriptionPlanV2ByIdQueryVariables>(OtcSubscriptionPlanV2ByIdDocument, options);
      }
export function useOtcSubscriptionPlanV2ByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OtcSubscriptionPlanV2ByIdQuery, OtcSubscriptionPlanV2ByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OtcSubscriptionPlanV2ByIdQuery, OtcSubscriptionPlanV2ByIdQueryVariables>(OtcSubscriptionPlanV2ByIdDocument, options);
        }
export function useOtcSubscriptionPlanV2ByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OtcSubscriptionPlanV2ByIdQuery, OtcSubscriptionPlanV2ByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OtcSubscriptionPlanV2ByIdQuery, OtcSubscriptionPlanV2ByIdQueryVariables>(OtcSubscriptionPlanV2ByIdDocument, options);
        }
export type OtcSubscriptionPlanV2ByIdQueryHookResult = ReturnType<typeof useOtcSubscriptionPlanV2ByIdQuery>;
export type OtcSubscriptionPlanV2ByIdLazyQueryHookResult = ReturnType<typeof useOtcSubscriptionPlanV2ByIdLazyQuery>;
export type OtcSubscriptionPlanV2ByIdSuspenseQueryHookResult = ReturnType<typeof useOtcSubscriptionPlanV2ByIdSuspenseQuery>;
export type OtcSubscriptionPlanV2ByIdQueryResult = Apollo.QueryResult<OtcSubscriptionPlanV2ByIdQuery, OtcSubscriptionPlanV2ByIdQueryVariables>;
export const OtcSubscriptionV2Document = gql`
    query OtcSubscriptionV2($id: String!) {
  subscriptionV2(id: $id) {
    id
    createdAt
    updatedAt
    nextPaymentAt
    status
    subscriptionPlan {
      ...OtcSubscriptionPlanV2Info
    }
  }
}
    ${OtcSubscriptionPlanV2InfoFragmentDoc}`;

/**
 * __useOtcSubscriptionV2Query__
 *
 * To run a query within a React component, call `useOtcSubscriptionV2Query` and pass it any options that fit your needs.
 * When your component renders, `useOtcSubscriptionV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOtcSubscriptionV2Query({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOtcSubscriptionV2Query(baseOptions: Apollo.QueryHookOptions<OtcSubscriptionV2Query, OtcSubscriptionV2QueryVariables> & ({ variables: OtcSubscriptionV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OtcSubscriptionV2Query, OtcSubscriptionV2QueryVariables>(OtcSubscriptionV2Document, options);
      }
export function useOtcSubscriptionV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OtcSubscriptionV2Query, OtcSubscriptionV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OtcSubscriptionV2Query, OtcSubscriptionV2QueryVariables>(OtcSubscriptionV2Document, options);
        }
export function useOtcSubscriptionV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OtcSubscriptionV2Query, OtcSubscriptionV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OtcSubscriptionV2Query, OtcSubscriptionV2QueryVariables>(OtcSubscriptionV2Document, options);
        }
export type OtcSubscriptionV2QueryHookResult = ReturnType<typeof useOtcSubscriptionV2Query>;
export type OtcSubscriptionV2LazyQueryHookResult = ReturnType<typeof useOtcSubscriptionV2LazyQuery>;
export type OtcSubscriptionV2SuspenseQueryHookResult = ReturnType<typeof useOtcSubscriptionV2SuspenseQuery>;
export type OtcSubscriptionV2QueryResult = Apollo.QueryResult<OtcSubscriptionV2Query, OtcSubscriptionV2QueryVariables>;
export const AddTreatmentDiscountDocument = gql`
    mutation AddTreatmentDiscount($treatmentId: String!, $discountCode: String!) {
  addTreatmentDiscount(treatmentId: $treatmentId, discountCode: $discountCode) {
    id
    treatmentDiscount {
      id
      discountCode {
        ...DiscountCodeForm
      }
    }
  }
}
    ${DiscountCodeFormFragmentDoc}`;
export type AddTreatmentDiscountMutationFn = Apollo.MutationFunction<AddTreatmentDiscountMutation, AddTreatmentDiscountMutationVariables>;

/**
 * __useAddTreatmentDiscountMutation__
 *
 * To run a mutation, you first call `useAddTreatmentDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTreatmentDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTreatmentDiscountMutation, { data, loading, error }] = useAddTreatmentDiscountMutation({
 *   variables: {
 *      treatmentId: // value for 'treatmentId'
 *      discountCode: // value for 'discountCode'
 *   },
 * });
 */
export function useAddTreatmentDiscountMutation(baseOptions?: Apollo.MutationHookOptions<AddTreatmentDiscountMutation, AddTreatmentDiscountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTreatmentDiscountMutation, AddTreatmentDiscountMutationVariables>(AddTreatmentDiscountDocument, options);
      }
export type AddTreatmentDiscountMutationHookResult = ReturnType<typeof useAddTreatmentDiscountMutation>;
export type AddTreatmentDiscountMutationResult = Apollo.MutationResult<AddTreatmentDiscountMutation>;
export type AddTreatmentDiscountMutationOptions = Apollo.BaseMutationOptions<AddTreatmentDiscountMutation, AddTreatmentDiscountMutationVariables>;
export const UseDelayTreatmentDocument = gql`
    mutation UseDelayTreatment($id: String!, $newDate: String!, $trigger: String) {
  delayTreatment(id: $id, newDate: $newDate, trigger: $trigger) {
    id
    nextPayment
    status
  }
}
    `;
export type UseDelayTreatmentMutationFn = Apollo.MutationFunction<UseDelayTreatmentMutation, UseDelayTreatmentMutationVariables>;

/**
 * __useUseDelayTreatmentMutation__
 *
 * To run a mutation, you first call `useUseDelayTreatmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUseDelayTreatmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [useDelayTreatmentMutation, { data, loading, error }] = useUseDelayTreatmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      newDate: // value for 'newDate'
 *      trigger: // value for 'trigger'
 *   },
 * });
 */
export function useUseDelayTreatmentMutation(baseOptions?: Apollo.MutationHookOptions<UseDelayTreatmentMutation, UseDelayTreatmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UseDelayTreatmentMutation, UseDelayTreatmentMutationVariables>(UseDelayTreatmentDocument, options);
      }
export type UseDelayTreatmentMutationHookResult = ReturnType<typeof useUseDelayTreatmentMutation>;
export type UseDelayTreatmentMutationResult = Apollo.MutationResult<UseDelayTreatmentMutation>;
export type UseDelayTreatmentMutationOptions = Apollo.BaseMutationOptions<UseDelayTreatmentMutation, UseDelayTreatmentMutationVariables>;
export const PauseUserTreatmentDocument = gql`
    mutation PauseUserTreatment($id: String!, $reason: String, $isReview: Boolean, $reasonExtended: String) {
  pauseTreatment(
    id: $id
    reason: $reason
    isReview: $isReview
    reasonExtended: $reasonExtended
  ) {
    id
    status
  }
}
    `;
export type PauseUserTreatmentMutationFn = Apollo.MutationFunction<PauseUserTreatmentMutation, PauseUserTreatmentMutationVariables>;

/**
 * __usePauseUserTreatmentMutation__
 *
 * To run a mutation, you first call `usePauseUserTreatmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePauseUserTreatmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pauseUserTreatmentMutation, { data, loading, error }] = usePauseUserTreatmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reason: // value for 'reason'
 *      isReview: // value for 'isReview'
 *      reasonExtended: // value for 'reasonExtended'
 *   },
 * });
 */
export function usePauseUserTreatmentMutation(baseOptions?: Apollo.MutationHookOptions<PauseUserTreatmentMutation, PauseUserTreatmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PauseUserTreatmentMutation, PauseUserTreatmentMutationVariables>(PauseUserTreatmentDocument, options);
      }
export type PauseUserTreatmentMutationHookResult = ReturnType<typeof usePauseUserTreatmentMutation>;
export type PauseUserTreatmentMutationResult = Apollo.MutationResult<PauseUserTreatmentMutation>;
export type PauseUserTreatmentMutationOptions = Apollo.BaseMutationOptions<PauseUserTreatmentMutation, PauseUserTreatmentMutationVariables>;
export const RefillTreatmentDocument = gql`
    mutation RefillTreatment($treatmentId: String!) {
  refillTreatment(treatmentId: $treatmentId, isPaused: false) {
    id
    status
    canRefill
    nextPayment
    experimentPaymentPlan {
      id
      nextPaymentAmount
      planEndDate
    }
  }
}
    `;
export type RefillTreatmentMutationFn = Apollo.MutationFunction<RefillTreatmentMutation, RefillTreatmentMutationVariables>;

/**
 * __useRefillTreatmentMutation__
 *
 * To run a mutation, you first call `useRefillTreatmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefillTreatmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refillTreatmentMutation, { data, loading, error }] = useRefillTreatmentMutation({
 *   variables: {
 *      treatmentId: // value for 'treatmentId'
 *   },
 * });
 */
export function useRefillTreatmentMutation(baseOptions?: Apollo.MutationHookOptions<RefillTreatmentMutation, RefillTreatmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefillTreatmentMutation, RefillTreatmentMutationVariables>(RefillTreatmentDocument, options);
      }
export type RefillTreatmentMutationHookResult = ReturnType<typeof useRefillTreatmentMutation>;
export type RefillTreatmentMutationResult = Apollo.MutationResult<RefillTreatmentMutation>;
export type RefillTreatmentMutationOptions = Apollo.BaseMutationOptions<RefillTreatmentMutation, RefillTreatmentMutationVariables>;
export const RemoveTreatmentDiscountDocument = gql`
    mutation RemoveTreatmentDiscount($treatmentId: String!) {
  removeTreatmentDiscount(treatmentId: $treatmentId) {
    id
    treatmentDiscount {
      id
      discountCode {
        ...DiscountCodeForm
      }
    }
  }
}
    ${DiscountCodeFormFragmentDoc}`;
export type RemoveTreatmentDiscountMutationFn = Apollo.MutationFunction<RemoveTreatmentDiscountMutation, RemoveTreatmentDiscountMutationVariables>;

/**
 * __useRemoveTreatmentDiscountMutation__
 *
 * To run a mutation, you first call `useRemoveTreatmentDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTreatmentDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTreatmentDiscountMutation, { data, loading, error }] = useRemoveTreatmentDiscountMutation({
 *   variables: {
 *      treatmentId: // value for 'treatmentId'
 *   },
 * });
 */
export function useRemoveTreatmentDiscountMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTreatmentDiscountMutation, RemoveTreatmentDiscountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTreatmentDiscountMutation, RemoveTreatmentDiscountMutationVariables>(RemoveTreatmentDiscountDocument, options);
      }
export type RemoveTreatmentDiscountMutationHookResult = ReturnType<typeof useRemoveTreatmentDiscountMutation>;
export type RemoveTreatmentDiscountMutationResult = Apollo.MutationResult<RemoveTreatmentDiscountMutation>;
export type RemoveTreatmentDiscountMutationOptions = Apollo.BaseMutationOptions<RemoveTreatmentDiscountMutation, RemoveTreatmentDiscountMutationVariables>;
export const RequestReviewTreatmentDocument = gql`
    mutation RequestReviewTreatment($input: RequestReviewTreatmentInput!) {
  requestReviewTreatment(input: $input) {
    id
    status
  }
}
    `;
export type RequestReviewTreatmentMutationFn = Apollo.MutationFunction<RequestReviewTreatmentMutation, RequestReviewTreatmentMutationVariables>;

/**
 * __useRequestReviewTreatmentMutation__
 *
 * To run a mutation, you first call `useRequestReviewTreatmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestReviewTreatmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestReviewTreatmentMutation, { data, loading, error }] = useRequestReviewTreatmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestReviewTreatmentMutation(baseOptions?: Apollo.MutationHookOptions<RequestReviewTreatmentMutation, RequestReviewTreatmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestReviewTreatmentMutation, RequestReviewTreatmentMutationVariables>(RequestReviewTreatmentDocument, options);
      }
export type RequestReviewTreatmentMutationHookResult = ReturnType<typeof useRequestReviewTreatmentMutation>;
export type RequestReviewTreatmentMutationResult = Apollo.MutationResult<RequestReviewTreatmentMutation>;
export type RequestReviewTreatmentMutationOptions = Apollo.BaseMutationOptions<RequestReviewTreatmentMutation, RequestReviewTreatmentMutationVariables>;
export const SubmitPatientPharmacistQuestionDocument = gql`
    mutation SubmitPatientPharmacistQuestion($treatmentId: String!, $messageText: String!, $contactMethod: ContactMethod) {
  submitPatientPharmacistQuestion(
    treatmentId: $treatmentId
    messageText: $messageText
    contactMethod: $contactMethod
  )
}
    `;
export type SubmitPatientPharmacistQuestionMutationFn = Apollo.MutationFunction<SubmitPatientPharmacistQuestionMutation, SubmitPatientPharmacistQuestionMutationVariables>;

/**
 * __useSubmitPatientPharmacistQuestionMutation__
 *
 * To run a mutation, you first call `useSubmitPatientPharmacistQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitPatientPharmacistQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitPatientPharmacistQuestionMutation, { data, loading, error }] = useSubmitPatientPharmacistQuestionMutation({
 *   variables: {
 *      treatmentId: // value for 'treatmentId'
 *      messageText: // value for 'messageText'
 *      contactMethod: // value for 'contactMethod'
 *   },
 * });
 */
export function useSubmitPatientPharmacistQuestionMutation(baseOptions?: Apollo.MutationHookOptions<SubmitPatientPharmacistQuestionMutation, SubmitPatientPharmacistQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitPatientPharmacistQuestionMutation, SubmitPatientPharmacistQuestionMutationVariables>(SubmitPatientPharmacistQuestionDocument, options);
      }
export type SubmitPatientPharmacistQuestionMutationHookResult = ReturnType<typeof useSubmitPatientPharmacistQuestionMutation>;
export type SubmitPatientPharmacistQuestionMutationResult = Apollo.MutationResult<SubmitPatientPharmacistQuestionMutation>;
export type SubmitPatientPharmacistQuestionMutationOptions = Apollo.BaseMutationOptions<SubmitPatientPharmacistQuestionMutation, SubmitPatientPharmacistQuestionMutationVariables>;
export const UseTreatmentDocument = gql`
    query UseTreatment($id: String!) {
  treatment(id: $id) {
    ...TreatmentInfo
  }
}
    ${TreatmentInfoFragmentDoc}`;

/**
 * __useUseTreatmentQuery__
 *
 * To run a query within a React component, call `useUseTreatmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseTreatmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseTreatmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUseTreatmentQuery(baseOptions: Apollo.QueryHookOptions<UseTreatmentQuery, UseTreatmentQueryVariables> & ({ variables: UseTreatmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseTreatmentQuery, UseTreatmentQueryVariables>(UseTreatmentDocument, options);
      }
export function useUseTreatmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseTreatmentQuery, UseTreatmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseTreatmentQuery, UseTreatmentQueryVariables>(UseTreatmentDocument, options);
        }
export function useUseTreatmentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UseTreatmentQuery, UseTreatmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UseTreatmentQuery, UseTreatmentQueryVariables>(UseTreatmentDocument, options);
        }
export type UseTreatmentQueryHookResult = ReturnType<typeof useUseTreatmentQuery>;
export type UseTreatmentLazyQueryHookResult = ReturnType<typeof useUseTreatmentLazyQuery>;
export type UseTreatmentSuspenseQueryHookResult = ReturnType<typeof useUseTreatmentSuspenseQuery>;
export type UseTreatmentQueryResult = Apollo.QueryResult<UseTreatmentQuery, UseTreatmentQueryVariables>;
export const UseTreatmentsDocument = gql`
    query UseTreatments {
  treatments {
    id
    type
    active
    status
    refillsLeft
    hasUnfulfilledOrder
    nextScheduledDate
    nextPayment
    consultation {
      id
      status
      isApproved
      stage
      quizApplication {
        id
      }
      doctor {
        id
        firstName
        lastName
        shortClinicianName
        fullClinicianName
        fullName
        provider {
          id
          clinicianType
          clinicianTitle
        }
      }
    }
    otcSchedules {
      id
      createdAt
      updatedAt
      cadence
      isActive
      quantity
      product {
        id
        name
        variants {
          id
          price
        }
      }
    }
    followupConsultations(orderBy: {createdAt: asc}) {
      id
      status
      stage
      isApproved
      doctor {
        id
        firstName
        lastName
        shortClinicianName
        fullClinicianName
        fullName
      }
    }
    product {
      id
      name
    }
    script {
      id
      createdAt
    }
  }
}
    `;

/**
 * __useUseTreatmentsQuery__
 *
 * To run a query within a React component, call `useUseTreatmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseTreatmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseTreatmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUseTreatmentsQuery(baseOptions?: Apollo.QueryHookOptions<UseTreatmentsQuery, UseTreatmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseTreatmentsQuery, UseTreatmentsQueryVariables>(UseTreatmentsDocument, options);
      }
export function useUseTreatmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseTreatmentsQuery, UseTreatmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseTreatmentsQuery, UseTreatmentsQueryVariables>(UseTreatmentsDocument, options);
        }
export function useUseTreatmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UseTreatmentsQuery, UseTreatmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UseTreatmentsQuery, UseTreatmentsQueryVariables>(UseTreatmentsDocument, options);
        }
export type UseTreatmentsQueryHookResult = ReturnType<typeof useUseTreatmentsQuery>;
export type UseTreatmentsLazyQueryHookResult = ReturnType<typeof useUseTreatmentsLazyQuery>;
export type UseTreatmentsSuspenseQueryHookResult = ReturnType<typeof useUseTreatmentsSuspenseQuery>;
export type UseTreatmentsQueryResult = Apollo.QueryResult<UseTreatmentsQuery, UseTreatmentsQueryVariables>;
export const TrackerDocument = gql`
    query Tracker {
  profile {
    id
    isBeingTreated(problemType: WEIGHT_LOSS)
  }
  tracker {
    id
    weightLoss {
      id
      lastCheckIn
      momentum
      waist {
        id
        value
        effectiveFrom
      }
      weight {
        id
        value
        effectiveFrom
      }
    }
  }
}
    `;

/**
 * __useTrackerQuery__
 *
 * To run a query within a React component, call `useTrackerQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrackerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrackerQuery({
 *   variables: {
 *   },
 * });
 */
export function useTrackerQuery(baseOptions?: Apollo.QueryHookOptions<TrackerQuery, TrackerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrackerQuery, TrackerQueryVariables>(TrackerDocument, options);
      }
export function useTrackerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrackerQuery, TrackerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrackerQuery, TrackerQueryVariables>(TrackerDocument, options);
        }
export function useTrackerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrackerQuery, TrackerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrackerQuery, TrackerQueryVariables>(TrackerDocument, options);
        }
export type TrackerQueryHookResult = ReturnType<typeof useTrackerQuery>;
export type TrackerLazyQueryHookResult = ReturnType<typeof useTrackerLazyQuery>;
export type TrackerSuspenseQueryHookResult = ReturnType<typeof useTrackerSuspenseQuery>;
export type TrackerQueryResult = Apollo.QueryResult<TrackerQuery, TrackerQueryVariables>;
export const TreatmentRefillJuniperDocument = gql`
    mutation TreatmentRefillJuniper($treatmentId: String!) {
  refillTreatment(treatmentId: $treatmentId, isPaused: false) {
    id
    status
    canRefill
    nextPayment
    refillsLeft
  }
}
    `;
export type TreatmentRefillJuniperMutationFn = Apollo.MutationFunction<TreatmentRefillJuniperMutation, TreatmentRefillJuniperMutationVariables>;

/**
 * __useTreatmentRefillJuniperMutation__
 *
 * To run a mutation, you first call `useTreatmentRefillJuniperMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTreatmentRefillJuniperMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [treatmentRefillJuniperMutation, { data, loading, error }] = useTreatmentRefillJuniperMutation({
 *   variables: {
 *      treatmentId: // value for 'treatmentId'
 *   },
 * });
 */
export function useTreatmentRefillJuniperMutation(baseOptions?: Apollo.MutationHookOptions<TreatmentRefillJuniperMutation, TreatmentRefillJuniperMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TreatmentRefillJuniperMutation, TreatmentRefillJuniperMutationVariables>(TreatmentRefillJuniperDocument, options);
      }
export type TreatmentRefillJuniperMutationHookResult = ReturnType<typeof useTreatmentRefillJuniperMutation>;
export type TreatmentRefillJuniperMutationResult = Apollo.MutationResult<TreatmentRefillJuniperMutation>;
export type TreatmentRefillJuniperMutationOptions = Apollo.BaseMutationOptions<TreatmentRefillJuniperMutation, TreatmentRefillJuniperMutationVariables>;
export const UseFlexiEnabledDocument = gql`
    query UseFlexiEnabled($consultationId: String!) {
  consultation(id: $consultationId) {
    id
    type
    stage
  }
}
    `;

/**
 * __useUseFlexiEnabledQuery__
 *
 * To run a query within a React component, call `useUseFlexiEnabledQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseFlexiEnabledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseFlexiEnabledQuery({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function useUseFlexiEnabledQuery(baseOptions: Apollo.QueryHookOptions<UseFlexiEnabledQuery, UseFlexiEnabledQueryVariables> & ({ variables: UseFlexiEnabledQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseFlexiEnabledQuery, UseFlexiEnabledQueryVariables>(UseFlexiEnabledDocument, options);
      }
export function useUseFlexiEnabledLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseFlexiEnabledQuery, UseFlexiEnabledQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseFlexiEnabledQuery, UseFlexiEnabledQueryVariables>(UseFlexiEnabledDocument, options);
        }
export function useUseFlexiEnabledSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UseFlexiEnabledQuery, UseFlexiEnabledQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UseFlexiEnabledQuery, UseFlexiEnabledQueryVariables>(UseFlexiEnabledDocument, options);
        }
export type UseFlexiEnabledQueryHookResult = ReturnType<typeof useUseFlexiEnabledQuery>;
export type UseFlexiEnabledLazyQueryHookResult = ReturnType<typeof useUseFlexiEnabledLazyQuery>;
export type UseFlexiEnabledSuspenseQueryHookResult = ReturnType<typeof useUseFlexiEnabledSuspenseQuery>;
export type UseFlexiEnabledQueryResult = Apollo.QueryResult<UseFlexiEnabledQuery, UseFlexiEnabledQueryVariables>;
export const WeightInAppOnboardingChecklistDocument = gql`
    query WeightInAppOnboardingChecklist {
  weightFacebookCommunityJoined: inSegment(
    segmentName: WEIGHT_FACEBOOK_COMMUNITY_JOINED
  )
}
    `;

/**
 * __useWeightInAppOnboardingChecklistQuery__
 *
 * To run a query within a React component, call `useWeightInAppOnboardingChecklistQuery` and pass it any options that fit your needs.
 * When your component renders, `useWeightInAppOnboardingChecklistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWeightInAppOnboardingChecklistQuery({
 *   variables: {
 *   },
 * });
 */
export function useWeightInAppOnboardingChecklistQuery(baseOptions?: Apollo.QueryHookOptions<WeightInAppOnboardingChecklistQuery, WeightInAppOnboardingChecklistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WeightInAppOnboardingChecklistQuery, WeightInAppOnboardingChecklistQueryVariables>(WeightInAppOnboardingChecklistDocument, options);
      }
export function useWeightInAppOnboardingChecklistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WeightInAppOnboardingChecklistQuery, WeightInAppOnboardingChecklistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WeightInAppOnboardingChecklistQuery, WeightInAppOnboardingChecklistQueryVariables>(WeightInAppOnboardingChecklistDocument, options);
        }
export function useWeightInAppOnboardingChecklistSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WeightInAppOnboardingChecklistQuery, WeightInAppOnboardingChecklistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WeightInAppOnboardingChecklistQuery, WeightInAppOnboardingChecklistQueryVariables>(WeightInAppOnboardingChecklistDocument, options);
        }
export type WeightInAppOnboardingChecklistQueryHookResult = ReturnType<typeof useWeightInAppOnboardingChecklistQuery>;
export type WeightInAppOnboardingChecklistLazyQueryHookResult = ReturnType<typeof useWeightInAppOnboardingChecklistLazyQuery>;
export type WeightInAppOnboardingChecklistSuspenseQueryHookResult = ReturnType<typeof useWeightInAppOnboardingChecklistSuspenseQuery>;
export type WeightInAppOnboardingChecklistQueryResult = Apollo.QueryResult<WeightInAppOnboardingChecklistQuery, WeightInAppOnboardingChecklistQueryVariables>;